import styled from "styled-components";
import { fromLonLat } from "ol/proj";
import { Layers, BasemapLayer, VectorLayer, GraticuleLayer } from "./Map/Layers";
import {
  Controls, FullScreenControl, GraticuleControl, ZoomControl, ZoomToExtentControl,
  ScaleLineControl, OverviewMapControl, AttributionControl,
  MeasureControl, IdentifyControl, DrawingControl
} from "./Map/Controls";
import { Interactions, DrawBbox } from "./Map/Interactions";

import Map from "./Map";
import ZoomToMap from './Map/ZoomToMap';
import PopUp from './Map/PopUp';
import { vector } from "./Map/Source"
import { Button, ButtonGroup, IconButton } from "@mui/material";
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';

import { Close, ExpandLess, ExpandMore, LayersRounded, Print as PrintIcon } from "@mui/icons-material";
import { useRef, useState, useEffect } from "react";

import Basemap from './Map/Basemap';
import Layer from './Map/Layer';
//import List from './Map/List';

//import Print from './Map/Print/Print';
//import BoundaryLayer from "./Map/Layers/BoundaryLayer";
//import BBoxLayer from "./Map/Layers/BBoxLayer";
import IndikatorLayer from "./Map/Layers/IndikatorLayer";
/*
import GroupLayer from "./Map/Layers/GroupLayer";
import StatisticLayer from "./Map/Layers/StatisticLayer";

import ProvinsiLayer from "./Map/Layers/ProvinsiLayer";
import KabupatenLayer from "./Map/Layers/KabupatenLayer";
import KecamatanLayer from "./Map/Layers/KecamatanLayer";

import BNBALayer from "./Map/Layers/BNBALayer";
*/
import DesaLayer from "./Map/Layers/DesaLayer";

//import AnalysisLayer from "./Map/Layers/AnalysisLayer";
import IdentifyLayer from "./Map/Layers/IdentifyLayer";
import { ImageWMS as ImageWMSSource } from 'ol/source';
import Config from '../config.json';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';


const listIndikator = [
  { id: 1, label: 'Prevalensi Stunting', layer: 'prev_stunt', provinsi: true, kabupaten: true, kecamatan: false, desa: false, bnba: false },
  //{ id: 2, label: 'Prevalensi Wasted', layer: 'prev_wasted', provinsi: true, kabupaten: true, kecamatan: false, desa: false, bnba: false },
  { id: 2, label: 'Persentase Keluarga dengan Anak Usia 0-23 Bulan', layer: 'bln_0_23n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 3, label: 'Persentase Keluarga dengan Anak Usia Balita', layer: 'balitan', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 4, label: 'Persentase Keluarga Beresiko Stunting', layer: 'riskn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true, },
  { id: 5, label: 'Persentase PUS Hamil', layer: 'pushmln', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 6, label: 'Persentase Keluarga Sasaran Memiliki Jamban Tidak Layak', layer: 'jmbnlykbn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 7, label: 'Persentase Keluarga Sasaran Memiliki Sumber Air Minum Tidak Layak', layer: 'smbairbn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 8, label: 'Presentase PUS Terlalu Muda', layer: 'tll_mudan', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 9, label: 'Presentase PUS Terlalu Tua', layer: 'tll_tuan', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 10, label: 'Presentase PUS Terlalu Dekat', layer: 'tll_dktn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 11, label: 'Presentase PUS Terlalu Banyak', layer: 'tll_bnykn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 12, label: 'Persentase Keluarga Berpartisipasi KB', layer: 'kbn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 13, label: 'Persentase Keluarga Berisiko 0', layer: 'risk0n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 14, label: 'Persentase Keluarga Berisiko 1', layer: 'risk1n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 15, label: 'Persentase Keluarga Berisiko 2', layer: 'risk2n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 16, label: 'Persentase Keluarga Berisiko 3', layer: 'risk3n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 17, label: 'Persentase Keluarga Berisiko 4', layer: 'risk4n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true }

]

export default function MapContainer({ center, zoom, basemap, setBasemap, bbox, visibleBbox,
  boundary, visibleBoundary, zoomBbox, setZoomBbox, drawing, setBbox, setDrawing, setVisibleBbox,
  setLabelArea, mapLayer, visibleAnalysis, buffered, setMapLayer
}) {
  const basemapRef = useRef();

  const [identifierDelete, setIdentifierDelete] = useState("");
  const [showBasemap, setShowBasemap] = useState(false);
  const [showLayer, setShowLayer] = useState(false);
  const [showIndikator, setShowIndikator] = useState(true);
  const [showStudyArea, setShowStudyArea] = useState(false);
  const [showLegenda, setShowLegenda] = useState(false);
  const [showAnalysis, setShowAnalysis] = useState(false);
  const [showMeasurement, setShowMeasurement] = useState(false);
  const [showInformation, setShowInformation] = useState(false);
  const [showDiagram, setShowDiagram] = useState(false);
  const [showProvinsi, setShowProvinsi] = useState(false);
  const [showKabupaten, setShowKabupaten] = useState(false);
  const [showKecamatan, setShowKecamatan] = useState(false);
  const [showDesa, setShowDesa] = useState(false);
  const [showBNBA, setShowBNBA] = useState(false);
  const [showPrint, setShowPrint] = useState(false);
  const [collapsedIndikator, setCollapsedIndikator] = useState(false);
  const [collapsedStudyArea, setCollapsedStudyArea] = useState(false);
  const [collapsedLegenda, setCollapsedLegenda] = useState(false);
  const [collapsedInformation, setCollapsedInformation] = useState(false);
  const [collapsedDiagram, setCollapsedDiagram] = useState(false);

  const [idProvince, setIdProvince] = useState(0);
  const [labelProvince, setLabelProvince] = useState('');
  const [idMunicipal, setIdMunicipal] = useState(0);
  const [labelMunicipal, setLabelMunicipal] = useState('');
  const [idKecamatan, setIdKecamatan] = useState(0);
  const [labelKecamatan, setLabelKecamatan] = useState('');
  const [idDesa, setIdDesa] = useState(0);
  const [labelDesa, setLabelDesa] = useState('');

  const [listCountries, setListCountries] = useState();
  const [listProvinces, setListProvinces] = useState();
  const [listMunicipals, setListMunicipals] = useState();
  const [listKecamatan, setListKecamatan] = useState();
  const [listDesa, setListDesa] = useState();
  const [listMunicipalsA, setListMunicipalsA] = useState();
  const [listKecamatanA, setListKecamatanA] = useState();
  const [listDesaA, setListDesaA] = useState();

  const [zoomToMap, setZoomToMap] = useState();

  const [value, setValue] = useState("");
  const [show, setShow] = useState(false);
  const [flag, setFlag] = useState(false);

  const [coordinate, setCoordinate] = useState();
  const [url, setUrl] = useState("");
  const [content, setContent] = useState();

  const [idIndikator, setIdIndikator] = useState(0);
  const [infoLabelIndikator, setInfoLabelIndikator] = useState("Belum ada indikator yang dipilih");
  const [listIndikatorAktif, setListIndikatorAktif] = useState([]);

  const [layer, setLayer] = useState("");
  const [level, setLevel] = useState("negara");// negara | provinsi | kabkot | kecamatan | desa
  const [kode, setKode] = useState(0);
  const [infoLabelWilayah, setInfoLabelWilayah] = useState("Indonesia");


  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: "170"
    },
    title: {
      text: 'Jumlah Keluarga Resiko Stunting',
      style: { "color": "#333333", "fontSize": "12px" }
      /*
      align: 'center',
      verticalAlign: 'middle',
      y: 60
      */
    },
    legend: {
      layout: 'vertical',
      backgroundColor: '#FFFFFF',
      align: 'right',
      verticalAlign: 'top',
      floating: true,
      x: 20,
      y: 45
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'white'
          }
        },
        startAngle: 0,
        endAngle: 360,
        center: ['25%', '50%'],
        size: '120%',
        showInLegend: true
      }
    },
    series: [{
      type: 'pie',
      name: 'Kasus',
      innerSize: '30%',
      data: [
        ['Tidak Signifikan', 25.0],
        ['Klaster Tinggi', 8.0],
        ['Klaster Rendah', 12.0],
      ]
    }]
  };
  function load_kabupaten53() {
    var kabupatenSet = [{ id: 0, province: 0, name: "Semua" }];
    kabupatenSet.push({ id:'11.05', province: 11, name:'Aceh Barat'});
    kabupatenSet.push({ id:'11.12', province: 11, name:'Aceh Barat Daya'});
    kabupatenSet.push({ id:'11.06', province: 11, name:'Aceh Besar'});
    kabupatenSet.push({ id:'11.14', province: 11, name:'Aceh Jaya'});
    kabupatenSet.push({ id:'11.01', province: 11, name:'Aceh Selatan'});
    kabupatenSet.push({ id:'11.10', province: 11, name:'Aceh Singkil'});
    kabupatenSet.push({ id:'11.16', province: 11, name:'Aceh Tamiang'});
    kabupatenSet.push({ id:'11.04', province: 11, name:'Aceh Tengah'});
    kabupatenSet.push({ id:'11.02', province: 11, name:'Aceh Tenggara'});
    kabupatenSet.push({ id:'11.03', province: 11, name:'Aceh Timur'});
    kabupatenSet.push({ id:'11.08', province: 11, name:'Aceh Utara'});
    kabupatenSet.push({ id:'11.17', province: 11, name:'Bener Meriah'});
    kabupatenSet.push({ id:'11.11', province: 11, name:'Bireuen'});
    kabupatenSet.push({ id:'11.13', province: 11, name:'Gayo Lues'});
    kabupatenSet.push({ id:'11.71', province: 11, name:'Kota Banda Aceh'});
    kabupatenSet.push({ id:'11.74', province: 11, name:'Kota Langsa'});
    kabupatenSet.push({ id:'11.73', province: 11, name:'Kota Lhokseumawe'});
    kabupatenSet.push({ id:'11.72', province: 11, name:'Kota Sabang'});
    kabupatenSet.push({ id:'11.75', province: 11, name:'Kota Subulussalam'});
    kabupatenSet.push({ id:'11.15', province: 11, name:'Nagan Raya'});
    kabupatenSet.push({ id:'11.07', province: 11, name:'Pidie'});
    kabupatenSet.push({ id:'11.18', province: 11, name:'Pidie Jaya'});
    kabupatenSet.push({ id:'11.09', province: 11, name:'Simeulue'});
    kabupatenSet.push({ id:'51.03', province: 51, name:'Badung'});
    kabupatenSet.push({ id:'51.06', province: 51, name:'Bangli'});
    kabupatenSet.push({ id:'51.08', province: 51, name:'Buleleng'});
    kabupatenSet.push({ id:'51.04', province: 51, name:'Gianyar'});
    kabupatenSet.push({ id:'51.01', province: 51, name:'Jembrana'});
    kabupatenSet.push({ id:'51.07', province: 51, name:'Karangasem'});
    kabupatenSet.push({ id:'51.05', province: 51, name:'Klungkung'});
    kabupatenSet.push({ id:'51.71', province: 51, name:'Kota Denpasar'});
    kabupatenSet.push({ id:'51.02', province: 51, name:'Tabanan'});
    kabupatenSet.push({ id:'36.72', province: 36, name:'Kota Cilegon'});
    kabupatenSet.push({ id:'36.73', province: 36, name:'Kota Serang'});
    kabupatenSet.push({ id:'36.71', province: 36, name:'Kota Tangerang'});
    kabupatenSet.push({ id:'36.74', province: 36, name:'Kota Tangerang Selatan'});
    kabupatenSet.push({ id:'36.02', province: 36, name:'Lebak'});
    kabupatenSet.push({ id:'36.01', province: 36, name:'Pandeglang'});
    kabupatenSet.push({ id:'36.04', province: 36, name:'Serang'});
    kabupatenSet.push({ id:'36.03', province: 36, name:'Tangerang'});
    kabupatenSet.push({ id:'17.01', province: 17, name:'Bengkulu Selatan'});
    kabupatenSet.push({ id:'17.09', province: 17, name:'Bengkulu Tengah'});
    kabupatenSet.push({ id:'17.03', province: 17, name:'Bengkulu Utara'});
    kabupatenSet.push({ id:'17.04', province: 17, name:'Kaur'});
    kabupatenSet.push({ id:'17.08', province: 17, name:'Kepahiang'});
    kabupatenSet.push({ id:'17.71', province: 17, name:'Kota Bengkulu'});
    kabupatenSet.push({ id:'17.07', province: 17, name:'Lebong'});
    kabupatenSet.push({ id:'17.06', province: 17, name:'Muko Muko'});
    kabupatenSet.push({ id:'17.02', province: 17, name:'Rejang Lebong'});
    kabupatenSet.push({ id:'17.05', province: 17, name:'Seluma'});
    kabupatenSet.push({ id:'34.02', province: 34, name:'Bantul'});
    kabupatenSet.push({ id:'34.03', province: 34, name:'Gunungkidul'});
    kabupatenSet.push({ id:'34.71', province: 34, name:'Kota Yogyakarta'});
    kabupatenSet.push({ id:'34.01', province: 34, name:'Kulon Progo'});
    kabupatenSet.push({ id:'34.04', province: 34, name:'Sleman'});
    kabupatenSet.push({ id:'75.02', province: 75, name:'Boalemo'});
    kabupatenSet.push({ id:'75.03', province: 75, name:'Bone Bolango'});
    kabupatenSet.push({ id:'75.01', province: 75, name:'Gorontalo'});
    kabupatenSet.push({ id:'75.05', province: 75, name:'Gorontalo Utara'});
    kabupatenSet.push({ id:'75.71', province: 75, name:'Kota Gorontalo'});
    kabupatenSet.push({ id:'75.04', province: 75, name:'Pohuwato'});
    kabupatenSet.push({ id:'15.04', province: 15, name:'Batanghari'});
    kabupatenSet.push({ id:'15.08', province: 15, name:'Bungo'});
    kabupatenSet.push({ id:'15.01', province: 15, name:'Kerinci'});
    kabupatenSet.push({ id:'15.71', province: 15, name:'Kota Jambi'});
    kabupatenSet.push({ id:'15.72', province: 15, name:'Kota Sungai Penuh'});
    kabupatenSet.push({ id:'15.02', province: 15, name:'Merangin'});
    kabupatenSet.push({ id:'15.05', province: 15, name:'Muaro Jambi'});
    kabupatenSet.push({ id:'15.03', province: 15, name:'Sarolangun'});
    kabupatenSet.push({ id:'15.06', province: 15, name:'Tanjung Jabung Barat'});
    kabupatenSet.push({ id:'15.07', province: 15, name:'Tanjung Jabung Timur'});
    kabupatenSet.push({ id:'15.09', province: 15, name:'Tebo'});
    kabupatenSet.push({ id:'32.04', province: 32, name:'Bandung'});
    kabupatenSet.push({ id:'32.17', province: 32, name:'Bandung Barat'});
    kabupatenSet.push({ id:'32.16', province: 32, name:'Bekasi'});
    kabupatenSet.push({ id:'32.01', province: 32, name:'Bogor'});
    kabupatenSet.push({ id:'32.07', province: 32, name:'Ciamis'});
    kabupatenSet.push({ id:'32.03', province: 32, name:'Cianjur'});
    kabupatenSet.push({ id:'32.09', province: 32, name:'Cirebon'});
    kabupatenSet.push({ id:'32.05', province: 32, name:'Garut'});
    kabupatenSet.push({ id:'32.12', province: 32, name:'Indramayu'});
    kabupatenSet.push({ id:'32.15', province: 32, name:'Karawang'});
    kabupatenSet.push({ id:'32.73', province: 32, name:'Kota Bandung'});
    kabupatenSet.push({ id:'32.79', province: 32, name:'Kota Banjar'});
    kabupatenSet.push({ id:'32.75', province: 32, name:'Kota Bekasi'});
    kabupatenSet.push({ id:'32.71', province: 32, name:'Kota Bogor'});
    kabupatenSet.push({ id:'32.77', province: 32, name:'Kota Cimahi'});
    kabupatenSet.push({ id:'32.74', province: 32, name:'Kota Cirebon'});
    kabupatenSet.push({ id:'32.76', province: 32, name:'Kota Depok'});
    kabupatenSet.push({ id:'32.72', province: 32, name:'Kota Sukabumi'});
    kabupatenSet.push({ id:'32.78', province: 32, name:'Kota Tasikmalaya'});
    kabupatenSet.push({ id:'32.08', province: 32, name:'Kuningan'});
    kabupatenSet.push({ id:'32.10', province: 32, name:'Majalengka'});
    kabupatenSet.push({ id:'32.18', province: 32, name:'Pangandaran'});
    kabupatenSet.push({ id:'32.14', province: 32, name:'Purwakarta'});
    kabupatenSet.push({ id:'32.13', province: 32, name:'Subang'});
    kabupatenSet.push({ id:'32.02', province: 32, name:'Sukabumi'});
    kabupatenSet.push({ id:'32.11', province: 32, name:'Sumedang'});
    kabupatenSet.push({ id:'32.06', province: 32, name:'Tasikmalaya'});
    kabupatenSet.push({ id:'33.04', province: 33, name:'Banjarnegara'});
    kabupatenSet.push({ id:'33.02', province: 33, name:'Banyumas'});
    kabupatenSet.push({ id:'33.25', province: 33, name:'Batang'});
    kabupatenSet.push({ id:'33.16', province: 33, name:'Blora'});
    kabupatenSet.push({ id:'33.09', province: 33, name:'Boyolali'});
    kabupatenSet.push({ id:'33.29', province: 33, name:'Brebes'});
    kabupatenSet.push({ id:'33.01', province: 33, name:'Cilacap'});
    kabupatenSet.push({ id:'33.21', province: 33, name:'Demak'});
    kabupatenSet.push({ id:'33.15', province: 33, name:'Grobogan'});
    kabupatenSet.push({ id:'33.20', province: 33, name:'Jepara'});
    kabupatenSet.push({ id:'33.13', province: 33, name:'Karanganyar'});
    kabupatenSet.push({ id:'33.05', province: 33, name:'Kebumen'});
    kabupatenSet.push({ id:'33.24', province: 33, name:'Kendal'});
    kabupatenSet.push({ id:'33.10', province: 33, name:'Klaten'});
    kabupatenSet.push({ id:'33.71', province: 33, name:'Kota Magelang'});
    kabupatenSet.push({ id:'33.75', province: 33, name:'Kota Pekalongan'});
    kabupatenSet.push({ id:'33.73', province: 33, name:'Kota Salatiga'});
    kabupatenSet.push({ id:'33.74', province: 33, name:'Kota Semarang'});
    kabupatenSet.push({ id:'33.72', province: 33, name:'Kota Surakarta'});
    kabupatenSet.push({ id:'33.76', province: 33, name:'Kota Tegal'});
    kabupatenSet.push({ id:'33.19', province: 33, name:'Kudus'});
    kabupatenSet.push({ id:'33.08', province: 33, name:'Magelang'});
    kabupatenSet.push({ id:'33.18', province: 33, name:'Pati'});
    kabupatenSet.push({ id:'33.26', province: 33, name:'Pekalongan'});
    kabupatenSet.push({ id:'33.27', province: 33, name:'Pemalang'});
    kabupatenSet.push({ id:'33.03', province: 33, name:'Purbalingga'});
    kabupatenSet.push({ id:'33.06', province: 33, name:'Purworejo'});
    kabupatenSet.push({ id:'33.17', province: 33, name:'Rembang'});
    kabupatenSet.push({ id:'33.22', province: 33, name:'Semarang'});
    kabupatenSet.push({ id:'33.14', province: 33, name:'Sragen'});
    kabupatenSet.push({ id:'33.11', province: 33, name:'Sukoharjo'});
    kabupatenSet.push({ id:'33.28', province: 33, name:'Tegal'});
    kabupatenSet.push({ id:'33.23', province: 33, name:'Temanggung'});
    kabupatenSet.push({ id:'33.12', province: 33, name:'Wonogiri'});
    kabupatenSet.push({ id:'33.07', province: 33, name:'Wonosobo'});
    kabupatenSet.push({ id:'35.26', province: 35, name:'Bangkalan'});
    kabupatenSet.push({ id:'35.10', province: 35, name:'Banyuwangi'});
    kabupatenSet.push({ id:'35.05', province: 35, name:'Blitar'});
    kabupatenSet.push({ id:'35.22', province: 35, name:'Bojonegoro'});
    kabupatenSet.push({ id:'35.11', province: 35, name:'Bondowoso'});
    kabupatenSet.push({ id:'35.25', province: 35, name:'Gresik'});
    kabupatenSet.push({ id:'35.09', province: 35, name:'Jember'});
    kabupatenSet.push({ id:'35.17', province: 35, name:'Jombang'});
    kabupatenSet.push({ id:'35.06', province: 35, name:'Kediri'});
    kabupatenSet.push({ id:'35.79', province: 35, name:'Kota Batu'});
    kabupatenSet.push({ id:'35.72', province: 35, name:'Kota Blitar'});
    kabupatenSet.push({ id:'35.71', province: 35, name:'Kota Kediri'});
    kabupatenSet.push({ id:'35.77', province: 35, name:'Kota Madiun'});
    kabupatenSet.push({ id:'35.73', province: 35, name:'Kota Malang'});
    kabupatenSet.push({ id:'35.76', province: 35, name:'Kota Mojokerto'});
    kabupatenSet.push({ id:'35.75', province: 35, name:'Kota Pasuruan'});
    kabupatenSet.push({ id:'35.74', province: 35, name:'Kota Probolinggo'});
    kabupatenSet.push({ id:'35.78', province: 35, name:'Kota Surabaya'});
    kabupatenSet.push({ id:'35.24', province: 35, name:'Lamongan'});
    kabupatenSet.push({ id:'35.08', province: 35, name:'Lumajang'});
    kabupatenSet.push({ id:'35.19', province: 35, name:'Madiun'});
    kabupatenSet.push({ id:'35.20', province: 35, name:'Magetan'});
    kabupatenSet.push({ id:'35.07', province: 35, name:'Malang'});
    kabupatenSet.push({ id:'35.16', province: 35, name:'Mojokerto'});
    kabupatenSet.push({ id:'35.18', province: 35, name:'Nganjuk'});
    kabupatenSet.push({ id:'35.21', province: 35, name:'Ngawi'});
    kabupatenSet.push({ id:'35.01', province: 35, name:'Pacitan'});
    kabupatenSet.push({ id:'35.28', province: 35, name:'Pamekasan'});
    kabupatenSet.push({ id:'35.14', province: 35, name:'Pasuruan'});
    kabupatenSet.push({ id:'35.02', province: 35, name:'Ponorogo'});
    kabupatenSet.push({ id:'35.13', province: 35, name:'Probolinggo'});
    kabupatenSet.push({ id:'35.27', province: 35, name:'Sampang'});
    kabupatenSet.push({ id:'35.15', province: 35, name:'Sidoarjo'});
    kabupatenSet.push({ id:'35.12', province: 35, name:'Situbondo'});
    kabupatenSet.push({ id:'35.29', province: 35, name:'Sumenep'});
    kabupatenSet.push({ id:'35.03', province: 35, name:'Trenggalek'});
    kabupatenSet.push({ id:'35.23', province: 35, name:'Tuban'});
    kabupatenSet.push({ id:'35.04', province: 35, name:'Tulungagung'});
    kabupatenSet.push({ id:'61.07', province: 61, name:'Bengkayang'});
    kabupatenSet.push({ id:'61.06', province: 61, name:'Kapuas Hulu'});
    kabupatenSet.push({ id:'61.11', province: 61, name:'Kayong Utara'});
    kabupatenSet.push({ id:'61.04', province: 61, name:'Ketapang'});
    kabupatenSet.push({ id:'61.71', province: 61, name:'Kota Pontianak'});
    kabupatenSet.push({ id:'61.72', province: 61, name:'Kota Singkawang'});
    kabupatenSet.push({ id:'61.12', province: 61, name:'Kubu Raya'});
    kabupatenSet.push({ id:'61.08', province: 61, name:'Landak'});
    kabupatenSet.push({ id:'61.10', province: 61, name:'Melawi'});
    kabupatenSet.push({ id:'61.02', province: 61, name:'Mempawah'});
    kabupatenSet.push({ id:'61.01', province: 61, name:'Sambas'});
    kabupatenSet.push({ id:'61.03', province: 61, name:'Sanggau'});
    kabupatenSet.push({ id:'61.09', province: 61, name:'Sekadau'});
    kabupatenSet.push({ id:'61.05', province: 61, name:'Sintang'});
    kabupatenSet.push({ id:'63.11', province: 63, name:'Balangan'});
    kabupatenSet.push({ id:'63.04', province: 63, name:'Barito Kuala'});
    kabupatenSet.push({ id:'63.06', province: 63, name:'Hulu Sungai Selatan'});
    kabupatenSet.push({ id:'63.07', province: 63, name:'Hulu Sungai Tengah'});
    kabupatenSet.push({ id:'63.08', province: 63, name:'Hulu Sungai Utara'});
    kabupatenSet.push({ id:'63.72', province: 63, name:'Kota Banjarbaru'});
    kabupatenSet.push({ id:'63.71', province: 63, name:'Kota Banjarmasin'});
    kabupatenSet.push({ id:'63.02', province: 63, name:'Kotabaru'});
    kabupatenSet.push({ id:'63.09', province: 63, name:'Tabalong'});
    kabupatenSet.push({ id:'63.10', province: 63, name:'Tanah Bumbu'});
    kabupatenSet.push({ id:'63.01', province: 63, name:'Tanah Laut'});
    kabupatenSet.push({ id:'63.05', province: 63, name:'Tapin'});
    kabupatenSet.push({ id:'63.03', province: 63, name:'Banjar'});
    kabupatenSet.push({ id:'62.04', province: 62, name:'Barito Selatan'});
    kabupatenSet.push({ id:'62.13', province: 62, name:'Barito Timur'});
    kabupatenSet.push({ id:'62.05', province: 62, name:'Barito Utara'});
    kabupatenSet.push({ id:'62.10', province: 62, name:'Gunung Mas'});
    kabupatenSet.push({ id:'62.03', province: 62, name:'Kapuas'});
    kabupatenSet.push({ id:'62.06', province: 62, name:'Katingan'});
    kabupatenSet.push({ id:'62.71', province: 62, name:'Kota Palangkaraya'});
    kabupatenSet.push({ id:'62.01', province: 62, name:'Kotawaringin Barat'});
    kabupatenSet.push({ id:'62.02', province: 62, name:'Kotawaringin Timur'});
    kabupatenSet.push({ id:'62.09', province: 62, name:'Lamandau'});
    kabupatenSet.push({ id:'62.12', province: 62, name:'Murung Raya'});
    kabupatenSet.push({ id:'62.11', province: 62, name:'Pulang Pisau'});
    kabupatenSet.push({ id:'62.07', province: 62, name:'Seruyan'});
    kabupatenSet.push({ id:'62.08', province: 62, name:'Sukamara'});
    kabupatenSet.push({ id:'64.03', province: 64, name:'Berau'});
    kabupatenSet.push({ id:'64.74', province: 64, name:'Kota Bontang'});
    kabupatenSet.push({ id:'64.72', province: 64, name:'Kota Samarinda'});
    kabupatenSet.push({ id:'64.07', province: 64, name:'Kutai Barat'});
    kabupatenSet.push({ id:'64.02', province: 64, name:'Kutai Kartanegara'});
    kabupatenSet.push({ id:'64.08', province: 64, name:'Kutai Timur'});
    kabupatenSet.push({ id:'64.11', province: 64, name:'Mahakam Ulu'});
    kabupatenSet.push({ id:'64.01', province: 64, name:'Paser'});
    kabupatenSet.push({ id:'64.09', province: 64, name:'Penajam Paser Utara'});
    kabupatenSet.push({ id:'64.71', province: 64, name:'Kota Balikpapan'});
    kabupatenSet.push({ id:'65.01', province: 65, name:'Bulungan'});
    kabupatenSet.push({ id:'65.71', province: 65, name:'Kota Tarakan'});
    kabupatenSet.push({ id:'65.02', province: 65, name:'Malinau'});
    kabupatenSet.push({ id:'65.03', province: 65, name:'Nunukan'});
    kabupatenSet.push({ id:'65.04', province: 65, name:'Tana Tidung'});
    kabupatenSet.push({ id:'19.01', province: 19, name:'Bangka'});
    kabupatenSet.push({ id:'19.05', province: 19, name:'Bangka Barat'});
    kabupatenSet.push({ id:'19.03', province: 19, name:'Bangka Selatan'});
    kabupatenSet.push({ id:'19.04', province: 19, name:'Bangka Tengah'});
    kabupatenSet.push({ id:'19.02', province: 19, name:'Belitung'});
    kabupatenSet.push({ id:'19.06', province: 19, name:'Belitung Timur'});
    kabupatenSet.push({ id:'19.71', province: 19, name:'Kota Pangkal Pinang'});
    kabupatenSet.push({ id:'21.01', province: 21, name:'Bintan'});
    kabupatenSet.push({ id:'21.02', province: 21, name:'Karimun'});
    kabupatenSet.push({ id:'21.05', province: 21, name:'Kepulauan Anambas'});
    kabupatenSet.push({ id:'21.71', province: 21, name:'Kota Batam'});
    kabupatenSet.push({ id:'21.72', province: 21, name:'Kota Tanjung Pinang'});
    kabupatenSet.push({ id:'21.04', province: 21, name:'Lingga'});
    kabupatenSet.push({ id:'21.03', province: 21, name:'Natuna'});
    kabupatenSet.push({ id:'18.71', province: 18, name:'Kota Bandar Lampung'});
    kabupatenSet.push({ id:'18.72', province: 18, name:'Kota Metro'});
    kabupatenSet.push({ id:'18.04', province: 18, name:'Lampung Barat'});
    kabupatenSet.push({ id:'18.01', province: 18, name:'Lampung Selatan'});
    kabupatenSet.push({ id:'18.02', province: 18, name:'Lampung Tengah'});
    kabupatenSet.push({ id:'18.07', province: 18, name:'Lampung Timur'});
    kabupatenSet.push({ id:'18.03', province: 18, name:'Lampung Utara'});
    kabupatenSet.push({ id:'18.11', province: 18, name:'Mesuji'});
    kabupatenSet.push({ id:'18.09', province: 18, name:'Pesawaran'});
    kabupatenSet.push({ id:'18.13', province: 18, name:'Pesisir Barat'});
    kabupatenSet.push({ id:'18.10', province: 18, name:'Pringsewu'});
    kabupatenSet.push({ id:'18.06', province: 18, name:'Tanggamus'});
    kabupatenSet.push({ id:'18.05', province: 18, name:'Tulang Bawang'});
    kabupatenSet.push({ id:'18.12', province: 18, name:'Tulang Bawang Barat'});
    kabupatenSet.push({ id:'18.08', province: 18, name:'Way Kanan'});
    kabupatenSet.push({ id:'81.04', province: 81, name:'Buru'});
    kabupatenSet.push({ id:'81.09', province: 81, name:'Buru Selatan'});
    kabupatenSet.push({ id:'81.07', province: 81, name:'Kepulauan Aru'});
    kabupatenSet.push({ id:'81.03', province: 81, name:'Kepulauan Tanimbar'});
    kabupatenSet.push({ id:'81.71', province: 81, name:'Kota Ambon'});
    kabupatenSet.push({ id:'81.72', province: 81, name:'Kota Tual'});
    kabupatenSet.push({ id:'81.08', province: 81, name:'Maluku Barat Daya'});
    kabupatenSet.push({ id:'81.01', province: 81, name:'Maluku Tengah'});
    kabupatenSet.push({ id:'81.02', province: 81, name:'Maluku Tenggara'});
    kabupatenSet.push({ id:'81.06', province: 81, name:'Seram Bagian Barat'});
    kabupatenSet.push({ id:'81.05', province: 81, name:'Seram Bagian Timur'});
    kabupatenSet.push({ id:'82.01', province: 82, name:'Halmahera Barat'});
    kabupatenSet.push({ id:'82.04', province: 82, name:'Halmahera Selatan'});
    kabupatenSet.push({ id:'82.02', province: 82, name:'Halmahera Tengah'});
    kabupatenSet.push({ id:'82.06', province: 82, name:'Halmahera Timur'});
    kabupatenSet.push({ id:'82.03', province: 82, name:'Halmahera Utara'});
    kabupatenSet.push({ id:'82.05', province: 82, name:'Kepulauan Sula'});
    kabupatenSet.push({ id:'82.71', province: 82, name:'Kota Ternate'});
    kabupatenSet.push({ id:'82.72', province: 82, name:'Kota Tidore Kepulauan'});
    kabupatenSet.push({ id:'82.07', province: 82, name:'Pulau Morotai'});
    kabupatenSet.push({ id:'82.08', province: 82, name:'Pulau Taliabu'});
    kabupatenSet.push({ id:'52.06', province: 52, name:'Bima'});
    kabupatenSet.push({ id:'52.05', province: 52, name:'Dompu'});
    kabupatenSet.push({ id:'52.72', province: 52, name:'Kota Bima'});
    kabupatenSet.push({ id:'52.71', province: 52, name:'Kota Mataram'});
    kabupatenSet.push({ id:'52.01', province: 52, name:'Lombok Barat'});
    kabupatenSet.push({ id:'52.02', province: 52, name:'Lombok Tengah'});
    kabupatenSet.push({ id:'52.03', province: 52, name:'Lombok Timur'});
    kabupatenSet.push({ id:'52.08', province: 52, name:'Lombok Utara'});
    kabupatenSet.push({ id:'52.04', province: 52, name:'Sumbawa'});
    kabupatenSet.push({ id:'52.07', province: 52, name:'Sumbawa Barat'});
    kabupatenSet.push({ id:'53.05', province: 53, name:'Alor'});
    kabupatenSet.push({ id:'53.04', province: 53, name:'Belu'});
    kabupatenSet.push({ id:'53.06', province: 53, name:'Flores Timur'});
    kabupatenSet.push({ id:'53.71', province: 53, name:'Kota Kupang'});
    kabupatenSet.push({ id:'53.01', province: 53, name:'Kupang'});
    kabupatenSet.push({ id:'53.13', province: 53, name:'Lembata'});
    kabupatenSet.push({ id:'53.21', province: 53, name:'Malaka'});
    kabupatenSet.push({ id:'53.10', province: 53, name:'Manggarai'});
    kabupatenSet.push({ id:'53.15', province: 53, name:'Manggarai Barat'});
    kabupatenSet.push({ id:'53.19', province: 53, name:'Manggarai Timur'});
    kabupatenSet.push({ id:'53.16', province: 53, name:'Nagekeo'});
    kabupatenSet.push({ id:'53.09', province: 53, name:'Ngada'});
    kabupatenSet.push({ id:'53.14', province: 53, name:'Rote Ndao'});
    kabupatenSet.push({ id:'53.20', province: 53, name:'Sabu Raijua'});
    kabupatenSet.push({ id:'53.07', province: 53, name:'Sikka'});
    kabupatenSet.push({ id:'53.12', province: 53, name:'Sumba Barat'});
    kabupatenSet.push({ id:'53.17', province: 53, name:'Sumba Tengah'});
    kabupatenSet.push({ id:'53.11', province: 53, name:'Sumba Timur'});
    kabupatenSet.push({ id:'53.02', province: 53, name:'Timor Tengah Selatan'});
    kabupatenSet.push({ id:'53.03', province: 53, name:'Timor Tengah Utara'});
    kabupatenSet.push({ id:'53.18', province: 53, name:'Sumba Barat Daya'});
    kabupatenSet.push({ id:'53.08', province: 53, name:'Ende'});
    kabupatenSet.push({ id:'91.18', province: 91, name:'Asmat'});
    kabupatenSet.push({ id:'91.06', province: 91, name:'Biak Numfor'});
    kabupatenSet.push({ id:'91.16', province: 91, name:'Boven Digoel'});
    kabupatenSet.push({ id:'91.28', province: 91, name:'Deiyai'});
    kabupatenSet.push({ id:'91.26', province: 91, name:'Dogiyai'});
    kabupatenSet.push({ id:'91.27', province: 91, name:'Intan Jaya'});
    kabupatenSet.push({ id:'91.03', province: 91, name:'Jayapura'});
    kabupatenSet.push({ id:'91.02', province: 91, name:'Jayawijaya'});
    kabupatenSet.push({ id:'91.11', province: 91, name:'Keerom'});
    kabupatenSet.push({ id:'91.05', province: 91, name:'Kepulauan Yapen'});
    kabupatenSet.push({ id:'91.71', province: 91, name:'Kota Jayapura'});
    kabupatenSet.push({ id:'91.23', province: 91, name:'Lanny Jaya'});
    kabupatenSet.push({ id:'91.20', province: 91, name:'Mamberamo Raya'});
    kabupatenSet.push({ id:'91.21', province: 91, name:'Mamberamo Tengah'});
    kabupatenSet.push({ id:'91.17', province: 91, name:'Mappi'});
    kabupatenSet.push({ id:'91.01', province: 91, name:'Merauke'});
    kabupatenSet.push({ id:'91.09', province: 91, name:'Mimika'});
    kabupatenSet.push({ id:'91.04', province: 91, name:'Nabire'});
    kabupatenSet.push({ id:'91.24', province: 91, name:'Nduga'});
    kabupatenSet.push({ id:'91.08', province: 91, name:'Paniai'});
    kabupatenSet.push({ id:'91.12', province: 91, name:'Pegunungan Bintang'});
    kabupatenSet.push({ id:'91.25', province: 91, name:'Puncak'});
    kabupatenSet.push({ id:'91.07', province: 91, name:'Puncak Jaya'});
    kabupatenSet.push({ id:'91.10', province: 91, name:'Sarmi'});
    kabupatenSet.push({ id:'91.19', province: 91, name:'Supiori'});
    kabupatenSet.push({ id:'91.14', province: 91, name:'Tolikara'});
    kabupatenSet.push({ id:'91.15', province: 91, name:'Waropen'});
    kabupatenSet.push({ id:'91.13', province: 91, name:'Yahukimo'});
    kabupatenSet.push({ id:'91.22', province: 91, name:'Yalimo'});
    kabupatenSet.push({ id:'92.03', province: 92, name:'Fak Fak'});
    kabupatenSet.push({ id:'92.08', province: 92, name:'Kaimana'});
    kabupatenSet.push({ id:'92.71', province: 92, name:'Kota Sorong'});
    kabupatenSet.push({ id:'92.02', province: 92, name:'Manokwari'});
    kabupatenSet.push({ id:'92.11', province: 92, name:'Manokwari Selatan'});
    kabupatenSet.push({ id:'92.10', province: 92, name:'Maybrat'});
    kabupatenSet.push({ id:'92.12', province: 92, name:'Pegunungan Arfak'});
    kabupatenSet.push({ id:'92.05', province: 92, name:'Raja Ampat'});
    kabupatenSet.push({ id:'92.01', province: 92, name:'Sorong'});
    kabupatenSet.push({ id:'92.04', province: 92, name:'Sorong Selatan'});
    kabupatenSet.push({ id:'92.09', province: 92, name:'Tambrauw'});
    kabupatenSet.push({ id:'92.06', province: 92, name:'Teluk Bintuni'});
    kabupatenSet.push({ id:'92.07', province: 92, name:'Teluk Wondama'});
    kabupatenSet.push({ id:'14.03', province: 14, name:'Bengkalis'});
    kabupatenSet.push({ id:'14.04', province: 14, name:'Indragiri Hilir'});
    kabupatenSet.push({ id:'14.02', province: 14, name:'Indragiri Hulu'});
    kabupatenSet.push({ id:'14.01', province: 14, name:'Kampar'});
    kabupatenSet.push({ id:'14.10', province: 14, name:'Kepulauan Meranti'});
    kabupatenSet.push({ id:'14.72', province: 14, name:'Kota Dumai'});
    kabupatenSet.push({ id:'14.71', province: 14, name:'Kota Pekanbaru'});
    kabupatenSet.push({ id:'14.09', province: 14, name:'Kuantan Singingi'});
    kabupatenSet.push({ id:'14.05', province: 14, name:'Pelalawan'});
    kabupatenSet.push({ id:'14.07', province: 14, name:'Rokan Hilir'});
    kabupatenSet.push({ id:'14.06', province: 14, name:'Rokan Hulu'});
    kabupatenSet.push({ id:'14.08', province: 14, name:'Siak'});
    kabupatenSet.push({ id:'76.05', province: 76, name:'Majene'});
    kabupatenSet.push({ id:'76.03', province: 76, name:'Mamasa'});
    kabupatenSet.push({ id:'76.02', province: 76, name:'Mamuju'});
    kabupatenSet.push({ id:'76.06', province: 76, name:'Mamuju Tengah'});
    kabupatenSet.push({ id:'76.01', province: 76, name:'Pasangkayu'});
    kabupatenSet.push({ id:'76.04', province: 76, name:'Polewali Mandar'});
    kabupatenSet.push({ id:'73.03', province: 73, name:'Bantaeng'});
    kabupatenSet.push({ id:'73.11', province: 73, name:'Barru'});
    kabupatenSet.push({ id:'73.08', province: 73, name:'Bone'});
    kabupatenSet.push({ id:'73.02', province: 73, name:'Bulukumba'});
    kabupatenSet.push({ id:'73.16', province: 73, name:'Enrekang'});
    kabupatenSet.push({ id:'73.06', province: 73, name:'Gowa'});
    kabupatenSet.push({ id:'73.04', province: 73, name:'Jeneponto'});
    kabupatenSet.push({ id:'73.01', province: 73, name:'Kepulauan Selayar'});
    kabupatenSet.push({ id:'73.71', province: 73, name:'Kota Makassar'});
    kabupatenSet.push({ id:'73.73', province: 73, name:'Kota Palopo'});
    kabupatenSet.push({ id:'73.72', province: 73, name:'Kota Pare Pare'});
    kabupatenSet.push({ id:'73.17', province: 73, name:'Luwu'});
    kabupatenSet.push({ id:'73.24', province: 73, name:'Luwu Timur'});
    kabupatenSet.push({ id:'73.09', province: 73, name:'Maros'});
    kabupatenSet.push({ id:'73.10', province: 73, name:'Pangkajene Kepulauan'});
    kabupatenSet.push({ id:'73.15', province: 73, name:'Pinrang'});
    kabupatenSet.push({ id:'73.14', province: 73, name:'Sidenreng Rappang'});
    kabupatenSet.push({ id:'73.07', province: 73, name:'Sinjai'});
    kabupatenSet.push({ id:'73.12', province: 73, name:'Soppeng'});
    kabupatenSet.push({ id:'73.05', province: 73, name:'Takalar'});
    kabupatenSet.push({ id:'73.18', province: 73, name:'Tana Toraja'});
    kabupatenSet.push({ id:'73.26', province: 73, name:'Toraja Utara'});
    kabupatenSet.push({ id:'73.13', province: 73, name:'Wajo'});
    kabupatenSet.push({ id:'73.22', province: 73, name:'Luwu Utara'});
    kabupatenSet.push({ id:'72.01', province: 72, name:'Banggai'});
    kabupatenSet.push({ id:'72.07', province: 72, name:'Banggai Kepulauan'});
    kabupatenSet.push({ id:'72.11', province: 72, name:'Banggai Laut'});
    kabupatenSet.push({ id:'72.05', province: 72, name:'Buol'});
    kabupatenSet.push({ id:'72.03', province: 72, name:'Donggala'});
    kabupatenSet.push({ id:'72.71', province: 72, name:'Kota Palu'});
    kabupatenSet.push({ id:'72.02', province: 72, name:'Poso'});
    kabupatenSet.push({ id:'72.06', province: 72, name:'Morowali'});
    kabupatenSet.push({ id:'72.12', province: 72, name:'Morowali Utara'});
    kabupatenSet.push({ id:'72.08', province: 72, name:'Parigi Moutong'});
    kabupatenSet.push({ id:'72.10', province: 72, name:'Sigi'});
    kabupatenSet.push({ id:'72.09', province: 72, name:'Tojo Una Una'});
    kabupatenSet.push({ id:'72.04', province: 72, name:'Toli Toli'});
    kabupatenSet.push({ id:'74.06', province: 74, name:'Bombana'});
    kabupatenSet.push({ id:'74.04', province: 74, name:'Buton'});
    kabupatenSet.push({ id:'74.15', province: 74, name:'Buton Selatan'});
    kabupatenSet.push({ id:'74.14', province: 74, name:'Buton Tengah'});
    kabupatenSet.push({ id:'74.10', province: 74, name:'Buton Utara'});
    kabupatenSet.push({ id:'74.01', province: 74, name:'Kolaka'});
    kabupatenSet.push({ id:'74.11', province: 74, name:'Kolaka Timur'});
    kabupatenSet.push({ id:'74.08', province: 74, name:'Kolaka Utara'});
    kabupatenSet.push({ id:'74.02', province: 74, name:'Konawe'});
    kabupatenSet.push({ id:'74.12', province: 74, name:'Konawe Kepulauan'});
    kabupatenSet.push({ id:'74.05', province: 74, name:'Konawe Selatan'});
    kabupatenSet.push({ id:'74.09', province: 74, name:'Konawe Utara'});
    kabupatenSet.push({ id:'74.72', province: 74, name:'Kota Bau Bau'});
    kabupatenSet.push({ id:'74.71', province: 74, name:'Kota Kendari'});
    kabupatenSet.push({ id:'74.03', province: 74, name:'Muna'});
    kabupatenSet.push({ id:'74.13', province: 74, name:'Muna Barat'});
    kabupatenSet.push({ id:'74.07', province: 74, name:'Wakatobi'});
    kabupatenSet.push({ id:'71.01', province: 71, name:'Bolaang Mongondow'});
    kabupatenSet.push({ id:'71.11', province: 71, name:'Bolaang Mongondow Selatan'});
    kabupatenSet.push({ id:'71.10', province: 71, name:'Bolaang Mongondow Timur'});
    kabupatenSet.push({ id:'71.08', province: 71, name:'Bolaang Mongondow Utara'});
    kabupatenSet.push({ id:'71.03', province: 71, name:'Kepulauan Sangihe'});
    kabupatenSet.push({ id:'71.09', province: 71, name:'Kepulauan Siau Tagulandang Biaro'});
    kabupatenSet.push({ id:'71.04', province: 71, name:'Kepulauan Talaud'});
    kabupatenSet.push({ id:'71.72', province: 71, name:'Kota Bitung'});
    kabupatenSet.push({ id:'71.74', province: 71, name:'Kota Kotamobagu'});
    kabupatenSet.push({ id:'71.71', province: 71, name:'Kota Manado'});
    kabupatenSet.push({ id:'71.73', province: 71, name:'Kota Tomohon'});
    kabupatenSet.push({ id:'71.02', province: 71, name:'Minahasa'});
    kabupatenSet.push({ id:'71.05', province: 71, name:'Minahasa Selatan'});
    kabupatenSet.push({ id:'71.07', province: 71, name:'Minahasa Tenggara'});
    kabupatenSet.push({ id:'71.06', province: 71, name:'Minahasa Utara'});
    kabupatenSet.push({ id:'13.06', province: 13, name:'Agam'});
    kabupatenSet.push({ id:'13.10', province: 13, name:'Dharmasraya'});
    kabupatenSet.push({ id:'13.09', province: 13, name:'Kepulauan Mentawai'});
    kabupatenSet.push({ id:'13.75', province: 13, name:'Kota Bukittinggi'});
    kabupatenSet.push({ id:'13.71', province: 13, name:'Kota Padang'});
    kabupatenSet.push({ id:'13.74', province: 13, name:'Kota Padang Panjang'});
    kabupatenSet.push({ id:'13.77', province: 13, name:'Kota Pariaman'});
    kabupatenSet.push({ id:'13.76', province: 13, name:'Kota Payakumbuh'});
    kabupatenSet.push({ id:'13.73', province: 13, name:'Kota Sawahlunto'});
    kabupatenSet.push({ id:'13.72', province: 13, name:'Kota Solok'});
    kabupatenSet.push({ id:'13.07', province: 13, name:'Lima Puluh Kota'});
    kabupatenSet.push({ id:'13.08', province: 13, name:'Pasaman'});
    kabupatenSet.push({ id:'13.12', province: 13, name:'Pasaman Barat'});
    kabupatenSet.push({ id:'13.01', province: 13, name:'Pesisir Selatan'});
    kabupatenSet.push({ id:'13.03', province: 13, name:'Sijunjung'});
    kabupatenSet.push({ id:'13.02', province: 13, name:'Solok'});
    kabupatenSet.push({ id:'13.11', province: 13, name:'Solok Selatan'});
    kabupatenSet.push({ id:'13.04', province: 13, name:'Tanah Datar'});
    kabupatenSet.push({ id:'13.05', province: 13, name:'Padang Pariaman'});
    kabupatenSet.push({ id:'16.07', province: 16, name:'Banyuasin'});
    kabupatenSet.push({ id:'16.11', province: 16, name:'Empat Lawang'});
    kabupatenSet.push({ id:'16.73', province: 16, name:'Kota Lubuk Linggau'});
    kabupatenSet.push({ id:'16.72', province: 16, name:'Kota Pagar Alam'});
    kabupatenSet.push({ id:'16.71', province: 16, name:'Kota Palembang'});
    kabupatenSet.push({ id:'16.74', province: 16, name:'Kota Prabumulih'});
    kabupatenSet.push({ id:'16.04', province: 16, name:'Lahat'});
    kabupatenSet.push({ id:'16.03', province: 16, name:'Muara Enim'});
    kabupatenSet.push({ id:'16.06', province: 16, name:'Musi Banyuasin'});
    kabupatenSet.push({ id:'16.05', province: 16, name:'Musi Rawas'});
    kabupatenSet.push({ id:'16.13', province: 16, name:'Musi Rawas Utara'});
    kabupatenSet.push({ id:'16.10', province: 16, name:'Ogan Ilir'});
    kabupatenSet.push({ id:'16.02', province: 16, name:'Ogan Komering Ilir'});
    kabupatenSet.push({ id:'16.01', province: 16, name:'Ogan Komering Ulu'});
    kabupatenSet.push({ id:'16.09', province: 16, name:'Ogan Komering Ulu Selatan'});
    kabupatenSet.push({ id:'16.08', province: 16, name:'Ogan Komering Ulu Timur'});
    kabupatenSet.push({ id:'16.12', province: 16, name:'Penukal Abab Lematang Ilir'});
    kabupatenSet.push({ id:'12.09', province: 12, name:'Asahan'});
    kabupatenSet.push({ id:'12.19', province: 12, name:'Batu Bara'});
    kabupatenSet.push({ id:'12.11', province: 12, name:'Dairi'});
    kabupatenSet.push({ id:'12.07', province: 12, name:'Deli Serdang'});
    kabupatenSet.push({ id:'12.16', province: 12, name:'Humbang Hasundutan'});
    kabupatenSet.push({ id:'12.06', province: 12, name:'Karo'});
    kabupatenSet.push({ id:'12.75', province: 12, name:'Kota Binjai'});
    kabupatenSet.push({ id:'12.78', province: 12, name:'Kota Gunungsitoli'});
    kabupatenSet.push({ id:'12.71', province: 12, name:'Kota Medan'});
    kabupatenSet.push({ id:'12.77', province: 12, name:'Kota Padang Sidempuan'});
    kabupatenSet.push({ id:'12.72', province: 12, name:'Kota Pematangsiantar'});
    kabupatenSet.push({ id:'12.73', province: 12, name:'Kota Sibolga'});
    kabupatenSet.push({ id:'12.74', province: 12, name:'Kota Tanjung Balai'});
    kabupatenSet.push({ id:'12.76', province: 12, name:'Kota Tebing Tinggi'});
    kabupatenSet.push({ id:'12.10', province: 12, name:'Labuhanbatu'});
    kabupatenSet.push({ id:'12.22', province: 12, name:'Labuhanbatu Selatan'});
    kabupatenSet.push({ id:'12.23', province: 12, name:'Labuhanbatu Utara'});
    kabupatenSet.push({ id:'12.05', province: 12, name:'Langkat'});
    kabupatenSet.push({ id:'12.13', province: 12, name:'Mandailing Natal'});
    kabupatenSet.push({ id:'12.04', province: 12, name:'Nias'});
    kabupatenSet.push({ id:'12.25', province: 12, name:'Nias Barat'});
    kabupatenSet.push({ id:'12.14', province: 12, name:'Nias Selatan'});
    kabupatenSet.push({ id:'12.24', province: 12, name:'Nias Utara'});
    kabupatenSet.push({ id:'12.21', province: 12, name:'Padang Lawas'});
    kabupatenSet.push({ id:'12.20', province: 12, name:'Padang Lawas Utara'});
    kabupatenSet.push({ id:'12.15', province: 12, name:'Pakpak Bharat'});
    kabupatenSet.push({ id:'12.17', province: 12, name:'Samosir'});
    kabupatenSet.push({ id:'12.18', province: 12, name:'Serdang Bedagai'});
    kabupatenSet.push({ id:'12.08', province: 12, name:'Simalungun'});
    kabupatenSet.push({ id:'12.03', province: 12, name:'Tapanuli Selatan'});
    kabupatenSet.push({ id:'12.01', province: 12, name:'Tapanuli Tengah'});
    kabupatenSet.push({ id:'12.02', province: 12, name:'Tapanuli Utara'});
    kabupatenSet.push({ id:'12.12', province: 12, name:'Toba'});
    kabupatenSet.push({ id:'31.01', province: 31, name:'Administrasi Kepulauan Seribu'});
    kabupatenSet.push({ id:'31.73', province: 31, name:'Kota Administrasi Jakarta Barat'});
    kabupatenSet.push({ id:'31.71', province: 31, name:'Kota Administrasi Jakarta Pusat'});
    kabupatenSet.push({ id:'31.74', province: 31, name:'Kota Administrasi Jakarta Selatan'});
    kabupatenSet.push({ id:'31.75', province: 31, name:'Kota Administrasi Jakarta Timur'});
    kabupatenSet.push({ id:'31.72', province: 31, name:'Kota Administrasi Jakarta Utara'});
    setListMunicipals(kabupatenSet)
    console.log('municipals done')
  }

  function load_kecamatan() {
    var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
    /*
    kecamatanSet.push({ id: '53.06.17', kabupaten: '53.06', name: 'Adonara' })
    kecamatanSet.push({ id: '53.06.08', kabupaten: '53.06', name: 'Adonara Barat' })
    kecamatanSet.push({ id: '53.06.18', kabupaten: '53.06', name: 'Adonara Tengah' })
    kecamatanSet.push({ id: '53.06.10', kabupaten: '53.06', name: 'Adonara Timur' })
    kecamatanSet.push({ id: '53.16.01', kabupaten: '53.16', name: 'Aesesa' })
    kecamatanSet.push({ id: '53.16.07', kabupaten: '53.16', name: 'Aesesa Selatan' })
    kecamatanSet.push({ id: '53.09.01', kabupaten: '53.09', name: 'Aimere' })
    kecamatanSet.push({ id: '53.71.01', kabupaten: '53.71', name: 'Alak' })
    kecamatanSet.push({ id: '53.07.05', kabupaten: '53.07', name: 'Alok' })
    kecamatanSet.push({ id: '53.07.14', kabupaten: '53.07', name: 'Alok Barat' })
    kecamatanSet.push({ id: '53.07.15', kabupaten: '53.07', name: 'Alok Timur' })
    kecamatanSet.push({ id: '53.05.03', kabupaten: '53.05', name: 'Alor Barat Daya' })
    kecamatanSet.push({ id: '53.05.02', kabupaten: '53.05', name: 'Alor Barat Laut' })
    kecamatanSet.push({ id: '53.05.04', kabupaten: '53.05', name: 'Alor Selatan' })
    kecamatanSet.push({ id: '53.05.07', kabupaten: '53.05', name: 'Alor Tengah Utara' })
    kecamatanSet.push({ id: '53.05.05', kabupaten: '53.05', name: 'Alor Timur' })
    kecamatanSet.push({ id: '53.05.08', kabupaten: '53.05', name: 'Alor Timur Laut' })
    kecamatanSet.push({ id: '53.01.25', kabupaten: '53.01', name: 'Amabi Oefeto' })
    kecamatanSet.push({ id: '53.01.20', kabupaten: '53.01', name: 'Amabi Oefeto Timur' })
    kecamatanSet.push({ id: '53.02.08', kabupaten: '53.02', name: 'Amanatun Selatan' })
    kecamatanSet.push({ id: '53.02.09', kabupaten: '53.02', name: 'Amanatun Utara' })
    kecamatanSet.push({ id: '53.02.07', kabupaten: '53.02', name: 'Amanuban Barat' })
    kecamatanSet.push({ id: '53.02.06', kabupaten: '53.02', name: 'Amanuban Selatan' })
    kecamatanSet.push({ id: '53.02.05', kabupaten: '53.02', name: 'Amanuban Tengah' })
    kecamatanSet.push({ id: '53.02.04', kabupaten: '53.02', name: 'Amanuban Timur' })
    kecamatanSet.push({ id: '53.01.09', kabupaten: '53.01', name: 'Amarasi' })
    kecamatanSet.push({ id: '53.01.17', kabupaten: '53.01', name: 'Amarasi Barat' })
    kecamatanSet.push({ id: '53.01.18', kabupaten: '53.01', name: 'Amarasi Selatan' })
    kecamatanSet.push({ id: '53.01.19', kabupaten: '53.01', name: 'Amarasi Timur' })
    kecamatanSet.push({ id: '53.01.21', kabupaten: '53.01', name: 'Amfoang Barat Daya' })
    kecamatanSet.push({ id: '53.01.22', kabupaten: '53.01', name: 'Amfoang Barat Laut' })
    kecamatanSet.push({ id: '53.01.12', kabupaten: '53.01', name: 'Amfoang Selatan' })
    kecamatanSet.push({ id: '53.01.30', kabupaten: '53.01', name: 'Amfoang Tengah' })
    kecamatanSet.push({ id: '53.01.26', kabupaten: '53.01', name: 'Amfoang Timur' })
    kecamatanSet.push({ id: '53.01.13', kabupaten: '53.01', name: 'Amfoang Utara' })
    kecamatanSet.push({ id: '53.13.02', kabupaten: '53.13', name: 'Atadei' })
    kecamatanSet.push({ id: '53.04.21', kabupaten: '53.04', name: 'Atambua Barat' })
    kecamatanSet.push({ id: '53.04.22', kabupaten: '53.04', name: 'Atambua Selatan' })
    kecamatanSet.push({ id: '53.09.06', kabupaten: '53.09', name: 'Bajawa' })
    kecamatanSet.push({ id: '53.09.15', kabupaten: '53.09', name: 'Bajawa Utara' })
    kecamatanSet.push({ id: '53.02.14', kabupaten: '53.02', name: 'Batu Putih' })
    kecamatanSet.push({ id: '53.03.07', kabupaten: '53.03', name: 'Biboki Anleu' })
    kecamatanSet.push({ id: '53.03.24', kabupaten: '53.03', name: 'Biboki Feotleu' })
    kecamatanSet.push({ id: '53.03.23', kabupaten: '53.03', name: 'Biboki Moenleu' })
    kecamatanSet.push({ id: '53.03.03', kabupaten: '53.03', name: 'Biboki Selatan' })
    kecamatanSet.push({ id: '53.03.22', kabupaten: '53.03', name: 'Biboki Tan Pah' })
    kecamatanSet.push({ id: '53.03.06', kabupaten: '53.03', name: 'Biboki Utara' })
    kecamatanSet.push({ id: '53.03.16', kabupaten: '53.03', name: 'Bikomi Nilulat' })
    kecamatanSet.push({ id: '53.03.14', kabupaten: '53.03', name: 'Bikomi Selatan' })
    kecamatanSet.push({ id: '53.03.15', kabupaten: '53.03', name: 'Bikomi Tengah' })
    kecamatanSet.push({ id: '53.03.17', kabupaten: '53.03', name: 'Bikomi Utara' })
    kecamatanSet.push({ id: '53.16.03', kabupaten: '53.16', name: 'Boawae' })
    kecamatanSet.push({ id: '53.02.15', kabupaten: '53.02', name: 'Boking' })
    kecamatanSet.push({ id: '53.07.11', kabupaten: '53.07', name: 'Bola' })
    kecamatanSet.push({ id: '53.15.06', kabupaten: '53.15', name: 'Boleng' })
    kecamatanSet.push({ id: '53.19.01', kabupaten: '53.19', name: 'Borong' })
    kecamatanSet.push({ id: '53.21.12', kabupaten: '53.21', name: 'Botin Leobele' })
    kecamatanSet.push({ id: '53.13.07', kabupaten: '53.13', name: 'Buyasuri' })
    kecamatanSet.push({ id: '53.10.06', kabupaten: '53.10', name: 'Cibal' })
    kecamatanSet.push({ id: '53.10.17', kabupaten: '53.10', name: 'Cibal barat' })
    kecamatanSet.push({ id: '53.06.14', kabupaten: '53.06', name: 'Demon Pagong' })
    kecamatanSet.push({ id: '53.08.15', kabupaten: '53.08', name: 'Detukeli' })
    kecamatanSet.push({ id: '53.08.06', kabupaten: '53.08', name: 'Detusoko' })
    kecamatanSet.push({ id: '53.07.20', kabupaten: '53.07', name: 'Doreng' })
    kecamatanSet.push({ id: '53.19.05', kabupaten: '53.19', name: 'Elar' })
    kecamatanSet.push({ id: '53.19.09', kabupaten: '53.19', name: 'Elar Selatan' })
    kecamatanSet.push({ id: '53.08.03', kabupaten: '53.08', name: 'Ende' })
    kecamatanSet.push({ id: '53.08.04', kabupaten: '53.08', name: 'Ende Selatan' })
    kecamatanSet.push({ id: '53.08.19', kabupaten: '53.08', name: 'Ende Tengah' })
    kecamatanSet.push({ id: '53.08.20', kabupaten: '53.08', name: 'Ende Timur' })
    kecamatanSet.push({ id: '53.08.18', kabupaten: '53.08', name: 'Ende Utara' })
    kecamatanSet.push({ id: '53.02.29', kabupaten: '53.02', name: 'Fatukopa' })
    kecamatanSet.push({ id: '53.01.10', kabupaten: '53.01', name: 'Fatuleu' })
    kecamatanSet.push({ id: '53.01.27', kabupaten: '53.01', name: 'Fatuleu Barat' })
    kecamatanSet.push({ id: '53.01.28', kabupaten: '53.01', name: 'Fatuleu Tengah' })
    kecamatanSet.push({ id: '53.02.12', kabupaten: '53.02', name: 'Fatumnasi' })
    kecamatanSet.push({ id: '53.02.28', kabupaten: '53.02', name: 'Fautmolo' })
    kecamatanSet.push({ id: '53.09.02', kabupaten: '53.09', name: 'Golewa' })
    kecamatanSet.push({ id: '53.09.19', kabupaten: '53.09', name: 'Golewa Barat' })
    kecamatanSet.push({ id: '53.09.18', kabupaten: '53.09', name: 'Golewa Selatan' })
    kecamatanSet.push({ id: '53.11.02', kabupaten: '53.11', name: 'Haharu' })
    kecamatanSet.push({ id: '53.20.05', kabupaten: '53.20', name: 'Hawu Mehara' })
    kecamatanSet.push({ id: '53.07.18', kabupaten: '53.07', name: 'Hewokloang' })
    kecamatanSet.push({ id: '53.13.03', kabupaten: '53.13', name: 'Ile Ape' })
    kecamatanSet.push({ id: '53.13.09', kabupaten: '53.13', name: 'Ile Ape Timur' })
    kecamatanSet.push({ id: '53.06.13', kabupaten: '53.06', name: 'Ile Boleng' })
    kecamatanSet.push({ id: '53.06.16', kabupaten: '53.06', name: 'Ile Bura' })
    kecamatanSet.push({ id: '53.06.04', kabupaten: '53.06', name: 'Ile Mandiri' })
    kecamatanSet.push({ id: '53.09.20', kabupaten: '53.09', name: 'Inerie' })
    kecamatanSet.push({ id: '53.03.08', kabupaten: '53.03', name: 'Insana' })
    kecamatanSet.push({ id: '53.03.20', kabupaten: '53.03', name: 'Insana Barat' })
    kecamatanSet.push({ id: '53.03.19', kabupaten: '53.03', name: 'Insana Fafinesu' })
    kecamatanSet.push({ id: '53.03.21', kabupaten: '53.03', name: 'Insana Tengah' })
    kecamatanSet.push({ id: '53.03.09', kabupaten: '53.03', name: 'Insana Utara' })
    kecamatanSet.push({ id: '53.21.06', kabupaten: '53.21', name: 'Io Kufeu' })
    kecamatanSet.push({ id: '53.09.12', kabupaten: '53.09', name: 'Jerebuu' })
    kecamatanSet.push({ id: '53.02.10', kabupaten: '53.02', name: "KI'E" })
    kecamatanSet.push({ id: '53.05.10', kabupaten: '53.05', name: 'Kabola' })
    kecamatanSet.push({ id: '53.11.14', kabupaten: '53.11', name: 'Kahaungu Eti' })
    kecamatanSet.push({ id: '53.04.05', kabupaten: '53.04', name: 'Kakuluk Mesak' })
    kecamatanSet.push({ id: '53.11.17', kabupaten: '53.11', name: 'Kambata Mapambuhang' })
    kecamatanSet.push({ id: '53.11.16', kabupaten: '53.11', name: 'Kambera' })
    kecamatanSet.push({ id: '53.11.20', kabupaten: '53.11', name: 'Kanatang' })
    kecamatanSet.push({ id: '53.07.19', kabupaten: '53.07', name: 'Kangae' })
    kecamatanSet.push({ id: '53.11.13', kabupaten: '53.11', name: 'Karera' })
    kecamatanSet.push({ id: '53.11.19', kabupaten: '53.11', name: 'Katala Hamu Lingu' })
    kecamatanSet.push({ id: '53.17.01', kabupaten: '53.17', name: 'Katiku Tana' })
    kecamatanSet.push({ id: '53.17.05', kabupaten: '53.17', name: 'Katiku Tana Selatan' })
    kecamatanSet.push({ id: '53.71.03', kabupaten: '53.71', name: 'Kelapa Lima' })
    kecamatanSet.push({ id: '53.08.14', kabupaten: '53.08', name: 'Kelimutu' })
    kecamatanSet.push({ id: '53.06.11', kabupaten: '53.06', name: 'Kelubagolit' })
    kecamatanSet.push({ id: '53.16.06', kabupaten: '53.16', name: 'Keo Tengah' })
    kecamatanSet.push({ id: '53.07.10', kabupaten: '53.07', name: 'Kewapante' })
    kecamatanSet.push({ id: '53.21.11', kabupaten: '53.21', name: 'Kobalima' })
    kecamatanSet.push({ id: '53.21.10', kabupaten: '53.21', name: 'Kobalima Timur' })
    kecamatanSet.push({ id: '53.18.07', kabupaten: '53.18', name: 'Kodi' })
    kecamatanSet.push({ id: '53.18.11', kabupaten: '53.18', name: 'Kodi Balaghar' })
    kecamatanSet.push({ id: '53.18.06', kabupaten: '53.18', name: 'Kodi Bangedo' })
    kecamatanSet.push({ id: '53.18.08', kabupaten: '53.18', name: 'Kodi Utara' })
    kecamatanSet.push({ id: '53.02.23', kabupaten: '53.02', name: 'Kok Baun' })
    kecamatanSet.push({ id: '53.02.19', kabupaten: '53.02', name: 'Kolbano' })
    kecamatanSet.push({ id: '53.15.05', kabupaten: '53.15', name: 'Komodo' })
    kecamatanSet.push({ id: '53.02.20', kabupaten: '53.02', name: 'Kot olin' })
    kecamatanSet.push({ id: '53.04.12', kabupaten: '53.04', name: 'Kota Atambua' })
    kecamatanSet.push({ id: '53.08.13', kabupaten: '53.08', name: 'Kota Baru' })
    kecamatanSet.push({ id: '53.03.05', kabupaten: '53.03', name: 'Kota Kefamenanu' })
    kecamatanSet.push({ id: '53.19.06', kabupaten: '53.19', name: 'Kota Komba' })
    kecamatanSet.push({ id: '53.71.06', kabupaten: '53.71', name: 'Kota Lama' })
    kecamatanSet.push({ id: '53.71.05', kabupaten: '53.71', name: 'Kota Raja' })
    kecamatanSet.push({ id: '53.02.01', kabupaten: '53.02', name: 'Kota Soe' })
    kecamatanSet.push({ id: '53.18.09', kabupaten: '53.18', name: 'Kota Tambolaka' })
    kecamatanSet.push({ id: '53.12.15', kabupaten: '53.12', name: 'Kota Waikabubak' })
    kecamatanSet.push({ id: '53.11.01', kabupaten: '53.11', name: 'Kota Waingapu' })
    kecamatanSet.push({ id: '53.07.16', kabupaten: '53.07', name: 'Koting' })
    kecamatanSet.push({ id: '53.02.21', kabupaten: '53.02', name: 'Kualin' })
    kecamatanSet.push({ id: '53.02.11', kabupaten: '53.02', name: 'Kuanfatu' })
    kecamatanSet.push({ id: '53.02.27', kabupaten: '53.02', name: 'Kuatnana' })
    kecamatanSet.push({ id: '53.01.05', kabupaten: '53.01', name: 'Kupang Barat' })
    kecamatanSet.push({ id: '53.01.08', kabupaten: '53.01', name: 'Kupang Tengah' })
    kecamatanSet.push({ id: '53.01.06', kabupaten: '53.01', name: 'Kupang Timur' })
    kecamatanSet.push({ id: '53.15.02', kabupaten: '53.15', name: 'Kuwus' })
    kecamatanSet.push({ id: '53.15.12', kabupaten: '53.15', name: 'Kuwus Barat' })
    kecamatanSet.push({ id: '53.12.18', kabupaten: '53.12', name: 'Laboya Barat' })
    kecamatanSet.push({ id: '53.21.08', kabupaten: '53.21', name: 'Laenmanen' })
    kecamatanSet.push({ id: '53.04.01', kabupaten: '53.04', name: 'Lamaknen' })
    kecamatanSet.push({ id: '53.04.18', kabupaten: '53.04', name: 'Lamaknen Selatan' })
    kecamatanSet.push({ id: '53.19.03', kabupaten: '53.19', name: 'Lamba Leda' })
    kecamatanSet.push({ id: '53.12.12', kabupaten: '53.12', name: 'Lamboya' })
    kecamatanSet.push({ id: '53.14.10', kabupaten: '53.14', name: 'Landu Leko' })
    kecamatanSet.push({ id: '53.10.12', kabupaten: '53.10', name: 'Langke Rembong' })
    kecamatanSet.push({ id: '53.06.03', kabupaten: '53.06', name: 'Larantuka' })
    kecamatanSet.push({ id: '53.04.17', kabupaten: '53.04', name: 'Lasiolat' })
    kecamatanSet.push({ id: '53.13.04', kabupaten: '53.13', name: 'Lebatukan' })
    kecamatanSet.push({ id: '53.07.03', kabupaten: '53.07', name: 'Lela' })
    kecamatanSet.push({ id: '53.10.15', kabupaten: '53.10', name: 'Lelak' })
    kecamatanSet.push({ id: '53.15.03', kabupaten: '53.15', name: 'Lembor' })
    kecamatanSet.push({ id: '53.15.09', kabupaten: '53.15', name: 'Lembor Selatan' })
    kecamatanSet.push({ id: '53.05.15', kabupaten: '53.05', name: 'Lembur' })
    kecamatanSet.push({ id: '53.08.21', kabupaten: '53.08', name: 'Lepembusu Kelisoke' })
    kecamatanSet.push({ id: '53.11.03', kabupaten: '53.11', name: 'Lewa' })
    kecamatanSet.push({ id: '53.11.18', kabupaten: '53.11', name: 'Lewa Tidahu' })
    kecamatanSet.push({ id: '53.06.15', kabupaten: '53.06', name: 'Lewolema' })
    kecamatanSet.push({ id: '53.08.12', kabupaten: '53.08', name: 'Lio Timur' })
    kecamatanSet.push({ id: '53.14.03', kabupaten: '53.14', name: 'Lobalain' })
    kecamatanSet.push({ id: '53.12.10', kabupaten: '53.12', name: 'Loli' })
    kecamatanSet.push({ id: '53.18.01', kabupaten: '53.18', name: 'Loura' })
    kecamatanSet.push({ id: '53.15.01', kabupaten: '53.15', name: 'Macang Pacar' })
    kecamatanSet.push({ id: '53.07.12', kabupaten: '53.07', name: 'Magepanda' })
    kecamatanSet.push({ id: '53.11.22', kabupaten: '53.11', name: 'Mahu' })
    kecamatanSet.push({ id: '53.21.02', kabupaten: '53.21', name: 'Malaka Barat' })
    kecamatanSet.push({ id: '53.21.01', kabupaten: '53.21', name: 'Malaka Tengah' })
    kecamatanSet.push({ id: '53.21.09', kabupaten: '53.21', name: 'Malaka Timur' })
    kecamatanSet.push({ id: '53.17.03', kabupaten: '53.17', name: 'Mamboro' })
    kecamatanSet.push({ id: '53.07.21', kabupaten: '53.07', name: 'Mapitara' })
    kecamatanSet.push({ id: '53.05.12', kabupaten: '53.05', name: 'Mataru' })
    kecamatanSet.push({ id: '53.11.15', kabupaten: '53.11', name: 'Matawai La Pawu' })
    kecamatanSet.push({ id: '53.08.11', kabupaten: '53.08', name: 'Maukaro' })
    kecamatanSet.push({ id: '53.71.02', kabupaten: '53.71', name: 'Maulafa' })
    kecamatanSet.push({ id: '53.16.04', kabupaten: '53.16', name: 'Mauponggo' })
    kecamatanSet.push({ id: '53.08.10', kabupaten: '53.08', name: 'Maurole' })
    kecamatanSet.push({ id: '53.15.10', kabupaten: '53.15', name: 'Mbeliling' })
    kecamatanSet.push({ id: '53.07.02', kabupaten: '53.07', name: 'Mego' })
    kecamatanSet.push({ id: '53.03.11', kabupaten: '53.03', name: 'Miomaffo Tengah' })
    kecamatanSet.push({ id: '53.03.02', kabupaten: '53.03', name: 'Miomafo Barat' })
    kecamatanSet.push({ id: '53.03.01', kabupaten: '53.03', name: 'Miomafo Timur' })
    kecamatanSet.push({ id: '53.02.22', kabupaten: '53.02', name: 'Mollo Barat' })
    kecamatanSet.push({ id: '53.02.02', kabupaten: '53.02', name: 'Mollo Selatan' })
    kecamatanSet.push({ id: '53.02.30', kabupaten: '53.02', name: 'Mollo Tengah' })
    kecamatanSet.push({ id: '53.02.03', kabupaten: '53.02', name: 'Mollo Utara' })
    kecamatanSet.push({ id: '53.03.12', kabupaten: '53.03', name: 'Musi' })
    kecamatanSet.push({ id: '53.03.13', kabupaten: '53.03', name: 'Mutis' })
    kecamatanSet.push({ id: '53.13.01', kabupaten: '53.13', name: 'Naga Wutung' })
    kecamatanSet.push({ id: '53.03.18', kabupaten: '53.03', name: 'Naibenu' })
    kecamatanSet.push({ id: '53.04.23', kabupaten: '53.04', name: 'Nanaet Duabesi' })
    kecamatanSet.push({ id: '53.08.01', kabupaten: '53.08', name: 'Nangapanda' })
    kecamatanSet.push({ id: '53.16.02', kabupaten: '53.16', name: 'Nangaroro' })
    kecamatanSet.push({ id: '53.14.09', kabupaten: '53.14', name: 'Ndao Nuse' })
    kecamatanSet.push({ id: '53.08.05', kabupaten: '53.08', name: 'Ndona' })
    kecamatanSet.push({ id: '53.08.16', kabupaten: '53.08', name: 'Ndona Timur' })
    kecamatanSet.push({ id: '53.08.17', kabupaten: '53.08', name: 'Ndori' })
    kecamatanSet.push({ id: '53.15.08', kabupaten: '53.15', name: 'Ndoso' })
    kecamatanSet.push({ id: '53.01.16', kabupaten: '53.01', name: 'Nekamese' })
    kecamatanSet.push({ id: '53.07.07', kabupaten: '53.07', name: 'Nelle' })
    kecamatanSet.push({ id: '53.11.21', kabupaten: '53.11', name: 'Ngadu Ngala' })
    kecamatanSet.push({ id: '53.11.04', kabupaten: '53.11', name: 'Nggaha Ori Angu' })
    kecamatanSet.push({ id: '53.07.04', kabupaten: '53.07', name: 'Nita' })
    kecamatanSet.push({ id: '53.02.24', kabupaten: '53.02', name: 'Noebana' })
    kecamatanSet.push({ id: '53.02.26', kabupaten: '53.02', name: 'Noebeba' })
    kecamatanSet.push({ id: '53.03.04', kabupaten: '53.03', name: 'Noemuti' })
    kecamatanSet.push({ id: '53.03.10', kabupaten: '53.03', name: 'Noemuti Timur' })
    kecamatanSet.push({ id: '53.13.05', kabupaten: '53.13', name: 'Nubatukan' })
    kecamatanSet.push({ id: '53.02.32', kabupaten: '53.02', name: 'Nunbena' })
    kecamatanSet.push({ id: '53.02.17', kabupaten: '53.02', name: 'Nunkolo' })
    kecamatanSet.push({ id: '53.71.04', kabupaten: '53.71', name: 'Oebobo' })
    kecamatanSet.push({ id: '53.02.18', kabupaten: '53.02', name: 'Oenino' })
    kecamatanSet.push({ id: '53.13.06', kabupaten: '53.13', name: 'Omesuri' })
    kecamatanSet.push({ id: '53.11.12', kabupaten: '53.11', name: 'Paberiwai' })
    kecamatanSet.push({ id: '53.15.11', kabupaten: '53.15', name: 'Pacar' })
    kecamatanSet.push({ id: '53.07.01', kabupaten: '53.07', name: 'Paga' })
    kecamatanSet.push({ id: '53.11.10', kabupaten: '53.11', name: 'Pahunga Lodu' })
    kecamatanSet.push({ id: '53.07.06', kabupaten: '53.07', name: 'Palue' })
    kecamatanSet.push({ id: '53.11.07', kabupaten: '53.11', name: 'Pandawai' })
    kecamatanSet.push({ id: '53.14.05', kabupaten: '53.14', name: 'Pantai Baru' })
    kecamatanSet.push({ id: '53.05.06', kabupaten: '53.05', name: 'Pantar' })
    kecamatanSet.push({ id: '53.05.09', kabupaten: '53.05', name: 'Pantar Barat' })
    kecamatanSet.push({ id: '53.05.17', kabupaten: '53.05', name: 'Pantar Baru Laut' })
    kecamatanSet.push({ id: '53.05.16', kabupaten: '53.05', name: 'Pantar Tengah' })
    kecamatanSet.push({ id: '53.05.14', kabupaten: '53.05', name: 'Pantar Timur' })
    kecamatanSet.push({ id: '53.11.06', kabupaten: '53.11', name: 'Pinu Pahar' })
    kecamatanSet.push({ id: '53.19.02', kabupaten: '53.19', name: 'Poco Ranaka' })
    kecamatanSet.push({ id: '53.19.08', kabupaten: '53.19', name: 'Poco Ranaka Timur' })
    kecamatanSet.push({ id: '53.02.13', kabupaten: '53.02', name: 'Polen' })
    kecamatanSet.push({ id: '53.08.02', kabupaten: '53.08', name: 'Pulau Ende' })
    kecamatanSet.push({ id: '53.05.11', kabupaten: '53.05', name: 'Pulau Pura' })
    kecamatanSet.push({ id: '53.05.13', kabupaten: '53.05', name: 'Pureman' })
    kecamatanSet.push({ id: '53.10.14', kabupaten: '53.10', name: 'Rahong Utara' })
    kecamatanSet.push({ id: '53.04.03', kabupaten: '53.04', name: 'Raihat' })
    kecamatanSet.push({ id: '53.20.06', kabupaten: '53.20', name: 'Raijua' })
    kecamatanSet.push({ id: '53.04.13', kabupaten: '53.04', name: 'Raimanuk' })
    kecamatanSet.push({ id: '53.19.07', kabupaten: '53.19', name: 'Rana Mese' })
    kecamatanSet.push({ id: '53.10.11', kabupaten: '53.10', name: 'Reok' })
    kecamatanSet.push({ id: '53.10.16', kabupaten: '53.10', name: 'Reok Barat' })
    kecamatanSet.push({ id: '53.11.09', kabupaten: '53.11', name: 'Rindi' })
    kecamatanSet.push({ id: '53.21.05', kabupaten: '53.21', name: 'Rinhat' })
    kecamatanSet.push({ id: '53.09.09', kabupaten: '53.09', name: 'Riung' })
    kecamatanSet.push({ id: '53.09.14', kabupaten: '53.09', name: 'Riung Barat' })
    kecamatanSet.push({ id: '53.14.08', kabupaten: '53.14', name: 'Rote  Selatan' })
    kecamatanSet.push({ id: '53.14.07', kabupaten: '53.14', name: 'Rote Barat' })
    kecamatanSet.push({ id: '53.14.01', kabupaten: '53.14', name: 'Rote Barat Daya' })
    kecamatanSet.push({ id: '53.14.02', kabupaten: '53.14', name: 'Rote Barat Laut' })
    kecamatanSet.push({ id: '53.14.04', kabupaten: '53.14', name: 'Rote Tengah' })
    kecamatanSet.push({ id: '53.14.06', kabupaten: '53.14', name: 'Rote Timur' })
    kecamatanSet.push({ id: '53.10.03', kabupaten: '53.10', name: 'Ruteng' })
    kecamatanSet.push({ id: '53.20.01', kabupaten: '53.20', name: 'Sabu Barat' })
    kecamatanSet.push({ id: '53.20.04', kabupaten: '53.20', name: 'Sabu Liae' })
    kecamatanSet.push({ id: '53.20.02', kabupaten: '53.20', name: 'Sabu Tengah' })
    kecamatanSet.push({ id: '53.20.03', kabupaten: '53.20', name: 'Sabu Timur' })
    kecamatanSet.push({ id: '53.19.04', kabupaten: '53.19', name: 'Sambi Rampas' })
    kecamatanSet.push({ id: '53.15.04', kabupaten: '53.15', name: 'Sano Nggoang' })
    kecamatanSet.push({ id: '53.02.25', kabupaten: '53.02', name: 'Santian' })
    kecamatanSet.push({ id: '53.21.07', kabupaten: '53.21', name: 'Sasitamean' })
    kecamatanSet.push({ id: '53.10.05', kabupaten: '53.10', name: 'Satar Mese' })
    kecamatanSet.push({ id: '53.10.13', kabupaten: '53.10', name: 'Satar Mese Barat' })
    kecamatanSet.push({ id: '53.10.18', kabupaten: '53.10', name: 'Satar Mese Utara' })
    kecamatanSet.push({ id: '53.01.04', kabupaten: '53.01', name: 'Semau' })
    kecamatanSet.push({ id: '53.01.23', kabupaten: '53.01', name: 'Semau Selatan' })
    kecamatanSet.push({ id: '53.09.07', kabupaten: '53.09', name: 'Soa' })
    kecamatanSet.push({ id: '53.06.06', kabupaten: '53.06', name: 'Solor Barat' })
    kecamatanSet.push({ id: '53.06.19', kabupaten: '53.06', name: 'Solor Selatan' })
    kecamatanSet.push({ id: '53.06.07', kabupaten: '53.06', name: 'Solor Timur' })
    kecamatanSet.push({ id: '53.01.07', kabupaten: '53.01', name: 'Sulamu' })
    kecamatanSet.push({ id: '53.11.05', kabupaten: '53.11', name: 'Tabundung' })
    kecamatanSet.push({ id: '53.01.24', kabupaten: '53.01', name: 'Taebenu' })
    kecamatanSet.push({ id: '53.01.11', kabupaten: '53.01', name: 'Takari' })
    kecamatanSet.push({ id: '53.07.08', kabupaten: '53.07', name: 'Talibura' })
    kecamatanSet.push({ id: '53.12.04', kabupaten: '53.12', name: 'Tana Righu' })
    kecamatanSet.push({ id: '53.07.17', kabupaten: '53.07', name: 'Tana Wawo' })
    kecamatanSet.push({ id: '53.06.05', kabupaten: '53.06', name: 'Tanjung Bunga' })
    kecamatanSet.push({ id: '53.04.04', kabupaten: '53.04', name: 'Tasifeto Barat' })
    kecamatanSet.push({ id: '53.04.02', kabupaten: '53.04', name: 'TasifetoTimur' })
    kecamatanSet.push({ id: '53.05.01', kabupaten: '53.05', name: 'Teluk Mutiara' })
    kecamatanSet.push({ id: '53.06.02', kabupaten: '53.06', name: 'Titehena' })
    kecamatanSet.push({ id: '53.02.31', kabupaten: '53.02', name: 'Tobu' })
    kecamatanSet.push({ id: '53.02.16', kabupaten: '53.02', name: 'Toianas' })
    kecamatanSet.push({ id: '53.11.08', kabupaten: '53.11', name: 'Umalulu' })
    kecamatanSet.push({ id: '53.17.04', kabupaten: '53.17', name: 'Umbu Ratu Nggay' })
    kecamatanSet.push({ id: '53.17.02', kabupaten: '53.17', name: 'Umbu Ratu Nggay Barat' })
    kecamatanSet.push({ id: '53.10.01', kabupaten: '53.10', name: 'Wae Rii' })
    kecamatanSet.push({ id: '53.07.13', kabupaten: '53.07', name: 'Waiblama' })
    kecamatanSet.push({ id: '53.07.09', kabupaten: '53.07', name: 'Waigete' })
    kecamatanSet.push({ id: '53.12.11', kabupaten: '53.12', name: 'Wanokaka' })
    kecamatanSet.push({ id: '53.15.07', kabupaten: '53.15', name: 'Welak' })
    kecamatanSet.push({ id: '53.21.04', kabupaten: '53.21', name: 'Weliman' })
    kecamatanSet.push({ id: '53.08.07', kabupaten: '53.08', name: 'Wewaria' })
    kecamatanSet.push({ id: '53.18.04', kabupaten: '53.18', name: 'Wewewa Barat' })
    kecamatanSet.push({ id: '53.18.05', kabupaten: '53.18', name: 'Wewewa Selatan' })
    kecamatanSet.push({ id: '53.18.10', kabupaten: '53.18', name: 'Wewewa Tengah' })
    kecamatanSet.push({ id: '53.18.03', kabupaten: '53.18', name: 'Wewewa Timur' })
    kecamatanSet.push({ id: '53.18.02', kabupaten: '53.18', name: 'Wewewa Utara' })
    kecamatanSet.push({ id: '53.21.03', kabupaten: '53.21', name: 'Wewiku' })
    kecamatanSet.push({ id: '53.06.12', kabupaten: '53.06', name: 'Witihama' })
    kecamatanSet.push({ id: '53.08.09', kabupaten: '53.08', name: 'Wolojita' })
    kecamatanSet.push({ id: '53.09.16', kabupaten: '53.09', name: 'Wolomeze' })
    kecamatanSet.push({ id: '53.16.05', kabupaten: '53.16', name: 'Wolowae' })
    kecamatanSet.push({ id: '53.08.08', kabupaten: '53.08', name: 'Wolowaru' })
    kecamatanSet.push({ id: '53.06.09', kabupaten: '53.06', name: 'Wotan Ulumando' })
    kecamatanSet.push({ id: '53.13.08', kabupaten: '53.13', name: 'Wulandoni' })
    kecamatanSet.push({ id: '53.06.01', kabupaten: '53.06', name: 'Wulanggitang' })
    kecamatanSet.push({ id: '53.11.11', kabupaten: '53.11', name: 'Wulla Waijelu' })
    */
    kecamatanSet.push({ id:'12.02.03', kabupaten:'12.02', name:'Adian Koting'})
kecamatanSet.push({ id:'12.03.22', kabupaten:'12.03', name:'Aek Bilah'})
kecamatanSet.push({ id:'12.09.18', kabupaten:'12.09', name:'Aek Kuasan'})
kecamatanSet.push({ id:'12.23.04', kabupaten:'12.23', name:'Aek Kuo'})
kecamatanSet.push({ id:'12.09.32', kabupaten:'12.09', name:'Aek Ledong'})
kecamatanSet.push({ id:'12.21.11', kabupaten:'12.21', name:'Aek Nabara Barumun'})
kecamatanSet.push({ id:'12.23.07', kabupaten:'12.23', name:'Aek Natas'})
kecamatanSet.push({ id:'12.09.21', kabupaten:'12.09', name:'Aek Songsongan'})
kecamatanSet.push({ id:'12.24.09', kabupaten:'12.24', name:'Afulu'})
kecamatanSet.push({ id:'12.09.13', kabupaten:'12.09', name:'Air Batu'})
kecamatanSet.push({ id:'12.09.09', kabupaten:'12.09', name:'Air Joman'})
kecamatanSet.push({ id:'12.19.03', kabupaten:'12.19', name:'Air Putih'})
kecamatanSet.push({ id:'12.12.08', kabupaten:'12.12', name:'Ajibata'})
kecamatanSet.push({ id:'12.24.07', kabupaten:'12.24', name:'Alasa'})
kecamatanSet.push({ id:'12.24.06', kabupaten:'12.24', name:'Alasa Talumuzoi'})
kecamatanSet.push({ id:'12.14.07', kabupaten:'12.14', name:'Amandraya'})
kecamatanSet.push({ id:'12.01.12', kabupaten:'12.01', name:'Andam Dewi'})
kecamatanSet.push({ id:'12.03.01', kabupaten:'12.03', name:'Angkola Barat'})
kecamatanSet.push({ id:'12.03.32', kabupaten:'12.03', name:'Angkola Muara Tais'})
kecamatanSet.push({ id:'12.03.31', kabupaten:'12.03', name:'Angkola Sangkunur'})
kecamatanSet.push({ id:'12.03.06', kabupaten:'12.03', name:'Angkola Selatan'})
kecamatanSet.push({ id:'12.03.03', kabupaten:'12.03', name:'Angkola Timur'})
kecamatanSet.push({ id:'12.14.15', kabupaten:'12.14', name:'Aramo'})
kecamatanSet.push({ id:'12.03.14', kabupaten:'12.03', name:'Arse'})
kecamatanSet.push({ id:'12.05.14', kabupaten:'12.05', name:'Babalan'})
kecamatanSet.push({ id:'12.01.15', kabupaten:'12.01', name:'Badiri'})
kecamatanSet.push({ id:'12.05.01', kabupaten:'12.05', name:'Bahorok'})
kecamatanSet.push({ id:'12.76.04', kabupaten:'12.76', name:'Bajenis'})
kecamatanSet.push({ id:'12.16.03', kabupaten:'12.16', name:'Baktiraja'})
kecamatanSet.push({ id:'12.12.01', kabupaten:'12.12', name:'Balige'})
kecamatanSet.push({ id:'12.08.23', kabupaten:'12.08', name:'Bandar'})
kecamatanSet.push({ id:'12.08.22', kabupaten:'12.08', name:'Bandar Huluan'})
kecamatanSet.push({ id:'12.18.06', kabupaten:'12.18', name:'Bandar Khalipah'})
kecamatanSet.push({ id:'12.08.24', kabupaten:'12.08', name:'Bandar Masilam'})
kecamatanSet.push({ id:'12.09.17', kabupaten:'12.09', name:'Bandar Pasir Mandoge'})
kecamatanSet.push({ id:'12.09.15', kabupaten:'12.09', name:'Bandar Pulau'})
kecamatanSet.push({ id:'12.07.09', kabupaten:'12.07', name:'Bangun Purba'})
kecamatanSet.push({ id:'12.21.07', kabupaten:'12.21', name:'Barumun'})
kecamatanSet.push({ id:'12.21.10', kabupaten:'12.21', name:'Barumun Selatan'})
kecamatanSet.push({ id:'12.21.02', kabupaten:'12.21', name:'Barumun Tengah'})
kecamatanSet.push({ id:'12.01.01', kabupaten:'12.01', name:'Barus'})
kecamatanSet.push({ id:'12.01.17', kabupaten:'12.01', name:'Barus Utara'})
kecamatanSet.push({ id:'12.06.03', kabupaten:'12.06', name:'Barusjahe'})
kecamatanSet.push({ id:'12.13.15', kabupaten:'12.13', name:'Batahan'})
kecamatanSet.push({ id:'12.03.07', kabupaten:'12.03', name:'Batang Angkola'})
kecamatanSet.push({ id:'12.07.27', kabupaten:'12.07', name:'Batang Kuis'})
kecamatanSet.push({ id:'12.21.09', kabupaten:'12.21', name:'Batang Lubu Sutam'})
kecamatanSet.push({ id:'12.13.13', kabupaten:'12.13', name:'Batang Natal'})
kecamatanSet.push({ id:'12.20.07', kabupaten:'12.20', name:'Batang Onang'})
kecamatanSet.push({ id:'12.05.19', kabupaten:'12.05', name:'Batang Serangan'})
kecamatanSet.push({ id:'12.03.02', kabupaten:'12.03', name:'Batang Toru'})
kecamatanSet.push({ id:'12.04.11', kabupaten:'12.04', name:'Bawolato'})
kecamatanSet.push({ id:'12.11.13', kabupaten:'12.11', name:'Berampu'})
kecamatanSet.push({ id:'12.05.18', kabupaten:'12.05', name:'Berandan Barat'})
kecamatanSet.push({ id:'12.06.02', kabupaten:'12.06', name:'Berastagi'})
kecamatanSet.push({ id:'12.07.33', kabupaten:'12.07', name:'Beringin'})
kecamatanSet.push({ id:'12.05.16', kabupaten:'12.05', name:'Besitang'})
kecamatanSet.push({ id:'12.10.07', kabupaten:'12.10', name:'Bilah Barat'})
kecamatanSet.push({ id:'12.10.08', kabupaten:'12.10', name:'Bilah Hilir'})
kecamatanSet.push({ id:'12.10.09', kabupaten:'12.10', name:'Bilah Hulu'})
kecamatanSet.push({ id:'12.05.05', kabupaten:'12.05', name:'Binjai'})
kecamatanSet.push({ id:'12.75.03', kabupaten:'12.75', name:'Binjai Barat'})
kecamatanSet.push({ id:'12.75.02', kabupaten:'12.75', name:'Binjai Kota'})
kecamatanSet.push({ id:'12.75.05', kabupaten:'12.75', name:'Binjai Selatan'})
kecamatanSet.push({ id:'12.75.04', kabupaten:'12.75', name:'Binjai Timur'})
kecamatanSet.push({ id:'12.75.01', kabupaten:'12.75', name:'Binjai Utara'})
kecamatanSet.push({ id:'12.18.17', kabupaten:'12.18', name:'Bintang Bayu'})
kecamatanSet.push({ id:'12.12.23', kabupaten:'12.12', name:'Bonatua Lunasi'})
kecamatanSet.push({ id:'12.12.06', kabupaten:'12.12', name:'Borbor'})
kecamatanSet.push({ id:'12.14.27', kabupaten:'12.14', name:'Boronadu'})
kecamatanSet.push({ id:'12.08.08', kabupaten:'12.08', name:'Bosar Maligas'})
kecamatanSet.push({ id:'12.04.21', kabupaten:'12.04', name:'Botomuzoi'})
kecamatanSet.push({ id:'12.13.07', kabupaten:'12.13', name:'Bukit Malintang'})
kecamatanSet.push({ id:'12.09.16', kabupaten:'12.09', name:'Buntu Pane'})
kecamatanSet.push({ id:'12.74.05', kabupaten:'12.74', name:'Datuk Bandar'})
kecamatanSet.push({ id:'12.74.06', kabupaten:'12.74', name:'Datuk Bandar Timur'})
kecamatanSet.push({ id:'12.19.10', kabupaten:'12.19', name:'Datuk Lima Puluh'})
kecamatanSet.push({ id:'12.19.11', kabupaten:'12.19', name:'Datuk Tanah Datar'})
kecamatanSet.push({ id:'12.07.22', kabupaten:'12.07', name:'Deli Tua'})
kecamatanSet.push({ id:'12.06.14', kabupaten:'12.06', name:'Dolat Rayat'})
kecamatanSet.push({ id:'12.08.32', kabupaten:'12.08', name:'Dolog Masagal'})
kecamatanSet.push({ id:'12.20.02', kabupaten:'12.20', name:'Dolok'})
kecamatanSet.push({ id:'12.08.17', kabupaten:'12.08', name:'Dolok Batu Nanggar'})
kecamatanSet.push({ id:'12.18.09', kabupaten:'12.18', name:'Dolok Masihul'})
kecamatanSet.push({ id:'12.18.07', kabupaten:'12.18', name:'Dolok Merawan'})
kecamatanSet.push({ id:'12.08.13', kabupaten:'12.08', name:'Dolok Panribuan'})
kecamatanSet.push({ id:'12.08.20', kabupaten:'12.08', name:'Dolok Pardamean'})
kecamatanSet.push({ id:'12.16.06', kabupaten:'12.16', name:'Dolok Sanggul'})
kecamatanSet.push({ id:'12.20.01', kabupaten:'12.20', name:'Dolok Sigompulon'})
kecamatanSet.push({ id:'12.08.26', kabupaten:'12.08', name:'Dolok Silau'})
kecamatanSet.push({ id:'12.14.18', kabupaten:'12.14', name:'Fanayama'})
kecamatanSet.push({ id:'12.07.19', kabupaten:'12.07', name:'Galang'})
kecamatanSet.push({ id:'12.02.14', kabupaten:'12.02', name:'Garoga'})
kecamatanSet.push({ id:'12.05.13', kabupaten:'12.05', name:'Gebang'})
kecamatanSet.push({ id:'12.04.06', kabupaten:'12.04', name:'Gido'})
kecamatanSet.push({ id:'12.08.16', kabupaten:'12.08', name:'Girsang Sipangan Bolon'})
kecamatanSet.push({ id:'12.14.02', kabupaten:'12.14', name:'Gomo'})
kecamatanSet.push({ id:'12.08.02', kabupaten:'12.08', name:'Gunung Malela'})
kecamatanSet.push({ id:'12.08.03', kabupaten:'12.08', name:'Gunung Maligas'})
kecamatanSet.push({ id:'12.07.01', kabupaten:'12.07', name:'Gunung Meriah'})
kecamatanSet.push({ id:'12.11.12', kabupaten:'12.11', name:'Gunung Sitember'})
kecamatanSet.push({ id:'12.78.01', kabupaten:'12.78', name:'Gunungsitoli'})
kecamatanSet.push({ id:'12.78.05', kabupaten:'12.78', name:'Gunungsitoli Alo Oa'})
kecamatanSet.push({ id:'12.78.06', kabupaten:'12.78', name:'Gunungsitoli Barat'})
kecamatanSet.push({ id:'12.78.04', kabupaten:'12.78', name:'Gunungsitoli Idanoi'})
kecamatanSet.push({ id:'12.78.02', kabupaten:'12.78', name:'Gunungsitoli Selatan'})
kecamatanSet.push({ id:'12.78.03', kabupaten:'12.78', name:'Gunungsitoli Utara'})
kecamatanSet.push({ id:'12.12.04', kabupaten:'12.12', name:'Habinsaran'})
kecamatanSet.push({ id:'12.20.03', kabupaten:'12.20', name:'Halongonan'})
kecamatanSet.push({ id:'12.20.11', kabupaten:'12.20', name:'Halongonan Timur'})
kecamatanSet.push({ id:'12.07.24', kabupaten:'12.07', name:'Hamparan Perak'})
kecamatanSet.push({ id:'12.08.15', kabupaten:'12.08', name:'Haranggaol Horison'})
kecamatanSet.push({ id:'12.17.05', kabupaten:'12.17', name:'Harian'})
kecamatanSet.push({ id:'12.08.12', kabupaten:'12.08', name:'Hatonduhan'})
kecamatanSet.push({ id:'12.14.04', kabupaten:'12.14', name:'Hibala'})
kecamatanSet.push({ id:'12.04.05', kabupaten:'12.04', name:'Hiliduho'})
kecamatanSet.push({ id:'12.14.11', kabupaten:'12.14', name:'Hilimegai'})
kecamatanSet.push({ id:'12.14.23', kabupaten:'12.14', name:'Hilisalawa Ahe'})
kecamatanSet.push({ id:'12.04.20', kabupaten:'12.04', name:'Hiliserangkai'})
kecamatanSet.push({ id:'12.05.10', kabupaten:'12.05', name:'Hinai'})
kecamatanSet.push({ id:'12.20.09', kabupaten:'12.20', name:'Hulu Sihapas'})
kecamatanSet.push({ id:'12.21.03', kabupaten:'12.21', name:'Huristak'})
kecamatanSet.push({ id:'12.14.20', kabupaten:'12.14', name:'Huruna'})
kecamatanSet.push({ id:'12.13.19', kabupaten:'12.13', name:'Huta Bargot'})
kecamatanSet.push({ id:'12.08.18', kabupaten:'12.08', name:'Huta Bayu Raja'})
kecamatanSet.push({ id:'12.21.05', kabupaten:'12.21', name:'Huta Raja Tinggi'})
kecamatanSet.push({ id:'12.04.10', kabupaten:'12.04', name:'Idanogawo'})
kecamatanSet.push({ id:'12.14.35', kabupaten:'12.14', name:'Idanotae'})
kecamatanSet.push({ id:'12.08.19', kabupaten:'12.08', name:'Jawa Maraja Bah Jambi'})
kecamatanSet.push({ id:'12.08.06', kabupaten:'12.08', name:'Jorlang Hataran'})
kecamatanSet.push({ id:'12.06.07', kabupaten:'12.06', name:'Juhar'})
kecamatanSet.push({ id:'12.06.01', kabupaten:'12.06', name:'Kabanjahe'})
kecamatanSet.push({ id:'12.22.02', kabupaten:'12.22', name:'Kampung Rakyat'})
kecamatanSet.push({ id:'12.15.02', kabupaten:'12.15', name:'Kerajaan'})
kecamatanSet.push({ id:'12.01.06', kabupaten:'12.01', name:'Kolang'})
kecamatanSet.push({ id:'12.09.19', kabupaten:'12.09', name:'Kota Kisaran Barat'})
kecamatanSet.push({ id:'12.09.20', kabupaten:'12.09', name:'Kota Kisaran Timur'})
kecamatanSet.push({ id:'12.13.08', kabupaten:'12.13', name:'Kotanopan'})
kecamatanSet.push({ id:'12.22.01', kabupaten:'12.22', name:'Kotapinang'})
kecamatanSet.push({ id:'12.18.10', kabupaten:'12.18', name:'Kotarih'})
kecamatanSet.push({ id:'12.05.03', kabupaten:'12.05', name:'Kuala'})
kecamatanSet.push({ id:'12.23.03', kabupaten:'12.23', name:'Kualuh Hilir'})
kecamatanSet.push({ id:'12.23.01', kabupaten:'12.23', name:'Kualuh Hulu'})
kecamatanSet.push({ id:'12.23.02', kabupaten:'12.23', name:'Kualuh Leidong'})
kecamatanSet.push({ id:'12.23.08', kabupaten:'12.23', name:'Kualuh Selatan'})
kecamatanSet.push({ id:'12.06.13', kabupaten:'12.06', name:'Kutabuluh'})
kecamatanSet.push({ id:'12.07.04', kabupaten:'12.07', name:'Kutalimbaru'})
kecamatanSet.push({ id:'12.05.22', kabupaten:'12.05', name:'Kutambaru'})
kecamatanSet.push({ id:'12.07.25', kabupaten:'12.07', name:'Labuhan Deli'})
kecamatanSet.push({ id:'12.11.11', kabupaten:'12.11', name:'Lae Parira'})
kecamatanSet.push({ id:'12.12.02', kabupaten:'12.12', name:'Laguboti'})
kecamatanSet.push({ id:'12.24.10', kabupaten:'12.24', name:'Lahewa'})
kecamatanSet.push({ id:'12.24.11', kabupaten:'12.24', name:'Lahewa Timur'})
kecamatanSet.push({ id:'12.25.01', kabupaten:'12.25', name:'Lahomi'})
kecamatanSet.push({ id:'12.14.03', kabupaten:'12.14', name:'Lahusa'})
kecamatanSet.push({ id:'12.06.09', kabupaten:'12.06', name:'Laubaleng'})
kecamatanSet.push({ id:'12.19.08', kabupaten:'12.19', name:'Laut Tador'})
kecamatanSet.push({ id:'12.13.09', kabupaten:'12.13', name:'Lembah Sorik Marapi'})
kecamatanSet.push({ id:'12.19.04', kabupaten:'12.19', name:'Lima Puluh'})
kecamatanSet.push({ id:'12.19.09', kabupaten:'12.19', name:'Lima Puluh Pesisir'})
kecamatanSet.push({ id:'12.13.14', kabupaten:'12.13', name:'Lingga Bayu'})
kecamatanSet.push({ id:'12.16.05', kabupaten:'12.16', name:'Lintong Nihuta'})
kecamatanSet.push({ id:'12.25.07', kabupaten:'12.25', name:'Lolofitu Moi'})
kecamatanSet.push({ id:'12.14.01', kabupaten:'12.14', name:'Lolomatua'})
kecamatanSet.push({ id:'12.14.08', kabupaten:'12.14', name:'Lolowau'})
kecamatanSet.push({ id:'12.24.01', kabupaten:'12.24', name:'Lotu'})
kecamatanSet.push({ id:'12.14.32', kabupaten:'12.14', name:'Luahagundre Maniamolo'})
kecamatanSet.push({ id:'12.21.04', kabupaten:'12.21', name:'Lubuk Barumun'})
kecamatanSet.push({ id:'12.07.28', kabupaten:'12.07', name:'Lubuk Pakam'})
kecamatanSet.push({ id:'12.12.09', kabupaten:'12.12', name:'Lumban Julu'})
kecamatanSet.push({ id:'12.01.19', kabupaten:'12.01', name:'Lumut'})
kecamatanSet.push({ id:'12.04.28', kabupaten:'12.04', name:'Ma U'})
kecamatanSet.push({ id:'12.25.05', kabupaten:'12.25', name:'Mandrehe'})
kecamatanSet.push({ id:'12.25.03', kabupaten:'12.25', name:'Mandrehe Barat'})
kecamatanSet.push({ id:'12.25.06', kabupaten:'12.25', name:'Mandrehe Utara'})
kecamatanSet.push({ id:'12.01.05', kabupaten:'12.01', name:'Manduamas'})
kecamatanSet.push({ id:'12.14.10', kabupaten:'12.14', name:'Maniamolo'})
kecamatanSet.push({ id:'12.03.20', kabupaten:'12.03', name:'Marancar'})
kecamatanSet.push({ id:'12.23.05', kabupaten:'12.23', name:'Marbau'})
kecamatanSet.push({ id:'12.06.10', kabupaten:'12.06', name:'Mardingding'})
kecamatanSet.push({ id:'12.14.13', kabupaten:'12.14', name:'Mazino'})
kecamatanSet.push({ id:'12.14.17', kabupaten:'12.14', name:'Mazo'})
kecamatanSet.push({ id:'12.71.09', kabupaten:'12.71', name:'Medan Amplas'})
kecamatanSet.push({ id:'12.71.10', kabupaten:'12.71', name:'Medan Area'})
kecamatanSet.push({ id:'12.71.05', kabupaten:'12.71', name:'Medan Barat'})
kecamatanSet.push({ id:'12.71.17', kabupaten:'12.71', name:'Medan Baru'})
kecamatanSet.push({ id:'12.71.08', kabupaten:'12.71', name:'Medan Belawan'})
kecamatanSet.push({ id:'12.71.06', kabupaten:'12.71', name:'Medan Deli'})
kecamatanSet.push({ id:'12.71.04', kabupaten:'12.71', name:'Medan Denai'})
kecamatanSet.push({ id:'12.71.03', kabupaten:'12.71', name:'Medan Helvetia'})
kecamatanSet.push({ id:'12.71.11', kabupaten:'12.71', name:'Medan Johor'})
kecamatanSet.push({ id:'12.71.01', kabupaten:'12.71', name:'Medan Kota'})
kecamatanSet.push({ id:'12.71.13', kabupaten:'12.71', name:'Medan Labuhan'})
kecamatanSet.push({ id:'12.71.15', kabupaten:'12.71', name:'Medan Maimun'})
kecamatanSet.push({ id:'12.71.12', kabupaten:'12.71', name:'Medan Marelan'})
kecamatanSet.push({ id:'12.71.18', kabupaten:'12.71', name:'Medan Perjuangan'})
kecamatanSet.push({ id:'12.71.19', kabupaten:'12.71', name:'Medan Petisah'})
kecamatanSet.push({ id:'12.71.16', kabupaten:'12.71', name:'Medan Polonia'})
kecamatanSet.push({ id:'12.71.21', kabupaten:'12.71', name:'Medan Selayang'})
kecamatanSet.push({ id:'12.71.02', kabupaten:'12.71', name:'Medan Sunggal'})
kecamatanSet.push({ id:'12.71.14', kabupaten:'12.71', name:'Medan Tembung'})
kecamatanSet.push({ id:'12.71.20', kabupaten:'12.71', name:'Medan Timur'})
kecamatanSet.push({ id:'12.71.07', kabupaten:'12.71', name:'Medan Tuntungan'})
kecamatanSet.push({ id:'12.19.01', kabupaten:'12.19', name:'Medang Deras'})
kecamatanSet.push({ id:'12.09.08', kabupaten:'12.09', name:'Meranti'})
kecamatanSet.push({ id:'12.06.15', kabupaten:'12.06', name:'Merdeka'})
kecamatanSet.push({ id:'12.06.05', kabupaten:'12.06', name:'Merek'})
kecamatanSet.push({ id:'12.25.04', kabupaten:'12.25', name:'Moro O'})
kecamatanSet.push({ id:'12.02.15', kabupaten:'12.02', name:'Muara'})
kecamatanSet.push({ id:'12.13.17', kabupaten:'12.13', name:'Muara Batang Gadis'})
kecamatanSet.push({ id:'12.03.29', kabupaten:'12.03', name:'Muara Batang Toru'})
kecamatanSet.push({ id:'12.13.12', kabupaten:'12.13', name:'Muara Sipongi'})
kecamatanSet.push({ id:'12.06.06', kabupaten:'12.06', name:'Munte'})
kecamatanSet.push({ id:'12.23.06', kabupaten:'12.23', name:'Na IX-X'})
kecamatanSet.push({ id:'12.13.23', kabupaten:'12.13', name:'Naga Juang'})
kecamatanSet.push({ id:'12.17.03', kabupaten:'12.17', name:'Nainggolan'})
kecamatanSet.push({ id:'12.06.16', kabupaten:'12.06', name:'Naman Teran'})
kecamatanSet.push({ id:'12.24.05', kabupaten:'12.24', name:'Namohalu Esiwa'})
kecamatanSet.push({ id:'12.07.06', kabupaten:'12.07', name:'Namorambe'})
kecamatanSet.push({ id:'12.12.21', kabupaten:'12.12', name:'Nassau'})
kecamatanSet.push({ id:'12.13.16', kabupaten:'12.13', name:'Natal'})
kecamatanSet.push({ id:'12.19.12', kabupaten:'12.19', name:'Nibung Hangus'})
kecamatanSet.push({ id:'12.14.21', kabupaten:'12.14', name:'O O U'})
kecamatanSet.push({ id:'12.16.08', kabupaten:'12.16', name:'Onan Ganjang'})
kecamatanSet.push({ id:'12.17.02', kabupaten:'12.17', name:'Onan Runggu'})
kecamatanSet.push({ id:'12.14.22', kabupaten:'12.14', name:'Onohazumba'})
kecamatanSet.push({ id:'12.14.33', kabupaten:'12.14', name:'Onolalu'})
kecamatanSet.push({ id:'12.20.04', kabupaten:'12.20', name:'Padang Bolak'})
kecamatanSet.push({ id:'12.20.05', kabupaten:'12.20', name:'Padang Bolak Julu'})
kecamatanSet.push({ id:'12.20.10', kabupaten:'12.20', name:'Padang Bolak Tenggara'})
kecamatanSet.push({ id:'12.76.03', kabupaten:'12.76', name:'Padang Hilir'})
kecamatanSet.push({ id:'12.76.01', kabupaten:'12.76', name:'Padang Hulu'})
kecamatanSet.push({ id:'12.05.12', kabupaten:'12.05', name:'Padang Tualang'})
kecamatanSet.push({ id:'12.77.06', kabupaten:'12.77', name:'Padangsidimpuan Angkola Julu'})
kecamatanSet.push({ id:'12.77.03', kabupaten:'12.77', name:'Padangsidimpuan Batunadua'})
kecamatanSet.push({ id:'12.77.04', kabupaten:'12.77', name:'Padangsidimpuan Hutaimbaru'})
kecamatanSet.push({ id:'12.77.02', kabupaten:'12.77', name:'Padangsidimpuan Selatan'})
kecamatanSet.push({ id:'12.77.05', kabupaten:'12.77', name:'Padangsidimpuan Tenggara'})
kecamatanSet.push({ id:'12.77.01', kabupaten:'12.77', name:'Padangsidimpuan Utara'})
kecamatanSet.push({ id:'12.07.31', kabupaten:'12.07', name:'Pagar Merbau'})
kecamatanSet.push({ id:'12.02.10', kabupaten:'12.02', name:'Pagaran'})
kecamatanSet.push({ id:'12.15.06', kabupaten:'12.15', name:'Pagindar'})
kecamatanSet.push({ id:'12.02.06', kabupaten:'12.02', name:'Pahae Jae'})
kecamatanSet.push({ id:'12.02.05', kabupaten:'12.02', name:'Pahae Julu'})
kecamatanSet.push({ id:'12.13.21', kabupaten:'12.13', name:'Pakantan'})
kecamatanSet.push({ id:'12.16.09', kabupaten:'12.16', name:'Pakkat'})
kecamatanSet.push({ id:'12.17.04', kabupaten:'12.17', name:'Palipi'})
kecamatanSet.push({ id:'12.08.31', kabupaten:'12.08', name:'Pamatang Silima Huta'})
kecamatanSet.push({ id:'12.10.19', kabupaten:'12.10', name:'Panai Hilir'})
kecamatanSet.push({ id:'12.10.20', kabupaten:'12.10', name:'Panai Hulu'})
kecamatanSet.push({ id:'12.10.18', kabupaten:'12.10', name:'Panai Tengah'})
kecamatanSet.push({ id:'12.07.05', kabupaten:'12.07', name:'Pancur Batu'})
kecamatanSet.push({ id:'12.01.03', kabupaten:'12.01', name:'Pandan'})
kecamatanSet.push({ id:'12.08.04', kabupaten:'12.08', name:'Panei'})
kecamatanSet.push({ id:'12.02.13', kabupaten:'12.02', name:'Pangaribuan'})
kecamatanSet.push({ id:'12.05.15', kabupaten:'12.05', name:'Pangkalan Susu'})
kecamatanSet.push({ id:'12.10.14', kabupaten:'12.10', name:'Pangkatan'})
kecamatanSet.push({ id:'12.17.08', kabupaten:'12.17', name:'Pangururan'})
kecamatanSet.push({ id:'12.08.05', kabupaten:'12.08', name:'Panombeian Pane'})
kecamatanSet.push({ id:'12.18.01', kabupaten:'12.18', name:'Pantai Cermin'})
kecamatanSet.push({ id:'12.07.32', kabupaten:'12.07', name:'Pantai Labu'})
kecamatanSet.push({ id:'12.13.01', kabupaten:'12.13', name:'Panyabungan'})
kecamatanSet.push({ id:'12.13.05', kabupaten:'12.13', name:'Panyabungan Barat'})
kecamatanSet.push({ id:'12.13.04', kabupaten:'12.13', name:'Panyabungan Selatan'})
kecamatanSet.push({ id:'12.13.03', kabupaten:'12.13', name:'Panyabungan Timur'})
kecamatanSet.push({ id:'12.13.02', kabupaten:'12.13', name:'Panyabungan Utara'})
kecamatanSet.push({ id:'12.16.04', kabupaten:'12.16', name:'Paranginan'})
kecamatanSet.push({ id:'12.11.10', kabupaten:'12.11', name:'Parbuluan'})
kecamatanSet.push({ id:'12.16.01', kabupaten:'12.16', name:'Parlilitan'})
kecamatanSet.push({ id:'12.12.24', kabupaten:'12.12', name:'Parmaksian'})
kecamatanSet.push({ id:'12.02.11', kabupaten:'12.02', name:'Parmonangan'})
kecamatanSet.push({ id:'12.01.16', kabupaten:'12.01', name:'Pasaribu Tobing'})
kecamatanSet.push({ id:'12.07.21', kabupaten:'12.07', name:'Patumbak'})
kecamatanSet.push({ id:'12.06.11', kabupaten:'12.06', name:'Payung'})
kecamatanSet.push({ id:'12.11.09', kabupaten:'12.11', name:'Pegagan Hilir'})
kecamatanSet.push({ id:'12.18.14', kabupaten:'12.18', name:'Pegajahan'})
kecamatanSet.push({ id:'12.08.21', kabupaten:'12.08', name:'Pematang Bandar'})
kecamatanSet.push({ id:'12.05.23', kabupaten:'12.05', name:'Pematang Jaya'})
kecamatanSet.push({ id:'12.08.10', kabupaten:'12.08', name:'Pematang Sidamanik'})
kecamatanSet.push({ id:'12.18.02', kabupaten:'12.18', name:'Perbaungan'})
kecamatanSet.push({ id:'12.07.26', kabupaten:'12.07', name:'Percut Sei Tuan'})
kecamatanSet.push({ id:'12.15.05', kabupaten:'12.15', name:'Pergetteng Getteng Sengkut'})
kecamatanSet.push({ id:'12.01.04', kabupaten:'12.01', name:'Pinangsori'})
kecamatanSet.push({ id:'12.12.05', kabupaten:'12.12', name:'Pintu Pohan Meranti'})
kecamatanSet.push({ id:'12.16.02', kabupaten:'12.16', name:'Pollung'})
kecamatanSet.push({ id:'12.12.07', kabupaten:'12.12', name:'Porsea'})
kecamatanSet.push({ id:'12.20.06', kabupaten:'12.20', name:'Portibi'})
kecamatanSet.push({ id:'12.09.14', kabupaten:'12.09', name:'Pulau Rakyat'})
kecamatanSet.push({ id:'12.14.05', kabupaten:'12.14', name:'Pulau-Pulau Batu'})
kecamatanSet.push({ id:'12.14.29', kabupaten:'12.14', name:'Pulau-Pulau Batu Barat'})
kecamatanSet.push({ id:'12.14.16', kabupaten:'12.14', name:'Pulau-Pulau Batu Timur'})
kecamatanSet.push({ id:'12.14.30', kabupaten:'12.14', name:'Pulau-Pulau Batu Utara'})
kecamatanSet.push({ id:'12.09.30', kabupaten:'12.09', name:'Pulo Bandring'})
kecamatanSet.push({ id:'12.13.20', kabupaten:'12.13', name:'Puncak Sorik Marapi'})
kecamatanSet.push({ id:'12.08.14', kabupaten:'12.08', name:'Purba'})
kecamatanSet.push({ id:'12.02.08', kabupaten:'12.02', name:'Purba Tua'})
kecamatanSet.push({ id:'12.09.22', kabupaten:'12.09', name:'Rahunig'})
kecamatanSet.push({ id:'12.76.02', kabupaten:'12.76', name:'Rambutan'})
kecamatanSet.push({ id:'12.10.02', kabupaten:'12.10', name:'Rantau Selatan'})
kecamatanSet.push({ id:'12.10.01', kabupaten:'12.10', name:'Rantau Utara'})
kecamatanSet.push({ id:'12.13.18', kabupaten:'12.13', name:'Ranto Baek'})
kecamatanSet.push({ id:'12.09.29', kabupaten:'12.09', name:'Rawang Panca Arga'})
kecamatanSet.push({ id:'12.08.29', kabupaten:'12.08', name:'Raya'})
kecamatanSet.push({ id:'12.08.07', kabupaten:'12.08', name:'Raya Kahean'})
kecamatanSet.push({ id:'12.17.07', kabupaten:'12.17', name:'Ronggur Nihuta'})
kecamatanSet.push({ id:'12.03.05', kabupaten:'12.03', name:'Saipar Dolok Hole'})
kecamatanSet.push({ id:'12.15.03', kabupaten:'12.15', name:'Salak'})
kecamatanSet.push({ id:'12.05.02', kabupaten:'12.05', name:'Salapian'})
kecamatanSet.push({ id:'12.01.20', kabupaten:'12.01', name:'Sarudik'})
kecamatanSet.push({ id:'12.05.20', kabupaten:'12.05', name:'Sawit Seberang'})
kecamatanSet.push({ id:'12.24.02', kabupaten:'12.24', name:'Sawo'})
kecamatanSet.push({ id:'12.03.21', kabupaten:'12.03', name:'Sayur Matinggi'})
kecamatanSet.push({ id:'12.05.09', kabupaten:'12.05', name:'Secanggang'})
kecamatanSet.push({ id:'12.19.07', kabupaten:'12.19', name:'Sei Balai'})
kecamatanSet.push({ id:'12.18.15', kabupaten:'12.18', name:'Sei Bamban'})
kecamatanSet.push({ id:'12.05.04', kabupaten:'12.05', name:'Sei Bingai'})
kecamatanSet.push({ id:'12.09.23', kabupaten:'12.09', name:'Sei Dadap'})
kecamatanSet.push({ id:'12.09.11', kabupaten:'12.09', name:'Sei Kepayang'})
kecamatanSet.push({ id:'12.09.24', kabupaten:'12.09', name:'Sei Kepayang Barat'})
kecamatanSet.push({ id:'12.09.25', kabupaten:'12.09', name:'Sei Kepayang Timur'})
kecamatanSet.push({ id:'12.05.17', kabupaten:'12.05', name:'Sei Lepan'})
kecamatanSet.push({ id:'12.18.04', kabupaten:'12.18', name:'Sei Rampah'})
kecamatanSet.push({ id:'12.19.02', kabupaten:'12.19', name:'Sei Suka'})
kecamatanSet.push({ id:'12.74.03', kabupaten:'12.74', name:'Sei Tualang Raso'})
kecamatanSet.push({ id:'12.05.06', kabupaten:'12.05', name:'Selesai'})
kecamatanSet.push({ id:'12.18.12', kabupaten:'12.18', name:'Serba Jadi'})
kecamatanSet.push({ id:'12.09.27', kabupaten:'12.09', name:'Setia Janji'})
kecamatanSet.push({ id:'12.13.06', kabupaten:'12.13', name:'Siabu'})
kecamatanSet.push({ id:'12.17.06', kabupaten:'12.17', name:'Sianjar Mula Mula'})
kecamatanSet.push({ id:'12.08.01', kabupaten:'12.08', name:'Siantar'})
kecamatanSet.push({ id:'12.72.02', kabupaten:'12.72', name:'Siantar Barat'})
kecamatanSet.push({ id:'12.72.05', kabupaten:'12.72', name:'Siantar Marihat'})
kecamatanSet.push({ id:'12.72.08', kabupaten:'12.72', name:'Siantar Marimbun'})
kecamatanSet.push({ id:'12.72.06', kabupaten:'12.72', name:'Siantar Martoba'})
kecamatanSet.push({ id:'12.12.20', kabupaten:'12.12', name:'Siantar Narumonda'})
kecamatanSet.push({ id:'12.72.04', kabupaten:'12.72', name:'Siantar Selatan'})
kecamatanSet.push({ id:'12.72.07', kabupaten:'12.72', name:'Siantar Sitalasari'})
kecamatanSet.push({ id:'12.72.01', kabupaten:'12.72', name:'Siantar Timur'})
kecamatanSet.push({ id:'12.72.03', kabupaten:'12.72', name:'Siantar Utara'})
kecamatanSet.push({ id:'12.02.02', kabupaten:'12.02', name:'Siatas Barita'})
kecamatanSet.push({ id:'12.01.08', kabupaten:'12.01', name:'Sibabangun'})
kecamatanSet.push({ id:'12.07.07', kabupaten:'12.07', name:'Sibiru-Biru'})
kecamatanSet.push({ id:'12.07.03', kabupaten:'12.07', name:'Sibolangit'})
kecamatanSet.push({ id:'12.73.02', kabupaten:'12.73', name:'Sibolga Kota'})
kecamatanSet.push({ id:'12.73.04', kabupaten:'12.73', name:'Sibolga Sambas'})
kecamatanSet.push({ id:'12.73.03', kabupaten:'12.73', name:'Sibolga Selatan'})
kecamatanSet.push({ id:'12.73.01', kabupaten:'12.73', name:'Sibolga Utara'})
kecamatanSet.push({ id:'12.02.09', kabupaten:'12.02', name:'Siborong-Borong'})
kecamatanSet.push({ id:'12.08.09', kabupaten:'12.08', name:'Sidamanik'})
kecamatanSet.push({ id:'12.11.01', kabupaten:'12.11', name:'Sidikalang'})
kecamatanSet.push({ id:'12.14.25', kabupaten:'12.14', name:'Sidua Ori'})
kecamatanSet.push({ id:'12.11.04', kabupaten:'12.11', name:'Siempat Nempu'})
kecamatanSet.push({ id:'12.11.08', kabupaten:'12.11', name:'Siempat Nempu Hilir'})
kecamatanSet.push({ id:'12.11.07', kabupaten:'12.11', name:'Siempat Nempu Hulu'})
kecamatanSet.push({ id:'12.15.08', kabupaten:'12.15', name:'Siempat Rube'})
kecamatanSet.push({ id:'12.12.19', kabupaten:'12.12', name:'Sigumpar'})
kecamatanSet.push({ id:'12.21.12', kabupaten:'12.21', name:'Sihapas Barumun'})
kecamatanSet.push({ id:'12.16.07', kabupaten:'12.16', name:'Sijamapolang'})
kecamatanSet.push({ id:'12.12.03', kabupaten:'12.12', name:'Silaen'})
kecamatanSet.push({ id:'12.11.14', kabupaten:'12.11', name:'Silahisabungan'})
kecamatanSet.push({ id:'12.22.05', kabupaten:'12.22', name:'Silangkitang'})
kecamatanSet.push({ id:'12.09.28', kabupaten:'12.09', name:'Silau Laut'})
kecamatanSet.push({ id:'12.11.05', kabupaten:'12.11', name:'Silima Pungga Pungga'})
kecamatanSet.push({ id:'12.08.25', kabupaten:'12.08', name:'Silimakuta'})
kecamatanSet.push({ id:'12.18.11', kabupaten:'12.18', name:'Silinda'})
kecamatanSet.push({ id:'12.08.27', kabupaten:'12.08', name:'Silou Kahean'})
kecamatanSet.push({ id:'12.20.08', kabupaten:'12.20', name:'Simangambat'})
kecamatanSet.push({ id:'12.02.07', kabupaten:'12.02', name:'Simangumban'})
kecamatanSet.push({ id:'12.17.01', kabupaten:'12.17', name:'Simanindo'})
kecamatanSet.push({ id:'12.06.12', kabupaten:'12.06', name:'Simpang Empat'})
kecamatanSet.push({ id:'12.09.12', kabupaten:'12.09', name:'Simpang Empat'})
kecamatanSet.push({ id:'12.14.28', kabupaten:'12.14', name:'Simuk'})
kecamatanSet.push({ id:'12.13.22', kabupaten:'12.13', name:'Sinunukan'})
kecamatanSet.push({ id:'12.02.12', kabupaten:'12.02', name:'Sipahutar'})
kecamatanSet.push({ id:'12.03.04', kabupaten:'12.03', name:'Sipirok'})
kecamatanSet.push({ id:'12.18.08', kabupaten:'12.18', name:'Sipispis'})
kecamatanSet.push({ id:'12.02.04', kabupaten:'12.02', name:'Sipoholon'})
kecamatanSet.push({ id:'12.01.11', kabupaten:'12.01', name:'Sirandorung'})
kecamatanSet.push({ id:'12.05.21', kabupaten:'12.05', name:'Sirapit'})
kecamatanSet.push({ id:'12.25.02', kabupaten:'12.25', name:'Sirombu'})
kecamatanSet.push({ id:'12.01.13', kabupaten:'12.01', name:'Sitahuis'})
kecamatanSet.push({ id:'12.15.01', kabupaten:'12.15', name:'Sitelu Tali Urang Jehe'})
kecamatanSet.push({ id:'12.15.04', kabupaten:'12.15', name:'Sitelu Tali Urang Julu'})
kecamatanSet.push({ id:'12.11.15', kabupaten:'12.11', name:'Sitinjo'})
kecamatanSet.push({ id:'12.17.09', kabupaten:'12.17', name:'Sitio-Tio'})
kecamatanSet.push({ id:'12.24.04', kabupaten:'12.24', name:'Sitolu Ori'})
kecamatanSet.push({ id:'12.04.35', kabupaten:'12.04', name:'Sogae Adu'})
kecamatanSet.push({ id:'12.14.26', kabupaten:'12.14', name:'Somambawa'})
kecamatanSet.push({ id:'12.04.29', kabupaten:'12.04', name:'Somolo-Molo'})
kecamatanSet.push({ id:'12.01.02', kabupaten:'12.01', name:'Sorkam'})
kecamatanSet.push({ id:'12.01.10', kabupaten:'12.01', name:'Sorkam Barat'})
kecamatanSet.push({ id:'12.21.08', kabupaten:'12.21', name:'Sosa'})
kecamatanSet.push({ id:'12.21.01', kabupaten:'12.21', name:'Sosopan'})
kecamatanSet.push({ id:'12.01.09', kabupaten:'12.01', name:'Sosorgadong'})
kecamatanSet.push({ id:'12.05.07', kabupaten:'12.05', name:'Stabat'})
kecamatanSet.push({ id:'12.07.08', kabupaten:'12.07', name:'Stm Hilir'})
kecamatanSet.push({ id:'12.07.20', kabupaten:'12.07', name:'Stm Hulu'})
kecamatanSet.push({ id:'12.01.18', kabupaten:'12.01', name:'Suka Bangun'})
kecamatanSet.push({ id:'12.11.02', kabupaten:'12.11', name:'Sumbul'})
kecamatanSet.push({ id:'12.22.04', kabupaten:'12.22', name:'Sungai Kanan'})
kecamatanSet.push({ id:'12.07.23', kabupaten:'12.07', name:'Sunggal'})
kecamatanSet.push({ id:'12.14.09', kabupaten:'12.14', name:'Susua'})
kecamatanSet.push({ id:'12.19.05', kabupaten:'12.19', name:'Talawi'})
kecamatanSet.push({ id:'12.13.10', kabupaten:'12.13', name:'Tambangan'})
kecamatanSet.push({ id:'12.12.22', kabupaten:'12.12', name:'Tampahan'})
kecamatanSet.push({ id:'12.08.11', kabupaten:'12.08', name:'Tanah Jawa'})
kecamatanSet.push({ id:'12.14.31', kabupaten:'12.14', name:'Tanah Masa'})
kecamatanSet.push({ id:'12.11.06', kabupaten:'12.11', name:'Tanah Pinem'})
kecamatanSet.push({ id:'12.09.10', kabupaten:'12.09', name:'Tanjung Balai'})
kecamatanSet.push({ id:'12.74.01', kabupaten:'12.74', name:'Tanjung Balai Selatan'})
kecamatanSet.push({ id:'12.74.02', kabupaten:'12.74', name:'Tanjung Balai Utara'})
kecamatanSet.push({ id:'12.18.05', kabupaten:'12.18', name:'Tanjung Beringin'})
kecamatanSet.push({ id:'12.07.02', kabupaten:'12.07', name:'Tanjung Morawa'})
kecamatanSet.push({ id:'12.05.11', kabupaten:'12.05', name:'Tanjung Pura'})
kecamatanSet.push({ id:'12.19.06', kabupaten:'12.19', name:'Tanjung Tiram'})
kecamatanSet.push({ id:'12.03.30', kabupaten:'12.03', name:'Tano Tombangan Angkola'})
kecamatanSet.push({ id:'12.08.28', kabupaten:'12.08', name:'Tapian Dolok'})
kecamatanSet.push({ id:'12.01.07', kabupaten:'12.01', name:'Tapian Nauli'})
kecamatanSet.push({ id:'12.16.10', kabupaten:'12.16', name:'Tarabintang'})
kecamatanSet.push({ id:'12.02.01', kabupaten:'12.02', name:'Tarutung'})
kecamatanSet.push({ id:'12.18.16', kabupaten:'12.18', name:'Tebing Syahbandar'})
kecamatanSet.push({ id:'12.18.13', kabupaten:'12.18', name:'Tebing Tinggi'})
kecamatanSet.push({ id:'12.76.05', kabupaten:'12.76', name:'Tebing Tinggi Kota'})
kecamatanSet.push({ id:'12.14.06', kabupaten:'12.14', name:'Teluk Dalam'})
kecamatanSet.push({ id:'12.09.31', kabupaten:'12.09', name:'Teluk Dalam'})
kecamatanSet.push({ id:'12.18.03', kabupaten:'12.18', name:'Teluk Mengkudu'})
kecamatanSet.push({ id:'12.74.04', kabupaten:'12.74', name:'Teluk Nibung'})
kecamatanSet.push({ id:'12.06.08', kabupaten:'12.06', name:'Tigabinanga'})
kecamatanSet.push({ id:'12.11.03', kabupaten:'12.11', name:'Tigalingga'})
kecamatanSet.push({ id:'12.06.17', kabupaten:'12.06', name:'Tiganderket'})
kecamatanSet.push({ id:'12.06.04', kabupaten:'12.06', name:'Tigapanah'})
kecamatanSet.push({ id:'12.15.07', kabupaten:'12.15', name:'Tinada'})
kecamatanSet.push({ id:'12.09.26', kabupaten:'12.09', name:'Tinggi Raja'})
kecamatanSet.push({ id:'12.14.12', kabupaten:'12.14', name:'Toma'})
kecamatanSet.push({ id:'12.22.03', kabupaten:'12.22', name:'Torgamba'})
kecamatanSet.push({ id:'12.24.08', kabupaten:'12.24', name:'Tugala Oyo'})
kecamatanSet.push({ id:'12.24.03', kabupaten:'12.24', name:'Tuhemberua'})
kecamatanSet.push({ id:'12.01.14', kabupaten:'12.01', name:'Tukka'})
kecamatanSet.push({ id:'12.20.12', kabupaten:'12.20', name:'Ujung Batu'})
kecamatanSet.push({ id:'12.08.30', kabupaten:'12.08', name:'Ujung Padang'})
kecamatanSet.push({ id:'12.21.06', kabupaten:'12.21', name:'Ulu Barumun'})
kecamatanSet.push({ id:'12.14.34', kabupaten:'12.14', name:'Ulu Idanotae'})
kecamatanSet.push({ id:'12.25.08', kabupaten:'12.25', name:'Ulu Moro O'})
kecamatanSet.push({ id:'12.13.11', kabupaten:'12.13', name:'Ulu Pungkut'})
kecamatanSet.push({ id:'12.12.10', kabupaten:'12.12', name:'Uluan'})
kecamatanSet.push({ id:'12.04.27', kabupaten:'12.04', name:'Ulugawo'})
kecamatanSet.push({ id:'12.14.19', kabupaten:'12.14', name:'Ulunoyo'})
kecamatanSet.push({ id:'12.14.24', kabupaten:'12.14', name:'Ulususua'})
kecamatanSet.push({ id:'12.14.14', kabupaten:'12.14', name:'Umbunasi'})
kecamatanSet.push({ id:'12.05.08', kabupaten:'12.05', name:'Wampu'})
    setListKecamatan(kecamatanSet)
    console.log('kecamatan done')
  }
  function load_desa() {
    var dataSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
    /*
    dataSet.push({ id: '53.02.18.2007', kecamatan: '53.02.18', name: 'Abi' })
    dataSet.push({ id: '53.02.03.2007', kecamatan: '53.02.03', name: 'Ajaobaki' })
    dataSet.push({ id: '53.02.08.2008', kecamatan: '53.02.08', name: 'Anin' })
    dataSet.push({ id: '53.02.19.2005', kecamatan: '53.02.19', name: 'Babuin' })
    dataSet.push({ id: '53.02.05.2004', kecamatan: '53.02.05', name: 'Baki' })
    dataSet.push({ id: '53.02.13.2010', kecamatan: '53.02.13', name: 'Balu' })
    dataSet.push({ id: '53.02.11.2005', kecamatan: '53.02.11', name: 'Basmuti' })
    dataSet.push({ id: '53.02.06.2015', kecamatan: '53.02.06', name: 'Batnun' })
    dataSet.push({ id: '53.02.15.2010', kecamatan: '53.02.15', name: 'Baus' })
    dataSet.push({ id: '53.02.10.2004', kecamatan: '53.02.10', name: 'Belle' })
    dataSet.push({ id: '53.02.06.2018', kecamatan: '53.02.06', name: 'Bena' })
    dataSet.push({ id: '53.02.23.2006', kecamatan: '53.02.23', name: 'Benehe' })
    dataSet.push({ id: '53.02.14.2001', kecamatan: '53.02.14', name: 'Benlutu' })
    dataSet.push({ id: '53.02.28.2007', kecamatan: '53.02.28', name: "Besle'u" })
    dataSet.push({ id: '53.02.29.2002', kecamatan: '53.02.29', name: 'Besnam' })
    dataSet.push({ id: '53.02.03.2010', kecamatan: '53.02.03', name: 'Bijaepunu' })
    dataSet.push({ id: '53.02.13.2003', kecamatan: '53.02.13', name: 'Bijeli' })
    dataSet.push({ id: '53.02.02.2013', kecamatan: '53.02.02', name: 'Bikekneno' })
    dataSet.push({ id: '53.02.28.2006', kecamatan: '53.02.28', name: 'Bileon' })
    dataSet.push({ id: '53.02.04.2001', kecamatan: '53.02.04', name: 'Billa' })
    dataSet.push({ id: '53.02.02.2001', kecamatan: '53.02.02', name: 'Biloto' })
    dataSet.push({ id: '53.02.30.2003', kecamatan: '53.02.30', name: 'Binaus' })
    dataSet.push({ id: '53.02.20.2006', kecamatan: '53.02.20', name: 'Binenok' })
    dataSet.push({ id: '53.02.02.2010', kecamatan: '53.02.02', name: 'Bisene' })
    dataSet.push({ id: '53.02.14.2002', kecamatan: '53.02.14', name: 'Boentuka' })
    dataSet.push({ id: '53.02.15.2009', kecamatan: '53.02.15', name: 'Boking' })
    dataSet.push({ id: '53.02.16.2005', kecamatan: '53.02.16', name: 'Bokong' })
    dataSet.push({ id: '53.02.05.2009', kecamatan: '53.02.05', name: 'Bone' })
    dataSet.push({ id: '53.02.03.2003', kecamatan: '53.02.03', name: 'Bosen' })
    dataSet.push({ id: '53.02.10.2006', kecamatan: '53.02.10', name: 'Boti' })
    dataSet.push({ id: '53.02.01.1002', kecamatan: '53.02.01', name: 'Cendana' })
    dataSet.push({ id: '53.02.29.2006', kecamatan: '53.02.29', name: 'Ello' })
    dataSet.push({ id: '53.02.26.2007', kecamatan: '53.02.26', name: 'Eno Nabuasa' })
    dataSet.push({ id: '53.02.10.2011', kecamatan: '53.02.10', name: 'Eno Napi' })
    dataSet.push({ id: '53.02.06.2019', kecamatan: '53.02.06', name: 'Eno Neten' })
    dataSet.push({ id: '53.02.27.2005', kecamatan: '53.02.27', name: 'Enoneontes' })
    dataSet.push({ id: '53.02.03.2002', kecamatan: '53.02.03', name: 'Eonbesi' })
    dataSet.push({ id: '53.02.08.2012', kecamatan: '53.02.08', name: 'Fae' })
    dataSet.push({ id: '53.02.17.2007', kecamatan: '53.02.17', name: 'Fat' })
    dataSet.push({ id: '53.02.15.2014', kecamatan: '53.02.15', name: 'Fatu Manufui' })
    dataSet.push({ id: '53.02.09.2006', kecamatan: '53.02.09', name: 'Fatu Oni' })
    dataSet.push({ id: '53.02.20.2003', kecamatan: '53.02.20', name: 'Fatuat' })
    dataSet.push({ id: '53.02.22.2002', kecamatan: '53.02.22', name: 'Fatukoko' })
    dataSet.push({ id: '53.02.29.2001', kecamatan: '53.02.29', name: 'Fatukopa' })
    dataSet.push({ id: '53.02.03.2015', kecamatan: '53.02.03', name: 'Fatukoto' })
    dataSet.push({ id: '53.02.10.2012', kecamatan: '53.02.10', name: 'Fatukusi' })
    dataSet.push({ id: '53.02.08.2011', kecamatan: '53.02.08', name: 'Fatulunu' })
    dataSet.push({ id: '53.02.12.2004', kecamatan: '53.02.12', name: 'Fatumnasi' })
    dataSet.push({ id: '53.02.24.2002', kecamatan: '53.02.24', name: 'Fatumnasi' })
    dataSet.push({ id: '53.02.13.2002', kecamatan: '53.02.13', name: 'Fatumnutu' })
    dataSet.push({ id: '53.02.26.2002', kecamatan: '53.02.26', name: 'Fatutnana' })
    dataSet.push({ id: '53.02.08.2004', kecamatan: '53.02.08', name: 'Fenun' })
    dataSet.push({ id: '53.02.32.2005', kecamatan: '53.02.32', name: 'Feto Mone' })
    dataSet.push({ id: '53.02.09.2002', kecamatan: '53.02.09', name: 'Fotilo' })
    dataSet.push({ id: '53.02.17.2004', kecamatan: '53.02.17', name: 'Haineno' })
    dataSet.push({ id: '53.02.03.2014', kecamatan: '53.02.03', name: 'Halmei' })
    dataSet.push({ id: '53.02.14.2003', kecamatan: '53.02.14', name: 'Hane' })
    dataSet.push({ id: '53.02.17.2008', kecamatan: '53.02.17', name: 'Haumeni' })
    dataSet.push({ id: '53.02.07.2013', kecamatan: '53.02.07', name: 'Haumeni Baki' })
    dataSet.push({ id: '53.02.19.2010', kecamatan: '53.02.19', name: 'Haunobenak' })
    dataSet.push({ id: '53.02.18.2004', kecamatan: '53.02.18', name: 'Hoi' })
    dataSet.push({ id: '53.02.20.2004', kecamatan: '53.02.20', name: 'Hoibeti' })
    dataSet.push({ id: '53.02.31.2006', kecamatan: '53.02.31', name: 'Huetalan' })
    dataSet.push({ id: '53.02.03.2019', kecamatan: '53.02.03', name: 'Iusmolo' })
    dataSet.push({ id: '53.02.11.2003', kecamatan: '53.02.11', name: 'Kakan' })
    dataSet.push({ id: '53.02.01.1011', kecamatan: '53.02.01', name: 'Kampung Baru' })
    dataSet.push({ id: '53.02.01.1006', kecamatan: '53.02.01', name: 'Karang Sirih' })
    dataSet.push({ id: '53.02.11.2008', kecamatan: '53.02.11', name: 'Kelle' })
    dataSet.push({ id: '53.02.11.2012', kecamatan: '53.02.11', name: 'Kelle Tunan' })
    dataSet.push({ id: '53.02.02.2003', kecamatan: '53.02.02', name: 'Kesetnana' })
    dataSet.push({ id: '53.02.29.2005', kecamatan: '53.02.29', name: 'Kiki' })
    dataSet.push({ id: '53.02.06.2010', kecamatan: '53.02.06', name: 'Kiubaat' })
    dataSet.push({ id: '53.02.21.2007', kecamatan: '53.02.21', name: 'Kiufatu' })
    dataSet.push({ id: '53.02.01.1008', kecamatan: '53.02.01', name: 'Kobekamusa' })
    dataSet.push({ id: '53.02.03.2016', kecamatan: '53.02.03', name: "Kokfe'u" })
    dataSet.push({ id: '53.02.08.2003', kecamatan: '53.02.08', name: 'Kokoi' })
    dataSet.push({ id: '53.02.19.2001', kecamatan: '53.02.19', name: 'Kolbano' })
    dataSet.push({ id: '53.02.23.2003', kecamatan: '53.02.23', name: 'Koloto' })
    dataSet.push({ id: '53.02.13.2001', kecamatan: '53.02.13', name: 'Konbaki' })
    dataSet.push({ id: '53.02.20.2001', kecamatan: '53.02.20', name: "Kot'olin" })
    dataSet.push({ id: '53.02.01.1010', kecamatan: '53.02.01', name: 'Kota Baru' })
    dataSet.push({ id: '53.02.08.2005', kecamatan: '53.02.08', name: "Kuale'u" })
    dataSet.push({ id: '53.02.30.2005', kecamatan: '53.02.30', name: 'Kualeu' })
    dataSet.push({ id: '53.02.21.2001', kecamatan: '53.02.21', name: 'Kualin' })
    dataSet.push({ id: '53.02.11.2007', kecamatan: '53.02.11', name: 'Kuanfatu' })
    dataSet.push({ id: '53.02.12.2009', kecamatan: '53.02.12', name: 'Kuanoel' })
    dataSet.push({ id: '53.02.01.2012', kecamatan: '53.02.01', name: 'Kuatae' })
    dataSet.push({ id: '53.02.11.2006', kecamatan: '53.02.11', name: 'Kusi' })
    dataSet.push({ id: '53.02.11.2011', kecamatan: '53.02.11', name: 'Kusi Utara' })
    dataSet.push({ id: '53.02.27.2004', kecamatan: '53.02.27', name: 'Lakat' })
    dataSet.push({ id: '53.02.08.2006', kecamatan: '53.02.08', name: 'Lanu' })
    dataSet.push({ id: '53.02.13.2008', kecamatan: '53.02.13', name: 'Laob' })
    dataSet.push({ id: '53.02.11.2002', kecamatan: '53.02.11', name: 'Lasi' })
    dataSet.push({ id: '53.02.03.2013', kecamatan: '53.02.03', name: 'Lelobatan' })
    dataSet.push({ id: '53.02.03.2012', kecamatan: '53.02.03', name: 'Leloboko' })
    dataSet.push({ id: '53.02.15.2013', kecamatan: '53.02.15', name: 'Leonmeni' })
    dataSet.push({ id: '53.02.32.2001', kecamatan: '53.02.32', name: 'Lill ana' })
    dataSet.push({ id: '53.02.09.2001', kecamatan: '53.02.09', name: 'Lilo' })
    dataSet.push({ id: '53.02.06.2011', kecamatan: '53.02.06', name: 'Linamnutu' })
    dataSet.push({ id: '53.02.16.2007', kecamatan: '53.02.16', name: 'Lobus' })
    dataSet.push({ id: '53.02.13.2004', kecamatan: '53.02.13', name: 'Loli' })
    dataSet.push({ id: '53.02.23.2001', kecamatan: '53.02.23', name: 'Lotas' })
    dataSet.push({ id: '53.02.25.2003', kecamatan: '53.02.25', name: 'Manufui' })
    dataSet.push({ id: '53.02.05.2011', kecamatan: '53.02.05', name: 'Maunum Niki-Niki' })
    dataSet.push({ id: '53.02.24.2004', kecamatan: '53.02.24', name: 'Mella' })
    dataSet.push({ id: '53.02.15.2011', kecamatan: '53.02.15', name: 'Meusin' })
    dataSet.push({ id: '53.02.16.2009', kecamatan: '53.02.16', name: 'Milli' })
    dataSet.push({ id: '53.02.06.2014', kecamatan: '53.02.06', name: 'Mio' })
    dataSet.push({ id: '53.02.04.2008', kecamatan: '53.02.04', name: 'Mnelaanen' })
    dataSet.push({ id: '53.02.07.2010', kecamatan: '53.02.07', name: 'Mnelalete' })
    dataSet.push({ id: '53.02.24.2005', kecamatan: '53.02.24', name: 'Mnelapetu' })
    dataSet.push({ id: '53.02.13.2006', kecamatan: '53.02.13', name: 'Mnesatbubuk' })
    dataSet.push({ id: '53.02.09.2015', kecamatan: '53.02.09', name: 'Muna' })
    dataSet.push({ id: '53.02.12.2010', kecamatan: '53.02.12', name: 'Mutis' })
    dataSet.push({ id: '53.02.10.2013', kecamatan: '53.02.10', name: "Naile'u" })
    dataSet.push({ id: '53.02.26.2001', kecamatan: '53.02.26', name: 'Naip' })
    dataSet.push({ id: '53.02.05.2002', kecamatan: '53.02.05', name: 'Nakfunu' })
    dataSet.push({ id: '53.02.15.2007', kecamatan: '53.02.15', name: 'Nano' })
    dataSet.push({ id: '53.02.09.2003', kecamatan: '53.02.09', name: 'Nasi' })
    dataSet.push({ id: '53.02.27.2002', kecamatan: '53.02.27', name: 'Naukae' })
    dataSet.push({ id: '53.02.03.2011', kecamatan: '53.02.03', name: 'Nefokoko' })
    dataSet.push({ id: '53.02.18.2001', kecamatan: '53.02.18', name: 'Neke' })
    dataSet.push({ id: '53.02.30.2002', kecamatan: '53.02.30', name: 'Nekemunifeto' })
    dataSet.push({ id: '53.02.10.2010', kecamatan: '53.02.10', name: 'Nekmese' })
    dataSet.push({ id: '53.02.12.2001', kecamatan: '53.02.12', name: 'Nenas' })
    dataSet.push({ id: '53.02.17.2003', kecamatan: '53.02.17', name: 'Nenoat' })
    dataSet.push({ id: '53.02.03.2008', kecamatan: '53.02.03', name: 'Netpala' })
    dataSet.push({ id: '53.02.08.2013', kecamatan: '53.02.08', name: 'Netutnana' })
    dataSet.push({ id: '53.02.07.2015', kecamatan: '53.02.07', name: 'Nifukani' })
    dataSet.push({ id: '53.02.04.2007', kecamatan: '53.02.04', name: 'Nifukiu' })
    dataSet.push({ id: '53.02.08.2010', kecamatan: '53.02.08', name: 'Nifuleo' })
    dataSet.push({ id: '53.02.29.2007', kecamatan: '53.02.29', name: 'Nifulinah' })
    dataSet.push({ id: '53.02.05.1010', kecamatan: '53.02.05', name: 'Niki-Niki' })
    dataSet.push({ id: '53.02.18.2005', kecamatan: '53.02.18', name: 'Niki Niki Un' })
    dataSet.push({ id: '53.02.23.2004', kecamatan: '53.02.23', name: 'Niti' })
    dataSet.push({ id: '53.02.05.2007', kecamatan: '53.02.05', name: 'Nobi-Nobi' })
    dataSet.push({ id: '53.02.24.2001', kecamatan: '53.02.24', name: 'Noebana' })
    dataSet.push({ id: '53.02.11.2013', kecamatan: '53.02.11', name: 'Noebeba' })
    dataSet.push({ id: '53.02.05.2006', kecamatan: '53.02.05', name: 'Noebesa' })
    dataSet.push({ id: '53.02.32.2003', kecamatan: '53.02.32', name: 'Noebesi' })
    dataSet.push({ id: '53.02.01.2013', kecamatan: '53.02.01', name: 'Noemeto' })
    dataSet.push({ id: '53.02.06.2004', kecamatan: '53.02.06', name: 'Noemuke' })
    dataSet.push({ id: '53.02.18.2003', kecamatan: '53.02.18', name: 'Noenoni' })
    dataSet.push({ id: '53.02.16.2008', kecamatan: '53.02.16', name: 'Noeolin' })
    dataSet.push({ id: '53.02.19.2002', kecamatan: '53.02.19', name: 'Noesiu' })
    dataSet.push({ id: '53.02.02.2012', kecamatan: '53.02.02', name: 'Noinbila' })
    dataSet.push({ id: '53.02.01.1005', kecamatan: '53.02.01', name: 'Nonohonis' })
    dataSet.push({ id: '53.02.20.2005', kecamatan: '53.02.20', name: 'Nualunat' })
    dataSet.push({ id: '53.02.12.2005', kecamatan: '53.02.12', name: 'Nuapin' })
    dataSet.push({ id: '53.02.07.2008', kecamatan: '53.02.07', name: 'Nule' })
    dataSet.push({ id: '53.02.20.2002', kecamatan: '53.02.20', name: 'Nunbena' })
    dataSet.push({ id: '53.02.32.2002', kecamatan: '53.02.32', name: 'Nunbena' })
    dataSet.push({ id: '53.02.29.2004', kecamatan: '53.02.29', name: 'Nunfutu' })
    dataSet.push({ id: '53.02.17.2005', kecamatan: '53.02.17', name: 'Nunkolo' })
    dataSet.push({ id: '53.02.08.2002', kecamatan: '53.02.08', name: "Nunle'u" })
    dataSet.push({ id: '53.02.28.2002', kecamatan: '53.02.28', name: 'Nunukhniti' })
    dataSet.push({ id: '53.02.01.1007', kecamatan: '53.02.01', name: 'Nunumeu' })
    dataSet.push({ id: '53.02.19.2008', kecamatan: '53.02.19', name: 'Nununamat' })
    dataSet.push({ id: '53.02.21.2003', kecamatan: '53.02.21', name: 'Nunusunu' })
    dataSet.push({ id: '53.02.07.2009', kecamatan: '53.02.07', name: 'Nusa' })
    dataSet.push({ id: '53.02.03.2001', kecamatan: '53.02.03', name: "O'besi" })
    dataSet.push({ id: '53.02.20.2008', kecamatan: '53.02.20', name: "O'obibi" })
    dataSet.push({ id: '53.02.27.2006', kecamatan: '53.02.27', name: "O'of" })
    dataSet.push({ id: '53.02.23.2005', kecamatan: '53.02.23', name: "Obaki" })
    dataSet.push({ id: '53.02.05.2003', kecamatan: '53.02.05', name: "Oe'ekam" })
    dataSet.push({ id: '53.02.26.2004', kecamatan: '53.02.26', name: "Oe'ekam" })
    dataSet.push({ id: '53.02.04.2012', kecamatan: '53.02.04', name: "Oe'Ekam" })
    dataSet.push({ id: '53.02.01.1009', kecamatan: '53.02.01', name: 'Oe Kefan' })
    dataSet.push({ id: '53.02.27.2008', kecamatan: '53.02.27', name: 'Oe Oe' })
    dataSet.push({ id: '53.02.26.2006', kecamatan: '53.02.26', name: 'Oebaki' })
    dataSet.push({ id: '53.02.06.2003', kecamatan: '53.02.06', name: 'Oebelo' })
    dataSet.push({ id: '53.02.01.1003', kecamatan: '53.02.01', name: 'Oebesa' })
    dataSet.push({ id: '53.02.11.2010', kecamatan: '53.02.11', name: 'Oebo' })
    dataSet.push({ id: '53.02.14.2004', kecamatan: '53.02.14', name: 'Oebobo' })
    dataSet.push({ id: '53.02.11.2014', kecamatan: '53.02.11', name: 'Oehan' })
    dataSet.push({ id: '53.02.14.2007', kecamatan: '53.02.14', name: 'Oehela' })
    dataSet.push({ id: '53.02.06.2002', kecamatan: '53.02.06', name: 'Oekiu' })
    dataSet.push({ id: '53.02.30.2004', kecamatan: '53.02.30', name: "Oel'Ekam" })
    dataSet.push({ id: '53.02.22.2004', kecamatan: '53.02.22', name: 'Oel Uban' })
    dataSet.push({ id: '53.02.30.2001', kecamatan: '53.02.30', name: 'Oelbubuk' })
    dataSet.push({ id: '53.02.04.2002', kecamatan: '53.02.04', name: 'Oelet' })
    dataSet.push({ id: '53.02.16.2003', kecamatan: '53.02.16', name: 'Oeleu' })
    dataSet.push({ id: '53.02.19.2006', kecamatan: '53.02.19', name: 'Oeleu' })
    dataSet.push({ id: '53.02.13.2009', kecamatan: '53.02.13', name: 'Oelnunuh' })
    dataSet.push({ id: '53.02.21.2008', kecamatan: '53.02.21', name: 'Oemaman' })
    dataSet.push({ id: '53.02.10.2003', kecamatan: '53.02.10', name: 'Oenai' })
    dataSet.push({ id: '53.02.18.2006', kecamatan: '53.02.18', name: 'Oenino' })
    dataSet.push({ id: '53.02.26.2003', kecamatan: '53.02.26', name: 'Oepliki' })
    dataSet.push({ id: '53.02.19.2004', kecamatan: '53.02.19', name: 'Oetuke' })
    dataSet.push({ id: '53.02.19.2011', kecamatan: '53.02.19', name: 'Ofu' })
    dataSet.push({ id: '53.02.02.2008', kecamatan: '53.02.02', name: 'Oinlasi' })
    dataSet.push({ id: '53.02.08.2001', kecamatan: '53.02.08', name: 'Oinlasi' })
    dataSet.push({ id: '53.02.11.2001', kecamatan: '53.02.11', name: 'Olais' })
    dataSet.push({ id: '53.02.21.2002', kecamatan: '53.02.21', name: 'Oni' })
    dataSet.push({ id: '53.02.17.2001', kecamatan: '53.02.17', name: 'OP' })
    dataSet.push({ id: '53.02.19.2009', kecamatan: '53.02.19', name: 'Pana' })
    dataSet.push({ id: '53.02.19.2003', kecamatan: '53.02.19', name: 'Pene Selatan' })
    dataSet.push({ id: '53.02.18.2002', kecamatan: '53.02.18', name: 'Pene Utara' })
    dataSet.push({ id: '53.02.30.2006', kecamatan: '53.02.30', name: 'Pika' })
    dataSet.push({ id: '53.02.04.2004', kecamatan: '53.02.04', name: 'Pisan' })
    dataSet.push({ id: '53.02.06.2001', kecamatan: '53.02.06', name: 'Pollo' })
    dataSet.push({ id: '53.02.20.2007', kecamatan: '53.02.20', name: 'Ponite' })
    dataSet.push({ id: '53.02.31.2005', kecamatan: '53.02.31', name: 'Pubasu' })
    dataSet.push({ id: '53.02.13.2007', kecamatan: '53.02.13', name: 'Puna' })
    dataSet.push({ id: '53.02.07.2011', kecamatan: '53.02.07', name: 'Pusu' })
    dataSet.push({ id: '53.02.17.2009', kecamatan: '53.02.17', name: 'Putun' })
    dataSet.push({ id: '53.02.23.2002', kecamatan: '53.02.23', name: 'Sabnala' })
    dataSet.push({ id: '53.02.17.2006', kecamatan: '53.02.17', name: 'Saenam' })
    dataSet.push({ id: '53.02.17.2002', kecamatan: '53.02.17', name: 'Sahan' })
    dataSet.push({ id: '53.02.13.2011', kecamatan: '53.02.13', name: 'Sainoni' })
    dataSet.push({ id: '53.02.16.2004', kecamatan: '53.02.16', name: 'Sanbet' })
    dataSet.push({ id: '53.02.25.2001', kecamatan: '53.02.25', name: 'Santian' })
    dataSet.push({ id: '53.02.19.2007', kecamatan: '53.02.19', name: "Se'i" })
    dataSet.push({ id: '53.02.03.2004', kecamatan: '53.02.03', name: 'Sebot' })
    dataSet.push({ id: '53.02.28.2001', kecamatan: '53.02.28', name: 'Sillu' })
    dataSet.push({ id: '53.02.04.2016', kecamatan: '53.02.04', name: 'Sini' })
    dataSet.push({ id: '53.02.16.2002', kecamatan: '53.02.16', name: 'Skinu' })
    dataSet.push({ id: '53.02.09.2004', kecamatan: '53.02.09', name: 'Snok' })
    dataSet.push({ id: '53.02.01.1001', kecamatan: '53.02.01', name: 'SoE' })
    dataSet.push({ id: '53.02.05.2008', kecamatan: '53.02.05', name: 'Sopo' })
    dataSet.push({ id: '53.02.19.2012', kecamatan: '53.02.19', name: 'Spaha' })
    dataSet.push({ id: '53.02.24.2003', kecamatan: '53.02.24', name: 'Suni' })
    dataSet.push({ id: '53.02.08.2007', kecamatan: '53.02.08', name: 'Sunu' })
    dataSet.push({ id: '53.02.27.2003', kecamatan: '53.02.27', name: 'Supul' })
    dataSet.push({ id: '53.02.05.2001', kecamatan: '53.02.05', name: 'Taebesa' })
    dataSet.push({ id: '53.02.29.2003', kecamatan: '53.02.29', name: 'Taebone' })
    dataSet.push({ id: '53.02.03.2018', kecamatan: '53.02.03', name: 'Taiftob' })
    dataSet.push({ id: '53.02.32.2004', kecamatan: '53.02.32', name: 'Taneotob' })
    dataSet.push({ id: '53.02.09.2009', kecamatan: '53.02.09', name: 'Tauanas' })
    dataSet.push({ id: '53.02.01.1004', kecamatan: '53.02.01', name: 'Taubneno' })
    dataSet.push({ id: '53.02.11.2009', kecamatan: '53.02.11', name: 'Taupi' })
    dataSet.push({ id: '53.02.26.2005', kecamatan: '53.02.26', name: 'Teas' })
    dataSet.push({ id: '53.02.04.2009', kecamatan: '53.02.04', name: 'Teluk' })
    dataSet.push({ id: '53.02.10.2008', kecamatan: '53.02.10', name: 'Tesiayofanu' })
    dataSet.push({ id: '53.02.27.2001', kecamatan: '53.02.27', name: 'Tetaf' })
    dataSet.push({ id: '53.02.04.2017', kecamatan: '53.02.04', name: 'Tliu' })
    dataSet.push({ id: '53.02.03.2017', kecamatan: '53.02.03', name: "To'fen" })
    dataSet.push({ id: '53.02.08.2009', kecamatan: '53.02.08', name: "To'i" })
    dataSet.push({ id: '53.02.03.2020', kecamatan: '53.02.03', name: "To'manat" })
    dataSet.push({ id: '53.02.16.2001', kecamatan: '53.02.16', name: 'Toianas' })
    dataSet.push({ id: '53.02.21.2005', kecamatan: '53.02.21', name: 'Toineke' })
    dataSet.push({ id: '53.02.21.2006', kecamatan: '53.02.21', name: 'Tuafanu' })
    dataSet.push({ id: '53.02.14.2006', kecamatan: '53.02.14', name: 'Tuakole' })
    dataSet.push({ id: '53.02.21.2004', kecamatan: '53.02.21', name: 'Tuapakas' })
    dataSet.push({ id: '53.02.02.2006', kecamatan: '53.02.02', name: 'Tuasene' })
    dataSet.push({ id: '53.02.16.2006', kecamatan: '53.02.16', name: 'Tuataum' })
    dataSet.push({ id: '53.02.07.2007', kecamatan: '53.02.07', name: 'Tublopo' })
    dataSet.push({ id: '53.02.27.2007', kecamatan: '53.02.27', name: 'Tubmonas' })
    dataSet.push({ id: '53.02.07.2012', kecamatan: '53.02.07', name: 'Tubuhue' })
    dataSet.push({ id: '53.02.05.2005', kecamatan: '53.02.05', name: 'Tumu' })
    dataSet.push({ id: '53.02.09.2005', kecamatan: '53.02.09', name: 'Tumu' })
    dataSet.push({ id: '53.02.32.2006', kecamatan: '53.02.32', name: 'Tunbes' })
    dataSet.push({ id: '53.02.31.2003', kecamatan: '53.02.31', name: 'Tune' })
    dataSet.push({ id: '53.02.03.2009', kecamatan: '53.02.03', name: 'Tunua' })
    dataSet.push({ id: '53.02.14.2005', kecamatan: '53.02.14', name: 'Tupan' })
    dataSet.push({ id: '53.02.13.2005', kecamatan: '53.02.13', name: 'Usapimnasi' })
    dataSet.push({ id: '53.06.02.2011', kecamatan: '53.06.02', name: 'Adabang' })
    dataSet.push({ id: '53.05.02.1002', kecamatan: '53.05.02', name: 'Adang' })
    dataSet.push({ id: '53.05.01.2019', kecamatan: '53.05.01', name: 'Adang Buom' })
    dataSet.push({ id: '53.06.11.2002', kecamatan: '53.06.11', name: 'Adolaba' })
    dataSet.push({ id: '53.06.17.2007', kecamatan: '53.06.17', name: 'Adonara' })
    dataSet.push({ id: '53.08.07.2023', kecamatan: '53.08.07', name: 'Ae Ndoko' })
    dataSet.push({ id: '53.08.17.2008', kecamatan: '53.08.17', name: 'Aebara' })
    dataSet.push({ id: '53.08.02.2001', kecamatan: '53.08.02', name: 'Aejeti' })
    dataSet.push({ id: '53.08.07.2018', kecamatan: '53.08.07', name: 'Aelipo' })
    dataSet.push({ id: '53.08.07.2012', kecamatan: '53.08.07', name: 'Aemuri' })
    dataSet.push({ id: '53.16.01.2010', kecamatan: '53.16.01', name: 'Aerama' })
    dataSet.push({ id: '53.16.04.2006', kecamatan: '53.16.04', name: 'Aewoe' })
    dataSet.push({ id: '53.08.10.2003', kecamatan: '53.08.10', name: 'Aewora' })
    dataSet.push({ id: '53.01.13.2001', kecamatan: '53.01.13', name: 'Afoan' })
    dataSet.push({ id: '53.07.09.2004', kecamatan: '53.07.09', name: 'Aibura' })
    dataSet.push({ id: '53.09.01.1002', kecamatan: '53.09.01', name: 'Aimere' })
    dataSet.push({ id: '53.09.01.2014', kecamatan: '53.09.01', name: 'Aimere Timur' })
    dataSet.push({ id: '53.05.02.2007', kecamatan: '53.05.02', name: 'Aimoli' })
    dataSet.push({ id: '53.03.12.2004', kecamatan: '53.03.12', name: 'Ainan' })
    dataSet.push({ id: '53.03.08.1015', kecamatan: '53.03.08', name: 'Ainiut' })
    dataSet.push({ id: '53.05.01.2015', kecamatan: '53.05.01', name: 'Air Kenari' })
    dataSet.push({ id: '53.05.08.2008', kecamatan: '53.05.08', name: 'Air Mancur' })
    dataSet.push({ id: '53.71.06.1001', kecamatan: '53.71.06', name: 'Airmata' })
    dataSet.push({ id: '53.71.05.1003', kecamatan: '53.71.05', name: 'Airnona' })
    dataSet.push({ id: '53.04.03.2005', kecamatan: '53.04.03', name: 'Aitoun' })
    dataSet.push({ id: '53.01.23.2001', kecamatan: '53.01.23', name: 'Akle' })
    dataSet.push({ id: '53.03.11.2002', kecamatan: '53.03.11', name: 'Akomi' })
    dataSet.push({ id: '53.05.02.2023', kecamatan: '53.05.02', name: "Ala'ang" })
    dataSet.push({ id: '53.71.01.1008', kecamatan: '53.71.01', name: 'Alak' })
    dataSet.push({ id: '53.21.05.2005', kecamatan: '53.21.05', name: 'Alala' })
    dataSet.push({ id: '53.13.08.2001', kecamatan: '53.13.08', name: 'Alap Atadei' })
    dataSet.push({ id: '53.21.10.2003', kecamatan: '53.21.10', name: 'Alas' })
    dataSet.push({ id: '53.21.10.2004', kecamatan: '53.21.10', name: 'Alas Selatan' })
    dataSet.push({ id: '53.21.10.2001', kecamatan: '53.21.10', name: 'Alas Utara' })
    dataSet.push({ id: '53.05.02.2008', kecamatan: '53.05.02', name: 'Alila' })
    dataSet.push({ id: '53.05.02.2014', kecamatan: '53.05.02', name: 'Alila Selatan' })
    dataSet.push({ id: '53.05.10.2005', kecamatan: '53.05.10', name: 'Alila Timur' })
    dataSet.push({ id: '53.05.07.2017', kecamatan: '53.05.07', name: 'Alim Mebung' })
    dataSet.push({ id: '53.21.03.2008', kecamatan: '53.21.03', name: 'Alkani' })
    dataSet.push({ id: '53.05.17.2004', kecamatan: '53.05.17', name: 'Allumang' })
    dataSet.push({ id: '53.05.02.2004', kecamatan: '53.05.02', name: 'Alor Besar' })
    dataSet.push({ id: '53.05.02.2003', kecamatan: '53.05.02', name: 'Alor Kecil' })
    dataSet.push({ id: '53.16.03.2022', kecamatan: '53.16.03', name: 'Alorawe' })
    dataSet.push({ id: '53.06.03.1010', kecamatan: '53.06.03', name: 'Amagarapati' })
    dataSet.push({ id: '53.13.03.2005', kecamatan: '53.13.03', name: 'Amakaka' })
    dataSet.push({ id: '53.03.01.2018', kecamatan: '53.03.01', name: 'Amol' })
    dataSet.push({ id: '53.05.02.2005', kecamatan: '53.05.02', name: 'Ampera' })
    dataSet.push({ id: '53.18.07.2019', kecamatan: '53.18.07', name: 'Ana Engge' })
    dataSet.push({ id: '53.18.06.2022', kecamatan: '53.18.06', name: 'Ana Goka' })
    dataSet.push({ id: '53.18.07.2016', kecamatan: '53.18.07', name: 'Ana Kaka' })
    dataSet.push({ id: '53.18.06.2027', kecamatan: '53.18.06', name: 'Ana Lewe' })
    dataSet.push({ id: '53.12.11.2013', kecamatan: '53.12.11', name: 'Ana Wolu' })
    dataSet.push({ id: '53.17.02.2005', kecamatan: '53.17.02', name: 'Anajiaka' })
    dataSet.push({ id: '53.17.01.2023', kecamatan: '53.17.01', name: 'Anakalang' })
    dataSet.push({ id: '53.16.05.2004', kecamatan: '53.16.05', name: 'Anakoli' })
    dataSet.push({ id: '53.11.13.2011', kecamatan: '53.11.13', name: 'Ananjaki' })
    dataSet.push({ id: '53.17.02.2023', kecamatan: '53.17.02', name: 'Anapalu' })
    dataSet.push({ id: '53.14.09.2002', kecamatan: '53.14.09', name: 'Anarae' })
    dataSet.push({ id: '53.08.01.2023', kecamatan: '53.08.01', name: 'Anaraja' })
    dataSet.push({ id: '53.21.04.2005', kecamatan: '53.21.04', name: 'Angkaes' })
    dataSet.push({ id: '53.03.05.1002', kecamatan: '53.03.05', name: 'Aplasi' })
    dataSet.push({ id: '53.01.09.2007', kecamatan: '53.01.09', name: 'Apren' })
    dataSet.push({ id: '53.05.16.2009', kecamatan: '53.05.16', name: 'Aramaba' })
    dataSet.push({ id: '53.13.06.2006', kecamatan: '53.13.06', name: 'Aramengi' })
    dataSet.push({ id: '53.06.05.2021', kecamatan: '53.06.05', name: 'Aransina' })
    dataSet.push({ id: '53.19.08.2002', kecamatan: '53.19.08', name: 'Arus' })
    dataSet.push({ id: '53.21.07.2001', kecamatan: '53.21.07', name: 'As Manulea' })
    dataSet.push({ id: '53.04.03.2001', kecamatan: '53.04.03', name: 'Asumanu' })
    dataSet.push({ id: '53.13.08.2014', kecamatan: '53.13.08', name: 'Ataili' })
    dataSet.push({ id: '53.13.08.2002', kecamatan: '53.13.08', name: 'Atakera' })
    dataSet.push({ id: '53.13.02.2001', kecamatan: '53.13.02', name: 'Atakera' })
    dataSet.push({ id: '53.13.04.2016', kecamatan: '53.13.04', name: 'Atakowa' })
    dataSet.push({ id: '53.13.01.2003', kecamatan: '53.13.01', name: 'Atawai' })
    dataSet.push({ id: '53.18.07.2002', kecamatan: '53.18.07', name: 'Ate Dalo' })
    dataSet.push({ id: '53.03.20.1006', kecamatan: '53.03.20', name: 'Atmen' })
    dataSet.push({ id: '53.03.20.2007', kecamatan: '53.03.20', name: 'Atmen' })
    dataSet.push({ id: '53.13.07.2020', kecamatan: '53.13.07', name: "Atu Wa'lupang" })
    dataSet.push({ id: '53.13.07.2003', kecamatan: '53.13.07', name: 'Atulaleng' })
    dataSet.push({ id: '53.13.09.2007', kecamatan: '53.13.09', name: 'Aulesa' })
    dataSet.push({ id: '53.14.03.2014', kecamatan: '53.14.03', name: 'Baadale' })
    dataSet.push({ id: '53.03.17.2009', kecamatan: '53.03.17', name: 'Baas' })
    dataSet.push({ id: '53.01.06.1001', kecamatan: '53.01.06', name: 'Babau' })
    dataSet.push({ id: '53.13.01.2007', kecamatan: '53.13.01', name: 'Babokerong' })
    dataSet.push({ id: '53.21.12.2001', kecamatan: '53.21.12', name: 'Babotin' })
    dataSet.push({ id: '53.21.12.2003', kecamatan: '53.21.12', name: 'Babotin Maemina' })
    dataSet.push({ id: '53.21.12.2004', kecamatan: '53.21.12', name: 'Babotin Selatan' })
    dataSet.push({ id: '53.21.11.2001', kecamatan: '53.21.11', name: 'Babulu' })
    dataSet.push({ id: '53.21.11.2002', kecamatan: '53.21.11', name: 'Babulu Selatan' })
    dataSet.push({ id: '53.21.03.2004', kecamatan: '53.21.03', name: 'Badarai' })
    dataSet.push({ id: '53.05.16.2006', kecamatan: '53.05.16', name: 'Bagang' })
    dataSet.push({ id: '53.06.05.2010', kecamatan: '53.06.05', name: 'Bahinga' })
    dataSet.push({ id: '53.10.11.2010', kecamatan: '53.10.11', name: 'Bajak' })
    dataSet.push({ id: '53.09.06.1013', kecamatan: '53.09.06', name: 'Bajawa' })
    dataSet.push({ id: '53.13.05.2018', kecamatan: '53.13.05', name: 'Bakalerek' })
    dataSet.push({ id: '53.21.01.2004', kecamatan: '53.21.01', name: 'Bakiruk' })
    dataSet.push({ id: '53.03.18.2003', kecamatan: '53.03.18', name: 'Bakitolas' })
    dataSet.push({ id: '53.01.13.2005', kecamatan: '53.01.13', name: 'Bakuin' })
    dataSet.push({ id: '53.71.05.1001', kecamatan: '53.71.05', name: 'Bakunase' })
    dataSet.push({ id: '53.71.05.1002', kecamatan: '53.71.05', name: 'Bakunase Dua' })
    dataSet.push({ id: '53.04.04.2005', kecamatan: '53.04.04', name: 'Bakustulama' })
    dataSet.push({ id: '53.14.02.2023', kecamatan: '53.14.02', name: 'Balaoli' })
    dataSet.push({ id: '53.07.19.2004', kecamatan: '53.07.19', name: 'Balatatatin' })
    dataSet.push({ id: '53.13.06.2001', kecamatan: '53.13.06', name: 'Balauring' })
    dataSet.push({ id: '53.06.12.2010', kecamatan: '53.06.12', name: 'Balaweling' })
    dataSet.push({ id: '53.06.06.2008', kecamatan: '53.06.06', name: 'Balaweling I' })
    dataSet.push({ id: '53.06.06.2007', kecamatan: '53.06.06', name: 'Balaweling II' })
    dataSet.push({ id: '53.06.12.2016', kecamatan: '53.06.12', name: 'Balaweling Noten' })
    dataSet.push({ id: '53.06.03.1005', kecamatan: '53.06.03', name: 'Balela' })
    dataSet.push({ id: '53.12.10.2004', kecamatan: '53.12.10', name: 'Bali Ledo' })
    dataSet.push({ id: '53.12.11.2007', kecamatan: '53.12.11', name: 'Bali Loku' })
    dataSet.push({ id: '53.20.06.2005', kecamatan: '53.20.06', name: 'Ballu' })
    dataSet.push({ id: '53.06.15.2005', kecamatan: '53.06.15', name: 'Baluk Herin' })
    dataSet.push({ id: '53.13.04.2012', kecamatan: '53.13.04', name: 'Balurebong' })
    dataSet.push({ id: '53.19.01.2025', kecamatan: '53.19.01', name: 'Balus Permai' })
    dataSet.push({ id: '53.06.14.2006', kecamatan: '53.06.14', name: 'Bama' })
    dataSet.push({ id: '53.19.06.2014', kecamatan: '53.19.06', name: 'Bamo' })
    dataSet.push({ id: '53.05.02.2025', kecamatan: '53.05.02', name: 'Bampalola' })
    dataSet.push({ id: '53.05.06.2014', kecamatan: '53.05.06', name: 'Bana' })
    dataSet.push({ id: '53.03.17.2002', kecamatan: '53.03.17', name: 'Banain A' })
    dataSet.push({ id: '53.03.17.2003', kecamatan: '53.03.17', name: 'Banain B' })
    dataSet.push({ id: '53.03.17.2004', kecamatan: '53.03.17', name: 'Banain C' })
    dataSet.push({ id: '53.05.06.2009', kecamatan: '53.05.06', name: 'Bandar' })
    dataSet.push({ id: '53.06.05.2016', kecamatan: '53.06.05', name: 'Bandona' })
    dataSet.push({ id: '53.03.04.2010', kecamatan: '53.03.04', name: 'Banfanu' })
    dataSet.push({ id: '53.11.05.2011', kecamatan: '53.11.05', name: 'Bangga Watu' })
    dataSet.push({ id: '53.10.14.2005', kecamatan: '53.10.14', name: 'Bangka Ajang' })
    dataSet.push({ id: '53.10.17.2008', kecamatan: '53.10.17', name: 'Bangka Ara' })
    dataSet.push({ id: '53.19.08.2015', kecamatan: '53.19.08', name: 'Bangka Arus' })
    dataSet.push({ id: '53.10.15.2006', kecamatan: '53.10.15', name: 'Bangka Dese' })
    dataSet.push({ id: '53.10.01.2010', kecamatan: '53.10.01', name: 'Bangka Jong' })
    dataSet.push({ id: '53.19.01.2035', kecamatan: '53.19.01', name: 'Bangka Kantar' })
    dataSet.push({ id: '53.19.07.2014', kecamatan: '53.19.07', name: 'Bangka Kempo' })
    dataSet.push({ id: '53.10.01.2012', kecamatan: '53.10.01', name: 'Bangka Kenda' })
    dataSet.push({ id: '53.19.02.2014', kecamatan: '53.19.02', name: 'Bangka Kuleng' })
    dataSet.push({ id: '53.10.03.2029', kecamatan: '53.10.03', name: 'Bangka Lao' })
    dataSet.push({ id: '53.10.12.1019', kecamatan: '53.10.12', name: 'Bangka Leda' })
    dataSet.push({ id: '53.10.15.2001', kecamatan: '53.10.15', name: 'Bangka Lelak' })
    dataSet.push({ id: '53.19.02.1042', kecamatan: '53.19.02', name: 'Bangka Leleng' })
    dataSet.push({ id: '53.15.02.2030', kecamatan: '53.15.02', name: 'Bangka Lewat' })
    dataSet.push({ id: '53.19.07.2018', kecamatan: '53.19.07', name: 'Bangka Masa' })
    dataSet.push({ id: '53.10.12.1012', kecamatan: '53.10.12', name: 'Bangka Nekang' })
    dataSet.push({ id: '53.19.02.2015', kecamatan: '53.19.02', name: 'Bangka Pau' })
    dataSet.push({ id: '53.10.14.2011', kecamatan: '53.10.14', name: 'Bangka Ruang' })
    dataSet.push({ id: '53.10.15.2009', kecamatan: '53.10.15', name: 'Bangka Tonggur' })
    dataSet.push({ id: '53.07.08.2015', kecamatan: '53.07.08', name: 'Bangkoor' })
    dataSet.push({ id: '53.21.06.2005', kecamatan: '53.21.06', name: 'Bani-Bani' })
    dataSet.push({ id: '53.13.04.2017', kecamatan: '53.13.04', name: 'Banitobo' })
    dataSet.push({ id: '53.03.20.2005', kecamatan: '53.03.20', name: 'Bannae' })
    dataSet.push({ id: '53.03.05.1004', kecamatan: '53.03.05', name: 'Bansone' })
    dataSet.push({ id: '53.06.15.2002', kecamatan: '53.06.15', name: 'Bantala' })
    dataSet.push({ id: '53.13.09.2005', kecamatan: '53.13.09', name: 'Bao Lali Duli' })
    dataSet.push({ id: '53.06.12.2014', kecamatan: '53.06.12', name: 'Baobage' })
    dataSet.push({ id: '53.13.01.2012', kecamatan: '53.13.01', name: 'Baobolak' })
    dataSet.push({ id: '53.05.06.2010', kecamatan: '53.05.06', name: 'Baolang' })
    dataSet.push({ id: '53.13.05.2006', kecamatan: '53.13.05', name: 'Baolangu' })
    dataSet.push({ id: '53.07.18.2003', kecamatan: '53.07.18', name: 'Baomekot' })
    dataSet.push({ id: '53.07.03.2008', kecamatan: '53.07.03', name: 'Baopaat' })
    dataSet.push({ id: '53.13.04.2005', kecamatan: '53.13.04', name: 'Baopana' })
    dataSet.push({ id: '53.21.01.2014', kecamatan: '53.21.01', name: 'Barada' })
    dataSet.push({ id: '53.05.09.2002', kecamatan: '53.05.09', name: 'Baraler' })
    dataSet.push({ id: '53.10.06.2009', kecamatan: '53.10.06', name: 'Barang' })
    dataSet.push({ id: '53.05.09.2018', kecamatan: '53.05.09', name: 'Baranusa' })
    dataSet.push({ id: '53.04.21.1001', kecamatan: '53.04.21', name: 'Bardao' })
    dataSet.push({ id: '53.21.01.2001', kecamatan: '53.21.01', name: 'Barene' })
    dataSet.push({ id: '53.13.07.2013', kecamatan: '53.13.07', name: 'Bareng' })
    dataSet.push({ id: '53.15.01.2001', kecamatan: '53.15.01', name: 'Bari' })
    dataSet.push({ id: '53.10.11.1019', kecamatan: '53.10.11', name: 'Baru' })
    dataSet.push({ id: '53.09.12.2015', kecamatan: '53.09.12', name: 'Batajawa' })
    dataSet.push({ id: '53.01.05.1002', kecamatan: '53.01.05', name: 'Batakte' })
    dataSet.push({ id: '53.14.06.2015', kecamatan: '53.14.06', name: 'Batefalu' })
    dataSet.push({ id: '53.03.12.2006', kecamatan: '53.03.12', name: 'Batnes' })
    dataSet.push({ id: '53.05.14.2003', kecamatan: '53.05.14', name: 'Batu' })
    dataSet.push({ id: '53.15.05.2019', kecamatan: '53.15.05', name: 'Batu Cermin' })
    dataSet.push({ id: '53.71.01.1009', kecamatan: '53.71.01', name: 'Batu Plat' })
    dataSet.push({ id: '53.15.06.2009', kecamatan: '53.15.06', name: 'Batu Tiga' })
    dataSet.push({ id: '53.01.04.2011', kecamatan: '53.01.04', name: 'Batuinan' })
    dataSet.push({ id: '53.14.05.2002', kecamatan: '53.14.05', name: 'Batulilok' })
    dataSet.push({ id: '53.14.01.2010', kecamatan: '53.14.01', name: 'Batutua' })
    dataSet.push({ id: '53.04.17.2007', kecamatan: '53.04.17', name: 'Baudaok' })
    dataSet.push({ id: '53.04.02.2009', kecamatan: '53.04.02', name: 'Bauho' })
    dataSet.push({ id: '53.01.24.2002', kecamatan: '53.01.24', name: 'Baumata' })
    dataSet.push({ id: '53.01.24.2008', kecamatan: '53.01.24', name: 'Baumata Barat' })
    dataSet.push({ id: '53.01.24.2007', kecamatan: '53.01.24', name: 'Baumata Timur' })
    dataSet.push({ id: '53.01.24.2006', kecamatan: '53.01.24', name: 'Baumata Utara' })
    dataSet.push({ id: '53.03.19.2005', kecamatan: '53.03.19', name: 'Baunuan' })
    dataSet.push({ id: '53.09.18.2001', kecamatan: '53.09.18', name: 'Bawarani' })
    dataSet.push({ id: '53.06.18.2008', kecamatan: '53.06.18', name: 'Baya' })
    dataSet.push({ id: '53.06.13.2019', kecamatan: '53.06.13', name: 'Bayuntaa' })
    dataSet.push({ id: '53.10.03.2031', kecamatan: '53.10.03', name: 'Bea Kakor' })
    dataSet.push({ id: '53.10.13.2005', kecamatan: '53.10.13', name: 'Bea Kondo' })
    dataSet.push({ id: '53.10.06.2011', kecamatan: '53.10.06', name: 'Bea Mese' })
    dataSet.push({ id: '53.19.07.2001', kecamatan: '53.19.07', name: 'Bea Ngencung' })
    dataSet.push({ id: '53.19.02.2011', kecamatan: '53.19.02', name: 'Bea Waek' })
    dataSet.push({ id: '53.13.07.2015', kecamatan: '53.13.07', name: 'Bean' })
    dataSet.push({ id: '53.21.07.2008', kecamatan: '53.21.07', name: 'Beaneno' })
    dataSet.push({ id: '53.05.17.2005', kecamatan: '53.05.17', name: 'Beangonong' })
    dataSet.push({ id: '53.20.02.2001', kecamatan: '53.20.02', name: 'Bebae' })
    dataSet.push({ id: '53.14.03.2003', kecamatan: '53.14.03', name: 'Bebalain' })
    dataSet.push({ id: '53.06.13.2001', kecamatan: '53.06.13', name: 'Bedalewun' })
    dataSet.push({ id: '53.04.21.1004', kecamatan: '53.04.21', name: 'Beirafu' })
    dataSet.push({ id: '53.09.06.2009', kecamatan: '53.09.06', name: 'Beiwali' })
    dataSet.push({ id: '53.09.06.2001', kecamatan: '53.09.06', name: 'Beja' })
    dataSet.push({ id: '53.09.06.2028', kecamatan: '53.09.06', name: 'Bela' })
    dataSet.push({ id: '53.16.04.2002', kecamatan: '53.16.04', name: 'Bela' })
    dataSet.push({ id: '53.10.03.2022', kecamatan: '53.10.03', name: 'Belang Turi' })
    dataSet.push({ id: '53.05.05.2013', kecamatan: '53.05.05', name: 'Belemana' })
    dataSet.push({ id: '53.71.02.1005', kecamatan: '53.71.02', name: 'Bello' })
    dataSet.push({ id: '53.13.01.2009', kecamatan: '53.13.01', name: 'Belobaja' })
    dataSet.push({ id: '53.13.08.2011', kecamatan: '53.13.08', name: 'Belobao' })
    dataSet.push({ id: '53.13.05.2009', kecamatan: '53.13.05', name: 'Belobatang' })
    dataSet.push({ id: '53.06.10.2014', kecamatan: '53.06.10', name: 'Belota' })
    dataSet.push({ id: '53.13.07.2002', kecamatan: '53.13.07', name: 'Benihading I' })
    dataSet.push({ id: '53.13.07.2016', kecamatan: '53.13.07', name: 'Benihading II' })
    dataSet.push({ id: '53.03.05.1005', kecamatan: '53.03.05', name: 'Benpasi' })
    dataSet.push({ id: '53.15.09.2010', kecamatan: '53.15.09', name: 'Benteng Dewa' })
    dataSet.push({ id: '53.10.03.2021', kecamatan: '53.10.03', name: 'Benteng Kuwu' })
    dataSet.push({ id: '53.15.11.2008', kecamatan: '53.15.11', name: 'Benteng Ndope' })
    dataSet.push({ id: '53.19.09.2011', kecamatan: '53.19.09', name: 'Benteng Pau' })
    dataSet.push({ id: '53.10.01.2018', kecamatan: '53.10.01', name: 'Benteng Poco' })
    dataSet.push({ id: '53.19.01.2010', kecamatan: '53.19.01', name: 'Benteng Raja' })
    dataSet.push({ id: '53.19.08.2006', kecamatan: '53.19.08', name: 'Benteng Rampas' })
    dataSet.push({ id: '53.19.01.2005', kecamatan: '53.19.01', name: 'Benteng Riwu' })
    dataSet.push({ id: '53.15.02.2018', kecamatan: '53.15.02', name: 'Benteng Suru' })
    dataSet.push({ id: '53.15.09.2014', kecamatan: '53.15.09', name: 'Benteng Tado' })
    dataSet.push({ id: '53.09.14.2001', kecamatan: '53.09.14', name: 'Benteng Tawa' })
    dataSet.push({ id: '53.09.14.2008', kecamatan: '53.09.14', name: 'Benteng Tawa I' })
    dataSet.push({ id: '53.09.09.1010', kecamatan: '53.09.09', name: 'Benteng Tengah' })
    dataSet.push({ id: '53.10.14.2002', kecamatan: '53.10.14', name: 'Benteng Tubi' })
    dataSet.push({ id: '53.19.08.2017', kecamatan: '53.19.08', name: 'Benteng Wunis' })
    dataSet.push({ id: '53.01.11.2002', kecamatan: '53.01.11', name: 'Benu' })
    dataSet.push({ id: '53.03.18.2002', kecamatan: '53.03.18', name: 'Benus' })
    dataSet.push({ id: '53.10.03.2011', kecamatan: '53.10.03', name: 'Beo Rahong' })
    dataSet.push({ id: '53.15.06.2021', kecamatan: '53.15.06', name: 'Beo Sepang' })
    dataSet.push({ id: '53.12.10.2001', kecamatan: '53.12.10', name: 'Bera Dolu' })
    dataSet.push({ id: '53.10.17.2001', kecamatan: '53.10.17', name: 'Bere' })
    dataSet.push({ id: '53.21.01.2015', kecamatan: '53.21.01', name: 'Bereliku' })
    dataSet.push({ id: '53.07.15.1001', kecamatan: '53.07.15', name: 'Beru' })
    dataSet.push({ id: '53.21.02.2008', kecamatan: '53.21.02', name: 'Besikama' })
    dataSet.push({ id: '53.02.31.2008', kecamatan: '53.02.31', name: 'Bestobe' })
    dataSet.push({ id: '53.13.03.2025', kecamatan: '53.13.03', name: 'Beutaran' })
    dataSet.push({ id: '53.09.19.2010', kecamatan: '53.09.19', name: 'Bewapawe' })
    dataSet.push({ id: '53.07.02.2001', kecamatan: '53.07.02', name: 'Bhera' })
    dataSet.push({ id: '53.08.01.2011', kecamatan: '53.08.01', name: 'Bheramari' })
    dataSet.push({ id: '53.21.06.2001', kecamatan: '53.21.06', name: 'Biau' })
    dataSet.push({ id: '53.06.18.2009', kecamatan: '53.06.18', name: 'Bidara' })
    dataSet.push({ id: '53.11.03.2013', kecamatan: '53.11.03', name: 'Bidi Hunga' })
    dataSet.push({ id: '53.11.18.2002', kecamatan: '53.11.18', name: 'Bidipraing' })
    dataSet.push({ id: '53.16.02.2010', kecamatan: '53.16.02', name: 'Bidoa' })
    dataSet.push({ id: '53.03.11.2003', kecamatan: '53.03.11', name: 'Bijaepasu' })
    dataSet.push({ id: '53.03.04.2001', kecamatan: '53.03.04', name: 'Bijeli' })
    dataSet.push({ id: '53.18.08.2010', kecamatan: '53.18.08', name: 'Bila Cenge' })
    dataSet.push({ id: '53.06.10.2005', kecamatan: '53.06.10', name: 'Bilal' })
    dataSet.push({ id: '53.11.05.2001', kecamatan: '53.11.05', name: 'Billa' })
    dataSet.push({ id: '53.03.06.2004', kecamatan: '53.03.06', name: 'Biloe' })
    dataSet.push({ id: '53.01.30.2002', kecamatan: '53.01.30', name: 'Binafun' })
    dataSet.push({ id: '53.09.01.2021', kecamatan: '53.09.01', name: 'Binawali' })
    dataSet.push({ id: '53.05.01.1005', kecamatan: '53.05.01', name: 'Binongko' })
    dataSet.push({ id: '53.01.21.2004', kecamatan: '53.01.21', name: 'Bioba Baru' })
    dataSet.push({ id: '53.01.07.2005', kecamatan: '53.01.07', name: 'Bipolo' })
    dataSet.push({ id: '53.06.16.2002', kecamatan: '53.06.16', name: 'Birawan' })
    dataSet.push({ id: '53.21.03.2011', kecamatan: '53.21.03', name: 'Biris' })
    dataSet.push({ id: '53.03.24.2002', kecamatan: '53.03.24', name: 'Birunatun' })
    dataSet.push({ id: '53.03.12.2005', kecamatan: '53.03.12', name: 'Bisafe' })
    dataSet.push({ id: '53.21.08.2008', kecamatan: '53.21.08', name: 'Bisesmus' })
    dataSet.push({ id: '53.01.16.2011', kecamatan: '53.01.16', name: 'Bismarak' })
    dataSet.push({ id: '53.03.08.1029', kecamatan: '53.03.08', name: 'Bitauni' })
    dataSet.push({ id: '53.03.01.1006', kecamatan: '53.03.01', name: 'Bitefa' })
    dataSet.push({ id: '53.19.05.2018', kecamatan: '53.19.05', name: 'Biting' })
    dataSet.push({ id: '53.01.30.2003', kecamatan: '53.01.30', name: 'Bitobe' })
    dataSet.push({ id: '53.21.05.2009', kecamatan: '53.21.05', name: 'Biudukfoho' })
    dataSet.push({ id: '53.05.09.2019', kecamatan: '53.05.09', name: 'Blang Merang' })
    dataSet.push({ id: '53.06.14.2004', kecamatan: '53.06.14', name: 'Blepanawa' })
    dataSet.push({ id: '53.06.09.2008', kecamatan: '53.06.09', name: 'Bliko' })
    dataSet.push({ id: '53.07.04.2008', kecamatan: '53.07.04', name: 'Bloro' })
    dataSet.push({ id: '53.14.07.2004', kecamatan: '53.14.07', name: "Bo'a" })
    dataSet.push({ id: '53.08.11.2005', kecamatan: '53.08.11', name: 'Boafeo' })
    dataSet.push({ id: '53.09.18.2004', kecamatan: '53.09.18', name: 'Boba' })
    dataSet.push({ id: '53.09.18.2005', kecamatan: '53.09.18', name: 'Boba Satu' })
    dataSet.push({ id: '53.20.03.2004', kecamatan: '53.20.03', name: 'Bodae' })
    dataSet.push({ id: '53.12.12.2014', kecamatan: '53.12.12', name: 'Bodo Hula' })
    dataSet.push({ id: '53.18.02.2007', kecamatan: '53.18.02', name: 'Bodo Ponda' })
    dataSet.push({ id: '53.21.05.2012', kecamatan: '53.21.05', name: 'Boen' })
    dataSet.push({ id: '53.09.07.2016', kecamatan: '53.09.07', name: 'Bogoboa' })
    dataSet.push({ id: '53.06.02.2014', kecamatan: '53.06.02', name: 'Bokang Wolomatang' })
    dataSet.push({ id: '53.08.08.1001', kecamatan: '53.08.08', name: 'Bokasape' })
    dataSet.push({ id: '53.08.08.2002', kecamatan: '53.08.08', name: 'Bokasape Timur' })
    dataSet.push({ id: '53.03.01.2005', kecamatan: '53.03.01', name: 'Bokon' })
    dataSet.push({ id: '53.01.24.2005', kecamatan: '53.01.24', name: 'Bokong' })
    dataSet.push({ id: '53.01.04.2003', kecamatan: '53.01.04', name: 'Bokonusan' })
    dataSet.push({ id: '53.07.11.2004', kecamatan: '53.07.11', name: 'Bola' })
    dataSet.push({ id: '53.14.10.2001', kecamatan: '53.14.10', name: 'Bolatena' })
    dataSet.push({ id: '53.06.13.2009', kecamatan: '53.06.13', name: 'Boleng' })
    dataSet.push({ id: '53.13.01.2014', kecamatan: '53.13.01', name: 'Boli Bean' })
    dataSet.push({ id: '53.01.05.2010', kecamatan: '53.01.05', name: 'Bolok' })
    dataSet.push({ id: '53.18.10.2007', kecamatan: '53.18.10', name: 'Bolora' })
    dataSet.push({ id: '53.20.03.1001', kecamatan: '53.20.03', name: 'Bolou' })
    dataSet.push({ id: '53.17.04.2004', kecamatan: '53.17.04', name: 'Bolu Bokat' })
    dataSet.push({ id: '53.17.04.2011', kecamatan: '53.17.04', name: 'Bolu Bokat Utara' })
    dataSet.push({ id: '53.20.06.2003', kecamatan: '53.20.06', name: 'Bolua' })
    dataSet.push({ id: '53.17.04.2018', kecamatan: '53.17.04', name: 'Bolubokat Barat' })
    dataSet.push({ id: '53.09.06.2002', kecamatan: '53.09.06', name: 'Bomari' })
    dataSet.push({ id: '53.18.06.2025', kecamatan: '53.18.06', name: 'Bondo Balla' })
    dataSet.push({ id: '53.18.05.2005', kecamatan: '53.18.05', name: 'Bondo Bela' })
    dataSet.push({ id: '53.18.01.2001', kecamatan: '53.18.01', name: 'Bondo Boghila' })
    dataSet.push({ id: '53.18.10.2016', kecamatan: '53.18.10', name: 'Bondo Delo' })
    dataSet.push({ id: '53.18.07.2001', kecamatan: '53.18.07', name: 'Bondo Kodi' })
    dataSet.push({ id: '53.17.03.2010', kecamatan: '53.17.03', name: 'Bondo Sulla' })
    dataSet.push({ id: '53.12.04.2010', kecamatan: '53.12.04', name: 'Bondo Tera' })
    dataSet.push({ id: '53.18.05.2008', kecamatan: '53.18.05', name: 'Bondo Ukka' })
    dataSet.push({ id: '53.01.16.2008', kecamatan: '53.01.16', name: 'Bone' })
    dataSet.push({ id: '53.21.04.2013', kecamatan: '53.21.04', name: 'Bonetasea' })
    dataSet.push({ id: '53.14.02.2005', kecamatan: '53.14.02', name: 'Boni' })
    dataSet.push({ id: '53.21.08.2006', kecamatan: '53.21.08', name: 'Boni Bais' })
    dataSet.push({ id: '53.71.06.1003', kecamatan: '53.71.06', name: 'Bonipoi' })
    dataSet.push({ id: '53.01.30.2004', kecamatan: '53.01.30', name: 'Bonmuti' })
    dataSet.push({ id: '53.09.06.2022', kecamatan: '53.09.06', name: 'Borani' })
    dataSet.push({ id: '53.10.13.2019', kecamatan: '53.10.13', name: 'Borik' })
    dataSet.push({ id: '53.08.18.2005', kecamatan: '53.08.18', name: 'Borokanda' })
    dataSet.push({ id: '53.03.06.1001', kecamatan: '53.03.06', name: 'Boronubaen' })
    dataSet.push({ id: '53.06.01.2008', kecamatan: '53.06.01', name: 'Boru' })
    dataSet.push({ id: '53.06.01.2014', kecamatan: '53.06.01', name: 'Boru Kedang' })
    dataSet.push({ id: '53.03.08.2027', kecamatan: '53.03.08', name: 'Botof' })
    dataSet.push({ id: '53.13.05.2019', kecamatan: '53.13.05', name: 'Bour' })
    dataSet.push({ id: '53.05.06.2016', kecamatan: '53.05.06', name: 'Bouweli' })
    dataSet.push({ id: '53.09.06.2025', kecamatan: '53.09.06', name: 'Bowali' })
    dataSet.push({ id: '53.07.17.2001', kecamatan: '53.07.17', name: 'Bu Selatan' })
    dataSet.push({ id: '53.08.12.2017', kecamatan: '53.08.12', name: 'Bu Tanalagu' })
    dataSet.push({ id: '53.07.17.2002', kecamatan: '53.07.17', name: 'Bu Utara' })
    dataSet.push({ id: '53.07.17.2003', kecamatan: '53.07.17', name: 'Bu Watuweti' })
    dataSet.push({ id: '53.10.14.2001', kecamatan: '53.10.14', name: 'Buar' })
    dataSet.push({ id: '53.06.19.2007', kecamatan: '53.06.19', name: 'Bubuatagamu' })
    dataSet.push({ id: '53.21.07.2005', kecamatan: '53.21.07', name: 'Builaran' })
    dataSet.push({ id: '53.03.15.2001', kecamatan: '53.03.15', name: 'Buk' })
    dataSet.push({ id: '53.18.08.2011', kecamatan: '53.18.08', name: 'Bukambero' })
    dataSet.push({ id: '53.05.06.2017', kecamatan: '53.05.06', name: 'Bukit Mas' })
    dataSet.push({ id: '53.06.08.2010', kecamatan: '53.06.08', name: 'Bukit Seburi I' })
    dataSet.push({ id: '53.06.08.2024', kecamatan: '53.06.08', name: 'Bukit Seburi II' })
    dataSet.push({ id: '53.10.03.2006', kecamatan: '53.10.03', name: 'Bulan' })
    dataSet.push({ id: '53.05.14.2009', kecamatan: '53.05.14', name: 'Bungabali' })
    dataSet.push({ id: '53.06.13.2004', kecamatan: '53.06.13', name: 'Bungalawan' })
    dataSet.push({ id: '53.06.08.2019', kecamatan: '53.06.08', name: 'Bungalima' })
    dataSet.push({ id: '53.13.03.2006', kecamatan: '53.13.03', name: 'Bungamuda' })
    dataSet.push({ id: '53.01.18.1001', kecamatan: '53.01.18', name: 'Buraen' })
    dataSet.push({ id: '53.13.07.2010', kecamatan: '53.13.07', name: 'Buriwutung' })
    dataSet.push({ id: '53.18.05.2001', kecamatan: '53.18.05', name: 'Buru Deilo' })
    dataSet.push({ id: '53.18.05.2003', kecamatan: '53.18.05', name: 'Buru Kaghu' })
    dataSet.push({ id: '53.14.02.1008', kecamatan: '53.14.02', name: 'Busalangga' })
    dataSet.push({ id: '53.14.02.2026', kecamatan: '53.14.02', name: 'Busalangga Barat' })
    dataSet.push({ id: '53.14.02.2025', kecamatan: '53.14.02', name: 'Busalangga Timur' })
    dataSet.push({ id: '53.19.04.2003', kecamatan: '53.19.04', name: 'Buti' })
    dataSet.push({ id: '53.10.13.2021', kecamatan: '53.10.13', name: 'Cambir Leca' })
    dataSet.push({ id: '53.01.10.1001', kecamatan: '53.01.10', name: 'Camplong I' })
    dataSet.push({ id: '53.01.10.2007', kecamatan: '53.01.10', name: 'Camplong II' })
    dataSet.push({ id: '53.10.12.1011', kecamatan: '53.10.12', name: 'Carep' })
    dataSet.push({ id: '53.10.13.2014', kecamatan: '53.10.13', name: 'Ceka Luju' })
    dataSet.push({ id: '53.17.03.2005', kecamatan: '53.17.03', name: 'Cendana' })
    dataSet.push({ id: '53.17.03.2013', kecamatan: '53.17.03', name: 'Cendana Barat' })
    dataSet.push({ id: '53.10.18.2009', kecamatan: '53.10.18', name: 'Cireng' })
    dataSet.push({ id: '53.15.02.2002', kecamatan: '53.15.02', name: 'Coal' })
    dataSet.push({ id: '53.19.08.2016', kecamatan: '53.19.08', name: 'Colol' })
    dataSet.push({ id: '53.15.11.2004', kecamatan: '53.15.11', name: 'Compang' })
    dataSet.push({ id: '53.10.12.1015', kecamatan: '53.10.12', name: 'Compang Carep' })
    dataSet.push({ id: '53.10.17.2009', kecamatan: '53.10.17', name: 'Compang Cibal' })
    dataSet.push({ id: '53.19.04.2008', kecamatan: '53.19.04', name: 'Compang Congkar' })
    dataSet.push({ id: '53.10.03.2030', kecamatan: '53.10.03', name: 'Compang Dalo' })
    dataSet.push({ id: '53.10.14.2003', kecamatan: '53.10.14', name: 'Compang Dari' })
    dataSet.push({ id: '53.19.03.2014', kecamatan: '53.19.03', name: 'Compang Deru' })
    dataSet.push({ id: '53.19.07.2012', kecamatan: '53.19.07', name: 'Compang Kantar' })
    dataSet.push({ id: '53.19.07.2021', kecamatan: '53.19.07', name: 'Compang Kempo' })
    dataSet.push({ id: '53.15.12.2007', kecamatan: '53.15.12', name: 'Compang Kules' })
    dataSet.push({ id: '53.19.02.2019', kecamatan: '53.19.02', name: 'Compang Laho' })
    dataSet.push({ id: '53.19.04.2016', kecamatan: '53.19.04', name: 'Compang Lawi' })
    dataSet.push({ id: '53.15.10.2014', kecamatan: '53.15.10', name: 'Compang Liang Ndara' })
    dataSet.push({ id: '53.15.05.2027', kecamatan: '53.15.05', name: 'Compang Longgo' })
    dataSet.push({ id: '53.19.07.2020', kecamatan: '53.19.07', name: 'Compang Loni' })
    dataSet.push({ id: '53.19.03.2013', kecamatan: '53.19.03', name: 'Compang Mekar' })
    dataSet.push({ id: '53.10.03.2032', kecamatan: '53.10.03', name: 'Compang Namut' })
    dataSet.push({ id: '53.10.01.2009', kecamatan: '53.10.01', name: 'Compang Ndehes' })
    dataSet.push({ id: '53.19.01.2038', kecamatan: '53.19.01', name: 'Compang Ndejing' })
    dataSet.push({ id: '53.19.03.2011', kecamatan: '53.19.03', name: 'Compang Necak' })
    dataSet.push({ id: '53.19.08.2013', kecamatan: '53.19.08', name: 'Compang Raci' })
    dataSet.push({ id: '53.19.05.2025', kecamatan: '53.19.05', name: 'Compang Soba' })
    dataSet.push({ id: '53.15.02.2017', kecamatan: '53.15.02', name: 'Compang Suka' })
    dataSet.push({ id: '53.19.07.2015', kecamatan: '53.19.07', name: 'Compang Teber' })
    dataSet.push({ id: '53.19.01.2034', kecamatan: '53.19.01', name: 'Compang Tenda' })
    dataSet.push({ id: '53.19.05.2026', kecamatan: '53.19.05', name: 'Compang Teo' })
    dataSet.push({ id: '53.10.12.1020', kecamatan: '53.10.12', name: 'Compang Tuke' })
    dataSet.push({ id: '53.19.02.2032', kecamatan: '53.19.02', name: 'Compang Weluk' })
    dataSet.push({ id: '53.19.02.2029', kecamatan: '53.19.02', name: 'Compang Wesang' })
    dataSet.push({ id: '53.19.08.2005', kecamatan: '53.19.08', name: 'Compang Wunis' })
    dataSet.push({ id: '53.10.03.2002', kecamatan: '53.10.03', name: 'Cumbi' })
    dataSet.push({ id: '53.15.10.2003', kecamatan: '53.15.10', name: 'Cunca Lolos' })
    dataSet.push({ id: '53.15.10.2004', kecamatan: '53.15.10', name: 'Cunca Wulang' })
    dataSet.push({ id: '53.09.02.2018', kecamatan: '53.09.02', name: 'Dadawea' })
    dataSet.push({ id: '53.14.10.2004', kecamatan: '53.14.10', name: 'Daeurendale' })
    dataSet.push({ id: '53.04.02.2007', kecamatan: '53.04.02', name: 'Dafala' })
    dataSet.push({ id: '53.17.02.2024', kecamatan: '53.17.02', name: 'Daha Elu' })
    dataSet.push({ id: '53.14.10.2005', kecamatan: '53.14.10', name: 'Daiama' })
    dataSet.push({ id: '53.20.05.2003', kecamatan: '53.20.05', name: 'Daieko' })
    dataSet.push({ id: '53.20.04.2008', kecamatan: '53.20.04', name: 'Dainao' })
    dataSet.push({ id: '53.14.08.2002', kecamatan: '53.14.08', name: 'Daleholu' })
    dataSet.push({ id: '53.14.01.2023', kecamatan: '53.14.01', name: 'Dalek Esa' })
    dataSet.push({ id: '53.15.03.2014', kecamatan: '53.15.03', name: 'Daleng' })
    dataSet.push({ id: '53.17.05.2005', kecamatan: '53.17.05', name: 'Dameka' })
    dataSet.push({ id: '53.16.01.1009', kecamatan: '53.16.01', name: 'Danga' })
    dataSet.push({ id: '53.18.03.2020', kecamatan: '53.18.03', name: 'Dangga Mangu' })
    dataSet.push({ id: '53.06.08.2012', kecamatan: '53.06.08', name: 'Danibao' })
    dataSet.push({ id: '53.06.06.2015', kecamatan: '53.06.06', name: 'Daniwato' })
    dataSet.push({ id: '53.05.07.2014', kecamatan: '53.05.07', name: 'Dapitau' })
    dataSet.push({ id: '53.07.08.2001', kecamatan: '53.07.08', name: 'Darat Gunung' })
    dataSet.push({ id: '53.07.08.2011', kecamatan: '53.07.08', name: 'Darat Pantai' })
    dataSet.push({ id: '53.09.12.2003', kecamatan: '53.09.12', name: 'Dariwali' })
    dataSet.push({ id: '53.09.12.2009', kecamatan: '53.09.12', name: 'Dariwali I' })
    dataSet.push({ id: '53.14.02.2014', kecamatan: '53.14.02', name: 'Daudolu' })
    dataSet.push({ id: '53.06.10.2003', kecamatan: '53.06.10', name: 'Dawataa' })
    dataSet.push({ id: '53.04.18.2006', kecamatan: '53.04.18', name: 'Debululik' })
    dataSet.push({ id: '53.18.03.2027', kecamatan: '53.18.03', name: 'Dede Pada' })
    dataSet.push({ id: '53.12.10.2005', kecamatan: '53.12.10', name: 'Dedekadu' })
    dataSet.push({ id: '53.16.02.2008', kecamatan: '53.16.02', name: 'Degalea' })
    dataSet.push({ id: '53.05.16.2010', kecamatan: '53.05.16', name: 'Delaki' })
    dataSet.push({ id: '53.18.05.2006', kecamatan: '53.18.05', name: 'Delo' })
    dataSet.push({ id: '53.20.01.2014', kecamatan: '53.20.01', name: 'Delo' })
    dataSet.push({ id: '53.18.06.2023', kecamatan: '53.18.06', name: 'Delu Depa' })
    dataSet.push({ id: '53.20.04.2006', kecamatan: '53.20.04', name: 'Deme' })
    dataSet.push({ id: '53.06.09.2013', kecamatan: '53.06.09', name: 'Demondei' })
    dataSet.push({ id: '53.08.16.2003', kecamatan: '53.08.16', name: 'Demulaka' })
    dataSet.push({ id: '53.09.16.2002', kecamatan: '53.09.16', name: 'Denatana' })
    dataSet.push({ id: '53.09.16.2008', kecamatan: '53.09.16', name: 'Denatana Timur' })
    dataSet.push({ id: '53.18.05.2004', kecamatan: '53.18.05', name: 'Denduka' })
    dataSet.push({ id: '53.19.02.2037', kecamatan: '53.19.02', name: 'Deno' })
    dataSet.push({ id: '53.20.01.2009', kecamatan: '53.20.01', name: 'Depe' })
    dataSet.push({ id: '53.04.04.2004', kecamatan: '53.04.04', name: 'Derokfaturene' })
    dataSet.push({ id: '53.08.21.2009', kecamatan: '53.08.21', name: 'Detuara' })
    dataSet.push({ id: '53.08.07.2007', kecamatan: '53.08.07', name: 'Detubela' })
    dataSet.push({ id: '53.07.17.2006', kecamatan: '53.07.17', name: 'Detubinga' })
    dataSet.push({ id: '53.08.14.2009', kecamatan: '53.08.14', name: 'Detuena' })
    dataSet.push({ id: '53.08.15.2002', kecamatan: '53.08.15', name: 'Detukeli' })
    dataSet.push({ id: '53.08.15.2008', kecamatan: '53.08.15', name: 'Detumbewa' })
    dataSet.push({ id: '53.08.12.2005', kecamatan: '53.08.12', name: 'Detupera' })
    dataSet.push({ id: '53.08.06.1001', kecamatan: '53.08.06', name: 'Detusoko' })
    dataSet.push({ id: '53.08.06.2002', kecamatan: '53.08.06', name: 'Detusoko Barat' })
    dataSet.push({ id: '53.08.10.2018', kecamatan: '53.08.10', name: 'Detuwulu' })
    dataSet.push({ id: '53.17.01.2024', kecamatan: '53.17.01', name: 'Dewa Jara' })
    dataSet.push({ id: '53.17.02.2025', kecamatan: '53.17.02', name: 'Dewa Tana' })
    dataSet.push({ id: '53.16.01.1001', kecamatan: '53.16.01', name: 'Dhawe' })
    dataSet.push({ id: '53.16.03.2019', kecamatan: '53.16.03', name: 'Dhereisa' })
    dataSet.push({ id: '53.13.04.2008', kecamatan: '53.13.04', name: 'Dikesare' })
    dataSet.push({ id: '53.18.03.2018', kecamatan: '53.18.03', name: 'Dikira' })
    dataSet.push({ id: '53.08.06.2018', kecamatan: '53.08.06', name: 'Dile' })
    dataSet.push({ id: '53.10.14.2004', kecamatan: '53.10.14', name: 'Dimpong' })
    dataSet.push({ id: '53.18.06.2001', kecamatan: '53.18.06', name: 'Dinjo' })
    dataSet.push({ id: '53.12.10.1013', kecamatan: '53.12.10', name: 'Dira Tana' })
    dataSet.push({ id: '53.21.09.2005', kecamatan: '53.21.09', name: 'Dirma' })
    dataSet.push({ id: '53.04.01.2008', kecamatan: '53.04.01', name: 'Dirun' })
    dataSet.push({ id: '53.09.19.2009', kecamatan: '53.09.19', name: 'Dizi Gedha' })
    dataSet.push({ id: '53.20.01.2016', kecamatan: '53.20.01', name: 'Djadu' })
    dataSet.push({ id: '53.18.02.2011', kecamatan: '53.18.02', name: 'Djela Manu' })
    dataSet.push({ id: '53.07.02.2002', kecamatan: '53.07.02', name: 'Dobo' })
    dataSet.push({ id: '53.07.02.2010', kecamatan: '53.07.02', name: 'Dobo Nuapuu' })
    dataSet.push({ id: '53.14.08.2003', kecamatan: '53.14.08', name: 'Dodaek' })
    dataSet.push({ id: '53.12.10.2002', kecamatan: '53.12.10', name: 'Doka Kaka' })
    dataSet.push({ id: '53.06.13.2018', kecamatan: '53.06.13', name: 'Dokeng' })
    dataSet.push({ id: '53.14.01.2016', kecamatan: '53.14.01', name: 'Dolasi' })
    dataSet.push({ id: '53.13.06.2009', kecamatan: '53.13.06', name: 'Dolulolong' })
    dataSet.push({ id: '53.07.12.2003', kecamatan: '53.07.12', name: 'Done' })
    dataSet.push({ id: '53.13.02.2012', kecamatan: '53.13.02', name: 'Dori Pewut' })
    dataSet.push({ id: '53.07.03.2009', kecamatan: '53.07.03', name: 'Du' })
    dataSet.push({ id: '53.04.13.2003', kecamatan: '53.04.13', name: 'Dua Koran' })
    dataSet.push({ id: '53.06.13.2011', kecamatan: '53.06.13', name: 'Duablolong' })
    dataSet.push({ id: '53.04.17.2005', kecamatan: '53.04.17', name: 'Dualasi' })
    dataSet.push({ id: '53.04.17.2004', kecamatan: '53.04.17', name: 'Dualasi Rai Ulun' })
    dataSet.push({ id: '53.04.05.2002', kecamatan: '53.04.05', name: 'Dualaus' })
    dataSet.push({ id: '53.06.08.2008', kecamatan: '53.06.08', name: 'Duanur' })
    dataSet.push({ id: '53.04.01.2004', kecamatan: '53.04.01', name: 'Duarato' })
    dataSet.push({ id: '53.13.01.2002', kecamatan: '53.13.01', name: 'Duawutun' })
    dataSet.push({ id: '53.04.23.2001', kecamatan: '53.04.23', name: 'Dubesi' })
    dataSet.push({ id: '53.06.02.2013', kecamatan: '53.06.02', name: 'Duli Jaya' })
    dataSet.push({ id: '53.06.16.2006', kecamatan: '53.06.16', name: 'Dulipali' })
    dataSet.push({ id: '53.13.02.2011', kecamatan: '53.13.02', name: 'Dulir' })
    dataSet.push({ id: '53.13.03.2002', kecamatan: '53.13.03', name: 'Dulitukan' })
    dataSet.push({ id: '53.05.02.2006', kecamatan: '53.05.02', name: 'Dulolong' })
    dataSet.push({ id: '53.05.02.2027', kecamatan: '53.05.02', name: 'Dulolong Barat' })
    dataSet.push({ id: '53.06.02.2012', kecamatan: '53.06.02', name: 'Dun Tana Lewoingu' })
    dataSet.push({ id: '53.15.07.2003', kecamatan: '53.15.07', name: 'Dunta' })
    dataSet.push({ id: '53.03.02.1026', kecamatan: '53.03.02', name: 'Eban' })
    dataSet.push({ id: '53.14.05.2008', kecamatan: '53.14.05', name: 'Edalode' })
    dataSet.push({ id: '53.07.09.2002', kecamatan: '53.07.09', name: 'Egon' })
    dataSet.push({ id: '53.07.21.2004', kecamatan: '53.07.21', name: 'Egon Gahar' })
    dataSet.push({ id: '53.20.03.2009', kecamatan: '53.20.03', name: 'Eiada' })
    dataSet.push({ id: '53.20.04.2009', kecamatan: '53.20.04', name: 'Eikare' })
    dataSet.push({ id: '53.20.02.2007', kecamatan: '53.20.02', name: 'Eilode' })
    dataSet.push({ id: '53.20.04.2005', kecamatan: '53.20.04', name: 'Eilogo' })
    dataSet.push({ id: '53.20.02.2005', kecamatan: '53.20.02', name: 'Eimadake' })
    dataSet.push({ id: '53.20.02.2008', kecamatan: '53.20.02', name: 'Eimau' })
    dataSet.push({ id: '53.18.10.2006', kecamatan: '53.18.10', name: 'Eka Pata' })
    dataSet.push({ id: '53.06.03.1011', kecamatan: '53.06.03', name: 'Ekasapta' })
    dataSet.push({ id: '53.01.10.2011', kecamatan: '53.01.10', name: 'Ekateta' })
    dataSet.push({ id: '53.04.18.2001', kecamatan: '53.04.18', name: 'Ekin' })
    dataSet.push({ id: '53.08.07.2011', kecamatan: '53.08.07', name: 'Ekoae' })
    dataSet.push({ id: '53.08.07.2022', kecamatan: '53.08.07', name: 'Ekolea' })
    dataSet.push({ id: '53.09.02.2037', kecamatan: '53.09.02', name: 'Ekoroka' })
    dataSet.push({ id: '53.05.05.2010', kecamatan: '53.05.05', name: 'Elok' })
    dataSet.push({ id: '53.17.05.2008', kecamatan: '53.17.05', name: 'Elu' })
    dataSet.push({ id: '53.12.04.2016', kecamatan: '53.12.04', name: 'Elu Loda' })
    dataSet.push({ id: '53.08.03.2034', kecamatan: '53.08.03', name: 'Embu Ngena' })
    dataSet.push({ id: '53.08.18.2009', kecamatan: '53.08.18', name: 'Embundoa' })
    dataSet.push({ id: '53.08.03.2014', kecamatan: '53.08.03', name: 'Emburia' })
    dataSet.push({ id: '53.08.03.2030', kecamatan: '53.08.03', name: 'Embutheru' })
    dataSet.push({ id: '53.08.01.2028', kecamatan: '53.08.01', name: 'Embuzozo' })
    dataSet.push({ id: '53.01.20.2009', kecamatan: '53.01.20', name: 'Enolanan' })
    dataSet.push({ id: '53.01.19.2004', kecamatan: '53.01.19', name: 'Enoraen' })
    dataSet.push({ id: '53.01.17.2008', kecamatan: '53.01.17', name: 'Erbaun' })
    dataSet.push({ id: '53.03.17.2001', kecamatan: '53.03.17', name: 'Faenake' })
    dataSet.push({ id: '53.03.19.2006', kecamatan: '53.03.19', name: 'Fafinesu' })
    dataSet.push({ id: '53.03.19.2001', kecamatan: '53.03.19', name: 'Fafinesu A' })
    dataSet.push({ id: '53.03.19.2002', kecamatan: '53.03.19', name: 'Fafinesu B' })
    dataSet.push({ id: '53.03.19.2003', kecamatan: '53.03.19', name: 'Fafinesu C' })
    dataSet.push({ id: '53.21.02.2003', kecamatan: '53.21.02', name: 'Fafoe' })
    dataSet.push({ id: '53.21.01.2011', kecamatan: '53.21.01', name: 'Fahiluka' })
    dataSet.push({ id: '53.14.06.2002', kecamatan: '53.14.06', name: 'Faifua' })
    dataSet.push({ id: '53.05.01.2013', kecamatan: '53.05.01', name: 'Fanating' })
    dataSet.push({ id: '53.09.06.1020', kecamatan: '53.09.06', name: 'Faobata' })
    dataSet.push({ id: '53.08.07.2008', kecamatan: '53.08.07', name: 'Fataatu' })
    dataSet.push({ id: '53.08.07.2009', kecamatan: '53.08.07', name: 'Fataatu Timur' })
    dataSet.push({ id: '53.08.12.2013', kecamatan: '53.08.12', name: 'Fatamari' })
    dataSet.push({ id: '53.14.05.2014', kecamatan: '53.14.05', name: 'Fatelilo' })
    dataSet.push({ id: '53.03.08.1024', kecamatan: '53.03.08', name: 'Fatoin' })
    dataSet.push({ id: '53.21.06.2006', kecamatan: '53.21.06', name: 'Fatoin' })
    dataSet.push({ id: '53.03.08.2026', kecamatan: '53.03.08', name: "Fatu'Ana" })
    dataSet.push({ id: '53.21.07.2004', kecamatan: '53.21.07', name: 'Fatuaruin' })
    dataSet.push({ id: '53.04.02.2006', kecamatan: '53.04.02', name: "Fatuba'a" })
    dataSet.push({ id: '53.04.12.1010', kecamatan: '53.04.12', name: 'Fatubenao' })
    dataSet.push({ id: '53.71.06.1008', kecamatan: '53.71.06', name: 'Fatubesi' })
    dataSet.push({ id: '53.71.01.1005', kecamatan: '53.71.01', name: 'Fatufeto' })
    dataSet.push({ id: '53.01.25.2001', kecamatan: '53.01.25', name: 'Fatukanutu' })
    dataSet.push({ id: '53.04.22.1004', kecamatan: '53.04.22', name: 'Fatukbot' })
    dataSet.push({ id: '53.04.05.2001', kecamatan: '53.04.05', name: 'Fatuketi' })
    dataSet.push({ id: '53.71.02.1006', kecamatan: '53.71.02', name: 'Fatukoa' })
    dataSet.push({ id: '53.01.11.2009', kecamatan: '53.01.11', name: 'Fatukona' })
    dataSet.push({ id: '53.04.17.2006', kecamatan: '53.04.17', name: 'Fatulotu' })
    dataSet.push({ id: '53.71.04.1011', kecamatan: '53.71.04', name: 'Fatululi' })
    dataSet.push({ id: '53.01.12.2004', kecamatan: '53.01.12', name: 'Fatumetan' })
    dataSet.push({ id: '53.01.30.2001', kecamatan: '53.01.30', name: 'Fatumonas' })
    dataSet.push({ id: '53.03.09.2006', kecamatan: '53.03.09', name: 'Fatumtasa' })
    dataSet.push({ id: '53.03.04.1014', kecamatan: '53.03.04', name: 'Fatumuti' })
    dataSet.push({ id: '53.01.13.2003', kecamatan: '53.01.13', name: 'Fatunaus' })
    dataSet.push({ id: '53.03.02.2002', kecamatan: '53.03.02', name: 'Fatuneno' })
    dataSet.push({ id: '53.03.02.2005', kecamatan: '53.03.02', name: 'Fatunisuan' })
    dataSet.push({ id: '53.04.13.2006', kecamatan: '53.04.13', name: 'Faturika' })
    dataSet.push({ id: '53.03.01.2019', kecamatan: '53.03.01', name: 'Fatusene' })
    dataSet.push({ id: '53.01.12.2001', kecamatan: '53.01.12', name: 'Fatusuki' })
    dataSet.push({ id: '53.03.02.2019', kecamatan: '53.03.02', name: 'Fatutasu' })
    dataSet.push({ id: '53.01.25.2005', kecamatan: '53.01.25', name: 'Fatuteta' })
    dataSet.push({ id: '53.01.22.2006', kecamatan: '53.01.22', name: 'Faumes' })
    dataSet.push({ id: '53.03.01.2024', kecamatan: '53.03.01', name: 'Femnasi' })
    dataSet.push({ id: '53.09.01.1003', kecamatan: '53.09.01', name: 'Foa' })
    dataSet.push({ id: '53.16.03.2023', kecamatan: '53.16.03', name: 'Focolodorawe' })
    dataSet.push({ id: '53.04.23.2003', kecamatan: '53.04.23', name: 'Fohoeka' })
    dataSet.push({ id: '53.71.05.1008', kecamatan: '53.71.05', name: 'Fontein' })
    dataSet.push({ id: '53.21.04.2008', kecamatan: '53.21.04', name: 'Forekmodok' })
    dataSet.push({ id: '53.14.01.2022', kecamatan: '53.14.01', name: 'Fuafuni' })
    dataSet.push({ id: '53.05.07.2008', kecamatan: '53.05.07', name: 'Fuisama' })
    dataSet.push({ id: '53.04.01.2002', kecamatan: '53.04.01', name: 'Fulur' })
    dataSet.push({ id: '53.05.07.2007', kecamatan: '53.05.07', name: 'Fungafeng' })
    dataSet.push({ id: '53.15.07.2007', kecamatan: '53.15.07', name: 'Galang' })
    dataSet.push({ id: '53.10.06.2025', kecamatan: '53.10.06', name: 'Gapong' })
    dataSet.push({ id: '53.10.05.2035', kecamatan: '53.10.05', name: 'Gara' })
    dataSet.push({ id: '53.12.18.2002', kecamatan: '53.12.18', name: 'Gaura' })
    dataSet.push({ id: '53.06.05.2020', kecamatan: '53.06.05', name: 'Gekengderan' })
    dataSet.push({ id: '53.07.10.2020', kecamatan: '53.07.10', name: 'Geliting' })
    dataSet.push({ id: '53.06.10.2019', kecamatan: '53.06.10', name: 'Gelong' })
    dataSet.push({ id: '53.10.15.2002', kecamatan: '53.10.15', name: 'Gelong' })
    dataSet.push({ id: '53.09.15.2008', kecamatan: '53.09.15', name: 'Genamere' })
    dataSet.push({ id: '53.07.02.2003', kecamatan: '53.07.02', name: 'Gera' })
    dataSet.push({ id: '53.16.03.2018', kecamatan: '53.16.03', name: 'Gerodhere' })
    dataSet.push({ id: '53.08.18.2004', kecamatan: '53.08.18', name: 'Gheoghoma' })
    dataSet.push({ id: '53.19.09.2004', kecamatan: '53.19.09', name: 'Gising' })
    dataSet.push({ id: '53.18.10.2013', kecamatan: '53.18.10', name: 'Gollu Sapi' })
    dataSet.push({ id: '53.10.06.2008', kecamatan: '53.10.06', name: 'Golo' })
    dataSet.push({ id: '53.15.05.2007', kecamatan: '53.15.05', name: 'Golo Bilas' })
    dataSet.push({ id: '53.15.08.2011', kecamatan: '53.15.08', name: 'Golo Bore' })
    dataSet.push({ id: '53.10.01.2006', kecamatan: '53.10.01', name: 'Golo Cador' })
    dataSet.push({ id: '53.15.10.2005', kecamatan: '53.15.10', name: 'Golo Damu' })
    dataSet.push({ id: '53.15.10.2008', kecamatan: '53.15.10', name: 'Golo Desat' })
    dataSet.push({ id: '53.10.12.1001', kecamatan: '53.10.12', name: 'Golo Dukal' })
    dataSet.push({ id: '53.19.01.2017', kecamatan: '53.19.01', name: 'Golo Kantar' })
    dataSet.push({ id: '53.15.08.2015', kecamatan: '53.15.08', name: 'Golo Keli' })
    dataSet.push({ id: '53.15.04.2005', kecamatan: '53.15.04', name: 'Golo Kempo' })
    dataSet.push({ id: '53.15.06.2002', kecamatan: '53.15.06', name: 'Golo Ketak' })
    dataSet.push({ id: '53.15.04.2026', kecamatan: '53.15.04', name: 'Golo Kondeng' })
    dataSet.push({ id: '53.15.11.2009', kecamatan: '53.15.11', name: 'Golo Lajang' })
    dataSet.push({ id: '53.15.11.2010', kecamatan: '53.15.11', name: 'Golo Lajang Barat' })
    dataSet.push({ id: '53.19.01.2014', kecamatan: '53.19.01', name: 'Golo Lalong' })
    dataSet.push({ id: '53.10.05.2031', kecamatan: '53.10.05', name: 'Golo Lambo' })
    dataSet.push({ id: '53.10.17.2004', kecamatan: '53.10.17', name: 'Golo Lanak' })
    dataSet.push({ id: '53.10.14.2008', kecamatan: '53.10.14', name: 'Golo Langkok' })
    dataSet.push({ id: '53.19.05.2004', kecamatan: '53.19.05', name: 'Golo Lebo' })
    dataSet.push({ id: '53.19.01.2032', kecamatan: '53.19.01', name: 'Golo Leda' })
    dataSet.push({ id: '53.15.04.2017', kecamatan: '53.15.04', name: 'Golo Leleng' })
    dataSet.push({ id: '53.19.03.2010', kecamatan: '53.19.03', name: 'Golo Lembur' })
    dataSet.push({ id: '53.19.08.2003', kecamatan: '53.19.08', name: 'Golo Lero' })
    dataSet.push({ id: '53.15.12.2001', kecamatan: '53.15.12', name: 'Golo Lewe' })
    dataSet.push({ id: '53.19.05.2005', kecamatan: '53.19.05', name: 'Golo Lijun' })
    dataSet.push({ id: '53.19.09.2010', kecamatan: '53.19.09', name: 'Golo Linus' })
    dataSet.push({ id: '53.19.02.2013', kecamatan: '53.19.02', name: 'Golo Lobos' })
    dataSet.push({ id: '53.19.07.2007', kecamatan: '53.19.07', name: 'Golo Loni' })
    dataSet.push({ id: '53.15.06.2008', kecamatan: '53.15.06', name: 'Golo Lujang' })
    dataSet.push({ id: '53.19.03.2007', kecamatan: '53.19.03', name: 'Golo Mangung' })
    dataSet.push({ id: '53.15.04.2008', kecamatan: '53.15.04', name: 'Golo Manting' })
    dataSet.push({ id: '53.15.04.2016', kecamatan: '53.15.04', name: 'Golo Mbu' })
    dataSet.push({ id: '53.19.07.2010', kecamatan: '53.19.07', name: 'Golo Meleng' })
    dataSet.push({ id: '53.10.01.2013', kecamatan: '53.10.01', name: 'Golo Mendo' })
    dataSet.push({ id: '53.19.06.2010', kecamatan: '53.19.06', name: 'Golo Meni' })
    dataSet.push({ id: '53.15.05.2004', kecamatan: '53.15.05', name: 'Golo Mori' })
    dataSet.push({ id: '53.19.05.2003', kecamatan: '53.19.05', name: 'Golo Munde' })
    dataSet.push({ id: '53.19.03.2004', kecamatan: '53.19.03', name: 'Golo Munga' })
    dataSet.push({ id: '53.19.03.2020', kecamatan: '53.19.03', name: 'Golo Munga Barat' })
    dataSet.push({ id: '53.10.05.2036', kecamatan: '53.10.05', name: 'Golo Muntas' })
    dataSet.push({ id: '53.10.06.2027', kecamatan: '53.10.06', name: 'Golo Ncuang' })
    dataSet.push({ id: '53.15.07.2019', kecamatan: '53.15.07', name: 'Golo Ndari' })
    dataSet.push({ id: '53.19.02.2026', kecamatan: '53.19.02', name: 'Golo Ndari' })
    dataSet.push({ id: '53.15.04.2001', kecamatan: '53.15.04', name: 'Golo Ndaring' })
    dataSet.push({ id: '53.19.06.2021', kecamatan: '53.19.06', name: 'Golo Ndele' })
    dataSet.push({ id: '53.19.02.2016', kecamatan: '53.19.02', name: 'Golo Nderu' })
    dataSet.push({ id: '53.19.06.2012', kecamatan: '53.19.06', name: 'Golo Nderu' })
    dataSet.push({ id: '53.15.03.2035', kecamatan: '53.15.03', name: 'Golo Ndeweng' })
    dataSet.push({ id: '53.15.10.2006', kecamatan: '53.15.10', name: 'Golo Ndoal' })
    dataSet.push({ id: '53.19.04.2004', kecamatan: '53.19.04', name: 'Golo Ngawan' })
    dataSet.push({ id: '53.19.03.2016', kecamatan: '53.19.03', name: 'Golo Nimbung' })
    dataSet.push({ id: '53.15.06.2020', kecamatan: '53.15.06', name: 'Golo Nobo' })
    dataSet.push({ id: '53.19.03.2023', kecamatan: '53.19.03', name: 'Golo Paleng' })
    dataSet.push({ id: '53.19.04.2015', kecamatan: '53.19.04', name: 'Golo Pari' })
    dataSet.push({ id: '53.15.08.2001', kecamatan: '53.15.08', name: 'Golo Poleng' })
    dataSet.push({ id: '53.15.05.2015', kecamatan: '53.15.05', name: 'Golo Pongkor' })
    dataSet.push({ id: '53.15.02.2032', kecamatan: '53.15.02', name: 'Golo Pua' })
    dataSet.push({ id: '53.19.02.2033', kecamatan: '53.19.02', name: 'Golo Rengket' })
    dataSet.push({ id: '53.19.03.2009', kecamatan: '53.19.03', name: 'Golo Rentung' })
    dataSet.push({ id: '53.15.12.2006', kecamatan: '53.15.12', name: 'Golo Riwu' })
    dataSet.push({ id: '53.15.07.2001', kecamatan: '53.15.07', name: 'Golo Ronggot' })
    dataSet.push({ id: '53.10.13.2012', kecamatan: '53.10.13', name: 'Golo Ropong' })
    dataSet.push({ id: '53.19.07.2004', kecamatan: '53.19.07', name: 'Golo Ros' })
    dataSet.push({ id: '53.15.08.2014', kecamatan: '53.15.08', name: "Golo Ru'a" })
    dataSet.push({ id: '53.15.02.1022', kecamatan: '53.15.02', name: "Golo Ru'u" })
    dataSet.push({ id: '53.19.07.2009', kecamatan: '53.19.07', name: 'Golo Rutuk' })
    dataSet.push({ id: '53.15.10.2007', kecamatan: '53.15.10', name: 'Golo Sembea' })
    dataSet.push({ id: '53.15.04.2024', kecamatan: '53.15.04', name: 'Golo Sengang' })
    dataSet.push({ id: '53.15.06.2005', kecamatan: '53.15.06', name: 'Golo Sepang' })
    dataSet.push({ id: '53.15.10.2011', kecamatan: '53.15.10', name: 'Golo Tantong' })
    dataSet.push({ id: '53.19.06.2005', kecamatan: '53.19.06', name: 'Golo Tolang' })
    dataSet.push({ id: '53.19.04.1010', kecamatan: '53.19.04', name: 'Golo Wangkung' })
    dataSet.push({ id: '53.19.04.1019', kecamatan: '53.19.04', name: 'Golo Wangkung Barat' })
    dataSet.push({ id: '53.19.04.1020', kecamatan: '53.19.04', name: 'Golo Wangkung Utara' })
    dataSet.push({ id: '53.10.01.2017', kecamatan: '53.10.01', name: 'Golo Watu' })
    dataSet.push({ id: '53.15.12.2009', kecamatan: '53.15.12', name: 'Golo Wedong' })
    dataSet.push({ id: '53.10.17.2003', kecamatan: '53.10.17', name: 'Golo Woi' })
    dataSet.push({ id: '53.19.03.2022', kecamatan: '53.19.03', name: 'Golo Wontong' })
    dataSet.push({ id: '53.10.03.2019', kecamatan: '53.10.03', name: 'Golo Worok' })
    dataSet.push({ id: '53.10.01.2014', kecamatan: '53.10.01', name: 'Golo Wuas' })
    dataSet.push({ id: '53.19.09.2007', kecamatan: '53.19.09', name: 'Golo Wuas' })
    dataSet.push({ id: '53.19.02.2030', kecamatan: '53.19.02', name: 'Golo Wune' })
    dataSet.push({ id: '53.08.06.2021', kecamatan: '53.08.06', name: 'Golulada' })
    dataSet.push({ id: '53.19.03.2003', kecamatan: '53.19.03', name: 'Goreng Meni' })
    dataSet.push({ id: '53.19.03.2021', kecamatan: '53.19.03', name: 'Goreng Meni Utara' })
    dataSet.push({ id: '53.15.05.2020', kecamatan: '53.15.05', name: 'Gorontalo' })
    dataSet.push({ id: '53.10.18.2003', kecamatan: '53.10.18', name: 'Gulung' })
    dataSet.push({ id: '53.19.06.2008', kecamatan: '53.19.06', name: 'Gunung' })
    dataSet.push({ id: '53.19.06.2022', kecamatan: '53.19.06', name: 'Gunung Baru' })
    dataSet.push({ id: '53.07.05.2016', kecamatan: '53.07.05', name: 'Gunung Sari' })
    dataSet.push({ id: '53.20.05.2009', kecamatan: '53.20.05', name: 'Gurimonearu' })
    dataSet.push({ id: '53.15.07.2004', kecamatan: '53.15.07', name: 'Gurung' })
    dataSet.push({ id: '53.19.01.2004', kecamatan: '53.19.01', name: 'Gurung Liwut' })
    dataSet.push({ id: '53.19.02.2018', kecamatan: '53.19.02', name: 'Gurung Turi' })
    dataSet.push({ id: '53.07.19.2008', kecamatan: '53.07.19', name: 'Habi' })
    dataSet.push({ id: '53.11.11.2002', kecamatan: '53.11.11', name: 'Hadakamali' })
    dataSet.push({ id: '53.13.04.2001', kecamatan: '53.13.04', name: 'Hadakewa' })
    dataSet.push({ id: '53.03.10.2002', kecamatan: '53.03.10', name: 'Haekto' })
    dataSet.push({ id: '53.11.09.2003', kecamatan: '53.11.09', name: 'Haikatapu' })
    dataSet.push({ id: '53.21.04.2002', kecamatan: '53.21.04', name: 'Haitimuk' })
    dataSet.push({ id: '53.19.05.2015', kecamatan: '53.19.05', name: 'Haju Ngendong' })
    dataSet.push({ id: '53.19.03.2019', kecamatan: '53.19.03', name: 'Haju Wangi' })
    dataSet.push({ id: '53.06.04.2007', kecamatan: '53.06.04', name: 'Halakodanuan' })
    dataSet.push({ id: '53.07.21.2001', kecamatan: '53.07.21', name: 'Hale' })
    dataSet.push({ id: '53.05.03.2010', kecamatan: '53.05.03', name: 'Halerman' })
    dataSet.push({ id: '53.21.03.2001', kecamatan: '53.21.03', name: 'Halibasar' })
    dataSet.push({ id: '53.21.04.2012', kecamatan: '53.21.04', name: 'Haliklaran' })
    dataSet.push({ id: '53.04.02.2019', kecamatan: '53.04.02', name: 'Halimodok' })
    dataSet.push({ id: '53.20.04.2011', kecamatan: '53.20.04', name: 'Halla Paji' })
    dataSet.push({ id: '53.11.01.1002', kecamatan: '53.11.01', name: 'Hambala' })
    dataSet.push({ id: '53.11.20.2003', kecamatan: '53.11.20', name: 'Hambapraing' })
    dataSet.push({ id: '53.11.21.2003', kecamatan: '53.11.21', name: 'Hambawutang' })
    dataSet.push({ id: '53.18.08.2018', kecamatan: '53.18.08', name: 'Hameli Ate' })
    dataSet.push({ id: '53.18.07.2003', kecamatan: '53.18.07', name: 'Hamonggo Lele' })
    dataSet.push({ id: '53.08.13.2007', kecamatan: '53.08.13', name: 'Hangalande' })
    dataSet.push({ id: '53.11.09.2005', kecamatan: '53.11.09', name: 'Hanggaroru' })
    dataSet.push({ id: '53.01.04.2008', kecamatan: '53.01.04', name: 'Hansisi' })
    dataSet.push({ id: '53.11.22.2006', kecamatan: '53.11.22', name: 'Haray' })
    dataSet.push({ id: '53.21.01.2013', kecamatan: '53.21.01', name: 'Harekakae' })
    dataSet.push({ id: '53.12.18.2004', kecamatan: '53.12.18', name: 'Harona Kalla' })
    dataSet.push({ id: '53.06.13.2014', kecamatan: '53.06.13', name: 'Harubala' })
    dataSet.push({ id: '53.03.02.2006', kecamatan: '53.03.02', name: 'Haulasi' })
    dataSet.push({ id: '53.03.17.2008', kecamatan: '53.03.17', name: 'Haumeni' })
    dataSet.push({ id: '53.03.16.2004', kecamatan: '53.03.16', name: 'Haumeni Ana' })
    dataSet.push({ id: '53.03.06.2002', kecamatan: '53.03.06', name: 'Hautaes' })
    dataSet.push({ id: '53.03.06.2014', kecamatan: '53.03.06', name: 'Hauteas Barat' })
    dataSet.push({ id: '53.09.01.2018', kecamatan: '53.09.01', name: 'Heawea' })
    dataSet.push({ id: '53.07.21.2002', kecamatan: '53.07.21', name: 'Hebing' })
    dataSet.push({ id: '53.05.06.2012', kecamatan: '53.05.06', name: 'Helangdohi' })
    dataSet.push({ id: '53.06.13.2006', kecamatan: '53.06.13', name: 'Helanlangowuyo' })
    dataSet.push({ id: '53.14.03.2005', kecamatan: '53.14.03', name: 'Helebeik' })
    dataSet.push({ id: '53.04.18.2005', kecamatan: '53.04.18', name: 'Henes' })
    dataSet.push({ id: '53.07.18.2006', kecamatan: '53.07.18', name: 'Heopuat' })
    dataSet.push({ id: '53.07.03.2007', kecamatan: '53.07.03', name: 'Hepang' })
    dataSet.push({ id: '53.06.01.2002', kecamatan: '53.06.01', name: 'Hewa' })
    dataSet.push({ id: '53.07.18.2005', kecamatan: '53.07.18', name: 'Hewokloang' })
    dataSet.push({ id: '53.07.14.1001', kecamatan: '53.07.14', name: 'Hewuli' })
    dataSet.push({ id: '53.07.08.2003', kecamatan: '53.07.08', name: 'Hikong' })
    dataSet.push({ id: '53.10.13.2002', kecamatan: '53.10.13', name: 'Hilihintir' })
    dataSet.push({ id: '53.06.11.2003', kecamatan: '53.06.11', name: 'Hinga' })
    dataSet.push({ id: '53.13.06.2008', kecamatan: '53.13.06', name: 'Hingalamamengi' })
    dataSet.push({ id: '53.12.11.2004', kecamatan: '53.12.11', name: 'Hoba Wawi' })
    dataSet.push({ id: '53.08.12.2002', kecamatan: '53.08.12', name: 'Hobatua' })
    dataSet.push({ id: '53.07.09.2006', kecamatan: '53.07.09', name: 'Hoder' })
    dataSet.push({ id: '53.13.06.2010', kecamatan: '53.13.06', name: 'Hoelea I' })
    dataSet.push({ id: '53.13.06.2016', kecamatan: '53.13.06', name: 'Hoelea II' })
    dataSet.push({ id: '53.18.08.2001', kecamatan: '53.18.08', name: 'Hoha Wungo' })
    dataSet.push({ id: '53.06.01.2012', kecamatan: '53.06.01', name: 'Hokeng Jaya' })
    dataSet.push({ id: '53.06.18.2011', kecamatan: '53.06.18', name: 'Hoko Horowura' })
    dataSet.push({ id: '53.07.11.2001', kecamatan: '53.07.11', name: 'Hokor' })
    dataSet.push({ id: '53.14.03.2007', kecamatan: '53.14.03', name: 'Holoama' })
    dataSet.push({ id: '53.14.02.2018', kecamatan: '53.14.02', name: 'Holulai' })
    dataSet.push({ id: '53.17.02.2026', kecamatan: '53.17.02', name: 'Holur Kambata' })
    dataSet.push({ id: '53.06.08.2021', kecamatan: '53.06.08', name: 'Homa' })
    dataSet.push({ id: '53.18.08.2002', kecamatan: '53.18.08', name: 'Homba Karipit' })
    dataSet.push({ id: '53.18.08.2013', kecamatan: '53.18.08', name: 'Homba Pare' })
    dataSet.push({ id: '53.18.07.2004', kecamatan: '53.18.07', name: 'Homba Rande' })
    dataSet.push({ id: '53.18.07.2015', kecamatan: '53.18.07', name: 'Homba Rica' })
    dataSet.push({ id: '53.01.22.2005', kecamatan: '53.01.22', name: 'Honuk' })
    dataSet.push({ id: '53.06.11.2008', kecamatan: '53.06.11', name: 'Horinara' })
    dataSet.push({ id: '53.06.18.2001', kecamatan: '53.06.18', name: 'Horowura' })
    dataSet.push({ id: '53.01.11.2003', kecamatan: '53.01.11', name: 'Hueknutu' })
    dataSet.push({ id: '53.01.04.2009', kecamatan: '53.01.04', name: 'Huilelot' })
    dataSet.push({ id: '53.05.02.2020', kecamatan: '53.05.02', name: 'Hulnani' })
    dataSet.push({ id: '53.03.09.1010', kecamatan: '53.03.09', name: 'Humusu C' })
    dataSet.push({ id: '53.03.09.2009', kecamatan: '53.03.09', name: 'Humusu Oekolo' })
    dataSet.push({ id: '53.03.09.2008', kecamatan: '53.03.09', name: 'Humusu Sainiup' })
    dataSet.push({ id: '53.14.06.2003', kecamatan: '53.14.06', name: 'Hundihopo' })
    dataSet.push({ id: '53.14.02.2019', kecamatan: '53.14.02', name: 'Hundihuk' })
    dataSet.push({ id: '53.12.11.2002', kecamatan: '53.12.11', name: 'Hupu Mada' })
    dataSet.push({ id: '53.06.08.2017', kecamatan: '53.06.08', name: 'Hurung' })
    dataSet.push({ id: '53.20.03.2008', kecamatan: '53.20.03', name: 'Huwaga' })
    dataSet.push({ id: '53.07.10.2009', kecamatan: '53.07.10', name: 'Iantena' })
    dataSet.push({ id: '53.13.01.2016', kecamatan: '53.13.01', name: 'Idalolong' })
    dataSet.push({ id: '53.21.06.2007', kecamatan: '53.21.06', name: 'Ikan Tuanbeis' })
    dataSet.push({ id: '53.06.02.2010', kecamatan: '53.06.02', name: 'Ile Gerong' })
    dataSet.push({ id: '53.13.02.2010', kecamatan: '53.13.02', name: 'Ile Kerbau' })
    dataSet.push({ id: '53.13.02.2008', kecamatan: '53.13.02', name: 'Ile Kimok' })
    dataSet.push({ id: '53.06.15.2001', kecamatan: '53.06.15', name: 'Ile Padung' })
    dataSet.push({ id: '53.06.08.2014', kecamatan: '53.06.08', name: 'Ile Pati' })
    dataSet.push({ id: '53.13.01.2006', kecamatan: '53.13.01', name: 'Ileboli' })
    dataSet.push({ id: '53.07.03.2006', kecamatan: '53.07.03', name: 'Iligai' })
    dataSet.push({ id: '53.07.13.2006', kecamatan: '53.07.13', name: 'Ilinmedo' })
    dataSet.push({ id: '53.05.09.2020', kecamatan: '53.05.09', name: 'Illu' })
    dataSet.push({ id: '53.13.08.2006', kecamatan: '53.13.08', name: 'Imu Lolong' })
    dataSet.push({ id: '53.14.08.2005', kecamatan: '53.14.08', name: 'Inaoe' })
    dataSet.push({ id: '53.03.16.2001', kecamatan: '53.03.16', name: 'Inbate' })
    dataSet.push({ id: '53.09.15.2003', kecamatan: '53.09.15', name: 'Inegena' })
    dataSet.push({ id: '53.09.15.2002', kecamatan: '53.09.15', name: 'Inelika' })
    dataSet.push({ id: '53.09.20.2003', kecamatan: '53.09.20', name: 'Inerie' })
    dataSet.push({ id: '53.14.02.2012', kecamatan: '53.14.02', name: 'Ingguinak' })
    dataSet.push({ id: '53.06.10.2015', kecamatan: '53.06.10', name: 'Ipi Ebang' })
    dataSet.push({ id: '53.07.11.2006', kecamatan: '53.07.11', name: 'Ipir' })
    dataSet.push({ id: '53.10.05.2039', kecamatan: '53.10.05', name: 'Iteng' })
    dataSet.push({ id: '53.08.03.2013', kecamatan: '53.08.03', name: 'Ja Moke Asa' })
    dataSet.push({ id: '53.03.01.2021', kecamatan: '53.03.01', name: 'Jak' })
    dataSet.push({ id: '53.11.13.2006', kecamatan: '53.11.13', name: 'Janggamangu' })
    dataSet.push({ id: '53.10.05.2003', kecamatan: '53.10.05', name: 'Jaong' })
    dataSet.push({ id: '53.09.06.1016', kecamatan: '53.09.06', name: 'Jawameze' })
    dataSet.push({ id: '53.16.04.2009', kecamatan: '53.16.04', name: 'Jawapogo' })
    dataSet.push({ id: '53.08.01.2017', kecamatan: '53.08.01', name: 'Jegharangga' })
    dataSet.push({ id: '53.08.03.2025', kecamatan: '53.08.03', name: 'Jejaraja' })
    dataSet.push({ id: '53.08.01.2027', kecamatan: '53.08.01', name: 'Jemburea' })
    dataSet.push({ id: '53.04.05.2003', kecamatan: '53.04.05', name: 'Jenilu' })
    dataSet.push({ id: '53.08.15.2014', kecamatan: '53.08.15', name: "Jeo Du'a" })
    dataSet.push({ id: '53.20.02.2006', kecamatan: '53.20.02', name: 'Jiwuwu' })
    dataSet.push({ id: '53.13.09.2002', kecamatan: '53.13.09', name: 'Jontona' })
    dataSet.push({ id: '53.08.08.2012', kecamatan: '53.08.08', name: 'Jopu' })
    dataSet.push({ id: '53.18.04.2004', kecamatan: '53.18.04', name: 'Kabali Dana' })
    dataSet.push({ id: '53.11.21.2004', kecamatan: '53.11.21', name: 'Kabanda' })
    dataSet.push({ id: '53.11.09.2004', kecamatan: '53.11.09', name: 'Kabaru' })
    dataSet.push({ id: '53.17.01.2003', kecamatan: '53.17.01', name: 'Kabela Wuntu' })
    dataSet.push({ id: '53.05.06.1001', kecamatan: '53.05.06', name: 'Kabir' })
    dataSet.push({ id: '53.05.10.1001', kecamatan: '53.05.10', name: 'Kabola' })
    dataSet.push({ id: '53.07.05.1008', kecamatan: '53.07.05', name: 'Kabor' })
    dataSet.push({ id: '53.12.12.2008', kecamatan: '53.12.12', name: 'Kabu Karudi' })
    dataSet.push({ id: '53.04.05.2006', kecamatan: '53.04.05', name: 'Kabuna' })
    dataSet.push({ id: '53.18.08.2017', kecamatan: '53.18.08', name: 'Kadaghu Tana' })
    dataSet.push({ id: '53.11.02.2008', kecamatan: '53.11.02', name: 'Kadahang' })
    dataSet.push({ id: '53.18.09.2007', kecamatan: '53.18.09', name: 'Kadi Pada' })
    dataSet.push({ id: '53.18.10.2015', kecamatan: '53.18.10', name: 'Kadi Roma' })
    dataSet.push({ id: '53.18.03.2022', kecamatan: '53.18.03', name: 'Kadi Wano' })
    dataSet.push({ id: '53.18.03.2029', kecamatan: '53.18.03', name: 'Kadi Wone' })
    dataSet.push({ id: '53.18.07.2018', kecamatan: '53.18.07', name: 'Kadoki Horo' })
    dataSet.push({ id: '53.18.08.2016', kecamatan: '53.18.08', name: 'Kadu Eta' })
    dataSet.push({ id: '53.11.07.2008', kecamatan: '53.11.07', name: 'Kadumbul' })
    dataSet.push({ id: '53.02.28.2003', kecamatan: '53.02.28', name: 'Kaeneno' })
    dataSet.push({ id: '53.05.14.2004', kecamatan: '53.05.14', name: 'Kaera' })
    dataSet.push({ id: '53.05.07.2010', kecamatan: '53.05.07', name: 'Kafakbeka' })
    dataSet.push({ id: '53.05.03.2013', kecamatan: '53.05.03', name: 'Kafelulang' })
    dataSet.push({ id: '53.18.11.2002', kecamatan: '53.18.11', name: 'Kahale' })
    dataSet.push({ id: '53.11.04.2004', kecamatan: '53.11.04', name: 'Kahiri' })
    dataSet.push({ id: '53.05.13.2003', kecamatan: '53.05.13', name: 'Kailesa' })
    dataSet.push({ id: '53.01.25.2002', kecamatan: '53.01.25', name: 'Kairane' })
    dataSet.push({ id: '53.10.16.2001', kecamatan: '53.10.16', name: 'Kajong' })
    dataSet.push({ id: '53.07.18.2004', kecamatan: '53.07.18', name: 'Kajowair' })
    dataSet.push({ id: '53.19.05.2028', kecamatan: '53.19.05', name: 'Kaju Wangi' })
    dataSet.push({ id: '53.11.21.2002', kecamatan: '53.11.21', name: 'Kakaha' })
    dataSet.push({ id: '53.21.01.2002', kecamatan: '53.21.01', name: 'Kakaniuk' })
    dataSet.push({ id: '53.10.03.2003', kecamatan: '53.10.03', name: 'Kakor' })
    dataSet.push({ id: '53.15.09.2005', kecamatan: '53.15.09', name: 'Kakor' })
    dataSet.push({ id: '53.05.01.1001', kecamatan: '53.05.01', name: 'Kalabahi Barat' })
    dataSet.push({ id: '53.05.01.1002', kecamatan: '53.05.01', name: 'Kalabahi Kota' })
    dataSet.push({ id: '53.05.01.1003', kecamatan: '53.05.01', name: 'Kalabahi Tengah' })
    dataSet.push({ id: '53.05.01.1004', kecamatan: '53.05.01', name: 'Kalabahi Timur' })
    dataSet.push({ id: '53.18.04.2015', kecamatan: '53.18.04', name: 'Kalaki Kambe' })
    dataSet.push({ id: '53.01.27.2003', kecamatan: '53.01.27', name: 'Kalali' })
    dataSet.push({ id: '53.11.02.2012', kecamatan: '53.11.02', name: 'Kalamba' })
    dataSet.push({ id: '53.05.14.2002', kecamatan: '53.05.14', name: 'Kaleb' })
    dataSet.push({ id: '53.12.04.2017', kecamatan: '53.12.04', name: 'Kalebu Ana Kaka' })
    dataSet.push({ id: '53.06.06.2004', kecamatan: '53.06.06', name: 'Kalelu' })
    dataSet.push({ id: '53.18.09.2010', kecamatan: '53.18.09', name: 'Kalembu Kaha' })
    dataSet.push({ id: '53.18.04.2016', kecamatan: '53.18.04', name: 'Kalembu Kanaika' })
    dataSet.push({ id: '53.12.15.2007', kecamatan: '53.12.15', name: 'Kalembu Kuni' })
    dataSet.push({ id: '53.18.03.2001', kecamatan: '53.18.03', name: 'Kalembu Ndara Mane' })
    dataSet.push({ id: '53.18.04.2002', kecamatan: '53.18.04', name: 'Kalembu Weri' })
    dataSet.push({ id: '53.18.08.2005', kecamatan: '53.18.08', name: 'Kalena Rongo' })
    dataSet.push({ id: '53.18.09.2002', kecamatan: '53.18.09', name: 'Kalena Wano' })
    dataSet.push({ id: '53.13.07.2014', kecamatan: '53.13.07', name: 'Kalikur' })
    dataSet.push({ id: '53.13.07.2008', kecamatan: '53.13.07', name: 'Kalikur WL.' })
    dataSet.push({ id: '53.18.04.2008', kecamatan: '53.18.04', name: 'Kalimbu Tillu' })
    dataSet.push({ id: '53.18.10.2009', kecamatan: '53.18.10', name: 'Kalingara' })
    dataSet.push({ id: '53.08.07.2017', kecamatan: '53.08.07', name: 'Kalitembu' })
    dataSet.push({ id: '53.11.10.2001', kecamatan: '53.11.10', name: 'Kaliuda' })
    dataSet.push({ id: '53.05.09.2003', kecamatan: '53.05.09', name: 'Kalondama' })
    dataSet.push({ id: '53.05.17.2006', kecamatan: '53.05.17', name: 'Kalondama Barat' })
    dataSet.push({ id: '53.05.17.2007', kecamatan: '53.05.17', name: 'Kalondama Tengah' })
    dataSet.push({ id: '53.05.12.2005', kecamatan: '53.05.12', name: 'Kamaifui' })
    dataSet.push({ id: '53.11.01.1004', kecamatan: '53.11.01', name: 'Kamalaputi' })
    dataSet.push({ id: '53.21.01.2005', kecamatan: '53.21.01', name: 'Kamanasa' })
    dataSet.push({ id: '53.11.14.2001', kecamatan: '53.11.14', name: 'Kamanggih' })
    dataSet.push({ id: '53.11.01.1001', kecamatan: '53.11.01', name: 'Kambajawa' })
    dataSet.push({ id: '53.11.16.1003', kecamatan: '53.11.16', name: 'Kambaniru' })
    dataSet.push({ id: '53.11.03.2003', kecamatan: '53.11.03', name: 'Kambata Wundut' })
    dataSet.push({ id: '53.11.07.2003', kecamatan: '53.11.07', name: 'Kambatatana' })
    dataSet.push({ id: '53.11.03.2002', kecamatan: '53.11.03', name: 'Kambuhapang' })
    dataSet.push({ id: '53.05.08.2003', kecamatan: '53.05.08', name: 'Kamot' })
    dataSet.push({ id: '53.12.15.1003', kecamatan: '53.12.15', name: 'Kampung Baru' })
    dataSet.push({ id: '53.12.15.1004', kecamatan: '53.12.15', name: 'Kampung Sawah' })
    dataSet.push({ id: '53.08.11.2003', kecamatan: '53.08.11', name: 'Kamubheka' })
    dataSet.push({ id: '53.11.12.2001', kecamatan: '53.11.12', name: 'Kananggar' })
    dataSet.push({ id: '53.18.10.2001', kecamatan: '53.18.10', name: 'Kanelu' })
    dataSet.push({ id: '53.08.15.2009', kecamatan: '53.08.15', name: 'Kanganara' })
    dataSet.push({ id: '53.11.18.2005', kecamatan: '53.11.18', name: 'Kangeli' })
    dataSet.push({ id: '53.13.07.2007', kecamatan: '53.13.07', name: 'Kaohua' })
    dataSet.push({ id: '53.18.07.2008', kecamatan: '53.18.07', name: 'Kapaka Madeta' })
    dataSet.push({ id: '53.21.08.2003', kecamatan: '53.21.08', name: 'Kapitan Meo' })
    dataSet.push({ id: '53.12.04.2006', kecamatan: '53.12.04', name: 'Karaka Nduku' })
    dataSet.push({ id: '53.18.06.2019', kecamatan: '53.18.06', name: 'Karang Indah' })
    dataSet.push({ id: '53.06.06.2013', kecamatan: '53.06.06', name: 'Karawatung' })
    dataSet.push({ id: '53.12.04.2014', kecamatan: '53.12.04', name: 'Kareka Nduku Selatan' })
    dataSet.push({ id: '53.12.04.2013', kecamatan: '53.12.04', name: 'Kareka Nduku Utara' })
    dataSet.push({ id: '53.11.12.2003', kecamatan: '53.11.12', name: 'Karera Jangga' })
    dataSet.push({ id: '53.06.10.2009', kecamatan: '53.06.10', name: 'Karinglamalouk' })
    dataSet.push({ id: '53.11.15.2003', kecamatan: '53.11.15', name: 'Karipi' })
    dataSet.push({ id: '53.11.05.2002', kecamatan: '53.11.05', name: 'Karita' })
    dataSet.push({ id: '53.10.12.1003', kecamatan: '53.10.12', name: 'Karot' })
    dataSet.push({ id: '53.18.01.2003', kecamatan: '53.18.01', name: 'Karuni' })
    dataSet.push({ id: '53.15.08.2004', kecamatan: '53.15.08', name: 'Kasong' })
    dataSet.push({ id: '53.11.14.2007', kecamatan: '53.11.14', name: 'Kataka' })
    dataSet.push({ id: '53.13.02.2009', kecamatan: '53.13.02', name: 'Katakeja' })
    dataSet.push({ id: '53.21.01.2003', kecamatan: '53.21.01', name: 'Kateri' })
    dataSet.push({ id: '53.12.11.2001', kecamatan: '53.12.11', name: 'Katiku Loku' })
    dataSet.push({ id: '53.11.15.2006', kecamatan: '53.11.15', name: 'Katiku Luku' })
    dataSet.push({ id: '53.11.15.2005', kecamatan: '53.11.15', name: 'Katiku Wai' })
    dataSet.push({ id: '53.11.15.2002', kecamatan: '53.11.15', name: 'Katikutana' })
    dataSet.push({ id: '53.03.23.2005', kecamatan: '53.03.23', name: 'Kaubele' })
    dataSet.push({ id: '53.01.11.2006', kecamatan: '53.01.11', name: 'Kauniki' })
    dataSet.push({ id: '53.06.14.2005', kecamatan: '53.06.14', name: 'Kawalelo' })
    dataSet.push({ id: '53.18.07.2009', kecamatan: '53.18.07', name: 'Kawango Hari' })
    dataSet.push({ id: '53.11.07.1001', kecamatan: '53.11.07', name: 'Kawangu' })
    dataSet.push({ id: '53.06.09.2005', kecamatan: '53.06.09', name: 'Kawela' })
    dataSet.push({ id: '53.06.07.2019', kecamatan: '53.06.07', name: 'Kawuta' })
    dataSet.push({ id: '53.05.17.2001', kecamatan: '53.05.17', name: 'Kayang' })
    dataSet.push({ id: '53.71.04.1013', kecamatan: '53.71.04', name: 'Kayu Putih' })
    dataSet.push({ id: '53.11.09.2008', kecamatan: '53.11.09', name: 'Kayuri' })
    dataSet.push({ id: '53.08.02.2008', kecamatan: '53.08.02', name: 'Kazo Kapo' })
    dataSet.push({ id: '53.03.01.2007', kecamatan: '53.03.01', name: 'Keanbaun' })
    dataSet.push({ id: '53.08.15.2003', kecamatan: '53.08.15', name: 'Kebesani' })
    dataSet.push({ id: '53.08.11.2001', kecamatan: '53.08.11', name: 'Kebirangga' })
    dataSet.push({ id: '53.08.11.2002', kecamatan: '53.08.11', name: 'Kebirangga Selatan' })
    dataSet.push({ id: '53.08.11.2010', kecamatan: '53.08.11', name: 'Kebirangga Tengah' })
    dataSet.push({ id: '53.08.20.2003', kecamatan: '53.08.20', name: 'Kedebodu' })
    dataSet.push({ id: '53.20.03.2005', kecamatan: '53.20.03', name: 'Keduru' })
    dataSet.push({ id: '53.03.05.1006', kecamatan: '53.03.05', name: 'Kefamenanu Selatan' })
    dataSet.push({ id: '53.03.05.1003', kecamatan: '53.03.05', name: 'Kefamenanu Tengah' })
    dataSet.push({ id: '53.03.05.1001', kecamatan: '53.03.05', name: 'Kefamenanu Utara' })
    dataSet.push({ id: '53.08.01.2024', kecamatan: '53.08.01', name: 'Kekandere' })
    dataSet.push({ id: '53.08.05.2014', kecamatan: '53.08.05', name: 'Kekasewa' })
    dataSet.push({ id: '53.05.04.2002', kecamatan: '53.05.04', name: 'Kelaisi Barat' })
    dataSet.push({ id: '53.05.04.2007', kecamatan: '53.05.04', name: 'Kelaisi Tengah' })
    dataSet.push({ id: '53.05.04.1001', kecamatan: '53.05.04', name: 'Kelaisi Timur' })
    dataSet.push({ id: '53.71.03.1001', kecamatan: '53.71.03', name: 'Kelapa Lima' })
    dataSet.push({ id: '53.16.03.2010', kecamatan: '53.16.03', name: 'Kelewae' })
    dataSet.push({ id: '53.16.06.2011', kecamatan: '53.16.06', name: 'Keli' })
    dataSet.push({ id: '53.19.03.2017', kecamatan: '53.19.03', name: 'Keli' })
    dataSet.push({ id: '53.09.01.2001', kecamatan: '53.09.01', name: 'Keligejo' })
    dataSet.push({ id: '53.20.03.2010', kecamatan: '53.20.03', name: 'Keliha' })
    dataSet.push({ id: '53.06.19.2001', kecamatan: '53.06.19', name: 'Kelike' })
    dataSet.push({ id: '53.06.19.2002', kecamatan: '53.06.19', name: 'Kelike Aimatan' })
    dataSet.push({ id: '53.08.05.2018', kecamatan: '53.08.05', name: 'Kelikiku' })
    dataSet.push({ id: '53.16.03.2012', kecamatan: '53.16.03', name: 'Kelimado' })
    dataSet.push({ id: '53.08.19.1003', kecamatan: '53.08.19', name: 'Kelimutu' })
    dataSet.push({ id: '53.08.17.2005', kecamatan: '53.08.17', name: 'Kelisamba' })
    dataSet.push({ id: '53.09.20.2006', kecamatan: '53.09.20', name: 'Kelitei' })
    dataSet.push({ id: '53.16.04.2019', kecamatan: '53.16.04', name: 'Keliwatulewa' })
    dataSet.push({ id: '53.08.10.2009', kecamatan: '53.08.10', name: 'Keliwumbu' })
    dataSet.push({ id: '53.06.11.2019', kecamatan: '53.06.11', name: 'Keluwain' })
    dataSet.push({ id: '53.19.04.2013', kecamatan: '53.19.04', name: 'Kembang Mekar' })
    dataSet.push({ id: '53.15.10.2009', kecamatan: '53.15.10', name: 'Kempo' })
    dataSet.push({ id: '53.05.08.2007', kecamatan: '53.05.08', name: 'Kenarimbala' })
    dataSet.push({ id: '53.18.08.2009', kecamatan: '53.18.08', name: 'Kendu Wela' })
    dataSet.push({ id: '53.04.05.2004', kecamatan: '53.04.05', name: 'Kenebibi' })
    dataSet.push({ id: '53.06.19.2004', kecamatan: '53.06.19', name: 'Kenere' })
    dataSet.push({ id: '53.06.18.2004', kecamatan: '53.06.18', name: 'Kenotan' })
    dataSet.push({ id: '53.10.06.2014', kecamatan: '53.10.06', name: 'Kentol' })
    dataSet.push({ id: '53.14.05.2007', kecamatan: '53.14.05', name: 'Keoen' })
    dataSet.push({ id: '53.21.12.2002', kecamatan: '53.21.12', name: 'Kereana' })
    dataSet.push({ id: '53.08.01.2005', kecamatan: '53.08.01', name: 'Kerirea' })
    dataSet.push({ id: '53.10.15.2004', kecamatan: '53.10.15', name: 'Ketang' })
    dataSet.push({ id: '53.03.08.2025', kecamatan: '53.03.08', name: 'Keun' })
    dataSet.push({ id: '53.04.01.2001', kecamatan: '53.04.01', name: 'Kewar' })
    dataSet.push({ id: '53.09.18.2007', kecamatan: '53.09.18', name: 'Kezewea' })
    dataSet.push({ id: '53.01.26.2002', kecamatan: '53.01.26', name: 'Kifu' })
    dataSet.push({ id: '53.18.10.2019', kecamatan: '53.18.10', name: 'Kiku Booko' })
    dataSet.push({ id: '53.09.01.2022', kecamatan: '53.09.01', name: 'Kila' })
    dataSet.push({ id: '53.06.08.2026', kecamatan: '53.06.08', name: 'Kimakamak' })
    dataSet.push({ id: '53.05.04.2008', kecamatan: '53.05.04', name: 'Kiraman' })
    dataSet.push({ id: '53.11.16.2008', kecamatan: '53.11.16', name: 'Kiritana' })
    dataSet.push({ id: '53.09.06.1015', kecamatan: '53.09.06', name: 'Kisanata' })
    dataSet.push({ id: '53.03.04.1015', kecamatan: '53.03.04', name: 'Kiuola' })
    dataSet.push({ id: '53.01.10.2015', kecamatan: '53.01.10', name: 'Kiuoni' })
    dataSet.push({ id: '53.03.14.2002', kecamatan: '53.03.14', name: 'Kiusili' })
    dataSet.push({ id: '53.06.10.2011', kecamatan: '53.06.10', name: 'Kiwangona' })
    dataSet.push({ id: '53.06.01.2021', kecamatan: '53.06.01', name: 'Klatanlo' })
    dataSet.push({ id: '53.21.04.2004', kecamatan: '53.21.04', name: 'Kleseleon' })
    dataSet.push({ id: '53.21.01.2009', kecamatan: '53.21.01', name: 'Kletek' })
    dataSet.push({ id: '53.07.20.2006', kecamatan: '53.07.20', name: 'Kloangpopot' })
    dataSet.push({ id: '53.06.09.2006', kecamatan: '53.06.09', name: 'Klukengnuking' })
    dataSet.push({ id: '53.10.05.2022', kecamatan: '53.10.05', name: 'Koak' })
    dataSet.push({ id: '53.08.14.2005', kecamatan: '53.08.14', name: 'Koanara' })
    dataSet.push({ id: '53.08.11.2007', kecamatan: '53.08.11', name: 'Kobaleba' })
    dataSet.push({ id: '53.06.02.2001', kecamatan: '53.06.02', name: 'Kobasoma' })
    dataSet.push({ id: '53.12.15.2005', kecamatan: '53.12.15', name: 'Kodaka' })
    dataSet.push({ id: '53.16.02.2019', kecamatan: '53.16.02', name: 'Kodaute' })
    dataSet.push({ id: '53.07.15.2006', kecamatan: '53.07.15', name: 'Koja Doi' })
    dataSet.push({ id: '53.07.15.2007', kecamatan: '53.07.15', name: 'Kojagete' })
    dataSet.push({ id: '53.18.07.2007', kecamatan: '53.18.07', name: 'Koki' })
    dataSet.push({ id: '53.06.18.2002', kecamatan: '53.06.18', name: 'Kokotobo' })
    dataSet.push({ id: '53.07.19.2003', kecamatan: '53.07.19', name: 'Kokowahor' })
    dataSet.push({ id: '53.01.13.2004', kecamatan: '53.01.13', name: 'Kolabe' })
    dataSet.push({ id: '53.06.05.2015', kecamatan: '53.06.05', name: 'Kolaka' })
    dataSet.push({ id: '53.05.05.2005', kecamatan: '53.05.05', name: 'Kolana Selatan' })
    dataSet.push({ id: '53.05.05.1001', kecamatan: '53.05.05', name: 'Kolana Utara' })
    dataSet.push({ id: '53.15.12.2005', kecamatan: '53.15.12', name: 'Kolang' })
    dataSet.push({ id: '53.10.18.2006', kecamatan: '53.10.18', name: 'Kole' })
    dataSet.push({ id: '53.71.02.1007', kecamatan: '53.71.02', name: 'Kolhua' })
    dataSet.push({ id: '53.07.03.2004', kecamatan: '53.07.03', name: 'Kolidetung' })
    dataSet.push({ id: '53.08.11.2009', kecamatan: '53.08.11', name: 'Kolikapa' })
    dataSet.push({ id: '53.06.17.2003', kecamatan: '53.06.17', name: 'Kolilanang' })
    dataSet.push({ id: '53.06.17.2002', kecamatan: '53.06.17', name: 'Kolimasang' })
    dataSet.push({ id: '53.13.03.2001', kecamatan: '53.13.03', name: 'Kolipadan' })
    dataSet.push({ id: '53.06.17.2008', kecamatan: '53.06.17', name: 'Kolipetung' })
    dataSet.push({ id: '53.07.12.2004', kecamatan: '53.07.12', name: 'Kolisia' })
    dataSet.push({ id: '53.07.12.2005', kecamatan: '53.07.12', name: 'Kolisia B' })
    dataSet.push({ id: '53.14.03.2004', kecamatan: '53.14.03', name: 'Kolobolon' })
    dataSet.push({ id: '53.13.03.2013', kecamatan: '53.13.03', name: 'Kolontobo' })
    dataSet.push({ id: '53.20.06.2004', kecamatan: '53.20.06', name: 'Kolorae' })
    dataSet.push({ id: '53.19.06.2013', kecamatan: '53.19.06', name: 'Komba' })
    dataSet.push({ id: '53.15.11.2011', kecamatan: '53.15.11', name: 'Kombo' })
    dataSet.push({ id: '53.15.11.2012', kecamatan: '53.15.11', name: 'Kombo Selatan' })
    dataSet.push({ id: '53.15.11.2013', kecamatan: '53.15.11', name: 'Kombo Tengah' })
    dataSet.push({ id: '53.12.15.1002', kecamatan: '53.12.15', name: 'Komerda' })
    dataSet.push({ id: '53.15.05.2001', kecamatan: '53.15.05', name: 'Komodo' })
    dataSet.push({ id: '53.11.19.2001', kecamatan: '53.11.19', name: 'Kompa Pari' })
    dataSet.push({ id: '53.17.05.2001', kecamatan: '53.17.05', name: 'Konda Maloba' })
    dataSet.push({ id: '53.11.03.2004', kecamatan: '53.11.03', name: 'Kondamara' })
    dataSet.push({ id: '53.06.02.2009', kecamatan: '53.06.02', name: 'Konga' })
    dataSet.push({ id: '53.05.10.2002', kecamatan: '53.05.10', name: 'Kopidil' })
    dataSet.push({ id: '53.07.10.2007', kecamatan: '53.07.10', name: 'Kopong' })
    dataSet.push({ id: '53.18.08.2004', kecamatan: '53.18.08', name: 'Kori' })
    dataSet.push({ id: '53.07.02.2007', kecamatan: '53.07.02', name: 'Korobhera' })
    dataSet.push({ id: '53.07.03.2003', kecamatan: '53.07.03', name: 'Korowuwu' })
    dataSet.push({ id: '53.04.12.1001', kecamatan: '53.04.12', name: 'Kota Atambua' })
    dataSet.push({ id: '53.07.15.1002', kecamatan: '53.07.15', name: 'Kota Baru' })
    dataSet.push({ id: '53.11.14.2005', kecamatan: '53.11.14', name: 'Kota Kawau' })
    dataSet.push({ id: '53.19.01.1020', kecamatan: '53.19.01', name: 'Kota Ndora' })
    dataSet.push({ id: '53.08.18.1001', kecamatan: '53.08.18', name: 'Kota Raja' })
    dataSet.push({ id: '53.08.18.1002', kecamatan: '53.08.18', name: 'Kota Ratu' })
    dataSet.push({ id: '53.07.05.1009', kecamatan: '53.07.05', name: 'Kota Uneng' })
    dataSet.push({ id: '53.08.13.2001', kecamatan: '53.08.13', name: 'Kotabaru' })
    dataSet.push({ id: '53.01.09.2004', kecamatan: '53.01.09', name: 'Kotabes' })
    dataSet.push({ id: '53.21.10.2002', kecamatan: '53.21.10', name: 'Kotabiru' })
    dataSet.push({ id: '53.03.07.2005', kecamatan: '53.03.07', name: 'Kotafoun' })
    dataSet.push({ id: '53.16.04.2016', kecamatan: '53.16.04', name: 'Kotagana' })
    dataSet.push({ id: '53.20.04.2007', kecamatan: '53.20.04', name: 'Kotahawu' })
    dataSet.push({ id: '53.16.02.2006', kecamatan: '53.16.02', name: 'Kotakeo' })
    dataSet.push({ id: '53.16.02.2018', kecamatan: '53.16.02', name: 'Kotakeo Dua' })
    dataSet.push({ id: '53.16.02.2017', kecamatan: '53.16.02', name: 'Kotakeo Satu' })
    dataSet.push({ id: '53.07.16.2001', kecamatan: '53.07.16', name: 'Koting A' })
    dataSet.push({ id: '53.07.16.2002', kecamatan: '53.07.16', name: 'Koting B' })
    dataSet.push({ id: '53.07.16.2003', kecamatan: '53.07.16', name: 'Koting C' })
    dataSet.push({ id: '53.07.16.2004', kecamatan: '53.07.16', name: 'Koting D' })
    dataSet.push({ id: '53.16.06.2008', kecamatan: '53.16.06', name: 'Kotodirumali' })
    dataSet.push({ id: '53.16.06.2005', kecamatan: '53.16.06', name: 'Kotowuji Barat' })
    dataSet.push({ id: '53.16.06.2004', kecamatan: '53.16.06', name: 'Kotowuji Timur' })
    dataSet.push({ id: '53.07.02.2009', kecamatan: '53.07.02', name: 'Kowi' })
    dataSet.push({ id: '53.07.08.2014', kecamatan: '53.07.08', name: 'Kringa' })
    dataSet.push({ id: '53.03.10.2004', kecamatan: '53.03.10', name: 'Kuaken' })
    dataSet.push({ id: '53.01.24.2003', kecamatan: '53.01.24', name: 'Kuaklalo' })
    dataSet.push({ id: '53.01.25.2004', kecamatan: '53.01.25', name: 'Kuanheum' })
    dataSet.push({ id: '53.01.05.2008', kecamatan: '53.01.05', name: 'Kuanheun' })
    dataSet.push({ id: '53.71.05.1006', kecamatan: '53.71.05', name: 'Kuanino' })
    dataSet.push({ id: '53.03.15.2005', kecamatan: '53.03.15', name: 'Kuenak' })
    dataSet.push({ id: '53.21.06.2002', kecamatan: '53.21.06', name: 'Kufeu' })
    dataSet.push({ id: '53.05.03.2023', kecamatan: '53.05.03', name: 'Kuifana' })
    dataSet.push({ id: '53.01.10.2012', kecamatan: '53.01.10', name: 'Kuimasi' })
    dataSet.push({ id: '53.20.03.2006', kecamatan: '53.20.03', name: 'Kuji Ratu' })
    dataSet.push({ id: '53.11.05.2003', kecamatan: '53.11.05', name: 'Kuki Talu' })
    dataSet.push({ id: '53.14.03.2002', kecamatan: '53.14.03', name: 'Kuli' })
    dataSet.push({ id: '53.14.03.2017', kecamatan: '53.14.03', name: 'Kuli Aisele' })
    dataSet.push({ id: '53.03.24.2005', kecamatan: '53.03.24', name: 'Kuluan' })
    dataSet.push({ id: '53.05.04.2005', kecamatan: '53.05.04', name: 'Kuneman' })
    dataSet.push({ id: '53.08.21.2004', kecamatan: '53.08.21', name: 'Kuru' })
    dataSet.push({ id: '53.08.16.2001', kecamatan: '53.08.16', name: 'Kurulimbu' })
    dataSet.push({ id: '53.08.16.2005', kecamatan: '53.08.16', name: 'Kurulimbu Selatan' })
    dataSet.push({ id: '53.08.21.2014', kecamatan: '53.08.21', name: 'Kurusare' })
    dataSet.push({ id: '53.11.10.2002', kecamatan: '53.11.10', name: 'Kuruwaki' })
    dataSet.push({ id: '53.21.09.2003', kecamatan: '53.21.09', name: 'Kusa' })
    dataSet.push({ id: '53.11.20.2002', kecamatan: '53.11.20', name: 'Kuta' })
    dataSet.push({ id: '53.06.10.2018', kecamatan: '53.06.10', name: 'Kwaelaga Lamawato' })
    dataSet.push({ id: '53.13.01.2005', kecamatan: '53.13.01', name: 'Labalimut' })
    dataSet.push({ id: '53.06.07.2007', kecamatan: '53.06.07', name: 'Labelen' })
    dataSet.push({ id: '53.16.01.2002', kecamatan: '53.16.01', name: 'Labolewa' })
    dataSet.push({ id: '53.12.12.2011', kecamatan: '53.12.12', name: 'Laboya Dete' })
    dataSet.push({ id: '53.15.05.1025', kecamatan: '53.15.05', name: 'Labuan Bajo' })
    dataSet.push({ id: '53.10.12.1016', kecamatan: '53.10.12', name: 'Laci Carep' })
    dataSet.push({ id: '53.19.04.2007', kecamatan: '53.19.04', name: 'Lada Mese' })
    dataSet.push({ id: '53.07.04.2004', kecamatan: '53.07.04', name: 'Ladogahar' })
    dataSet.push({ id: '53.16.06.2010', kecamatan: '53.16.06', name: 'Ladolima' })
    dataSet.push({ id: '53.16.06.2013', kecamatan: '53.16.06', name: 'Ladolima Timur' })
    dataSet.push({ id: '53.16.06.2014', kecamatan: '53.16.06', name: 'Ladolima Utara' })
    dataSet.push({ id: '53.10.06.2013', kecamatan: '53.10.06', name: 'Ladur' })
    dataSet.push({ id: '53.18.04.2017', kecamatan: '53.18.04', name: 'Laga Lete' })
    dataSet.push({ id: '53.11.22.2001', kecamatan: '53.11.22', name: 'Lahiru' })
    dataSet.push({ id: '53.71.06.1002', kecamatan: '53.71.06', name: 'Lai Lai Bisi Kopan' })
    dataSet.push({ id: '53.11.18.2006', kecamatan: '53.11.18', name: 'Laihau' })
    dataSet.push({ id: '53.11.09.2006', kecamatan: '53.11.09', name: 'Lailanjang' })
    dataSet.push({ id: '53.11.19.2004', kecamatan: '53.11.19', name: 'Lailara' })
    dataSet.push({ id: '53.11.06.2003', kecamatan: '53.11.06', name: 'Lailunggi' })
    dataSet.push({ id: '53.11.14.2004', kecamatan: '53.11.14', name: 'Laimbonga' })
    dataSet.push({ id: '53.11.17.2003', kecamatan: '53.11.17', name: 'Laimeta' })
    dataSet.push({ id: '53.11.07.2012', kecamatan: '53.11.07', name: 'Laindeha' })
    dataSet.push({ id: '53.11.11.2005', kecamatan: '53.11.11', name: 'Lainjanji' })
    dataSet.push({ id: '53.11.11.2006', kecamatan: '53.11.11', name: 'Laipandak' })
    dataSet.push({ id: '53.11.08.2007', kecamatan: '53.11.08', name: 'Lairuru' })
    dataSet.push({ id: '53.11.12.2011', kecamatan: '53.11.12', name: 'Laitaku' })
    dataSet.push({ id: '53.16.04.2018', kecamatan: '53.16.04', name: 'Lajawajo' })
    dataSet.push({ id: '53.14.06.2006', kecamatan: '53.14.06', name: 'Lakamola' })
    dataSet.push({ id: '53.04.17.2003', kecamatan: '53.04.17', name: 'Lakan Mau' })
    dataSet.push({ id: '53.05.12.2003', kecamatan: '53.05.12', name: 'Lakatuli' })
    dataSet.push({ id: '53.21.11.2007', kecamatan: '53.21.11', name: 'Lakekun' })
    dataSet.push({ id: '53.21.11.2008', kecamatan: '53.21.11', name: 'Lakekun Barat' })
    dataSet.push({ id: '53.21.11.2006', kecamatan: '53.21.11', name: 'Lakekun Utara' })
    dataSet.push({ id: '53.04.18.2004', kecamatan: '53.04.18', name: 'Lakmaras' })
    dataSet.push({ id: '53.21.04.2010', kecamatan: '53.21.04', name: 'Lakulo' })
    dataSet.push({ id: '53.05.07.2012', kecamatan: '53.05.07', name: 'Lakwati' })
    dataSet.push({ id: '53.05.14.2011', kecamatan: '53.05.14', name: 'Lalafang' })
    dataSet.push({ id: '53.19.07.2019', kecamatan: '53.19.07', name: 'Lalang' })
    dataSet.push({ id: '53.15.07.2011', kecamatan: '53.15.07', name: 'Lale' })
    dataSet.push({ id: '53.21.04.2003', kecamatan: '53.21.04', name: 'Laleten' })
    dataSet.push({ id: '53.10.01.2002', kecamatan: '53.10.01', name: 'Lalong' })
    dataSet.push({ id: '53.15.09.2006', kecamatan: '53.15.09', name: 'Lalong' })
    dataSet.push({ id: '53.14.01.2007', kecamatan: '53.14.01', name: 'Lalukoen' })
    dataSet.push({ id: '53.13.09.2006', kecamatan: '53.13.09', name: 'Lamaau' })
    dataSet.push({ id: '53.06.13.2016', kecamatan: '53.06.13', name: 'Lamabayung' })
    dataSet.push({ id: '53.06.12.2006', kecamatan: '53.06.12', name: 'Lamabelawa' })
    dataSet.push({ id: '53.13.04.2013', kecamatan: '53.13.04', name: 'Lamadale' })
    dataSet.push({ id: '53.13.09.2009', kecamatan: '53.13.09', name: 'Lamagute' })
    dataSet.push({ id: '53.06.10.2006', kecamatan: '53.06.10', name: 'Lamahala Jaya' })
    dataSet.push({ id: '53.06.17.2006', kecamatan: '53.06.17', name: 'Lamahoda' })
    dataSet.push({ id: '53.04.01.2006', kecamatan: '53.04.01', name: 'Lamaksenulu' })
    dataSet.push({ id: '53.06.10.2016', kecamatan: '53.06.10', name: 'Lamalata' })
    dataSet.push({ id: '53.06.12.2015', kecamatan: '53.06.12', name: 'Lamaleka' })
    dataSet.push({ id: '53.13.04.2015', kecamatan: '53.13.04', name: 'Lamalela' })
    dataSet.push({ id: '53.13.08.2008', kecamatan: '53.13.08', name: 'Lamalera A' })
    dataSet.push({ id: '53.13.08.2007', kecamatan: '53.13.08', name: 'Lamalera B' })
    dataSet.push({ id: '53.06.05.2023', kecamatan: '53.06.05', name: 'Lamanabi' })
    dataSet.push({ id: '53.06.06.2003', kecamatan: '53.06.06', name: 'Lamaole' })
    dataSet.push({ id: '53.06.11.2004', kecamatan: '53.06.11', name: 'Lamapaha' })
    dataSet.push({ id: '53.13.09.2004', kecamatan: '53.13.09', name: 'Lamatokan' })
    dataSet.push({ id: '53.13.04.2002', kecamatan: '53.13.04', name: 'Lamatuka' })
    dataSet.push({ id: '53.06.05.2012', kecamatan: '53.06.05', name: 'Lamatutu' })
    dataSet.push({ id: '53.06.10.1002', kecamatan: '53.06.10', name: 'Lamatwelu' })
    dataSet.push({ id: '53.06.07.2018', kecamatan: '53.06.07', name: 'Lamawai' })
    dataSet.push({ id: '53.06.03.2020', kecamatan: '53.06.03', name: 'Lamawalang' })
    dataSet.push({ id: '53.06.06.2014', kecamatan: '53.06.06', name: 'Lamawalang' })
    dataSet.push({ id: '53.13.03.2024', kecamatan: '53.13.03', name: 'Lamawara' })
    dataSet.push({ id: '53.06.13.2005', kecamatan: '53.06.13', name: 'Lamawolo' })
    dataSet.push({ id: '53.13.09.2003', kecamatan: '53.13.09', name: 'Lamawolo' })
    dataSet.push({ id: '53.11.10.2006', kecamatan: '53.11.10', name: 'Lambakara' })
    dataSet.push({ id: '53.11.16.1007', kecamatan: '53.11.16', name: 'Lambanapu' })
    dataSet.push({ id: '53.12.12.2006', kecamatan: '53.12.12', name: 'Lamboya Bawah' })
    dataSet.push({ id: '53.06.11.2010', kecamatan: '53.06.11', name: 'Lambunga' })
    dataSet.push({ id: '53.21.03.2009', kecamatan: '53.21.03', name: 'Lamea' })
    dataSet.push({ id: '53.06.14.2001', kecamatan: '53.06.14', name: 'Lamika' })
    dataSet.push({ id: '53.05.17.2003', kecamatan: '53.05.17', name: 'Lamma' })
    dataSet.push({ id: '53.21.04.2007', kecamatan: '53.21.04', name: 'Lamudur' })
    dataSet.push({ id: '53.09.14.2002', kecamatan: '53.09.14', name: 'Lanamai' })
    dataSet.push({ id: '53.09.14.2009', kecamatan: '53.09.14', name: 'Lanamai I' })
    dataSet.push({ id: '53.03.21.2001', kecamatan: '53.03.21', name: 'Lanaus' })
    dataSet.push({ id: '53.10.06.2024', kecamatan: '53.10.06', name: 'Lando' })
    dataSet.push({ id: '53.14.01.2018', kecamatan: '53.14.01', name: 'Landu' })
    dataSet.push({ id: '53.09.06.2023', kecamatan: '53.09.06', name: 'Langagedha' })
    dataSet.push({ id: '53.16.07.2003', kecamatan: '53.16.07', name: 'Langedhawe' })
    dataSet.push({ id: '53.18.09.1003', kecamatan: '53.18.09', name: 'Langga Lero' })
    dataSet.push({ id: '53.19.09.2005', kecamatan: '53.19.09', name: 'Langga Sai' })
    dataSet.push({ id: '53.10.05.2023', kecamatan: '53.10.05', name: 'Langgo' })
    dataSet.push({ id: '53.07.19.2009', kecamatan: '53.07.19', name: 'Langir' })
    dataSet.push({ id: '53.10.06.2012', kecamatan: '53.10.06', name: 'Langkas' })
    dataSet.push({ id: '53.05.13.2001', kecamatan: '53.05.13', name: 'Langkuru' })
    dataSet.push({ id: '53.05.13.2004', kecamatan: '53.05.13', name: 'Langkuru Utara' })
    dataSet.push({ id: '53.10.16.2002', kecamatan: '53.10.16', name: 'Lante' })
    dataSet.push({ id: '53.12.15.2011', kecamatan: '53.12.15', name: 'Lapale' })
    dataSet.push({ id: '53.16.01.1011', kecamatan: '53.16.01', name: 'Lape' })
    dataSet.push({ id: '53.03.20.2003', kecamatan: '53.03.20', name: 'Lapeom' })
    dataSet.push({ id: '53.06.03.1004', kecamatan: '53.06.03', name: 'Larantuka' })
    dataSet.push({ id: '53.13.03.2014', kecamatan: '53.13.03', name: 'Laranwutun' })
    dataSet.push({ id: '53.21.02.2004', kecamatan: '53.21.02', name: 'Lasaen' })
    dataSet.push({ id: '53.71.03.1011', kecamatan: '53.71.03', name: 'Lasiana' })
    dataSet.push({ id: '53.04.17.2001', kecamatan: '53.04.17', name: 'Lasiolat' })
    dataSet.push({ id: '53.11.11.2004', kecamatan: '53.11.11', name: 'Latena' })
    dataSet.push({ id: '53.06.05.2013', kecamatan: '53.06.05', name: 'Latonliwo' })
    dataSet.push({ id: '53.06.05.2022', kecamatan: '53.06.05', name: 'Latonliwo Dua' })
    dataSet.push({ id: '53.10.17.2005', kecamatan: '53.10.17', name: 'Latung' })
    dataSet.push({ id: '53.09.09.2013', kecamatan: '53.09.09', name: 'Latung' })
    dataSet.push({ id: '53.05.10.2004', kecamatan: '53.05.10', name: 'Lawahing' })
    dataSet.push({ id: '53.21.01.2012', kecamatan: '53.21.01', name: 'Lawalu' })
    dataSet.push({ id: '53.04.04.2009', kecamatan: '53.04.04', name: 'Lawalutolus' })
    dataSet.push({ id: '53.15.02.2011', kecamatan: '53.15.02', name: 'Lawi' })
    dataSet.push({ id: '53.10.12.1005', kecamatan: '53.10.12', name: 'Lawir' })
    dataSet.push({ id: '53.13.02.2007', kecamatan: '53.13.02', name: 'Lebaata' })
    dataSet.push({ id: '53.06.13.2002', kecamatan: '53.06.13', name: 'Lebanuba' })
    dataSet.push({ id: '53.06.07.2003', kecamatan: '53.06.07', name: 'Lebao' })
    dataSet.push({ id: '53.13.06.2017', kecamatan: '53.13.06', name: 'Lebewala' })
    dataSet.push({ id: '53.09.06.1019', kecamatan: '53.09.06', name: 'Lebijaga' })
    dataSet.push({ id: '53.20.05.2006', kecamatan: '53.20.05', name: 'Ledeae' })
    dataSet.push({ id: '53.20.01.2008', kecamatan: '53.20.01', name: 'Ledeana' })
    dataSet.push({ id: '53.20.04.2004', kecamatan: '53.20.04', name: 'Ledeke' })
    dataSet.push({ id: '53.20.06.1001', kecamatan: '53.20.06', name: 'Ledeke' })
    dataSet.push({ id: '53.20.01.2017', kecamatan: '53.20.01', name: 'Ledekepaka' })
    dataSet.push({ id: '53.20.05.2008', kecamatan: '53.20.05', name: 'Lederaga' })
    dataSet.push({ id: '53.20.04.2012', kecamatan: '53.20.04', name: 'Ledetalo' })
    dataSet.push({ id: '53.20.06.1002', kecamatan: '53.20.06', name: 'Ledeunu' })
    dataSet.push({ id: '53.05.09.2007', kecamatan: '53.05.09', name: 'Leer' })
    dataSet.push({ id: '53.05.02.2024', kecamatan: '53.05.02', name: 'Lefokisu' })
    dataSet.push({ id: '53.16.03.2006', kecamatan: '53.16.03', name: 'Legederu' })
    dataSet.push({ id: '53.09.20.2009', kecamatan: '53.09.20', name: 'Legeriwu' })
    dataSet.push({ id: '53.10.05.2024', kecamatan: '53.10.05', name: 'Legu' })
    dataSet.push({ id: '53.19.05.2016', kecamatan: '53.19.05', name: 'Legur Lai' })
    dataSet.push({ id: '53.14.01.2015', kecamatan: '53.14.01', name: 'Lekik' })
    dataSet.push({ id: '53.09.01.2020', kecamatan: '53.09.01', name: 'Lekogoko' })
    dataSet.push({ id: '53.05.14.2008', kecamatan: '53.05.14', name: 'Lekom' })
    dataSet.push({ id: '53.14.05.2012', kecamatan: '53.14.05', name: 'Lekona' })
    dataSet.push({ id: '53.14.03.2015', kecamatan: '53.14.03', name: 'Lekunik' })
    dataSet.push({ id: '53.07.03.2001', kecamatan: '53.07.03', name: 'Lela' })
    dataSet.push({ id: '53.13.08.2009', kecamatan: '53.13.08', name: 'Lelata' })
    dataSet.push({ id: '53.18.03.2024', kecamatan: '53.18.03', name: 'Lele Maya' })
    dataSet.push({ id: '53.06.10.2020', kecamatan: '53.06.10', name: 'Lelen Bala' })
    dataSet.push({ id: '53.05.04.2012', kecamatan: '53.05.04', name: 'Lella' })
    dataSet.push({ id: '53.01.12.2008', kecamatan: '53.01.12', name: 'Leloboko' })
    dataSet.push({ id: '53.01.12.1003', kecamatan: '53.01.12', name: 'Lelogama' })
    dataSet.push({ id: '53.06.19.2005', kecamatan: '53.06.19', name: 'Lemanu' })
    dataSet.push({ id: '53.10.16.2007', kecamatan: '53.10.16', name: 'Lemarang' })
    dataSet.push({ id: '53.19.06.2003', kecamatan: '53.19.06', name: 'Lembur' })
    dataSet.push({ id: '53.05.07.2001', kecamatan: '53.05.07', name: 'Lembur Barat' })
    dataSet.push({ id: '53.05.07.2002', kecamatan: '53.05.07', name: 'Lembur Tengah' })
    dataSet.push({ id: '53.05.15.2001', kecamatan: '53.05.15', name: 'Lembur Timur' })
    dataSet.push({ id: '53.03.02.2004', kecamatan: '53.03.02', name: 'Lemon' })
    dataSet.push({ id: '53.19.09.1001', kecamatan: '53.19.09', name: 'Lempang Paji' })
    dataSet.push({ id: '53.07.01.2008', kecamatan: '53.07.01', name: 'Lenandareta' })
    dataSet.push({ id: '53.17.04.2007', kecamatan: '53.17.04', name: 'Lenang' })
    dataSet.push({ id: '53.19.02.2003', kecamatan: '53.19.02', name: 'Lenang' })
    dataSet.push({ id: '53.17.04.2017', kecamatan: '53.17.04', name: 'Lenang Selatan' })
    dataSet.push({ id: '53.19.03.2012', kecamatan: '53.19.03', name: 'Lencur' })
    dataSet.push({ id: '53.10.17.2010', kecamatan: '53.10.17', name: 'Lenda' })
    dataSet.push({ id: '53.05.01.2012', kecamatan: '53.05.01', name: 'Lendola' })
    dataSet.push({ id: '53.15.09.2012', kecamatan: '53.15.09', name: 'Lendong' })
    dataSet.push({ id: '53.19.05.2001', kecamatan: '53.19.05', name: 'Lengko Namut' })
    dataSet.push({ id: '53.09.09.2008', kecamatan: '53.09.09', name: 'Lengkosambi' })
    dataSet.push({ id: '53.09.09.2018', kecamatan: '53.09.09', name: 'Lengkosambi Barat' })
    dataSet.push({ id: '53.09.09.2017', kecamatan: '53.09.09', name: 'Lengkosambi Timur' })
    dataSet.push({ id: '53.09.09.2020', kecamatan: '53.09.09', name: 'Lengkosambi Utara' })
    dataSet.push({ id: '53.14.08.2001', kecamatan: '53.14.08', name: 'Lenguselu' })
    dataSet.push({ id: '53.10.15.2010', kecamatan: '53.10.15', name: 'Lentang' })
    dataSet.push({ id: '53.14.01.2019', kecamatan: '53.14.01', name: 'Lentera' })
    dataSet.push({ id: '53.19.02.2031', kecamatan: '53.19.02', name: 'Lento' })
    dataSet.push({ id: '53.14.05.2003', kecamatan: '53.14.05', name: 'Lenupetu' })
    dataSet.push({ id: '53.19.02.2005', kecamatan: '53.19.02', name: 'Leong' })
    dataSet.push({ id: '53.04.05.2005', kecamatan: '53.04.05', name: 'Leosama' })
    dataSet.push({ id: '53.04.01.2009', kecamatan: '53.04.01', name: 'Leowalu' })
    dataSet.push({ id: '53.07.15.2008', kecamatan: '53.07.15', name: 'Lepo Lima' })
    dataSet.push({ id: '53.06.02.2006', kecamatan: '53.06.02', name: 'Leraboleng' })
    dataSet.push({ id: '53.13.04.2010', kecamatan: '53.13.04', name: 'Lerahinga' })
    dataSet.push({ id: '53.13.02.2004', kecamatan: '53.13.02', name: 'Lerek' })
    dataSet.push({ id: '53.01.04.2013', kecamatan: '53.01.04', name: 'Letbaun' })
    dataSet.push({ id: '53.18.03.2013', kecamatan: '53.18.03', name: 'Lete Kamouna' })
    dataSet.push({ id: '53.18.01.2002', kecamatan: '53.18.01', name: 'Lete Konda' })
    dataSet.push({ id: '53.18.01.2017', kecamatan: '53.18.01', name: 'Lete Konda Selatan' })
    dataSet.push({ id: '53.18.06.2002', kecamatan: '53.18.06', name: 'Lete Loko' })
    dataSet.push({ id: '53.18.10.2017', kecamatan: '53.18.10', name: 'Lete Wungana' })
    dataSet.push({ id: '53.01.21.2002', kecamatan: '53.01.21', name: 'Letkole' })
    dataSet.push({ id: '53.03.21.2002', kecamatan: '53.03.21', name: 'Letmafo' })
    dataSet.push({ id: '53.03.21.2006', kecamatan: '53.03.21', name: 'Letmafo Timur' })
    dataSet.push({ id: '53.03.20.2004', kecamatan: '53.03.20', name: 'Letneo' })
    dataSet.push({ id: '53.03.20.2008', kecamatan: '53.03.20', name: 'Letneo Selatan' })
    dataSet.push({ id: '53.13.06.2003', kecamatan: '53.13.06', name: 'Leubatang' })
    dataSet.push({ id: '53.13.07.2006', kecamatan: '53.13.07', name: 'Leuburi' })
    dataSet.push({ id: '53.13.06.2013', kecamatan: '53.13.06', name: 'Leudanung' })
    dataSet.push({ id: '53.21.04.2011', kecamatan: '53.21.04', name: 'Leunklot' })
    dataSet.push({ id: '53.04.13.2007', kecamatan: '53.04.13', name: 'Leuntolu' })
    dataSet.push({ id: '53.13.06.2012', kecamatan: '53.13.06', name: 'Leuwayang' })
    dataSet.push({ id: '53.13.07.2012', kecamatan: '53.13.07', name: 'Leuwohung' })
    dataSet.push({ id: '53.11.03.1001', kecamatan: '53.11.03', name: 'Lewa Paku' })
    dataSet.push({ id: '53.05.02.2026', kecamatan: '53.05.02', name: 'Lewalu' })
    dataSet.push({ id: '53.16.06.2002', kecamatan: '53.16.06', name: 'Lewangera' })
    dataSet.push({ id: '53.06.13.2017', kecamatan: '53.06.13', name: 'Lewat' })
    dataSet.push({ id: '53.15.01.2015', kecamatan: '53.15.01', name: 'Lewat' })
    dataSet.push({ id: '53.06.16.2005', kecamatan: '53.06.16', name: 'Lewoawang' })
    dataSet.push({ id: '53.06.18.2007', kecamatan: '53.06.18', name: 'Lewobele' })
    dataSet.push({ id: '53.06.15.2007', kecamatan: '53.06.15', name: 'Lewobelen' })
    dataSet.push({ id: '53.06.05.2006', kecamatan: '53.06.05', name: 'Lewobunga' })
    dataSet.push({ id: '53.06.10.2013', kecamatan: '53.06.10', name: 'Lewobunga' })
    dataSet.push({ id: '53.13.04.2007', kecamatan: '53.13.04', name: 'Lewoeleng' })
    dataSet.push({ id: '53.06.07.2017', kecamatan: '53.06.07', name: 'Lewogeka' })
    dataSet.push({ id: '53.06.19.2006', kecamatan: '53.06.19', name: 'Lewograran' })
    dataSet.push({ id: '53.13.02.2016', kecamatan: '53.13.02', name: 'Lewogroma' })
    dataSet.push({ id: '53.06.04.2006', kecamatan: '53.06.04', name: 'Lewohala' })
    dataSet.push({ id: '53.06.07.2013', kecamatan: '53.06.07', name: 'Lewohedo' })
    dataSet.push({ id: '53.06.02.2003', kecamatan: '53.06.02', name: 'Lewoingu' })
    dataSet.push({ id: '53.06.13.2012', kecamatan: '53.06.13', name: 'Lewokeleng' })
    dataSet.push({ id: '53.06.14.2003', kecamatan: '53.06.14', name: 'Lewokluok' })
    dataSet.push({ id: '53.06.02.2002', kecamatan: '53.06.02', name: 'Lewolaga' })
    dataSet.push({ id: '53.13.05.1001', kecamatan: '53.13.05', name: 'Lewoleba' })
    dataSet.push({ id: '53.13.05.1017', kecamatan: '53.13.05', name: 'Lewoleba Barat' })
    dataSet.push({ id: '53.13.05.1016', kecamatan: '53.13.05', name: 'Lewoleba Selatan' })
    dataSet.push({ id: '53.13.05.1003', kecamatan: '53.13.05', name: 'Lewoleba Tengah' })
    dataSet.push({ id: '53.13.05.1002', kecamatan: '53.13.05', name: 'Lewoleba Timur' })
    dataSet.push({ id: '53.13.05.1004', kecamatan: '53.13.05', name: 'Lewoleba Utara' })
    dataSet.push({ id: '53.06.03.1002', kecamatan: '53.06.03', name: 'Lewolere' })
    dataSet.push({ id: '53.06.04.2002', kecamatan: '53.06.04', name: 'Lewoloba' })
    dataSet.push({ id: '53.07.08.2008', kecamatan: '53.07.08', name: 'Lewomada' })
    dataSet.push({ id: '53.06.14.2007', kecamatan: '53.06.14', name: 'Lewomuda' })
    dataSet.push({ id: '53.06.06.2020', kecamatan: '53.06.06', name: 'Lewonama' })
    dataSet.push({ id: '53.06.13.2007', kecamatan: '53.06.13', name: 'Lewopao' })
    dataSet.push({ id: '53.06.18.2012', kecamatan: '53.06.18', name: 'Lewopao' })
    dataSet.push({ id: '53.06.12.2008', kecamatan: '53.06.12', name: 'Lewopulo' })
    dataSet.push({ id: '53.13.08.2003', kecamatan: '53.13.08', name: 'Leworaja' })
    dataSet.push({ id: '53.06.06.2017', kecamatan: '53.06.06', name: 'Lewotanah Ole' })
    dataSet.push({ id: '53.15.02.2010', kecamatan: '53.15.02', name: 'Lewur' })
    dataSet.push({ id: '53.10.18.2005', kecamatan: '53.10.18', name: 'Lia' })
    dataSet.push({ id: '53.08.12.2007', kecamatan: '53.08.12', name: 'Liabeke' })
    dataSet.push({ id: '53.07.02.2004', kecamatan: '53.07.02', name: 'Liakutu' })
    dataSet.push({ id: '53.10.14.2006', kecamatan: '53.10.14', name: 'Liang Bua' })
    dataSet.push({ id: '53.19.03.2015', kecamatan: '53.19.03', name: 'Liang Deruk' })
    dataSet.push({ id: '53.15.10.2001', kecamatan: '53.15.10', name: 'Liang Ndara' })
    dataSet.push({ id: '53.15.03.2033', kecamatan: '53.15.03', name: 'LIang Sola' })
    dataSet.push({ id: '53.09.07.2012', kecamatan: '53.09.07', name: 'Libunio' })
    dataSet.push({ id: '53.14.04.2011', kecamatan: '53.14.04', name: 'Lidabesi' })
    dataSet.push({ id: '53.04.22.1003', kecamatan: '53.04.22', name: 'Lidak' })
    dataSet.push({ id: '53.14.04.2005', kecamatan: '53.14.04', name: 'Lidamanu' })
    dataSet.push({ id: '53.07.06.2008', kecamatan: '53.07.06', name: 'Lidi' })
    dataSet.push({ id: '53.19.07.2017', kecamatan: '53.19.07', name: 'Lidi' })
    dataSet.push({ id: '53.14.02.2010', kecamatan: '53.14.02', name: 'Lidor' })
    dataSet.push({ id: '53.01.05.2005', kecamatan: '53.01.05', name: 'Lifuleo' })
    dataSet.push({ id: '53.14.10.2002', kecamatan: '53.14.10', name: 'Lifuleo' })
    dataSet.push({ id: '53.08.08.2020', kecamatan: '53.08.08', name: 'Likanaka' })
    dataSet.push({ id: '53.05.07.2004', kecamatan: '53.05.07', name: 'Likwatang' })
    dataSet.push({ id: '53.71.04.1010', kecamatan: '53.71.04', name: 'Liliba' })
    dataSet.push({ id: '53.01.13.2010', kecamatan: '53.01.13', name: 'Lilmus' })
    dataSet.push({ id: '53.20.03.1002', kecamatan: '53.20.03', name: 'Limaggu' })
    dataSet.push({ id: '53.14.04.2004', kecamatan: '53.14.04', name: 'Limakoli' })
    dataSet.push({ id: '53.18.08.2021', kecamatan: '53.18.08', name: 'Limbu Kembe' })
    dataSet.push({ id: '53.18.10.2018', kecamatan: '53.18.10', name: 'Limbu Watu' })
    dataSet.push({ id: '53.10.18.2007', kecamatan: '53.10.18', name: 'Ling' })
    dataSet.push({ id: '53.12.04.2005', kecamatan: '53.12.04', name: 'Lingu Lango' })
    dataSet.push({ id: '53.05.08.2006', kecamatan: '53.05.08', name: 'Lippang' })
    dataSet.push({ id: '53.08.08.2024', kecamatan: '53.08.08', name: "Lise Pu'u" })
    dataSet.push({ id: '53.08.08.2016', kecamatan: '53.08.08', name: 'Lisedetu' })
    dataSet.push({ id: '53.08.21.2011', kecamatan: '53.08.21', name: 'Lisekuru' })
    dataSet.push({ id: '53.08.13.2013', kecamatan: '53.08.13', name: 'Liselande' })
    dataSet.push({ id: '53.08.08.2019', kecamatan: '53.08.08', name: 'Liselowobora' })
    dataSet.push({ id: '53.21.11.2005', kecamatan: '53.21.11', name: 'Litamali' })
    dataSet.push({ id: '53.06.18.2003', kecamatan: '53.06.18', name: 'Lite' })
    dataSet.push({ id: '53.13.05.2014', kecamatan: '53.13.05', name: 'Lite Ulu Mado' })
    dataSet.push({ id: '53.06.07.2011', kecamatan: '53.06.07', name: 'Liwo' })
    dataSet.push({ id: '53.13.01.2018', kecamatan: '53.13.01', name: 'Liwulagang' })
    dataSet.push({ id: '53.09.07.2006', kecamatan: '53.09.07', name: 'Loa' })
    dataSet.push({ id: '53.20.02.2004', kecamatan: '53.20.02', name: 'Loboaju' })
    dataSet.push({ id: '53.20.03.2003', kecamatan: '53.20.03', name: 'Lobodei' })
    dataSet.push({ id: '53.20.05.2001', kecamatan: '53.20.05', name: 'Lobohede' })
    dataSet.push({ id: '53.08.13.2004', kecamatan: '53.08.13', name: 'Loboniki' })
    dataSet.push({ id: '53.20.03.2007', kecamatan: '53.20.03', name: 'Loborai' })
    dataSet.push({ id: '53.20.04.2010', kecamatan: '53.20.04', name: 'Loborui' })
    dataSet.push({ id: '53.10.16.2006', kecamatan: '53.10.16', name: 'Loce' })
    dataSet.push({ id: '53.12.10.1011', kecamatan: '53.12.10', name: 'Loda Pare' })
    dataSet.push({ id: '53.16.04.2011', kecamatan: '53.16.04', name: 'Lodaolo' })
    dataSet.push({ id: '53.13.04.2004', kecamatan: '53.13.04', name: 'Lodotodokowa' })
    dataSet.push({ id: '53.03.08.2007', kecamatan: '53.03.08', name: 'Loeram' })
    dataSet.push({ id: '53.15.11.2007', kecamatan: '53.15.11', name: 'Loha' })
    dataSet.push({ id: '53.06.03.1007', kecamatan: '53.06.03', name: 'Lohayong' })
    dataSet.push({ id: '53.06.07.2009', kecamatan: '53.06.07', name: 'Lohayong I' })
    dataSet.push({ id: '53.06.07.2014', kecamatan: '53.06.07', name: 'Lohayong II' })
    dataSet.push({ id: '53.16.04.2017', kecamatan: '53.16.04', name: 'Lokalaba' })
    dataSet.push({ id: '53.07.17.2004', kecamatan: '53.07.17', name: 'Loke' })
    dataSet.push({ id: '53.06.03.1008', kecamatan: '53.06.03', name: 'Lokea' })
    dataSet.push({ id: '53.18.01.2016', kecamatan: '53.18.01', name: 'Loko Kalada' })
    dataSet.push({ id: '53.12.04.2001', kecamatan: '53.12.04', name: 'Loko Ry' })
    dataSet.push({ id: '53.18.11.2007', kecamatan: '53.18.11', name: 'Loko Tali' })
    dataSet.push({ id: '53.08.05.1002', kecamatan: '53.08.05', name: 'Lokoboko' })
    dataSet.push({ id: '53.03.06.2012', kecamatan: '53.03.06', name: 'Lokomea' })
    dataSet.push({ id: '53.10.05.2041', kecamatan: '53.10.05', name: 'Lolang' })
    dataSet.push({ id: '53.14.03.2016', kecamatan: '53.14.03', name: 'Loleoen' })
    dataSet.push({ id: '53.18.04.2022', kecamatan: '53.18.04', name: 'Lolo Ole' })
    dataSet.push({ id: '53.12.04.2012', kecamatan: '53.12.04', name: 'Lolo Tana' })
    dataSet.push({ id: '53.12.04.2002', kecamatan: '53.12.04', name: 'Lolo Wano' })
    dataSet.push({ id: '53.13.01.2010', kecamatan: '53.13.01', name: 'Lolong' })
    dataSet.push({ id: '53.18.10.2005', kecamatan: '53.18.10', name: 'Lombu' })
    dataSet.push({ id: '53.14.06.1004', kecamatan: '53.14.06', name: 'Londalusi' })
    dataSet.push({ id: '53.10.01.2007', kecamatan: '53.10.01', name: 'Longko' })
    dataSet.push({ id: '53.21.02.2010', kecamatan: '53.21.02', name: 'Loofoun' })
    dataSet.push({ id: '53.04.04.2003', kecamatan: '53.04.04', name: 'Lookeu' })
    dataSet.push({ id: '53.04.18.2002', kecamatan: '53.04.18', name: 'Loonuna' })
    dataSet.push({ id: '53.21.03.2006', kecamatan: '53.21.03', name: 'Lorotolus' })
    dataSet.push({ id: '53.21.05.2003', kecamatan: '53.21.05', name: 'Lotas' })
    dataSet.push({ id: '53.13.07.2005', kecamatan: '53.13.07', name: 'Loyobohor' })
    dataSet.push({ id: '53.18.04.2019', kecamatan: '53.18.04', name: 'Lua Koba' })
    dataSet.push({ id: '53.05.15.2002', kecamatan: '53.05.15', name: 'Luba' })
    dataSet.push({ id: '53.11.01.2012', kecamatan: '53.11.01', name: 'Lukukamaru' })
    dataSet.push({ id: '53.11.17.2001', kecamatan: '53.11.17', name: 'Lukuwingir' })
    dataSet.push({ id: '53.11.22.2005', kecamatan: '53.11.22', name: 'Lulundilu' })
    dataSet.push({ id: '53.11.11.2003', kecamatan: '53.11.11', name: 'Lumbu Manggit' })
    dataSet.push({ id: '53.11.08.1001', kecamatan: '53.11.08', name: 'Lumbukore' })
    dataSet.push({ id: '53.15.08.2009', kecamatan: '53.15.08', name: 'Lumut' })
    dataSet.push({ id: '53.10.05.2020', kecamatan: '53.10.05', name: 'Lungar' })
    dataSet.push({ id: '53.08.17.2007', kecamatan: '53.08.17', name: 'Lungaria' })
    dataSet.push({ id: '53.03.23.2002', kecamatan: '53.03.23', name: 'Luniup' })
    dataSet.push({ id: '53.13.01.2004', kecamatan: '53.13.01', name: 'Lusiduawutun' })
    dataSet.push({ id: '53.13.02.2002', kecamatan: '53.13.02', name: 'Lusilame' })
    dataSet.push({ id: '53.07.04.2007', kecamatan: '53.07.04', name: 'Lusitada' })
    dataSet.push({ id: '53.04.18.2008', kecamatan: '53.04.18', name: 'Lutha Rato' })
    dataSet.push({ id: '53.15.05.2008', kecamatan: '53.15.05', name: 'Macang Tanggar' })
    dataSet.push({ id: '53.05.06.2019', kecamatan: '53.05.06', name: 'Madar' })
    dataSet.push({ id: '53.07.05.1006', kecamatan: '53.07.05', name: 'Madawat' })
    dataSet.push({ id: '53.17.02.2004', kecamatan: '53.17.02', name: 'Maderi' })
    dataSet.push({ id: '53.08.11.2004', kecamatan: '53.08.11', name: 'Magekapa' })
    dataSet.push({ id: '53.07.12.2001', kecamatan: '53.07.12', name: 'Magepanda' })
    dataSet.push({ id: '53.18.08.2014', kecamatan: '53.18.08', name: 'Magho Linyo' })
    dataSet.push({ id: '53.13.06.2005', kecamatan: '53.13.06', name: 'Mahal I' })
    dataSet.push({ id: '53.13.06.2018', kecamatan: '53.13.06', name: 'Mahal II' })
    dataSet.push({ id: '53.11.06.2006', kecamatan: '53.11.06', name: 'Mahaniwa' })
    dataSet.push({ id: '53.07.04.2017', kecamatan: '53.07.04', name: 'Mahebora' })
    dataSet.push({ id: '53.11.17.2004', kecamatan: '53.11.17', name: 'Mahubokul' })
    dataSet.push({ id: '53.04.01.2015', kecamatan: '53.04.01', name: 'Mahuitas' })
    dataSet.push({ id: '53.11.17.2006', kecamatan: '53.11.17', name: 'Maidang' })
    dataSet.push({ id: '53.05.04.2009', kecamatan: '53.05.04', name: 'Maikang' })
    dataSet.push({ id: '53.09.16.2003', kecamatan: '53.09.16', name: 'Mainai' })
    dataSet.push({ id: '53.18.03.2021', kecamatan: '53.18.03', name: 'Mainda Ole' })
    dataSet.push({ id: '53.11.04.2001', kecamatan: '53.11.04', name: 'Makamenggit' })
    dataSet.push({ id: '53.17.01.2001', kecamatan: '53.17.01', name: 'Makata Keri' })
    dataSet.push({ id: '53.04.01.2005', kecamatan: '53.04.01', name: 'Makir' })
    dataSet.push({ id: '53.21.02.2009', kecamatan: '53.21.02', name: 'Maktihan' })
    dataSet.push({ id: '53.03.24.2003', kecamatan: '53.03.24', name: 'Makun' })
    dataSet.push({ id: '53.05.04.2010', kecamatan: '53.05.04', name: 'Malaipea' })
    dataSet.push({ id: '53.09.02.2020', kecamatan: '53.09.02', name: 'Malanuza' })
    dataSet.push({ id: '53.09.02.2031', kecamatan: '53.09.02', name: 'Malanuza Satu' })
    dataSet.push({ id: '53.12.04.2003', kecamatan: '53.12.04', name: 'Malata' })
    dataSet.push({ id: '53.08.01.2022', kecamatan: '53.08.01', name: 'Malawaru' })
    dataSet.push({ id: '53.18.07.2011', kecamatan: '53.18.07', name: 'Mali lha' })
    dataSet.push({ id: '53.18.02.2001', kecamatan: '53.18.02', name: 'Mali Mada' })
    dataSet.push({ id: '53.17.05.2003', kecamatan: '53.17.05', name: 'Malinjak' })
    dataSet.push({ id: '53.12.15.1009', kecamatan: '53.12.15', name: 'Maliti' })
    dataSet.push({ id: '53.18.06.2026', kecamatan: '53.18.06', name: 'Maliti Bondo Ate' })
    dataSet.push({ id: '53.18.03.2025', kecamatan: '53.18.03', name: 'Maliti Dari' })
    dataSet.push({ id: '53.11.16.1006', kecamatan: '53.11.16', name: 'Malumbi' })
    dataSet.push({ id: '53.07.06.2001', kecamatan: '53.07.06', name: 'Maluriwu' })
    dataSet.push({ id: '53.12.11.2009', kecamatan: '53.12.11', name: 'Mamodu' })
    dataSet.push({ id: '53.13.07.2011', kecamatan: '53.13.07', name: 'Mampir' })
    dataSet.push({ id: '53.03.18.2001', kecamatan: '53.03.18', name: 'Manamas' })
    dataSet.push({ id: '53.05.03.2020', kecamatan: '53.05.03', name: 'Manatang' })
    dataSet.push({ id: '53.11.19.2003', kecamatan: '53.11.19', name: 'Mandahu' })
    dataSet.push({ id: '53.04.13.2004', kecamatan: '53.04.13', name: 'Mandeu' })
    dataSet.push({ id: '53.04.13.2001', kecamatan: '53.04.13', name: 'Mandeu Raimanus' })
    dataSet.push({ id: '53.19.02.1027', kecamatan: '53.19.02', name: 'Mandosawu' })
    dataSet.push({ id: '53.18.05.2012', kecamatan: '53.18.05', name: 'Mandungo' })
    dataSet.push({ id: '53.04.17.2002', kecamatan: '53.04.17', name: 'Maneikun' })
    dataSet.push({ id: '53.05.07.2011', kecamatan: '53.05.07', name: 'Manetwati' })
    dataSet.push({ id: '53.06.11.2012', kecamatan: '53.06.11', name: 'Mangaaleng' })
    dataSet.push({ id: '53.09.07.2010', kecamatan: '53.09.07', name: 'Mangeruda' })
    dataSet.push({ id: '53.18.08.2008', kecamatan: '53.18.08', name: 'Mangganipi' })
    dataSet.push({ id: '53.09.19.1001', kecamatan: '53.09.19', name: 'Mangulewa' })
    dataSet.push({ id: '53.03.10.2003', kecamatan: '53.03.10', name: 'Manikin' })
    dataSet.push({ id: '53.04.02.2005', kecamatan: '53.04.02', name: 'Manleten' })
    dataSet.push({ id: '53.05.04.2013', kecamatan: '53.05.04', name: 'Manmas' })
    dataSet.push({ id: '53.12.10.2014', kecamatan: '53.12.10', name: 'Manola' })
    dataSet.push({ id: '53.10.14.2010', kecamatan: '53.10.14', name: 'Manong' })
    dataSet.push({ id: '53.15.11.2002', kecamatan: '53.15.11', name: 'Manong' })
    dataSet.push({ id: '53.71.01.1007', kecamatan: '53.71.01', name: 'Mantasi' })
    dataSet.push({ id: '53.12.04.2011', kecamatan: '53.12.04', name: 'Manu Kuku' })
    dataSet.push({ id: '53.12.04.2015', kecamatan: '53.12.04', name: 'Manu Mada' })
    dataSet.push({ id: '53.18.06.2018', kecamatan: '53.18.06', name: 'Manu Toghi' })
    dataSet.push({ id: '53.17.03.2008', kecamatan: '53.17.03', name: 'Manu Wolu' })
    dataSet.push({ id: '53.04.22.1001', kecamatan: '53.04.22', name: 'Manuaman' })
    dataSet.push({ id: '53.01.21.2001', kecamatan: '53.01.21', name: 'Manubelon' })
    dataSet.push({ id: '53.09.20.2010', kecamatan: '53.09.20', name: 'Manubhara' })
    dataSet.push({ id: '53.07.07.2006', kecamatan: '53.07.07', name: 'Manubura' })
    dataSet.push({ id: '53.01.05.2003', kecamatan: '53.01.05', name: 'Manulai I' })
    dataSet.push({ id: '53.71.01.1010', kecamatan: '53.71.01', name: 'Manulai II' })
    dataSet.push({ id: '53.08.05.2015', kecamatan: '53.08.05', name: 'Manulando' })
    dataSet.push({ id: '53.21.07.2002', kecamatan: '53.21.07', name: 'Manulea' })
    dataSet.push({ id: '53.03.24.2004', kecamatan: '53.03.24', name: 'Manumean' })
    dataSet.push({ id: '53.04.12.1003', kecamatan: '53.04.12', name: 'Manumutin' })
    dataSet.push({ id: '53.21.07.2006', kecamatan: '53.21.07', name: 'Manumutin Silole' })
    dataSet.push({ id: '53.03.08.1018', kecamatan: '53.03.08', name: 'Manunain A' })
    dataSet.push({ id: '53.03.08.2008', kecamatan: '53.03.08', name: 'Manunain B' })
    dataSet.push({ id: '53.17.05.2007', kecamatan: '53.17.05', name: 'Manurara' })
    dataSet.push({ id: '53.01.06.2016', kecamatan: '53.01.06', name: 'Manusak' })
    dataSet.push({ id: '53.03.02.2020', kecamatan: '53.03.02', name: 'Manusasi' })
    dataSet.push({ id: '53.71.01.1006', kecamatan: '53.71.01', name: 'Manutapen' })
    dataSet.push({ id: '53.17.04.2005', kecamatan: '53.17.04', name: 'Mara Desa' })
    dataSet.push({ id: '53.11.17.2005', kecamatan: '53.11.17', name: 'Marada Mundi' })
    dataSet.push({ id: '53.17.04.2013', kecamatan: '53.17.04', name: 'Maradesa Selatan' })
    dataSet.push({ id: '53.17.04.2012', kecamatan: '53.17.04', name: 'Maradesa Timur' })
    dataSet.push({ id: '53.16.01.2012', kecamatan: '53.16.01', name: 'Marapokot' })
    dataSet.push({ id: '53.18.03.2005', kecamatan: '53.18.03', name: 'Mareda Kalada' })
    dataSet.push({ id: '53.05.03.2027', kecamatan: '53.05.03', name: 'Margeta' })
    dataSet.push({ id: '53.05.17.2002', kecamatan: '53.05.17', name: 'Marisa' })
    dataSet.push({ id: '53.05.05.2008', kecamatan: '53.05.05', name: 'Maritaing' })
    dataSet.push({ id: '53.18.04.2006', kecamatan: '53.18.04', name: 'Marokota' })
    dataSet.push({ id: '53.05.11.2002', kecamatan: '53.05.11', name: 'Maru' })
    dataSet.push({ id: '53.07.01.2001', kecamatan: '53.07.01', name: 'Masabewa' })
    dataSet.push({ id: '53.09.07.2011', kecamatan: '53.09.07', name: 'Masu Kedhi' })
    dataSet.push({ id: '53.09.07.2004', kecamatan: '53.09.07', name: 'Masumeli' })
    dataSet.push({ id: '53.01.08.2013', kecamatan: '53.01.08', name: 'Mata Air' })
    dataSet.push({ id: '53.10.11.1018', kecamatan: '53.10.11', name: 'Mata Air' })
    dataSet.push({ id: '53.18.06.2011', kecamatan: '53.18.06', name: 'Mata Kapore' })
    dataSet.push({ id: '53.18.02.2004', kecamatan: '53.18.02', name: 'Mata Loko' })
    dataSet.push({ id: '53.18.10.2014', kecamatan: '53.18.10', name: 'Mata Lombu' })
    dataSet.push({ id: '53.18.03.2014', kecamatan: '53.18.03', name: 'Mata Pyawu' })
    dataSet.push({ id: '53.17.01.2025', kecamatan: '53.17.01', name: 'Mata Redi' })
    dataSet.push({ id: '53.10.18.2011', kecamatan: '53.10.18', name: 'Mata Wae' })
    dataSet.push({ id: '53.17.02.2027', kecamatan: '53.17.02', name: 'Mata Waikajawi' })
    dataSet.push({ id: '53.18.10.2012', kecamatan: '53.18.10', name: 'Mata Wee Karoro' })
    dataSet.push({ id: '53.18.03.2028', kecamatan: '53.18.03', name: 'Mata Wee Lima' })
    dataSet.push({ id: '53.17.01.2004', kecamatan: '53.17.01', name: 'Mata Woga' })
    dataSet.push({ id: '53.03.23.2003', kecamatan: '53.03.23', name: 'Matabesi' })
    dataSet.push({ id: '53.09.02.1017', kecamatan: '53.09.02', name: 'Mataloko' })
    dataSet.push({ id: '53.14.06.2017', kecamatan: '53.14.06', name: 'Matanae' })
    dataSet.push({ id: '53.05.12.2006', kecamatan: '53.05.12', name: 'Mataru Barat' })
    dataSet.push({ id: '53.05.12.2001', kecamatan: '53.05.12', name: 'Mataru Selatan' })
    dataSet.push({ id: '53.05.12.2004', kecamatan: '53.05.12', name: 'Mataru Timur' })
    dataSet.push({ id: '53.05.12.2002', kecamatan: '53.05.12', name: 'Mataru Utara' })
    dataSet.push({ id: '53.14.06.2007', kecamatan: '53.14.06', name: 'Matasio' })
    dataSet.push({ id: '53.15.04.2009', kecamatan: '53.15.04', name: 'Matawae' })
    dataSet.push({ id: '53.11.01.1003', kecamatan: '53.11.01', name: 'Matawai' })
    dataSet.push({ id: '53.11.19.2002', kecamatan: '53.11.19', name: 'Matawai Amahu' })
    dataSet.push({ id: '53.11.08.2005', kecamatan: '53.11.08', name: 'Matawai Atu' })
    dataSet.push({ id: '53.11.14.2006', kecamatan: '53.11.14', name: 'Matawai Katingga' })
    dataSet.push({ id: '53.11.14.2008', kecamatan: '53.11.14', name: 'Matawai Maringgu' })
    dataSet.push({ id: '53.11.03.2005', kecamatan: '53.11.03', name: 'Matawai Pawali' })
    dataSet.push({ id: '53.20.02.2003', kecamatan: '53.20.02', name: 'Matei' })
    dataSet.push({ id: '53.11.16.1005', kecamatan: '53.11.16', name: 'Mau Hau' })
    dataSet.push({ id: '53.08.17.2001', kecamatan: '53.08.17', name: 'Maubasa' })
    dataSet.push({ id: '53.08.17.2010', kecamatan: '53.08.17', name: 'Maubasa Barat' })
    dataSet.push({ id: '53.08.17.2002', kecamatan: '53.08.17', name: 'Maubasa Timur' })
    dataSet.push({ id: '53.03.05.1008', kecamatan: '53.03.05', name: 'Maubeli' })
    dataSet.push({ id: '53.03.21.1004', kecamatan: '53.03.21', name: 'Maubesi' })
    dataSet.push({ id: '53.14.04.2001', kecamatan: '53.14.04', name: 'Maubesi' })
    dataSet.push({ id: '53.11.07.2009', kecamatan: '53.11.07', name: 'Maubokul' })
    dataSet.push({ id: '53.04.01.2014', kecamatan: '53.04.01', name: 'Maudemu' })
    dataSet.push({ id: '53.03.07.2004', kecamatan: '53.03.07', name: 'Maukabatan' })
    dataSet.push({ id: '53.16.04.2005', kecamatan: '53.16.04', name: 'Maukeli' })
    dataSet.push({ id: '53.05.05.2014', kecamatan: '53.05.05', name: 'Maukuru' })
    dataSet.push({ id: '53.71.02.1002', kecamatan: '53.71.02', name: 'Maulafa' })
    dataSet.push({ id: '53.11.16.1004', kecamatan: '53.11.16', name: 'Mauliru' })
    dataSet.push({ id: '53.07.01.2012', kecamatan: '53.07.01', name: 'Mauloo' })
    dataSet.push({ id: '53.04.03.2003', kecamatan: '53.04.03', name: 'Maumutin' })
    dataSet.push({ id: '53.16.04.1001', kecamatan: '53.16.04', name: 'Mauponggo' })
    dataSet.push({ id: '53.11.14.2009', kecamatan: '53.11.14', name: 'Mauramba' })
    dataSet.push({ id: '53.03.14.2004', kecamatan: '53.03.14', name: 'Maurisu' })
    dataSet.push({ id: '53.03.14.2008', kecamatan: '53.03.14', name: 'Maurisu Selatan' })
    dataSet.push({ id: '53.03.14.2009', kecamatan: '53.03.14', name: 'Maurisu Tengah' })
    dataSet.push({ id: '53.03.14.2007', kecamatan: '53.03.14', name: 'Maurisu Utara' })
    dataSet.push({ id: '53.08.10.2001', kecamatan: '53.08.10', name: 'Maurole' })
    dataSet.push({ id: '53.08.15.2007', kecamatan: '53.08.15', name: 'Maurole Selatan' })
    dataSet.push({ id: '53.05.05.2012', kecamatan: '53.05.05', name: 'Mausamang' })
    dataSet.push({ id: '53.08.10.2005', kecamatan: '53.08.10', name: 'Mausambi' })
    dataSet.push({ id: '53.05.16.2002', kecamatan: '53.05.16', name: 'Mauta' })
    dataSet.push({ id: '53.08.20.1001', kecamatan: '53.08.20', name: 'Mautapaga' })
    dataSet.push({ id: '53.08.07.2003', kecamatan: '53.08.07', name: 'Mautenda' })
    dataSet.push({ id: '53.08.07.2004', kecamatan: '53.08.07', name: 'Mautenda Barat' })
    dataSet.push({ id: '53.05.14.2005', kecamatan: '53.05.14', name: 'Mawar' })
    dataSet.push({ id: '53.18.03.2026', kecamatan: '53.18.03', name: 'Mawo Dana' })
    dataSet.push({ id: '53.18.02.2012', kecamatan: '53.18.02', name: 'Mawo Maliti' })
    dataSet.push({ id: '53.16.06.2006', kecamatan: '53.16.06', name: 'Mbaenuamuri' })
    dataSet.push({ id: '53.15.01.2003', kecamatan: '53.15.01', name: 'Mbakung' })
    dataSet.push({ id: '53.14.09.2001', kecamatan: '53.14.09', name: 'Mbali Lendeiki' })
    dataSet.push({ id: '53.11.01.2013', kecamatan: '53.11.01', name: 'Mbatakapidu' })
    dataSet.push({ id: '53.11.02.2010', kecamatan: '53.11.02', name: 'Mbatapuhu' })
    dataSet.push({ id: '53.10.12.1009', kecamatan: '53.10.12', name: 'Mbaumuku' })
    dataSet.push({ id: '53.16.01.1003', kecamatan: '53.16.01', name: 'Mbay I' })
    dataSet.push({ id: '53.16.01.1007', kecamatan: '53.16.01', name: 'Mbay II' })
    dataSet.push({ id: '53.19.06.2006', kecamatan: '53.19.06', name: 'Mbengan' })
    dataSet.push({ id: '53.07.01.2004', kecamatan: '53.07.01', name: 'Mbengu' })
    dataSet.push({ id: '53.08.12.2018', kecamatan: '53.08.12', name: 'Mbewawora' })
    dataSet.push({ id: '53.17.04.2001', kecamatan: '53.17.04', name: 'Mbilur Pangadu' })
    dataSet.push({ id: '53.14.09.2003', kecamatan: '53.14.09', name: 'Mbiu Lombo' })
    dataSet.push({ id: '53.08.01.2021', kecamatan: '53.08.01', name: 'Mbobhenga' })
    dataSet.push({ id: '53.14.01.2014', kecamatan: '53.14.01', name: 'Mbokak' })
    dataSet.push({ id: '53.08.18.2008', kecamatan: '53.08.18', name: 'Mbomba' })
    dataSet.push({ id: '53.08.04.1003', kecamatan: '53.08.04', name: 'Mbongawani' })
    dataSet.push({ id: '53.08.07.2014', kecamatan: '53.08.07', name: 'Mbotulaka' })
    dataSet.push({ id: '53.08.03.2003', kecamatan: '53.08.03', name: 'Mbotutenda' })
    dataSet.push({ id: '53.14.07.2007', kecamatan: '53.14.07', name: 'Mbueain' })
    dataSet.push({ id: '53.15.06.2001', kecamatan: '53.15.06', name: 'Mbuit' })
    dataSet.push({ id: '53.08.08.2010', kecamatan: '53.08.08', name: 'Mbuliloo' })
    dataSet.push({ id: '53.08.08.2014', kecamatan: '53.08.08', name: 'Mbuliwaralau' })
    dataSet.push({ id: '53.08.08.2015', kecamatan: '53.08.08', name: 'Mbuliwaralau Utara' })
    dataSet.push({ id: '53.11.10.2004', kecamatan: '53.11.10', name: 'Mburukulu' })
    dataSet.push({ id: '53.20.01.1001', kecamatan: '53.20.01', name: 'Mebba' })
    dataSet.push({ id: '53.11.12.2002', kecamatan: '53.11.12', name: 'Mehang Mata' })
    dataSet.push({ id: '53.20.04.2002', kecamatan: '53.20.04', name: 'Mehona' })
    dataSet.push({ id: '53.07.19.2002', kecamatan: '53.07.19', name: 'Mekendetung' })
    dataSet.push({ id: '53.10.03.2020', kecamatan: '53.10.03', name: 'Meler' })
    dataSet.push({ id: '53.09.07.2013', kecamatan: '53.09.07', name: 'Meli Waru' })
    dataSet.push({ id: '53.19.02.2004', kecamatan: '53.19.02', name: 'Melo' })
    dataSet.push({ id: '53.13.06.2007', kecamatan: '53.13.06', name: 'Meluwiting' })
    dataSet.push({ id: '53.13.06.2022', kecamatan: '53.13.06', name: 'Meluwiting I' })
    dataSet.push({ id: '53.06.07.2008', kecamatan: '53.06.07', name: 'Menanga' })
    dataSet.push({ id: '53.20.01.2002', kecamatan: '53.20.01', name: 'Menia' })
    dataSet.push({ id: '53.18.04.2011', kecamatan: '53.18.04', name: 'Menne Ate' })
    dataSet.push({ id: '53.14.01.2011', kecamatan: '53.14.01', name: 'Meoain' })
    dataSet.push({ id: '53.21.08.2001', kecamatan: '53.21.08', name: 'Meotroi' })
    dataSet.push({ id: '53.01.17.2007', kecamatan: '53.01.17', name: 'Merbaun' })
    dataSet.push({ id: '53.01.06.1005', kecamatan: '53.01.06', name: 'Merdeka' })
    dataSet.push({ id: '53.05.14.2006', kecamatan: '53.05.14', name: 'Merdeka' })
    dataSet.push({ id: '53.13.04.2009', kecamatan: '53.13.04', name: 'Merdeka' })
    dataSet.push({ id: '53.71.06.1006', kecamatan: '53.71.06', name: 'Merdeka' })
    dataSet.push({ id: '53.18.06.2024', kecamatan: '53.18.06', name: 'Mere Kehe' })
    dataSet.push({ id: '53.18.10.2011', kecamatan: '53.18.10', name: 'Mereda Wuni' })
    dataSet.push({ id: '53.14.03.1011', kecamatan: '53.14.03', name: 'Metina' })
    dataSet.push({ id: '53.18.05.2010', kecamatan: '53.18.05', name: 'Milla Ate' })
    dataSet.push({ id: '53.10.05.2021', kecamatan: '53.10.05', name: 'Mocok' })
    dataSet.push({ id: '53.15.09.2015', kecamatan: '53.15.09', name: 'Modo' })
    dataSet.push({ id: '53.14.02.2007', kecamatan: '53.14.02', name: 'Modosinal' })
    dataSet.push({ id: '53.12.15.2012', kecamatan: '53.12.15', name: 'Modu Waimaringu' })
    dataSet.push({ id: '53.06.03.2019', kecamatan: '53.06.03', name: 'Mokantarak' })
    dataSet.push({ id: '53.14.03.1009', kecamatan: '53.14.03', name: 'Mokdale' })
    dataSet.push({ id: '53.19.06.2009', kecamatan: '53.19.06', name: 'Mokel' })
    dataSet.push({ id: '53.19.06.2019', kecamatan: '53.19.06', name: 'Mokel Morid' })
    dataSet.push({ id: '53.08.17.2006', kecamatan: '53.08.17', name: 'Mole' })
    dataSet.push({ id: '53.20.05.2002', kecamatan: '53.20.05', name: 'Molie' })
    dataSet.push({ id: '53.15.08.2008', kecamatan: '53.15.08', name: 'Momol' })
    dataSet.push({ id: '53.11.20.2004', kecamatan: '53.11.20', name: 'Mondu' })
    dataSet.push({ id: '53.11.18.2004', kecamatan: '53.11.18', name: 'Mondulambi' })
    dataSet.push({ id: '53.05.03.2014', kecamatan: '53.05.03', name: 'Moramam' })
    dataSet.push({ id: '53.05.03.2007', kecamatan: '53.05.03', name: 'Morba' })
    dataSet.push({ id: '53.18.08.2022', kecamatan: '53.18.08', name: 'Moro Manduyo' })
    dataSet.push({ id: '53.05.03.1001', kecamatan: '53.05.03', name: 'Moru' })
    dataSet.push({ id: '53.19.09.2013', kecamatan: '53.19.09', name: 'Mosi Ngaran' })
    dataSet.push({ id: '53.21.02.2013', kecamatan: '53.21.02', name: 'Motaain' })
    dataSet.push({ id: '53.03.07.2001', kecamatan: '53.03.07', name: 'Motadik' })
    dataSet.push({ id: '53.21.02.2001', kecamatan: '53.21.02', name: 'Motaulun' })
    dataSet.push({ id: '53.05.01.2014', kecamatan: '53.05.01', name: 'Motongbang' })
    dataSet.push({ id: '53.06.07.2005', kecamatan: '53.06.07', name: 'Motonwutun' })
    dataSet.push({ id: '53.06.11.2007', kecamatan: '53.06.11', name: 'Muda' })
    dataSet.push({ id: '53.06.04.2008', kecamatan: '53.06.04', name: 'Mudakaputu' })
    dataSet.push({ id: '53.01.20.2004', kecamatan: '53.01.20', name: 'Muke' })
    dataSet.push({ id: '53.21.05.2019', kecamatan: '53.21.05', name: 'Muke' })
    dataSet.push({ id: '53.14.06.2001', kecamatan: '53.14.06', name: 'Mukekuku' })
    dataSet.push({ id: '53.08.21.2002', kecamatan: '53.08.21', name: 'Mukureku' })
    dataSet.push({ id: '53.08.21.2013', kecamatan: '53.08.21', name: "Mukureku Sa'ate" })
    dataSet.push({ id: '53.08.07.2010', kecamatan: '53.08.07', name: 'Mukusaki' })
    dataSet.push({ id: '53.16.03.2014', kecamatan: '53.16.03', name: 'Mulakoli' })
    dataSet.push({ id: '53.05.06.2011', kecamatan: '53.05.06', name: 'Munaseli' })
    dataSet.push({ id: '53.14.02.2024', kecamatan: '53.14.02', name: 'Mundek' })
    dataSet.push({ id: '53.08.11.2008', kecamatan: '53.08.11', name: 'Mundinggasa' })
    dataSet.push({ id: '53.07.18.2007', kecamatan: '53.07.18', name: 'Munerana' })
    dataSet.push({ id: '53.15.09.2004', kecamatan: '53.15.09', name: 'Munting' })
    dataSet.push({ id: '53.05.16.2003', kecamatan: '53.05.16', name: 'Muriabang' })
    dataSet.push({ id: '53.13.03.2018', kecamatan: '53.13.03', name: 'Muruona' })
    dataSet.push({ id: '53.05.01.1010', kecamatan: '53.05.01', name: 'Mutiara' })
    dataSet.push({ id: '53.11.08.2006', kecamatan: '53.11.08', name: 'Mutunggeding' })
    dataSet.push({ id: '53.03.11.2005', kecamatan: '53.03.11', name: 'N i a n' })
    dataSet.push({ id: '53.21.02.2016', kecamatan: '53.21.02', name: 'Naas' })
    dataSet.push({ id: '53.20.01.2004', kecamatan: '53.20.01', name: 'Naawawi' })
    dataSet.push({ id: '53.08.11.2006', kecamatan: '53.08.11', name: 'Nabe' })
    dataSet.push({ id: '53.09.15.2007', kecamatan: '53.09.15', name: 'Nabelena' })
    dataSet.push({ id: '53.21.05.2016', kecamatan: '53.21.05', name: 'Nabutaek' })
    dataSet.push({ id: '53.03.13.2002', kecamatan: '53.03.13', name: 'Naekake A' })
    dataSet.push({ id: '53.03.13.2003', kecamatan: '53.03.13', name: 'Naekake B' })
    dataSet.push({ id: '53.04.04.2002', kecamatan: '53.04.04', name: 'Naekasa' })
    dataSet.push({ id: '53.21.05.2008', kecamatan: '53.21.05', name: 'Naet' })
    dataSet.push({ id: '53.16.03.1005', kecamatan: '53.16.03', name: 'Nageoga' })
    dataSet.push({ id: '53.16.03.2008', kecamatan: '53.16.03', name: 'Nagerawe' })
    dataSet.push({ id: '53.16.03.1003', kecamatan: '53.16.03', name: 'Nagesapadhi' })
    dataSet.push({ id: '53.01.06.1003', kecamatan: '53.01.06', name: 'Naibonat' })
    dataSet.push({ id: '53.21.07.2003', kecamatan: '53.21.07', name: 'Naibone' })
    dataSet.push({ id: '53.01.23.2005', kecamatan: '53.01.23', name: 'Naikean' })
    dataSet.push({ id: '53.01.13.1002', kecamatan: '53.01.13', name: 'Naikliu' })
    dataSet.push({ id: '53.71.02.1009', kecamatan: '53.71.02', name: 'Naikolan' })
    dataSet.push({ id: '53.71.05.1005', kecamatan: '53.71.05', name: 'Naikoten Dua' })
    dataSet.push({ id: '53.71.05.1004', kecamatan: '53.71.05', name: 'Naikoten Satu' })
    dataSet.push({ id: '53.05.08.2005', kecamatan: '53.05.08', name: 'Nailang' })
    dataSet.push({ id: '53.21.01.2010', kecamatan: '53.21.01', name: 'Naimana' })
    dataSet.push({ id: '53.71.02.1004', kecamatan: '53.71.02', name: 'Naimata' })
    dataSet.push({ id: '53.03.16.2003', kecamatan: '53.03.16', name: 'Nainaban' })
    dataSet.push({ id: '53.03.14.2003', kecamatan: '53.03.14', name: 'Naiola' })
    dataSet.push({ id: '53.03.14.2010', kecamatan: '53.03.14', name: 'Naiola Timur' })
    dataSet.push({ id: '53.71.01.1011', kecamatan: '53.71.01', name: 'Naioni' })
    dataSet.push({ id: '53.21.07.2009', kecamatan: '53.21.07', name: 'Naisau' })
    dataSet.push({ id: '53.01.27.2005', kecamatan: '53.01.27', name: 'Naitae' })
    dataSet.push({ id: '53.04.04.2007', kecamatan: '53.04.04', name: 'Naitimu' })
    dataSet.push({ id: '53.21.05.2020', kecamatan: '53.21.05', name: 'Naiusu' })
    dataSet.push({ id: '53.08.08.2021', kecamatan: '53.08.08', name: 'Nakambara' })
    dataSet.push({ id: '53.03.24.2001', kecamatan: '53.03.24', name: 'Naku' })
    dataSet.push({ id: '53.08.03.2011', kecamatan: '53.08.03', name: 'Nakuramba' })
    dataSet.push({ id: '53.07.10.2008', kecamatan: '53.07.10', name: 'Namangkewa' })
    dataSet.push({ id: '53.14.03.1001', kecamatan: '53.14.03', name: 'Namodale' })
    dataSet.push({ id: '53.71.01.1001', kecamatan: '53.71.01', name: 'Namosain' })
    dataSet.push({ id: '53.15.04.2011', kecamatan: '53.15.04', name: 'Nampar Macing' })
    dataSet.push({ id: '53.19.04.2012', kecamatan: '53.19.04', name: 'Nampar Sepang' })
    dataSet.push({ id: '53.19.03.2005', kecamatan: '53.19.03', name: 'Nampar Tabang' })
    dataSet.push({ id: '53.04.23.2004', kecamatan: '53.04.23', name: 'Nanaenoe' })
    dataSet.push({ id: '53.04.23.2002', kecamatan: '53.04.23', name: 'Nanaet' })
    dataSet.push({ id: '53.21.05.2018', kecamatan: '53.21.05', name: 'Nanebot' })
    dataSet.push({ id: '53.19.04.1011', kecamatan: '53.19.04', name: 'Nanga Baras' })
    dataSet.push({ id: '53.19.04.2001', kecamatan: '53.19.04', name: 'Nanga Baur' })
    dataSet.push({ id: '53.15.09.2009', kecamatan: '53.15.09', name: 'Nanga Bere' })
    dataSet.push({ id: '53.15.01.2008', kecamatan: '53.15.01', name: 'Nanga Kantor' })
    dataSet.push({ id: '53.19.01.2001', kecamatan: '53.19.01', name: 'Nanga Labang' })
    dataSet.push({ id: '53.15.09.2008', kecamatan: '53.15.09', name: 'Nanga Lili' })
    dataSet.push({ id: '53.19.04.2002', kecamatan: '53.19.04', name: 'Nanga Mbaling' })
    dataSet.push({ id: '53.19.09.2008', kecamatan: '53.19.09', name: 'Nanga Meje' })
    dataSet.push({ id: '53.19.09.2014', kecamatan: '53.19.09', name: 'Nanga Puun' })
    dataSet.push({ id: '53.16.01.2018', kecamatan: '53.16.01', name: 'Nangadhero' })
    dataSet.push({ id: '53.07.08.2010', kecamatan: '53.07.08', name: 'Nangahale' })
    dataSet.push({ id: '53.07.05.1007', kecamatan: '53.07.05', name: 'Nangalimang' })
    dataSet.push({ id: '53.09.09.1011', kecamatan: '53.09.09', name: 'Nangamese' })
    dataSet.push({ id: '53.07.15.1003', kecamatan: '53.07.15', name: 'Nangameting' })
    dataSet.push({ id: '53.08.05.2016', kecamatan: '53.08.05', name: 'Nanganesa' })
    dataSet.push({ id: '53.16.02.1001', kecamatan: '53.16.02', name: 'Nangaroro' })
    dataSet.push({ id: '53.07.09.2008', kecamatan: '53.07.09', name: 'Nangatobong' })
    dataSet.push({ id: '53.11.13.2005', kecamatan: '53.11.13', name: 'Nangga' })
    dataSet.push({ id: '53.18.08.2020', kecamatan: '53.18.08', name: 'Nangga Mutu' })
    dataSet.push({ id: '53.21.05.2004', kecamatan: '53.21.05', name: 'Nanin' })
    dataSet.push({ id: '53.03.08.2005', kecamatan: '53.03.08', name: 'Nansean' })
    dataSet.push({ id: '53.03.08.2028', kecamatan: '53.03.08', name: 'Nansean Timur' })
    dataSet.push({ id: '53.15.02.1023', kecamatan: '53.15.02', name: 'Nantal' })
    dataSet.push({ id: '53.10.18.2008', kecamatan: '53.10.18', name: 'Nao' })
    dataSet.push({ id: '53.03.10.2001', kecamatan: '53.03.10', name: 'Naob' })
    dataSet.push({ id: '53.03.17.2007', kecamatan: '53.03.17', name: 'Napan' })
    dataSet.push({ id: '53.13.03.2007', kecamatan: '53.13.03', name: 'Napasabok' })
    dataSet.push({ id: '53.11.02.2009', kecamatan: '53.11.02', name: 'Napu' })
    dataSet.push({ id: '53.06.10.2008', kecamatan: '53.06.10', name: 'Narasaosina' })
    dataSet.push({ id: '53.09.06.2005', kecamatan: '53.09.06', name: 'Naru' })
    dataSet.push({ id: '53.09.12.2004', kecamatan: '53.09.12', name: 'Naruwolo' })
    dataSet.push({ id: '53.09.12.2007', kecamatan: '53.09.12', name: 'Naruwolo I' })
    dataSet.push({ id: '53.09.12.2008', kecamatan: '53.09.12', name: 'Naruwolo II' })
    dataSet.push({ id: '53.07.21.2003', kecamatan: '53.07.21', name: 'Natakoli' })
    dataSet.push({ id: '53.16.03.1001', kecamatan: '53.16.03', name: 'Natanage' })
    dataSet.push({ id: '53.16.03.1021', kecamatan: '53.16.03', name: 'Natanage Timur' })
    dataSet.push({ id: '53.08.11.2011', kecamatan: '53.08.11', name: 'Natanangge' })
    dataSet.push({ id: '53.07.13.2001', kecamatan: '53.07.13', name: 'Natarmage' })
    dataSet.push({ id: '53.16.05.2005', kecamatan: '53.16.05', name: 'Natatoto' })
    dataSet.push({ id: '53.16.02.2012', kecamatan: '53.16.02', name: 'Nataute' })
    dataSet.push({ id: '53.10.15.2007', kecamatan: '53.10.15', name: 'Nati' })
    dataSet.push({ id: '53.21.08.2007', kecamatan: '53.21.08', name: 'Nauke Kusa' })
    dataSet.push({ id: '53.01.10.2008', kecamatan: '53.01.10', name: 'Naunnu' })
    dataSet.push({ id: '53.06.01.2007', kecamatan: '53.06.01', name: 'Nawokote' })
    dataSet.push({ id: '53.06.09.2003', kecamatan: '53.06.09', name: 'Nayubaya' })
    dataSet.push({ id: '53.14.09.2005', kecamatan: '53.14.09', name: 'Ndaonuse' })
    dataSet.push({ id: '53.11.20.2005', kecamatan: '53.11.20', name: 'Ndapayami' })
    dataSet.push({ id: '53.10.01.2005', kecamatan: '53.10.01', name: 'Ndehes' })
    dataSet.push({ id: '53.08.21.2005', kecamatan: '53.08.21', name: 'Ndenggarongge' })
    dataSet.push({ id: '53.08.03.2007', kecamatan: '53.08.03', name: 'Ndetundora I' })
    dataSet.push({ id: '53.08.03.2008', kecamatan: '53.08.03', name: 'Ndetundora II' })
    dataSet.push({ id: '53.08.03.2019', kecamatan: '53.08.03', name: 'Ndetundora III' })
    dataSet.push({ id: '53.08.01.2014', kecamatan: '53.08.01', name: 'Ndeturea' })
    dataSet.push({ id: '53.08.21.2006', kecamatan: '53.08.21', name: 'Ndikosapu' })
    dataSet.push({ id: '53.08.06.2019', kecamatan: '53.08.06', name: 'Ndito' })
    dataSet.push({ id: '53.10.15.2008', kecamatan: '53.10.15', name: 'Ndiwar' })
    dataSet.push({ id: '53.08.13.2005', kecamatan: '53.08.13', name: 'Ndondo' })
    dataSet.push({ id: '53.08.02.2004', kecamatan: '53.08.02', name: 'Ndoriwoi' })
    dataSet.push({ id: '53.08.01.1001', kecamatan: '53.08.01', name: 'Ndorurea' })
    dataSet.push({ id: '53.08.01.2015', kecamatan: '53.08.01', name: 'Ndorurea I' })
    dataSet.push({ id: '53.15.08.2005', kecamatan: '53.15.08', name: 'Ndoso' })
    dataSet.push({ id: '53.08.14.2002', kecamatan: '53.08.14', name: 'Nduaria' })
    dataSet.push({ id: '53.08.20.2004', kecamatan: '53.08.20', name: 'Ndungga' })
    dataSet.push({ id: '53.07.08.2006', kecamatan: '53.07.08', name: 'Nebe' })
    dataSet.push({ id: '53.71.06.1010', kecamatan: '53.71.06', name: 'Nefonaek' })
    dataSet.push({ id: '53.01.21.2003', kecamatan: '53.01.21', name: 'Nefoneut' })
    dataSet.push({ id: '53.01.17.2006', kecamatan: '53.01.17', name: 'Nekbaun' })
    dataSet.push({ id: '53.01.18.2003', kecamatan: '53.01.18', name: 'Nekmese' })
    dataSet.push({ id: '53.06.13.2010', kecamatan: '53.06.13', name: 'Neleblolong' })
    dataSet.push({ id: '53.06.13.2015', kecamatan: '53.06.13', name: 'Nelelamadike' })
    dataSet.push({ id: '53.06.13.2013', kecamatan: '53.06.13', name: 'Nelelamawangi' })
    dataSet.push({ id: '53.06.13.2021', kecamatan: '53.06.13', name: 'Nelelamawangi Dua' })
    dataSet.push({ id: '53.06.13.2008', kecamatan: '53.06.13', name: 'Nelereren' })
    dataSet.push({ id: '53.07.07.2005', kecamatan: '53.07.07', name: 'Nella Lorang' })
    dataSet.push({ id: '53.07.07.2004', kecamatan: '53.07.07', name: 'Nelle Barat' })
    dataSet.push({ id: '53.07.07.2002', kecamatan: '53.07.07', name: 'Nelle Urung' })
    dataSet.push({ id: '53.07.07.2003', kecamatan: '53.07.07', name: 'Nelle Wutung' })
    dataSet.push({ id: '53.14.07.2002', kecamatan: '53.14.07', name: 'Nemberala' })
    dataSet.push({ id: '53.08.03.2033', kecamatan: '53.08.03', name: 'Nemboramba' })
    dataSet.push({ id: '53.07.20.2002', kecamatan: '53.07.20', name: 'Nenbura' })
    dataSet.push({ id: '53.09.12.2005', kecamatan: '53.09.12', name: 'Nenowea' })
    dataSet.push({ id: '53.10.06.2001', kecamatan: '53.10.06', name: 'Nenu' })
    dataSet.push({ id: '53.03.11.2004', kecamatan: '53.03.11', name: 'Neonasi' })
    dataSet.push({ id: '53.03.02.2018', kecamatan: '53.03.02', name: 'Neotoko' })
    dataSet.push({ id: '53.08.13.2016', kecamatan: '53.08.13', name: 'Neotonda' })
    dataSet.push({ id: '53.01.26.2005', kecamatan: '53.01.26', name: 'Netemnanu' })
    dataSet.push({ id: '53.01.26.2003', kecamatan: '53.01.26', name: 'Netemnanu Selatan' })
    dataSet.push({ id: '53.01.26.2004', kecamatan: '53.01.26', name: 'Netemnanu Utara' })
    dataSet.push({ id: '53.14.02.2009', kecamatan: '53.14.02', name: 'Netenaen' })
    dataSet.push({ id: '53.09.07.2014', kecamatan: '53.09.07', name: 'Ngabheo' })
    dataSet.push({ id: '53.17.04.2010', kecamatan: '53.17.04', name: 'Ngadu Bolu' })
    dataSet.push({ id: '53.17.04.2016', kecamatan: '53.17.04', name: 'Ngadu Olu' })
    dataSet.push({ id: '53.12.04.2004', kecamatan: '53.12.04', name: 'Ngadu Pada' })
    dataSet.push({ id: '53.11.04.2012', kecamatan: '53.11.04', name: 'Ngadulanggi' })
    dataSet.push({ id: '53.08.10.2021', kecamatan: '53.08.10', name: 'Ngalukoja' })
    dataSet.push({ id: '53.08.05.2007', kecamatan: '53.08.05', name: 'Ngalupolo' })
    dataSet.push({ id: '53.08.05.2012', kecamatan: '53.08.05', name: 'Ngaluroga' })
    dataSet.push({ id: '53.19.01.2006', kecamatan: '53.19.01', name: 'Ngampang Mas' })
    dataSet.push({ id: '53.15.03.2025', kecamatan: '53.15.03', name: 'Ngancar' })
    dataSet.push({ id: '53.09.14.2005', kecamatan: '53.09.14', name: 'Ngara' })
    dataSet.push({ id: '53.11.08.2010', kecamatan: '53.11.08', name: 'Ngaru Kanoru' })
    dataSet.push({ id: '53.09.06.1018', kecamatan: '53.09.06', name: 'Ngedukelu' })
    dataSet.push({ id: '53.16.01.2015', kecamatan: '53.16.01', name: 'Ngegedhawe' })
    dataSet.push({ id: '53.16.06.2012', kecamatan: '53.16.06', name: 'Ngera' })
    dataSet.push({ id: '53.10.16.2005', kecamatan: '53.10.16', name: 'Nggalak' })
    dataSet.push({ id: '53.19.02.1028', kecamatan: '53.19.02', name: 'Nggalak Leleng' })
    dataSet.push({ id: '53.08.09.2006', kecamatan: '53.08.09', name: 'Nggela' })
    dataSet.push({ id: '53.14.08.2006', kecamatan: '53.14.08', name: 'Nggelodae' })
    dataSet.push({ id: '53.08.15.2001', kecamatan: '53.08.15', name: 'Nggesa' })
    dataSet.push({ id: '53.08.15.2012', kecamatan: '53.08.15', name: 'Nggesabiri' })
    dataSet.push({ id: '53.15.01.2004', kecamatan: '53.15.01', name: 'Nggilat' })
    dataSet.push({ id: '53.14.04.2003', kecamatan: '53.14.04', name: 'Nggodimeda' })
    dataSet.push({ id: '53.16.01.2017', kecamatan: '53.16.01', name: 'Nggolombay' })
    dataSet.push({ id: '53.16.01.2006', kecamatan: '53.16.01', name: 'Nggolonio' })
    dataSet.push({ id: '53.11.13.2001', kecamatan: '53.11.13', name: 'Nggongi' })
    dataSet.push({ id: '53.15.05.2016', kecamatan: '53.15.05', name: 'Nggorang' })
    dataSet.push({ id: '53.08.01.2009', kecamatan: '53.08.01', name: 'Nggorea' })
    dataSet.push({ id: '53.08.21.2001', kecamatan: '53.08.21', name: 'Nggumbelaka' })
    dataSet.push({ id: '53.08.16.2006', kecamatan: '53.08.16', name: 'Ngguwa' })
    dataSet.push({ id: '53.09.16.2001', kecamatan: '53.09.16', name: 'Nginamanu' })
    dataSet.push({ id: '53.09.16.2006', kecamatan: '53.09.16', name: 'Nginamanu Barat' })
    dataSet.push({ id: '53.09.16.2005', kecamatan: '53.09.16', name: 'Nginamanu Selatan' })
    dataSet.push({ id: '53.10.05.2032', kecamatan: '53.10.05', name: 'Ngkaer' })
    dataSet.push({ id: '53.19.08.2007', kecamatan: '53.19.08', name: 'Ngkiong Dora' })
    dataSet.push({ id: '53.09.06.2026', kecamatan: '53.09.06', name: 'Ngoranale' })
    dataSet.push({ id: '53.03.04.2009', kecamatan: '53.03.04', name: 'Nibaaf' })
    dataSet.push({ id: '53.08.15.2006', kecamatan: '53.08.15', name: 'Nida' })
    dataSet.push({ id: '53.03.04.1012', kecamatan: '53.03.04', name: 'Nifuboke' })
    dataSet.push({ id: '53.03.20.2010', kecamatan: '53.03.20', name: 'Nifunenas' })
    dataSet.push({ id: '53.03.07.2009', kecamatan: '53.03.07', name: 'Nifutasi' })
    dataSet.push({ id: '53.08.05.2013', kecamatan: '53.08.05', name: 'Nila' })
    dataSet.push({ id: '53.13.06.2002', kecamatan: '53.13.06', name: 'Nilanapo' })
    dataSet.push({ id: '53.06.01.2011', kecamatan: '53.06.01', name: 'Nileknoheng' })
    dataSet.push({ id: '53.03.16.2005', kecamatan: '53.03.16', name: 'Nilulat' })
    dataSet.push({ id: '53.03.15.2003', kecamatan: '53.03.15', name: 'Nimasi' })
    dataSet.push({ id: '53.06.08.2032', kecamatan: '53.06.08', name: 'Nimun Danibao' })
    dataSet.push({ id: '53.09.12.2010', kecamatan: '53.09.12', name: 'Nio Lewa' })
    dataSet.push({ id: '53.08.13.2006', kecamatan: '53.08.13', name: 'Niopanda' })
    dataSet.push({ id: '53.08.06.2007', kecamatan: '53.08.06', name: 'Niowula' })
    dataSet.push({ id: '53.08.08.2022', kecamatan: '53.08.08', name: 'Niramesi' })
    dataSet.push({ id: '53.07.04.2011', kecamatan: '53.07.04', name: 'Nirangkliung' })
    dataSet.push({ id: '53.08.10.2022', kecamatan: '53.08.10', name: 'Niranusa' })
    dataSet.push({ id: '53.09.18.2008', kecamatan: '53.09.18', name: 'Nirmala' })
    dataSet.push({ id: '53.06.17.2005', kecamatan: '53.06.17', name: 'Nisa Nulan' })
    dataSet.push({ id: '53.06.11.2006', kecamatan: '53.06.11', name: 'Nisakarang' })
    dataSet.push({ id: '53.07.04.2001', kecamatan: '53.07.04', name: 'Nita' })
    dataSet.push({ id: '53.07.04.2005', kecamatan: '53.07.04', name: 'Nitakloang' })
    dataSet.push({ id: '53.21.05.2010', kecamatan: '53.21.05', name: 'Niti' })
    dataSet.push({ id: '53.01.05.2009', kecamatan: '53.01.05', name: 'Nitneo' })
    dataSet.push({ id: '53.07.06.2005', kecamatan: '53.07.06', name: 'Nitunglea' })
    dataSet.push({ id: '53.01.17.2004', kecamatan: '53.01.17', name: 'Niukbaun' })
    dataSet.push({ id: '53.01.25.2007', kecamatan: '53.01.25', name: 'Niunbaun' })
    dataSet.push({ id: '53.06.13.2020', kecamatan: '53.06.13', name: 'Nobo' })
    dataSet.push({ id: '53.06.16.2004', kecamatan: '53.06.16', name: 'Nobokonga' })
    dataSet.push({ id: '53.03.04.2002', kecamatan: '53.03.04', name: 'Noebaun' })
    dataSet.push({ id: '53.01.08.2008', kecamatan: '53.01.08', name: 'Noelbaki' })
    dataSet.push({ id: '53.03.13.2004', kecamatan: '53.03.13', name: 'Noelelo' })
    dataSet.push({ id: '53.01.11.2001', kecamatan: '53.01.11', name: 'Noelmina' })
    dataSet.push({ id: '53.03.04.1013', kecamatan: '53.03.04', name: 'Noemuti' })
    dataSet.push({ id: '53.03.02.2001', kecamatan: '53.03.02', name: 'Noepesu' })
    dataSet.push({ id: '53.13.02.2014', kecamatan: '53.13.02', name: 'Nogo Doni' })
    dataSet.push({ id: '53.18.08.2007', kecamatan: '53.18.08', name: 'Noha' })
    dataSet.push({ id: '53.01.28.2002', kecamatan: '53.01.28', name: 'Nonbaun' })
    dataSet.push({ id: '53.01.09.1002', kecamatan: '53.01.09', name: 'Nonbes' })
    dataSet.push({ id: '53.03.07.2002', kecamatan: '53.03.07', name: 'Nonotbatan' })
    dataSet.push({ id: '53.13.06.2014', kecamatan: '53.13.06', name: 'Normal' })
    dataSet.push({ id: '53.13.06.2021', kecamatan: '53.13.06', name: 'Normal I' })
    dataSet.push({ id: '53.08.12.2015', kecamatan: '53.08.12', name: 'Nua Lima' })
    dataSet.push({ id: '53.08.03.2031', kecamatan: '53.08.03', name: 'Nuaja' })
    dataSet.push({ id: '53.04.18.2003', kecamatan: '53.04.18', name: 'Nualain' })
    dataSet.push({ id: '53.08.08.2017', kecamatan: '53.08.08', name: 'Nualise' })
    dataSet.push({ id: '53.08.09.2005', kecamatan: '53.08.09', name: 'Nuamulu' })
    dataSet.push({ id: '53.08.14.2003', kecamatan: '53.08.14', name: 'Nuamuri' })
    dataSet.push({ id: '53.08.13.2017', kecamatan: '53.08.13', name: 'Nuanaga' })
    dataSet.push({ id: '53.08.07.2002', kecamatan: '53.08.07', name: 'Nuangenda' })
    dataSet.push({ id: '53.08.06.2009', kecamatan: '53.08.06', name: 'Nuaone' })
    dataSet.push({ id: '53.01.27.2002', kecamatan: '53.01.27', name: 'Nuataus' })
    dataSet.push({ id: '53.13.02.2013', kecamatan: '53.13.02', name: 'Nuba Atalojo' })
    dataSet.push({ id: '53.13.02.2015', kecamatan: '53.13.02', name: 'Nubaboli' })
    dataSet.push({ id: '53.13.02.2005', kecamatan: '53.13.02', name: 'Nubahaeraka' })
    dataSet.push({ id: '53.06.18.2005', kecamatan: '53.06.18', name: 'Nubalema' })
    dataSet.push({ id: '53.06.18.2013', kecamatan: '53.06.18', name: 'Nubalema Dua' })
    dataSet.push({ id: '53.13.05.2007', kecamatan: '53.13.05', name: 'Nubamado' })
    dataSet.push({ id: '53.10.13.2018', kecamatan: '53.10.13', name: 'Nuca Molas' })
    dataSet.push({ id: '53.05.14.2001', kecamatan: '53.05.14', name: 'Nule' })
    dataSet.push({ id: '53.08.07.2015', kecamatan: '53.08.07', name: 'Numba' })
    dataSet.push({ id: '53.21.09.2004', kecamatan: '53.21.09', name: 'Numponi' })
    dataSet.push({ id: '53.71.01.1003', kecamatan: '53.71.01', name: 'Nunbaun Delha' })
    dataSet.push({ id: '53.71.01.1002', kecamatan: '53.71.01', name: 'Nunbaun Sabu' })
    dataSet.push({ id: '53.71.01.1004', kecamatan: '53.71.01', name: 'Nunhila' })
    dataSet.push({ id: '53.01.06.2002', kecamatan: '53.01.06', name: 'Nunkurus' })
    dataSet.push({ id: '53.71.05.1007', kecamatan: '53.71.05', name: 'Nunleu' })
    dataSet.push({ id: '53.01.20.2003', kecamatan: '53.01.20', name: 'Nunmafo' })
    dataSet.push({ id: '53.03.08.1016', kecamatan: '53.03.08', name: 'Nunmafo' })
    dataSet.push({ id: '53.01.28.2003', kecamatan: '53.01.28', name: 'Nunsaen' })
    dataSet.push({ id: '53.01.26.2001', kecamatan: '53.01.26', name: 'Nunuanah' })
    dataSet.push({ id: '53.05.07.2009', kecamatan: '53.05.07', name: 'Nur Benlelang' })
    dataSet.push({ id: '53.06.16.2003', kecamatan: '53.06.16', name: 'Nurri' })
    dataSet.push({ id: '53.05.01.1006', kecamatan: '53.05.01', name: 'Nusa Kenari' })
    dataSet.push({ id: '53.06.05.2017', kecamatan: '53.06.05', name: 'Nusa Nipa' })
    dataSet.push({ id: '53.06.06.2005', kecamatan: '53.06.06', name: 'Nusadani' })
    dataSet.push({ id: '53.14.05.2001', kecamatan: '53.14.05', name: 'Nusakdale' })
    dataSet.push({ id: '53.14.09.2004', kecamatan: '53.14.09', name: 'Nuse' })
    dataSet.push({ id: '53.18.03.2023', kecamatan: '53.18.03', name: 'Nyura Lele' })
    dataSet.push({ id: '53.05.02.2022', kecamatan: '53.05.02', name: "O'a Mate" })
    dataSet.push({ id: '53.03.20.2009', kecamatan: '53.03.20', name: 'Oabikase' })
    dataSet.push({ id: '53.21.02.2014', kecamatan: '53.21.02', name: 'Oan Mane' })
    dataSet.push({ id: '53.01.16.2010', kecamatan: '53.01.16', name: 'Oben' })
    dataSet.push({ id: '53.18.02.2009', kecamatan: '53.18.02', name: 'Odi Paurata' })
    dataSet.push({ id: '53.71.06.1007', kecamatan: '53.71.06', name: 'Oeba' })
    dataSet.push({ id: '53.14.01.2012', kecamatan: '53.14.01', name: 'Oebafok' })
    dataSet.push({ id: '53.14.01.2013', kecamatan: '53.14.01', name: 'Oebatu' })
    dataSet.push({ id: '53.14.05.2005', kecamatan: '53.14.05', name: 'Oebau' })
    dataSet.push({ id: '53.14.02.2015', kecamatan: '53.14.02', name: 'Oebela' })
    dataSet.push({ id: '53.01.08.2010', kecamatan: '53.01.08', name: 'Oebelo' })
    dataSet.push({ id: '53.01.19.2001', kecamatan: '53.01.19', name: 'Oebesi' })
    dataSet.push({ id: '53.71.04.1001', kecamatan: '53.71.04', name: 'Oebobo' })
    dataSet.push({ id: '53.01.10.2009', kecamatan: '53.01.10', name: 'Oebola' })
    dataSet.push({ id: '53.01.10.2014', kecamatan: '53.01.10', name: 'Oebola Dalam' })
    dataSet.push({ id: '53.14.02.2020', kecamatan: '53.14.02', name: 'Oebole' })
    dataSet.push({ id: '53.14.01.2006', kecamatan: '53.14.01', name: 'Oebou' })
    dataSet.push({ id: '53.71.04.1009', kecamatan: '53.71.04', name: 'Oebufu' })
    dataSet.push({ id: '53.01.06.2007', kecamatan: '53.01.06', name: 'Oefafi' })
    dataSet.push({ id: '53.01.25.2006', kecamatan: '53.01.25', name: 'Oefeto' })
    dataSet.push({ id: '53.03.21.2007', kecamatan: '53.03.21', name: 'Oehalo' })
    dataSet.push({ id: '53.14.01.2008', kecamatan: '53.14.01', name: 'Oehandi' })
    dataSet.push({ id: '53.21.05.2006', kecamatan: '53.21.05', name: 'Oekmurak' })
    dataSet.push({ id: '53.03.22.2003', kecamatan: '53.03.22', name: 'Oekopa' })
    dataSet.push({ id: '53.03.14.1001', kecamatan: '53.03.14', name: 'Oelami' })
    dataSet.push({ id: '53.14.01.2017', kecamatan: '53.14.01', name: 'Oelasin' })
    dataSet.push({ id: '53.01.06.2018', kecamatan: '53.01.06', name: 'Oelatimo' })
    dataSet.push({ id: '53.01.12.2002', kecamatan: '53.01.12', name: 'Oelbanu' })
    dataSet.push({ id: '53.01.28.2001', kecamatan: '53.01.28', name: 'Oelbiteno' })
    dataSet.push({ id: '53.03.15.2004', kecamatan: '53.03.15', name: 'Oelbonak' })
    dataSet.push({ id: '53.14.05.2006', kecamatan: '53.14.05', name: 'Oeledo' })
    dataSet.push({ id: '53.14.03.2018', kecamatan: '53.14.03', name: 'Oeleka' })
    dataSet.push({ id: '53.01.24.2004', kecamatan: '53.01.24', name: 'Oeletsala' })
    dataSet.push({ id: '53.01.22.2003', kecamatan: '53.01.22', name: 'Oelfatu' })
    dataSet.push({ id: '53.01.11.2004', kecamatan: '53.01.11', name: 'Oelnaineno' })
    dataSet.push({ id: '53.01.08.2006', kecamatan: '53.01.08', name: 'Oelnasi' })
    dataSet.push({ id: '53.03.12.2001', kecamatan: '53.03.12', name: 'Oelneke' })
    dataSet.push({ id: '53.14.07.2006', kecamatan: '53.14.07', name: 'Oelolok' })
    dataSet.push({ id: '53.01.16.2001', kecamatan: '53.01.16', name: 'Oelomin' })
    dataSet.push({ id: '53.01.08.2009', kecamatan: '53.01.08', name: 'Oelpuah' })
    dataSet.push({ id: '53.01.24.2001', kecamatan: '53.01.24', name: 'Oeltuah' })
    dataSet.push({ id: '53.14.02.2006', kecamatan: '53.14.02', name: 'Oelua' })
    dataSet.push({ id: '53.14.03.2010', kecamatan: '53.14.03', name: 'Oelunggu' })
    dataSet.push({ id: '53.03.07.2008', kecamatan: '53.03.07', name: 'Oemanu' })
    dataSet.push({ id: '53.01.16.2003', kecamatan: '53.01.16', name: 'Oemasi' })
    dataSet.push({ id: '53.14.03.2012', kecamatan: '53.14.03', name: 'Oematamboli' })
    dataSet.push({ id: '53.01.05.2007', kecamatan: '53.01.05', name: 'Oematnunu' })
    dataSet.push({ id: '53.01.20.2002', kecamatan: '53.01.20', name: 'Oemofa' })
    dataSet.push({ id: '53.01.20.2008', kecamatan: '53.01.20', name: 'Oemolo' })
    dataSet.push({ id: '53.01.05.2012', kecamatan: '53.01.05', name: 'Oenaek' })
    dataSet.push({ id: '53.21.08.2009', kecamatan: '53.21.08', name: 'Oenaek' })
    dataSet.push({ id: '53.03.03.2002', kecamatan: '53.03.03', name: 'Oenaem' })
    dataSet.push({ id: '53.03.19.2004', kecamatan: '53.03.19', name: 'Oenain' })
    dataSet.push({ id: '53.03.04.1011', kecamatan: '53.03.04', name: 'Oenak' })
    dataSet.push({ id: '53.01.20.2010', kecamatan: '53.01.20', name: 'Oenaunu' })
    dataSet.push({ id: '53.03.08.2017', kecamatan: '53.03.08', name: 'Oenbit' })
    dataSet.push({ id: '53.03.15.2002', kecamatan: '53.03.15', name: 'Oenenu' })
    dataSet.push({ id: '53.03.15.2008', kecamatan: '53.03.15', name: 'Oenenu Selatan' })
    dataSet.push({ id: '53.03.15.2007', kecamatan: '53.03.15', name: 'Oenenu Utara' })
    dataSet.push({ id: '53.01.05.1001', kecamatan: '53.01.05', name: 'Oenesu' })
    dataSet.push({ id: '53.14.05.2013', kecamatan: '53.14.05', name: 'Oenggae' })
    dataSet.push({ id: '53.14.07.2003', kecamatan: '53.14.07', name: 'Oenggaut' })
    dataSet.push({ id: '53.01.16.2005', kecamatan: '53.01.16', name: 'Oenif' })
    dataSet.push({ id: '53.01.20.2006', kecamatan: '53.01.20', name: 'Oeniko' })
    dataSet.push({ id: '53.03.15.2006', kecamatan: '53.03.15', name: 'Oenino' })
    dataSet.push({ id: '53.14.07.2005', kecamatan: '53.14.07', name: 'Oenitas' })
    dataSet.push({ id: '53.01.09.2006', kecamatan: '53.01.09', name: 'Oenoni' })
    dataSet.push({ id: '53.01.09.2008', kecamatan: '53.01.09', name: 'Oenoni II' })
    dataSet.push({ id: '53.01.20.2007', kecamatan: '53.01.20', name: 'Oenuntono' })
    dataSet.push({ id: '53.03.12.2003', kecamatan: '53.03.12', name: 'Oeolo' })
    dataSet.push({ id: '53.01.16.2007', kecamatan: '53.01.16', name: 'Oepaha' })
    dataSet.push({ id: '53.03.04.2016', kecamatan: '53.03.04', name: 'Oeperigi' })
    dataSet.push({ id: '53.03.23.2004', kecamatan: '53.03.23', name: 'Oepuah' })
    dataSet.push({ id: '53.03.23.2007', kecamatan: '53.03.23', name: 'Oepuah Selatan' })
    dataSet.push({ id: '53.03.23.2006', kecamatan: '53.03.23', name: 'Oepuah Utara' })
    dataSet.push({ id: '53.71.02.1001', kecamatan: '53.71.02', name: 'Oepura' })
    dataSet.push({ id: '53.03.22.2002', kecamatan: '53.03.22', name: 'Oerinbesi' })
    dataSet.push({ id: '53.01.06.1004', kecamatan: '53.01.06', name: 'Oesao' })
    dataSet.push({ id: '53.01.06.2015', kecamatan: '53.01.06', name: 'Oesao' })
    dataSet.push({ id: '53.71.03.1010', kecamatan: '53.71.03', name: 'Oesapa' })
    dataSet.push({ id: '53.71.03.1014', kecamatan: '53.71.03', name: 'Oesapa Barat' })
    dataSet.push({ id: '53.71.03.1015', kecamatan: '53.71.03', name: 'Oesapa Selatan' })
    dataSet.push({ id: '53.06.18.2010', kecamatan: '53.06.18', name: 'Oesayang' })
    dataSet.push({ id: '53.14.01.2005', kecamatan: '53.14.01', name: 'Oeseli' })
    dataSet.push({ id: '53.01.09.2001', kecamatan: '53.01.09', name: 'Oesena' })
    dataSet.push({ id: '53.03.01.1020', kecamatan: '53.03.01', name: 'Oesena' })
    dataSet.push({ id: '53.03.09.2007', kecamatan: '53.03.09', name: 'Oesoko' })
    dataSet.push({ id: '53.01.11.2010', kecamatan: '53.01.11', name: 'Oesusu' })
    dataSet.push({ id: '53.03.14.2005', kecamatan: '53.03.14', name: 'Oetalus' })
    dataSet.push({ id: '53.14.01.2009', kecamatan: '53.14.01', name: 'Oetefu' })
    dataSet.push({ id: '53.01.07.2004', kecamatan: '53.01.07', name: 'Oeteta' })
    dataSet.push({ id: '53.71.04.1008', kecamatan: '53.71.04', name: 'Oetete' })
    dataSet.push({ id: '53.03.12.2002', kecamatan: '53.03.12', name: 'Oetulu' })
    dataSet.push({ id: '53.14.02.2013', kecamatan: '53.14.02', name: 'Oetutulu' })
    dataSet.push({ id: '53.14.05.2015', kecamatan: '53.14.05', name: 'Ofalangga' })
    dataSet.push({ id: '53.01.12.2005', kecamatan: '53.01.12', name: "Oh'aem" })
    dataSet.push({ id: '53.01.12.2011', kecamatan: '53.01.12', name: "Oh'aem II" })
    dataSet.push({ id: '53.06.01.2001', kecamatan: '53.06.01', name: 'Ojandetun' })
    dataSet.push({ id: '53.07.08.2002', kecamatan: '53.07.08', name: 'Ojang' })
    dataSet.push({ id: '53.17.05.2009', kecamatan: '53.17.05', name: 'Oka Wacu' })
    dataSet.push({ id: '53.14.05.1009', kecamatan: '53.14.05', name: 'Olafulihaa' })
    dataSet.push({ id: '53.16.01.2008', kecamatan: '53.16.01', name: 'Olaia' })
    dataSet.push({ id: '53.16.03.1013', kecamatan: '53.16.03', name: 'Olakile' })
    dataSet.push({ id: '53.17.03.2007', kecamatan: '53.17.03', name: 'Ole Ate' })
    dataSet.push({ id: '53.18.07.2017', kecamatan: '53.18.07', name: 'Ole Ate' })
    dataSet.push({ id: '53.17.03.2012', kecamatan: '53.17.03', name: 'Ole Dewa' })
    dataSet.push({ id: '53.18.10.2008', kecamatan: '53.18.10', name: 'Omba Rade' })
    dataSet.push({ id: '53.05.14.2007', kecamatan: '53.05.14', name: 'Ombay' })
    dataSet.push({ id: '53.01.23.2003', kecamatan: '53.01.23', name: 'Onansila' })
    dataSet.push({ id: '53.14.04.1002', kecamatan: '53.14.04', name: 'Onatali' })
    dataSet.push({ id: '53.08.01.2002', kecamatan: '53.08.01', name: 'Ondorea' })
    dataSet.push({ id: '53.08.01.2018', kecamatan: '53.08.01', name: 'Ondorea Barat' })
    dataSet.push({ id: '53.08.19.1002', kecamatan: '53.08.19', name: 'Onekore' })
    dataSet.push({ id: '53.08.05.1001', kecamatan: '53.08.05', name: 'Onelako' })
    dataSet.push({ id: '53.06.06.2012', kecamatan: '53.06.06', name: 'Ongalereng' })
    dataSet.push({ id: '53.18.07.2010', kecamatan: '53.18.07', name: 'Onggol' })
    dataSet.push({ id: '53.05.03.2021', kecamatan: '53.05.03', name: 'Orgen' })
    dataSet.push({ id: '53.06.12.2004', kecamatan: '53.06.12', name: 'Oringbele' })
    dataSet.push({ id: '53.15.07.2005', kecamatan: '53.15.07', name: 'Orong' })
    dataSet.push({ id: '53.01.04.2004', kecamatan: '53.01.04', name: 'Otan' })
    dataSet.push({ id: '53.08.10.2019', kecamatan: '53.08.10', name: 'Otogedu' })
    dataSet.push({ id: '53.05.02.2009', kecamatan: '53.05.02', name: 'Otvai' })
    dataSet.push({ id: '53.06.09.2004', kecamatan: '53.06.09', name: 'Oyangbarang' })
    dataSet.push({ id: '53.19.06.2016', kecamatan: '53.19.06', name: 'Paan Leleng' })
    dataSet.push({ id: '53.19.09.2009', kecamatan: '53.19.09', name: 'Paan Waru' })
    dataSet.push({ id: '53.11.12.2005', kecamatan: '53.11.12', name: 'Pabera Manera' })
    dataSet.push({ id: '53.15.11.2001', kecamatan: '53.15.11', name: 'Pacar' })
    dataSet.push({ id: '53.13.05.2013', kecamatan: '53.13.05', name: 'Pada' })
    dataSet.push({ id: '53.12.15.1008', kecamatan: '53.12.15', name: 'Pada Eweta' })
    dataSet.push({ id: '53.18.03.2006', kecamatan: '53.18.03', name: 'Pada Eweta' })
    dataSet.push({ id: '53.05.04.2004', kecamatan: '53.05.04', name: 'Padang Alang' })
    dataSet.push({ id: '53.05.05.2007', kecamatan: '53.05.05', name: 'Padang Panjang' })
    dataSet.push({ id: '53.08.02.2003', kecamatan: '53.08.02', name: 'Paderape' })
    dataSet.push({ id: '53.17.04.2009', kecamatan: '53.17.04', name: 'Padira Tana' })
    dataSet.push({ id: '53.07.01.2005', kecamatan: '53.07.01', name: 'Paga' })
    dataSet.push({ id: '53.10.06.1026', kecamatan: '53.10.06', name: 'Pagal' })
    dataSet.push({ id: '53.16.02.2007', kecamatan: '53.16.02', name: 'Pagomogo' })
    dataSet.push({ id: '53.12.11.2006', kecamatan: '53.12.11', name: 'Pahola' })
    dataSet.push({ id: '53.05.03.2015', kecamatan: '53.05.03', name: 'Pailelang' })
    dataSet.push({ id: '53.06.15.2004', kecamatan: '53.06.15', name: 'Paingnapang' })
    dataSet.push({ id: '53.06.08.2013', kecamatan: '53.06.08', name: 'Pajinian' })
    dataSet.push({ id: '53.10.05.2025', kecamatan: '53.10.05', name: 'Paka' })
    dataSet.push({ id: '53.01.19.2002', kecamatan: '53.01.19', name: 'Pakubaun' })
    dataSet.push({ id: '53.12.12.2015', kecamatan: '53.12.12', name: 'Pala Moko' })
    dataSet.push({ id: '53.11.07.2007', kecamatan: '53.11.07', name: 'Palaka Hembi' })
    dataSet.push({ id: '53.11.10.2009', kecamatan: '53.11.10', name: 'Palanggai' })
    dataSet.push({ id: '53.13.03.2022', kecamatan: '53.13.03', name: 'Palilolon' })
    dataSet.push({ id: '53.06.06.2009', kecamatan: '53.06.06', name: 'Pamakayo' })
    dataSet.push({ id: '53.11.01.2014', kecamatan: '53.11.01', name: 'Pambotandjara' })
    dataSet.push({ id: '53.11.10.2005', kecamatan: '53.11.10', name: 'Pamburu' })
    dataSet.push({ id: '53.13.07.2001', kecamatan: '53.13.07', name: 'Panama' })
    dataSet.push({ id: '53.05.06.2005', kecamatan: '53.05.06', name: 'Pandai' })
    dataSet.push({ id: '53.06.09.2007', kecamatan: '53.06.09', name: 'Pandai' })
    dataSet.push({ id: '53.18.02.2010', kecamatan: '53.18.02', name: 'Pandua Tana' })
    dataSet.push({ id: '53.18.11.2004', kecamatan: '53.18.11', name: 'Panenggo Ede' })
    dataSet.push({ id: '53.15.02.2004', kecamatan: '53.15.02', name: 'Pangga' })
    dataSet.push({ id: '53.03.03.2001', kecamatan: '53.03.03', name: 'Pantae' })
    dataSet.push({ id: '53.01.07.2006', kecamatan: '53.01.07', name: 'Pantai Beringin' })
    dataSet.push({ id: '53.06.03.1003', kecamatan: '53.06.03', name: 'Pantai Besar' })
    dataSet.push({ id: '53.13.08.2004', kecamatan: '53.13.08', name: 'Pantai Harapan' })
    dataSet.push({ id: '53.06.01.2013', kecamatan: '53.06.01', name: 'Pantai Oa' })
    dataSet.push({ id: '53.15.05.2028', kecamatan: '53.15.05', name: 'Pantar' })
    dataSet.push({ id: '53.05.10.2003', kecamatan: '53.05.10', name: 'Pante Deere' })
    dataSet.push({ id: '53.01.07.2007', kecamatan: '53.01.07', name: 'Pantulan' })
    dataSet.push({ id: '53.15.05.2018', kecamatan: '53.15.05', name: 'Papa Garang' })
    dataSet.push({ id: '53.10.05.2018', kecamatan: '53.10.05', name: 'Papang' })
    dataSet.push({ id: '53.09.06.2024', kecamatan: '53.09.06', name: 'Pape' })
    dataSet.push({ id: '53.14.06.2016', kecamatan: '53.14.06', name: 'Papela' })
    dataSet.push({ id: '53.10.16.2009', kecamatan: '53.10.16', name: 'Para Lando' })
    dataSet.push({ id: '53.11.11.2008', kecamatan: '53.11.11', name: 'Paranda' })
    dataSet.push({ id: '53.19.06.2020', kecamatan: '53.19.06', name: 'Pari' })
    dataSet.push({ id: '53.12.11.2014', kecamatan: '53.12.11', name: 'Pari Rara' })
    dataSet.push({ id: '53.01.07.2003', kecamatan: '53.01.07', name: 'Pariti' })
    dataSet.push({ id: '53.15.05.2003', kecamatan: '53.15.05', name: 'Pasir Panjang' })
    dataSet.push({ id: '53.71.06.1009', kecamatan: '53.71.06', name: 'Pasir Panjang' })
    dataSet.push({ id: '53.13.01.2001', kecamatan: '53.13.01', name: 'Pasir Putih' })
    dataSet.push({ id: '53.15.05.2002', kecamatan: '53.15.05', name: 'Pasir Putih' })
    dataSet.push({ id: '53.01.28.2004', kecamatan: '53.01.28', name: 'Passi' })
    dataSet.push({ id: '53.11.22.2002', kecamatan: '53.11.22', name: 'Patamawai' })
    dataSet.push({ id: '53.11.08.2003', kecamatan: '53.11.08', name: 'Patawang' })
    dataSet.push({ id: '53.15.08.2012', kecamatan: '53.15.08', name: 'Pateng Lesuh' })
    dataSet.push({ id: '53.01.20.2005', kecamatan: '53.01.20', name: 'Pathau' })
    dataSet.push({ id: '53.12.12.2004', kecamatan: '53.12.12', name: 'Patiala Bawa' })
    dataSet.push({ id: '53.12.18.2003', kecamatan: '53.12.18', name: 'Patiala Dete' })
    dataSet.push({ id: '53.06.05.2018', kecamatan: '53.06.05', name: 'Patisira Walang' })
    dataSet.push({ id: '53.10.12.1006', kecamatan: '53.10.12', name: 'Pau' })
    dataSet.push({ id: '53.07.16.2005', kecamatan: '53.07.16', name: 'Paubekor' })
    dataSet.push({ id: '53.13.05.2012', kecamatan: '53.13.05', name: 'Paubokol' })
    dataSet.push({ id: '53.16.06.2016', kecamatan: '53.16.06', name: 'Paumali' })
    dataSet.push({ id: '53.09.20.2001', kecamatan: '53.09.20', name: 'Paupaga' })
    dataSet.push({ id: '53.08.04.1006', kecamatan: '53.08.04', name: 'Paupanda' })
    dataSet.push({ id: '53.08.19.1004', kecamatan: '53.08.19', name: 'Paupire' })
    dataSet.push({ id: '53.16.06.2009', kecamatan: '53.16.06', name: 'Pautola' })
    dataSet.push({ id: '53.18.01.2014', kecamatan: '53.18.01', name: 'Payola Umbu' })
    dataSet.push({ id: '53.20.05.2004', kecamatan: '53.20.05', name: 'Pedarro' })
    dataSet.push({ id: '53.07.05.2014', kecamatan: '53.07.05', name: 'Pemana' })
    dataSet.push({ id: '53.08.14.2007', kecamatan: '53.08.14', name: 'Pemo' })
    dataSet.push({ id: '53.71.02.1003', kecamatan: '53.71.02', name: 'Penfui' })
    dataSet.push({ id: '53.01.08.2011', kecamatan: '53.01.08', name: 'Penfui Timur' })
    dataSet.push({ id: '53.08.01.2016', kecamatan: '53.08.01', name: 'Penggajawa' })
    dataSet.push({ id: '53.15.07.2010', kecamatan: '53.15.07', name: 'Pengka' })
    dataSet.push({ id: '53.14.06.2014', kecamatan: '53.14.06', name: 'Pengodua' })
    dataSet.push({ id: '53.13.01.2008', kecamatan: '53.13.01', name: 'Penikenek' })
    dataSet.push({ id: '53.71.01.1012', kecamatan: '53.71.01', name: 'Penkase Oeleta' })
    dataSet.push({ id: '53.08.03.2029', kecamatan: '53.08.03', name: 'Peozakaramba' })
    dataSet.push({ id: '53.06.11.2009', kecamatan: '53.06.11', name: 'Pepakelu' })
    dataSet.push({ id: '53.10.06.2010', kecamatan: '53.10.06', name: 'Perak' })
    dataSet.push({ id: '53.18.04.2023', kecamatan: '53.18.04', name: 'Pero' })
    dataSet.push({ id: '53.18.07.2005', kecamatan: '53.18.07', name: 'Pero Batang' })
    dataSet.push({ id: '53.18.07.2014', kecamatan: '53.18.07', name: 'Pero Konda' })
    dataSet.push({ id: '53.07.15.2009', kecamatan: '53.07.15', name: 'Perumaan' })
    dataSet.push({ id: '53.05.07.2018', kecamatan: '53.05.07', name: 'Petleng' })
    dataSet.push({ id: '53.13.03.2012', kecamatan: '53.13.03', name: 'Petuntawa' })
    dataSet.push({ id: '53.13.06.2019', kecamatan: '53.13.06', name: 'Peusawa' })
    dataSet.push({ id: '53.05.08.2001', kecamatan: '53.05.08', name: 'Pido' })
    dataSet.push({ id: '53.09.07.2005', kecamatan: '53.09.07', name: 'Piga' })
    dataSet.push({ id: '53.09.07.2017', kecamatan: '53.09.07', name: 'Piga Satu' })
    dataSet.push({ id: '53.14.08.2007', kecamatan: '53.14.08', name: 'Pilasue' })
    dataSet.push({ id: '53.11.05.2007', kecamatan: '53.11.05', name: 'Pindu Hurani' })
    dataSet.push({ id: '53.10.06.2022', kecamatan: '53.10.06', name: 'Pinggang' })
    dataSet.push({ id: '53.05.03.2008', kecamatan: '53.05.03', name: 'Pintumas' })
    dataSet.push({ id: '53.05.09.2024', kecamatan: '53.05.09', name: 'Piringsina' })
    dataSet.push({ id: '53.08.13.2015', kecamatan: '53.08.13', name: 'Pise' })
    dataSet.push({ id: '53.01.07.2002', kecamatan: '53.01.07', name: 'Pitai' })
    dataSet.push({ id: '53.10.12.1004', kecamatan: '53.10.12', name: 'Pitak' })
    dataSet.push({ id: '53.06.12.2007', kecamatan: '53.06.12', name: 'Pledo' })
    dataSet.push({ id: '53.10.01.2003', kecamatan: '53.10.01', name: 'Poco' })
    dataSet.push({ id: '53.15.03.2036', kecamatan: '53.15.03', name: 'Poco Dedeng' })
    dataSet.push({ id: '53.15.04.2027', kecamatan: '53.15.04', name: 'Poco Golo Kempo' })
    dataSet.push({ id: '53.19.02.2001', kecamatan: '53.19.02', name: 'Poco Lia' })
    dataSet.push({ id: '53.10.03.2025', kecamatan: '53.10.03', name: 'Poco Likang' })
    dataSet.push({ id: '53.10.12.1014', kecamatan: '53.10.12', name: 'Poco Mal' })
    dataSet.push({ id: '53.19.01.2018', kecamatan: '53.19.01', name: 'Poco Rii' })
    dataSet.push({ id: '53.15.03.2023', kecamatan: '53.15.03', name: 'Poco Rutang' })
    dataSet.push({ id: '53.19.02.2002', kecamatan: '53.19.02', name: 'Pocong' })
    dataSet.push({ id: '53.16.02.2002', kecamatan: '53.16.02', name: 'Podenura' })
    dataSet.push({ id: '53.18.01.2013', kecamatan: '53.18.01', name: 'Pogo Tena' })
    dataSet.push({ id: '53.07.09.2003', kecamatan: '53.07.09', name: 'Pogon' })
    dataSet.push({ id: '53.06.03.1022', kecamatan: '53.06.03', name: 'Pohon Bao' })
    dataSet.push({ id: '53.06.03.1006', kecamatan: '53.06.03', name: 'Pohon Sirih' })
    dataSet.push({ id: '53.07.17.2008', kecamatan: '53.07.17', name: 'Poma' })
    dataSet.push({ id: '53.01.09.2003', kecamatan: '53.01.09', name: 'Ponain' })
    dataSet.push({ id: '53.15.03.2022', kecamatan: '53.15.03', name: 'Pondo' })
    dataSet.push({ id: '53.17.02.2003', kecamatan: '53.17.02', name: 'Pondok' })
    dataSet.push({ id: '53.15.11.2006', kecamatan: '53.15.11', name: 'Pong Kolong' })
    dataSet.push({ id: '53.10.03.2033', kecamatan: '53.10.03', name: 'Pong Lale' })
    dataSet.push({ id: '53.10.03.2010', kecamatan: '53.10.03', name: 'Pong Lao' })
    dataSet.push({ id: '53.10.03.2023', kecamatan: '53.10.03', name: 'Pong Leko' })
    dataSet.push({ id: '53.10.14.2009', kecamatan: '53.10.14', name: 'Pong Lengor' })
    dataSet.push({ id: '53.15.03.2013', kecamatan: '53.15.03', name: 'Pong Majok' })
    dataSet.push({ id: '53.10.03.2004', kecamatan: '53.10.03', name: 'Pong Murung' })
    dataSet.push({ id: '53.15.08.2010', kecamatan: '53.15.08', name: 'Pong Narang' })
    dataSet.push({ id: '53.19.06.2015', kecamatan: '53.19.06', name: 'Pong Ruan' })
    dataSet.push({ id: '53.10.15.2005', kecamatan: '53.10.15', name: 'Pong Umpu' })
    dataSet.push({ id: '53.15.07.2006', kecamatan: '53.15.07', name: 'Pong Welak' })
    dataSet.push({ id: '53.10.05.2038', kecamatan: '53.10.05', name: 'Ponggeok' })
    dataSet.push({ id: '53.10.05.2004', kecamatan: '53.10.05', name: 'Pongkor' })
    dataSet.push({ id: '53.15.06.2006', kecamatan: '53.15.06', name: 'Pontianak' })
    dataSet.push({ id: '53.15.03.2011', kecamatan: '53.15.03', name: 'Ponto Ara' })
    dataSet.push({ id: '53.03.07.1007', kecamatan: '53.03.07', name: 'Ponu' })
    dataSet.push({ id: '53.03.04.2004', kecamatan: '53.03.04', name: 'Popnam' })
    dataSet.push({ id: '53.10.18.2004', kecamatan: '53.10.18', name: 'Popo' })
    dataSet.push({ id: '53.08.09.2004', kecamatan: '53.08.09', name: 'Pora' })
    dataSet.push({ id: '53.13.08.2012', kecamatan: '53.13.08', name: 'Posiwatu' })
    dataSet.push({ id: '53.06.03.1009', kecamatan: '53.06.03', name: 'Postoh' })
    dataSet.push({ id: '53.19.04.1009', kecamatan: '53.19.04', name: 'Pota' })
    dataSet.push({ id: '53.15.06.2003', kecamatan: '53.15.06', name: 'Pota Wangka' })
    dataSet.push({ id: '53.01.27.2001', kecamatan: '53.01.27', name: 'Poto' })
    dataSet.push({ id: '53.08.19.1001', kecamatan: '53.08.19', name: 'Potulando' })
    dataSet.push({ id: '53.11.15.2001', kecamatan: '53.11.15', name: 'Prai Bakul' })
    dataSet.push({ id: '53.11.02.2006', kecamatan: '53.11.02', name: 'Praibakul' })
    dataSet.push({ id: '53.11.19.2005', kecamatan: '53.11.19', name: 'Praibakul' })
    dataSet.push({ id: '53.12.11.2003', kecamatan: '53.12.11', name: 'Praibakul' })
    dataSet.push({ id: '53.11.22.2004', kecamatan: '53.11.22', name: 'Praikalala' })
    dataSet.push({ id: '53.11.04.2010', kecamatan: '53.11.04', name: 'Praikarang' })
    dataSet.push({ id: '53.17.04.2003', kecamatan: '53.17.04', name: 'Praikoruku Jangga' })
    dataSet.push({ id: '53.11.16.1002', kecamatan: '53.11.16', name: 'Prailiu' })
    dataSet.push({ id: '53.17.02.2002', kecamatan: '53.17.02', name: 'Praimadeta' })
    dataSet.push({ id: '53.11.13.2002', kecamatan: '53.11.13', name: 'Praimadita' })
    dataSet.push({ id: '53.11.12.2004', kecamatan: '53.11.12', name: 'Praimbana' })
    dataSet.push({ id: '53.11.05.2008', kecamatan: '53.11.05', name: 'Praing Kareha' })
    dataSet.push({ id: '53.11.04.2003', kecamatan: '53.11.04', name: 'Praipaha' })
    dataSet.push({ id: '53.11.21.2001', kecamatan: '53.11.21', name: 'Praiwitu' })
    dataSet.push({ id: '53.11.21.2005', kecamatan: '53.11.21', name: 'Prauraming' })
    dataSet.push({ id: '53.05.03.2002', kecamatan: '53.05.03', name: 'Probur' })
    dataSet.push({ id: '53.05.03.2019', kecamatan: '53.05.03', name: 'Probur Utara' })
    dataSet.push({ id: '53.07.13.2003', kecamatan: '53.07.13', name: 'Pruda' })
    dataSet.push({ id: '53.06.10.2017', kecamatan: '53.06.10', name: 'Puhu' })
    dataSet.push({ id: '53.01.06.2011', kecamatan: '53.01.06', name: 'Pukdale' })
    dataSet.push({ id: '53.06.03.1014', kecamatan: '53.06.03', name: 'Pukentobi Wangin Bao' })
    dataSet.push({ id: '53.14.10.2006', kecamatan: '53.14.10', name: 'Pukuafu' })
    dataSet.push({ id: '53.05.02.2019', kecamatan: '53.05.02', name: 'Pulau Buaya' })
    dataSet.push({ id: '53.15.04.2028', kecamatan: '53.15.04', name: 'Pulau Nuncung' })
    dataSet.push({ id: '53.11.04.2005', kecamatan: '53.11.04', name: 'Pulu Panjang' })
    dataSet.push({ id: '53.06.01.2009', kecamatan: '53.06.01', name: 'Pululera' })
    dataSet.push({ id: '53.13.08.2005', kecamatan: '53.13.08', name: 'Puor' })
    dataSet.push({ id: '53.13.08.2013', kecamatan: '53.13.08', name: 'Puor B' })
    dataSet.push({ id: '53.05.11.1001', kecamatan: '53.05.11', name: 'Pura' })
    dataSet.push({ id: '53.05.11.2006', kecamatan: '53.05.11', name: 'Pura Barat' })
    dataSet.push({ id: '53.05.11.2004', kecamatan: '53.05.11', name: 'Pura Selatan' })
    dataSet.push({ id: '53.05.11.2005', kecamatan: '53.05.11', name: 'Pura Timur' })
    dataSet.push({ id: '53.05.11.2003', kecamatan: '53.05.11', name: 'Pura Utara' })
    dataSet.push({ id: '53.05.13.2002', kecamatan: '53.05.13', name: 'Purnama' })
    dataSet.push({ id: '53.12.15.2013', kecamatan: '53.12.15', name: 'Puu Mawo' })
    dataSet.push({ id: '53.18.02.2006', kecamatan: '53.18.02', name: 'Puu Potto' })
    dataSet.push({ id: '53.08.02.2002', kecamatan: '53.08.02', name: 'Puutara' })
    dataSet.push({ id: '53.08.05.2006', kecamatan: '53.08.05', name: 'Puutuga' })
    dataSet.push({ id: '53.18.04.2013', kecamatan: '53.18.04', name: 'Raba Ege' })
    dataSet.push({ id: '53.21.02.2011', kecamatan: '53.21.02', name: 'Rabasa' })
    dataSet.push({ id: '53.21.03.2010', kecamatan: '53.21.03', name: 'Rabasa Biris' })
    dataSet.push({ id: '53.21.02.2012', kecamatan: '53.21.02', name: 'Rabasa Haerain' })
    dataSet.push({ id: '53.21.02.2006', kecamatan: '53.21.02', name: 'Rabasahain' })
    dataSet.push({ id: '53.01.19.2003', kecamatan: '53.01.19', name: 'Rabeka' })
    dataSet.push({ id: '53.08.03.2001', kecamatan: '53.08.03', name: 'Raburia' })
    dataSet.push({ id: '53.15.07.2015', kecamatan: '53.15.07', name: 'Racang Welak' })
    dataSet.push({ id: '53.18.06.2010', kecamatan: '53.18.06', name: 'Rada Loko' })
    dataSet.push({ id: '53.18.06.2020', kecamatan: '53.18.06', name: 'Rada Malando' })
    dataSet.push({ id: '53.18.09.2001', kecamatan: '53.18.09', name: 'Rada Mata' })
    dataSet.push({ id: '53.09.02.2011', kecamatan: '53.09.02', name: 'Radabata' })
    dataSet.push({ id: '53.09.18.2011', kecamatan: '53.09.18', name: 'Radamasa' })
    dataSet.push({ id: '53.10.06.2002', kecamatan: '53.10.06', name: 'Rado' })
    dataSet.push({ id: '53.20.01.2007', kecamatan: '53.20.01', name: 'Raedewa' })
    dataSet.push({ id: '53.20.01.2011', kecamatan: '53.20.01', name: 'Raekore' })
    dataSet.push({ id: '53.20.01.2003', kecamatan: '53.20.01', name: 'Raeloro' })
    dataSet.push({ id: '53.20.01.2013', kecamatan: '53.20.01', name: 'Raemadia' })
    dataSet.push({ id: '53.20.01.2010', kecamatan: '53.20.01', name: 'Raemude' })
    dataSet.push({ id: '53.20.01.2006', kecamatan: '53.20.01', name: 'Raenalulu' })
    dataSet.push({ id: '53.20.01.2012', kecamatan: '53.20.01', name: 'Raenyale' })
    dataSet.push({ id: '53.20.04.2001', kecamatan: '53.20.04', name: 'Raerobo' })
    dataSet.push({ id: '53.04.13.2005', kecamatan: '53.04.13', name: 'Rafae' })
    dataSet.push({ id: '53.10.03.2024', kecamatan: '53.10.03', name: 'Rai' })
    dataSet.push({ id: '53.04.03.2004', kecamatan: '53.04.03', name: 'Raifatus' })
    dataSet.push({ id: '53.21.01.2016', kecamatan: '53.21.01', name: 'Railor Tahak' })
    dataSet.push({ id: '53.21.02.2015', kecamatan: '53.21.02', name: 'Raimataus' })
    dataSet.push({ id: '53.21.11.2004', kecamatan: '53.21.11', name: 'Rainawe' })
    dataSet.push({ id: '53.21.05.2014', kecamatan: '53.21.05', name: 'Raisamane' })
    dataSet.push({ id: '53.21.09.2001', kecamatan: '53.21.09', name: 'Raiulun' })
    dataSet.push({ id: '53.16.03.2016', kecamatan: '53.16.03', name: 'Raja' })
    dataSet.push({ id: '53.16.03.2027', kecamatan: '53.16.03', name: 'Raja Selatan' })
    dataSet.push({ id: '53.16.03.2026', kecamatan: '53.16.03', name: 'Raja Timur' })
    dataSet.push({ id: '53.12.12.2009', kecamatan: '53.12.12', name: 'Rajaka' })
    dataSet.push({ id: '53.15.08.2003', kecamatan: '53.15.08', name: 'Raka' })
    dataSet.push({ id: '53.09.19.2003', kecamatan: '53.09.19', name: 'Rakalaba' })
    dataSet.push({ id: '53.09.19.2007', kecamatan: '53.09.19', name: 'Rakateda Dua' })
    dataSet.push({ id: '53.09.19.2006', kecamatan: '53.09.19', name: 'Rakateda Satu' })
    dataSet.push({ id: '53.11.03.2006', kecamatan: '53.11.03', name: 'Rakawatu' })
    dataSet.push({ id: '53.01.25.2003', kecamatan: '53.01.25', name: 'Raknamo' })
    dataSet.push({ id: '53.18.01.2009', kecamatan: '53.18.01', name: 'Rama Dana' })
    dataSet.push({ id: '53.11.02.2003', kecamatan: '53.11.02', name: 'Rambangaru' })
    dataSet.push({ id: '53.20.05.2010', kecamatan: '53.20.05', name: 'Ramedue' })
    dataSet.push({ id: '53.11.06.2001', kecamatan: '53.11.06', name: 'Ramuk' })
    dataSet.push({ id: '53.19.05.2017', kecamatan: '53.19.05', name: 'Rana Gapang' })
    dataSet.push({ id: '53.19.06.2007', kecamatan: '53.19.06', name: 'Rana Kolong' })
    dataSet.push({ id: '53.19.05.2002', kecamatan: '53.19.05', name: 'Rana Kulan' })
    dataSet.push({ id: '53.19.01.1021', kecamatan: '53.19.01', name: 'Rana Loba' })
    dataSet.push({ id: '53.19.01.2009', kecamatan: '53.19.01', name: 'Rana Masak' })
    dataSet.push({ id: '53.19.06.2018', kecamatan: '53.19.06', name: 'Rana Mbata' })
    dataSet.push({ id: '53.19.06.2011', kecamatan: '53.19.06', name: 'Rana Mbeling' })
    dataSet.push({ id: '53.19.04.2006', kecamatan: '53.19.04', name: 'Rana Mese' })
    dataSet.push({ id: '53.10.01.2016', kecamatan: '53.10.01', name: 'Ranaka' })
    dataSet.push({ id: '53.08.10.2006', kecamatan: '53.08.10', name: 'Ranakolo' })
    dataSet.push({ id: '53.08.10.2008', kecamatan: '53.08.10', name: 'Ranakolo Selatan' })
    dataSet.push({ id: '53.08.03.2027', kecamatan: '53.08.03', name: 'Randorama' })
    dataSet.push({ id: '53.08.06.2015', kecamatan: '53.08.06', name: 'Randoria' })
    dataSet.push({ id: '53.08.03.2016', kecamatan: '53.08.03', name: 'Randotonda' })
    dataSet.push({ id: '53.08.06.2022', kecamatan: '53.08.06', name: 'Ranga' })
    dataSet.push({ id: '53.08.13.2014', kecamatan: '53.08.13', name: 'Rangalaka' })
    dataSet.push({ id: '53.08.12.2014', kecamatan: '53.08.12', name: 'Ranggatalo' })
    dataSet.push({ id: '53.10.01.2008', kecamatan: '53.10.01', name: 'Ranggi' })
    dataSet.push({ id: '53.15.12.2010', kecamatan: '53.15.12', name: 'Ranggu' })
    dataSet.push({ id: '53.08.03.2028', kecamatan: '53.08.03', name: 'Ranoramba' })
    dataSet.push({ id: '53.08.01.2010', kecamatan: '53.08.01', name: 'Raporendu' })
    dataSet.push({ id: '53.08.01.2008', kecamatan: '53.08.01', name: 'Rapowawo' })
    dataSet.push({ id: '53.08.17.2009', kecamatan: '53.08.17', name: 'Ratemangga' })
    dataSet.push({ id: '53.08.06.2017', kecamatan: '53.08.06', name: 'Rateroru' })
    dataSet.push({ id: '53.08.18.2010', kecamatan: '53.08.18', name: 'Raterua' })
    dataSet.push({ id: '53.08.07.2013', kecamatan: '53.08.07', name: 'Ratewati' })
    dataSet.push({ id: '53.08.07.2019', kecamatan: '53.08.07', name: 'Ratewati Selatan' })
    dataSet.push({ id: '53.09.02.2010', kecamatan: '53.09.02', name: 'Ratogesa' })
    dataSet.push({ id: '53.16.03.1011', kecamatan: '53.16.03', name: 'Ratongamobo' })
    dataSet.push({ id: '53.06.05.2008', kecamatan: '53.06.05', name: 'Ratulodong' })
    dataSet.push({ id: '53.09.09.2014', kecamatan: '53.09.09', name: 'Rawangkalo' })
    dataSet.push({ id: '53.18.04.2012', kecamatan: '53.18.04', name: 'Reda Pada' })
    dataSet.push({ id: '53.18.02.2008', kecamatan: '53.18.02', name: 'Reda Wano' })
    dataSet.push({ id: '53.08.02.2007', kecamatan: '53.08.02', name: 'Redorory' })
    dataSet.push({ id: '53.16.03.1009', kecamatan: '53.16.03', name: 'Rega' })
    dataSet.push({ id: '53.15.01.2005', kecamatan: '53.15.01', name: 'Rego' })
    dataSet.push({ id: '53.15.07.2008', kecamatan: '53.15.07', name: 'Rehak' })
    dataSet.push({ id: '53.08.05.2020', kecamatan: '53.08.05', name: 'Reka' })
    dataSet.push({ id: '53.10.18.2001', kecamatan: '53.10.18', name: 'Renda' })
    dataSet.push({ id: '53.19.08.2009', kecamatan: '53.19.08', name: 'Rende Nao' })
    dataSet.push({ id: '53.08.02.2006', kecamatan: '53.08.02', name: 'Rendoraterua' })
    dataSet.push({ id: '53.16.07.2001', kecamatan: '53.16.07', name: 'Rendubutowe' })
    dataSet.push({ id: '53.16.07.2007', kecamatan: '53.16.07', name: 'Rendut Tutubhada' })
    dataSet.push({ id: '53.16.07.2004', kecamatan: '53.16.07', name: 'Renduteno' })
    dataSet.push({ id: '53.16.07.2005', kecamatan: '53.16.07', name: 'Renduwawo' })
    dataSet.push({ id: '53.08.02.2009', kecamatan: '53.08.02', name: 'Renga Menge' })
    dataSet.push({ id: '53.07.17.2005', kecamatan: '53.07.17', name: 'Renggarasi' })
    dataSet.push({ id: '53.19.08.2004', kecamatan: '53.19.08', name: 'Rengkam' })
    dataSet.push({ id: '53.04.13.2002', kecamatan: '53.04.13', name: 'Renrua' })
    dataSet.push({ id: '53.10.11.1017', kecamatan: '53.10.11', name: 'Reo' })
    dataSet.push({ id: '53.15.09.2001', kecamatan: '53.15.09', name: 'Repi' })
    dataSet.push({ id: '53.07.12.2002', kecamatan: '53.07.12', name: 'Reroroja' })
    dataSet.push({ id: '53.07.06.2002', kecamatan: '53.07.06', name: 'Reruwairere' })
    dataSet.push({ id: '53.01.18.2004', kecamatan: '53.01.18', name: 'Retraen' })
    dataSet.push({ id: '53.12.11.2011', kecamatan: '53.12.11', name: 'Rewa Rara' })
    dataSet.push({ id: '53.08.20.1002', kecamatan: '53.08.20', name: 'Rewarangga' })
    dataSet.push({ id: '53.08.20.1006', kecamatan: '53.08.20', name: 'Rewarangga Selatan' })
    dataSet.push({ id: '53.09.14.2004', kecamatan: '53.09.14', name: 'Ria' })
    dataSet.push({ id: '53.13.01.2017', kecamatan: '53.13.01', name: 'Ria Bao' })
    dataSet.push({ id: '53.09.14.2006', kecamatan: '53.09.14', name: 'Ria I' })
    dataSet.push({ id: '53.06.16.2007', kecamatan: '53.06.16', name: 'Riang Rita' })
    dataSet.push({ id: '53.13.03.2026', kecamatan: '53.13.03', name: 'Riangbao' })
    dataSet.push({ id: '53.06.16.2001', kecamatan: '53.06.16', name: 'Riangbura' })
    dataSet.push({ id: '53.06.12.2012', kecamatan: '53.06.12', name: 'Riangduli' })
    dataSet.push({ id: '53.06.04.2005', kecamatan: '53.06.04', name: 'Riangkemie' })
    dataSet.push({ id: '53.06.15.2006', kecamatan: '53.06.15', name: 'Riangkotek' })
    dataSet.push({ id: '53.06.08.2036', kecamatan: '53.06.08', name: 'Riangpadu' })
    dataSet.push({ id: '53.06.13.2003', kecamatan: '53.06.13', name: 'Rianwale' })
    dataSet.push({ id: '53.08.03.2002', kecamatan: '53.08.03', name: 'Riaraja' })
    dataSet.push({ id: '53.07.16.2006', kecamatan: '53.07.16', name: 'Ribang' })
    dataSet.push({ id: '53.16.03.2020', kecamatan: '53.16.03', name: 'Rigi' })
    dataSet.push({ id: '53.07.04.2009', kecamatan: '53.07.04', name: 'Riit' })
    dataSet.push({ id: '53.04.22.1002', kecamatan: '53.04.22', name: 'Rinbesi' })
    dataSet.push({ id: '53.04.04.2006', kecamatan: '53.04.04', name: 'Rinbesihat' })
    dataSet.push({ id: '53.11.09.2001', kecamatan: '53.11.09', name: 'Rindi' })
    dataSet.push({ id: '53.08.08.2011', kecamatan: '53.08.08', name: 'Rindiwawo' })
    dataSet.push({ id: '53.12.12.2012', kecamatan: '53.12.12', name: 'Ringu Rara' })
    dataSet.push({ id: '53.18.05.2011', kecamatan: '53.18.05', name: 'Rita Baru' })
    dataSet.push({ id: '53.06.06.1001', kecamatan: '53.06.06', name: 'Ritaebang' })
    dataSet.push({ id: '53.16.02.2005', kecamatan: '53.16.02', name: 'Riti' })
    dataSet.push({ id: '53.10.06.2015', kecamatan: '53.10.06', name: 'Riung' })
    dataSet.push({ id: '53.08.06.2005', kecamatan: '53.08.06', name: 'Roa' })
    dataSet.push({ id: '53.10.11.2001', kecamatan: '53.10.11', name: 'Robek' })
    dataSet.push({ id: '53.15.07.2017', kecamatan: '53.15.07', name: 'Robo' })
    dataSet.push({ id: '53.20.01.2015', kecamatan: '53.20.01', name: 'Roboaba' })
    dataSet.push({ id: '53.06.11.2001', kecamatan: '53.06.11', name: 'Rodentena' })
    dataSet.push({ id: '53.08.16.2004', kecamatan: '53.08.16', name: 'Roga' })
    dataSet.push({ id: '53.13.07.2004', kecamatan: '53.13.07', name: 'Roho' })
    dataSet.push({ id: '53.15.01.2002', kecamatan: '53.15.01', name: 'Rokap' })
    dataSet.push({ id: '53.07.06.2006', kecamatan: '53.07.06', name: 'Rokirole' })
    dataSet.push({ id: '53.13.06.2011', kecamatan: '53.13.06', name: 'Roma' })
    dataSet.push({ id: '53.15.11.2003', kecamatan: '53.15.11', name: 'Romang' })
    dataSet.push({ id: '53.08.01.2019', kecamatan: '53.08.01', name: 'Romarea' })
    dataSet.push({ id: '53.19.07.2005', kecamatan: '53.19.07', name: 'Rondo Woing' })
    dataSet.push({ id: '53.19.06.1002', kecamatan: '53.19.06', name: 'Rongga Koe' })
    dataSet.push({ id: '53.08.02.2005', kecamatan: '53.08.02', name: 'Rorurangga' })
    dataSet.push({ id: '53.16.03.2002', kecamatan: '53.16.03', name: 'Rowa' })
    dataSet.push({ id: '53.10.12.1018', kecamatan: '53.10.12', name: 'Rowang' })
    dataSet.push({ id: '53.08.18.1003', kecamatan: '53.08.18', name: 'Roworena' })
    dataSet.push({ id: '53.08.18.1007', kecamatan: '53.08.18', name: 'Roworena Barat' })
    dataSet.push({ id: '53.12.11.2010', kecamatan: '53.12.11', name: 'Rua' })
    dataSet.push({ id: '53.19.06.2004', kecamatan: '53.19.06', name: 'Ruan' })
    dataSet.push({ id: '53.10.18.2010', kecamatan: '53.10.18', name: 'Ruang' })
    dataSet.push({ id: '53.07.18.2001', kecamatan: '53.07.18', name: 'Rubit' })
    dataSet.push({ id: '53.10.11.2009', kecamatan: '53.10.11', name: 'Ruis' })
    dataSet.push({ id: '53.08.04.1004', kecamatan: '53.08.04', name: 'Rukun Lima' })
    dataSet.push({ id: '53.08.03.2017', kecamatan: '53.08.03', name: 'Rukuramba' })
    dataSet.push({ id: '53.13.07.2019', kecamatan: '53.13.07', name: 'Rumang' })
    dataSet.push({ id: '53.07.09.2001', kecamatan: '53.07.09', name: 'Runut' })
    dataSet.push({ id: '53.10.16.2010', kecamatan: '53.10.16', name: 'Rura' })
    dataSet.push({ id: '53.08.21.2012', kecamatan: '53.08.21', name: 'Rutujeja' })
    dataSet.push({ id: '53.03.02.2028', kecamatan: '53.03.02', name: "Sa'tab" })
    dataSet.push({ id: '53.02.15.2006', kecamatan: '53.02.15', name: 'Sabun' })
    dataSet.push({ id: '53.09.18.2009', kecamatan: '53.09.18', name: 'Sadha' })
    dataSet.push({ id: '53.04.02.2003', kecamatan: '53.04.02', name: 'Sadi' })
    dataSet.push({ id: '53.03.02.2025', kecamatan: '53.03.02', name: 'Saenam' })
    dataSet.push({ id: '53.21.05.2001', kecamatan: '53.21.05', name: 'Saenama' })
    dataSet.push({ id: '53.08.06.2006', kecamatan: '53.08.06', name: 'Saga' })
    dataSet.push({ id: '53.06.17.2001', kecamatan: '53.06.17', name: 'Sagu' })
    dataSet.push({ id: '53.01.18.2005', kecamatan: '53.01.18', name: 'Sahraen' })
    dataSet.push({ id: '53.14.02.2021', kecamatan: '53.14.02', name: 'Saindule' })
    dataSet.push({ id: '53.03.03.2010', kecamatan: '53.03.03', name: 'Sainiup' })
    dataSet.push({ id: '53.03.17.2005', kecamatan: '53.03.17', name: 'Sainoni' })
    dataSet.push({ id: '53.14.01.2021', kecamatan: '53.14.01', name: 'Sakubatun' })
    dataSet.push({ id: '53.16.04.2014', kecamatan: '53.16.04', name: 'Salalejo' })
    dataSet.push({ id: '53.10.11.2012', kecamatan: '53.10.11', name: 'Salama' })
    dataSet.push({ id: '53.03.02.1027', kecamatan: '53.03.02', name: 'Sallu' })
    dataSet.push({ id: '53.15.02.2021', kecamatan: '53.15.02', name: 'Sama' })
    dataSet.push({ id: '53.17.02.2011', kecamatan: '53.17.02', name: 'Sambali Loku' })
    dataSet.push({ id: '53.10.16.2004', kecamatan: '53.10.16', name: 'Sambi' })
    dataSet.push({ id: '53.09.09.2012', kecamatan: '53.09.09', name: 'Sambinasi' })
    dataSet.push({ id: '53.09.09.2019', kecamatan: '53.09.09', name: 'Sambinasi Barat' })
    dataSet.push({ id: '53.07.05.2015', kecamatan: '53.07.05', name: 'Samparong' })
    dataSet.push({ id: '53.06.09.2009', kecamatan: '53.06.09', name: 'Samsoge' })
    dataSet.push({ id: '53.06.12.2009', kecamatan: '53.06.12', name: 'Sandosi' })
    dataSet.push({ id: '53.09.02.2009', kecamatan: '53.09.02', name: 'Sangadeto' })
    dataSet.push({ id: '53.19.09.2002', kecamatan: '53.19.09', name: 'Sangan Kalo' })
    dataSet.push({ id: '53.14.01.2020', kecamatan: '53.14.01', name: 'Sanggandolu' })
    dataSet.push({ id: '53.14.03.2006', kecamatan: '53.14.03', name: 'Sanggaoen' })
    dataSet.push({ id: '53.08.01.2013', kecamatan: '53.08.01', name: 'Sanggarhorho' })
    dataSet.push({ id: '53.18.04.2021', kecamatan: '53.18.04', name: 'Sangu Ate' })
    dataSet.push({ id: '53.21.09.2006', kecamatan: '53.21.09', name: 'Sanleo' })
    dataSet.push({ id: '53.19.07.2006', kecamatan: '53.19.07', name: 'Sano Lokom' })
    dataSet.push({ id: '53.15.04.2018', kecamatan: '53.15.04', name: 'Sano Nggoang' })
    dataSet.push({ id: '53.06.10.2021', kecamatan: '53.06.10', name: 'Saosina' })
    dataSet.push({ id: '53.03.06.2006', kecamatan: '53.03.06', name: 'Sapaen' })
    dataSet.push({ id: '53.04.02.2010', kecamatan: '53.04.02', name: 'Sarabau' })
    dataSet.push({ id: '53.15.01.2025', kecamatan: '53.15.01', name: 'Sarae Naru' })
    dataSet.push({ id: '53.09.02.2019', kecamatan: '53.09.02', name: 'Sarasedu' })
    dataSet.push({ id: '53.09.02.2032', kecamatan: '53.09.02', name: 'Sarasedu Satu' })
    dataSet.push({ id: '53.06.03.1012', kecamatan: '53.06.03', name: 'Sarotari' })
    dataSet.push({ id: '53.06.03.1023', kecamatan: '53.06.03', name: 'Sarotari Tengah' })
    dataSet.push({ id: '53.06.03.1024', kecamatan: '53.06.03', name: 'Sarotari Timur' })
    dataSet.push({ id: '53.03.05.1009', kecamatan: '53.03.05', name: 'Sasi' })
    dataSet.push({ id: '53.19.03.2018', kecamatan: '53.19.03', name: 'Satar Kampas' })
    dataSet.push({ id: '53.19.07.2002', kecamatan: '53.19.07', name: 'Satar Lahing' })
    dataSet.push({ id: '53.10.13.2016', kecamatan: '53.10.13', name: 'Satar Lenda' })
    dataSet.push({ id: '53.19.07.2016', kecamatan: '53.19.07', name: 'Satar Lenda' })
    dataSet.push({ id: '53.10.05.2040', kecamatan: '53.10.05', name: 'Satar Loung' })
    dataSet.push({ id: '53.10.13.2015', kecamatan: '53.10.13', name: 'Satar Luju' })
    dataSet.push({ id: '53.19.04.2005', kecamatan: '53.19.04', name: 'Satar Nawang' })
    dataSet.push({ id: '53.10.01.2001', kecamatan: '53.10.01', name: 'Satar Ngkeling' })
    dataSet.push({ id: '53.19.03.2008', kecamatan: '53.19.03', name: 'Satar Padut' })
    dataSet.push({ id: '53.19.01.1039', kecamatan: '53.19.01', name: 'Satar Peot' })
    dataSet.push({ id: '53.19.03.2006', kecamatan: '53.19.03', name: 'Satar Punda' })
    dataSet.push({ id: '53.19.03.2024', kecamatan: '53.19.03', name: 'Satar Punda Barat' })
    dataSet.push({ id: '53.10.13.2017', kecamatan: '53.10.13', name: 'Satar Ruwuk' })
    dataSet.push({ id: '53.10.12.1013', kecamatan: '53.10.12', name: 'Satar Tacik' })
    dataSet.push({ id: '53.19.02.2017', kecamatan: '53.19.02', name: 'Satar Tesem' })
    dataSet.push({ id: '53.01.22.2002', kecamatan: '53.01.22', name: 'Saukibe' })
    dataSet.push({ id: '53.16.04.2008', kecamatan: '53.16.04', name: 'Sawu' })
    dataSet.push({ id: '53.09.20.2002', kecamatan: '53.09.20', name: 'Sebowuli' })
    dataSet.push({ id: '53.14.07.2001', kecamatan: '53.14.07', name: 'Sedeoen' })
    dataSet.push({ id: '53.01.20.2001', kecamatan: '53.01.20', name: 'Seki' })
    dataSet.push({ id: '53.03.08.2011', kecamatan: '53.03.08', name: 'Sekon' })
    dataSet.push({ id: '53.16.04.2021', kecamatan: '53.16.04', name: 'Selalejo Timur' })
    dataSet.push({ id: '53.13.05.1015', kecamatan: '53.13.05', name: 'Selandoro' })
    dataSet.push({ id: '53.15.07.2002', kecamatan: '53.15.07', name: 'Semang' })
    dataSet.push({ id: '53.03.04.2003', kecamatan: '53.03.04', name: 'Seo' })
    dataSet.push({ id: '53.15.06.2007', kecamatan: '53.15.06', name: 'Sepang' })
    dataSet.push({ id: '53.08.17.2004', kecamatan: '53.08.17', name: 'Serandori' })
    dataSet.push({ id: '53.13.04.2003', kecamatan: '53.13.04', name: 'Seranggorang' })
    dataSet.push({ id: '53.15.05.2026', kecamatan: '53.15.05', name: 'Seraya Marannu' })
    dataSet.push({ id: '53.06.02.2007', kecamatan: '53.06.02', name: 'Serinuho' })
    dataSet.push({ id: '53.14.06.2005', kecamatan: '53.14.06', name: 'Serubeba' })
    dataSet.push({ id: '53.21.03.2007', kecamatan: '53.21.03', name: 'Seserai' })
    dataSet.push({ id: '53.09.07.2008', kecamatan: '53.09.07', name: 'Seso' })
    dataSet.push({ id: '53.07.10.2005', kecamatan: '53.07.10', name: 'Seusina' })
    dataSet.push({ id: '53.15.07.2016', kecamatan: '53.15.07', name: 'Sewar' })
    dataSet.push({ id: '53.05.04.2003', kecamatan: '53.05.04', name: 'Sidabui' })
    dataSet.push({ id: '53.03.07.2003', kecamatan: '53.03.07', name: 'Sifaniha' })
    dataSet.push({ id: '53.07.03.2005', kecamatan: '53.07.03', name: 'Sikka' })
    dataSet.push({ id: '53.71.02.1008', kecamatan: '53.71.02', name: 'Sikumana' })
    dataSet.push({ id: '53.21.02.2002', kecamatan: '53.21.02', name: 'Sikun' })
    dataSet.push({ id: '53.05.04.2006', kecamatan: '53.05.04', name: 'Silaipui' })
    dataSet.push({ id: '53.04.02.2001', kecamatan: '53.04.02', name: 'Silawan' })
    dataSet.push({ id: '53.01.10.2010', kecamatan: '53.01.10', name: 'Sillu' })
    dataSet.push({ id: '53.06.05.2007', kecamatan: '53.06.05', name: 'Sinamalaka' })
    dataSet.push({ id: '53.06.15.2003', kecamatan: '53.06.15', name: 'Sinar Hading' })
    dataSet.push({ id: '53.06.05.2009', kecamatan: '53.06.05', name: 'Sinarhadigala' })
    dataSet.push({ id: '53.14.04.2013', kecamatan: '53.14.04', name: 'Siomeda' })
    dataSet.push({ id: '53.19.09.2003', kecamatan: '53.19.09', name: 'Sipi' })
    dataSet.push({ id: '53.08.06.2020', kecamatan: '53.08.06', name: 'Sipijena' })
    dataSet.push({ id: '53.15.03.2021', kecamatan: '53.15.03', name: 'Siru' })
    dataSet.push({ id: '53.21.11.2003', kecamatan: '53.21.11', name: 'Sisi' })
    dataSet.push({ id: '53.04.18.2007', kecamatan: '53.04.18', name: 'Sisi Fatuberal' })
    dataSet.push({ id: '53.19.05.2009', kecamatan: '53.19.05', name: 'Sisir' })
    dataSet.push({ id: '53.19.07.2008', kecamatan: '53.19.07', name: 'Sita' })
    dataSet.push({ id: '53.01.17.2002', kecamatan: '53.01.17', name: 'Soba' })
    dataSet.push({ id: '53.12.15.2010', kecamatan: '53.12.15', name: 'Soba Rade' })
    dataSet.push({ id: '53.12.10.1008', kecamatan: '53.12.10', name: 'Sobawawi' })
    dataSet.push({ id: '53.09.19.2004', kecamatan: '53.09.19', name: 'Sobo' })
    dataSet.push({ id: '53.09.19.2005', kecamatan: '53.09.19', name: 'Sobo Satu' })
    dataSet.push({ id: '53.12.12.2010', kecamatan: '53.12.12', name: 'Sodana' })
    dataSet.push({ id: '53.08.16.2002', kecamatan: '53.08.16', name: 'Sokoria' })
    dataSet.push({ id: '53.08.16.2007', kecamatan: '53.08.16', name: 'Sokoria Selatan' })
    dataSet.push({ id: '53.01.22.2001', kecamatan: '53.01.22', name: 'Soliu' })
    dataSet.push({ id: '53.16.03.2004', kecamatan: '53.16.03', name: 'Solo' })
    dataSet.push({ id: '53.71.06.1004', kecamatan: '53.71.06', name: 'Solor' })
    dataSet.push({ id: '53.15.12.2003', kecamatan: '53.15.12', name: 'Sompang Kolang' })
    dataSet.push({ id: '53.03.21.2005', kecamatan: '53.03.21', name: 'Sone' })
    dataSet.push({ id: '53.14.05.2004', kecamatan: '53.14.05', name: 'Sonimanu' })
    dataSet.push({ id: '53.02.09.2007', kecamatan: '53.02.09', name: 'Sono' })
    dataSet.push({ id: '53.03.15.2009', kecamatan: '53.03.15', name: 'Sono' })
    dataSet.push({ id: '53.01.18.1002', kecamatan: '53.01.18', name: 'Sonraen' })
    dataSet.push({ id: '53.17.04.2002', kecamatan: '53.17.04', name: 'Soru' })
    dataSet.push({ id: '53.14.10.2003', kecamatan: '53.14.10', name: 'Sotimori' })
    dataSet.push({ id: '53.21.01.2017', kecamatan: '53.21.01', name: 'Suai' })
    dataSet.push({ id: '53.03.02.2003', kecamatan: '53.03.02', name: 'Suanae' })
    dataSet.push({ id: '53.05.04.2014', kecamatan: '53.05.04', name: 'Subo' })
    dataSet.push({ id: '53.03.20.2001', kecamatan: '53.03.20', name: 'Subun' })
    dataSet.push({ id: '53.03.20.2011', kecamatan: '53.03.20', name: 'Subun Bestobe' })
    dataSet.push({ id: '53.03.20.2012', kecamatan: '53.03.20', name: 'Subun Tualele' })
    dataSet.push({ id: '53.14.04.2010', kecamatan: '53.14.04', name: 'Suebela' })
    dataSet.push({ id: '53.14.03.2013', kecamatan: '53.14.03', name: 'Suelain' })
    dataSet.push({ id: '53.15.02.2031', kecamatan: '53.15.02', name: 'Suka Kiong' })
    dataSet.push({ id: '53.06.11.2005', kecamatan: '53.06.11', name: 'Sukutokan' })
    dataSet.push({ id: '53.01.07.1001', kecamatan: '53.01.07', name: 'Sulamu' })
    dataSet.push({ id: '53.06.19.2003', kecamatan: '53.06.19', name: 'Sulengwaseng' })
    dataSet.push({ id: '53.01.05.2004', kecamatan: '53.01.05', name: 'Sumlili' })
    dataSet.push({ id: '53.03.16.2002', kecamatan: '53.03.16', name: 'Sunkaen' })
    dataSet.push({ id: '53.03.18.2004', kecamatan: '53.03.18', name: 'Sunsea' })
    dataSet.push({ id: '53.03.03.1011', kecamatan: '53.03.03', name: 'Supun' })
    dataSet.push({ id: '53.15.09.2003', kecamatan: '53.15.09', name: 'Surunumbeng' })
    dataSet.push({ id: '53.09.06.1021', kecamatan: '53.09.06', name: 'Susu' })
    dataSet.push({ id: '53.17.03.2011', kecamatan: '53.17.03', name: 'Susu Wendewa' })
    dataSet.push({ id: '53.03.08.2006', kecamatan: '53.03.08', name: 'Susulaku' })
    dataSet.push({ id: '53.03.08.2022', kecamatan: '53.03.08', name: 'Susulaku B' })
    dataSet.push({ id: '53.03.22.2004', kecamatan: '53.03.22', name: "T'Eba Timur" })
    dataSet.push({ id: '53.21.04.2014', kecamatan: '53.21.04', name: 'Taaba' })
    dataSet.push({ id: '53.01.05.2011', kecamatan: '53.01.05', name: 'Tablolong' })
    dataSet.push({ id: '53.20.02.2002', kecamatan: '53.20.02', name: 'Tada' })
    dataSet.push({ id: '53.16.01.2016', kecamatan: '53.16.01', name: 'Tadakisa' })
    dataSet.push({ id: '53.09.09.2009', kecamatan: '53.09.09', name: 'Tadho' })
    dataSet.push({ id: '53.10.05.2034', kecamatan: '53.10.05', name: 'Tado' })
    dataSet.push({ id: '53.10.12.1017', kecamatan: '53.10.12', name: 'Tadong' })
    dataSet.push({ id: '53.03.01.2025', kecamatan: '53.03.01', name: 'Taekas' })
    dataSet.push({ id: '53.09.09.2022', kecamatan: '53.09.09', name: 'Taen Terong Dua' })
    dataSet.push({ id: '53.09.09.2021', kecamatan: '53.09.09', name: 'Taen Terong Satu' })
    dataSet.push({ id: '53.09.09.2005', kecamatan: '53.09.09', name: 'Taenterong' })
    dataSet.push({ id: '53.21.05.2011', kecamatan: '53.21.05', name: 'Tafuli' })
    dataSet.push({ id: '53.21.05.2017', kecamatan: '53.21.05', name: 'Tafuli I' })
    dataSet.push({ id: '53.13.03.2003', kecamatan: '53.13.03', name: 'Tagawiti' })
    dataSet.push({ id: '53.03.21.2003', kecamatan: '53.03.21', name: 'Tainsala' })
    dataSet.push({ id: '53.07.04.2002', kecamatan: '53.07.04', name: 'Takaplager' })
    dataSet.push({ id: '53.21.12.2005', kecamatan: '53.21.12', name: 'Takarai' })
    dataSet.push({ id: '53.01.11.1007', kecamatan: '53.01.11', name: 'Takari' })
    dataSet.push({ id: '53.09.18.2010', kecamatan: '53.09.18', name: 'Takatunga' })
    dataSet.push({ id: '53.04.02.2008', kecamatan: '53.04.02', name: 'Takirin' })
    dataSet.push({ id: '53.10.05.2028', kecamatan: '53.10.05', name: 'Tal' })
    dataSet.push({ id: '53.07.08.2013', kecamatan: '53.07.08', name: 'Talibura' })
    dataSet.push({ id: '53.01.16.2009', kecamatan: '53.01.16', name: 'Taloetan' })
    dataSet.push({ id: '53.05.15.2003', kecamatan: '53.05.15', name: 'Talwai' })
    dataSet.push({ id: '53.05.16.2005', kecamatan: '53.05.16', name: 'Tamakh' })
    dataSet.push({ id: '53.05.12.2007', kecamatan: '53.05.12', name: 'Taman Mataru' })
    dataSet.push({ id: '53.05.04.2011', kecamatan: '53.05.04', name: 'Tamanapui' })
    dataSet.push({ id: '53.11.09.2007', kecamatan: '53.11.09', name: 'Tamburi' })
    dataSet.push({ id: '53.11.10.2007', kecamatan: '53.11.10', name: 'Tamma' })
    dataSet.push({ id: '53.07.19.2006', kecamatan: '53.07.19', name: 'Tana Duen' })
    dataSet.push({ id: '53.08.08.2023', kecamatan: '53.08.08', name: "Tana Lo'o" })
    dataSet.push({ id: '53.11.10.2003', kecamatan: '53.11.10', name: 'Tana Manang' })
    dataSet.push({ id: '53.17.04.2008', kecamatan: '53.17.04', name: 'Tana Mbanas' })
    dataSet.push({ id: '53.17.04.2015', kecamatan: '53.17.04', name: 'Tana Mbanas Barat' })
    dataSet.push({ id: '53.17.04.2014', kecamatan: '53.17.04', name: 'Tana Mbanas Selatan' })
    dataSet.push({ id: '53.18.06.2016', kecamatan: '53.18.06', name: 'Tana Mete' })
    dataSet.push({ id: '53.17.05.2002', kecamatan: '53.17.05', name: 'Tana Modu' })
    dataSet.push({ id: '53.11.03.2007', kecamatan: '53.11.03', name: 'Tana Rara' })
    dataSet.push({ id: '53.12.10.2003', kecamatan: '53.12.10', name: 'Tana Rara' })
    dataSet.push({ id: '53.06.09.2012', kecamatan: '53.06.09', name: 'Tana Tukan' })
    dataSet.push({ id: '53.06.06.2002', kecamatan: '53.06.06', name: 'Tanah Lein' })
    dataSet.push({ id: '53.01.08.2012', kecamatan: '53.01.08', name: 'Tanah Merah' })
    dataSet.push({ id: '53.01.06.2017', kecamatan: '53.01.06', name: 'Tanah Putih' })
    dataSet.push({ id: '53.19.06.1017', kecamatan: '53.19.06', name: 'Tanah Rata' })
    dataSet.push({ id: '53.06.07.2012', kecamatan: '53.06.07', name: 'Tanah Werang' })
    dataSet.push({ id: '53.20.05.2005', kecamatan: '53.20.05', name: 'Tanajawa' })
    dataSet.push({ id: '53.08.21.2008', kecamatan: '53.08.21', name: 'Tanalangi' })
    dataSet.push({ id: '53.08.07.2006', kecamatan: '53.08.07', name: 'Tanali' })
    dataSet.push({ id: '53.09.06.1014', kecamatan: '53.09.06', name: 'Tanalodu' })
    dataSet.push({ id: '53.11.09.2002', kecamatan: '53.11.09', name: 'Tanaraing' })
    dataSet.push({ id: '53.07.13.2002', kecamatan: '53.07.13', name: 'Tanarawa' })
    dataSet.push({ id: '53.08.12.2016', kecamatan: '53.08.12', name: 'Tanaroga' })
    dataSet.push({ id: '53.11.04.2011', kecamatan: '53.11.04', name: 'Tanatuku' })
    dataSet.push({ id: '53.08.01.2025', kecamatan: '53.08.01', name: 'Tanazozo' })
    dataSet.push({ id: '53.15.10.2002', kecamatan: '53.15.10', name: 'Tandong Belang' })
    dataSet.push({ id: '53.11.04.2002', kecamatan: '53.11.04', name: 'Tandula Jangga' })
    dataSet.push({ id: '53.11.13.2004', kecamatan: '53.11.13', name: 'Tandula Jangga' })
    dataSet.push({ id: '53.18.10.2002', kecamatan: '53.18.10', name: 'Tanggaba' })
    dataSet.push({ id: '53.15.03.1032', kecamatan: '53.15.03', name: 'Tangge' })
    dataSet.push({ id: '53.05.05.2004', kecamatan: '53.05.05', name: 'Tanglapui' })
    dataSet.push({ id: '53.05.05.2011', kecamatan: '53.05.05', name: 'Tanglapui Timur' })
    dataSet.push({ id: '53.19.08.2011', kecamatan: '53.19.08', name: 'Tango Molas' })
    dataSet.push({ id: '53.01.11.2005', kecamatan: '53.01.11', name: 'Tanini' })
    dataSet.push({ id: '53.08.21.2007', kecamatan: '53.08.21', name: 'Taniwoda' })
    dataSet.push({ id: '53.08.04.1014', kecamatan: '53.08.04', name: 'Tanjung' })
    dataSet.push({ id: '53.13.03.2016', kecamatan: '53.13.03', name: 'Tanjung Batu' })
    dataSet.push({ id: '53.15.06.2004', kecamatan: '53.15.06', name: 'Tanjung Boleng' })
    dataSet.push({ id: '53.18.07.2013', kecamatan: '53.18.07', name: 'Tanjung Karoso' })
    dataSet.push({ id: '53.03.08.2010', kecamatan: '53.03.08', name: 'Tapenpah' })
    dataSet.push({ id: '53.11.05.2004', kecamatan: '53.11.05', name: 'Tapil' })
    dataSet.push({ id: '53.06.10.2012', kecamatan: '53.06.10', name: 'Tapobali' })
    dataSet.push({ id: '53.13.08.2015', kecamatan: '53.13.08', name: 'Tapobali' })
    dataSet.push({ id: '53.13.04.2011', kecamatan: '53.13.04', name: 'Tapobarang' })
    dataSet.push({ id: '53.13.04.2014', kecamatan: '53.13.04', name: 'Tapolangu' })
    dataSet.push({ id: '53.12.11.2008', kecamatan: '53.12.11', name: 'Tara Manu' })
    dataSet.push({ id: '53.05.08.2004', kecamatan: '53.05.08', name: 'Taramana' })
    dataSet.push({ id: '53.09.07.2007', kecamatan: '53.09.07', name: 'Tarawaja' })
    dataSet.push({ id: '53.09.07.2018', kecamatan: '53.09.07', name: 'Tarawali' })
    dataSet.push({ id: '53.11.05.2005', kecamatan: '53.11.05', name: 'Tarimbang' })
    dataSet.push({ id: '53.12.04.2018', kecamatan: '53.12.04', name: 'Tarona' })
    dataSet.push({ id: '53.18.10.2020', kecamatan: '53.18.10', name: 'Tarra Mata' })
    dataSet.push({ id: '53.01.08.1007', kecamatan: '53.01.08', name: 'Tarus' })
    dataSet.push({ id: '53.04.13.2009', kecamatan: '53.04.13', name: 'Tasain' })
    dataSet.push({ id: '53.05.15.2006', kecamatan: '53.05.15', name: 'Tasi' })
    dataSet.push({ id: '53.01.16.2002', kecamatan: '53.01.16', name: 'Tasikona' })
    dataSet.push({ id: '53.14.02.2022', kecamatan: '53.14.02', name: 'Tasilo' })
    dataSet.push({ id: '53.03.13.2001', kecamatan: '53.03.13', name: 'Tasinifu' })
    dataSet.push({ id: '53.03.06.2005', kecamatan: '53.03.06', name: 'Taunbaen' })
    dataSet.push({ id: '53.03.06.2013', kecamatan: '53.03.06', name: 'Taunbaen Timur' })
    dataSet.push({ id: '53.03.03.2007', kecamatan: '53.03.03', name: 'Tautpah' })
    dataSet.push({ id: '53.18.04.2020', kecamatan: '53.18.04', name: 'Tawo Rara' })
    dataSet.push({ id: '53.11.06.2004', kecamatan: '53.11.06', name: 'Tawui' })
    dataSet.push({ id: '53.03.22.2001', kecamatan: '53.03.22', name: 'Teba' })
    dataSet.push({ id: '53.12.15.2006', kecamatan: '53.12.15', name: 'Tebara' })
    dataSet.push({ id: '53.14.08.2004', kecamatan: '53.14.08', name: 'Tebole' })
    dataSet.push({ id: '53.07.04.2003', kecamatan: '53.07.04', name: 'Tebuk' })
    dataSet.push({ id: '53.16.01.2004', kecamatan: '53.16.01', name: 'Tedamude' })
    dataSet.push({ id: '53.15.08.2013', kecamatan: '53.15.08', name: 'Tehong' })
    dataSet.push({ id: '53.07.19.2001', kecamatan: '53.07.19', name: 'Teka Iku' })
    dataSet.push({ id: '53.05.01.2018', kecamatan: '53.05.01', name: 'Teluk Kenari' })
    dataSet.push({ id: '53.12.10.2009', kecamatan: '53.12.10', name: 'Tema Tana' })
    dataSet.push({ id: '53.18.03.2002', kecamatan: '53.18.03', name: 'Tema Tana' })
    dataSet.push({ id: '53.14.02.2004', kecamatan: '53.14.02', name: 'Temas' })
    dataSet.push({ id: '53.11.20.1001', kecamatan: '53.11.20', name: 'Temu' })
    dataSet.push({ id: '53.14.10.2007', kecamatan: '53.14.10', name: 'Tena Lai' })
    dataSet.push({ id: '53.18.05.2007', kecamatan: '53.18.05', name: 'Tena Teke' })
    dataSet.push({ id: '53.06.02.2005', kecamatan: '53.06.02', name: 'Tenawahang' })
    dataSet.push({ id: '53.08.09.2002', kecamatan: '53.08.09', name: 'Tenda' })
    dataSet.push({ id: '53.10.12.1010', kecamatan: '53.10.12', name: 'Tenda' })
    dataSet.push({ id: '53.08.01.2026', kecamatan: '53.08.01', name: 'Tenda Ondo' })
    dataSet.push({ id: '53.16.05.2003', kecamatan: '53.16.05', name: 'Tendakinde' })
    dataSet.push({ id: '53.08.01.2006', kecamatan: '53.08.01', name: 'Tendambepa' })
    dataSet.push({ id: '53.08.03.2026', kecamatan: '53.08.03', name: 'Tendambonggi' })
    dataSet.push({ id: '53.08.01.2004', kecamatan: '53.08.01', name: 'Tendarea' })
    dataSet.push({ id: '53.16.05.2001', kecamatan: '53.16.05', name: 'Tendatoto' })
    dataSet.push({ id: '53.16.07.2002', kecamatan: '53.16.07', name: 'Tengatiba' })
    dataSet.push({ id: '53.15.12.2008', kecamatan: '53.15.12', name: 'Tengku' })
    dataSet.push({ id: '53.19.03.2002', kecamatan: '53.19.03', name: 'Tengku Lawar' })
    dataSet.push({ id: '53.19.03.2001', kecamatan: '53.19.03', name: 'Tengku Leda' })
    dataSet.push({ id: '53.10.14.2007', kecamatan: '53.10.14', name: 'Tengku Lese' })
    dataSet.push({ id: '53.19.09.2006', kecamatan: '53.19.09', name: 'Teno Mese' })
    dataSet.push({ id: '53.15.08.2002', kecamatan: '53.15.08', name: 'Tentang' })
    dataSet.push({ id: '53.04.12.1002', kecamatan: '53.04.12', name: 'Tenukiik' })
    dataSet.push({ id: '53.05.14.2010', kecamatan: '53.05.14', name: 'Tereweng' })
    dataSet.push({ id: '53.20.01.2005', kecamatan: '53.20.01', name: 'Teriwu' })
    dataSet.push({ id: '53.05.02.2012', kecamatan: '53.05.02', name: 'Ternate' })
    dataSet.push({ id: '53.05.02.2013', kecamatan: '53.05.02', name: 'Ternate Selatan' })
    dataSet.push({ id: '53.06.10.2004', kecamatan: '53.06.10', name: 'Teromh' })
    dataSet.push({ id: '53.10.13.2013', kecamatan: '53.10.13', name: 'Terong' })
    dataSet.push({ id: '53.03.17.2006', kecamatan: '53.03.17', name: 'Tes' })
    dataSet.push({ id: '53.21.08.2002', kecamatan: '53.21.08', name: 'Tesa' })
    dataSet.push({ id: '53.14.05.2011', kecamatan: '53.14.05', name: 'Tesa Bela' })
    dataSet.push({ id: '53.01.05.2006', kecamatan: '53.01.05', name: 'Tesabela' })
    dataSet.push({ id: '53.01.09.2005', kecamatan: '53.01.09', name: 'Tesbatan' })
    dataSet.push({ id: '53.01.09.2009', kecamatan: '53.01.09', name: 'Tesbatan II' })
    dataSet.push({ id: '53.08.04.1008', kecamatan: '53.08.04', name: 'Tetandara' })
    dataSet.push({ id: '53.04.13.2008', kecamatan: '53.04.13', name: 'Teun' })
    dataSet.push({ id: '53.01.17.1001', kecamatan: '53.01.17', name: 'Teunbaun' })
    dataSet.push({ id: '53.13.01.2013', kecamatan: '53.13.01', name: 'Tewaowutung' })
    dataSet.push({ id: '53.04.02.2018', kecamatan: '53.04.02', name: 'Tialai' })
    dataSet.push({ id: '53.06.17.2004', kecamatan: '53.06.17', name: 'Tikatukan' })
    dataSet.push({ id: '53.07.04.2010', kecamatan: '53.07.04', name: 'Tilang' })
    dataSet.push({ id: '53.01.22.2004', kecamatan: '53.01.22', name: 'Timau' })
    dataSet.push({ id: '53.08.01.2020', kecamatan: '53.08.01', name: 'Timbaria' })
    dataSet.push({ id: '53.10.17.2007', kecamatan: '53.10.17', name: 'Timbu' })
    dataSet.push({ id: '53.07.08.2017', kecamatan: '53.07.08', name: 'Timutawa' })
    dataSet.push({ id: '53.08.03.2018', kecamatan: '53.08.03', name: 'Tinabani' })
    dataSet.push({ id: '53.06.06.2019', kecamatan: '53.06.06', name: 'Titehena' })
    dataSet.push({ id: '53.20.01.2018', kecamatan: '53.20.01', name: 'Titinalede' })
    dataSet.push({ id: '53.08.01.2012', kecamatan: '53.08.01', name: 'Titwerea' })
    dataSet.push({ id: '53.06.04.2003', kecamatan: '53.06.04', name: 'Tiwatobi' })
    dataSet.push({ id: '53.15.10.2012', kecamatan: '53.15.10', name: 'Tiwi Riwung' })
    dataSet.push({ id: '53.09.12.2002', kecamatan: '53.09.12', name: 'Tiworiwu' })
    dataSet.push({ id: '53.09.12.2011', kecamatan: '53.09.12', name: 'Tiworiwu I' })
    dataSet.push({ id: '53.09.12.2012', kecamatan: '53.09.12', name: 'Tiworiwu II' })
    dataSet.push({ id: '53.19.05.1020', kecamatan: '53.19.05', name: 'Tiwu Kondo' })
    dataSet.push({ id: '53.15.05.2022', kecamatan: '53.15.05', name: 'Tiwu Nampar' })
    dataSet.push({ id: '53.09.20.2008', kecamatan: '53.09.20', name: 'Tiwurana' })
    dataSet.push({ id: '53.08.21.2010', kecamatan: '53.08.21', name: 'Tiwusora' })
    dataSet.push({ id: '53.08.20.2005', kecamatan: '53.08.20', name: 'Tiwutewa' })
    dataSet.push({ id: '53.21.08.2004', kecamatan: '53.21.08', name: 'Tniumanu' })
    dataSet.push({ id: '53.05.16.2007', kecamatan: '53.05.16', name: 'Toang' })
    dataSet.push({ id: '53.06.09.2011', kecamatan: '53.06.09', name: 'Tobilota' })
    dataSet.push({ id: '53.06.12.2011', kecamatan: '53.06.12', name: 'Tobitika' })
    dataSet.push({ id: '53.13.07.2017', kecamatan: '53.13.07', name: 'Tobotani' })
    dataSet.push({ id: '53.09.02.1008', kecamatan: '53.09.02', name: 'Todabelu' })
    dataSet.push({ id: '53.13.09.2001', kecamatan: '53.13.09', name: 'Todanara' })
    dataSet.push({ id: '53.71.06.1005', kecamatan: '53.71.06', name: 'Tode Kisar' })
    dataSet.push({ id: '53.10.18.2002', kecamatan: '53.10.18', name: 'Todo' })
    dataSet.push({ id: '53.10.16.2003', kecamatan: '53.10.16', name: 'Toe' })
    dataSet.push({ id: '53.04.03.2002', kecamatan: '53.04.03', name: 'Tohe' })
    dataSet.push({ id: '53.04.03.2006', kecamatan: '53.04.03', name: 'Tohe Leten' })
    dataSet.push({ id: '53.03.03.2009', kecamatan: '53.03.03', name: 'Tokbesi' })
    dataSet.push({ id: '53.14.02.2011', kecamatan: '53.14.02', name: 'Tolama' })
    dataSet.push({ id: '53.01.10.2013', kecamatan: '53.01.10', name: 'Tolnaku' })
    dataSet.push({ id: '53.08.03.2009', kecamatan: '53.08.03', name: 'Tomberabu I' })
    dataSet.push({ id: '53.08.03.2010', kecamatan: '53.08.03', name: 'Tomberabu II' })
    dataSet.push({ id: '53.05.07.2020', kecamatan: '53.05.07', name: 'Tominuku' })
    dataSet.push({ id: '53.16.02.2003', kecamatan: '53.16.02', name: 'Tonggo' })
    dataSet.push({ id: '53.08.03.2021', kecamatan: '53.08.03', name: 'Tonggopapa' })
    dataSet.push({ id: '53.16.01.2013', kecamatan: '53.16.01', name: 'Tonggurambang' })
    dataSet.push({ id: '53.06.08.2016', kecamatan: '53.06.08', name: 'Tonuwotan' })
    dataSet.push({ id: '53.01.17.2003', kecamatan: '53.01.17', name: 'Toobaun' })
    dataSet.push({ id: '53.19.07.2003', kecamatan: '53.19.07', name: 'Torok Golo' })
    dataSet.push({ id: '53.10.16.2008', kecamatan: '53.10.16', name: 'Torong Koe' })
    dataSet.push({ id: '53.18.01.2004', kecamatan: '53.18.01', name: 'Totok' })
    dataSet.push({ id: '53.16.05.2002', kecamatan: '53.16.05', name: 'Totomala' })
    dataSet.push({ id: '53.08.13.2002', kecamatan: '53.08.13', name: 'Tou' })
    dataSet.push({ id: '53.08.13.2012', kecamatan: '53.08.13', name: 'Tou Barat' })
    dataSet.push({ id: '53.08.13.2003', kecamatan: '53.08.13', name: 'Tou Timur' })
    dataSet.push({ id: '53.16.01.1005', kecamatan: '53.16.01', name: 'Towak' })
    dataSet.push({ id: '53.05.03.2003', kecamatan: '53.05.03', name: 'Tribur' })
    dataSet.push({ id: '53.09.06.1017', kecamatan: '53.09.06', name: 'Trikora' })
    dataSet.push({ id: '53.07.13.2005', kecamatan: '53.07.13', name: 'Tua Bao' })
    dataSet.push({ id: '53.03.11.2001', kecamatan: '53.03.11', name: 'Tuabatan' })
    dataSet.push({ id: '53.03.11.2006', kecamatan: '53.03.11', name: 'Tuabatan Barat' })
    dataSet.push({ id: '53.06.12.2002', kecamatan: '53.06.12', name: 'Tuagoetobi' })
    dataSet.push({ id: '53.71.04.1014', kecamatan: '53.71.04', name: 'Tuak Daun Merah' })
    dataSet.push({ id: '53.01.27.2004', kecamatan: '53.01.27', name: 'Tuakau' })
    dataSet.push({ id: '53.06.02.2004', kecamatan: '53.06.02', name: 'Tuakepa' })
    dataSet.push({ id: '53.03.06.2003', kecamatan: '53.03.06', name: 'Tualena' })
    dataSet.push({ id: '53.14.02.2017', kecamatan: '53.14.02', name: 'Tualima' })
    dataSet.push({ id: '53.03.07.2006', kecamatan: '53.03.07', name: 'Tuamese' })
    dataSet.push({ id: '53.14.03.2008', kecamatan: '53.14.03', name: 'Tuanatuk' })
    dataSet.push({ id: '53.07.06.2003', kecamatan: '53.07.06', name: 'Tuanggeo' })
    dataSet.push({ id: '53.01.11.2008', kecamatan: '53.01.11', name: 'Tuapanaf' })
    dataSet.push({ id: '53.01.06.2006', kecamatan: '53.01.06', name: 'Tuapukan' })
    dataSet.push({ id: '53.01.06.1008', kecamatan: '53.01.06', name: 'Tuatuka' })
    dataSet.push({ id: '53.06.10.2010', kecamatan: '53.06.10', name: 'Tuawolo' })
    dataSet.push({ id: '53.05.16.2004', kecamatan: '53.05.16', name: 'Tubbe' })
    dataSet.push({ id: '53.03.14.1006', kecamatan: '53.03.14', name: 'Tublopo' })
    dataSet.push({ id: '53.03.16.2006', kecamatan: '53.03.16', name: 'Tubu' })
    dataSet.push({ id: '53.03.05.1007', kecamatan: '53.03.05', name: 'Tubuhue' })
    dataSet.push({ id: '53.13.02.2006', kecamatan: '53.13.02', name: 'Tubukrajan' })
    dataSet.push({ id: '53.13.07.2018', kecamatan: '53.13.07', name: 'Tubung Walang' })
    dataSet.push({ id: '53.05.16.2001', kecamatan: '53.05.16', name: 'Tude' })
    dataSet.push({ id: '53.15.12.2002', kecamatan: '53.15.12', name: 'Tueng' })
    dataSet.push({ id: '53.04.04.2001', kecamatan: '53.04.04', name: 'Tukuneno' })
    dataSet.push({ id: '53.04.02.2002', kecamatan: '53.04.02', name: 'Tulakadi' })
    dataSet.push({ id: '53.04.21.1002', kecamatan: '53.04.21', name: 'Tulamalae' })
    dataSet.push({ id: '53.05.15.2004', kecamatan: '53.05.15', name: 'Tulleng' })
    dataSet.push({ id: '53.21.06.2004', kecamatan: '53.21.06', name: 'Tunabesi' })
    dataSet.push({ id: '53.03.03.2012', kecamatan: '53.03.03', name: 'Tunbaen' })
    dataSet.push({ id: '53.01.17.2005', kecamatan: '53.01.17', name: 'Tunbaun' })
    dataSet.push({ id: '53.03.23.2001', kecamatan: '53.03.23', name: 'Tunbes' })
    dataSet.push({ id: '53.01.16.2006', kecamatan: '53.01.16', name: 'Tunfeu' })
    dataSet.push({ id: '53.14.05.2010', kecamatan: '53.14.05', name: 'Tungganamo' })
    dataSet.push({ id: '53.21.06.2003', kecamatan: '53.21.06', name: 'Tunmat' })
    dataSet.push({ id: '53.03.01.2023', kecamatan: '53.03.01', name: 'Tunoe' })
    dataSet.push({ id: '53.03.01.2022', kecamatan: '53.03.01', name: 'Tuntun' })
    dataSet.push({ id: '53.09.15.2011', kecamatan: '53.09.15', name: 'Tura Muri' })
    dataSet.push({ id: '53.09.16.2004', kecamatan: '53.09.16', name: 'Turaloa' })
    dataSet.push({ id: '53.09.19.2002', kecamatan: '53.09.19', name: 'Turekisa' })
    dataSet.push({ id: '53.08.06.2024', kecamatan: '53.08.06', name: 'Turunalu' })
    dataSet.push({ id: '53.02.31.2002', kecamatan: '53.02.31', name: 'Tutem' })
    dataSet.push({ id: '53.07.17.2007', kecamatan: '53.07.17', name: 'Tuwa' })
    dataSet.push({ id: '53.16.04.2015', kecamatan: '53.16.04', name: 'Ua' })
    dataSet.push({ id: '53.21.08.2005', kecamatan: '53.21.08', name: 'Uabau' })
    dataSet.push({ id: '53.09.06.2004', kecamatan: '53.09.06', name: 'Ubedolumolo' })
    dataSet.push({ id: '53.09.06.2027', kecamatan: '53.09.06', name: 'Ubedolumolo Satu' })
    dataSet.push({ id: '53.12.10.2006', kecamatan: '53.12.10', name: 'Ubu Pede' })
    dataSet.push({ id: '53.12.10.2010', kecamatan: '53.12.10', name: 'Ubu Raya' })
    dataSet.push({ id: '53.13.05.2011', kecamatan: '53.13.05', name: 'Udak Melomata' })
    dataSet.push({ id: '53.16.06.2007', kecamatan: '53.16.06', name: 'Udiworowatu' })
    dataSet.push({ id: '53.01.04.2006', kecamatan: '53.01.04', name: 'Uiasa' })
    dataSet.push({ id: '53.01.23.2006', kecamatan: '53.01.23', name: 'Uiboa' })
    dataSet.push({ id: '53.01.04.2005', kecamatan: '53.01.04', name: 'Uitao' })
    dataSet.push({ id: '53.01.23.2002', kecamatan: '53.01.23', name: 'Uitiuh Ana' })
    dataSet.push({ id: '53.01.23.2004', kecamatan: '53.01.23', name: 'Uitiuh Tuan' })
    dataSet.push({ id: '53.10.05.2042', kecamatan: '53.10.05', name: 'Ulu Belang' })
    dataSet.push({ id: '53.09.02.2036', kecamatan: '53.09.02', name: 'Ulu Belu' })
    dataSet.push({ id: '53.19.08.2008', kecamatan: '53.19.08', name: 'Ulu Wae' })
    dataSet.push({ id: '53.08.10.2023', kecamatan: '53.08.10', name: 'Uludala' })
    dataSet.push({ id: '53.16.04.2010', kecamatan: '53.16.04', name: 'Ululoga' })
    dataSet.push({ id: '53.19.04.1018', kecamatan: '53.19.04', name: 'Ulung Baras' })
    dataSet.push({ id: '53.16.02.2009', kecamatan: '53.16.02', name: 'Ulupulu' })
    dataSet.push({ id: '53.16.02.2015', kecamatan: '53.16.02', name: 'Ulupulu I' })
    dataSet.push({ id: '53.09.15.2001', kecamatan: '53.09.15', name: 'Uluwae' })
    dataSet.push({ id: '53.09.15.2009', kecamatan: '53.09.15', name: 'Uluwae I' })
    dataSet.push({ id: '53.09.15.2010', kecamatan: '53.09.15', name: 'Uluwae II' })
    dataSet.push({ id: '53.07.10.2016', kecamatan: '53.07.10', name: 'Umagera' })
    dataSet.push({ id: '53.21.01.2007', kecamatan: '53.21.01', name: 'Umakatahan' })
    dataSet.push({ id: '53.04.02.2004', kecamatan: '53.04.02', name: 'Umaklaran' })
    dataSet.push({ id: '53.21.04.2009', kecamatan: '53.21.04', name: 'Umalawain' })
    dataSet.push({ id: '53.13.07.2009', kecamatan: '53.13.07', name: 'Umaleu' })
    dataSet.push({ id: '53.21.02.2007', kecamatan: '53.21.02', name: 'Umalor' })
    dataSet.push({ id: '53.11.08.2002', kecamatan: '53.11.08', name: 'Umalulu' })
    dataSet.push({ id: '53.11.18.2003', kecamatan: '53.11.18', name: 'Umamanu' })
    dataSet.push({ id: '53.04.21.1003', kecamatan: '53.04.21', name: 'Umanen' })
    dataSet.push({ id: '53.21.01.2008', kecamatan: '53.21.01', name: 'Umanen Lawalu' })
    dataSet.push({ id: '53.21.02.2005', kecamatan: '53.21.02', name: 'Umatoos' })
    dataSet.push({ id: '53.07.11.2005', kecamatan: '53.07.11', name: 'Umauta' })
    dataSet.push({ id: '53.17.02.2022', kecamatan: '53.17.02', name: 'Umbu Jodu' })
    dataSet.push({ id: '53.17.02.2007', kecamatan: '53.17.02', name: 'Umbu Kawolu' })
    dataSet.push({ id: '53.17.02.2010', kecamatan: '53.17.02', name: 'Umbu Langang' })
    dataSet.push({ id: '53.17.02.2008', kecamatan: '53.17.02', name: 'Umbu Mamijuk' })
    dataSet.push({ id: '53.18.06.2012', kecamatan: '53.18.06', name: 'Umbu Ngedo' })
    dataSet.push({ id: '53.17.02.2009', kecamatan: '53.17.02', name: 'Umbu Pabal' })
    dataSet.push({ id: '53.17.02.2021', kecamatan: '53.17.02', name: 'Umbu Pabal Selatan' })
    dataSet.push({ id: '53.17.01.2019', kecamatan: '53.17.01', name: 'Umbu Riri' })
    dataSet.push({ id: '53.18.05.2009', kecamatan: '53.18.05', name: 'Umbu Wangu' })
    dataSet.push({ id: '53.10.05.2033', kecamatan: '53.10.05', name: 'Umung' })
    dataSet.push({ id: '53.21.07.2007', kecamatan: '53.21.07', name: 'Umutnana' })
    dataSet.push({ id: '53.08.15.2011', kecamatan: '53.08.15', name: 'Unggu' })
    dataSet.push({ id: '53.03.03.1003', kecamatan: '53.03.03', name: 'Up Faon' })
    dataSet.push({ id: '53.10.15.2003', kecamatan: '53.10.15', name: 'Urang' })
    dataSet.push({ id: '53.19.08.2012', kecamatan: '53.19.08', name: 'Urung Dora' })
    dataSet.push({ id: '53.01.16.2004', kecamatan: '53.01.16', name: 'Usapi Sonbai' })
    dataSet.push({ id: '53.03.20.2002', kecamatan: '53.03.20', name: 'Usapinonot' })
    dataSet.push({ id: '53.16.02.2011', kecamatan: '53.16.02', name: 'Utetoto' })
    dataSet.push({ id: '53.08.03.2020', kecamatan: '53.08.03', name: 'Uzuramba' })
    dataSet.push({ id: '53.08.03.2035', kecamatan: '53.08.03', name: 'Uzuramba Barat' })
    dataSet.push({ id: '53.08.01.2029', kecamatan: '53.08.01', name: 'Uzuzozo' })
    dataSet.push({ id: '53.20.05.2007', kecamatan: '53.20.05', name: 'Wadumaddi' })
    dataSet.push({ id: '53.20.04.2003', kecamatan: '53.20.04', name: 'Waduwalla' })
    dataSet.push({ id: '53.10.05.2005', kecamatan: '53.10.05', name: 'Wae Ajang' })
    dataSet.push({ id: '53.15.03.2012', kecamatan: '53.15.03', name: 'Wae Bangka' })
    dataSet.push({ id: '53.10.03.1005', kecamatan: '53.10.03', name: 'Wae Belang' })
    dataSet.push({ id: '53.15.08.2007', kecamatan: '53.15.08', name: 'Wae Buka' })
    dataSet.push({ id: '53.10.17.2002', kecamatan: '53.10.17', name: 'Wae Codi' })
    dataSet.push({ id: '53.15.10.2010', kecamatan: '53.15.10', name: 'Wae Jare' })
    dataSet.push({ id: '53.15.03.2010', kecamatan: '53.15.03', name: 'Wae Kanta' })
    dataSet.push({ id: '53.15.05.1024', kecamatan: '53.15.05', name: 'Wae Kelambu' })
    dataSet.push({ id: '53.09.02.2038', kecamatan: '53.09.02', name: 'Wae La' })
    dataSet.push({ id: '53.19.05.2029', kecamatan: '53.19.05', name: 'Wae Lokom' })
    dataSet.push({ id: '53.15.04.2020', kecamatan: '53.15.04', name: 'Wae Lolos' })
    dataSet.push({ id: '53.10.14.2012', kecamatan: '53.10.14', name: 'Wae Mantang' })
    dataSet.push({ id: '53.15.09.2007', kecamatan: '53.15.09', name: 'Wae Mose' })
    dataSet.push({ id: '53.15.03.2034', kecamatan: '53.15.03', name: 'Wae Mowol' })
    dataSet.push({ id: '53.10.01.2004', kecamatan: '53.10.01', name: 'Wae Mulu' })
    dataSet.push({ id: '53.19.07.2011', kecamatan: '53.19.07', name: 'Wae Nggori' })
    dataSet.push({ id: '53.19.09.2012', kecamatan: '53.19.09', name: 'Wae Rasan' })
    dataSet.push({ id: '53.10.17.2006', kecamatan: '53.10.17', name: 'Wae Renca' })
    dataSet.push({ id: '53.10.01.2015', kecamatan: '53.10.01', name: 'Wae Rii' })
    dataSet.push({ id: '53.15.04.2014', kecamatan: '53.15.04', name: 'Wae Sano' })
    dataSet.push({ id: '53.15.03.2003', kecamatan: '53.15.03', name: 'Wae Wako' })
    dataSet.push({ id: '53.09.20.2007', kecamatan: '53.09.20', name: 'Waebela' })
    dataSet.push({ id: '53.16.01.2014', kecamatan: '53.16.01', name: 'Waekokak' })
    dataSet.push({ id: '53.09.07.2001', kecamatan: '53.09.07', name: 'Waepana' })
    dataSet.push({ id: '53.09.01.2023', kecamatan: '53.09.01', name: 'Waesae' })
    dataSet.push({ id: '53.09.15.2006', kecamatan: '53.09.15', name: 'Waewea' })
    dataSet.push({ id: '53.11.06.2005', kecamatan: '53.11.06', name: 'Wahang' })
    dataSet.push({ id: '53.07.10.2021', kecamatan: '53.07.10', name: 'Waiara' })
    dataSet.push({ id: '53.06.03.1001', kecamatan: '53.06.03', name: 'Waibalun' })
    dataSet.push({ id: '53.06.05.2011', kecamatan: '53.06.05', name: 'Waibao' })
    dataSet.push({ id: '53.06.10.2007', kecamatan: '53.06.10', name: 'Waiburak' })
    dataSet.push({ id: '53.13.04.2006', kecamatan: '53.13.04', name: 'Waienga' })
    dataSet.push({ id: '53.18.11.2005', kecamatan: '53.18.11', name: 'Waiha' })
    dataSet.push({ id: '53.06.03.1021', kecamatan: '53.06.03', name: 'Waihali' })
    dataSet.push({ id: '53.07.20.2001', kecamatan: '53.07.20', name: 'Waihawa' })
    dataSet.push({ id: '53.18.08.2006', kecamatan: '53.18.08', name: 'Waiholo' })
    dataSet.push({ id: '53.12.11.2005', kecamatan: '53.12.11', name: 'Waihura' })
    dataSet.push({ id: '53.13.05.2010', kecamatan: '53.13.05', name: 'Waijarang' })
    dataSet.push({ id: '53.18.06.2006', kecamatan: '53.18.06', name: 'Waikadada' })
    dataSet.push({ id: '53.11.05.2006', kecamatan: '53.11.05', name: 'Waikanabu' })
    dataSet.push({ id: '53.18.06.2021', kecamatan: '53.18.06', name: 'Waikaninyo' })
    dataSet.push({ id: '53.18.11.2003', kecamatan: '53.18.11', name: 'Waikarara' })
    dataSet.push({ id: '53.18.08.2003', kecamatan: '53.18.08', name: 'Wailabubur' })
    dataSet.push({ id: '53.07.08.2007', kecamatan: '53.07.08', name: 'Wailamung' })
    dataSet.push({ id: '53.18.11.2001', kecamatan: '53.18.11', name: 'Wailangira' })
    dataSet.push({ id: '53.17.05.2004', kecamatan: '53.17.05', name: 'Wailawa' })
    dataSet.push({ id: '53.05.06.2013', kecamatan: '53.05.06', name: 'Wailawar' })
    dataSet.push({ id: '53.06.09.2001', kecamatan: '53.06.09', name: 'Wailebe' })
    dataSet.push({ id: '53.12.15.1001', kecamatan: '53.12.15', name: 'Wailiang' })
    dataSet.push({ id: '53.12.12.2005', kecamatan: '53.12.12', name: 'Wailibo' })
    dataSet.push({ id: '53.07.14.1002', kecamatan: '53.07.14', name: 'Wailiti' })
    dataSet.push({ id: '53.06.04.2001', kecamatan: '53.06.04', name: 'Wailolong' })
    dataSet.push({ id: '53.13.06.2015', kecamatan: '53.13.06', name: 'Wailolong' })
    dataSet.push({ id: '53.18.06.2014', kecamatan: '53.18.06', name: 'Waimakaha' })
    dataSet.push({ id: '53.18.04.2001', kecamatan: '53.18.04', name: 'Waimangura' })
    dataSet.push({ id: '53.17.05.2006', kecamatan: '53.17.05', name: 'Waimanu' })
    dataSet.push({ id: '53.18.06.2015', kecamatan: '53.18.06', name: 'Waimaringi' })
    dataSet.push({ id: '53.13.09.2008', kecamatan: '53.13.09', name: 'Waimatan' })
    dataSet.push({ id: '53.11.17.2002', kecamatan: '53.11.17', name: 'Waimbidi' })
    dataSet.push({ id: '53.05.15.2005', kecamatan: '53.05.15', name: 'Waimi' })
    dataSet.push({ id: '53.18.11.2006', kecamatan: '53.18.11', name: 'Wainyapu' })
    dataSet.push({ id: '53.07.15.1004', kecamatan: '53.07.15', name: 'Waioti' })
    dataSet.push({ id: '53.18.06.2017', kecamatan: '53.18.06', name: 'Waipaddi' })
    dataSet.push({ id: '53.18.11.2008', kecamatan: '53.18.11', name: 'Waipakolo' })
    dataSet.push({ id: '53.11.22.2003', kecamatan: '53.11.22', name: 'Wairara' })
    dataSet.push({ id: '53.17.02.2006', kecamatan: '53.17.02', name: 'Wairasa' })
    dataSet.push({ id: '53.07.09.2005', kecamatan: '53.07.09', name: 'Wairbleler' })
    dataSet.push({ id: '53.07.10.2024', kecamatan: '53.07.10', name: 'Wairkoja' })
    dataSet.push({ id: '53.07.15.1005', kecamatan: '53.07.15', name: 'Wairotang' })
    dataSet.push({ id: '53.07.09.2007', kecamatan: '53.07.09', name: 'Wairterang' })
    dataSet.push({ id: '53.05.08.2002', kecamatan: '53.05.08', name: 'Waisika' })
    dataSet.push({ id: '53.18.09.1004', kecamatan: '53.18.09', name: 'Waitabula' })
    dataSet.push({ id: '53.18.08.2019', kecamatan: '53.18.08', name: 'Waitaru' })
    dataSet.push({ id: '53.06.08.2033', kecamatan: '53.06.08', name: 'Waitukan' })
    dataSet.push({ id: '53.06.01.2003', kecamatan: '53.06.01', name: 'Waiula' })
    dataSet.push({ id: '53.06.08.2011', kecamatan: '53.06.08', name: 'Waiwadan' })
    dataSet.push({ id: '53.06.10.1001', kecamatan: '53.06.10', name: 'Waiwerang Kota' })
    dataSet.push({ id: '53.06.12.2013', kecamatan: '53.06.12', name: 'Waiwuring' })
    dataSet.push({ id: '53.08.03.2032', kecamatan: '53.08.03', name: 'Wajakea Jaya' })
    dataSet.push({ id: '53.16.06.2003', kecamatan: '53.16.06', name: 'Wajo' })
    dataSet.push({ id: '53.16.06.2015', kecamatan: '53.16.06', name: 'Wajo Timur' })
    dataSet.push({ id: '53.16.07.2006', kecamatan: '53.16.07', name: 'Wajomara' })
    dataSet.push({ id: '53.15.12.2004', kecamatan: '53.15.12', name: 'Wajur' })
    dataSet.push({ id: '53.08.07.2020', kecamatan: '53.08.07', name: 'Waka' })
    dataSet.push({ id: '53.15.11.2005', kecamatan: '53.15.11', name: 'Waka' })
    dataSet.push({ id: '53.05.03.2004', kecamatan: '53.05.03', name: 'Wakapsir' })
    dataSet.push({ id: '53.05.03.2022', kecamatan: '53.05.03', name: 'Wakapsir Timur' })
    dataSet.push({ id: '53.13.06.2004', kecamatan: '53.13.06', name: 'Walang Sawah' })
    dataSet.push({ id: '53.10.12.1002', kecamatan: '53.10.12', name: 'Wali' })
    dataSet.push({ id: '53.18.04.2003', kecamatan: '53.18.04', name: 'Wali Ate' })
    dataSet.push({ id: '53.19.01.2031', kecamatan: '53.19.01', name: 'Waling' })
    dataSet.push({ id: '53.18.06.2003', kecamatan: '53.18.06', name: 'Walla Ndimu' })
    dataSet.push({ id: '53.11.08.2004', kecamatan: '53.11.08', name: 'Wanga' })
    dataSet.push({ id: '53.11.16.1001', kecamatan: '53.11.16', name: 'Wangga' })
    dataSet.push({ id: '53.11.06.2002', kecamatan: '53.11.06', name: 'Wangga Mbewa' })
    dataSet.push({ id: '53.11.15.2004', kecamatan: '53.11.15', name: 'Wangga Meti' })
    dataSet.push({ id: '53.17.02.2001', kecamatan: '53.17.02', name: 'Wangga Waiyengu' })
    dataSet.push({ id: '53.09.09.2006', kecamatan: '53.09.09', name: 'Wangka' })
    dataSet.push({ id: '53.09.09.2016', kecamatan: '53.09.09', name: 'Wangka Selatan' })
    dataSet.push({ id: '53.19.08.2010', kecamatan: '53.19.08', name: 'Wangkar Weli' })
    dataSet.push({ id: '53.10.11.1020', kecamatan: '53.10.11', name: 'Wangkung' })
    dataSet.push({ id: '53.15.08.2006', kecamatan: '53.15.08', name: 'Waning' })
    dataSet.push({ id: '53.12.04.2007', kecamatan: '53.12.04', name: 'Wano Kasa' })
    dataSet.push({ id: '53.18.02.2002', kecamatan: '53.18.02', name: 'Wano Talla' })
    dataSet.push({ id: '53.13.03.2004', kecamatan: '53.13.03', name: 'Waowala' })
    dataSet.push({ id: '53.13.01.2015', kecamatan: '53.13.01', name: 'Warawatung' })
    dataSet.push({ id: '53.15.05.2005', kecamatan: '53.15.05', name: 'Warloka' })
    dataSet.push({ id: '53.09.20.2005', kecamatan: '53.09.20', name: 'Warupele Dua' })
    dataSet.push({ id: '53.09.20.2004', kecamatan: '53.09.20', name: 'Warupele Satu' })
    dataSet.push({ id: '53.10.12.1007', kecamatan: '53.10.12', name: 'Waso' })
    dataSet.push({ id: '53.06.07.2002', kecamatan: '53.06.07', name: 'Watanhura' })
    dataSet.push({ id: '53.06.07.2016', kecamatan: '53.06.07', name: 'Watanhura II' })
    dataSet.push({ id: '53.06.08.2030', kecamatan: '53.06.08', name: 'Watobaya' })
    dataSet.push({ id: '53.06.07.2006', kecamatan: '53.06.07', name: 'Watobuku' })
    dataSet.push({ id: '53.13.03.2015', kecamatan: '53.13.03', name: 'Watodiri' })
    dataSet.push({ id: '53.06.07.2004', kecamatan: '53.06.07', name: 'Watohari' })
    dataSet.push({ id: '53.13.05.2008', kecamatan: '53.13.05', name: 'Watokobu' })
    dataSet.push({ id: '53.06.12.2001', kecamatan: '53.06.12', name: 'Watololong' })
    dataSet.push({ id: '53.06.12.2005', kecamatan: '53.06.12', name: 'Watoone' })
    dataSet.push({ id: '53.06.14.2002', kecamatan: '53.06.14', name: 'Watotika Ile' })
    dataSet.push({ id: '53.06.04.2004', kecamatan: '53.06.04', name: 'Watotutu' })
    dataSet.push({ id: '53.06.02.2008', kecamatan: '53.06.02', name: 'Watowara' })
    dataSet.push({ id: '53.10.12.1008', kecamatan: '53.10.12', name: 'Watu' })
    dataSet.push({ id: '53.19.08.2001', kecamatan: '53.19.08', name: 'Watu Arus' })
    dataSet.push({ id: '53.17.03.2009', kecamatan: '53.17.03', name: 'Watu Asa' })
    dataSet.push({ id: '53.10.11.2011', kecamatan: '53.10.11', name: 'Watu Baur' })
    dataSet.push({ id: '53.15.10.2015', kecamatan: '53.15.10', name: 'Watu Galang' })
    dataSet.push({ id: '53.12.12.2007', kecamatan: '53.12.12', name: 'Watu Karere' })
    dataSet.push({ id: '53.18.09.2008', kecamatan: '53.18.09', name: 'Watu Kawula' })
    dataSet.push({ id: '53.18.04.2007', kecamatan: '53.18.04', name: 'Watu Labara' })
    dataSet.push({ id: '53.19.02.2020', kecamatan: '53.19.02', name: 'Watu Lanur' })
    dataSet.push({ id: '53.15.01.2016', kecamatan: '53.15.01', name: 'Watu Manggar' })
    dataSet.push({ id: '53.19.07.2013', kecamatan: '53.19.07', name: 'Watu Mori' })
    dataSet.push({ id: '53.15.05.2009', kecamatan: '53.15.05', name: 'Watu Nggelek' })
    dataSet.push({ id: '53.19.06.1001', kecamatan: '53.19.06', name: 'Watu Nggene' })
    dataSet.push({ id: '53.15.04.2025', kecamatan: '53.15.04', name: 'Watu Panggal' })
    dataSet.push({ id: '53.15.09.2011', kecamatan: '53.15.09', name: 'Watu Rambung' })
    dataSet.push({ id: '53.09.18.2003', kecamatan: '53.09.18', name: 'Watu Sipi' })
    dataSet.push({ id: '53.10.11.2016', kecamatan: '53.10.11', name: 'Watu Tango' })
    dataSet.push({ id: '53.15.09.2013', kecamatan: '53.15.09', name: 'Watu Tiri' })
    dataSet.push({ id: '53.15.07.2009', kecamatan: '53.15.07', name: 'Watu Umpu' })
    dataSet.push({ id: '53.15.09.2002', kecamatan: '53.15.09', name: 'Watu Waja' })
    dataSet.push({ id: '53.15.10.2013', kecamatan: '53.15.10', name: 'Watu Wangka' })
    dataSet.push({ id: '53.18.07.2012', kecamatan: '53.18.07', name: 'Watu Wona' })
    dataSet.push({ id: '53.15.01.2014', kecamatan: '53.15.01', name: 'Watubaru' })
    dataSet.push({ id: '53.07.09.2009', kecamatan: '53.07.09', name: 'Watudiran' })
    dataSet.push({ id: '53.07.15.2010', kecamatan: '53.07.15', name: 'Watugong' })
    dataSet.push({ id: '53.11.08.2008', kecamatan: '53.11.08', name: 'Watuhadang' })
    dataSet.push({ id: '53.08.10.2007', kecamatan: '53.08.10', name: 'Watukamba' })
    dataSet.push({ id: '53.09.15.2005', kecamatan: '53.09.15', name: 'Watukapu' })
    dataSet.push({ id: '53.07.19.2005', kecamatan: '53.07.19', name: 'Watuliwung' })
    dataSet.push({ id: '53.09.12.2001', kecamatan: '53.09.12', name: 'Watumanu' })
    dataSet.push({ id: '53.11.07.1002', kecamatan: '53.11.07', name: 'Watumbaka' })
    dataSet.push({ id: '53.11.18.2001', kecamatan: '53.11.18', name: 'Watumbelar' })
    dataSet.push({ id: '53.07.20.2004', kecamatan: '53.07.20', name: 'Watumerak' })
    dataSet.push({ id: '53.07.19.2007', kecamatan: '53.07.19', name: 'Watumilok' })
    dataSet.push({ id: '53.08.01.2003', kecamatan: '53.08.01', name: 'Watumite' })
    dataSet.push({ id: '53.09.19.2008', kecamatan: '53.09.19', name: 'Watunay' })
    dataSet.push({ id: '53.08.12.1001', kecamatan: '53.08.12', name: 'Watuneso' })
    dataSet.push({ id: '53.08.15.2005', kecamatan: '53.08.15', name: 'Watunggere' })
    dataSet.push({ id: '53.08.15.2013', kecamatan: '53.08.15', name: 'Watunggere Marilonga' })
    dataSet.push({ id: '53.11.08.2009', kecamatan: '53.11.08', name: 'Watupuda' })
    dataSet.push({ id: '53.08.14.2011', kecamatan: '53.08.14', name: 'Waturaka' })
    dataSet.push({ id: '53.08.18.2006', kecamatan: '53.08.18', name: 'Watusipi' })
    dataSet.push({ id: '53.07.03.2002', kecamatan: '53.07.03', name: 'Watutedang' })
    dataSet.push({ id: '53.08.03.2024', kecamatan: '53.08.03', name: 'Wawonato' })
    dataSet.push({ id: '53.09.06.2003', kecamatan: '53.09.06', name: 'Wawowae' })
    dataSet.push({ id: '53.19.04.2017', kecamatan: '53.19.04', name: 'Wea' })
    dataSet.push({ id: '53.16.03.2015', kecamatan: '53.16.03', name: 'Wea Au' })
    dataSet.push({ id: '53.21.05.2015', kecamatan: '53.21.05', name: 'Weain' })
    dataSet.push({ id: '53.21.05.2007', kecamatan: '53.21.05', name: 'Webetun' })
    dataSet.push({ id: '53.21.03.2003', kecamatan: '53.21.03', name: 'Webriamata' })
    dataSet.push({ id: '53.21.04.2006', kecamatan: '53.21.04', name: 'Wederok' })
    dataSet.push({ id: '53.18.05.2014', kecamatan: '53.18.05', name: 'Wee Baghe' })
    dataSet.push({ id: '53.12.10.1012', kecamatan: '53.12.10', name: 'Wee Dabo' })
    dataSet.push({ id: '53.18.01.2015', kecamatan: '53.18.01', name: 'Wee Kambala' })
    dataSet.push({ id: '53.12.10.1007', kecamatan: '53.12.10', name: 'Wee Karou' })
    dataSet.push({ id: '53.18.10.2003', kecamatan: '53.18.10', name: 'Wee Kokora' })
    dataSet.push({ id: '53.18.04.2005', kecamatan: '53.18.04', name: 'Wee Kombaka' })
    dataSet.push({ id: '53.18.04.2018', kecamatan: '53.18.04', name: 'Wee Kura' })
    dataSet.push({ id: '53.18.03.2015', kecamatan: '53.18.03', name: 'Wee Lima' })
    dataSet.push({ id: '53.18.03.2012', kecamatan: '53.18.03', name: 'Wee Limbu' })
    dataSet.push({ id: '53.18.09.2005', kecamatan: '53.18.09', name: 'Wee Londa' })
    dataSet.push({ id: '53.17.03.2006', kecamatan: '53.17.03', name: 'Wee Luri' })
    dataSet.push({ id: '53.18.01.2010', kecamatan: '53.18.01', name: 'Wee Mananda' })
    dataSet.push({ id: '53.18.02.2005', kecamatan: '53.18.02', name: 'Wee Namba' })
    dataSet.push({ id: '53.18.02.2003', kecamatan: '53.18.02', name: 'Wee Paboba' })
    dataSet.push({ id: '53.18.09.2006', kecamatan: '53.18.09', name: 'Wee Pangali' })
    dataSet.push({ id: '53.18.10.2010', kecamatan: '53.18.10', name: 'Wee Patando' })
    dataSet.push({ id: '53.12.04.2008', kecamatan: '53.12.04', name: 'Wee Patola' })
    dataSet.push({ id: '53.18.10.2004', kecamatan: '53.18.10', name: 'Wee Rame' })
    dataSet.push({ id: '53.18.09.2009', kecamatan: '53.18.09', name: 'Wee Rena' })
    dataSet.push({ id: '53.12.18.2001', kecamatan: '53.12.18', name: 'Wee Tana' })
    dataSet.push({ id: '53.18.08.2015', kecamatan: '53.18.08', name: 'Wee Wella' })
    dataSet.push({ id: '53.18.05.2013', kecamatan: '53.18.05', name: 'Wee Wulla' })
    dataSet.push({ id: '53.21.01.2006', kecamatan: '53.21.01', name: 'Wehali' })
    dataSet.push({ id: '53.12.11.2012', kecamatan: '53.12.11', name: 'Wei Mangoma' })
    dataSet.push({ id: '53.19.08.2018', kecamatan: '53.19.08', name: 'Wejang Mali' })
    dataSet.push({ id: '53.19.08.2014', kecamatan: '53.19.08', name: 'Wejang Mawe' })
    dataSet.push({ id: '53.21.05.2013', kecamatan: '53.21.05', name: 'Wekeke' })
    dataSet.push({ id: '53.21.05.2002', kecamatan: '53.21.05', name: 'Wekmidar' })
    dataSet.push({ id: '53.19.04.2014', kecamatan: '53.19.04', name: 'Wela Lada' })
    dataSet.push({ id: '53.05.01.1008', kecamatan: '53.05.01', name: 'Welai Barat' })
    dataSet.push({ id: '53.05.07.2019', kecamatan: '53.05.07', name: 'Welai Selatan' })
    dataSet.push({ id: '53.05.01.1009', kecamatan: '53.05.01', name: 'Welai Timur' })
    dataSet.push({ id: '53.08.07.2001', kecamatan: '53.08.07', name: 'Welamosa' })
    dataSet.push({ id: '53.10.06.2007', kecamatan: '53.10.06', name: 'Welu' })
    dataSet.push({ id: '53.17.04.2006', kecamatan: '53.17.04', name: 'Weluk Praimemang' })
    dataSet.push({ id: '53.21.09.2002', kecamatan: '53.21.09', name: 'Wemeda' })
    dataSet.push({ id: '53.17.03.2004', kecamatan: '53.17.03', name: 'Wendewa Barat' })
    dataSet.push({ id: '53.17.03.2002', kecamatan: '53.17.03', name: 'Wendewa Selatan' })
    dataSet.push({ id: '53.17.03.2001', kecamatan: '53.17.03', name: 'Wendewa Timur' })
    dataSet.push({ id: '53.17.03.2003', kecamatan: '53.17.03', name: 'Wendewa Utara' })
    dataSet.push({ id: '53.21.03.2005', kecamatan: '53.21.03', name: 'Weoe' })
    dataSet.push({ id: '53.07.13.2004', kecamatan: '53.07.13', name: 'Werang' })
    dataSet.push({ id: '53.06.12.2003', kecamatan: '53.06.12', name: 'Weranggere' })
    dataSet.push({ id: '53.09.02.2025', kecamatan: '53.09.02', name: 'Were' })
    dataSet.push({ id: '53.09.18.2012', kecamatan: '53.09.18', name: 'Were Dua' })
    dataSet.push({ id: '53.09.02.2002', kecamatan: '53.09.02', name: 'Were I' })
    dataSet.push({ id: '53.09.02.2026', kecamatan: '53.09.02', name: 'Were IV' })
    dataSet.push({ id: '53.09.18.2006', kecamatan: '53.09.18', name: 'Were Tiga' })
    dataSet.push({ id: '53.06.03.1013', kecamatan: '53.06.03', name: 'Weri' })
    dataSet.push({ id: '53.18.05.2002', kecamatan: '53.18.05', name: 'Weri Lolo' })
    dataSet.push({ id: '53.21.03.2012', kecamatan: '53.21.03', name: 'Weseben' })
    dataSet.push({ id: '53.21.04.2001', kecamatan: '53.21.04', name: 'Wesey' })
    dataSet.push({ id: '53.05.01.1011', kecamatan: '53.05.01', name: 'Wetabua' })
    dataSet.push({ id: '53.21.03.2002', kecamatan: '53.21.03', name: 'Weulun' })
    dataSet.push({ id: '53.15.07.2018', kecamatan: '53.15.07', name: 'Wewa' })
    dataSet.push({ id: '53.08.07.2005', kecamatan: '53.08.07', name: 'Wewaria' })
    dataSet.push({ id: '53.06.18.2006', kecamatan: '53.06.18', name: 'Wewit' })
    dataSet.push({ id: '53.10.05.2019', kecamatan: '53.10.05', name: 'Wewo' })
    dataSet.push({ id: '53.11.12.2010', kecamatan: '53.11.12', name: 'Winumuru' })
    dataSet.push({ id: '53.16.06.2001', kecamatan: '53.16.06', name: 'Witurombaua' })
    dataSet.push({ id: '53.08.09.2003', kecamatan: '53.08.09', name: 'Wiwipemo' })
    dataSet.push({ id: '53.16.02.2013', kecamatan: '53.16.02', name: 'Woedoa' })
    dataSet.push({ id: '53.16.04.2013', kecamatan: '53.16.04', name: 'Woewolo' })
    dataSet.push({ id: '53.16.02.2014', kecamatan: '53.16.02', name: 'Woewutu' })
    dataSet.push({ id: '53.07.20.2003', kecamatan: '53.07.20', name: 'Wogalirit' })
    dataSet.push({ id: '53.09.18.2002', kecamatan: '53.09.18', name: 'Wogowela' })
    dataSet.push({ id: '53.16.02.2004', kecamatan: '53.16.02', name: 'Wokodekororo' })
    dataSet.push({ id: '53.16.02.2016', kecamatan: '53.16.02', name: 'Wokowoe' })
    dataSet.push({ id: '53.08.14.2006', kecamatan: '53.08.14', name: 'Woloara' })
    dataSet.push({ id: '53.08.12.2004', kecamatan: '53.08.12', name: 'Woloara' })
    dataSet.push({ id: '53.08.10.2020', kecamatan: '53.08.10', name: 'Woloau' })
    dataSet.push({ id: '53.16.04.2012', kecamatan: '53.16.04', name: 'Woloede' })
    dataSet.push({ id: '53.08.06.2008', kecamatan: '53.08.06', name: 'Wolofeo' })
    dataSet.push({ id: '53.08.03.2004', kecamatan: '53.08.03', name: 'Wologai' })
    dataSet.push({ id: '53.08.06.2010', kecamatan: '53.08.06', name: 'Wologai' })
    dataSet.push({ id: '53.08.03.2022', kecamatan: '53.08.03', name: 'Wologai Dua' })
    dataSet.push({ id: '53.08.06.2011', kecamatan: '53.08.06', name: 'Wologai Tengah' })
    dataSet.push({ id: '53.08.21.2003', kecamatan: '53.08.21', name: 'Wologai Timur' })
    dataSet.push({ id: '53.08.09.1001', kecamatan: '53.08.09', name: 'Wolojita' })
    dataSet.push({ id: '53.08.03.2012', kecamatan: '53.08.03', name: 'Wolokaro' })
    dataSet.push({ id: '53.08.14.2010', kecamatan: '53.08.14', name: 'Wolokelo' })
    dataSet.push({ id: '53.06.08.2035', kecamatan: '53.06.08', name: 'Wolokibang' })
    dataSet.push({ id: '53.16.04.2003', kecamatan: '53.16.04', name: 'Wolokisa' })
    dataSet.push({ id: '53.07.11.2003', kecamatan: '53.07.11', name: 'Wolokoli' })
    dataSet.push({ id: '53.08.08.2013', kecamatan: '53.08.08', name: 'Wolokoli' })
    dataSet.push({ id: '53.08.05.2017', kecamatan: '53.08.05', name: 'Wolokota' })
    dataSet.push({ id: '53.08.12.2006', kecamatan: '53.08.12', name: 'Wololela A' })
    dataSet.push({ id: '53.16.04.2020', kecamatan: '53.16.04', name: 'Wololelu' })
    dataSet.push({ id: '53.09.15.2004', kecamatan: '53.09.15', name: 'Wololika' })
    dataSet.push({ id: '53.08.06.2013', kecamatan: '53.08.06', name: 'Wolomage' })
    dataSet.push({ id: '53.07.18.2002', kecamatan: '53.07.18', name: 'Wolomapa' })
    dataSet.push({ id: '53.07.14.1003', kecamatan: '53.07.14', name: 'Wolomarang' })
    dataSet.push({ id: '53.08.06.2016', kecamatan: '53.08.06', name: 'Wolomasi' })
    dataSet.push({ id: '53.09.14.2010', kecamatan: '53.09.14', name: 'Wolomese Dua' })
    dataSet.push({ id: '53.09.14.2003', kecamatan: '53.09.14', name: 'Wolomeze' })
    dataSet.push({ id: '53.09.14.2007', kecamatan: '53.09.14', name: 'Wolomeze I' })
    dataSet.push({ id: '53.07.20.2007', kecamatan: '53.07.20', name: 'Wolomotong' })
    dataSet.push({ id: '53.08.15.2004', kecamatan: '53.08.15', name: 'Wolomuku' })
    dataSet.push({ id: '53.07.20.2005', kecamatan: '53.07.20', name: 'Wolonterang' })
    dataSet.push({ id: '53.07.11.2002', kecamatan: '53.07.11', name: 'Wolonwalu' })
    dataSet.push({ id: '53.08.07.2021', kecamatan: '53.08.07', name: 'Wolooja' })
    dataSet.push({ id: '53.16.03.1007', kecamatan: '53.16.03', name: 'Wolopogo' })
    dataSet.push({ id: '53.07.01.2013', kecamatan: '53.07.01', name: 'Wolorega' })
    dataSet.push({ id: '53.08.12.2003', kecamatan: '53.08.12', name: 'Wolosambi' })
    dataSet.push({ id: '53.08.08.2018', kecamatan: '53.08.08', name: 'Wolosoko' })
    dataSet.push({ id: '53.16.04.2007', kecamatan: '53.16.04', name: 'Wolotelu' })
    dataSet.push({ id: '53.08.06.2003', kecamatan: '53.08.06', name: 'Wolotolo' })
    dataSet.push({ id: '53.08.06.2004', kecamatan: '53.08.06', name: 'Wolotolo Tengah' })
    dataSet.push({ id: '53.08.05.2004', kecamatan: '53.08.05', name: 'Wolotolo Timur' })
    dataSet.push({ id: '53.08.05.2003', kecamatan: '53.08.05', name: 'Wolotopo' })
    dataSet.push({ id: '53.16.03.2017', kecamatan: '53.16.03', name: 'Wolowea' })
    dataSet.push({ id: '53.16.03.2025', kecamatan: '53.16.03', name: 'Wolowea Barat' })
    dataSet.push({ id: '53.16.03.2024', kecamatan: '53.16.03', name: 'Wolowea Timur' })
    dataSet.push({ id: '53.07.01.2003', kecamatan: '53.07.01', name: 'Wolowiro' })
    dataSet.push({ id: '53.07.01.2015', kecamatan: '53.07.01', name: 'Wolowona' })
    dataSet.push({ id: '53.05.03.2009', kecamatan: '53.05.03', name: 'Wolwal' })
    dataSet.push({ id: '53.05.03.2016', kecamatan: '53.05.03', name: 'Wolwal Barat' })
    dataSet.push({ id: '53.05.03.2018', kecamatan: '53.05.03', name: 'Wolwal Selatan' })
    dataSet.push({ id: '53.05.03.2017', kecamatan: '53.05.03', name: 'Wolwal Tengah' })
    dataSet.push({ id: '53.08.17.2003', kecamatan: '53.08.17', name: 'Wonda' })
    dataSet.push({ id: '53.10.13.2022', kecamatan: '53.10.13', name: 'Wongka' })
    dataSet.push({ id: '53.15.01.2006', kecamatan: '53.15.01', name: 'Wontong' })
    dataSet.push({ id: '53.08.03.2023', kecamatan: '53.08.03', name: 'Worhopapa' })
    dataSet.push({ id: '53.06.09.2002', kecamatan: '53.06.09', name: 'Wotanulumado' })
    dataSet.push({ id: '53.13.06.2020', kecamatan: '53.13.06', name: 'Wowong' })
    dataSet.push({ id: '53.13.01.2011', kecamatan: '53.13.01', name: 'Wuakoreng' })
    dataSet.push({ id: '53.10.06.2006', kecamatan: '53.10.06', name: 'Wudi' })
    dataSet.push({ id: '53.11.05.2009', kecamatan: '53.11.05', name: 'Wudi Pandak' })
    dataSet.push({ id: '53.09.16.2007', kecamatan: '53.09.16', name: 'Wue' })
    dataSet.push({ id: '53.13.08.2010', kecamatan: '53.13.08', name: 'Wulandoni' })
    dataSet.push({ id: '53.16.04.2004', kecamatan: '53.16.04', name: 'Wuliwalo' })
    dataSet.push({ id: '53.07.04.2006', kecamatan: '53.07.04', name: 'Wuliwutik' })
    dataSet.push({ id: '53.11.11.2001', kecamatan: '53.11.11', name: 'Wulla' })
    dataSet.push({ id: '53.06.07.2010', kecamatan: '53.06.07', name: 'Wulublolong' })
    dataSet.push({ id: '53.11.02.2007', kecamatan: '53.11.02', name: 'Wunga' })
    dataSet.push({ id: '53.18.07.2006', kecamatan: '53.18.07', name: 'Wura Homba' })
    dataSet.push({ id: '53.06.08.2015', kecamatan: '53.06.08', name: 'Wureh' })
    dataSet.push({ id: '53.07.14.1004', kecamatan: '53.07.14', name: 'Wuring' })
    dataSet.push({ id: '53.12.04.2009', kecamatan: '53.12.04', name: 'Zala Kadu' })
    dataSet.push({ id: '53.08.01.2007', kecamatan: '53.08.01', name: 'Zozozea' })
    dataSet.push({ id: '53.09.01.2019', kecamatan: '53.09.01', name: 'Legelapu' })
    */
    dataSet.push({ id:'12.71.15.1001', kecamatan:'12.71.15', name:'A u r'})
    dataSet.push({ id:'12.14.16.2007', kecamatan:'12.14.16', name:'Adam'})
    dataSet.push({ id:'12.11.04.2012', kecamatan:'12.11.04', name:'Adian Gupa'})
    dataSet.push({ id:'12.13.01.2001', kecamatan:'12.13.01', name:'Adian Jior'})
    dataSet.push({ id:'12.02.03.2008', kecamatan:'12.02.03', name:'Adian Koting'})
    dataSet.push({ id:'12.11.04.2004', kecamatan:'12.11.04', name:'Adian Nangka'})
    dataSet.push({ id:'12.23.07.2008', kecamatan:'12.23.07', name:'Adian Torop'})
    dataSet.push({ id:'12.08.08.2012', kecamatan:'12.08.08', name:'Adil Makmur'})
    dataSet.push({ id:'12.05.02.2024', kecamatan:'12.05.02', name:'Adin Tengah'})
    dataSet.push({ id:'12.18.02.2001', kecamatan:'12.18.02', name:'Adolina'})
    dataSet.push({ id:'12.03.21.2023', kecamatan:'12.03.21', name:'Aek Badak Jae'})
    dataSet.push({ id:'12.03.21.2024', kecamatan:'12.03.21', name:'Aek Badak Julu'})
    dataSet.push({ id:'12.09.21.2004', kecamatan:'12.09.21', name:'Aek Bamban'})
    dataSet.push({ id:'12.09.32.2001', kecamatan:'12.09.32', name:'Aek Bange'})
    dataSet.push({ id:'12.13.01.2002', kecamatan:'12.13.01', name:'Aek Banir'})
    dataSet.push({ id:'12.20.05.2018', kecamatan:'12.20.05', name:'Aek Bargot'})
    dataSet.push({ id:'12.21.01.2009', kecamatan:'12.21.01', name:'Aek Bargot'})
    dataSet.push({ id:'12.13.13.2028', kecamatan:'12.13.13', name:'Aek Baru Jae'})
    dataSet.push({ id:'12.13.13.2029', kecamatan:'12.13.13', name:'Aek Baru Julu'})
    dataSet.push({ id:'12.03.04.2113', kecamatan:'12.03.04', name:'Aek Batang Paya'})
    dataSet.push({ id:'12.22.03.2006', kecamatan:'12.22.03', name:'Aek Batu'})
    dataSet.push({ id:'12.20.10.2004', kecamatan:'12.20.10', name:'Aek Bayur'})
    dataSet.push({ id:'12.77.03.2009', kecamatan:'12.77.03', name:'Aek Bayur'})
    dataSet.push({ id:'12.12.01.2024', kecamatan:'12.12.01', name:'Aek Bolon Jae'})
    dataSet.push({ id:'12.12.01.2013', kecamatan:'12.12.01', name:'Aek Bolon Julu'})
    dataSet.push({ id:'12.21.11.2017', kecamatan:'12.21.11', name:'Aek Bonban'})
    dataSet.push({ id:'12.01.14.2008', kecamatan:'12.01.14', name:'Aek Bottar'})
    dataSet.push({ id:'12.13.12.2022', kecamatan:'12.13.12', name:'Aek Botung'})
    dataSet.push({ id:'12.21.11.2023', kecamatan:'12.21.11', name:'Aek Buaton'})
    dataSet.push({ id:'12.10.07.2008', kecamatan:'12.10.07', name:'Aek Buru Selatan'})
    dataSet.push({ id:'12.01.01.2009', kecamatan:'12.01.01', name:'Aek Dakka'})
    dataSet.push({ id:'12.01.19.2002', kecamatan:'12.01.19', name:'Aek Gambir'})
    dataSet.push({ id:'12.20.04.2075', kecamatan:'12.20.04', name:'Aek Gambir'})
    dataSet.push({ id:'12.13.14.2001', kecamatan:'12.13.14', name:'Aek Garingging'})
    dataSet.push({ id:'12.01.03.2014', kecamatan:'12.01.03', name:'Aek Garut'})
    dataSet.push({ id:'12.08.30.2012', kecamatan:'12.08.30', name:'Aek Gerger Sidodadi'})
    dataSet.push({ id:'12.20.09.2001', kecamatan:'12.20.09', name:'Aek Godang'})
    dataSet.push({ id:'12.16.08.2011', kecamatan:'12.16.08', name:'Aek Godang Arbaan'})
    dataSet.push({ id:'12.21.12.2010', kecamatan:'12.21.12', name:'Aek Goti'})
    dataSet.push({ id:'12.22.05.2003', kecamatan:'12.22.05', name:'Aek Goti'})
    dataSet.push({ id:'12.03.07.2067', kecamatan:'12.03.07', name:'Aek Gunung'})
    dataSet.push({ id:'12.13.13.2001', kecamatan:'12.13.13', name:'Aek Guo'})
    dataSet.push({ id:'12.73.03.1001', kecamatan:'12.73.03', name:'Aek Habil'})
    dataSet.push({ id:'12.03.14.2034', kecamatan:'12.03.14', name:'Aek Haminjon'})
    dataSet.push({ id:'12.20.02.2004', kecamatan:'12.20.02', name:'Aek Haruaya'})
    dataSet.push({ id:'12.20.06.2004', kecamatan:'12.20.06', name:'Aek Haruaya'})
    dataSet.push({ id:'12.21.06.2015', kecamatan:'12.21.06', name:'Aek Haruaya'})
    dataSet.push({ id:'12.23.05.2017', kecamatan:'12.23.05', name:'Aek Hitetoras'})
    dataSet.push({ id:'12.13.13.2002', kecamatan:'12.13.13', name:'Aek Holbung'})
    dataSet.push({ id:'12.01.15.2004', kecamatan:'12.01.15', name:'Aek Horsik'})
    dataSet.push({ id:'12.20.02.2025', kecamatan:'12.20.02', name:'Aek Ilung'})
    dataSet.push({ id:'12.20.01.2003', kecamatan:'12.20.01', name:'Aek Jabut'})
    dataSet.push({ id:'12.20.04.2077', kecamatan:'12.20.04', name:'Aek Jangkang'})
    dataSet.push({ id:'12.03.30.2004', kecamatan:'12.03.30', name:'Aek Kahombu'})
    dataSet.push({ id:'12.20.01.2037', kecamatan:'12.20.01', name:'Aek Kanan'})
    dataSet.push({ id:'12.23.01.1001', kecamatan:'12.23.01', name:'Aek Kanopan'})
    dataSet.push({ id:'12.23.01.1002', kecamatan:'12.23.01', name:'Aek Kanopan Timur'})
    dataSet.push({ id:'12.09.32.2002', kecamatan:'12.09.32', name:'Aek Korsik'})
    dataSet.push({ id:'12.23.04.2001', kecamatan:'12.23.04', name:'Aek Korsik'})
    dataSet.push({ id:'12.23.06.1001', kecamatan:'12.23.06', name:'Aek Kota Batu'})
    dataSet.push({ id:'12.20.01.2034', kecamatan:'12.20.01', name:'Aek Kundur'})
    dataSet.push({ id:'12.21.04.2009', kecamatan:'12.21.04', name:'Aek Lancat'})
    dataSet.push({ id:'12.03.22.2046', kecamatan:'12.03.22', name:'Aek Latong'})
    dataSet.push({ id:'12.09.32.2003', kecamatan:'12.09.32', name:'Aek Ledong'})
    dataSet.push({ id:'12.03.21.2018', kecamatan:'12.03.21', name:'Aek Libung'})
    dataSet.push({ id:'12.09.18.2013', kecamatan:'12.09.18', name:'Aek Loba'})
    dataSet.push({ id:'12.09.18.2002', kecamatan:'12.09.18', name:'Aek Loba Afdeling I'})
    dataSet.push({ id:'12.09.18.1001', kecamatan:'12.09.18', name:'Aek Loba Pekan'})
    dataSet.push({ id:'12.16.06.2026', kecamatan:'12.16.06', name:'Aek Lung'})
    dataSet.push({ id:'12.13.13.2003', kecamatan:'12.13.13', name:'Aek Manggis'})
    dataSet.push({ id:'12.73.03.1002', kecamatan:'12.73.03', name:'Aek Manis'})
    dataSet.push({ id:'12.13.14.2002', kecamatan:'12.13.14', name:'Aek Manyuruk'})
    dataSet.push({ id:'12.13.09.2001', kecamatan:'12.13.09', name:'Aek Marian Mg'})
    dataSet.push({ id:'12.13.01.2003', kecamatan:'12.13.01', name:'Aek Mata'})
    dataSet.push({ id:'12.13.06.2001', kecamatan:'12.13.06', name:'Aek Mual'})
    dataSet.push({ id:'12.73.03.1003', kecamatan:'12.73.03', name:'Aek Muara Pinang'})
    dataSet.push({ id:'12.02.07.2004', kecamatan:'12.02.07', name:'Aek Nabara'})
    dataSet.push({ id:'12.03.01.2008', kecamatan:'12.03.01', name:'Aek Nabara'})
    dataSet.push({ id:'12.03.20.2032', kecamatan:'12.03.20', name:'Aek Nabara'})
    dataSet.push({ id:'12.13.03.2001', kecamatan:'12.13.03', name:'Aek Nabara'})
    dataSet.push({ id:'12.13.13.2004', kecamatan:'12.13.13', name:'Aek Nabara'})
    dataSet.push({ id:'12.21.11.2002', kecamatan:'12.21.11', name:'Aek Nabara Jae'})
    dataSet.push({ id:'12.21.11.2019', kecamatan:'12.21.11', name:'Aek Nabara Julu'})
    dataSet.push({ id:'12.21.11.2001', kecamatan:'12.21.11', name:'Aek Nabara Tonga'})
    dataSet.push({ id:'12.09.32.2005', kecamatan:'12.09.32', name:'Aek Nabuntu'})
    dataSet.push({ id:'12.01.16.2005', kecamatan:'12.01.16', name:'Aek Nadua'})
    dataSet.push({ id:'12.09.15.2020', kecamatan:'12.09.15', name:'Aek Nagali'})
    dataSet.push({ id:'12.77.03.2013', kecamatan:'12.77.03', name:'Aek Najaji'})
    dataSet.push({ id:'12.13.13.2005', kecamatan:'12.13.13', name:'Aek Nangali'})
    dataSet.push({ id:'12.03.06.2015', kecamatan:'12.03.06', name:'Aek Natas'})
    dataSet.push({ id:'12.12.09.2018', kecamatan:'12.12.09', name:'Aek Natolu Jaya'})
    dataSet.push({ id:'12.03.07.2005', kecamatan:'12.03.07', name:'Aek Nauli'})
    dataSet.push({ id:'12.17.08.2024', kecamatan:'12.17.08', name:'Aek Nauli'})
    dataSet.push({ id:'12.19.01.2003', kecamatan:'12.19.01', name:'Aek Nauli'})
    dataSet.push({ id:'12.20.09.2002', kecamatan:'12.20.09', name:'Aek Nauli'})
    dataSet.push({ id:'12.72.04.1006', kecamatan:'12.72.04', name:'Aek Nauli'})
    dataSet.push({ id:'12.02.12.2016', kecamatan:'12.02.12', name:'Aek Nauli I'})
    dataSet.push({ id:'12.16.02.2008', kecamatan:'12.16.02', name:'Aek Nauli I'})
    dataSet.push({ id:'12.02.12.2011', kecamatan:'12.02.12', name:'Aek Nauli Ii'})
    dataSet.push({ id:'12.16.02.2009', kecamatan:'12.16.02', name:'Aek Nauli Ii'})
    dataSet.push({ id:'12.02.12.2017', kecamatan:'12.02.12', name:'Aek Nauli Iii'})
    dataSet.push({ id:'12.02.12.2023', kecamatan:'12.02.12', name:'Aek Nauli Iv'})
    dataSet.push({ id:'12.03.02.2036', kecamatan:'12.03.02', name:'Aek Ngadol Sitinjak'})
    dataSet.push({ id:'12.13.04.2001', kecamatan:'12.13.04', name:'Aek Ngali'})
    dataSet.push({ id:'12.10.01.1010', kecamatan:'12.10.01', name:'Aek Paing'})
    dataSet.push({ id:'12.07.02.2006', kecamatan:'12.07.02', name:'Aek Pancur'})
    dataSet.push({ id:'12.03.31.2006', kecamatan:'12.03.31', name:'Aek Pardomuan'})
    dataSet.push({ id:'12.73.03.1004', kecamatan:'12.73.03', name:'Aek Parombunan'})
    dataSet.push({ id:'12.03.30.2016', kecamatan:'12.03.30', name:'Aek Parupuk'})
    dataSet.push({ id:'12.03.02.1032', kecamatan:'12.03.02', name:'Aek Pining'})
    dataSet.push({ id:'12.02.11.2005', kecamatan:'12.02.11', name:'Aek Raja'})
    dataSet.push({ id:'12.20.02.2020', kecamatan:'12.20.02', name:'Aek Rao Tapian Nadenggan'})
    dataSet.push({ id:'12.01.10.2005', kecamatan:'12.01.10', name:'Aek Raso'})
    dataSet.push({ id:'12.22.03.2008', kecamatan:'12.22.03', name:'Aek Raso'})
    dataSet.push({ id:'12.03.20.2035', kecamatan:'12.03.20', name:'Aek Sabaon'})
    dataSet.push({ id:'12.20.06.2021', kecamatan:'12.20.06', name:'Aek Siala'})
    dataSet.push({ id:'12.21.02.2070', kecamatan:'12.21.02', name:'Aek Siala'})
    dataSet.push({ id:'12.02.01.2015', kecamatan:'12.02.01', name:'Aek Siansimun'})
    dataSet.push({ id:'12.20.01.2032', kecamatan:'12.20.01', name:'Aek Simanap'})
    dataSet.push({ id:'12.03.05.1080', kecamatan:'12.03.05', name:'Aek Simotung'})
    dataSet.push({ id:'12.17.06.2004', kecamatan:'12.17.06', name:'Aek Sipitudai'})
    dataSet.push({ id:'12.01.03.1011', kecamatan:'12.01.03', name:'Aek Sitio-tio'})
    dataSet.push({ id:'12.09.21.2001', kecamatan:'12.09.21', name:'Aek Songsongan'})
    dataSet.push({ id:'12.21.09.2018', kecamatan:'12.21.09', name:'Aek Sorik'})
    dataSet.push({ id:'12.20.04.2031', kecamatan:'12.20.04', name:'Aek Suhat'})
    dataSet.push({ id:'12.20.02.2010', kecamatan:'12.20.02', name:'Aek Suhat Jae'})
    dataSet.push({ id:'12.20.02.2070', kecamatan:'12.20.02', name:'Aek Suhat Tr'})
    dataSet.push({ id:'12.20.02.2057', kecamatan:'12.20.02', name:'Aek Sundur'})
    dataSet.push({ id:'12.77.02.1006', kecamatan:'12.77.02', name:'Aek Tampang'})
    dataSet.push({ id:'12.21.02.2004', kecamatan:'12.21.02', name:'Aek Tanduk'})
    dataSet.push({ id:'12.02.14.2011', kecamatan:'12.02.14', name:'Aek Tangga'})
    dataSet.push({ id:'12.20.02.2083', kecamatan:'12.20.02', name:'Aek Tangga'})
    dataSet.push({ id:'12.23.05.2014', kecamatan:'12.23.05', name:'Aek Tapa'})
    dataSet.push({ id:'12.21.08.2014', kecamatan:'12.21.08', name:'Aek Tinga'})
    dataSet.push({ id:'12.01.03.1003', kecamatan:'12.01.03', name:'Aek Tolang'})
    dataSet.push({ id:'12.01.14.1009', kecamatan:'12.01.14', name:'Aek Tolang Induk'})
    dataSet.push({ id:'12.20.10.2005', kecamatan:'12.20.10', name:'Aek Tolong'})
    dataSet.push({ id:'12.20.06.2027', kecamatan:'12.20.06', name:'Aek Torop'})
    dataSet.push({ id:'12.77.03.2006', kecamatan:'12.77.03', name:'Aek Tuhul'})
    dataSet.push({ id:'12.21.02.2009', kecamatan:'12.21.02', name:'Aek Tunjang'})
    dataSet.push({ id:'12.12.04.2028', kecamatan:'12.12.04', name:'Aek Ulok'})
    dataSet.push({ id:'12.03.30.2002', kecamatan:'12.03.30', name:'Aek Uncim'})
    dataSet.push({ id:'12.12.06.2006', kecamatan:'12.12.06', name:'Aek Unsim'})
    dataSet.push({ id:'12.03.22.2047', kecamatan:'12.03.22', name:'Aek Urat'})
    dataSet.push({ id:'12.20.08.2015', kecamatan:'12.20.08', name:'Aekraru'})
    dataSet.push({ id:'12.21.08.2023', kecamatan:'12.21.08', name:'Aer Bale'})
    dataSet.push({ id:'12.10.07.2006', kecamatan:'12.10.07', name:'Afdeling I Rantauprapat'})
    dataSet.push({ id:'12.10.07.2007', kecamatan:'12.10.07', name:'Afdeling II Rantauprapat'})
    dataSet.push({ id:'12.18.07.2009', kecamatan:'12.18.07', name:'Afdeling IV Dolok Ilir'})
    dataSet.push({ id:'12.18.07.2011', kecamatan:'12.18.07', name:'Afdeling VII Dolok Ilir'})
    dataSet.push({ id:'12.24.10.2016', kecamatan:'12.24.10', name:'Afia'})
    dataSet.push({ id:'12.78.03.2001', kecamatan:'12.78.03', name:'Afia'})
    dataSet.push({ id:'12.14.30.2011', kecamatan:'12.14.30', name:'Afore Gobo'})
    dataSet.push({ id:'12.24.09.2001', kecamatan:'12.24.09', name:'Afulu'})
    dataSet.push({ id:'12.04.10.2017', kecamatan:'12.04.10', name:'Ahedano'})
    dataSet.push({ id:'12.09.13.2013', kecamatan:'12.09.13', name:'Air Genting'})
    dataSet.push({ id:'12.05.13.2005', kecamatan:'12.05.13', name:'Air Hitam'})
    dataSet.push({ id:'12.19.10.2008', kecamatan:'12.19.10', name:'Air Hitam'})
    dataSet.push({ id:'12.23.02.2006', kecamatan:'12.23.02', name:'Air Hitam'})
    dataSet.push({ id:'12.09.09.2002', kecamatan:'12.09.09', name:'Air Joman'})
    dataSet.push({ id:'12.09.09.2003', kecamatan:'12.09.09', name:'Air Joman Baru'})
    dataSet.push({ id:'12.22.02.2006', kecamatan:'12.22.02', name:'Air Merah'})
    dataSet.push({ id:'12.09.08.2021', kecamatan:'12.09.08', name:'Air Putih'})
    dataSet.push({ id:'12.09.13.2012', kecamatan:'12.09.13', name:'Air Teluk Hessa'})
    dataSet.push({ id:'12.09.31.2001', kecamatan:'12.09.31', name:'Air Teluk Kiri'})
    dataSet.push({ id:'12.13.22.2008', kecamatan:'12.13.22', name:'Airapa'})
    dataSet.push({ id:'12.07.07.2001', kecamatan:'12.07.07', name:'Aji Baho'})
    dataSet.push({ id:'12.06.04.2029', kecamatan:'12.06.04', name:'Ajibuhara'})
    dataSet.push({ id:'12.06.04.2007', kecamatan:'12.06.04', name:'Ajijahe'})
    dataSet.push({ id:'12.06.04.2002', kecamatan:'12.06.04', name:'Ajijulu'})
    dataSet.push({ id:'12.06.04.2028', kecamatan:'12.06.04', name:'Ajimbelang'})
    dataSet.push({ id:'12.06.05.2013', kecamatan:'12.06.05', name:'Ajinembah'})
    dataSet.push({ id:'12.04.06.2008', kecamatan:'12.04.06', name:'Akhelauwe'})
    dataSet.push({ id:'12.13.11.2001', kecamatan:'12.13.11', name:'Alahan Kae'})
    dataSet.push({ id:'12.09.18.2003', kecamatan:'12.09.18', name:'Alang Bonbon'})
    dataSet.push({ id:'12.01.04.1009', kecamatan:'12.01.04', name:'Albion Prancis'})
    dataSet.push({ id:'12.21.05.2010', kecamatan:'12.21.05', name:'Aliaga'})
    dataSet.push({ id:'12.24.03.2004', kecamatan:'12.24.03', name:'Alo Oa'})
    dataSet.push({ id:'12.20.06.2012', kecamatan:'12.20.06', name:'Aloban'})
    dataSet.push({ id:'12.01.07.2005', kecamatan:'12.01.07', name:'Aloban Bair'})
    dataSet.push({ id:'12.05.15.2001', kecamatan:'12.05.15', name:'Alur Cempedak'})
    dataSet.push({ id:'12.05.17.1002', kecamatan:'12.05.17', name:'Alur Dua'})
    dataSet.push({ id:'12.05.17.1008', kecamatan:'12.05.17', name:'Alur Dua Baru'})
    dataSet.push({ id:'12.05.20.2002', kecamatan:'12.05.20', name:'Alur Gadung'})
    dataSet.push({ id:'12.05.20.2007', kecamatan:'12.05.20', name:'Alur Melati'})
    dataSet.push({ id:'12.11.06.2016', kecamatan:'12.11.06', name:'Alur Subur'})
    dataSet.push({ id:'12.05.21.2005', kecamatan:'12.05.21', name:'Aman Damai'})
    dataSet.push({ id:'12.08.17.1016', kecamatan:'12.08.17', name:'Aman Sari'})
    dataSet.push({ id:'12.14.07.2030', kecamatan:'12.14.07', name:'Amandraya'})
    dataSet.push({ id:'12.14.24.2009', kecamatan:'12.14.24', name:'Amandraya'})
    dataSet.push({ id:'12.09.16.2001', kecamatan:'12.09.16', name:'Ambalutu'})
    dataSet.push({ id:'12.12.05.2008', kecamatan:'12.12.05', name:'Ambar Halim'})
    dataSet.push({ id:'12.08.09.2003', kecamatan:'12.08.09', name:'Ambarisan'})
    dataSet.push({ id:'12.17.01.2005', kecamatan:'12.17.01', name:'Ambarita'})
    dataSet.push({ id:'12.08.07.2003', kecamatan:'12.08.07', name:'Ambarokan Pane Raya'})
    dataSet.push({ id:'12.20.04.2013', kecamatan:'12.20.04', name:'Ambasang Natigor'})
    dataSet.push({ id:'12.16.09.2018', kecamatan:'12.16.09', name:'Ambobi Paranginan'})
    dataSet.push({ id:'12.12.07.2004', kecamatan:'12.12.07', name:'Amborgang'})
    dataSet.push({ id:'12.14.14.2006', kecamatan:'12.14.14', name:'Ambukha'})
    dataSet.push({ id:'12.25.07.2003', kecamatan:'12.25.07', name:'Ambukha'})
    dataSet.push({ id:'12.14.19.2012', kecamatan:'12.14.19', name:'Ambukha I'})
    dataSet.push({ id:'12.14.19.2004', kecamatan:'12.14.19', name:'Amorosa'})
    dataSet.push({ id:'12.07.26.2008', kecamatan:'12.07.26', name:'Amplas'})
    dataSet.push({ id:'12.71.09.1001', kecamatan:'12.71.09', name:'Amplas'})
    dataSet.push({ id:'12.21.08.2025', kecamatan:'12.21.08', name:'Ampolu'})
    dataSet.push({ id:'12.13.13.2006', kecamatan:'12.13.13', name:'Ampung Julu'})
    dataSet.push({ id:'12.13.13.2007', kecamatan:'12.13.13', name:'Ampung Padang'})
    dataSet.push({ id:'12.13.13.2008', kecamatan:'12.13.13', name:'Ampung Siala'})
    dataSet.push({ id:'12.14.08.2001', kecamatan:'12.14.08', name:'Amuri'})
    dataSet.push({ id:'12.14.23.2007', kecamatan:'12.14.23', name:'Anaoma'})
    dataSet.push({ id:'12.24.07.2003', kecamatan:'12.24.07', name:'Anaoma'})
    dataSet.push({ id:'12.01.08.2006', kecamatan:'12.01.08', name:'Anggoli'})
    dataSet.push({ id:'12.71.16.1005', kecamatan:'12.71.16', name:'Anggrung'})
    dataSet.push({ id:'12.13.10.2001', kecamatan:'12.13.10', name:'Angin Barat'})
    dataSet.push({ id:'12.73.01.1002', kecamatan:'12.73.01', name:'Angin Nauli'})
    dataSet.push({ id:'12.14.03.2037', kecamatan:'12.14.03', name:'Angorudua Balaekha'})
    dataSet.push({ id:'12.09.12.2013', kecamatan:'12.09.12', name:'Anjung Ganjang'})
    dataSet.push({ id:'12.19.04.2016', kecamatan:'12.19.04', name:'Antara'})
    dataSet.push({ id:'12.15.05.2003', kecamatan:'12.15.05', name:'Aornakan I'})
    dataSet.push({ id:'12.15.05.2005', kecamatan:'12.15.05', name:'Aornakan Ii'})
    dataSet.push({ id:'12.05.07.2009', kecamatan:'12.05.07', name:'Ara Condong'})
    dataSet.push({ id:'12.18.01.2009', kecamatan:'12.18.01', name:'Ara Payung'})
    dataSet.push({ id:'12.14.15.2005', kecamatan:'12.14.15', name:'Aramo'})
    dataSet.push({ id:'12.19.03.2008', kecamatan:'12.19.03', name:'Aras'})
    dataSet.push({ id:'12.07.33.2003', kecamatan:'12.07.33', name:'Aras Kabu'})
    dataSet.push({ id:'12.18.09.2023', kecamatan:'12.18.09', name:'Aras Panjang'})
    dataSet.push({ id:'12.02.15.2015', kecamatan:'12.02.15', name:'Aritonang'})
    dataSet.push({ id:'12.03.14.1039', kecamatan:'12.03.14', name:'Arse'})
    dataSet.push({ id:'12.20.02.2047', kecamatan:'12.20.02', name:'Arse'})
    dataSet.push({ id:'12.21.07.2038', kecamatan:'12.21.07', name:'Arsesimatorkis'})
    dataSet.push({ id:'12.12.02.2005', kecamatan:'12.12.02', name:'Aruan'})
    dataSet.push({ id:'12.09.10.2001', kecamatan:'12.09.10', name:'Asahan Mati'})
    dataSet.push({ id:'12.22.03.2010', kecamatan:'12.22.03', name:'Asam Jawa'})
    dataSet.push({ id:'12.71.21.1001', kecamatan:'12.71.21', name:'Asam Kumbang'})
    dataSet.push({ id:'12.72.01.1004', kecamatan:'12.72.01', name:'Asuhan'})
    dataSet.push({ id:'12.04.28.2007', kecamatan:'12.04.28', name:'Atualuo'})
    dataSet.push({ id:'12.78.04.2018', kecamatan:'12.78.04', name:'Awa Ai'})
    dataSet.push({ id:'12.04.20.2012', kecamatan:'12.04.20', name:'Awela'})
    dataSet.push({ id:'12.14.35.2007', kecamatan:'12.14.35', name:'Awoni'})
    dataSet.push({ id:'12.04.10.2026', kecamatan:'12.04.10', name:'Awoni Lauso'})
    dataSet.push({ id:'12.71.17.1002', kecamatan:'12.71.17', name:'Babura'})
    dataSet.push({ id:'12.71.02.1004', kecamatan:'12.71.02', name:'Babura Sunggal'})
    dataSet.push({ id:'12.23.05.2012', kecamatan:'12.23.05', name:'Babussalam'})
    dataSet.push({ id:'12.76.05.1004', kecamatan:'12.76.05', name:'Badak Bejuang'})
    dataSet.push({ id:'12.19.06.1022', kecamatan:'12.19.06', name:'Bagan Arya'})
    dataSet.push({ id:'12.09.10.2002', kecamatan:'12.09.10', name:'Bagan Asahan'})
    dataSet.push({ id:'12.09.10.2003', kecamatan:'12.09.10', name:'Bagan Asahan Baru'})
    dataSet.push({ id:'12.09.10.2004', kecamatan:'12.09.10', name:'Bagan Asahan Pekan'})
    dataSet.push({ id:'12.19.12.2011', kecamatan:'12.19.12', name:'Bagan Baru'})
    dataSet.push({ id:'12.10.18.2008', kecamatan:'12.10.18', name:'Bagan Bilah'})
    dataSet.push({ id:'12.19.06.2004', kecamatan:'12.19.06', name:'Bagan Dalam'})
    dataSet.push({ id:'12.71.08.1006', kecamatan:'12.71.08', name:'Bagan Deli'})
    dataSet.push({ id:'12.18.05.2008', kecamatan:'12.18.05', name:'Bagan Kuala'})
    dataSet.push({ id:'12.07.32.2003', kecamatan:'12.07.32', name:'Bagan Serdang'})
    dataSet.push({ id:'12.03.04.2010', kecamatan:'12.03.04', name:'Bagas Lombang'})
    dataSet.push({ id:'12.76.03.1001', kecamatan:'12.76.03', name:'Bagelen'})
    dataSet.push({ id:'12.14.15.2018', kecamatan:'12.14.15', name:'Bagoa'})
    dataSet.push({ id:'12.07.20.2008', kecamatan:'12.07.20', name:'Bah Bah Buntu'})
    dataSet.push({ id:'12.07.09.2003', kecamatan:'12.07.09', name:'Bah Balua'})
    dataSet.push({ id:'12.08.09.2010', kecamatan:'12.08.09', name:'Bah Biak'})
    dataSet.push({ id:'12.08.06.2005', kecamatan:'12.08.06', name:'Bah Birong Ulu'})
    dataSet.push({ id:'12.08.32.2004', kecamatan:'12.08.32', name:'Bah Bolon'})
    dataSet.push({ id:'12.08.04.2008', kecamatan:'12.08.04', name:'Bah Bolon Tonga'})
    dataSet.push({ id:'12.08.07.2005', kecamatan:'12.08.07', name:'Bah Bulian'})
    dataSet.push({ id:'12.08.09.2001', kecamatan:'12.08.09', name:'Bah Butong I'})
    dataSet.push({ id:'12.08.09.2005', kecamatan:'12.08.09', name:'Bah Butong Ii'})
    dataSet.push({ id:'12.08.22.2002', kecamatan:'12.08.22', name:'Bah Gunung'})
    dataSet.push({ id:'12.08.19.2008', kecamatan:'12.08.19', name:'Bah Jambi'})
    dataSet.push({ id:'12.08.11.2006', kecamatan:'12.08.11', name:'Bah Jambi Ii'})
    dataSet.push({ id:'12.08.11.2017', kecamatan:'12.08.11', name:'Bah Jambi Iii'})
    dataSet.push({ id:'12.08.19.2007', kecamatan:'12.08.19', name:'Bah Joga'})
    dataSet.push({ id:'12.72.07.1002', kecamatan:'12.72.07', name:'Bah Kapul'})
    dataSet.push({ id:'12.18.09.2027', kecamatan:'12.18.09', name:'Bah Kerapuh'})
    dataSet.push({ id:'12.08.11.2007', kecamatan:'12.08.11', name:'Bah Kisat'})
    dataSet.push({ id:'12.08.23.2006', kecamatan:'12.08.23', name:'Bah Lias'})
    dataSet.push({ id:'12.08.04.2015', kecamatan:'12.08.04', name:'Bah Liran Siborna'})
    dataSet.push({ id:'12.07.09.2001', kecamatan:'12.07.09', name:'Bah Perak'})
    dataSet.push({ id:'12.08.06.2004', kecamatan:'12.08.06', name:'Bah Sampuran'})
    dataSet.push({ id:'12.08.27.2013', kecamatan:'12.08.27', name:'Bah Sarimah'})
    dataSet.push({ id:'12.18.12.2038', kecamatan:'12.18.12', name:'Bah Sidua-Dua'})
    dataSet.push({ id:'12.72.07.1005', kecamatan:'12.72.07', name:'Bah Sorma'})
    dataSet.push({ id:'12.18.13.2001', kecamatan:'12.18.13', name:'Bah Sumbu'})
    dataSet.push({ id:'12.08.17.2002', kecamatan:'12.08.17', name:'Bah Tobu'})
    dataSet.push({ id:'12.08.07.2004', kecamatan:'12.08.07', name:'Bah Tonang'})
    dataSet.push({ id:'12.20.06.2017', kecamatan:'12.20.06', name:'Bahal'})
    dataSet.push({ id:'12.08.18.2012', kecamatan:'12.08.18', name:'Bahal Batu'})
    dataSet.push({ id:'12.21.02.2019', kecamatan:'12.21.02', name:'Bahal Batu'})
    dataSet.push({ id:'12.02.09.2006', kecamatan:'12.02.09', name:'Bahal Batu I'})
    dataSet.push({ id:'12.02.09.2007', kecamatan:'12.02.09', name:'Bahal Batu Ii'})
    dataSet.push({ id:'12.02.09.2008', kecamatan:'12.02.09', name:'Bahal Batu Iii'})
    dataSet.push({ id:'12.08.09.2006', kecamatan:'12.08.09', name:'Bahal Gajah'})
    dataSet.push({ id:'12.08.19.2003', kecamatan:'12.08.19', name:'Bahalat Bayu'})
    dataSet.push({ id:'12.20.02.2024', kecamatan:'12.20.02', name:'Bahap'})
    dataSet.push({ id:'12.08.29.2007', kecamatan:'12.08.29', name:'Bahapal Raya'})
    dataSet.push({ id:'12.18.07.2014', kecamatan:'12.18.07', name:'Bahdamar'})
    dataSet.push({ id:'12.18.16.2006', kecamatan:'12.18.16', name:'Bahilang'})
    dataSet.push({ id:'12.24.01.2008', kecamatan:'12.24.01', name:'Baho'})
    dataSet.push({ id:'12.08.17.2014', kecamatan:'12.08.17', name:'Bahung Huluan'})
    dataSet.push({ id:'12.08.17.2006', kecamatan:'12.08.17', name:'Bahung Kahean'})
    dataSet.push({ id:'12.09.23.2006', kecamatan:'12.09.23', name:'Bahung Sibatu-Batu'})
    dataSet.push({ id:'12.01.07.2009', kecamatan:'12.01.07', name:'Bair'})
    dataSet.push({ id:'12.14.16.2005', kecamatan:'12.14.16', name:'Bais'})
    dataSet.push({ id:'12.14.16.2009', kecamatan:'12.14.16', name:'Bais Baru'})
    dataSet.push({ id:'12.08.11.2004', kecamatan:'12.08.11', name:'Baja Dolok'})
    dataSet.push({ id:'12.18.08.2006', kecamatan:'12.18.08', name:'Baja Dolok'})
    dataSet.push({ id:'12.05.11.2010', kecamatan:'12.05.11', name:'Baja Kuning'})
    dataSet.push({ id:'12.18.09.2008', kecamatan:'12.18.09', name:'Baja Ronggi'})
    dataSet.push({ id:'12.01.11.1001', kecamatan:'12.01.11', name:'Bajamas'})
    dataSet.push({ id:'12.11.05.2020', kecamatan:'12.11.05', name:'Bakal Gajah'})
    dataSet.push({ id:'12.11.07.2011', kecamatan:'12.11.07', name:'Bakal Julu'})
    dataSet.push({ id:'12.07.27.2008', kecamatan:'12.07.27', name:'Bakaran Batu'})
    dataSet.push({ id:'12.07.28.2006', kecamatan:'12.07.28', name:'Bakaran Batu'})
    dataSet.push({ id:'12.10.02.1001', kecamatan:'12.10.02', name:'Bakaran Batu'})
    dataSet.push({ id:'12.18.15.2003', kecamatan:'12.18.15', name:'Bakaran Batu'})
    dataSet.push({ id:'12.05.03.2003', kecamatan:'12.05.03', name:'Balai Kasih'})
    dataSet.push({ id:'12.20.05.2020', kecamatan:'12.20.05', name:'Balakka'})
    dataSet.push({ id:'12.20.06.2032', kecamatan:'12.20.06', name:'Balakka Torop'})
    dataSet.push({ id:'12.04.11.2026', kecamatan:'12.04.11', name:'Balale Toba A'})
    dataSet.push({ id:'12.11.06.2013', kecamatan:'12.11.06', name:'Balandua'})
    dataSet.push({ id:'12.21.12.2013', kecamatan:'12.21.12', name:'Balangka'})
    dataSet.push({ id:'12.14.30.2006', kecamatan:'12.14.30', name:'Bale-Bale'})
    dataSet.push({ id:'12.14.30.2012', kecamatan:'12.14.30', name:'Bale-Bale Sibohou'})
    dataSet.push({ id:'12.24.10.2014', kecamatan:'12.24.10', name:'Balefadoro Tuho'})
    dataSet.push({ id:'12.12.01.1034', kecamatan:'12.12.01', name:'Balige I'})
    dataSet.push({ id:'12.12.01.2023', kecamatan:'12.12.01', name:'Balige II'})
    dataSet.push({ id:'12.12.01.1035', kecamatan:'12.12.01', name:'Balige Iii'})
    dataSet.push({ id:'12.08.11.2015', kecamatan:'12.08.11', name:'Baliju'})
    dataSet.push({ id:'12.13.16.2001', kecamatan:'12.13.16', name:'Balimbing'})
    dataSet.push({ id:'12.20.03.2005', kecamatan:'12.20.03', name:'Balimbing'})
    dataSet.push({ id:'12.20.05.2007', kecamatan:'12.20.05', name:'Balimbing Jae'})
    dataSet.push({ id:'12.20.05.2009', kecamatan:'12.20.05', name:'Balimbing Julu'})
    dataSet.push({ id:'12.08.11.2003', kecamatan:'12.08.11', name:'Balimbingan'})
    dataSet.push({ id:'12.04.28.2001', kecamatan:'12.04.28', name:'Balodano'})
    dataSet.push({ id:'12.25.06.2001', kecamatan:'12.25.06', name:'Balodano'})
    dataSet.push({ id:'12.14.05.2027', kecamatan:'12.14.05', name:'Balogia'})
    dataSet.push({ id:'12.14.15.2012', kecamatan:'12.14.15', name:'Balohao'})
    dataSet.push({ id:'12.04.21.2008', kecamatan:'12.04.21', name:'Balohili Botomuzoi'})
    dataSet.push({ id:'12.14.27.2002', kecamatan:'12.14.27', name:'Balohili Gomo'})
    dataSet.push({ id:'12.14.14.2005', kecamatan:'12.14.14', name:'Balohili Mola'})
    dataSet.push({ id:'12.14.21.2011', kecamatan:'12.14.21', name:'Balohili O O U'})
    dataSet.push({ id:'12.14.35.2009', kecamatan:'12.14.35', name:'Balombaruzo Orahua'})
    dataSet.push({ id:'12.25.02.2012', kecamatan:'12.25.02', name:'Balowondrate'})
    dataSet.push({ id:'12.14.31.2001', kecamatan:'12.14.31', name:'Baluta'})
    dataSet.push({ id:'12.07.03.2001', kecamatan:'12.07.03', name:'Bandar Baru'})
    dataSet.push({ id:'12.15.01.2004', kecamatan:'12.15.01', name:'Bandar Baru'})
    dataSet.push({ id:'12.18.10.2013', kecamatan:'12.18.10', name:'Bandar Bayu'})
    dataSet.push({ id:'12.08.22.2008', kecamatan:'12.08.22', name:'Bandar Betsy I'})
    dataSet.push({ id:'12.08.22.2009', kecamatan:'12.08.22', name:'Bandar Betsy Ii'})
    dataSet.push({ id:'12.07.31.2010', kecamatan:'12.07.31', name:'Bandar Dolok'})
    dataSet.push({ id:'12.08.13.2008', kecamatan:'12.08.13', name:'Bandar Dolok'})
    dataSet.push({ id:'12.23.07.1001', kecamatan:'12.23.07', name:'Bandar Durian'})
    dataSet.push({ id:'12.07.09.2005', kecamatan:'12.07.09', name:'Bandar Gugung'})
    dataSet.push({ id:'12.08.24.2010', kecamatan:'12.08.24', name:'Bandar Gunung'})
    dataSet.push({ id:'12.03.29.2001', kecamatan:'12.03.29', name:'Bandar Hapinis'})
    dataSet.push({ id:'12.11.09.2002', kecamatan:'12.11.09', name:'Bandar Huta Usang'})
    dataSet.push({ id:'12.08.23.2012', kecamatan:'12.08.23', name:'Bandar Jawa'})
    dataSet.push({ id:'12.07.26.2011', kecamatan:'12.07.26', name:'Bandar Khalipah'})
    dataSet.push({ id:'12.07.26.2012', kecamatan:'12.07.26', name:'Bandar Klippa'})
    dataSet.push({ id:'12.07.09.2002', kecamatan:'12.07.09', name:'Bandar Kuala'})
    dataSet.push({ id:'12.07.19.2003', kecamatan:'12.07.19', name:'Bandar Kuala'})
    dataSet.push({ id:'12.10.07.2002', kecamatan:'12.10.07', name:'Bandar Kumbul'})
    dataSet.push({ id:'12.07.02.2004', kecamatan:'12.07.02', name:'Bandar Labuhan'})
    dataSet.push({ id:'12.23.08.2008', kecamatan:'12.23.08', name:'Bandar Lama'})
    dataSet.push({ id:'12.13.14.2003', kecamatan:'12.13.14', name:'Bandar Limabung'})
    dataSet.push({ id:'12.18.17.2006', kecamatan:'12.18.17', name:'Bandar Magodang'})
    dataSet.push({ id:'12.08.03.2009', kecamatan:'12.08.03', name:'Bandar Malela'})
    dataSet.push({ id:'12.08.10.2004', kecamatan:'12.08.10', name:'Bandar Manik'})
    dataSet.push({ id:'12.08.21.2008', kecamatan:'12.08.21', name:'Bandar Manis'})
    dataSet.push({ id:'12.08.27.2004', kecamatan:'12.08.27', name:'Bandar Maruhur'})
    dataSet.push({ id:'12.08.24.2001', kecamatan:'12.08.24', name:'Bandar Masilam'})
    dataSet.push({ id:'12.08.24.2006', kecamatan:'12.08.24', name:'Bandar Masilam Ii'})
    dataSet.push({ id:'12.06.06.2004', kecamatan:'12.06.06', name:'Bandar Meriah'})
    dataSet.push({ id:'12.07.09.2006', kecamatan:'12.07.09', name:'Bandar Meriah'})
    dataSet.push({ id:'12.08.27.2009', kecamatan:'12.08.27', name:'Bandar Nagori'})
    dataSet.push({ id:'12.20.02.2079', kecamatan:'12.20.02', name:'Bandar Nauli'})
    dataSet.push({ id:'12.18.17.2004', kecamatan:'12.18.17', name:'Bandar Negeri'})
    dataSet.push({ id:'12.13.12.2001', kecamatan:'12.13.12', name:'Bandar Panjang'})
    dataSet.push({ id:'12.13.12.2002', kecamatan:'12.13.12', name:'Bandar Panjang Tuo'})
    dataSet.push({ id:'12.09.17.2001', kecamatan:'12.09.17', name:'Bandar Pasir Mandoge'})
    dataSet.push({ id:'12.18.17.2011', kecamatan:'12.18.17', name:'Bandar Pinang Kebun'})
    dataSet.push({ id:'12.18.17.2013', kecamatan:'12.18.17', name:'Bandar Pinang Rambe'})
    dataSet.push({ id:'12.09.15.2003', kecamatan:'12.09.15', name:'Bandar Pulau Pekan'})
    dataSet.push({ id:'12.08.23.2005', kecamatan:'12.08.23', name:'Bandar Pulo'})
    dataSet.push({ id:'12.06.10.2007', kecamatan:'12.06.10', name:'Bandar Purba'})
    dataSet.push({ id:'12.19.06.2018', kecamatan:'12.19.06', name:'Bandar Rahmat'})
    dataSet.push({ id:'12.08.23.2004', kecamatan:'12.08.23', name:'Bandar Rakyat'})
    dataSet.push({ id:'12.08.24.2009', kecamatan:'12.08.24', name:'Bandar Rejo'})
    dataSet.push({ id:'12.76.04.1005', kecamatan:'12.76.04', name:'Bandar Sakti'})
    dataSet.push({ id:'12.08.31.2010', kecamatan:'12.08.31', name:'Bandar Saribu'})
    dataSet.push({ id:'12.08.14.2011', kecamatan:'12.08.14', name:'Bandar Sauhur'})
    dataSet.push({ id:'12.08.17.2003', kecamatan:'12.08.17', name:'Bandar Selamat'})
    dataSet.push({ id:'12.23.04.2002', kecamatan:'12.23.04', name:'Bandar Selamat'})
    dataSet.push({ id:'12.71.14.1006', kecamatan:'12.71.14', name:'Bandar Selamat'})
    dataSet.push({ id:'12.75.03.1001', kecamatan:'12.75.03', name:'Bandar Senembah'})
    dataSet.push({ id:'12.07.26.2017', kecamatan:'12.07.26', name:'Bandar Setia'})
    dataSet.push({ id:'12.08.02.2008', kecamatan:'12.08.02', name:'Bandar Siantar'})
    dataSet.push({ id:'12.08.24.2003', kecamatan:'12.08.24', name:'Bandar Silou'})
    dataSet.push({ id:'12.19.12.2006', kecamatan:'12.19.12', name:'Bandar Sono'})
    dataSet.push({ id:'12.76.01.1007', kecamatan:'12.76.01', name:'Bandar Sono'})
    dataSet.push({ id:'12.03.31.2005', kecamatan:'12.03.31', name:'Bandar Tarutung'})
    dataSet.push({ id:'12.18.06.2001', kecamatan:'12.18.06', name:'Bandar Tengah'})
    dataSet.push({ id:'12.08.24.2008', kecamatan:'12.08.24', name:'Bandar Tinggi'})
    dataSet.push({ id:'12.10.09.2007', kecamatan:'12.10.09', name:'Bandar Tinggi'})
    dataSet.push({ id:'12.08.22.2003', kecamatan:'12.08.22', name:'Bandar Tonga'})
    dataSet.push({ id:'12.06.05.2017', kecamatan:'12.06.05', name:'Bandar Tongging'})
    dataSet.push({ id:'12.76.05.1005', kecamatan:'12.76.05', name:'Bandar Utama'})
    dataSet.push({ id:'12.18.07.2003', kecamatan:'12.18.07', name:'Bandarawan'})
    dataSet.push({ id:'12.72.03.1007', kecamatan:'12.72.03', name:'Bane'})
    dataSet.push({ id:'12.22.03.2001', kecamatan:'12.22.03', name:'Bangai'})
    dataSet.push({ id:'12.03.21.2012', kecamatan:'12.03.21', name:'Bange'})
    dataSet.push({ id:'12.13.07.2001', kecamatan:'12.13.07', name:'Bange'})
    dataSet.push({ id:'12.13.07.2015', kecamatan:'12.13.07', name:'Bange Nauli'})
    dataSet.push({ id:'12.13.13.2009', kecamatan:'12.13.13', name:'Bangkelang'})
    dataSet.push({ id:'12.21.11.2021', kecamatan:'12.21.11', name:'Bangkuang'})
    dataSet.push({ id:'12.20.06.2031', kecamatan:'12.20.06', name:'Bangkudu'})
    dataSet.push({ id:'12.21.02.2007', kecamatan:'12.21.02', name:'Bangkudu'})
    dataSet.push({ id:'12.08.02.2010', kecamatan:'12.08.02', name:'Bangun'})
    dataSet.push({ id:'12.09.14.2007', kecamatan:'12.09.14', name:'Bangun'})
    dataSet.push({ id:'12.11.10.2001', kecamatan:'12.11.10', name:'Bangun'})
    dataSet.push({ id:'12.09.11.2016', kecamatan:'12.09.11', name:'Bangun Baru'})
    dataSet.push({ id:'12.08.04.2013', kecamatan:'12.08.04', name:'Bangun Das Mariah'})
    dataSet.push({ id:'12.11.10.2011', kecamatan:'12.11.10', name:'Bangun I'})
    dataSet.push({ id:'12.08.25.2003', kecamatan:'12.08.25', name:'Bangun Mariah'})
    dataSet.push({ id:'12.71.09.1007', kecamatan:'12.71.09', name:'Bangun Mulia'})
    dataSet.push({ id:'12.08.32.2006', kecamatan:'12.08.32', name:'Bangun Pane'})
    dataSet.push({ id:'12.03.07.1068', kecamatan:'12.03.07', name:'Bangun Purba'})
    dataSet.push({ id:'12.07.09.2008', kecamatan:'12.07.09', name:'Bangun Purba'})
    dataSet.push({ id:'12.13.09.2002', kecamatan:'12.13.09', name:'Bangun Purba'})
    dataSet.push({ id:'12.20.10.2008', kecamatan:'12.20.10', name:'Bangun Purba'})
    dataSet.push({ id:'12.07.09.2009', kecamatan:'12.07.09', name:'Bangun Purba Tengah'})
    dataSet.push({ id:'12.08.04.2005', kecamatan:'12.08.04', name:'Bangun Rakyat'})
    dataSet.push({ id:'12.08.07.2006', kecamatan:'12.08.07', name:'Bangun Raya'})
    dataSet.push({ id:'12.21.07.2003', kecamatan:'12.21.07', name:'Bangun Raya'})
    dataSet.push({ id:'12.07.02.2005', kecamatan:'12.07.02', name:'Bangun Rejo'})
    dataSet.push({ id:'12.23.06.2013', kecamatan:'12.23.06', name:'Bangun Rejo'})
    dataSet.push({ id:'12.07.02.2016', kecamatan:'12.07.02', name:'Bangun Sari'})
    dataSet.push({ id:'12.09.27.2005', kecamatan:'12.09.27', name:'Bangun Sari'})
    dataSet.push({ id:'12.09.28.2005', kecamatan:'12.09.28', name:'Bangun Sari'})
    dataSet.push({ id:'12.19.11.2005', kecamatan:'12.19.11', name:'Bangun Sari'})
    dataSet.push({ id:'12.07.02.2023', kecamatan:'12.07.02', name:'Bangun Sari Baru'})
    dataSet.push({ id:'12.13.18.2006', kecamatan:'12.13.18', name:'Bangun Saroha'})
    dataSet.push({ id:'12.13.19.2001', kecamatan:'12.13.19', name:'Bangun Sejati'})
    dataSet.push({ id:'12.08.04.2014', kecamatan:'12.08.04', name:'Bangun Sitolu Bah'})
    dataSet.push({ id:'12.08.30.2011', kecamatan:'12.08.30', name:'Bangun Sordang'})
    dataSet.push({ id:'12.09.09.2005', kecamatan:'12.09.09', name:'Banjar'})
    dataSet.push({ id:'12.72.02.1007', kecamatan:'12.72.02', name:'Banjar'})
    dataSet.push({ id:'12.13.15.2001', kecamatan:'12.13.15', name:'Banjar Aur'})
    dataSet.push({ id:'12.13.22.2006', kecamatan:'12.13.22', name:'Banjar Aur Utara'})
    dataSet.push({ id:'12.12.24.2003', kecamatan:'12.12.24', name:'Banjar Ganjang'})
    dataSet.push({ id:'12.08.30.2019', kecamatan:'12.08.30', name:'Banjar Hulu'})
    dataSet.push({ id:'12.13.03.2014', kecamatan:'12.13.03', name:'Banjar Lancat'})
    dataSet.push({ id:'12.13.18.2010', kecamatan:'12.13.18', name:'Banjar Maga'})
    dataSet.push({ id:'12.13.13.2010', kecamatan:'12.13.13', name:'Banjar Malayu'})
    dataSet.push({ id:'12.11.13.2003', kecamatan:'12.11.13', name:'Banjar Toba'})
    dataSet.push({ id:'12.08.07.2013', kecamatan:'12.08.07', name:'Banjaran'})
    dataSet.push({ id:'12.18.10.2003', kecamatan:'12.18.10', name:'Banjaran Godang'})
    dataSet.push({ id:'12.05.12.2011', kecamatan:'12.05.12', name:'Banjaran Raya'})
    dataSet.push({ id:'12.18.09.2016', kecamatan:'12.18.09', name:'Bantan'})
    dataSet.push({ id:'12.71.14.1004', kecamatan:'12.71.14', name:'Bantan'})
    dataSet.push({ id:'12.72.02.1003', kecamatan:'12.72.02', name:'Bantan'})
    dataSet.push({ id:'12.71.14.1007', kecamatan:'12.71.14', name:'Bantan Timur'})
    dataSet.push({ id:'12.08.07.2011', kecamatan:'12.08.07', name:'Banu Raya'})
    dataSet.push({ id:'12.24.03.2006', kecamatan:'12.24.03', name:'Banua Gea'})
    dataSet.push({ id:'12.12.19.2010', kecamatan:'12.12.19', name:'Banua Huta'})
    dataSet.push({ id:'12.13.23.2004', kecamatan:'12.13.23', name:'Banua Rakyat'})
    dataSet.push({ id:'12.24.05.2011', kecamatan:'12.24.05', name:'Banua Sibohou'})
    dataSet.push({ id:'12.04.21.2014', kecamatan:'12.04.21', name:'Banua Sibohou Botomuzoi'})
    dataSet.push({ id:'12.24.07.2008', kecamatan:'12.24.07', name:'Banua Sibohou I'})
    dataSet.push({ id:'12.24.07.2010', kecamatan:'12.24.07', name:'Banua Sibohou Ii'})
    dataSet.push({ id:'12.24.06.2001', kecamatan:'12.24.06', name:'Banua Sibohou Iii'})
    dataSet.push({ id:'12.04.11.2019', kecamatan:'12.04.11', name:'Banua Sibohou Silima Ewali'})
    dataSet.push({ id:'12.13.23.2006', kecamatan:'12.13.23', name:'Banua Simanosor'})
    dataSet.push({ id:'12.21.01.2018', kecamatan:'12.21.01', name:'Banua Tonga'})
    dataSet.push({ id:'12.21.10.2006', kecamatan:'12.21.10', name:'Banua Tonga'})
    dataSet.push({ id:'12.02.03.2011', kecamatan:'12.02.03', name:'Banuaji I'})
    dataSet.push({ id:'12.02.03.2012', kecamatan:'12.02.03', name:'Banuaji Ii'})
    dataSet.push({ id:'12.02.03.2010', kecamatan:'12.02.03', name:'Banuaji Iv'})
    dataSet.push({ id:'12.02.10.2007', kecamatan:'12.02.10', name:'Banualuhu'})
    dataSet.push({ id:'12.16.09.2010', kecamatan:'12.16.09', name:'Banuarea'})
    dataSet.push({ id:'12.08.05.2010', kecamatan:'12.08.05', name:'Banuh Raya'})
    dataSet.push({ id:'12.05.07.2007', kecamatan:'12.05.07', name:'Banyumas'})
    dataSet.push({ id:'12.20.06.2018', kecamatan:'12.20.06', name:'Bara'})
    dataSet.push({ id:'12.21.02.2018', kecamatan:'12.21.02', name:'Bara Batu'})
    dataSet.push({ id:'12.01.09.2004', kecamatan:'12.01.09', name:'Barambang'})
    dataSet.push({ id:'12.13.05.2001', kecamatan:'12.13.05', name:'Barbaran'})
    dataSet.push({ id:'12.13.05.2002', kecamatan:'12.13.05', name:'Barbaran Jae'})
    dataSet.push({ id:'12.03.07.2047', kecamatan:'12.03.07', name:'Bargot Topong'})
    dataSet.push({ id:'12.20.03.2020', kecamatan:'12.20.03', name:'Bargot Topong Jae'})
    dataSet.push({ id:'12.20.03.2019', kecamatan:'12.20.03', name:'Bargot Topong Julu'})
    dataSet.push({ id:'12.77.03.2015', kecamatan:'12.77.03', name:'Bargottopong'})
    dataSet.push({ id:'12.01.09.2009', kecamatan:'12.01.09', name:'Baringin'})
    dataSet.push({ id:'12.03.04.1004', kecamatan:'12.03.04', name:'Baringin'})
    dataSet.push({ id:'12.16.01.2004', kecamatan:'12.16.01', name:'Baringin'})
    dataSet.push({ id:'12.16.01.2020', kecamatan:'12.16.01', name:'Baringin Natam'})
    dataSet.push({ id:'12.72.05.1005', kecamatan:'12.72.05', name:'Baringin Pancur Nauli'})
    dataSet.push({ id:'12.08.29.1018', kecamatan:'12.08.29', name:'Baringin Raya'})
    dataSet.push({ id:'12.20.02.2058', kecamatan:'12.20.02', name:'Baringin Sil'})
    dataSet.push({ id:'12.20.02.2017', kecamatan:'12.20.02', name:'Baringin Sip'})
    dataSet.push({ id:'12.11.02.2025', kecamatan:'12.11.02', name:'Barisan Nauli'})
    dataSet.push({ id:'12.03.04.2097', kecamatan:'12.03.04', name:'Barnang Koling'})
    dataSet.push({ id:'12.18.08.2003', kecamatan:'12.18.08', name:'Bartong'})
    dataSet.push({ id:'12.07.05.2024', kecamatan:'12.07.05', name:'Baru'})
    dataSet.push({ id:'12.07.27.2004', kecamatan:'12.07.27', name:'Baru'})
    dataSet.push({ id:'12.09.14.2011', kecamatan:'12.09.14', name:'Baru'})
    dataSet.push({ id:'12.72.03.1003', kecamatan:'12.72.03', name:'Baru'})
    dataSet.push({ id:'12.05.10.2009', kecamatan:'12.05.10', name:'Baru Pasar Viii'})
    dataSet.push({ id:'12.07.19.2002', kecamatan:'12.07.19', name:'Baru Titi Besi'})
    dataSet.push({ id:'12.12.01.2012', kecamatan:'12.12.01', name:'Baruara'})
    dataSet.push({ id:'12.77.03.2007', kecamatan:'12.77.03', name:'Baruas'})
    dataSet.push({ id:'12.19.09.2004', kecamatan:'12.19.09', name:'Barung-Barung'})
    dataSet.push({ id:'12.06.06.2005', kecamatan:'12.06.06', name:'Barung Kersap'})
    dataSet.push({ id:'12.06.03.2008', kecamatan:'12.06.03', name:'Barusjahe'})
    dataSet.push({ id:'12.06.03.2005', kecamatan:'12.06.03', name:'Barusjulu'})
    dataSet.push({ id:'12.14.05.2007', kecamatan:'12.14.05', name:'Baruyu Lasara'})
    dataSet.push({ id:'12.14.04.2022', kecamatan:'12.14.04', name:'Baruyu Sibohou'})
    dataSet.push({ id:'12.04.10.2031', kecamatan:'12.04.10', name:'Baruzo'})
    dataSet.push({ id:'12.04.35.2007', kecamatan:'12.04.35', name:'Baruzo'})
    dataSet.push({ id:'12.03.32.2003', kecamatan:'12.03.32', name:'Basilam Baru'})
    dataSet.push({ id:'12.13.08.2001', kecamatan:'12.13.08', name:'Batahan'})
    dataSet.push({ id:'12.13.15.2003', kecamatan:'12.13.15', name:'Batahan I'})
    dataSet.push({ id:'12.13.15.2019', kecamatan:'12.13.15', name:'Batahan Ii'})
    dataSet.push({ id:'12.13.15.2020', kecamatan:'12.13.15', name:'Batahan Iii'})
    dataSet.push({ id:'12.13.15.2021', kecamatan:'12.13.15', name:'Batahan Iv'})
    dataSet.push({ id:'12.77.01.1007', kecamatan:'12.77.01', name:'Batang Ayumi Jae'})
    dataSet.push({ id:'12.77.01.1008', kecamatan:'12.77.01', name:'Batang Ayumi Julu'})
    dataSet.push({ id:'12.77.03.2012', kecamatan:'12.77.03', name:'Batang Bahal'})
    dataSet.push({ id:'12.20.04.2043', kecamatan:'12.20.04', name:'Batang Baruhar Jae'})
    dataSet.push({ id:'12.20.04.2042', kecamatan:'12.20.04', name:'Batang Baruhar Julu'})
    dataSet.push({ id:'12.11.01.1009', kecamatan:'12.11.01', name:'Batang Beruh'})
    dataSet.push({ id:'12.21.10.2003', kecamatan:'12.21.10', name:'Batang Bulu Baru'})
    dataSet.push({ id:'12.21.04.2015', kecamatan:'12.21.04', name:'Batang Bulu Jae'})
    dataSet.push({ id:'12.21.10.2001', kecamatan:'12.21.10', name:'Batang Bulu Lama'})
    dataSet.push({ id:'12.21.04.2024', kecamatan:'12.21.04', name:'Batang Bulu Tanggal'})
    dataSet.push({ id:'12.13.05.2003', kecamatan:'12.13.05', name:'Batang Gadis'})
    dataSet.push({ id:'12.13.05.2010', kecamatan:'12.13.05', name:'Batang Gadis Jae'})
    dataSet.push({ id:'12.22.04.2002', kecamatan:'12.22.04', name:'Batang Nadenggan'})
    dataSet.push({ id:'12.20.07.2008', kecamatan:'12.20.07', name:'Batang Onang Baru'})
    dataSet.push({ id:'12.20.07.2005', kecamatan:'12.20.07', name:'Batang Onang Lama'})
    dataSet.push({ id:'12.20.11.2012', kecamatan:'12.20.11', name:'Batang Pane I'})
    dataSet.push({ id:'12.20.11.2013', kecamatan:'12.20.11', name:'Batang Pane Ii'})
    dataSet.push({ id:'12.20.11.2014', kecamatan:'12.20.11', name:'Batang Pane Iii'})
    dataSet.push({ id:'12.03.05.2079', kecamatan:'12.03.05', name:'Batang Parsuluman'})
    dataSet.push({ id:'12.05.19.1001', kecamatan:'12.05.19', name:'Batang Serangan'})
    dataSet.push({ id:'12.21.04.2010', kecamatan:'12.21.04', name:'Batang Tanggal Baru'})
    dataSet.push({ id:'12.18.02.1040', kecamatan:'12.18.02', name:'Batang Terap'})
    dataSet.push({ id:'12.03.04.2108', kecamatan:'12.03.04', name:'Batang Tura'})
    dataSet.push({ id:'12.03.04.2107', kecamatan:'12.03.04', name:'Batang Tura Julu'})
    dataSet.push({ id:'12.03.03.1099', kecamatan:'12.03.03', name:'Batang Tura Sirumambe'})
    dataSet.push({ id:'12.07.27.2005', kecamatan:'12.07.27', name:'Batangkuis Pekan'})
    dataSet.push({ id:'12.18.09.2006', kecamatan:'12.18.09', name:'Batu 12'})
    dataSet.push({ id:'12.18.09.2007', kecamatan:'12.18.09', name:'Batu 13'})
    dataSet.push({ id:'12.09.22.2004', kecamatan:'12.09.22', name:'Batu Anam'})
    dataSet.push({ id:'12.21.08.2035', kecamatan:'12.21.08', name:'Batu Gajah'})
    dataSet.push({ id:'12.20.05.2016', kecamatan:'12.20.05', name:'Batu Gana'})
    dataSet.push({ id:'12.07.06.2030', kecamatan:'12.07.06', name:'Batu Gemuk'})
    dataSet.push({ id:'12.07.09.2007', kecamatan:'12.07.09', name:'Batu Gingging'})
    dataSet.push({ id:'12.03.31.2009', kecamatan:'12.03.31', name:'Batu Godang'})
    dataSet.push({ id:'12.11.12.2003', kecamatan:'12.11.12', name:'Batu Gun Gun'})
    dataSet.push({ id:'12.20.01.2018', kecamatan:'12.20.01', name:'Batu Hibul'})
    dataSet.push({ id:'12.03.02.2005', kecamatan:'12.03.02', name:'Batu Horing'})
    dataSet.push({ id:'12.03.30.2005', kecamatan:'12.03.30', name:'Batu Horpak'})
    dataSet.push({ id:'12.03.02.2008', kecamatan:'12.03.02', name:'Batu Hula'})
    dataSet.push({ id:'12.05.01.2014', kecamatan:'12.05.01', name:'Batu Jong-Jong'})
    dataSet.push({ id:'12.77.06.2002', kecamatan:'12.77.06', name:'Batu Layan'})
    dataSet.push({ id:'12.07.03.2002', kecamatan:'12.07.03', name:'Batu Layang'})
    dataSet.push({ id:'12.07.19.2004', kecamatan:'12.07.19', name:'Batu Lokong'})
    dataSet.push({ id:'12.13.13.2011', kecamatan:'12.13.13', name:'Batu Madinding'})
    dataSet.push({ id:'12.05.10.2002', kecamatan:'12.05.10', name:'Batu Malenggang'})
    dataSet.push({ id:'12.06.07.2012', kecamatan:'12.06.07', name:'Batu Mamak'})
    dataSet.push({ id:'12.20.04.2027', kecamatan:'12.20.04', name:'Batu Mamak'})
    dataSet.push({ id:'12.20.07.2018', kecamatan:'12.20.07', name:'Batu Mamak'})
    dataSet.push({ id:'12.12.21.2007', kecamatan:'12.12.21', name:'Batu Manumpak'})
    dataSet.push({ id:'12.18.11.2004', kecamatan:'12.18.11', name:'Batu Masagi'})
    dataSet.push({ id:'12.07.03.2003', kecamatan:'12.07.03', name:'Batu Mbelin'})
    dataSet.push({ id:'12.07.06.2009', kecamatan:'12.07.06', name:'Batu Mbelin'})
    dataSet.push({ id:'12.13.17.2001', kecamatan:'12.13.17', name:'Batu Mundom'})
    dataSet.push({ id:'12.12.04.2018', kecamatan:'12.12.04', name:'Batu Nabolon'})
    dataSet.push({ id:'12.02.13.2008', kecamatan:'12.02.13', name:'Batu Nadua'})
    dataSet.push({ id:'12.16.08.2001', kecamatan:'12.16.08', name:'Batu Nagodang Siatas'})
    dataSet.push({ id:'12.20.07.2031', kecamatan:'12.20.07', name:'Batu Nanggar'})
    dataSet.push({ id:'12.07.06.2018', kecamatan:'12.07.06', name:'Batu Penjemuran'})
    dataSet.push({ id:'12.20.07.2011', kecamatan:'12.20.07', name:'Batu Pulut'})
    dataSet.push({ id:'12.20.05.2004', kecamatan:'12.20.05', name:'Batu Rancang'})
    dataSet.push({ id:'12.07.09.2011', kecamatan:'12.07.09', name:'Batu Rata'})
    dataSet.push({ id:'12.07.06.2032', kecamatan:'12.07.06', name:'Batu Rejo'})
    dataSet.push({ id:'12.06.09.2014', kecamatan:'12.06.09', name:'Batu Rongkam'})
    dataSet.push({ id:'12.20.02.2022', kecamatan:'12.20.02', name:'Batu Runding'})
    dataSet.push({ id:'12.03.04.2017', kecamatan:'12.03.04', name:'Batu Satail'})
    dataSet.push({ id:'12.08.28.2001', kecamatan:'12.08.28', name:'Batu Silangit'})
    dataSet.push({ id:'12.13.15.2004', kecamatan:'12.13.15', name:'Batu Sondat'})
    dataSet.push({ id:'12.20.04.2054', kecamatan:'12.20.04', name:'Batu Sundung'})
    dataSet.push({ id:'12.20.04.2050', kecamatan:'12.20.04', name:'Batu Tambun'})
    dataSet.push({ id:'12.20.03.2044', kecamatan:'12.20.03', name:'Batu Tunggal'})
    dataSet.push({ id:'12.23.06.2003', kecamatan:'12.23.06', name:'Batu Tunggal'})
    dataSet.push({ id:'12.02.11.2014', kecamatan:'12.02.11', name:'Batuarimo'})
    dataSet.push({ id:'12.02.15.2012', kecamatan:'12.02.15', name:'Batubinumbun'})
    dataSet.push({ id:'12.06.11.2012', kecamatan:'12.06.11', name:'Batukarang'})
    dataSet.push({ id:'12.06.08.2020', kecamatan:'12.06.08', name:'Batumamak'})
    dataSet.push({ id:'12.02.13.2015', kecamatan:'12.02.13', name:'Batumanumpak'})
    dataSet.push({ id:'12.77.03.1001', kecamatan:'12.77.03', name:'Batunadua Jae'})
    dataSet.push({ id:'12.77.03.1002', kecamatan:'12.77.03', name:'Batunadua Julu'})
    dataSet.push({ id:'12.16.07.2001', kecamatan:'12.16.07', name:'Batunajagar'})
    dataSet.push({ id:'12.21.02.2071', kecamatan:'12.21.02', name:'Batusundung'})
    dataSet.push({ id:'12.08.26.2007', kecamatan:'12.08.26', name:'Bawang'})
    dataSet.push({ id:'12.25.02.2005', kecamatan:'12.25.02', name:'Bawasawa'})
    dataSet.push({ id:'12.14.05.2003', kecamatan:'12.14.05', name:'Bawo Amahelato'})
    dataSet.push({ id:'12.14.05.2004', kecamatan:'12.14.05', name:'Bawo Omasio'})
    dataSet.push({ id:'12.14.03.2003', kecamatan:'12.14.03', name:'Bawo Otalua'})
    dataSet.push({ id:'12.14.31.2009', kecamatan:'12.14.31', name:'Bawo Analita Saeru'})
    dataSet.push({ id:'12.14.19.2011', kecamatan:'12.14.19', name:'Bawo Lolomatua'})
    dataSet.push({ id:'12.14.31.2003', kecamatan:'12.14.31', name:'Bawo Ofuloa'})
    dataSet.push({ id:'12.14.31.2005', kecamatan:'12.14.31', name:'Bawo Orudua'})
    dataSet.push({ id:'12.78.01.2001', kecamatan:'12.78.01', name:'Bawodesolo'})
    dataSet.push({ id:'12.78.04.2004', kecamatan:'12.78.04', name:'Bawodesolo'})
    dataSet.push({ id:'12.14.05.2002', kecamatan:'12.14.05', name:'Bawodobara'})
    dataSet.push({ id:'12.14.06.2023', kecamatan:'12.14.06', name:'Bawodobara'})
    dataSet.push({ id:'12.14.18.2015', kecamatan:'12.14.18', name:'Bawofanayama'})
    dataSet.push({ id:'12.14.12.2004', kecamatan:'12.14.12', name:'Bawoganowo'})
    dataSet.push({ id:'12.14.10.2002', kecamatan:'12.14.10', name:'Bawogosali'})
    dataSet.push({ id:'12.14.20.2002', kecamatan:'12.14.20', name:'Bawohosi'})
    dataSet.push({ id:'12.14.10.2015', kecamatan:'12.14.10', name:'Bawohosi Maniamolo'})
    dataSet.push({ id:'12.14.13.2004', kecamatan:'12.14.13', name:'Bawolahusa'})
    dataSet.push({ id:'12.14.13.2011', kecamatan:'12.14.13', name:'Bawolahusa Doli-Doli'})
    dataSet.push({ id:'12.14.03.2001', kecamatan:'12.14.03', name:'Bawolato'})
    dataSet.push({ id:'12.14.29.2007', kecamatan:'12.14.29', name:'Bawolawindra'})
    dataSet.push({ id:'12.14.06.2024', kecamatan:'12.14.06', name:'Bawolowalani'})
    dataSet.push({ id:'12.14.32.2010', kecamatan:'12.14.32', name:'Bawomaenamolo'})
    dataSet.push({ id:'12.14.18.2001', kecamatan:'12.14.18', name:'Bawomataluo'})
    dataSet.push({ id:'12.14.18.2003', kecamatan:'12.14.18', name:'Bawonahono'})
    dataSet.push({ id:'12.14.06.2009', kecamatan:'12.14.06', name:'Bawonifaoso'})
    dataSet.push({ id:'12.14.21.2004', kecamatan:'12.14.21', name:'Bawosalo O Bawoluo'})
    dataSet.push({ id:'12.14.11.2003', kecamatan:'12.14.11', name:'Bawosalo O Dao-Dao'})
    dataSet.push({ id:'12.14.08.2004', kecamatan:'12.14.08', name:'Bawosalo O Siwalawa'})
    dataSet.push({ id:'12.25.02.2001', kecamatan:'12.25.02', name:'Bawosaloo'})
    dataSet.push({ id:'12.14.10.2016', kecamatan:'12.14.10', name:'Bawosaodano'})
    dataSet.push({ id:'12.14.29.2004', kecamatan:'12.14.29', name:'Bawositora'})
    dataSet.push({ id:'12.25.01.2002', kecamatan:'12.25.01', name:'Bawozamaiwo'})
    dataSet.push({ id:'12.14.06.2010', kecamatan:'12.14.06', name:'Bawozaua'})
    dataSet.push({ id:'12.14.03.2002', kecamatan:'12.14.03', name:'Bawozihono'})
    dataSet.push({ id:'12.08.11.2016', kecamatan:'12.08.11', name:'Bayu Bagasan'})
    dataSet.push({ id:'12.06.12.2022', kecamatan:'12.06.12', name:'Beganding'})
    dataSet.push({ id:'12.07.09.2010', kecamatan:'12.07.09', name:'Begerpang'})
    dataSet.push({ id:'12.06.16.2008', kecamatan:'12.06.16', name:'Bekerah'})
    dataSet.push({ id:'12.06.07.2005', kecamatan:'12.06.07', name:'Bekilang'})
    dataSet.push({ id:'12.05.03.2004', kecamatan:'12.05.03', name:'Bekiung'})
    dataSet.push({ id:'12.07.06.2012', kecamatan:'12.07.06', name:'Bekukul'})
    dataSet.push({ id:'12.05.06.2008', kecamatan:'12.05.06', name:'Bekulap'})
    dataSet.push({ id:'12.05.03.1019', kecamatan:'12.05.03', name:'Bela Rakyat'})
    dataSet.push({ id:'12.11.01.2008', kecamatan:'12.11.01', name:'Belang Malum'})
    dataSet.push({ id:'12.71.08.1003', kecamatan:'12.71.08', name:'Belawan Bahagia'})
    dataSet.push({ id:'12.71.08.1004', kecamatan:'12.71.08', name:'Belawan Bahari'})
    dataSet.push({ id:'12.71.08.1001', kecamatan:'12.71.08', name:'Belawan I'})
    dataSet.push({ id:'12.71.08.1002', kecamatan:'12.71.08', name:'Belawan Ii'})
    dataSet.push({ id:'12.71.08.1005', kecamatan:'12.71.08', name:'Belawan Sicanang'})
    dataSet.push({ id:'12.05.04.2006', kecamatan:'12.05.04', name:'Belinteng'})
    dataSet.push({ id:'12.23.05.2010', kecamatan:'12.23.05', name:'Belongkut'})
    dataSet.push({ id:'12.18.14.2001', kecamatan:'12.18.14', name:'Bengabing'})
    dataSet.push({ id:'12.18.02.2003', kecamatan:'12.18.02', name:'Bengkel'})
    dataSet.push({ id:'12.07.03.2005', kecamatan:'12.07.03', name:'Bengkurung'})
    dataSet.push({ id:'12.19.05.2017', kecamatan:'12.19.05', name:'Benteng'})
    dataSet.push({ id:'12.03.07.2027', kecamatan:'12.03.07', name:'Benteng Huraba'})
    dataSet.push({ id:'12.19.07.2012', kecamatan:'12.19.07', name:'Benteng Jaya'})
    dataSet.push({ id:'12.11.13.2004', kecamatan:'12.11.13', name:'Berampu'})
    dataSet.push({ id:'12.05.14.1006', kecamatan:'12.05.14', name:'Berandan Barat'})
    dataSet.push({ id:'12.05.14.1008', kecamatan:'12.05.14', name:'Berandan Timur'})
    dataSet.push({ id:'12.05.14.1007', kecamatan:'12.05.14', name:'Berandan Timur Baru'})
    dataSet.push({ id:'12.05.15.1009', kecamatan:'12.05.15', name:'Beras Basah'})
    dataSet.push({ id:'12.06.12.2025', kecamatan:'12.06.12', name:'Berastepu'})
    dataSet.push({ id:'12.07.33.2007', kecamatan:'12.07.33', name:'Beringin'})
    dataSet.push({ id:'12.71.21.1004', kecamatan:'12.71.21', name:'Beringin'})
    dataSet.push({ id:'12.13.02.2002', kecamatan:'12.13.02', name:'Beringin Jaya'})
    dataSet.push({ id:'12.22.03.2012', kecamatan:'12.22.03', name:'Beringin Jaya'})
    dataSet.push({ id:'12.75.02.1001', kecamatan:'12.75.02', name:'Berngam'})
    dataSet.push({ id:'12.76.04.1004', kecamatan:'12.76.04', name:'Berohol'})
    dataSet.push({ id:'12.06.04.2016', kecamatan:'12.06.04', name:'Bertah'})
    dataSet.push({ id:'12.11.03.2008', kecamatan:'12.11.03', name:'Bertungen Julu'})
    dataSet.push({ id:'12.24.05.2001', kecamatan:'12.24.05', name:'Berua'})
    dataSet.push({ id:'12.14.23.2008', kecamatan:'12.14.23', name:'Berua Siwalawa'})
    dataSet.push({ id:'12.05.03.2007', kecamatan:'12.05.03', name:'Beruam'})
    dataSet.push({ id:'12.05.03.2006', kecamatan:'12.05.03', name:'Besadi'})
    dataSet.push({ id:'12.71.13.1003', kecamatan:'12.71.13', name:'Besar'})
    dataSet.push({ id:'12.18.01.2007', kecamatan:'12.18.01', name:'Besar Ii Terjun'})
    dataSet.push({ id:'12.05.12.2005', kecamatan:'12.05.12', name:'Besilam'})
    dataSet.push({ id:'12.05.08.2004', kecamatan:'12.05.08', name:'Besilam Bukit Lembasa'})
    dataSet.push({ id:'12.07.03.2004', kecamatan:'12.07.03', name:'Betimus Mbaru'})
    dataSet.push({ id:'12.74.04.1005', kecamatan:'12.74.04', name:'Beting Kuala Kapias'})
    dataSet.push({ id:'12.75.05.1003', kecamatan:'12.75.05', name:'Bhakti Karya'})
    dataSet.push({ id:'12.06.06.2022', kecamatan:'12.06.06', name:'Biaknampe'})
    dataSet.push({ id:'12.21.07.2013', kecamatan:'12.21.07', name:'Binabo Jae'})
    dataSet.push({ id:'12.21.07.2012', kecamatan:'12.21.07', name:'Binabo Julu'})
    dataSet.push({ id:'12.78.04.2012', kecamatan:'12.78.04', name:'Binaka'})
    dataSet.push({ id:'12.13.19.2013', kecamatan:'12.13.19', name:'Binanga'})
    dataSet.push({ id:'12.21.02.2010', kecamatan:'12.21.02', name:'Binanga'})
    dataSet.push({ id:'12.20.02.2075', kecamatan:'12.20.02', name:'Binanga Gumbot'})
    dataSet.push({ id:'12.20.02.2003', kecamatan:'12.20.02', name:'Binanga Panasahan'})
    dataSet.push({ id:'12.21.01.2008', kecamatan:'12.21.01', name:'Binanga Tolu'})
    dataSet.push({ id:'12.21.03.2001', kecamatan:'12.21.03', name:'Binanga Tolu'})
    dataSet.push({ id:'12.22.05.2002', kecamatan:'12.22.05', name:'Binangadua'})
    dataSet.push({ id:'12.10.01.1007', kecamatan:'12.10.01', name:'Binaraga'})
    dataSet.push({ id:'12.01.10.1019', kecamatan:'12.01.10', name:'Binasi'})
    dataSet.push({ id:'12.77.01.1014', kecamatan:'12.77.01', name:'Bincar'})
    dataSet.push({ id:'12.05.08.1001', kecamatan:'12.05.08', name:'Bingai'})
    dataSet.push({ id:'12.18.14.2002', kecamatan:'12.18.14', name:'Bingkat'})
    dataSet.push({ id:'12.07.03.2006', kecamatan:'12.07.03', name:'Bingkawan'})
    dataSet.push({ id:'12.18.16.2004', kecamatan:'12.18.16', name:'Binjai'})
    dataSet.push({ id:'12.71.04.1005', kecamatan:'12.71.04', name:'Binjai'})
    dataSet.push({ id:'12.75.02.1006', kecamatan:'12.75.02', name:'Binjai'})
    dataSet.push({ id:'12.07.32.2015', kecamatan:'12.07.32', name:'Binjai Bakung'})
    dataSet.push({ id:'12.19.11.2004', kecamatan:'12.19.11', name:'Binjai Baru'})
    dataSet.push({ id:'12.75.05.1002', kecamatan:'12.75.05', name:'Binjai Estate'})
    dataSet.push({ id:'12.09.09.1001', kecamatan:'12.09.09', name:'Binjai Serbangan'})
    dataSet.push({ id:'12.01.05.1003', kecamatan:'12.01.05', name:'Binjohara'})
    dataSet.push({ id:'12.01.05.2013', kecamatan:'12.01.05', name:'Binjohara Baru'})
    dataSet.push({ id:'12.01.05.2012', kecamatan:'12.01.05', name:'Binjohara Uruk'})
    dataSet.push({ id:'12.20.02.2007', kecamatan:'12.20.02', name:'Bintais Julu'})
    dataSet.push({ id:'12.11.01.2013', kecamatan:'12.11.01', name:'Bintang'})
    dataSet.push({ id:'12.14.09.2014', kecamatan:'12.14.09', name:'Bintang Baru'})
    dataSet.push({ id:'12.18.17.2010', kecamatan:'12.18.17', name:'Bintang Bayu'})
    dataSet.push({ id:'12.11.01.1015', kecamatan:'12.11.01', name:'Bintang Hulu'})
    dataSet.push({ id:'12.08.32.2003', kecamatan:'12.08.32', name:'Bintang Mariah'})
    dataSet.push({ id:'12.06.13.2005', kecamatan:'12.06.13', name:'Bintang Meriah'})
    dataSet.push({ id:'12.07.01.2006', kecamatan:'12.07.01', name:'Bintang Meriah'})
    dataSet.push({ id:'12.07.05.2001', kecamatan:'12.07.05', name:'Bintang Meriah'})
    dataSet.push({ id:'12.07.27.2007', kecamatan:'12.07.27', name:'Bintang Meriah'})
    dataSet.push({ id:'12.11.01.2017', kecamatan:'12.11.01', name:'Bintang Mersada'})
    dataSet.push({ id:'12.14.29.2005', kecamatan:'12.14.29', name:'Bintuang'})
    dataSet.push({ id:'12.13.16.2002', kecamatan:'12.13.16', name:'Bintuas'})
    dataSet.push({ id:'12.03.32.1001', kecamatan:'12.03.32', name:'Bintuju'})
    dataSet.push({ id:'12.13.15.2005', kecamatan:'12.13.15', name:'Bintungan Bejangkar'})
    dataSet.push({ id:'12.13.22.2005', kecamatan:'12.13.22', name:'Bintungan Bejangkar Baru'})
    dataSet.push({ id:'12.04.10.2025', kecamatan:'12.04.10', name:'Biouti'})
    dataSet.push({ id:'12.04.10.2037', kecamatan:'12.04.10', name:'Biouti Timur'})
    dataSet.push({ id:'12.21.02.2061', kecamatan:'12.21.02', name:'Bire'})
    dataSet.push({ id:'12.08.09.2011', kecamatan:'12.08.09', name:'Birong Ulu Manriah'})
    dataSet.push({ id:'12.03.22.2005', kecamatan:'12.03.22', name:'Biru'})
    dataSet.push({ id:'12.07.07.2002', kecamatan:'12.07.07', name:'Biru-Biru'})
    dataSet.push({ id:'12.24.07.2001', kecamatan:'12.24.07', name:'Bitaya'})
    dataSet.push({ id:'12.12.24.2010', kecamatan:'12.12.24', name:'Bius Gu Barat'})
    dataSet.push({ id:'12.05.03.2005', kecamatan:'12.05.03', name:'Blankahan'})
    dataSet.push({ id:'12.18.09.2002', kecamatan:'12.18.09', name:'Blok 10'})
    dataSet.push({ id:'12.15.03.2003', kecamatan:'12.15.03', name:'Boangmanalu'})
    dataSet.push({ id:'12.04.10.2027', kecamatan:'12.04.10', name:'Bobozioli Loloana A'})
    dataSet.push({ id:'12.19.06.2005', kecamatan:'12.19.06', name:'Bogak'})
    dataSet.push({ id:'12.18.03.2011', kecamatan:'12.18.03', name:'Bogak Besar'})
    dataSet.push({ id:'12.14.27.2003', kecamatan:'12.14.27', name:'Bohalu'})
    dataSet.push({ id:'12.17.06.2007', kecamatan:'12.17.06', name:'Boho'})
    dataSet.push({ id:'12.14.07.2029', kecamatan:'12.14.07', name:'Boholu'})
    dataSet.push({ id:'12.20.11.2002', kecamatan:'12.20.11', name:'Bolatan'})
    dataSet.push({ id:'12.08.08.2003', kecamatan:'12.08.08', name:'Boluk'})
    dataSet.push({ id:'12.01.14.1002', kecamatan:'12.01.14', name:'Bona Lumban'})
    dataSet.push({ id:'12.21.04.2011', kecamatan:'12.21.04', name:'Bonal'})
    dataSet.push({ id:'12.13.06.2002', kecamatan:'12.13.06', name:'Bonan Dolok'})
    dataSet.push({ id:'12.16.05.2015', kecamatan:'12.16.05', name:'Bonan Dolok'})
    dataSet.push({ id:'12.17.06.2011', kecamatan:'12.17.06', name:'Bonan Dolok'})
    dataSet.push({ id:'12.20.07.2006', kecamatan:'12.20.07', name:'Bonan Dolok'})
    dataSet.push({ id:'12.21.08.2010', kecamatan:'12.21.08', name:'Bonan Dolok'})
    dataSet.push({ id:'12.77.01.1011', kecamatan:'12.77.01', name:'Bonan Dolok'})
    dataSet.push({ id:'12.12.01.2029', kecamatan:'12.12.01', name:'Bonan Dolok I'})
    dataSet.push({ id:'12.16.07.2007', kecamatan:'12.16.07', name:'Bonan Dolok I'})
    dataSet.push({ id:'12.12.01.2030', kecamatan:'12.12.01', name:'Bonan Dolok Ii'})
    dataSet.push({ id:'12.16.07.2008', kecamatan:'12.16.07', name:'Bonan Dolok Ii'})
    dataSet.push({ id:'12.12.01.2031', kecamatan:'12.12.01', name:'Bonan Dolok III'})
    dataSet.push({ id:'12.01.13.2001', kecamatan:'12.01.13', name:'Bonandolok'})
    dataSet.push({ id:'12.02.08.2003', kecamatan:'12.02.08', name:'Bonani Dolok'})
    dataSet.push({ id:'12.16.06.2018', kecamatan:'12.16.06', name:'Bonanionan'})
    dataSet.push({ id:'12.13.14.2031', kecamatan:'12.13.14', name:'Bonca Bayuon'})
    dataSet.push({ id:'12.13.16.2003', kecamatan:'12.13.16', name:'Bonda Kase'})
    dataSet.push({ id:'12.01.12.2008', kecamatan:'12.01.12', name:'Bondar Sihudon I'})
    dataSet.push({ id:'12.01.12.2012', kecamatan:'12.01.12', name:'Bondar Sihudon II'})
    dataSet.push({ id:'12.08.29.2016', kecamatan:'12.08.29', name:'Bongguran Kariahan'})
    dataSet.push({ id:'12.11.05.2011', kecamatan:'12.11.05', name:'Bongkaras'})
    dataSet.push({ id:'12.14.10.2008', kecamatan:'12.14.10', name:'Bonia Hilisimaetano'})
    dataSet.push({ id:'12.11.05.2018', kecamatan:'12.11.05', name:'Bonian'})
    dataSet.push({ id:'12.14.19.2006', kecamatan:'12.14.19', name:'Borowosi'})
    dataSet.push({ id:'12.08.18.2010', kecamatan:'12.08.18', name:'Bosar Bayu'})
    dataSet.push({ id:'12.08.11.2005', kecamatan:'12.08.11', name:'Bosar Galugur'})
    dataSet.push({ id:'12.08.08.1013', kecamatan:'12.08.08', name:'Bosar Maligas'})
    dataSet.push({ id:'12.08.12.2002', kecamatan:'12.08.12', name:'Bosar Nauli'})
    dataSet.push({ id:'12.08.26.2013', kecamatan:'12.08.26', name:'Bosi Sinumbah'})
    dataSet.push({ id:'12.04.11.2012', kecamatan:'12.04.11', name:'Botohaenga'})
    dataSet.push({ id:'12.14.08.2033', kecamatan:'12.14.08', name:'Botohili'})
    dataSet.push({ id:'12.14.32.2007', kecamatan:'12.14.32', name:'Botohili Silambo'})
    dataSet.push({ id:'12.14.32.2008', kecamatan:'12.14.32', name:'Botohili Sorake'})
    dataSet.push({ id:'12.14.01.2026', kecamatan:'12.14.01', name:'Botohilindruria'})
    dataSet.push({ id:'12.14.32.2002', kecamatan:'12.14.32', name:'Botohilisalo O'})
    dataSet.push({ id:'12.14.32.2001', kecamatan:'12.14.32', name:'Botohilitano'})
    dataSet.push({ id:'12.24.03.2001', kecamatan:'12.24.03', name:'Botolakha'})
    dataSet.push({ id:'12.24.04.2006', kecamatan:'12.24.04', name:'Botombawo'})
    dataSet.push({ id:'12.24.08.2007', kecamatan:'12.24.08', name:'Botona Ai'})
    dataSet.push({ id:'12.01.02.2015', kecamatan:'12.01.02', name:'Bottot'})
    dataSet.push({ id:'12.13.08.2002', kecamatan:'12.13.08', name:'Botung'})
    dataSet.push({ id:'12.20.04.2020', kecamatan:'12.20.04', name:'Botung'})
    dataSet.push({ id:'12.21.09.2007', kecamatan:'12.21.09', name:'Botung'})
    dataSet.push({ id:'12.14.04.2006', kecamatan:'12.14.04', name:'Bowonifaoso'})
    dataSet.push({ id:'12.78.01.2002', kecamatan:'12.78.01', name:'Boyo'})
    dataSet.push({ id:'12.04.10.2015', kecamatan:'12.04.10', name:'Bozihona'})
    dataSet.push({ id:'12.19.02.2020', kecamatan:'12.19.02', name:'Brohol'})
    dataSet.push({ id:'12.07.03.2007', kecamatan:'12.07.03', name:'Buah Nabar'})
    dataSet.push({ id:'12.06.13.2010', kecamatan:'12.06.13', name:'Buah Raya'})
    dataSet.push({ id:'12.05.11.2015', kecamatan:'12.05.11', name:'Bubun'})
    dataSet.push({ id:'12.13.16.2004', kecamatan:'12.13.16', name:'Buburan'})
    dataSet.push({ id:'12.01.03.1022', kecamatan:'12.01.03', name:'Budi Luhur'})
    dataSet.push({ id:'12.14.35.2012', kecamatan:'12.14.35', name:'Buhawa'})
    dataSet.push({ id:'12.06.14.2003', kecamatan:'12.06.14', name:'Bukit'})
    dataSet.push({ id:'12.11.09.2012', kecamatan:'12.11.09', name:'Bukit Baru'})
    dataSet.push({ id:'12.14.23.2011', kecamatan:'12.14.23', name:'Bukit Burasi'})
    dataSet.push({ id:'12.18.09.2017', kecamatan:'12.18.09', name:'Bukit Cermin Hilir'})
    dataSet.push({ id:'12.05.15.1010', kecamatan:'12.05.15', name:'Bukit Jengkol'})
    dataSet.push({ id:'12.05.16.1010', kecamatan:'12.05.16', name:'Bukit Kubu'})
    dataSet.push({ id:'12.11.12.2001', kecamatan:'12.11.12', name:'Bukit Lau Kersik'})
    dataSet.push({ id:'12.06.10.2012', kecamatan:'12.06.10', name:'Bukit Makmur'})
    dataSet.push({ id:'12.08.02.2012', kecamatan:'12.08.02', name:'Bukit Maraja'})
    dataSet.push({ id:'12.05.16.2002', kecamatan:'12.05.16', name:'Bukit Mas'})
    dataSet.push({ id:'12.05.08.2006', kecamatan:'12.05.08', name:'Bukit Melintang'})
    dataSet.push({ id:'12.05.13.2010', kecamatan:'12.05.13', name:'Bukit Mengkirai'})
    dataSet.push({ id:'12.20.04.2076', kecamatan:'12.20.04', name:'Bukit Raya Sordang'})
    dataSet.push({ id:'12.08.09.2015', kecamatan:'12.08.09', name:'Bukit Rejo'})
    dataSet.push({ id:'12.05.12.2012', kecamatan:'12.05.12', name:'Bukit Sari'})
    dataSet.push({ id:'12.05.16.2008', kecamatan:'12.05.16', name:'Bukit Selamat'})
    dataSet.push({ id:'12.72.07.1004', kecamatan:'12.72.07', name:'Bukit Sofa'})
    dataSet.push({ id:'12.11.09.2007', kecamatan:'12.11.09', name:'Bukit Tinggi'})
    dataSet.push({ id:'12.20.02.2077', kecamatan:'12.20.02', name:'Bukit Tinggi'})
    dataSet.push({ id:'12.25.08.2001', kecamatan:'12.25.08', name:'Bukit Tinggi'})
    dataSet.push({ id:'12.22.03.2013', kecamatan:'12.22.03', name:'Bukit Tujuh'})
    dataSet.push({ id:'12.07.03.2008', kecamatan:'12.07.03', name:'Bukum'})
    dataSet.push({ id:'12.19.09.2009', kecamatan:'12.19.09', name:'Bulan-Bulan'})
    dataSet.push({ id:'12.06.12.2035', kecamatan:'12.06.12', name:'Bulanbaru'})
    dataSet.push({ id:'12.06.03.2009', kecamatan:'12.06.03', name:'Bulanjahe'})
    dataSet.push({ id:'12.06.03.2014', kecamatan:'12.06.03', name:'Bulanjulu'})
    dataSet.push({ id:'12.76.04.1003', kecamatan:'12.76.04', name:'Bulian'})
    dataSet.push({ id:'12.07.24.2016', kecamatan:'12.07.24', name:'Bulu Cina'})
    dataSet.push({ id:'12.21.03.2006', kecamatan:'12.21.03', name:'Bulu Cina'})
    dataSet.push({ id:'12.03.21.2013', kecamatan:'12.03.21', name:'Bulu Gading'})
    dataSet.push({ id:'12.03.04.2096', kecamatan:'12.03.04', name:'Bulu Mario'})
    dataSet.push({ id:'12.13.13.2012', kecamatan:'12.13.13', name:'Bulu Soma'})
    dataSet.push({ id:'12.11.11.2004', kecamatan:'12.11.11', name:'Buluduri'})
    dataSet.push({ id:'12.07.03.2009', kecamatan:'12.07.03', name:'Buluh Awar'})
    dataSet.push({ id:'12.18.08.2015', kecamatan:'12.18.08', name:'Buluh Duri'})
    dataSet.push({ id:'12.06.07.2020', kecamatan:'12.06.07', name:'Buluh Pancur'})
    dataSet.push({ id:'12.06.09.2013', kecamatan:'12.06.09', name:'Buluh Pancur'})
    dataSet.push({ id:'12.05.12.2004', kecamatan:'12.05.12', name:'Buluh Telang'})
    dataSet.push({ id:'12.15.07.2006', kecamatan:'12.15.07', name:'Buluh Tellang'})
    dataSet.push({ id:'12.06.06.2007', kecamatan:'12.06.06', name:'Buluhnaman'})
    dataSet.push({ id:'12.23.05.2016', kecamatan:'12.23.05', name:'Bulungihit'})
    dataSet.push({ id:'12.21.07.2037', kecamatan:'12.21.07', name:'Bulusonik'})
    dataSet.push({ id:'12.06.08.2016', kecamatan:'12.06.08', name:'Bunga Baru'})
    dataSet.push({ id:'12.03.04.1005', kecamatan:'12.03.04', name:'Bunga Bondar'})
    dataSet.push({ id:'12.08.14.2012', kecamatan:'12.08.14', name:'Bunga Sampang'})
    dataSet.push({ id:'12.74.06.1004', kecamatan:'12.74.06', name:'Bunga Tanjung'})
    dataSet.push({ id:'12.01.01.2017', kecamatan:'12.01.01', name:'Bungo Tanjung'})
    dataSet.push({ id:'12.07.02.2015', kecamatan:'12.07.02', name:'Buntu Badimbar'})
    dataSet.push({ id:'12.09.15.2005', kecamatan:'12.09.15', name:'Buntu Maraja'})
    dataSet.push({ id:'12.17.09.2004', kecamatan:'12.17.09', name:'Buntu Mauli'})
    dataSet.push({ id:'12.09.16.2002', kecamatan:'12.09.16', name:'Buntu Pane'})
    dataSet.push({ id:'12.08.12.2004', kecamatan:'12.08.12', name:'Buntu Turunan'})
    dataSet.push({ id:'12.11.04.2005', kecamatan:'12.11.04', name:'Bunturaja'})
    dataSet.push({ id:'12.06.04.2008', kecamatan:'12.06.04', name:'Bunuraya'})
    dataSet.push({ id:'12.09.19.1001', kecamatan:'12.09.19', name:'Bunut'})
    dataSet.push({ id:'12.20.02.2008', kecamatan:'12.20.02', name:'Bunut'})
    dataSet.push({ id:'12.22.03.2005', kecamatan:'12.22.03', name:'Bunut'})
    dataSet.push({ id:'12.09.19.1002', kecamatan:'12.09.19', name:'Bunut Barat'})
    dataSet.push({ id:'12.09.30.2010', kecamatan:'12.09.30', name:'Bunut Seberang'})
    dataSet.push({ id:'12.08.12.2001', kecamatan:'12.08.12', name:'Buttu Bayu'})
    dataSet.push({ id:'12.08.27.2011', kecamatan:'12.08.27', name:'Buttu Bayu'})
    dataSet.push({ id:'12.08.20.2007', kecamatan:'12.08.20', name:'Butu Bayu Pane Raja'})
    dataSet.push({ id:'12.19.10.2010', kecamatan:'12.19.10', name:'Cahaya Pardomuan'})
    dataSet.push({ id:'12.07.07.2003', kecamatan:'12.07.07', name:'Candi Rejo'})
    dataSet.push({ id:'12.14.01.2027', kecamatan:'12.14.01', name:'Caritas Sogawunasi'})
    dataSet.push({ id:'12.18.01.2004', kecamatan:'12.18.01', name:'Celawan'})
    dataSet.push({ id:'12.07.28.1010', kecamatan:'12.07.28', name:'Cemara'})
    dataSet.push({ id:'12.05.10.2001', kecamatan:'12.05.10', name:'Cempa'})
    dataSet.push({ id:'12.18.04.2001', kecamatan:'12.18.04', name:'Cempedak Lobang'})
    dataSet.push({ id:'12.10.01.1006', kecamatan:'12.10.01', name:'Cendana'})
    dataSet.push({ id:'12.75.01.1006', kecamatan:'12.75.01', name:'Cengkeh Turi'})
    dataSet.push({ id:'12.19.01.2019', kecamatan:'12.19.01', name:'Cengkering Pekan'})
    dataSet.push({ id:'12.15.04.2005', kecamatan:'12.15.04', name:'Cikaok'})
    dataSet.push({ id:'12.07.09.2012', kecamatan:'12.07.09', name:'Cimahi'})
    dataSet.push({ id:'12.06.11.2017', kecamatan:'12.06.11', name:'Cimbang'})
    dataSet.push({ id:'12.08.26.2001', kecamatan:'12.08.26', name:'Cingkes'})
    dataSet.push({ id:'12.18.02.2005', kecamatan:'12.18.02', name:'Cinta Air'})
    dataSet.push({ id:'12.07.26.2016', kecamatan:'12.07.26', name:'Cinta Damai'})
    dataSet.push({ id:'12.12.21.2009', kecamatan:'12.12.21', name:'Cinta Damai'})
    dataSet.push({ id:'12.71.03.1005', kecamatan:'12.71.03', name:'Cinta Damai'})
    dataSet.push({ id:'12.17.01.2009', kecamatan:'12.17.01', name:'Cinta Dame'})
    dataSet.push({ id:'12.17.09.2006', kecamatan:'12.17.09', name:'Cinta Maju'})
    dataSet.push({ id:'12.10.20.2004', kecamatan:'12.10.20', name:'Cinta Makmur'})
    dataSet.push({ id:'12.05.09.2003', kecamatan:'12.05.09', name:'Cinta Raja'})
    dataSet.push({ id:'12.06.15.2001', kecamatan:'12.06.15', name:'Cinta Rakyat'})
    dataSet.push({ id:'12.07.03.2010', kecamatan:'12.07.03', name:'Cinta Rakyat'})
    dataSet.push({ id:'12.07.06.2017', kecamatan:'12.07.06', name:'Cinta Rakyat'})
    dataSet.push({ id:'12.07.26.2007', kecamatan:'12.07.26', name:'Cinta Rakyat'})
    dataSet.push({ id:'12.18.02.2006', kecamatan:'12.18.02', name:'Citaman Jernih'})
    dataSet.push({ id:'12.09.19.1003', kecamatan:'12.09.19', name:'Dadimulyo'})
    dataSet.push({ id:'12.07.02.2017', kecamatan:'12.07.02', name:'Dagang Kelambir'})
    dataSet.push({ id:'12.07.02.2013', kecamatan:'12.07.02', name:'Dagang Kerawan'})
    dataSet.push({ id:'12.24.01.2011', kecamatan:'12.24.01', name:'Dahadano'})
    dataSet.push({ id:'12.04.20.2007', kecamatan:'12.04.20', name:'Dahadano Botombawo'})
    dataSet.push({ id:'12.78.01.2003', kecamatan:'12.78.01', name:'Dahadano Gawu-Gawu'})
    dataSet.push({ id:'12.04.11.2017', kecamatan:'12.04.11', name:'Dahana'})
    dataSet.push({ id:'12.78.04.2003', kecamatan:'12.78.04', name:'Dahana'})
    dataSet.push({ id:'12.24.07.2011', kecamatan:'12.24.07', name:'Dahana Alasa'})
    dataSet.push({ id:'12.24.05.2003', kecamatan:'12.24.05', name:'Dahana Hiligodu'})
    dataSet.push({ id:'12.78.01.2004', kecamatan:'12.78.01', name:'Dahana Tabaloho'})
    dataSet.push({ id:'12.24.07.2004', kecamatan:'12.24.07', name:'Dahana Tugala Oyo'})
    dataSet.push({ id:'12.19.05.2015', kecamatan:'12.19.05', name:'Dahari Indah'})
    dataSet.push({ id:'12.19.05.2004', kecamatan:'12.19.05', name:'Dahari Selebar'})
    dataSet.push({ id:'12.13.01.1036', kecamatan:'12.13.01', name:'Dalan Lidang'})
    dataSet.push({ id:'12.13.14.2029', kecamatan:'12.13.14', name:'Dalan Lidang'})
    dataSet.push({ id:'12.05.03.2002', kecamatan:'12.05.03', name:'Dalan Naman'})
    dataSet.push({ id:'12.08.29.1002', kecamatan:'12.08.29', name:'Dalig Raya'})
    dataSet.push({ id:'12.03.14.2038', kecamatan:'12.03.14', name:'Dalihan Natolu'})
    dataSet.push({ id:'12.12.03.2009', kecamatan:'12.12.03', name:'Dalihan Natolu'})
    dataSet.push({ id:'12.20.02.2044', kecamatan:'12.20.02', name:'Dalihan Natolu'})
    dataSet.push({ id:'12.07.02.2018', kecamatan:'12.07.02', name:'Dalu Sepuluh-A'})
    dataSet.push({ id:'12.07.02.2019', kecamatan:'12.07.02', name:'Dalu Sepuluh-B'})
    dataSet.push({ id:'12.14.34.2008', kecamatan:'12.14.34', name:'Damai'})
    dataSet.push({ id:'12.75.01.1004', kecamatan:'12.75.01', name:'Damai'})
    dataSet.push({ id:'12.18.11.2013', kecamatan:'12.18.11', name:'Damak Gelugur'})
    dataSet.push({ id:'12.07.09.2014', kecamatan:'12.07.09', name:'Damak Maliho'})
    dataSet.push({ id:'12.18.17.2012', kecamatan:'12.18.17', name:'Damak Tolong Buho'})
    dataSet.push({ id:'12.18.08.2017', kecamatan:'12.18.08', name:'Damak Urat'})
    dataSet.push({ id:'12.05.23.2002', kecamatan:'12.05.23', name:'Damar Condong'})
    dataSet.push({ id:'12.76.03.1007', kecamatan:'12.76.03', name:'Damar Sari'})
    dataSet.push({ id:'12.08.27.2014', kecamatan:'12.08.27', name:'Damaritang'})
    dataSet.push({ id:'12.18.09.2001', kecamatan:'12.18.09', name:'Dame'})
    dataSet.push({ id:'12.08.29.2020', kecamatan:'12.08.29', name:'Dame Raya'})
    dataSet.push({ id:'12.03.05.2071', kecamatan:'12.03.05', name:'Damparan Haunatas'})
    dataSet.push({ id:'12.23.08.2006', kecamatan:'12.23.08', name:'Damuli Kebun'})
    dataSet.push({ id:'12.23.08.2002', kecamatan:'12.23.08', name:'Damuli Pekan'})
    dataSet.push({ id:'12.10.02.1008', kecamatan:'12.10.02', name:'Danau Bale'})
    dataSet.push({ id:'12.01.04.2008', kecamatan:'12.01.04', name:'Danau Pandan'})
    dataSet.push({ id:'12.09.13.2010', kecamatan:'12.09.13', name:'Danau Sijabut'})
    dataSet.push({ id:'12.14.15.2009', kecamatan:'12.14.15', name:'Dao-Dao'})
    dataSet.push({ id:'12.14.11.2008', kecamatan:'12.14.11', name:'Dao-Dao Sowo'})
    dataSet.push({ id:'12.14.09.2012', kecamatan:'12.14.09', name:'Dao-Dao Zanuwo'})
    dataSet.push({ id:'12.14.34.2004', kecamatan:'12.14.34', name:'Dao-Dao Zanuwo Idano Tae'})
    dataSet.push({ id:'12.71.17.1004', kecamatan:'12.71.17', name:'Darat'})
    dataSet.push({ id:'12.13.01.2004', kecamatan:'12.13.01', name:'Darussalam'})
    dataSet.push({ id:'12.75.04.1002', kecamatan:'12.75.04', name:'Dataran Tinggi'})
    dataSet.push({ id:'12.06.02.2001', kecamatan:'12.06.02', name:'Daulu'})
    dataSet.push({ id:'12.76.03.1009', kecamatan:'12.76.03', name:'Deblod Sundoro'})
    dataSet.push({ id:'12.04.28.2009', kecamatan:'12.04.28', name:'Dekha'})
    dataSet.push({ id:'12.18.02.2008', kecamatan:'12.18.02', name:'Deli Muda Hilir'})
    dataSet.push({ id:'12.18.02.2007', kecamatan:'12.18.02', name:'Deli Muda Hulu'})
    dataSet.push({ id:'12.07.06.2001', kecamatan:'12.07.06', name:'Deli Tua'})
    dataSet.push({ id:'12.07.22.1004', kecamatan:'12.07.22', name:'Deli Tua'})
    dataSet.push({ id:'12.07.22.1006', kecamatan:'12.07.22', name:'Deli Tua Barat'})
    dataSet.push({ id:'12.07.22.1005', kecamatan:'12.07.22', name:'Deli Tua Timur'})
    dataSet.push({ id:'12.71.04.1004', kecamatan:'12.71.04', name:'Denai'})
    dataSet.push({ id:'12.07.32.2013', kecamatan:'12.07.32', name:'Denai Kuala'})
    dataSet.push({ id:'12.07.32.2012', kecamatan:'12.07.32', name:'Denai Lama'})
    dataSet.push({ id:'12.07.32.2014', kecamatan:'12.07.32', name:'Denai Sarang Burung'})
    dataSet.push({ id:'12.05.07.1011', kecamatan:'12.05.07', name:'Dendang'})
    dataSet.push({ id:'12.06.15.2007', kecamatan:'12.06.15', name:'Deram'})
    dataSet.push({ id:'12.19.08.2005', kecamatan:'12.19.08', name:'Dewi Sri'})
    dataSet.push({ id:'12.04.05.2021', kecamatan:'12.04.05', name:'Dima'})
    dataSet.push({ id:'12.08.06.2010', kecamatan:'12.08.06', name:'Dipar Hataran'})
    dataSet.push({ id:'12.05.13.2007', kecamatan:'12.05.13', name:'Dogang'})
    dataSet.push({ id:'12.06.05.2004', kecamatan:'12.06.05', name:'Dokan'})
    dataSet.push({ id:'12.06.14.2007', kecamatan:'12.06.14', name:'Dolat Rayat'})
    dataSet.push({ id:'12.25.05.2017', kecamatan:'12.25.05', name:'Doli-Doli'})
    dataSet.push({ id:'12.14.02.2005', kecamatan:'12.14.02', name:'Doli-doli Idanotae'})
    dataSet.push({ id:'12.08.32.2002', kecamatan:'12.08.32', name:'Dolog Huluan'})
    dataSet.push({ id:'12.03.06.2016', kecamatan:'12.03.06', name:'Dolok Godang'})
    dataSet.push({ id:'12.08.01.2013', kecamatan:'12.08.01', name:'Dolok Hataran'})
    dataSet.push({ id:'12.08.17.2004', kecamatan:'12.08.17', name:'Dolok Ilir I'})
    dataSet.push({ id:'12.08.17.2005', kecamatan:'12.08.17', name:'Dolok Ilir Ii'})
    dataSet.push({ id:'12.12.19.2006', kecamatan:'12.12.19', name:'Dolok Jior'})
    dataSet.push({ id:'12.08.28.2005', kecamatan:'12.08.28', name:'Dolok Kahean'})
    dataSet.push({ id:'12.08.17.2012', kecamatan:'12.08.17', name:'Dolok Kataran'})
    dataSet.push({ id:'12.08.17.2007', kecamatan:'12.08.17', name:'Dolok Mainu'})
    dataSet.push({ id:'12.08.02.2001', kecamatan:'12.08.02', name:'Dolok Malela'})
    dataSet.push({ id:'12.18.09.2010', kecamatan:'12.18.09', name:'Dolok Manampang'})
    dataSet.push({ id:'12.08.28.2002', kecamatan:'12.08.28', name:'Dolok Maraja'})
    dataSet.push({ id:'12.08.27.2006', kecamatan:'12.08.27', name:'Dolok Marawa'})
    dataSet.push({ id:'12.16.05.2007', kecamatan:'12.16.05', name:'Dolok Margu'})
    dataSet.push({ id:'12.08.26.2006', kecamatan:'12.08.26', name:'Dolok Mariah'})
    dataSet.push({ id:'12.08.01.2003', kecamatan:'12.08.01', name:'Dolok Marlawan'})
    dataSet.push({ id:'12.08.06.2007', kecamatan:'12.08.06', name:'Dolok Marlawan'})
    dataSet.push({ id:'12.18.17.2002', kecamatan:'12.18.17', name:'Dolok Masango'})
    dataSet.push({ id:'12.02.15.2005', kecamatan:'12.02.15', name:'Dolok Matumbur'})
    dataSet.push({ id:'12.08.17.2008', kecamatan:'12.08.17', name:'Dolok Merangir I'})
    dataSet.push({ id:'12.08.17.2009', kecamatan:'12.08.17', name:'Dolok Merangir Ii'})
    dataSet.push({ id:'12.18.07.2006', kecamatan:'12.18.07', name:'Dolok Merawan'})
    dataSet.push({ id:'12.12.10.2002', kecamatan:'12.12.10', name:'Dolok Nagodang'})
    dataSet.push({ id:'12.02.03.2001', kecamatan:'12.02.03', name:'Dolok Nauli'})
    dataSet.push({ id:'12.12.24.2009', kecamatan:'12.12.24', name:'Dolok Nauli'})
    dataSet.push({ id:'12.01.02.2011', kecamatan:'12.01.02', name:'Dolok Pantis'})
    dataSet.push({ id:'12.08.13.2002', kecamatan:'12.08.13', name:'Dolok Parmonangan'})
    dataSet.push({ id:'12.08.22.2004', kecamatan:'12.08.22', name:'Dolok Parmonangan'})
    dataSet.push({ id:'12.08.06.2012', kecamatan:'12.08.06', name:'Dolok Parriasan'})
    dataSet.push({ id:'12.17.05.2004', kecamatan:'12.17.05', name:'Dolok Raja'})
    dataSet.push({ id:'12.20.04.2022', kecamatan:'12.20.04', name:'Dolok Sae'})
    dataSet.push({ id:'12.18.09.2009', kecamatan:'12.18.09', name:'Dolok Sagala'})
    dataSet.push({ id:'12.02.07.2002', kecamatan:'12.02.07', name:'Dolok Sanggul'})
    dataSet.push({ id:'12.20.02.2051', kecamatan:'12.20.02', name:'Dolok Sanggul'})
    dataSet.push({ id:'12.08.20.2004', kecamatan:'12.08.20', name:'Dolok Saribu'})
    dataSet.push({ id:'12.08.27.2008', kecamatan:'12.08.27', name:'Dolok Saribu Bangun'})
    dataSet.push({ id:'12.12.10.2001', kecamatan:'12.12.10', name:'Dolok Saribu Janji Matogu'})
    dataSet.push({ id:'12.12.10.2019', kecamatan:'12.12.10', name:'Dolok Saribu Lumban Nabolon'})
    dataSet.push({ id:'12.02.07.2005', kecamatan:'12.02.07', name:'Dolok Saut'})
    dataSet.push({ id:'12.08.28.2011', kecamatan:'12.08.28', name:'Dolok Simbolon'})
    dataSet.push({ id:'12.08.18.2005', kecamatan:'12.08.18', name:'Dolok Sinumbah'})
    dataSet.push({ id:'12.03.04.2109', kecamatan:'12.03.04', name:'Dolok Sordang'})
    dataSet.push({ id:'12.03.04.2101', kecamatan:'12.03.04', name:'Dolok Sordang Julu'})
    dataSet.push({ id:'12.08.17.2011', kecamatan:'12.08.17', name:'Dolok Tenera'})
    dataSet.push({ id:'12.11.02.2015', kecamatan:'12.11.02', name:'Dolok Tolong'})
    dataSet.push({ id:'12.08.13.2003', kecamatan:'12.08.13', name:'Dolok Tomuan'})
    dataSet.push({ id:'12.08.28.2003', kecamatan:'12.08.28', name:'Dolok Ulu'})
    dataSet.push({ id:'12.02.10.2011', kecamatan:'12.02.10', name:'Doloksaribu'})
    dataSet.push({ id:'12.17.01.2004', kecamatan:'12.17.01', name:'Dosroha'})
    dataSet.push({ id:'12.13.18.2016', kecamatan:'12.13.18', name:'Dua Sepakat'})
    dataSet.push({ id:'12.25.07.2002', kecamatan:'12.25.07', name:'Duria'})
    dataSet.push({ id:'12.07.32.2018', kecamatan:'12.07.32', name:'Durian'})
    dataSet.push({ id:'12.19.01.2004', kecamatan:'12.19.01', name:'Durian'})
    dataSet.push({ id:'12.19.07.2004', kecamatan:'12.19.07', name:'Durian'})
    dataSet.push({ id:'12.71.20.1003', kecamatan:'12.71.20', name:'Durian'})
    dataSet.push({ id:'12.76.04.1001', kecamatan:'12.76.04', name:'Durian'})
    dataSet.push({ id:'12.08.07.2007', kecamatan:'12.08.07', name:'Durian Banggal'})
    dataSet.push({ id:'12.07.20.2005', kecamatan:'12.07.20', name:'Durian Iv Mbelang'})
    dataSet.push({ id:'12.18.10.2014', kecamatan:'12.18.10', name:'Durian Kondot'})
    dataSet.push({ id:'12.05.04.2013', kecamatan:'12.05.04', name:'Durian Lingga'})
    dataSet.push({ id:'12.18.09.2020', kecamatan:'12.18.09', name:'Durian Puloan'})
    dataSet.push({ id:'12.07.20.2019', kecamatan:'12.07.20', name:'Durian Tinggung'})
    dataSet.push({ id:'12.07.05.2019', kecamatan:'12.07.05', name:'Durin Jangak'})
    dataSet.push({ id:'12.06.09.2006', kecamatan:'12.06.09', name:'Durin Rugun'})
    dataSet.push({ id:'12.07.03.2011', kecamatan:'12.07.03', name:'Durin Serugun'})
    dataSet.push({ id:'12.07.05.2004', kecamatan:'12.07.05', name:'Durin Simbelang'})
    dataSet.push({ id:'12.07.05.2006', kecamatan:'12.07.05', name:'Durin Tonggal'})
    dataSet.push({ id:'12.14.04.2001', kecamatan:'12.14.04', name:'Duru'})
    dataSet.push({ id:'12.08.08.2007', kecamatan:'12.08.08', name:'Dusun Pengkolan'})
    dataSet.push({ id:'12.08.30.2003', kecamatan:'12.08.30', name:'Dusun Ulu'})
    dataSet.push({ id:'12.71.03.1006', kecamatan:'12.71.03', name:'Dwi Kora'})
    dataSet.push({ id:'12.72.02.1001', kecamatan:'12.72.02', name:'Dwikora'})
    dataSet.push({ id:'12.14.04.2004', kecamatan:'12.14.04', name:'Eho'})
    dataSet.push({ id:'12.14.31.2002', kecamatan:'12.14.31', name:'Eho Baluta'})
    dataSet.push({ id:'12.14.10.2011', kecamatan:'12.14.10', name:'Eho Hilisimaetano'})
    dataSet.push({ id:'12.14.18.2022', kecamatan:'12.14.18', name:'Eho Orahili'})
    dataSet.push({ id:'12.04.20.2011', kecamatan:'12.04.20', name:'Ehosakhozi'})
    dataSet.push({ id:'12.14.20.2001', kecamatan:'12.14.20', name:'Ehosakhozi'})
    dataSet.push({ id:'12.19.10.2002', kecamatan:'12.19.10', name:'Empat Negeri'})
    dataSet.push({ id:'12.10.09.2006', kecamatan:'12.10.09', name:'Emplasemen Aek Nabara'})
    dataSet.push({ id:'12.05.04.2009', kecamatan:'12.05.04', name:'Emplasmen Kwala Mencirim'})
    dataSet.push({ id:'12.05.01.2011', kecamatan:'12.05.01', name:'Empus'})
    dataSet.push({ id:'12.02.02.2006', kecamatan:'12.02.02', name:'Enda Portibi'})
    dataSet.push({ id:'12.07.33.2005', kecamatan:'12.07.33', name:'Eplasmen Kuala Namu'})
    dataSet.push({ id:'12.24.05.2002', kecamatan:'12.24.05', name:'Esiwa'})
    dataSet.push({ id:'12.14.18.2023', kecamatan:'12.14.18', name:'Ete Batu'})
    dataSet.push({ id:'12.14.01.2023', kecamatan:'12.14.01', name:'Ewo'})
    dataSet.push({ id:'12.24.08.2003', kecamatan:'12.24.08', name:'Fabaliwa Oyo'})
    dataSet.push({ id:'12.25.02.2019', kecamatan:'12.25.02', name:'Fadoro'})
    dataSet.push({ id:'12.25.05.2009', kecamatan:'12.25.05', name:'Fadoro'})
    dataSet.push({ id:'12.78.04.2020', kecamatan:'12.78.04', name:'Fadoro'})
    dataSet.push({ id:'12.25.05.2012', kecamatan:'12.25.05', name:'Fadoro Bahili'})
    dataSet.push({ id:'12.14.22.2001', kecamatan:'12.14.22', name:'Fadoro Ewo'})
    dataSet.push({ id:'12.24.01.2003', kecamatan:'12.24.01', name:'Fadoro Fulolo'})
    dataSet.push({ id:'12.24.10.2021', kecamatan:'12.24.10', name:'Fadoro Hilihambawa'})
    dataSet.push({ id:'12.24.10.2020', kecamatan:'12.24.10', name:'Fadoro Hilimbowo'})
    dataSet.push({ id:'12.78.05.2006', kecamatan:'12.78.05', name:'Fadoro Hilimbowo'})
    dataSet.push({ id:'12.04.20.2001', kecamatan:'12.04.20', name:'Fadoro Hunogoa'})
    dataSet.push({ id:'12.04.20.2008', kecamatan:'12.04.20', name:'Fadoro Lalai'})
    dataSet.push({ id:'12.78.01.2005', kecamatan:'12.78.01', name:'Fadoro Lasara'})
    dataSet.push({ id:'12.04.05.2027', kecamatan:'12.04.05', name:'Fadoro Lauru'})
    dataSet.push({ id:'12.24.10.2011', kecamatan:'12.24.10', name:'Fadoro Sitolu Hili'})
    dataSet.push({ id:'12.14.20.2012', kecamatan:'12.14.20', name:'Fadoro Tuhemberua'})
    dataSet.push({ id:'12.78.05.2007', kecamatan:'12.78.05', name:'Fadoro You'})
    dataSet.push({ id:'12.25.03.2006', kecamatan:'12.25.03', name:'Fadorosifulubanua'})
    dataSet.push({ id:'12.78.02.2003', kecamatan:'12.78.02', name:'Faekhu'})
    dataSet.push({ id:'12.24.09.2009', kecamatan:'12.24.09', name:'Faekhuna A'})
    dataSet.push({ id:'12.04.27.2007', kecamatan:'12.04.27', name:'Fahandrona'})
    dataSet.push({ id:'12.01.02.2005', kecamatan:'12.01.02', name:'Fajar'})
    dataSet.push({ id:'12.14.26.2009', kecamatan:'12.14.26', name:'Fanedanu'})
    dataSet.push({ id:'12.14.34.2001', kecamatan:'12.14.34', name:'Fanedanu'})
    dataSet.push({ id:'12.14.34.2002', kecamatan:'12.14.34', name:'Fanedanu Sibohou'})
    dataSet.push({ id:'12.14.10.2010', kecamatan:'12.14.10', name:'Faomasi Hilisimaetano'})
    dataSet.push({ id:'12.04.27.2006', kecamatan:'12.04.27', name:'Fatodano'})
    dataSet.push({ id:'12.24.03.2008', kecamatan:'12.24.03', name:'Fino'})
    dataSet.push({ id:'12.18.04.2002', kecamatan:'12.18.04', name:'Firdaus'})
    dataSet.push({ id:'12.18.04.2012', kecamatan:'12.18.04', name:'Firdaus Estate'})
    dataSet.push({ id:'12.78.02.2002', kecamatan:'12.78.02', name:'Fodo'})
    dataSet.push({ id:'12.14.24.2010', kecamatan:'12.14.24', name:'Foikhu Fondrako'})
    dataSet.push({ id:'12.14.14.2009', kecamatan:'12.14.14', name:'Foikhugaga'})
    dataSet.push({ id:'12.14.24.2001', kecamatan:'12.14.24', name:'Fondrakoraya'})
    dataSet.push({ id:'12.78.04.2011', kecamatan:'12.78.04', name:'Fowa'})
    dataSet.push({ id:'12.14.29.2001', kecamatan:'12.14.29', name:'Fuge'})
    dataSet.push({ id:'12.24.07.2005', kecamatan:'12.24.07', name:'Fulolo'})
    dataSet.push({ id:'12.04.21.2010', kecamatan:'12.04.21', name:'Fulolo Botomuzoi'})
    dataSet.push({ id:'12.04.20.2003', kecamatan:'12.04.20', name:'Fulolo Lalai'})
    dataSet.push({ id:'12.24.04.2005', kecamatan:'12.24.04', name:'Fulolo Salo O'})
    dataSet.push({ id:'12.01.01.2011', kecamatan:'12.01.01', name:'Gabungan Hasang'})
    dataSet.push({ id:'12.14.26.2012', kecamatan:'12.14.26', name:'Gabungan Tasua'})
    dataSet.push({ id:'12.78.06.2004', kecamatan:'12.78.06', name:'Gada'})
    dataSet.push({ id:'12.21.02.2065', kecamatan:'12.21.02', name:'Gading'})
    dataSet.push({ id:'12.74.05.1003', kecamatan:'12.74.05', name:'Gading'})
    dataSet.push({ id:'12.13.08.2003', kecamatan:'12.13.08', name:'Gading Bain'})
    dataSet.push({ id:'12.20.01.2022', kecamatan:'12.20.01', name:'Gadung Holbung'})
    dataSet.push({ id:'12.71.20.1011', kecamatan:'12.71.20', name:'Gaharu'})
    dataSet.push({ id:'12.06.12.2017', kecamatan:'12.06.12', name:'Gajah'})
    dataSet.push({ id:'12.09.08.2019', kecamatan:'12.09.08', name:'Gajah'})
    dataSet.push({ id:'12.09.15.2021', kecamatan:'12.09.15', name:'Gajah Sakti'})
    dataSet.push({ id:'12.21.03.2023', kecamatan:'12.21.03', name:'Gala Bonang'})
    dataSet.push({ id:'12.12.07.2022', kecamatan:'12.12.07', name:'Gala Gala Pangkailan'})
    dataSet.push({ id:'12.07.19.2006', kecamatan:'12.07.19', name:'Galang Barat'})
    dataSet.push({ id:'12.07.19.1038', kecamatan:'12.07.19', name:'Galang Kota'})
    dataSet.push({ id:'12.07.19.2005', kecamatan:'12.07.19', name:'Galang Suka'})
    dataSet.push({ id:'12.20.07.2013', kecamatan:'12.20.07', name:'Galanggang'})
    dataSet.push({ id:'12.06.12.2009', kecamatan:'12.06.12', name:'Gamber'})
    dataSet.push({ id:'12.09.20.1012', kecamatan:'12.09.20', name:'Gambir Baru'})
    dataSet.push({ id:'12.19.09.2001', kecamatan:'12.19.09', name:'Gambus Laut'})
    dataSet.push({ id:'12.21.03.2018', kecamatan:'12.21.03', name:'Ganal'})
    dataSet.push({ id:'12.71.20.1001', kecamatan:'12.71.20', name:'Gang Buntu'})
    dataSet.push({ id:'12.08.03.2008', kecamatan:'12.08.03', name:'Ganjing'})
    dataSet.push({ id:'12.14.06.2044', kecamatan:'12.14.06', name:'Ganowo Saua'})
    dataSet.push({ id:'12.03.20.2033', kecamatan:'12.03.20', name:'Gapuk Tua'})
    dataSet.push({ id:'12.20.05.2019', kecamatan:'12.20.05', name:'Gariang'})
    dataSet.push({ id:'12.06.05.2015', kecamatan:'12.06.05', name:'Garingging'})
    dataSet.push({ id:'12.17.01.2007', kecamatan:'12.17.01', name:'Garoga'})
    dataSet.push({ id:'12.20.04.2052', kecamatan:'12.20.04', name:'Garoga'})
    dataSet.push({ id:'12.02.14.2001', kecamatan:'12.02.14', name:'Garoga Sibargot'})
    dataSet.push({ id:'12.20.04.2055', kecamatan:'12.20.04', name:'Garonggang'})
    dataSet.push({ id:'12.05.03.2016', kecamatan:'12.05.03', name:'Garunggang'})
    dataSet.push({ id:'12.12.02.2017', kecamatan:'12.12.02', name:'Gasaribu'})
    dataSet.push({ id:'12.78.03.2007', kecamatan:'12.78.03', name:'Gawu-Gawu Bo Uso'})
    dataSet.push({ id:'12.04.11.2004', kecamatan:'12.04.11', name:'Gazamanu'})
    dataSet.push({ id:'12.09.30.2005', kecamatan:'12.09.30', name:'Gedangan'})
    dataSet.push({ id:'12.71.11.1005', kecamatan:'12.71.11', name:'Gedung Johor'})
    dataSet.push({ id:'12.18.06.2003', kecamatan:'12.18.06', name:'Gelam Sei Serimah'})
    dataSet.push({ id:'12.18.15.2004', kecamatan:'12.18.15', name:'Gempolan'})
    dataSet.push({ id:'12.05.08.2007', kecamatan:'12.05.08', name:'Gergas'})
    dataSet.push({ id:'12.21.02.2020', kecamatan:'12.21.02', name:'Ginduang Batu'})
    dataSet.push({ id:'12.17.06.2010', kecamatan:'12.17.06', name:'Ginolat'})
    dataSet.push({ id:'12.08.16.1003', kecamatan:'12.08.16', name:'Girsang'})
    dataSet.push({ id:'12.71.20.1004', kecamatan:'12.71.20', name:'Glugur Darat I'})
    dataSet.push({ id:'12.71.20.1005', kecamatan:'12.71.20', name:'Glugur Darat II'})
    dataSet.push({ id:'12.71.05.1003', kecamatan:'12.71.05', name:'Glugur Kota'})
    dataSet.push({ id:'12.19.11.2010', kecamatan:'12.19.11', name:'Glugur Makmur'})
    dataSet.push({ id:'12.14.28.2001', kecamatan:'12.14.28', name:'Gobo'})
    dataSet.push({ id:'12.14.28.2005', kecamatan:'12.14.28', name:'Gobo Baru'})
    dataSet.push({ id:'12.02.13.2003', kecamatan:'12.02.13', name:'Godung Borotan'})
    dataSet.push({ id:'12.05.08.2002', kecamatan:'12.05.08', name:'Gohor Lama'})
    dataSet.push({ id:'12.14.03.2004', kecamatan:'12.14.03', name:'Golambanua I'})
    dataSet.push({ id:'12.14.26.2007', kecamatan:'12.14.26', name:'Golambanua Ii'})
    dataSet.push({ id:'12.11.04.2011', kecamatan:'12.11.04', name:'Gomit'})
    dataSet.push({ id:'12.14.28.2004', kecamatan:'12.14.28', name:'Gondia'})
    dataSet.push({ id:'12.06.15.2004', kecamatan:'12.06.15', name:'Gongsol'})
    dataSet.push({ id:'12.13.18.2005', kecamatan:'12.13.18', name:'Gonting'})
    dataSet.push({ id:'12.20.01.2014', kecamatan:'12.20.01', name:'Gonting Bange'})
    dataSet.push({ id:'12.02.14.2007', kecamatan:'12.02.14', name:'Gonting Garoga'})
    dataSet.push({ id:'12.21.03.2022', kecamatan:'12.21.03', name:'Gonting Jae'})
    dataSet.push({ id:'12.21.03.2005', kecamatan:'12.21.03', name:'Gonting Julu'})
    dataSet.push({ id:'12.01.02.2010', kecamatan:'12.01.02', name:'Gonting Mahe'})
    dataSet.push({ id:'12.09.15.2006', kecamatan:'12.09.15', name:'Gonting Malaha'})
    dataSet.push({ id:'12.02.14.2009', kecamatan:'12.02.14', name:'Gonting Salak'})
    dataSet.push({ id:'12.03.22.2048', kecamatan:'12.03.22', name:'Gorahut'})
    dataSet.push({ id:'12.08.10.2010', kecamatan:'12.08.10', name:'Gorak'})
    dataSet.push({ id:'12.17.04.2002', kecamatan:'12.17.04', name:'Gorat Pallombuan'})
    dataSet.push({ id:'12.77.05.2008', kecamatan:'12.77.05', name:'Goti'})
    dataSet.push({ id:'12.09.17.2009', kecamatan:'12.09.17', name:'Gotting Sidodadi'})
    dataSet.push({ id:'12.07.09.2015', kecamatan:'12.07.09', name:'Greahan'})
    dataSet.push({ id:'12.18.17.2001', kecamatan:'12.18.17', name:'Gudang Garam'})
    dataSet.push({ id:'12.14.17.2007', kecamatan:'12.14.17', name:'Guigui'})
    dataSet.push({ id:'12.20.10.2012', kecamatan:'12.20.10', name:'Gulangan'})
    dataSet.push({ id:'12.21.12.2011', kecamatan:'12.21.12', name:'Gulangan'})
    dataSet.push({ id:'12.20.02.2071', kecamatan:'12.20.02', name:'Gumaruntar'})
    dataSet.push({ id:'12.20.06.2022', kecamatan:'12.20.06', name:'Gumarupu Baru'})
    dataSet.push({ id:'12.20.06.2024', kecamatan:'12.20.06', name:'Gumarupu Lama'})
    dataSet.push({ id:'12.20.02.2031', kecamatan:'12.20.02', name:'Gumbot'})
    dataSet.push({ id:'12.11.12.2005', kecamatan:'12.11.12', name:'Gundaling'})
    dataSet.push({ id:'12.06.02.1008', kecamatan:'12.06.02', name:'Gundaling I'})
    dataSet.push({ id:'12.06.02.1009', kecamatan:'12.06.02', name:'Gundaling Ii'})
    dataSet.push({ id:'12.06.01.1011', kecamatan:'12.06.01', name:'Gung Leto'})
    dataSet.push({ id:'12.06.01.1012', kecamatan:'12.06.01', name:'Gung Negeri'})
    dataSet.push({ id:'12.06.16.2010', kecamatan:'12.06.16', name:'Gung Pinto'})
    dataSet.push({ id:'12.23.08.1001', kecamatan:'12.23.08', name:'Gunting Saga'})
    dataSet.push({ id:'12.19.06.2002', kecamatan:'12.19.06', name:'Guntung'})
    dataSet.push({ id:'12.19.09.2003', kecamatan:'12.19.09', name:'Guntung'})
    dataSet.push({ id:'12.06.08.2001', kecamatan:'12.06.08', name:'Gunung'})
    dataSet.push({ id:'12.05.04.2004', kecamatan:'12.05.04', name:'Gunung Ambat'})
    dataSet.push({ id:'12.19.09.2010', kecamatan:'12.19.09', name:'Gunung Bandung'})
    dataSet.push({ id:'12.13.01.2005', kecamatan:'12.13.01', name:'Gunung Barani'})
    dataSet.push({ id:'12.21.10.2007', kecamatan:'12.21.10', name:'Gunung Barani'})
    dataSet.push({ id:'12.03.06.2018', kecamatan:'12.03.06', name:'Gunung Baringin'})
    dataSet.push({ id:'12.13.03.1002', kecamatan:'12.13.03', name:'Gunung Baringin'})
    dataSet.push({ id:'12.20.06.2005', kecamatan:'12.20.06', name:'Gunung Baringin'})
    dataSet.push({ id:'12.21.02.2001', kecamatan:'12.21.02', name:'Gunung Baringin'})
    dataSet.push({ id:'12.21.08.2015', kecamatan:'12.21.08', name:'Gunung Baringin'})
    dataSet.push({ id:'12.08.08.2005', kecamatan:'12.08.08', name:'Gunung Bayu'})
    dataSet.push({ id:'12.07.06.2021', kecamatan:'12.07.06', name:'Gunung Berita'})
    dataSet.push({ id:'12.09.15.2022', kecamatan:'12.09.15', name:'Gunung Berkat'})
    dataSet.push({ id:'12.03.20.2014', kecamatan:'12.03.20', name:'Gunung Binanga'})
    dataSet.push({ id:'12.08.07.2009', kecamatan:'12.08.07', name:'Gunung Datas'})
    dataSet.push({ id:'12.14.02.2042', kecamatan:'12.14.02', name:'Gunung Gabungan'})
    dataSet.push({ id:'12.13.18.2017', kecamatan:'12.13.18', name:'Gunung Godang'})
    dataSet.push({ id:'12.77.03.2004', kecamatan:'12.77.03', name:'Gunung Hasahatan'})
    dataSet.push({ id:'12.20.11.2004', kecamatan:'12.20.11', name:'Gunung Intan'})
    dataSet.push({ id:'12.21.10.2004', kecamatan:'12.21.10', name:'Gunung Intan'})
    dataSet.push({ id:'12.21.09.2027', kecamatan:'12.21.09', name:'Gunung Inten'})
    dataSet.push({ id:'12.06.07.2017', kecamatan:'12.06.07', name:'Gunung Juhar'})
    dataSet.push({ id:'12.01.15.2005', kecamatan:'12.01.15', name:'Gunung Kelambu'})
    dataSet.push({ id:'12.07.06.2004', kecamatan:'12.07.06', name:'Gunung Kelawas'})
    dataSet.push({ id:'12.21.02.2025', kecamatan:'12.21.02', name:'Gunung Malintang'})
    dataSet.push({ id:'12.13.01.2006', kecamatan:'12.13.01', name:'Gunung Manaon'})
    dataSet.push({ id:'12.21.02.2022', kecamatan:'12.21.02', name:'Gunung Manaon'})
    dataSet.push({ id:'12.21.03.2025', kecamatan:'12.21.03', name:'Gunung Manaon'})
    dataSet.push({ id:'12.21.09.2028', kecamatan:'12.21.09', name:'Gunung Manaon'})
    dataSet.push({ id:'12.20.06.2015', kecamatan:'12.20.06', name:'Gunung Manaon I'})
    dataSet.push({ id:'12.20.04.2069', kecamatan:'12.20.04', name:'Gunung Manaon Ii'})
    dataSet.push({ id:'12.20.11.2006', kecamatan:'12.20.11', name:'Gunung Manaon Iii'})
    dataSet.push({ id:'12.20.08.2028', kecamatan:'12.20.08', name:'Gunung Manaon Sim'})
    dataSet.push({ id:'12.20.12.2003', kecamatan:'12.20.12', name:'Gunung Manaon Ub'})
    dataSet.push({ id:'12.21.04.2014', kecamatan:'12.21.04', name:'Gunung Manobot'})
    dataSet.push({ id:'12.06.06.2013', kecamatan:'12.06.06', name:'Gunung Manumpak'})
    dataSet.push({ id:'12.07.20.2007', kecamatan:'12.07.20', name:'Gunung Manupak A'})
    dataSet.push({ id:'12.07.20.2015', kecamatan:'12.07.20', name:'Gunung Manupak B'})
    dataSet.push({ id:'12.20.02.2018', kecamatan:'12.20.02', name:'Gunung Maria'})
    dataSet.push({ id:'12.08.13.2009', kecamatan:'12.08.13', name:'Gunung Mariah'})
    dataSet.push({ id:'12.01.04.2002', kecamatan:'12.01.04', name:'Gunung Marijo'})
    dataSet.push({ id:'12.20.06.2025', kecamatan:'12.20.06', name:'Gunung Martua'})
    dataSet.push({ id:'12.21.03.2026', kecamatan:'12.21.03', name:'Gunung Matinggi'})
    dataSet.push({ id:'12.09.22.2003', kecamatan:'12.09.22', name:'Gunung Melayu'})
    dataSet.push({ id:'12.23.08.2005', kecamatan:'12.23.08', name:'Gunung Melayu'})
    dataSet.push({ id:'12.06.13.2009', kecamatan:'12.06.13', name:'Gunung Meriah'})
    dataSet.push({ id:'12.07.01.2009', kecamatan:'12.07.01', name:'Gunung Meriah'})
    dataSet.push({ id:'12.11.07.2005', kecamatan:'12.11.07', name:'Gunung Meriah'})
    dataSet.push({ id:'12.06.17.2016', kecamatan:'12.06.17', name:'Gunung Merlawan'})
    dataSet.push({ id:'12.18.08.2016', kecamatan:'12.18.08', name:'Gunung Monako'})
    dataSet.push({ id:'12.18.08.2019', kecamatan:'12.18.08', name:'Gunung Pane'})
    dataSet.push({ id:'12.18.07.2004', kecamatan:'12.18.07', name:'Gunung Para Ii'})
    dataSet.push({ id:'12.07.01.2002', kecamatan:'12.07.01', name:'Gunung Paribuan'})
    dataSet.push({ id:'12.19.05.2014', kecamatan:'12.19.05', name:'Gunung Rante'})
    dataSet.push({ id:'12.07.08.2002', kecamatan:'12.07.08', name:'Gunung Rintih'})
    dataSet.push({ id:'12.06.06.2019', kecamatan:'12.06.06', name:'Gunung Saribu'})
    dataSet.push({ id:'12.10.09.2005', kecamatan:'12.10.09', name:'Gunung Selamat'})
    dataSet.push({ id:'12.20.02.2032', kecamatan:'12.20.02', name:'Gunung Selamat'})
    dataSet.push({ id:'12.08.24.2005', kecamatan:'12.08.24', name:'Gunung Serawan'})
    dataSet.push({ id:'12.07.01.2004', kecamatan:'12.07.01', name:'Gunung Seribu'})
    dataSet.push({ id:'12.07.01.2005', kecamatan:'12.07.01', name:'Gunung Sinembah'})
    dataSet.push({ id:'12.11.12.2002', kecamatan:'12.11.12', name:'Gunung Sitember'})
    dataSet.push({ id:'12.20.01.2005', kecamatan:'12.20.01', name:'Gunung Sormin'})
    dataSet.push({ id:'12.05.21.2002', kecamatan:'12.05.21', name:'Gunung Tinggi'})
    dataSet.push({ id:'12.07.05.2017', kecamatan:'12.07.05', name:'Gunung Tinggi'})
    dataSet.push({ id:'12.11.06.2002', kecamatan:'12.11.06', name:'Gunung Tua'})
    dataSet.push({ id:'12.21.08.2038', kecamatan:'12.21.08', name:'Gunung Tua'})
    dataSet.push({ id:'12.24.08.2006', kecamatan:'12.24.08', name:'Gunung Tua'})
    dataSet.push({ id:'12.20.04.2029', kecamatan:'12.20.04', name:'Gunung Tua Baru'})
    dataSet.push({ id:'12.13.01.2007', kecamatan:'12.13.01', name:'Gunung Tua Jae'})
    dataSet.push({ id:'12.20.04.2039', kecamatan:'12.20.04', name:'Gunung Tua Jae'})
    dataSet.push({ id:'12.13.01.2008', kecamatan:'12.13.01', name:'Gunung Tua Julu'})
    dataSet.push({ id:'12.20.04.2040', kecamatan:'12.20.04', name:'Gunung Tua Julu'})
    dataSet.push({ id:'12.20.07.2024', kecamatan:'12.20.07', name:'Gunung Tua Julu'})
    dataSet.push({ id:'12.13.08.2004', kecamatan:'12.13.08', name:'Gunung Tua Ms'})
    dataSet.push({ id:'12.13.08.2005', kecamatan:'12.13.08', name:'Gunung Tua Sm'})
    dataSet.push({ id:'12.13.01.2009', kecamatan:'12.13.01', name:'Gunung Tua Tonga'})
    dataSet.push({ id:'12.20.04.2038', kecamatan:'12.20.04', name:'Gunung Tua Tonga'})
    dataSet.push({ id:'12.25.04.2002', kecamatan:'12.25.04', name:'Gunungbaru'})
    dataSet.push({ id:'12.25.02.2025', kecamatan:'12.25.02', name:'Gunungcahaya'})
    dataSet.push({ id:'12.20.07.2015', kecamatan:'12.20.07', name:'Gunungtua Batang Onang'})
    dataSet.push({ id:'12.20.07.2014', kecamatan:'12.20.07', name:'Gunungtua Tumbu Jati'})
    dataSet.push({ id:'12.13.13.2013', kecamatan:'12.13.13', name:'Guo Batu'})
    dataSet.push({ id:'12.12.22.2004', kecamatan:'12.12.22', name:'Gurgur Aek Raja'})
    dataSet.push({ id:'12.72.07.1001', kecamatan:'12.72.07', name:'Gurilla'})
    dataSet.push({ id:'12.06.06.2021', kecamatan:'12.06.06', name:'Gurubenua'})
    dataSet.push({ id:'12.06.11.2015', kecamatan:'12.06.11', name:'Gurukinayan'})
    dataSet.push({ id:'12.06.02.2002', kecamatan:'12.06.02', name:'Gurusinga'})
    dataSet.push({ id:'12.16.05.2013', kecamatan:'12.16.05', name:'Habeahan'})
    dataSet.push({ id:'12.17.06.2012', kecamatan:'12.17.06', name:'Habeahan Naburahan'})
    dataSet.push({ id:'12.13.11.2002', kecamatan:'12.13.11', name:'Habincaran'})
    dataSet.push({ id:'12.13.13.2014', kecamatan:'12.13.13', name:'Hadangkahan'})
    dataSet.push({ id:'12.22.01.2006', kecamatan:'12.22.01', name:'Hadundung'})
    dataSet.push({ id:'12.20.06.2006', kecamatan:'12.20.06', name:'Hadungdung'})
    dataSet.push({ id:'12.21.11.2009', kecamatan:'12.21.11', name:'Hadungdung Aek Rampah'})
    dataSet.push({ id:'12.21.11.2015', kecamatan:'12.21.11', name:'Hadungdung Pintu Padang'})
    dataSet.push({ id:'12.01.03.1002', kecamatan:'12.01.03', name:'Hajoran'})
    dataSet.push({ id:'12.20.04.2053', kecamatan:'12.20.04', name:'Hajoran'})
    dataSet.push({ id:'12.22.04.2004', kecamatan:'12.22.04', name:'Hajoran'})
    dataSet.push({ id:'12.01.03.1026', kecamatan:'12.01.03', name:'Hajoran Indah'})
    dataSet.push({ id:'12.05.16.2001', kecamatan:'12.05.16', name:'Halaban'})
    dataSet.push({ id:'12.12.05.2010', kecamatan:'12.12.05', name:'Halado'})
    dataSet.push({ id:'12.25.02.2007', kecamatan:'12.25.02', name:'Halamona'})
    dataSet.push({ id:'12.14.31.2004', kecamatan:'12.14.31', name:'Hale Baluta'})
    dataSet.push({ id:'12.25.01.2009', kecamatan:'12.25.01', name:'Haliadulo'})
    dataSet.push({ id:'12.25.04.2006', kecamatan:'12.25.04', name:'Halifadolo'})
    dataSet.push({ id:'12.20.03.2018', kecamatan:'12.20.03', name:'Halongonan'})
    dataSet.push({ id:'12.78.03.2006', kecamatan:'12.78.03', name:'Hambawa'})
    dataSet.push({ id:'12.20.04.2045', kecamatan:'12.20.04', name:'Hambiri'})
    dataSet.push({ id:'12.20.03.2002', kecamatan:'12.20.03', name:'Hambulo'})
    dataSet.push({ id:'12.71.15.1002', kecamatan:'12.71.15', name:'Hamdan'})
    dataSet.push({ id:'12.07.24.2001', kecamatan:'12.07.24', name:'Hamparan Perak'})
    dataSet.push({ id:'12.21.06.2004', kecamatan:'12.21.06', name:'Handang Kopo'})
    dataSet.push({ id:'12.13.20.2003', kecamatan:'12.13.20', name:'Handel'})
    dataSet.push({ id:'12.21.08.2039', kecamatan:'12.21.08', name:'Handio'})
    dataSet.push({ id:'12.21.07.2005', kecamatan:'12.21.07', name:'Handis Julu'})
    dataSet.push({ id:'12.25.02.2008', kecamatan:'12.25.02', name:'Hanofa'})
    dataSet.push({ id:'12.77.02.1010', kecamatan:'12.77.02', name:'Hanopan'})
    dataSet.push({ id:'12.03.02.2017', kecamatan:'12.03.02', name:'Hapesong Baru'})
    dataSet.push({ id:'12.03.02.2022', kecamatan:'12.03.02', name:'Hapesong Lama'})
    dataSet.push({ id:'12.02.01.2013', kecamatan:'12.02.01', name:'Hapoltahan'})
    dataSet.push({ id:'12.21.08.2007', kecamatan:'12.21.08', name:'Hapung'})
    dataSet.push({ id:'12.21.08.2034', kecamatan:'12.21.08', name:'Hapung Torop'})
    dataSet.push({ id:'12.21.08.2036', kecamatan:'12.21.08', name:'Harang Jae'})
    dataSet.push({ id:'12.21.08.2004', kecamatan:'12.21.08', name:'Harang Julu'})
    dataSet.push({ id:'12.08.15.1005', kecamatan:'12.08.15', name:'Haranggaol'})
    dataSet.push({ id:'12.11.06.2003', kecamatan:'12.11.06', name:'Harapan'})
    dataSet.push({ id:'12.05.17.2012', kecamatan:'12.05.17', name:'Harapan Baru'})
    dataSet.push({ id:'12.05.17.1009', kecamatan:'12.05.17', name:'Harapan Jaya'})
    dataSet.push({ id:'12.05.17.2013', kecamatan:'12.05.17', name:'Harapan Maju'})
    dataSet.push({ id:'12.05.17.2014', kecamatan:'12.05.17', name:'Harapan Makmur'})
    dataSet.push({ id:'12.03.30.2015', kecamatan:'12.03.30', name:'Harean'})
    dataSet.push({ id:'12.24.08.2008', kecamatan:'12.24.08', name:'Harefa'})
    dataSet.push({ id:'12.14.35.2010', kecamatan:'12.14.35', name:'Harefa Orahua'})
    dataSet.push({ id:'12.24.06.2002', kecamatan:'12.24.06', name:'Harefanaese'})
    dataSet.push({ id:'12.14.03.2017', kecamatan:'12.14.03', name:'Harenoro'})
    dataSet.push({ id:'12.24.09.2005', kecamatan:'12.24.09', name:'Harewakhe'})
    dataSet.push({ id:'12.17.02.2012', kecamatan:'12.17.02', name:'Harian'})
    dataSet.push({ id:'12.02.13.2019', kecamatan:'12.02.13', name:'Harianja'})
    dataSet.push({ id:'12.17.05.2015', kecamatan:'12.17.05', name:'Hariara Pintu'})
    dataSet.push({ id:'12.17.05.2003', kecamatan:'12.17.05', name:'Hariara Pohan'})
    dataSet.push({ id:'12.71.09.1004', kecamatan:'12.71.09', name:'Harjosari I'})
    dataSet.push({ id:'12.71.09.1005', kecamatan:'12.71.09', name:'Harjosari Ii'})
    dataSet.push({ id:'12.12.23.2004', kecamatan:'12.12.23', name:'Harungguan'})
    dataSet.push({ id:'12.20.01.2026', kecamatan:'12.20.01', name:'Hasahatan'})
    dataSet.push({ id:'12.20.03.2014', kecamatan:'12.20.03', name:'Hasahatan'})
    dataSet.push({ id:'12.21.07.2009', kecamatan:'12.21.07', name:'Hasahatan Jae'})
    dataSet.push({ id:'12.21.07.2016', kecamatan:'12.21.07', name:'Hasahatan Julu'})
    dataSet.push({ id:'12.20.05.2002', kecamatan:'12.20.05', name:'Hasambi'})
    dataSet.push({ id:'12.23.08.2007', kecamatan:'12.23.08', name:'Hasang'})
    dataSet.push({ id:'12.03.04.2025', kecamatan:'12.03.04', name:'Hasang Marsada'})
    dataSet.push({ id:'12.02.10.2014', kecamatan:'12.02.10', name:'Hasibuan'})
    dataSet.push({ id:'12.17.06.2003', kecamatan:'12.17.06', name:'Hasinggaan'})
    dataSet.push({ id:'12.23.06.2010', kecamatan:'12.23.06', name:'Hatapang'})
    dataSet.push({ id:'12.12.09.2003', kecamatan:'12.12.09', name:'Hatinggian'})
    dataSet.push({ id:'12.20.01.2035', kecamatan:'12.20.01', name:'Hatiran'})
    dataSet.push({ id:'12.17.04.2006', kecamatan:'12.17.04', name:'Hatoguan'})
    dataSet.push({ id:'12.21.09.2006', kecamatan:'12.21.09', name:'Hatongga'})
    dataSet.push({ id:'12.13.13.2015', kecamatan:'12.13.13', name:'Hatupangan'})
    dataSet.push({ id:'12.16.09.2022', kecamatan:'12.16.09', name:'Hauagong'})
    dataSet.push({ id:'12.03.20.2028', kecamatan:'12.03.20', name:'Haunatas'})
    dataSet.push({ id:'12.12.02.2012', kecamatan:'12.12.02', name:'Haunatas I'})
    dataSet.push({ id:'12.12.02.2008', kecamatan:'12.12.02', name:'Haunatas Ii'})
    dataSet.push({ id:'12.18.09.2022', kecamatan:'12.18.09', name:'Havea'})
    dataSet.push({ id:'12.14.29.2008', kecamatan:'12.14.29', name:'Hayo'})
    dataSet.push({ id:'12.25.05.2018', kecamatan:'12.25.05', name:'Hayo'})
    dataSet.push({ id:'12.13.04.2003', kecamatan:'12.13.04', name:'Hayuraja'})
    dataSet.push({ id:'12.14.22.2010', kecamatan:'12.14.22', name:'Helefanikha'})
    dataSet.push({ id:'12.78.04.2009', kecamatan:'12.78.04', name:'Helefanikha'})
    dataSet.push({ id:'12.04.06.2019', kecamatan:'12.04.06', name:'Heliweto Gido'})
    dataSet.push({ id:'12.07.23.2009', kecamatan:'12.07.23', name:'Helvetia'})
    dataSet.push({ id:'12.07.25.2001', kecamatan:'12.07.25', name:'Helvetia'})
    dataSet.push({ id:'12.71.03.1001', kecamatan:'12.71.03', name:'Helvetia'})
    dataSet.push({ id:'12.71.03.1002', kecamatan:'12.71.03', name:'Helvetia Tengah'})
    dataSet.push({ id:'12.71.03.1003', kecamatan:'12.71.03', name:'Helvetia Timur'})
    dataSet.push({ id:'12.09.13.2014', kecamatan:'12.09.13', name:'Hessa Air Genting'})
    dataSet.push({ id:'12.09.13.2007', kecamatan:'12.09.13', name:'Hessa Perlompongan'})
    dataSet.push({ id:'12.25.06.2002', kecamatan:'12.25.06', name:'Hiambanua'})
    dataSet.push({ id:'12.04.10.2035', kecamatan:'12.04.10', name:'Hili Adulo'})
    dataSet.push({ id:'12.14.12.2005', kecamatan:'12.14.12', name:'Hili Alawa'})
    dataSet.push({ id:'12.14.03.2024', kecamatan:'12.14.03', name:'Hiliabolata'})
    dataSet.push({ id:'12.14.15.2016', kecamatan:'12.14.15', name:'Hiliadolowa'})
    dataSet.push({ id:'12.14.11.2009', kecamatan:'12.14.11', name:'Hiliadulo'})
    dataSet.push({ id:'12.14.23.2002', kecamatan:'12.14.23', name:'Hiliadulo'})
    dataSet.push({ id:'12.14.09.2018', kecamatan:'12.14.09', name:'Hiliadulosoi'})
    dataSet.push({ id:'12.04.11.2006', kecamatan:'12.04.11', name:'Hilialawa'})
    dataSet.push({ id:'12.14.26.2013', kecamatan:'12.14.26', name:'Hilialawa'})
    dataSet.push({ id:'12.14.33.2007', kecamatan:'12.14.33', name:'Hilialito Saua'})
    dataSet.push({ id:'12.14.34.2007', kecamatan:'12.14.34', name:'Hilialo Oa'})
    dataSet.push({ id:'12.14.12.2003', kecamatan:'12.14.12', name:'Hiliamaetaluo'})
    dataSet.push({ id:'12.14.32.2005', kecamatan:'12.14.32', name:'Hiliamaetaniha'})
    dataSet.push({ id:'12.14.05.2006', kecamatan:'12.14.05', name:'Hiliamaodula'})
    dataSet.push({ id:'12.14.15.2004', kecamatan:'12.14.15', name:'Hiliamauzula'})
    dataSet.push({ id:'12.14.06.2040', kecamatan:'12.14.06', name:'Hiliamuri'})
    dataSet.push({ id:'12.14.06.2042', kecamatan:'12.14.06', name:'Hiliana A'})
    dataSet.push({ id:'12.14.02.2007', kecamatan:'12.14.02', name:'Hiliana A Gomo'})
    dataSet.push({ id:'12.14.09.2003', kecamatan:'12.14.09', name:'Hiliana A Susua'})
    dataSet.push({ id:'12.14.04.2007', kecamatan:'12.14.04', name:'Hilianombasela'})
    dataSet.push({ id:'12.14.12.2011', kecamatan:'12.14.12', name:'Hiliasi'})
    dataSet.push({ id:'12.14.10.2013', kecamatan:'12.14.10', name:'Hiliaurifa Hilisimaetano'})
    dataSet.push({ id:'12.04.27.2005', kecamatan:'12.04.27', name:'Hilibadalu'})
    dataSet.push({ id:'12.04.35.2002', kecamatan:'12.04.35', name:'Hilibadalu'})
    dataSet.push({ id:'12.14.14.2008', kecamatan:'12.14.14', name:'Hilibadalu'})
    dataSet.push({ id:'12.25.08.2005', kecamatan:'12.25.08', name:'Hilibadalu'})
    dataSet.push({ id:'12.24.05.2004', kecamatan:'12.24.05', name:'Hilibanua'})
    dataSet.push({ id:'12.04.29.2010', kecamatan:'12.04.29', name:'Hiliborodano'})
    dataSet.push({ id:'12.14.09.2009', kecamatan:'12.14.09', name:'Hilidanayao'})
    dataSet.push({ id:'12.14.25.2002', kecamatan:'12.14.25', name:'Hilidohona'})
    dataSet.push({ id:'12.04.05.2030', kecamatan:'12.04.05', name:'Hiliduho'})
    dataSet.push({ id:'12.24.01.2001', kecamatan:'12.24.01', name:'Hilidundra'})
    dataSet.push({ id:'12.24.02.2009', kecamatan:'12.24.02', name:'Hiliduruwa'})
    dataSet.push({ id:'12.14.07.2014', kecamatan:'12.14.07', name:'Hilifadolo'})
    dataSet.push({ id:'12.14.08.2009', kecamatan:'12.14.08', name:'Hilifadolo'})
    dataSet.push({ id:'12.14.15.2007', kecamatan:'12.14.15', name:'Hilifadolo'})
    dataSet.push({ id:'12.14.19.2010', kecamatan:'12.14.19', name:'Hilifakhe'})
    dataSet.push({ id:'12.14.33.2001', kecamatan:'12.14.33', name:'Hilifalago'})
    dataSet.push({ id:'12.14.33.2009', kecamatan:'12.14.33', name:'Hilifalago Raya'})
    dataSet.push({ id:'12.14.10.2003', kecamatan:'12.14.10', name:'Hilifalawu'})
    dataSet.push({ id:'12.14.20.2013', kecamatan:'12.14.20', name:'Hilifalawu'})
    dataSet.push({ id:'12.14.01.2029', kecamatan:'12.14.01', name:'Hilifaondrato'})
    dataSet.push({ id:'12.04.11.2007', kecamatan:'12.04.11', name:'Hilifaosi'})
    dataSet.push({ id:'12.14.18.2021', kecamatan:'12.14.18', name:'Hilifarokha Lawa'})
    dataSet.push({ id:'12.14.33.2004', kecamatan:'12.14.33', name:'Hilifarono'})
    dataSet.push({ id:'12.14.13.2009', kecamatan:'12.14.13', name:'Hilifondege Hilizoroilawa'})
    dataSet.push({ id:'12.14.35.2011', kecamatan:'12.14.35', name:'Hiligabungan'})
    dataSet.push({ id:'12.04.27.2013', kecamatan:'12.04.27', name:'Hiligafoa'})
    dataSet.push({ id:'12.14.15.2013', kecamatan:'12.14.15', name:'Hiligafoa'})
    dataSet.push({ id:'12.14.03.2025', kecamatan:'12.14.03', name:'Hiligambukha'})
    dataSet.push({ id:'12.04.11.2003', kecamatan:'12.04.11', name:'Hiliganoita'})
    dataSet.push({ id:'12.14.06.2011', kecamatan:'12.14.06', name:'Hiliganowo'})
    dataSet.push({ id:'12.14.06.2043', kecamatan:'12.14.06', name:'Hiliganowo Salo O'})
    dataSet.push({ id:'12.78.02.2011', kecamatan:'12.78.02', name:'Hiligara'})
    dataSet.push({ id:'12.24.10.2013', kecamatan:'12.24.10', name:'Hiligawolo'})
    dataSet.push({ id:'12.24.07.2006', kecamatan:'12.24.07', name:'Hiligawoni'})
    dataSet.push({ id:'12.14.06.2006', kecamatan:'12.14.06', name:'Hiligeho'})
    dataSet.push({ id:'12.14.31.2011', kecamatan:'12.14.31', name:'Hiligeho Sogawu'})
    dataSet.push({ id:'12.24.01.2013', kecamatan:'12.24.01', name:'Hiligeo Afia'})
    dataSet.push({ id:'12.14.18.2019', kecamatan:'12.14.18', name:'Hiligito'})
    dataSet.push({ id:'12.14.23.2010', kecamatan:'12.14.23', name:'Hiligodu'})
    dataSet.push({ id:'12.24.01.2005', kecamatan:'12.24.01', name:'Hiligodu'})
    dataSet.push({ id:'12.04.21.2001', kecamatan:'12.04.21', name:'Hiligodu Botomuzoi'})
    dataSet.push({ id:'12.24.10.2008', kecamatan:'12.24.10', name:'Hiligodu Hoya'})
    dataSet.push({ id:'12.78.02.2014', kecamatan:'12.78.02', name:'Hiligodu Ombolata'})
    dataSet.push({ id:'12.04.29.2009', kecamatan:'12.04.29', name:'Hiligodu Somolo-Molo'})
    dataSet.push({ id:'12.04.05.2031', kecamatan:'12.04.05', name:'Hiligodu Tanoseo'})
    dataSet.push({ id:'12.78.03.2010', kecamatan:'12.78.03', name:'Hiligodu Ulu'})
    dataSet.push({ id:'12.04.10.2034', kecamatan:'12.04.10', name:'Hiligogowaya Maliwa A'})
    dataSet.push({ id:'12.14.15.2017', kecamatan:'12.14.15', name:'Hiligumbu'})
    dataSet.push({ id:'12.78.04.2017', kecamatan:'12.78.04', name:'Hilihambawa'})
    dataSet.push({ id:'12.04.21.2009', kecamatan:'12.04.21', name:'Hilihambawa Botomuzoi'})
    dataSet.push({ id:'12.78.01.2006', kecamatan:'12.78.01', name:'Hilihao'})
    dataSet.push({ id:'12.04.11.2022', kecamatan:'12.04.11', name:'Hilihao Cugala'})
    dataSet.push({ id:'12.24.10.2010', kecamatan:'12.24.10', name:'Hilihati'})
    dataSet.push({ id:'12.04.11.2005', kecamatan:'12.04.11', name:'Hilihoru'})
    dataSet.push({ id:'12.14.07.2005', kecamatan:'12.14.07', name:'Hilihoru'})
    dataSet.push({ id:'12.14.04.2025', kecamatan:'12.14.04', name:'Hilikana'})
    dataSet.push({ id:'12.14.08.2035', kecamatan:'12.14.08', name:'Hilikara'})
    dataSet.push({ id:'12.14.33.2006', kecamatan:'12.14.33', name:'Hilikara'})
    dataSet.push({ id:'12.14.18.2017', kecamatan:'12.14.18', name:'Hilikara Maha'})
    dataSet.push({ id:'12.14.25.2003', kecamatan:'12.14.25', name:'Hililaora'})
    dataSet.push({ id:'12.04.10.2008', kecamatan:'12.04.10', name:'Hililawae'})
    dataSet.push({ id:'12.14.06.2046', kecamatan:'12.14.06', name:'Hililaza'})
    dataSet.push({ id:'12.14.13.2008', kecamatan:'12.14.13', name:'Hililaza Hilinawalo Mazino'})
    dataSet.push({ id:'12.14.32.2009', kecamatan:'12.14.32', name:'Hilimaenamolo'})
    dataSet.push({ id:'12.14.07.2028', kecamatan:'12.14.07', name:'Hilimaera'})
    dataSet.push({ id:'12.14.19.2007', kecamatan:'12.14.19', name:'Hilimaera'})
    dataSet.push({ id:'12.14.12.2007', kecamatan:'12.14.12', name:'Hilimagari'})
    dataSet.push({ id:'12.14.15.2010', kecamatan:'12.14.15', name:'Hilimagiao'})
    dataSet.push({ id:'12.14.20.2016', kecamatan:'12.14.20', name:'Hilimanawa'})
    dataSet.push({ id:'12.14.17.2009', kecamatan:'12.14.17', name:'Hilimaufa'})
    dataSet.push({ id:'12.25.06.2003', kecamatan:'12.25.06', name:'Hilimayo'})
    dataSet.push({ id:'12.04.35.2004', kecamatan:'12.04.35', name:'Hilimbana'})
    dataSet.push({ id:'12.14.17.2002', kecamatan:'12.14.17', name:'Hilimbaruzo'})
    dataSet.push({ id:'12.25.06.2007', kecamatan:'12.25.06', name:'Hilimbaruzo'})
    dataSet.push({ id:'12.78.01.2007', kecamatan:'12.78.01', name:'Hilimbaruzo'})
    dataSet.push({ id:'12.78.04.2002', kecamatan:'12.78.04', name:'Hilimbawodesolo'})
    dataSet.push({ id:'12.25.02.2013', kecamatan:'12.25.02', name:'Hilimberuanaa'})
    dataSet.push({ id:'12.14.09.2005', kecamatan:'12.14.09', name:'Hilimboe'})
    dataSet.push({ id:'12.14.09.2006', kecamatan:'12.14.09', name:'Hilimboho'})
    dataSet.push({ id:'12.24.04.2003', kecamatan:'12.24.04', name:'Hilimbosi'})
    dataSet.push({ id:'12.04.27.2004', kecamatan:'12.04.27', name:'Hilimbowo'})
    dataSet.push({ id:'12.14.07.2009', kecamatan:'12.14.07', name:'Hilimbowo'})
    dataSet.push({ id:'12.14.15.2014', kecamatan:'12.14.15', name:'Hilimbowo'})
    dataSet.push({ id:'12.14.21.2002', kecamatan:'12.14.21', name:'Hilimbowo'})
    dataSet.push({ id:'12.25.06.2012', kecamatan:'12.25.06', name:'Hilimbowo'})
    dataSet.push({ id:'12.04.21.2004', kecamatan:'12.04.21', name:'Hilimbowo Botomuzoi'})
    dataSet.push({ id:'12.78.04.2022', kecamatan:'12.78.04', name:'Hilimbowo Idanoi'})
    dataSet.push({ id:'12.14.35.2004', kecamatan:'12.14.35', name:'Hilimbowo Idanotae'})
    dataSet.push({ id:'12.24.06.2003', kecamatan:'12.24.06', name:'Hilimbowo Kare'})
    dataSet.push({ id:'12.25.07.2004', kecamatan:'12.25.07', name:'Hilimbowo Mau'})
    dataSet.push({ id:'12.78.03.2009', kecamatan:'12.78.03', name:'Hilimbowo Olora'})
    dataSet.push({ id:'12.14.08.2047', kecamatan:'12.14.08', name:'Hilimbowo Siwalawa'})
    dataSet.push({ id:'12.14.21.2005', kecamatan:'12.14.21', name:'Hilimbuasi'})
    dataSet.push({ id:'12.25.07.2005', kecamatan:'12.25.07', name:'Hilimbuasi'})
    dataSet.push({ id:'12.14.07.2006', kecamatan:'12.14.07', name:'Hilimbulawa'})
    dataSet.push({ id:'12.14.15.2015', kecamatan:'12.14.15', name:'Hilimezaya'})
    dataSet.push({ id:'12.04.10.2005', kecamatan:'12.04.10', name:'Hilimoasio'})
    dataSet.push({ id:'12.04.10.2036', kecamatan:'12.04.10', name:'Hilimoasio Dua'})
    dataSet.push({ id:'12.14.33.2002', kecamatan:'12.14.33', name:'Hilimondregeraya'})
    dataSet.push({ id:'12.24.06.2006', kecamatan:'12.24.06', name:'Hilina A'})
    dataSet.push({ id:'12.24.10.2007', kecamatan:'12.24.10', name:'Hilina A'})
    dataSet.push({ id:'12.78.01.2008', kecamatan:'12.78.01', name:'Hilina A'})
    dataSet.push({ id:'12.04.10.2018', kecamatan:'12.04.10', name:'Hilina A Tafuo'})
    dataSet.push({ id:'12.78.06.2007', kecamatan:'12.78.06', name:'Hilinakhe'})
    dataSet.push({ id:'12.14.21.2001', kecamatan:'12.14.21', name:'Hilinamazihono'})
    dataSet.push({ id:'12.14.21.2010', kecamatan:'12.14.21', name:'Hilinamazihono Moale'})
    dataSet.push({ id:'12.14.12.2002', kecamatan:'12.14.12', name:'Hilinamoniha'})
    dataSet.push({ id:'12.14.33.2003', kecamatan:'12.14.33', name:'Hilinamozaua'})
    dataSet.push({ id:'12.14.33.2008', kecamatan:'12.14.33', name:'Hilinamozaua Raya'})
    dataSet.push({ id:'12.14.03.2038', kecamatan:'12.14.03', name:'Hilinawalo Balaekha'})
    dataSet.push({ id:'12.14.18.2007', kecamatan:'12.14.18', name:'Hilinawalo Fau'})
    dataSet.push({ id:'12.14.13.2002', kecamatan:'12.14.13', name:'Hilinawalo Mazino'})
    dataSet.push({ id:'12.14.07.2027', kecamatan:'12.14.07', name:'Hilindraso'})
    dataSet.push({ id:'12.14.12.2012', kecamatan:'12.14.12', name:'Hilindraso Raya'})
    dataSet.push({ id:'12.14.12.2006', kecamatan:'12.14.12', name:'Hilindrasoniha'})
    dataSet.push({ id:'12.14.04.2026', kecamatan:'12.14.04', name:'Hilinifaese'})
    dataSet.push({ id:'12.14.24.2007', kecamatan:'12.14.24', name:'Hilinifaoso'})
    dataSet.push({ id:'12.14.18.2012', kecamatan:'12.14.18', name:'Hiliofonaluo'})
    dataSet.push({ id:'12.14.31.2012', kecamatan:'12.14.31', name:'Hiliomasio'})
    dataSet.push({ id:'12.14.33.2005', kecamatan:'12.14.33', name:'Hilionaha'})
    dataSet.push({ id:'12.04.10.2019', kecamatan:'12.04.10', name:'Hiliono Zega'})
    dataSet.push({ id:'12.14.09.2004', kecamatan:'12.14.09', name:'Hiliorahua'})
    dataSet.push({ id:'12.14.26.2010', kecamatan:'12.14.26', name:'Hiliorahua Tasua'})
    dataSet.push({ id:'12.14.04.2009', kecamatan:'12.14.04', name:'Hiliorodua Tebolo'})
    dataSet.push({ id:'12.14.04.2003', kecamatan:'12.14.04', name:'Hilioromao'})
    dataSet.push({ id:'12.14.03.2027', kecamatan:'12.14.03', name:'Hiliorudua'})
    dataSet.push({ id:'12.14.09.2013', kecamatan:'12.14.09', name:'Hiliorudua'})
    dataSet.push({ id:'12.14.15.2002', kecamatan:'12.14.15', name:'Hiliorudua'})
    dataSet.push({ id:'12.14.21.2009', kecamatan:'12.14.21', name:'Hiliorudua'})
    dataSet.push({ id:'12.04.06.2006', kecamatan:'12.04.06', name:'Hiliotalua'})
    dataSet.push({ id:'12.14.01.2005', kecamatan:'12.14.01', name:'Hiliotalua'})
    dataSet.push({ id:'12.14.05.2001', kecamatan:'12.14.05', name:'Hiliotalua'})
    dataSet.push({ id:'12.14.18.2018', kecamatan:'12.14.18', name:'Hilisalawa'})
    dataSet.push({ id:'12.14.07.2024', kecamatan:'12.14.07', name:'Hilisalo O'})
    dataSet.push({ id:'12.14.35.2008', kecamatan:'12.14.35', name:'Hilisalo O'})
    dataSet.push({ id:'12.24.04.2004', kecamatan:'12.24.04', name:'Hilisalo O'})
    dataSet.push({ id:'12.14.33.2010', kecamatan:'12.14.33', name:'Hilisanekhehosi'})
    dataSet.push({ id:'12.25.08.2004', kecamatan:'12.25.08', name:'Hilisangawola'})
    dataSet.push({ id:'12.14.01.2002', kecamatan:'12.14.01', name:'Hilisangowola'})
    dataSet.push({ id:'12.14.25.2006', kecamatan:'12.14.25', name:'Hilisao Oto'})
    dataSet.push({ id:'12.14.06.2025', kecamatan:'12.14.06', name:'Hilisao Otoniha'})
    dataSet.push({ id:'12.14.12.2001', kecamatan:'12.14.12', name:'Hilisataro'})
    dataSet.push({ id:'12.14.12.2014', kecamatan:'12.14.12', name:'Hilisataro Eho Sofayo'})
    dataSet.push({ id:'12.14.12.2009', kecamatan:'12.14.12', name:'Hilisataro Gewa'})
    dataSet.push({ id:'12.14.12.2013', kecamatan:'12.14.12', name:'Hilisataro Nandisa'})
    dataSet.push({ id:'12.14.12.2008', kecamatan:'12.14.12', name:'Hilisataro Raya'})
    dataSet.push({ id:'12.14.15.2011', kecamatan:'12.14.15', name:'Hilisawato'})
    dataSet.push({ id:'12.04.06.2016', kecamatan:'12.04.06', name:'Hilisebua'})
    dataSet.push({ id:'12.24.07.2014', kecamatan:'12.24.07', name:'Hilisebua Siwalubanua'})
    dataSet.push({ id:'12.14.35.2002', kecamatan:'12.14.35', name:'Hiliserangkai'})
    dataSet.push({ id:'12.14.09.2017', kecamatan:'12.14.09', name:'Hilisibohou'})
    dataSet.push({ id:'12.14.10.2001', kecamatan:'12.14.10', name:'Hilisimaetano'})
    dataSet.push({ id:'12.14.03.2007', kecamatan:'12.14.03', name:'Hilisimaetano Balaekha'})
    dataSet.push({ id:'12.14.06.2026', kecamatan:'12.14.06', name:'Hilisondrekha'})
    dataSet.push({ id:'12.14.12.2010', kecamatan:'12.14.12', name:'Hilisoromi'})
    dataSet.push({ id:'12.25.04.2003', kecamatan:'12.25.04', name:'Hilisoromi'})
    dataSet.push({ id:'12.14.06.2007', kecamatan:'12.14.06', name:'Hilitobara'})
    dataSet.push({ id:'12.14.09.2015', kecamatan:'12.14.09', name:'Hilitobara Susua'})
    dataSet.push({ id:'12.14.11.2007', kecamatan:'12.14.11', name:'Hilitoese'})
    dataSet.push({ id:'12.14.15.2001', kecamatan:'12.14.15', name:'Hilitotao'})
    dataSet.push({ id:'12.14.14.2004', kecamatan:'12.14.14', name:'Hiliuso'})
    dataSet.push({ id:'12.14.20.2009', kecamatan:'12.14.20', name:'Hiliuso'})
    dataSet.push({ id:'12.25.07.2007', kecamatan:'12.25.07', name:'Hiliuso'})
    dataSet.push({ id:'12.14.09.2008', kecamatan:'12.14.09', name:'Hiliwaebu'})
    dataSet.push({ id:'12.14.19.2003', kecamatan:'12.14.19', name:'Hiliwaebu'})
    dataSet.push({ id:'12.25.04.2008', kecamatan:'12.25.04', name:'Hiliwaele'})
    dataSet.push({ id:'12.04.21.2003', kecamatan:'12.04.21', name:'Hiliwaele I'})
    dataSet.push({ id:'12.04.21.2006', kecamatan:'12.04.21', name:'Hiliwaele Ii'})
    dataSet.push({ id:'12.25.05.2007', kecamatan:'12.25.05', name:'Hiliwaloo I'})
    dataSet.push({ id:'12.25.04.2001', kecamatan:'12.25.04', name:'Hiliwaloo Ii'})
    dataSet.push({ id:'12.04.11.2008', kecamatan:'12.04.11', name:'Hiliwarokha'})
    dataSet.push({ id:'12.14.03.2041', kecamatan:'12.14.03', name:'Hiliwatema'})
    dataSet.push({ id:'12.14.22.2007', kecamatan:'12.14.22', name:'Hiliweto'})
    dataSet.push({ id:'12.78.04.2021', kecamatan:'12.78.04', name:'Hiliweto Idanoi'})
    dataSet.push({ id:'12.04.27.2002', kecamatan:'12.04.27', name:'Hiliwetogela'})
    dataSet.push({ id:'12.14.24.2011', kecamatan:'12.14.24', name:'Hiliwosi'})
    dataSet.push({ id:'12.14.13.2001', kecamatan:'12.14.13', name:'Hilizalo Otano'})
    dataSet.push({ id:'12.14.13.2006', kecamatan:'12.14.13', name:'Hilizalo Otano Laowo'})
    dataSet.push({ id:'12.14.13.2007', kecamatan:'12.14.13', name:'Hilizalo Otano Larono'})
    dataSet.push({ id:'12.14.29.2009', kecamatan:'12.14.29', name:'Hilizamorogotano'})
    dataSet.push({ id:'12.14.09.2010', kecamatan:'12.14.09', name:'Hilizamurugo'})
    dataSet.push({ id:'12.14.25.2008', kecamatan:'12.14.25', name:'Hilizanuwo'})
    dataSet.push({ id:'12.04.20.2010', kecamatan:'12.04.20', name:'Hilizia Lauru'})
    dataSet.push({ id:'12.14.18.2011', kecamatan:'12.14.18', name:'Hilizihono'})
    dataSet.push({ id:'12.04.06.2054', kecamatan:'12.04.06', name:'Hilizoi'})
    dataSet.push({ id:'12.14.20.2003', kecamatan:'12.14.20', name:'Hilizoliga'})
    dataSet.push({ id:'12.14.03.2032', kecamatan:'12.14.03', name:'Hilizomboi'})
    dataSet.push({ id:'12.14.13.2005', kecamatan:'12.14.13', name:'Hilizoroi Lawa'})
    dataSet.push({ id:'12.24.10.2005', kecamatan:'12.24.10', name:'Hilizukhu'})
    dataSet.push({ id:'12.25.03.2007', kecamatan:'12.25.03', name:'Hillidaura'})
    dataSet.push({ id:'12.05.10.2006', kecamatan:'12.05.10', name:'Hinai Kanan'})
    dataSet.push({ id:'12.05.09.1004', kecamatan:'12.05.09', name:'Hinai Kiri'})
    dataSet.push({ id:'12.25.02.2010', kecamatan:'12.25.02', name:'Hinako'})
    dataSet.push({ id:'12.08.14.2005', kecamatan:'12.08.14', name:'Hinalang'})
    dataSet.push({ id:'12.12.01.2005', kecamatan:'12.12.01', name:'Hinalang Bagasan'})
    dataSet.push({ id:'12.12.04.2014', kecamatan:'12.12.04', name:'Hitetano'})
    dataSet.push({ id:'12.20.03.2009', kecamatan:'12.20.03', name:'Hiteurat'})
    dataSet.push({ id:'12.01.06.2010', kecamatan:'12.01.06', name:'Hodopa Nauli'})
    dataSet.push({ id:'12.17.09.2001', kecamatan:'12.17.09', name:'Holbung'})
    dataSet.push({ id:'12.04.27.2009', kecamatan:'12.04.27', name:'Holi'})
    dataSet.push({ id:'12.24.10.2003', kecamatan:'12.24.10', name:'Holi'})
    dataSet.push({ id:'12.02.11.2012', kecamatan:'12.02.11', name:'Horisan Ranggitgit'})
    dataSet.push({ id:'12.12.08.2005', kecamatan:'12.12.08', name:'Horsik'})
    dataSet.push({ id:'12.21.08.2037', kecamatan:'12.21.08', name:'Horuon'})
    dataSet.push({ id:'12.20.06.2020', kecamatan:'12.20.06', name:'Hotang Sasa'})
    dataSet.push({ id:'12.04.11.2024', kecamatan:'12.04.11', name:'Hou'})
    dataSet.push({ id:'12.14.25.2009', kecamatan:'12.14.25', name:'Hoya'})
    dataSet.push({ id:'12.02.01.2016', kecamatan:'12.02.01', name:'Htgalung Siwaluompo'})
    dataSet.push({ id:'12.20.02.2059', kecamatan:'12.20.02', name:'Hula Baringin'})
    dataSet.push({ id:'12.21.01.2011', kecamatan:'12.21.01', name:'Hulim'})
    dataSet.push({ id:'12.07.05.2007', kecamatan:'12.07.05', name:'Hulu'})
    dataSet.push({ id:'12.13.23.2003', kecamatan:'12.13.23', name:'Humbang I'})
    dataSet.push({ id:'12.14.15.2008', kecamatan:'12.14.15', name:'Hume'})
    dataSet.push({ id:'12.78.04.2007', kecamatan:'12.78.04', name:'Humene'})
    dataSet.push({ id:'12.24.08.2005', kecamatan:'12.24.08', name:'Humene Siheneasi'})
    dataSet.push({ id:'12.04.29.2003', kecamatan:'12.04.29', name:'Huno'})
    dataSet.push({ id:'12.03.03.2008', kecamatan:'12.03.03', name:'Huraba'})
    dataSet.push({ id:'12.03.20.2002', kecamatan:'12.03.20', name:'Huraba'})
    dataSet.push({ id:'12.13.06.2007', kecamatan:'12.13.06', name:'Huraba I'})
    dataSet.push({ id:'12.13.06.2008', kecamatan:'12.13.06', name:'Huraba Ii'})
    dataSet.push({ id:'12.03.07.2055', kecamatan:'12.03.07', name:'Hurase'})
    dataSet.push({ id:'12.21.03.2003', kecamatan:'12.21.03', name:'Huristak'})
    dataSet.push({ id:'12.01.06.2008', kecamatan:'12.01.06', name:'Hurlang Muara Nauli'})
    dataSet.push({ id:'12.21.08.2002', kecamatan:'12.21.08', name:'Hurung Jilok'})
    dataSet.push({ id:'12.09.17.2002', kecamatan:'12.09.17', name:'Huta Bagasan'})
    dataSet.push({ id:'12.13.03.2004', kecamatan:'12.13.03', name:'Huta Bangun'})
    dataSet.push({ id:'12.13.07.2003', kecamatan:'12.13.07', name:'Huta Bangun'})
    dataSet.push({ id:'12.13.07.2014', kecamatan:'12.13.07', name:'Huta Bangun Jae'})
    dataSet.push({ id:'12.21.01.2020', kecamatan:'12.21.01', name:'Huta Bara'})
    dataSet.push({ id:'12.73.01.1001', kecamatan:'12.73.01', name:'Huta Barangan'})
    dataSet.push({ id:'12.02.05.2012', kecamatan:'12.02.05', name:'Huta Barat'})
    dataSet.push({ id:'12.21.01.2003', kecamatan:'12.21.01', name:'Huta Bargot'})
    dataSet.push({ id:'12.21.11.2004', kecamatan:'12.21.11', name:'Huta Bargot'})
    dataSet.push({ id:'12.13.19.2005', kecamatan:'12.13.19', name:'Huta Bargot Dolok'})
    dataSet.push({ id:'12.13.19.2004', kecamatan:'12.13.19', name:'Huta Bargot Lombang'})
    dataSet.push({ id:'12.13.19.2007', kecamatan:'12.13.19', name:'Huta Bargot Nauli'})
    dataSet.push({ id:'12.13.19.2006', kecamatan:'12.13.19', name:'Huta Bargot Setia'})
    dataSet.push({ id:'12.13.05.2004', kecamatan:'12.13.05', name:'Huta Baringin'})
    dataSet.push({ id:'12.13.06.2005', kecamatan:'12.13.06', name:'Huta Baringin'})
    dataSet.push({ id:'12.13.18.2007', kecamatan:'12.13.18', name:'Huta Baringin'})
    dataSet.push({ id:'12.13.20.2011', kecamatan:'12.13.20', name:'Huta Baringin'})
    dataSet.push({ id:'12.20.08.2027', kecamatan:'12.20.08', name:'Huta Baringin'})
    dataSet.push({ id:'12.13.08.2009', kecamatan:'12.13.08', name:'Huta Baringin Tb'})
    dataSet.push({ id:'12.03.02.2026', kecamatan:'12.03.02', name:'Huta Baru'})
    dataSet.push({ id:'12.03.22.2045', kecamatan:'12.03.22', name:'Huta Baru'})
    dataSet.push({ id:'12.13.20.2002', kecamatan:'12.13.20', name:'Huta Baru'})
    dataSet.push({ id:'12.20.08.2018', kecamatan:'12.20.08', name:'Huta Baru'})
    dataSet.push({ id:'12.20.02.2011', kecamatan:'12.20.02', name:'Huta Baru Sil'})
    dataSet.push({ id:'12.20.02.2066', kecamatan:'12.20.02', name:'Huta Baru Sip'})
    dataSet.push({ id:'12.08.18.1013', kecamatan:'12.08.18', name:'Huta Bayu'})
    dataSet.push({ id:'12.17.08.2009', kecamatan:'12.17.08', name:'Huta Bolon'})
    dataSet.push({ id:'12.13.02.2007', kecamatan:'12.13.02', name:'Huta Damai'})
    dataSet.push({ id:'12.12.01.2032', kecamatan:'12.12.01', name:'Huta Dame'})
    dataSet.push({ id:'12.21.04.2013', kecamatan:'12.21.04', name:'Huta Dolok'})
    dataSet.push({ id:'12.18.17.2015', kecamatan:'12.18.17', name:'Huta Durian'})
    dataSet.push({ id:'12.18.10.2023', kecamatan:'12.18.10', name:'Huta Galuh'})
    dataSet.push({ id:'12.13.21.2003', kecamatan:'12.13.21', name:'Huta Gambir'})
    dataSet.push({ id:'12.03.03.2014', kecamatan:'12.03.03', name:'Huta Ginjang'})
    dataSet.push({ id:'12.17.01.2010', kecamatan:'12.17.01', name:'Huta Ginjang'})
    dataSet.push({ id:'12.17.06.2001', kecamatan:'12.17.06', name:'Huta Ginjang'})
    dataSet.push({ id:'12.03.02.2004', kecamatan:'12.03.02', name:'Huta Godang'})
    dataSet.push({ id:'12.13.11.1003', kecamatan:'12.13.11', name:'Huta Godang'})
    dataSet.push({ id:'12.22.04.2006', kecamatan:'12.22.04', name:'Huta Godang'})
    dataSet.push({ id:'12.13.06.2006', kecamatan:'12.13.06', name:'Huta Godang Muda'})
    dataSet.push({ id:'12.12.03.2018', kecamatan:'12.12.03', name:'Huta Gur-Gur I'})
    dataSet.push({ id:'12.12.03.2004', kecamatan:'12.12.03', name:'Huta Gur-Gur II'})
    dataSet.push({ id:'12.17.06.2005', kecamatan:'12.17.06', name:'Huta Gurgur'})
    dataSet.push({ id:'12.03.32.2005', kecamatan:'12.03.32', name:'Huta Holbung'})
    dataSet.push({ id:'12.17.02.2002', kecamatan:'12.17.02', name:'Huta Hotang'})
    dataSet.push({ id:'12.11.04.2009', kecamatan:'12.11.04', name:'Huta Imbaru'})
    dataSet.push({ id:'12.13.04.2004', kecamatan:'12.13.04', name:'Huta Julu'})
    dataSet.push({ id:'12.13.21.2005', kecamatan:'12.13.21', name:'Huta Julu'})
    dataSet.push({ id:'12.77.05.2010', kecamatan:'12.77.05', name:'Huta Koje'})
    dataSet.push({ id:'12.20.07.2012', kecamatan:'12.20.07', name:'Huta Lambung'})
    dataSet.push({ id:'12.13.21.2004', kecamatan:'12.13.21', name:'Huta Lancat'})
    dataSet.push({ id:'12.13.13.2025', kecamatan:'12.13.13', name:'Huta Lobu'})
    dataSet.push({ id:'12.13.20.2001', kecamatan:'12.13.20', name:'Huta Lombang'})
    dataSet.push({ id:'12.21.04.2020', kecamatan:'12.21.04', name:'Huta Lombang'})
    dataSet.push({ id:'12.77.05.2015', kecamatan:'12.77.05', name:'Huta Lombang'})
    dataSet.push({ id:'12.13.01.2010', kecamatan:'12.13.01', name:'Huta Lombang Lubis'})
    dataSet.push({ id:'12.01.14.1003', kecamatan:'12.01.14', name:'Huta Nabolon'})
    dataSet.push({ id:'12.13.19.2014', kecamatan:'12.13.19', name:'Huta Naingkan'})
    dataSet.push({ id:'12.17.08.2012', kecamatan:'12.17.08', name:'Huta Namora'})
    dataSet.push({ id:'12.13.18.2014', kecamatan:'12.13.18', name:'Huta Nauli'})
    dataSet.push({ id:'12.18.09.2015', kecamatan:'12.18.09', name:'Huta Nauli'})
    dataSet.push({ id:'12.21.09.2013', kecamatan:'12.21.09', name:'Huta Nopan'})
    dataSet.push({ id:'12.03.07.2058', kecamatan:'12.03.07', name:'Huta Padang'})
    dataSet.push({ id:'12.09.17.2007', kecamatan:'12.09.17', name:'Huta Padang'})
    dataSet.push({ id:'12.13.21.2007', kecamatan:'12.13.21', name:'Huta Padang'})
    dataSet.push({ id:'12.77.04.2008', kecamatan:'12.77.04', name:'Huta Padang'})
    dataSet.push({ id:'12.77.05.2012', kecamatan:'12.77.05', name:'Huta Padang'})
    dataSet.push({ id:'12.13.08.2007', kecamatan:'12.13.08', name:'Huta Padang Ms'})
    dataSet.push({ id:'12.13.11.2004', kecamatan:'12.13.11', name:'Huta Padang Up'})
    dataSet.push({ id:'12.03.21.2026', kecamatan:'12.03.21', name:'Huta Pardomuan'})
    dataSet.push({ id:'12.08.30.2002', kecamatan:'12.08.30', name:'Huta Parik'})
    dataSet.push({ id:'12.20.08.2022', kecamatan:'12.20.08', name:'Huta Pasir'})
    dataSet.push({ id:'12.21.03.2012', kecamatan:'12.21.03', name:'Huta Pasir Ulak Tano'})
    dataSet.push({ id:'12.13.06.2004', kecamatan:'12.13.06', name:'Huta Puli'})
    dataSet.push({ id:'12.13.08.2010', kecamatan:'12.13.08', name:'Huta Pungkut Jae'})
    dataSet.push({ id:'12.13.08.2012', kecamatan:'12.13.08', name:'Huta Pungkut Julu'})
    dataSet.push({ id:'12.13.08.2011', kecamatan:'12.13.08', name:'Huta Pungkut Tonga'})
    dataSet.push({ id:'12.02.04.2008', kecamatan:'12.02.04', name:'Huta Raja'})
    dataSet.push({ id:'12.03.30.2014', kecamatan:'12.03.30', name:'Huta Raja'})
    dataSet.push({ id:'12.08.14.2010', kecamatan:'12.08.14', name:'Huta Raja'})
    dataSet.push({ id:'12.13.04.2010', kecamatan:'12.13.04', name:'Huta Raja'})
    dataSet.push({ id:'12.13.06.2003', kecamatan:'12.13.06', name:'Huta Raja'})
    dataSet.push({ id:'12.13.18.2011', kecamatan:'12.13.18', name:'Huta Raja'})
    dataSet.push({ id:'12.20.12.2001', kecamatan:'12.20.12', name:'Huta Raja'})
    dataSet.push({ id:'12.21.08.2017', kecamatan:'12.21.08', name:'Huta Raja Lamo'})
    dataSet.push({ id:'12.11.01.2011', kecamatan:'12.11.01', name:'Huta Rakyat'})
    dataSet.push({ id:'12.09.15.2019', kecamatan:'12.09.15', name:'Huta Rao'})
    dataSet.push({ id:'12.21.02.2053', kecamatan:'12.21.02', name:'Huta Ruhom'})
    dataSet.push({ id:'12.08.26.2008', kecamatan:'12.08.26', name:'Huta Saing'})
    dataSet.push({ id:'12.13.03.2005', kecamatan:'12.13.03', name:'Huta Tinggi'})
    dataSet.push({ id:'12.17.08.2004', kecamatan:'12.17.08', name:'Huta Tinggi'})
    dataSet.push({ id:'12.01.09.2007', kecamatan:'12.01.09', name:'Huta Tombak'})
    dataSet.push({ id:'12.03.32.1002', kecamatan:'12.03.32', name:'Huta Tonga'})
    dataSet.push({ id:'12.73.01.1003', kecamatan:'12.73.01', name:'Huta Tonga-Tonga'})
    dataSet.push({ id:'12.13.10.2006', kecamatan:'12.13.10', name:'Huta Tonga Ab'})
    dataSet.push({ id:'12.13.05.2005', kecamatan:'12.13.05', name:'Huta Tonga Bb'})
    dataSet.push({ id:'12.13.21.2006', kecamatan:'12.13.21', name:'Huta Toras'})
    dataSet.push({ id:'12.16.06.2013', kecamatan:'12.16.06', name:'Hutabagasan'})
    dataSet.push({ id:'12.01.15.1001', kecamatan:'12.01.15', name:'Hutabalang'})
    dataSet.push({ id:'12.13.20.2006', kecamatan:'12.13.20', name:'Hutabaringin Julu'})
    dataSet.push({ id:'12.21.09.2012', kecamatan:'12.21.09', name:'Hutabaru'})
    dataSet.push({ id:'12.20.11.2010', kecamatan:'12.20.11', name:'Hutabaru Nangka'})
    dataSet.push({ id:'12.21.01.2007', kecamatan:'12.21.01', name:'Hutabaru Siundol'})
    dataSet.push({ id:'12.21.01.2021', kecamatan:'12.21.01', name:'Hutabaru Sosopan'})
    dataSet.push({ id:'12.02.09.2016', kecamatan:'12.02.09', name:'Hutabulu'})
    dataSet.push({ id:'12.12.01.2008', kecamatan:'12.12.01', name:'Hutabulu Mejan'})
    dataSet.push({ id:'12.17.04.2018', kecamatan:'12.17.04', name:'Hutadame'})
    dataSet.push({ id:'12.08.03.2007', kecamatan:'12.08.03', name:'Hutadipar'})
    dataSet.push({ id:'12.17.05.2014', kecamatan:'12.17.05', name:'Hutagalung'})
    dataSet.push({ id:'12.12.01.2004', kecamatan:'12.12.01', name:'Hutagaol Peatalun'})
    dataSet.push({ id:'12.12.03.2024', kecamatan:'12.12.03', name:'Hutagaol Sihujur'})
    dataSet.push({ id:'12.01.17.2001', kecamatan:'12.01.17', name:'Hutaginjang'})
    dataSet.push({ id:'12.02.15.2004', kecamatan:'12.02.15', name:'Hutaginjang'})
    dataSet.push({ id:'12.16.07.2005', kecamatan:'12.16.07', name:'Hutaginjang'})
    dataSet.push({ id:'12.17.04.2012', kecamatan:'12.17.04', name:'Hutaginjang'})
    dataSet.push({ id:'12.01.08.2011', kecamatan:'12.01.08', name:'Hutagur-Gur'})
    dataSet.push({ id:'12.12.06.2011', kecamatan:'12.12.06', name:'Hutagurgur'})
    dataSet.push({ id:'12.16.06.2024', kecamatan:'12.16.06', name:'Hutagurgur'})
    dataSet.push({ id:'12.21.04.2004', kecamatan:'12.21.04', name:'Hutaibus'})
    dataSet.push({ id:'12.13.03.2003', kecamatan:'12.13.03', name:'Hutaimbaru'})
    dataSet.push({ id:'12.13.17.2002', kecamatan:'12.13.17', name:'Hutaimbaru'})
    dataSet.push({ id:'12.20.03.2001', kecamatan:'12.20.03', name:'Hutaimbaru'})
    dataSet.push({ id:'12.21.08.2011', kecamatan:'12.21.08', name:'Hutaimbaru'})
    dataSet.push({ id:'12.77.04.1001', kecamatan:'12.77.04', name:'Hutaimbaru'})
    dataSet.push({ id:'12.20.02.2029', kecamatan:'12.20.02', name:'Hutaimbaru Gul'})
    dataSet.push({ id:'12.20.04.2073', kecamatan:'12.20.04', name:'Hutaimbaru Ii'})
    dataSet.push({ id:'12.20.01.2015', kecamatan:'12.20.01', name:'Hutaimbaru Simundol'})
    dataSet.push({ id:'12.13.11.2005', kecamatan:'12.13.11', name:'Hutaimbaru UP'})
    dataSet.push({ id:'12.02.11.2004', kecamatan:'12.02.11', name:'Hutajulu'})
    dataSet.push({ id:'12.16.02.2004', kecamatan:'12.16.02', name:'Hutajulu'})
    dataSet.push({ id:'12.16.08.2008', kecamatan:'12.16.08', name:'Hutajulu'})
    dataSet.push({ id:'12.02.11.2011', kecamatan:'12.02.11', name:'Hutajulu Parbalik'})
    dataSet.push({ id:'12.77.05.2011', kecamatan:'12.77.05', name:'Hutalimbong'})
    dataSet.push({ id:'12.20.04.2041', kecamatan:'12.20.04', name:'Hutalombang'})
    dataSet.push({ id:'12.02.15.2003', kecamatan:'12.02.15', name:'Hutalontung'})
    dataSet.push({ id:'12.02.08.2005', kecamatan:'12.02.08', name:'Hutanagodang'})
    dataSet.push({ id:'12.02.15.2001', kecamatan:'12.02.15', name:'Hutanagodang'})
    dataSet.push({ id:'12.13.20.2005', kecamatan:'12.13.20', name:'Hutanamale'})
    dataSet.push({ id:'12.12.01.2003', kecamatan:'12.12.01', name:'Hutanamora'})
    dataSet.push({ id:'12.12.03.2015', kecamatan:'12.12.03', name:'Hutanamora'})
    dataSet.push({ id:'12.12.09.2016', kecamatan:'12.12.09', name:'Hutanamora'})
    dataSet.push({ id:'12.20.03.2032', kecamatan:'12.20.03', name:'Hutanopan'})
    dataSet.push({ id:'12.21.04.2006', kecamatan:'12.21.04', name:'Hutanopan'})
    dataSet.push({ id:'12.16.02.2002', kecamatan:'12.16.02', name:'Hutapaung'})
    dataSet.push({ id:'12.16.02.2013', kecamatan:'12.16.02', name:'Hutapaung Utara'})
    dataSet.push({ id:'12.02.01.2010', kecamatan:'12.02.01', name:'Hutapea Banuarea'})
    dataSet.push({ id:'12.13.08.2006', kecamatan:'12.13.08', name:'Hutapuli'})
    dataSet.push({ id:'12.02.13.2023', kecamatan:'12.02.13', name:'Hutaraja'})
    dataSet.push({ id:'12.03.29.1002', kecamatan:'12.03.29', name:'Hutaraja'})
    dataSet.push({ id:'12.16.06.2016', kecamatan:'12.16.06', name:'Hutaraja'})
    dataSet.push({ id:'12.02.04.2012', kecamatan:'12.02.04', name:'Hutaraja Hasundutan'})
    dataSet.push({ id:'12.02.04.2014', kecamatan:'12.02.04', name:'Hutaraja Simanungkalit'})
    dataSet.push({ id:'12.21.05.2017', kecamatan:'12.21.05', name:'Hutaraja Tinggi'})
    dataSet.push({ id:'12.17.03.2002', kecamatan:'12.17.03', name:'Hutarihit'})
    dataSet.push({ id:'12.13.04.2002', kecamatan:'12.13.04', name:'Hutarimbaru'})
    dataSet.push({ id:'12.13.19.2002', kecamatan:'12.13.19', name:'Hutarimbaru'})
    dataSet.push({ id:'12.21.07.2024', kecamatan:'12.21.07', name:'Hutarimbaru'})
    dataSet.push({ id:'12.13.08.2008', kecamatan:'12.13.08', name:'Hutarimbaru Sm'})
    dataSet.push({ id:'12.16.05.2008', kecamatan:'12.16.05', name:'Hutasoit I'})
    dataSet.push({ id:'12.16.05.2019', kecamatan:'12.16.05', name:'Hutasoit Ii'})
    dataSet.push({ id:'12.03.04.1003', kecamatan:'12.03.04', name:'Hutasuhut'})
    dataSet.push({ id:'12.02.11.2006', kecamatan:'12.02.11', name:'Hutatinggi'})
    dataSet.push({ id:'12.13.20.2004', kecamatan:'12.13.20', name:'Hutatinggi'})
    dataSet.push({ id:'12.02.01.2030', kecamatan:'12.02.01', name:'Hutatoruan I'})
    dataSet.push({ id:'12.02.01.2031', kecamatan:'12.02.01', name:'Hutatoruan Iii'})
    dataSet.push({ id:'12.02.01.2018', kecamatan:'12.02.01', name:'Hutatoruan Iv'})
    dataSet.push({ id:'12.02.01.1005', kecamatan:'12.02.01', name:'Hutatoruan Ix'})
    dataSet.push({ id:'12.02.01.1002', kecamatan:'12.02.01', name:'Hutatoruan V'})
    dataSet.push({ id:'12.02.01.1003', kecamatan:'12.02.01', name:'Hutatoruan Vi'})
    dataSet.push({ id:'12.02.01.1004', kecamatan:'12.02.01', name:'Hutatoruan Vii'})
    dataSet.push({ id:'12.02.01.2020', kecamatan:'12.02.01', name:'Hutatoruan Viii'})
    dataSet.push({ id:'12.02.01.1006', kecamatan:'12.02.01', name:'Hutatoruan X'})
    dataSet.push({ id:'12.02.01.1007', kecamatan:'12.02.01', name:'Hutatoruan Xi'})
    dataSet.push({ id:'12.02.11.2010', kecamatan:'12.02.11', name:'Hutatua'})
    dataSet.push({ id:'12.02.01.2012', kecamatan:'12.02.01', name:'Hutauruk'})
    dataSet.push({ id:'12.02.04.2002', kecamatan:'12.02.04', name:'Hutauruk'})
    dataSet.push({ id:'12.02.04.2015', kecamatan:'12.02.04', name:'Hutauruk Hasundutan'})
    dataSet.push({ id:'12.04.29.2002', kecamatan:'12.04.29', name:'I Odano'})
    dataSet.push({ id:'12.14.10.2006', kecamatan:'12.14.10', name:'Idala Jaya Hilisimaetano'})
    dataSet.push({ id:'12.78.04.2013', kecamatan:'12.78.04', name:'Idanotae'})
    dataSet.push({ id:'12.25.02.2002', kecamatan:'12.25.02', name:'Imana'})
    dataSet.push({ id:'12.71.14.1001', kecamatan:'12.71.14', name:'Indra Kasih'})
    dataSet.push({ id:'12.74.01.1006', kecamatan:'12.74.01', name:'Indra Sakti'})
    dataSet.push({ id:'12.19.05.2016', kecamatan:'12.19.05', name:'Indra Yaman'})
    dataSet.push({ id:'12.19.03.1001', kecamatan:'12.19.03', name:'Indrapura'})
    dataSet.push({ id:'12.19.03.1019', kecamatan:'12.19.03', name:'Indrasakti'})
    dataSet.push({ id:'12.03.30.2009', kecamatan:'12.03.30', name:'Ingul Jae'})
    dataSet.push({ id:'12.13.01.2012', kecamatan:'12.13.01', name:'Ipar Bondar'})
    dataSet.push({ id:'12.24.10.2002', kecamatan:'12.24.10', name:'Iraono Lase'})
    dataSet.push({ id:'12.25.01.2005', kecamatan:'12.25.01', name:'Iraonogaila'})
    dataSet.push({ id:'12.25.05.2010', kecamatan:'12.25.05', name:'Iraonogambo'})
    dataSet.push({ id:'12.25.03.2004', kecamatan:'12.25.03', name:'Iraonogeba'})
    dataSet.push({ id:'12.78.01.2009', kecamatan:'12.78.01', name:'Iraonogeba'})
    dataSet.push({ id:'12.78.05.2003', kecamatan:'12.78.05', name:'Iraonolase'})
    dataSet.push({ id:'12.71.15.1003', kecamatan:'12.71.15', name:'J a t i'})
    dataSet.push({ id:'12.07.06.2027', kecamatan:'12.07.06', name:'Jaba'})
    dataSet.push({ id:'12.20.08.2024', kecamatan:'12.20.08', name:'Jabi Jabi'})
    dataSet.push({ id:'12.01.15.2003', kecamatan:'12.01.15', name:'Jago Jago'})
    dataSet.push({ id:'12.07.19.2007', kecamatan:'12.07.19', name:'Jaharum A'})
    dataSet.push({ id:'12.07.19.2008', kecamatan:'12.07.19', name:'Jaharum B'})
    dataSet.push({ id:'12.18.13.2003', kecamatan:'12.18.13', name:'Jambu'})
    dataSet.push({ id:'12.20.12.2011', kecamatan:'12.20.12', name:'Jambu Tonang'})
    dataSet.push({ id:'12.13.13.2027', kecamatan:'12.13.13', name:'Jambur Baru'})
    dataSet.push({ id:'12.20.02.2035', kecamatan:'12.20.02', name:'Jambur Batu'})
    dataSet.push({ id:'12.11.08.2005', kecamatan:'12.11.08', name:'Jambur Indonesia'})
    dataSet.push({ id:'12.02.01.2027', kecamatan:'12.02.01', name:'Jambur Nauli'})
    dataSet.push({ id:'12.13.02.2008', kecamatan:'12.13.02', name:'Jambur Padang Matinggi'})
    dataSet.push({ id:'12.18.02.2009', kecamatan:'12.18.02', name:'Jambur Pulau'})
    dataSet.push({ id:'12.06.07.2019', kecamatan:'12.06.07', name:'Jandi'})
    dataSet.push({ id:'12.06.17.2005', kecamatan:'12.06.17', name:'Jandimeriah'})
    dataSet.push({ id:'12.12.09.2015', kecamatan:'12.12.09', name:'Jangga Dolok'})
    dataSet.push({ id:'12.12.09.2005', kecamatan:'12.12.09', name:'Jangga Toruan'})
    dataSet.push({ id:'12.08.04.2001', kecamatan:'12.08.04', name:'Janggir Leto'})
    dataSet.push({ id:'12.10.07.2004', kecamatan:'12.10.07', name:'Janji'})
    dataSet.push({ id:'12.11.08.2007', kecamatan:'12.11.08', name:'Janji'})
    dataSet.push({ id:'12.16.06.2021', kecamatan:'12.16.06', name:'Janji'})
    dataSet.push({ id:'12.16.01.2019', kecamatan:'12.16.01', name:'Janji Hutanapa'})
    dataSet.push({ id:'12.21.04.2017', kecamatan:'12.21.04', name:'Janji Lobi Lima'})
    dataSet.push({ id:'12.20.07.2029', kecamatan:'12.20.07', name:'Janji Manahan'})
    dataSet.push({ id:'12.21.02.2028', kecamatan:'12.21.02', name:'Janji Manahan'})
    dataSet.push({ id:'12.20.01.2001', kecamatan:'12.20.01', name:'Janji Manahan Gnt'})
    dataSet.push({ id:'12.20.02.2040', kecamatan:'12.20.02', name:'Janji Manahan Gul'})
    dataSet.push({ id:'12.20.02.2016', kecamatan:'12.20.02', name:'Janji Manahan Sil'})
    dataSet.push({ id:'12.03.07.2018', kecamatan:'12.03.07', name:'Janji Manaon'})
    dataSet.push({ id:'12.17.03.2015', kecamatan:'12.17.03', name:'Janji Marapot'})
    dataSet.push({ id:'12.01.18.2004', kecamatan:'12.01.18', name:'Janji Maria'})
    dataSet.push({ id:'12.12.06.2008', kecamatan:'12.12.06', name:'Janji Maria'})
    dataSet.push({ id:'12.17.09.2008', kecamatan:'12.17.09', name:'Janji Maria'})
    dataSet.push({ id:'12.21.11.2005', kecamatan:'12.21.11', name:'Janji Maria'})
    dataSet.push({ id:'12.17.05.2012', kecamatan:'12.17.05', name:'Janji Martahan'})
    dataSet.push({ id:'12.13.07.2005', kecamatan:'12.13.07', name:'Janji Matogu'})
    dataSet.push({ id:'12.17.02.2009', kecamatan:'12.17.02', name:'Janji Matogu'})
    dataSet.push({ id:'12.20.02.2073', kecamatan:'12.20.02', name:'Janji Matogu'})
    dataSet.push({ id:'12.20.06.2033', kecamatan:'12.20.06', name:'Janji Matogu'})
    dataSet.push({ id:'12.20.08.2019', kecamatan:'12.20.08', name:'Janji Matogu'})
    dataSet.push({ id:'12.21.02.2024', kecamatan:'12.21.02', name:'Janji Matogu'})
    dataSet.push({ id:'12.21.04.2001', kecamatan:'12.21.04', name:'Janji Matogu'})
    dataSet.push({ id:'12.03.04.2034', kecamatan:'12.03.04', name:'Janji Mauli'})
    dataSet.push({ id:'12.20.07.2022', kecamatan:'12.20.07', name:'Janji Mauli'})
    dataSet.push({ id:'12.03.21.2003', kecamatan:'12.03.21', name:'Janji Mauli Baringin'})
    dataSet.push({ id:'12.03.32.2009', kecamatan:'12.03.32', name:'Janji Mauli MT'})
    dataSet.push({ id:'12.16.08.2006', kecamatan:'12.16.08', name:'Janji Nagodang'})
    dataSet.push({ id:'12.02.05.2003', kecamatan:'12.02.05', name:'Janji Natogu'})
    dataSet.push({ id:'12.02.08.2007', kecamatan:'12.02.08', name:'Janji Nauli'})
    dataSet.push({ id:'12.17.09.2002', kecamatan:'12.17.09', name:'Janji Raja'})
    dataSet.push({ id:'12.21.02.2012', kecamatan:'12.21.02', name:'Janji Raja'})
    dataSet.push({ id:'12.21.07.2008', kecamatan:'12.21.07', name:'Janjilobi'})
    dataSet.push({ id:'12.21.08.2020', kecamatan:'12.21.08', name:'Janjiraja'})
    dataSet.push({ id:'12.20.03.2041', kecamatan:'12.20.03', name:'Japinulik'})
    dataSet.push({ id:'12.06.15.2005', kecamatan:'12.06.15', name:'Jaranguda'})
    dataSet.push({ id:'12.05.09.2011', kecamatan:'12.05.09', name:'Jaring Halus'})
    dataSet.push({ id:'12.07.31.2009', kecamatan:'12.07.31', name:'Jati Baru'})
    dataSet.push({ id:'12.75.01.1009', kecamatan:'12.75.01', name:'Jati Karya'})
    dataSet.push({ id:'12.07.06.2002', kecamatan:'12.07.06', name:'Jati Kesuma'})
    dataSet.push({ id:'12.75.01.1008', kecamatan:'12.75.01', name:'Jati Makmur'})
    dataSet.push({ id:'12.19.12.2003', kecamatan:'12.19.12', name:'Jati Mulia'})
    dataSet.push({ id:'12.18.14.2003', kecamatan:'12.18.14', name:'Jati Mulyo'})
    dataSet.push({ id:'12.75.01.1002', kecamatan:'12.75.01', name:'Jati Negara'})
    dataSet.push({ id:'12.07.31.2005', kecamatan:'12.07.31', name:'Jati Rejo'})
    dataSet.push({ id:'12.05.12.2010', kecamatan:'12.05.12', name:'Jati Sari'})
    dataSet.push({ id:'12.75.01.1007', kecamatan:'12.75.01', name:'Jati Utomo'})
    dataSet.push({ id:'12.08.18.2007', kecamatan:'12.08.18', name:'Jawa Baru'})
    dataSet.push({ id:'12.08.19.2001', kecamatan:'12.08.19', name:'Jawa Maraja'})
    dataSet.push({ id:'12.08.12.2006', kecamatan:'12.08.12', name:'Jawa Tonga'})
    dataSet.push({ id:'12.08.12.2009', kecamatan:'12.08.12', name:'Jawa Tongah Ii'})
    dataSet.push({ id:'12.14.31.2006', kecamatan:'12.14.31', name:'Jeke'})
    dataSet.push({ id:'12.05.08.2013', kecamatan:'12.05.08', name:'Jentera Stabat'})
    dataSet.push({ id:'12.06.12.2028', kecamatan:'12.06.12', name:'Jeraya'})
    dataSet.push({ id:'12.06.13.2006', kecamatan:'12.06.13', name:'Jinabun'})
    dataSet.push({ id:'12.12.24.2007', kecamatan:'12.12.24', name:'Jonggi Manulus'})
    dataSet.push({ id:'12.12.09.2017', kecamatan:'12.12.09', name:'Jonggi Nihuta'})
    dataSet.push({ id:'12.77.06.2001', kecamatan:'12.77.06', name:'Joring Lombang'})
    dataSet.push({ id:'12.77.06.2008', kecamatan:'12.77.06', name:'Joring Natobang'})
    dataSet.push({ id:'12.08.06.2003', kecamatan:'12.08.06', name:'Jorlang Hataran'})
    dataSet.push({ id:'12.08.10.2005', kecamatan:'12.08.10', name:'Jorlang Huluan'})
    dataSet.push({ id:'12.18.06.2002', kecamatan:'12.18.06', name:'Juhar'})
    dataSet.push({ id:'12.07.19.2009', kecamatan:'12.07.19', name:'Juhar Baru'})
    dataSet.push({ id:'12.06.07.2009', kecamatan:'12.06.07', name:'Juhar Ginting'})
    dataSet.push({ id:'12.06.07.2025', kecamatan:'12.06.07', name:'Juhar Ginting Sadanioga'})
    dataSet.push({ id:'12.06.07.2001', kecamatan:'12.06.07', name:'Juhar Perangin-Angin'})
    dataSet.push({ id:'12.06.07.2010', kecamatan:'12.06.07', name:'Juhar Tarigan'})
    dataSet.push({ id:'12.11.03.2003', kecamatan:'12.11.03', name:'Juma Gerat'})
    dataSet.push({ id:'12.11.04.2006', kecamatan:'12.11.04', name:'Juma Siulok'})
    dataSet.push({ id:'12.11.04.2007', kecamatan:'12.11.04', name:'Juma Teguh'})
    dataSet.push({ id:'12.07.08.2008', kecamatan:'12.07.08', name:'Juma Tombak'})
    dataSet.push({ id:'12.11.04.2010', kecamatan:'12.11.04', name:'Jumantuang'})
    dataSet.push({ id:'12.06.01.2002', kecamatan:'12.06.01', name:'Kaban'})
    dataSet.push({ id:'12.11.11.2009', kecamatan:'12.11.11', name:'Kaban Julu'})
    dataSet.push({ id:'12.15.01.2003', kecamatan:'12.15.01', name:'Kaban Tengah'})
    dataSet.push({ id:'12.06.06.2012', kecamatan:'12.06.06', name:'Kaban Tua'})
    dataSet.push({ id:'12.06.01.2008', kecamatan:'12.06.01', name:'Kacaribu'})
    dataSet.push({ id:'12.06.04.2014', kecamatan:'12.06.04', name:'Kacinambun'})
    dataSet.push({ id:'12.25.02.2004', kecamatan:'12.25.02', name:'Kafo Kafo'})
    dataSet.push({ id:'12.08.17.2010', kecamatan:'12.08.17', name:'Kahean'})
    dataSet.push({ id:'12.72.03.1005', kecamatan:'12.72.03', name:'Kahean'})
    dataSet.push({ id:'12.11.01.2012', kecamatan:'12.11.01', name:'Kalang'})
    dataSet.push({ id:'12.11.01.2014', kecamatan:'12.11.01', name:'Kalang Simbara'})
    dataSet.push({ id:'12.01.03.1013', kecamatan:'12.01.03', name:'Kalangan'})
    dataSet.push({ id:'12.01.03.1023', kecamatan:'12.01.03', name:'Kalangan Indah'})
    dataSet.push({ id:'12.18.07.2008', kecamatan:'12.18.07', name:'Kalembak'})
    dataSet.push({ id:'12.10.07.2009', kecamatan:'12.10.07', name:'Kampung Baru'})
    dataSet.push({ id:'12.13.02.2009', kecamatan:'12.13.02', name:'Kampung Baru'})
    dataSet.push({ id:'12.13.14.2010', kecamatan:'12.13.14', name:'Kampung Baru'})
    dataSet.push({ id:'12.71.15.1006', kecamatan:'12.71.15', name:'Kampung Baru'})
    dataSet.push({ id:'12.10.08.2006', kecamatan:'12.10.08', name:'Kampung Bilah'})
    dataSet.push({ id:'12.06.01.1013', kecamatan:'12.06.01', name:'Kampung Dalam'})
    dataSet.push({ id:'12.10.09.2008', kecamatan:'12.10.09', name:'Kampung Dalam'})
    dataSet.push({ id:'12.13.15.2007', kecamatan:'12.13.15', name:'Kampung Kapas'})
    dataSet.push({ id:'12.13.15.2023', kecamatan:'12.13.15', name:'Kampung Kapas I'})
    dataSet.push({ id:'12.13.22.2007', kecamatan:'12.13.22', name:'Kampung Kapas Ii'})
    dataSet.push({ id:'12.19.03.2018', kecamatan:'12.19.03', name:'Kampung Kelapa'})
    dataSet.push({ id:'12.18.17.2016', kecamatan:'12.18.17', name:'Kampung Kristen'})
    dataSet.push({ id:'12.08.30.2017', kecamatan:'12.08.30', name:'Kampung Lalang'})
    dataSet.push({ id:'12.19.06.2019', kecamatan:'12.19.06', name:'Kampung Lalang'})
    dataSet.push({ id:'12.05.16.1011', kecamatan:'12.05.16', name:'Kampung Lama'})
    dataSet.push({ id:'12.23.03.1001', kecamatan:'12.23.03', name:'Kampung Mesjid'})
    dataSet.push({ id:'12.01.01.2008', kecamatan:'12.01.01', name:'Kampung Mudik'})
    dataSet.push({ id:'12.10.14.2004', kecamatan:'12.10.14', name:'Kampung Padang'})
    dataSet.push({ id:'12.13.01.2013', kecamatan:'12.13.01', name:'Kampung Padang'})
    dataSet.push({ id:'12.23.06.2008', kecamatan:'12.23.06', name:'Kampung Pajak'})
    dataSet.push({ id:'12.22.02.2009', kecamatan:'12.22.02', name:'Kampung Perlabian'})
    dataSet.push({ id:'12.13.12.2007', kecamatan:'12.13.12', name:'Kampung Pinang'})
    dataSet.push({ id:'12.13.16.2005', kecamatan:'12.13.16', name:'Kampung Sawah'})
    dataSet.push({ id:'12.01.01.2003', kecamatan:'12.01.01', name:'Kampung Solok'})
    dataSet.push({ id:'12.23.07.2010', kecamatan:'12.23.07', name:'Kampung Yaman'})
    dataSet.push({ id:'12.08.21.2004', kecamatan:'12.08.21', name:'Kandangan'})
    dataSet.push({ id:'12.19.08.2010', kecamatan:'12.19.08', name:'Kandangan'})
    dataSet.push({ id:'12.06.01.2007', kecamatan:'12.06.01', name:'Kandibata'})
    dataSet.push({ id:'12.77.01.1015', kecamatan:'12.77.01', name:'Kantin'})
    dataSet.push({ id:'12.19.12.2012', kecamatan:'12.19.12', name:'Kapal Merah'})
    dataSet.push({ id:'12.05.22.2004', kecamatan:'12.05.22', name:'Kaperas'})
    dataSet.push({ id:'12.09.10.2005', kecamatan:'12.09.10', name:'Kapias Batu Viii'})
    dataSet.push({ id:'12.74.04.1004', kecamatan:'12.74.04', name:'Kapias Pulau Buaya'})
    dataSet.push({ id:'12.05.09.2015', kecamatan:'12.05.09', name:'Karang Anyar'})
    dataSet.push({ id:'12.07.33.2009', kecamatan:'12.07.33', name:'Karang Anyar'})
    dataSet.push({ id:'12.18.14.2004', kecamatan:'12.18.14', name:'Karang Anyar'})
    dataSet.push({ id:'12.20.01.2036', kecamatan:'12.20.01', name:'Karang Anyar'})
    dataSet.push({ id:'12.23.04.2006', kecamatan:'12.23.04', name:'Karang Anyar'})
    dataSet.push({ id:'12.08.03.2002', kecamatan:'12.08.03', name:'Karang Anyer'})
    dataSet.push({ id:'12.09.20.1011', kecamatan:'12.09.20', name:'Karang Anyer'})
    dataSet.push({ id:'12.08.01.2008', kecamatan:'12.08.01', name:'Karang Bangun'})
    dataSet.push({ id:'12.19.11.2006', kecamatan:'12.19.11', name:'Karang Baru'})
    dataSet.push({ id:'12.71.05.1006', kecamatan:'12.71.05', name:'Karang Berombak'})
    dataSet.push({ id:'12.05.09.2010', kecamatan:'12.05.09', name:'Karang Gading'})
    dataSet.push({ id:'12.07.25.2004', kecamatan:'12.07.25', name:'Karang Gading'})
    dataSet.push({ id:'12.05.07.2001', kecamatan:'12.05.07', name:'Karang Rejo'})
    dataSet.push({ id:'12.08.03.2003', kecamatan:'12.08.03', name:'Karang Rejo'})
    dataSet.push({ id:'12.08.03.2004', kecamatan:'12.08.03', name:'Karang Sari'})
    dataSet.push({ id:'12.18.12.2014', kecamatan:'12.18.12', name:'Karang Tengah'})
    dataSet.push({ id:'12.11.13.2005', kecamatan:'12.11.13', name:'Karing'})
    dataSet.push({ id:'12.72.04.1002', kecamatan:'12.72.04', name:'Karo'})
    dataSet.push({ id:'12.10.01.1005', kecamatan:'12.10.01', name:'Kartini'})
    dataSet.push({ id:'12.75.02.1004', kecamatan:'12.75.02', name:'Kartini'})
    dataSet.push({ id:'12.16.09.2003', kecamatan:'12.16.09', name:'Karya'})
    dataSet.push({ id:'12.74.01.1004', kecamatan:'12.74.01', name:'Karya'})
    dataSet.push({ id:'12.09.16.2019', kecamatan:'12.09.16', name:'Karya Ambalutu'})
    dataSet.push({ id:'12.05.19.2007', kecamatan:'12.05.19', name:'Karya Jadi'})
    dataSet.push({ id:'12.76.02.1007', kecamatan:'12.76.02', name:'Karya Jaya'})
    dataSet.push({ id:'12.05.11.2018', kecamatan:'12.05.11', name:'Karya Maju'})
    dataSet.push({ id:'12.08.06.2001', kecamatan:'12.08.06', name:'Kasindir'})
    dataSet.push({ id:'12.18.06.2005', kecamatan:'12.18.06', name:'Kayu Besar'})
    dataSet.push({ id:'12.13.01.1014', kecamatan:'12.13.01', name:'Kayu Jati'})
    dataSet.push({ id:'12.13.04.2005', kecamatan:'12.13.04', name:'Kayu Laut'})
    dataSet.push({ id:'12.77.01.1016', kecamatan:'12.77.01', name:'Kayu Ombun'})
    dataSet.push({ id:'12.06.16.2006', kecamatan:'12.06.16', name:'Kebayaken'})
    dataSet.push({ id:'12.05.08.2005', kecamatan:'12.05.08', name:'Kebun Balok'})
    dataSet.push({ id:'12.05.09.2005', kecamatan:'12.05.09', name:'Kebun Kelapa'})
    dataSet.push({ id:'12.05.10.1008', kecamatan:'12.05.10', name:'Kebun Lada'})
    dataSet.push({ id:'12.75.01.1005', kecamatan:'12.75.01', name:'Kebun Lada'})
    dataSet.push({ id:'12.01.15.2006', kecamatan:'12.01.15', name:'Kebun Pisang'})
    dataSet.push({ id:'12.72.01.1001', kecamatan:'12.72.01', name:'Kebun Sayur'})
    dataSet.push({ id:'12.08.09.2012', kecamatan:'12.08.09', name:'Kebun Sayur Bah Butong'})
    dataSet.push({ id:'12.15.05.2001', kecamatan:'12.15.05', name:'Kecupak I'})
    dataSet.push({ id:'12.15.05.2002', kecamatan:'12.15.05', name:'Kecupak Ii'})
    dataSet.push({ id:'12.07.22.2001', kecamatan:'12.07.22', name:'Kedai Durian'})
    dataSet.push({ id:'12.71.11.1003', kecamatan:'12.71.11', name:'Kedai Durian'})
    dataSet.push({ id:'12.01.01.2018', kecamatan:'12.01.01', name:'Kedai Gedang'})
    dataSet.push({ id:'12.09.20.1010', kecamatan:'12.09.20', name:'Kedai Ledang'})
    dataSet.push({ id:'12.07.32.2017', kecamatan:'12.07.32', name:'Kelambir'})
    dataSet.push({ id:'12.07.24.2009', kecamatan:'12.07.24', name:'Kelambir Lima Kebun'})
    dataSet.push({ id:'12.05.18.2007', kecamatan:'12.05.18', name:'Kelantan'})
    dataSet.push({ id:'12.18.12.2015', kecamatan:'12.18.12', name:'Kelapa Bajohom'})
    dataSet.push({ id:'12.07.19.2016', kecamatan:'12.07.19', name:'Kelapa Satu'})
    dataSet.push({ id:'12.23.02.2004', kecamatan:'12.23.02', name:'Kelapa Sebatang'})
    dataSet.push({ id:'12.06.08.2002', kecamatan:'12.06.08', name:'Kem Kem'})
    dataSet.push({ id:'12.71.07.1004', kecamatan:'12.71.07', name:'Kemenangan Tani'})
    dataSet.push({ id:'12.11.06.2006', kecamatan:'12.11.06', name:'Kempawa'})
    dataSet.push({ id:'12.07.26.1019', kecamatan:'12.07.26', name:'Kenangan'})
    dataSet.push({ id:'12.07.26.1020', kecamatan:'12.07.26', name:'Kenangan Baru'})
    dataSet.push({ id:'12.11.12.2006', kecamatan:'12.11.12', name:'Kendit Liang'})
    dataSet.push({ id:'12.11.11.2002', kecamatan:'12.11.11', name:'Kentara'})
    dataSet.push({ id:'12.05.09.2001', kecamatan:'12.05.09', name:'Kepala Sungai'})
    dataSet.push({ id:'12.07.19.2012', kecamatan:'12.07.19', name:'Keramat Gajah'})
    dataSet.push({ id:'12.74.03.1001', kecamatan:'12.74.03', name:'Keramat Kubah'})
    dataSet.push({ id:'12.18.09.2025', kecamatan:'12.18.09', name:'Kerapuh'})
    dataSet.push({ id:'12.08.21.1009', kecamatan:'12.08.21', name:'Kerasaan I'})
    dataSet.push({ id:'12.08.21.2007', kecamatan:'12.08.21', name:'Kerasaan Ii'})
    dataSet.push({ id:'12.06.07.2016', kecamatan:'12.06.07', name:'Keriahen'})
    dataSet.push({ id:'12.18.02.2012', kecamatan:'12.18.02', name:'Kesatuan'})
    dataSet.push({ id:'12.71.05.1001', kecamatan:'12.71.05', name:'Kesawan'})
    dataSet.push({ id:'12.07.03.2012', kecamatan:'12.07.03', name:'Ketangkuhen'})
    dataSet.push({ id:'12.06.01.2003', kecamatan:'12.06.01', name:'Ketaren'})
    dataSet.push({ id:'12.06.07.2018', kecamatan:'12.06.07', name:'Ketawaren'})
    dataSet.push({ id:'12.06.07.2003', kecamatan:'12.06.07', name:'Kidupen'})
    dataSet.push({ id:'12.03.04.2104', kecamatan:'12.03.04', name:'Kilang Papan'})
    dataSet.push({ id:'12.01.01.2007', kecamatan:'12.01.01', name:'Kinali'})
    dataSet.push({ id:'12.06.09.2010', kecamatan:'12.06.09', name:'Kinangkong'})
    dataSet.push({ id:'12.06.06.2003', kecamatan:'12.06.06', name:'Kineppen'})
    dataSet.push({ id:'12.09.19.1004', kecamatan:'12.09.19', name:'Kisaran Barat'})
    dataSet.push({ id:'12.09.19.1005', kecamatan:'12.09.19', name:'Kisaran Baru'})
    dataSet.push({ id:'12.09.19.1006', kecamatan:'12.09.19', name:'Kisaran Kota'})
    dataSet.push({ id:'12.09.20.1009', kecamatan:'12.09.20', name:'Kisaran Naga'})
    dataSet.push({ id:'12.09.20.1008', kecamatan:'12.09.20', name:'Kisaran Timur'})
    dataSet.push({ id:'12.07.24.2007', kecamatan:'12.07.24', name:'Klambir'})
    dataSet.push({ id:'12.07.24.2005', kecamatan:'12.07.24', name:'Klambir Lima Kampung'})
    dataSet.push({ id:'12.07.24.2004', kecamatan:'12.07.24', name:'Klumpang Kampung'})
    dataSet.push({ id:'12.07.24.2003', kecamatan:'12.07.24', name:'Klumpang Kebun'})
    dataSet.push({ id:'12.14.01.2024', kecamatan:'12.14.01', name:'Ko Olotano'})
    dataSet.push({ id:'12.06.05.2003', kecamatan:'12.06.05', name:'Kodon-Kodon'})
    dataSet.push({ id:'12.14.01.2006', kecamatan:'12.14.01', name:'Koendrafo'})
    dataSet.push({ id:'12.07.26.2003', kecamatan:'12.07.26', name:'Kolam'})
    dataSet.push({ id:'12.01.06.1007', kecamatan:'12.01.06', name:'Kolang Nauli'})
    dataSet.push({ id:'12.18.07.2017', kecamatan:'12.18.07', name:'Korajim'})
    dataSet.push({ id:'12.20.08.2034', kecamatan:'12.20.08', name:'Kosik Putih'})
    dataSet.push({ id:'12.71.06.1004', kecamatan:'12.71.06', name:'Kota Bangun'})
    dataSet.push({ id:'12.73.02.1001', kecamatan:'12.73.02', name:'Kota Baringin'})
    dataSet.push({ id:'12.07.24.2015', kecamatan:'12.07.24', name:'Kota Datar'})
    dataSet.push({ id:'12.18.02.2013', kecamatan:'12.18.02', name:'Kota Galuh'})
    dataSet.push({ id:'12.71.10.1006', kecamatan:'12.71.10', name:'Kota Matsum I'})
    dataSet.push({ id:'12.71.10.1007', kecamatan:'12.71.10', name:'Kota Matsum Ii'})
    dataSet.push({ id:'12.71.10.1008', kecamatan:'12.71.10', name:'Kota Matsum Iv'})
    dataSet.push({ id:'12.18.01.2003', kecamatan:'12.18.01', name:'Kota Pari'})
    dataSet.push({ id:'12.07.24.2017', kecamatan:'12.07.24', name:'Kota Rantang'})
    dataSet.push({ id:'12.13.01.1011', kecamatan:'12.13.01', name:'Kota Siantar'})
    dataSet.push({ id:'12.18.09.2003', kecamatan:'12.18.09', name:'Kota Tengah'})
    dataSet.push({ id:'12.03.30.2012', kecamatan:'12.03.30', name:'Kota Tua'})
    dataSet.push({ id:'12.71.01.1006', kecamatan:'12.71.01', name:'Kotamatsum III'})
    dataSet.push({ id:'12.07.19.2015', kecamatan:'12.07.19', name:'Kotangan'})
    dataSet.push({ id:'12.22.01.1001', kecamatan:'12.22.01', name:'Kotapinang'})
    dataSet.push({ id:'12.18.10.2002', kecamatan:'12.18.10', name:'Kotarih Baru'})
    dataSet.push({ id:'12.18.10.2001', kecamatan:'12.18.10', name:'Kotarih Pekan'})
    dataSet.push({ id:'12.07.19.2013', kecamatan:'12.07.19', name:'Kotasan'})
    dataSet.push({ id:'12.14.05.2041', kecamatan:'12.14.05', name:'Koto'})
    dataSet.push({ id:'12.13.12.2008', kecamatan:'12.13.12', name:'Koto Baringin'})
    dataSet.push({ id:'12.13.12.2023', kecamatan:'12.13.12', name:'Koto Boru'})
    dataSet.push({ id:'12.72.04.1005', kecamatan:'12.72.04', name:'Kristen'})
    dataSet.push({ id:'12.06.08.2004', kecamatan:'12.06.08', name:'Kuala'})
    dataSet.push({ id:'12.07.03.2013', kecamatan:'12.07.03', name:'Kuala'})
    dataSet.push({ id:'12.18.12.2011', kecamatan:'12.18.12', name:'Kuala Bali'})
    dataSet.push({ id:'12.23.03.2002', kecamatan:'12.23.03', name:'Kuala Bangka'})
    dataSet.push({ id:'12.13.15.2008', kecamatan:'12.13.15', name:'Kuala Batahan'})
    dataSet.push({ id:'12.23.01.2003', kecamatan:'12.23.01', name:'Kuala Beringin'})
    dataSet.push({ id:'12.07.07.2005', kecamatan:'12.07.07', name:'Kuala Dekah'})
    dataSet.push({ id:'12.19.02.2011', kecamatan:'12.19.02', name:'Kuala Indah'})
    dataSet.push({ id:'12.18.01.2006', kecamatan:'12.18.01', name:'Kuala Lama'})
    dataSet.push({ id:'12.74.02.1004', kecamatan:'12.74.02', name:'Kuala Silo Bestari'})
    dataSet.push({ id:'12.20.01.2007', kecamatan:'12.20.01', name:'Kuala Simpang'})
    dataSet.push({ id:'12.19.02.2012', kecamatan:'12.19.02', name:'Kuala Tanjung'})
    dataSet.push({ id:'12.07.32.2006', kecamatan:'12.07.32', name:'Kubah Sentang'})
    dataSet.push({ id:'12.13.15.2024', kecamatan:'12.13.15', name:'Kubangan Pandan Sari'})
    dataSet.push({ id:'12.13.15.2009', kecamatan:'12.13.15', name:'Kubangan Tompek'})
    dataSet.push({ id:'12.06.14.2001', kecamatan:'12.06.14', name:'Kubu Colia'})
    dataSet.push({ id:'12.06.04.2010', kecamatan:'12.06.04', name:'Kubusimbelang'})
    dataSet.push({ id:'12.18.11.2016', kecamatan:'12.18.11', name:'Kulasar'})
    dataSet.push({ id:'12.13.19.2010', kecamatan:'12.13.19', name:'Kumpulan Setia'})
    dataSet.push({ id:'12.13.16.2030', kecamatan:'12.13.16', name:'Kun-Kun'})
    dataSet.push({ id:'12.15.07.2001', kecamatan:'12.15.07', name:'Kuta Babo'})
    dataSet.push({ id:'12.06.08.2008', kecamatan:'12.06.08', name:'Kuta Bangun'})
    dataSet.push({ id:'12.18.13.2011', kecamatan:'12.18.13', name:'Kuta Baru'})
    dataSet.push({ id:'12.07.01.2001', kecamatan:'12.07.01', name:'Kuta Bayu'})
    dataSet.push({ id:'12.06.08.2018', kecamatan:'12.06.08', name:'Kuta Buara'})
    dataSet.push({ id:'12.11.06.2009', kecamatan:'12.11.06', name:'Kuta Buluh'})
    dataSet.push({ id:'12.15.02.2004', kecamatan:'12.15.02', name:'Kuta Dame'})
    dataSet.push({ id:'12.05.22.2002', kecamatan:'12.05.22', name:'Kuta Gajah'})
    dataSet.push({ id:'12.06.08.2015', kecamatan:'12.06.08', name:'Kuta Galoh'})
    dataSet.push({ id:'12.11.06.2005', kecamatan:'12.11.06', name:'Kuta Gamber'})
    dataSet.push({ id:'12.11.01.1005', kecamatan:'12.11.01', name:'Kuta Gambir'})
    dataSet.push({ id:'12.06.06.2009', kecamatan:'12.06.06', name:'Kuta Gerat'})
    dataSet.push({ id:'12.06.08.2013', kecamatan:'12.06.08', name:'Kuta Gerat'})
    dataSet.push({ id:'12.11.02.2020', kecamatan:'12.11.02', name:'Kuta Gugung'})
    dataSet.push({ id:'12.15.08.2005', kecamatan:'12.15.08', name:'Kuta Jungak'})
    dataSet.push({ id:'12.07.08.2010', kecamatan:'12.07.08', name:'Kuta Jurung'})
    dataSet.push({ id:'12.06.13.2007', kecamatan:'12.06.13', name:'Kuta Male'})
    dataSet.push({ id:'12.07.20.2011', kecamatan:'12.07.20', name:'Kuta Mbelin'})
    dataSet.push({ id:'12.15.02.2003', kecamatan:'12.15.02', name:'Kuta Meriah'})
    dataSet.push({ id:'12.07.07.2004', kecamatan:'12.07.07', name:'Kuta Mulyo'})
    dataSet.push({ id:'12.05.06.2007', kecamatan:'12.05.06', name:'Kuta Parit'})
    dataSet.push({ id:'12.06.10.2006', kecamatan:'12.06.10', name:'Kuta Pengkih'})
    dataSet.push({ id:'12.18.16.2009', kecamatan:'12.18.16', name:'Kuta Pinang'})
    dataSet.push({ id:'12.06.08.2009', kecamatan:'12.06.08', name:'Kuta Raya'})
    dataSet.push({ id:'12.15.02.2002', kecamatan:'12.15.02', name:'Kuta Saga'})
    dataSet.push({ id:'12.06.06.2015', kecamatan:'12.06.06', name:'Kuta Suah'})
    dataSet.push({ id:'12.07.01.2007', kecamatan:'12.07.01', name:'Kuta Tengah'})
    dataSet.push({ id:'12.07.06.2019', kecamatan:'12.07.06', name:'Kuta Tengah'})
    dataSet.push({ id:'12.11.07.2002', kecamatan:'12.11.07', name:'Kuta Tengah'})
    dataSet.push({ id:'12.15.03.2013', kecamatan:'12.15.03', name:'Kuta Tinggi'})
    dataSet.push({ id:'12.06.16.2003', kecamatan:'12.06.16', name:'Kuta Tonggal'})
    dataSet.push({ id:'12.07.06.2028', kecamatan:'12.07.06', name:'Kuta Tualah'})
    dataSet.push({ id:'12.11.09.2009', kecamatan:'12.11.09', name:'Kuta Usang'})
    dataSet.push({ id:'12.06.04.2025', kecamatan:'12.06.04', name:'Kutabale'})
    dataSet.push({ id:'12.06.13.2013', kecamatan:'12.06.13', name:'Kutabuluh'})
    dataSet.push({ id:'12.06.13.2002', kecamatan:'12.06.13', name:'Kutabuluh Gugung'})
    dataSet.push({ id:'12.06.17.2003', kecamatan:'12.06.17', name:'Kutagaluh'})
    dataSet.push({ id:'12.06.07.2021', kecamatan:'12.06.07', name:'Kutagugung'})
    dataSet.push({ id:'12.06.16.2002', kecamatan:'12.06.16', name:'Kutagugung'})
    dataSet.push({ id:'12.06.04.2015', kecamatan:'12.06.04', name:'Kutajulu'})
    dataSet.push({ id:'12.06.04.2001', kecamatan:'12.06.04', name:'Kutakepar'})
    dataSet.push({ id:'12.06.17.2011', kecamatan:'12.06.17', name:'Kutakepar'})
    dataSet.push({ id:'12.07.04.2006', kecamatan:'12.07.04', name:'Kutalimbaru'})
    dataSet.push({ id:'12.05.22.2008', kecamatan:'12.05.22', name:'Kutambaru'})
    dataSet.push({ id:'12.06.06.2006', kecamatan:'12.06.06', name:'Kutambaru'})
    dataSet.push({ id:'12.06.17.2004', kecamatan:'12.06.17', name:'Kutambaru'})
    dataSet.push({ id:'12.06.08.2017', kecamatan:'12.06.08', name:'Kutambaru Punti'})
    dataSet.push({ id:'12.06.04.2024', kecamatan:'12.06.04', name:'Kutambelin'})
    dataSet.push({ id:'12.06.07.2014', kecamatan:'12.06.07', name:'Kutambelin'})
    dataSet.push({ id:'12.06.09.2008', kecamatan:'12.06.09', name:'Kutambelin'})
    dataSet.push({ id:'12.06.16.2011', kecamatan:'12.06.16', name:'Kutambelin'})
    dataSet.push({ id:'12.06.16.2007', kecamatan:'12.06.16', name:'Kutarayat'})
    dataSet.push({ id:'12.06.12.2005', kecamatan:'12.06.12', name:'Kutatengah'})
    dataSet.push({ id:'12.05.06.2012', kecamatan:'12.05.06', name:'Kwala Air Hitam'})
    dataSet.push({ id:'12.05.05.1001', kecamatan:'12.05.05', name:'Kwala Begumit'})
    dataSet.push({ id:'12.05.07.2002', kecamatan:'12.05.07', name:'Kwala Begumit'})
    dataSet.push({ id:'12.71.11.1006', kecamatan:'12.71.11', name:'Kwala Bekala'})
    dataSet.push({ id:'12.05.09.2014', kecamatan:'12.05.09', name:'Kwala Besar'})
    dataSet.push({ id:'12.05.12.2003', kecamatan:'12.05.12', name:'Kwala Besilam'})
    dataSet.push({ id:'12.05.07.1005', kecamatan:'12.05.07', name:'Kwala Bingai'})
    dataSet.push({ id:'12.05.13.2009', kecamatan:'12.05.13', name:'Kwala Gebang'})
    dataSet.push({ id:'12.19.10.2009', kecamatan:'12.19.10', name:'Kwala Gunung'})
    dataSet.push({ id:'12.05.11.2014', kecamatan:'12.05.11', name:'Kwala Langkat'})
    dataSet.push({ id:'12.07.04.2009', kecamatan:'12.07.04', name:'Kwala Lau Bicik'})
    dataSet.push({ id:'12.05.19.2006', kecamatan:'12.05.19', name:'Kwala Musam'})
    dataSet.push({ id:'12.05.11.2013', kecamatan:'12.05.11', name:'Kwala Serapuh'})
    dataSet.push({ id:'12.19.07.2001', kecamatan:'12.19.07', name:'Kwala Sikasim'})
    dataSet.push({ id:'12.07.06.2029', kecamatan:'12.07.06', name:'Kwala Simeme'})
    dataSet.push({ id:'12.24.03.2003', kecamatan:'12.24.03', name:'La Aya'})
    dataSet.push({ id:'12.04.35.2003', kecamatan:'12.04.35', name:'La Uri'})
    dataSet.push({ id:'12.14.16.2008', kecamatan:'12.14.16', name:'Labara'})
    dataSet.push({ id:'12.14.16.2003', kecamatan:'12.14.16', name:'Labuan Rima'})
    dataSet.push({ id:'12.14.16.2010', kecamatan:'12.14.16', name:'Labuan Rima Baru'})
    dataSet.push({ id:'12.14.16.2002', kecamatan:'12.14.16', name:'Labuhan Bazau'})
    dataSet.push({ id:'12.10.18.1001', kecamatan:'12.10.18', name:'Labuhan Bilik'})
    dataSet.push({ id:'12.71.12.1001', kecamatan:'12.71.12', name:'Labuhan Deli'})
    dataSet.push({ id:'12.14.16.2001', kecamatan:'12.14.16', name:'Labuhan Hiu'})
    dataSet.push({ id:'12.20.12.2004', kecamatan:'12.20.12', name:'Labuhan Jurung'})
    dataSet.push({ id:'12.77.05.2014', kecamatan:'12.77.05', name:'Labuhan Labo'})
    dataSet.push({ id:'12.77.05.2017', kecamatan:'12.77.05', name:'Labuhan Rasoki'})
    dataSet.push({ id:'12.19.05.1001', kecamatan:'12.19.05', name:'Labuhan Ruku'})
    dataSet.push({ id:'12.71.07.1007', kecamatan:'12.71.07', name:'Ladang Bambu'})
    dataSet.push({ id:'12.01.12.2010', kecamatan:'12.01.12', name:'Ladang Tengah'})
    dataSet.push({ id:'12.24.03.2005', kecamatan:'12.24.03', name:'Ladara'})
    dataSet.push({ id:'12.04.06.2024', kecamatan:'12.04.06', name:'Ladea'})
    dataSet.push({ id:'12.04.06.2051', kecamatan:'12.04.06', name:'Ladea Orahua'})
    dataSet.push({ id:'12.11.05.2022', kecamatan:'12.11.05', name:'Lae Ambat'})
    dataSet.push({ id:'12.11.08.2010', kecamatan:'12.11.08', name:'Lae Haporas'})
    dataSet.push({ id:'12.11.10.2002', kecamatan:'12.11.10', name:'Lae Hole'})
    dataSet.push({ id:'12.11.10.2009', kecamatan:'12.11.10', name:'Lae Hole I'})
    dataSet.push({ id:'12.11.10.2010', kecamatan:'12.11.10', name:'Lae Hole Ii'})
    dataSet.push({ id:'12.11.08.2001', kecamatan:'12.11.08', name:'Lae Itam'})
    dataSet.push({ id:'12.15.04.2004', kecamatan:'12.15.04', name:'Lae Langge Namuseng'})
    dataSet.push({ id:'12.11.08.2002', kecamatan:'12.11.08', name:'Lae Luhung'})
    dataSet.push({ id:'12.11.08.2004', kecamatan:'12.11.08', name:'Lae Markelang'})
    dataSet.push({ id:'12.15.06.2003', kecamatan:'12.15.06', name:'Lae Mbentar'})
    dataSet.push({ id:'12.01.05.2009', kecamatan:'12.01.05', name:'Lae Monong'})
    dataSet.push({ id:'12.11.07.2003', kecamatan:'12.11.07', name:'Lae Nuaha'})
    dataSet.push({ id:'12.11.05.2024', kecamatan:'12.11.05', name:'Lae Pangaroan'})
    dataSet.push({ id:'12.11.05.2021', kecamatan:'12.11.05', name:'Lae Panginuman'})
    dataSet.push({ id:'12.11.11.2003', kecamatan:'12.11.11', name:'Lae Parira'})
    dataSet.push({ id:'12.11.05.2023', kecamatan:'12.11.05', name:'Lae Rambong'})
    dataSet.push({ id:'12.11.08.2009', kecamatan:'12.11.08', name:'Lae Sering'})
    dataSet.push({ id:'12.24.06.2004', kecamatan:'12.24.06', name:'Laehuwa'})
    dataSet.push({ id:'12.04.11.2021', kecamatan:'12.04.11', name:'Lagasimahe'})
    dataSet.push({ id:'12.14.32.2003', kecamatan:'12.14.32', name:'Lagundri'})
    dataSet.push({ id:'12.25.06.2011', kecamatan:'12.25.06', name:'Lahagu'})
    dataSet.push({ id:'12.25.02.2009', kecamatan:'12.25.02', name:'Lahawa'})
    dataSet.push({ id:'12.24.07.2002', kecamatan:'12.24.07', name:'Lahemboho'})
    dataSet.push({ id:'12.04.06.2023', kecamatan:'12.04.06', name:'Lahemo'})
    dataSet.push({ id:'12.14.03.2009', kecamatan:'12.14.03', name:'Lahusa'})
    dataSet.push({ id:'12.25.02.2014', kecamatan:'12.25.02', name:'Lahusa'})
    dataSet.push({ id:'12.14.18.2008', kecamatan:'12.14.18', name:'Lahusa Fau'})
    dataSet.push({ id:'12.14.03.2040', kecamatan:'12.14.03', name:'Lahusa I'})
    dataSet.push({ id:'12.14.35.2001', kecamatan:'12.14.35', name:'Lahusa Idanotae'})
    dataSet.push({ id:'12.14.24.2005', kecamatan:'12.14.24', name:'Lahusa Susua'})
    dataSet.push({ id:'12.04.10.2029', kecamatan:'12.04.10', name:'Laira'})
    dataSet.push({ id:'12.25.05.2006', kecamatan:'12.25.05', name:'Lakhene'})
    dataSet.push({ id:'12.11.09.2005', kecamatan:'12.11.09', name:'Laksa'})
    dataSet.push({ id:'12.04.20.2005', kecamatan:'12.04.20', name:'Lalai I/Ii'})
    dataSet.push({ id:'12.05.11.2004', kecamatan:'12.05.11', name:'Lalang'})
    dataSet.push({ id:'12.07.23.2002', kecamatan:'12.07.23', name:'Lalang'})
    dataSet.push({ id:'12.19.01.2005', kecamatan:'12.19.01', name:'Lalang'})
    dataSet.push({ id:'12.71.02.1001', kecamatan:'12.71.02', name:'Lalang'})
    dataSet.push({ id:'12.76.02.1009', kecamatan:'12.76.02', name:'Lalang'})
    dataSet.push({ id:'12.14.20.2007', kecamatan:'12.14.20', name:'Lalimanawa'})
    dataSet.push({ id:'12.05.17.2005', kecamatan:'12.05.17', name:'Lama'})
    dataSet.push({ id:'12.07.05.2014', kecamatan:'12.07.05', name:'Lama'})
    dataSet.push({ id:'12.07.24.2019', kecamatan:'12.07.24', name:'Lama'})
    dataSet.push({ id:'12.05.17.2007', kecamatan:'12.05.17', name:'Lama Baru'})
    dataSet.push({ id:'12.14.16.2004', kecamatan:'12.14.16', name:'Lambak'})
    dataSet.push({ id:'12.06.04.2030', kecamatan:'12.06.04', name:'Lambar'})
    dataSet.push({ id:'12.13.07.2013', kecamatan:'12.13.07', name:'Lambou Darul Ihsan'})
    dataSet.push({ id:'12.03.14.1040', kecamatan:'12.03.14', name:'Lancat'})
    dataSet.push({ id:'12.13.14.2006', kecamatan:'12.13.14', name:'Lancat'})
    dataSet.push({ id:'12.08.23.2016', kecamatan:'12.08.23', name:'Landbouw'})
    dataSet.push({ id:'12.07.02.2009', kecamatan:'12.07.02', name:'Langau Seprang'})
    dataSet.push({ id:'12.22.04.1001', kecamatan:'12.22.04', name:'Langga Payung'})
    dataSet.push({ id:'12.20.08.2023', kecamatan:'12.20.08', name:'Langkimat'})
    dataSet.push({ id:'12.07.21.2001', kecamatan:'12.07.21', name:'Lantasan Baru'})
    dataSet.push({ id:'12.07.21.2004', kecamatan:'12.07.21', name:'Lantasan Lama'})
    dataSet.push({ id:'12.20.06.2003', kecamatan:'12.20.06', name:'Lantosan I'})
    dataSet.push({ id:'12.20.05.2015', kecamatan:'12.20.05', name:'Lantosan Ii'})
    dataSet.push({ id:'12.03.03.2069', kecamatan:'12.03.03', name:'Lantosan Rogas'})
    dataSet.push({ id:'12.04.10.2007', kecamatan:'12.04.10', name:'Laowo Hilimbaruzo'})
    dataSet.push({ id:'12.24.11.2001', kecamatan:'12.24.11', name:'Laowowaga'})
    dataSet.push({ id:'12.08.22.2005', kecamatan:'12.08.22', name:'Laras'})
    dataSet.push({ id:'12.08.01.2012', kecamatan:'12.08.01', name:'Laras Dua'})
    dataSet.push({ id:'12.13.10.2007', kecamatan:'12.13.10', name:'Laru Baringin'})
    dataSet.push({ id:'12.13.10.2008', kecamatan:'12.13.10', name:'Laru Bolak'})
    dataSet.push({ id:'12.13.10.2009', kecamatan:'12.13.10', name:'Laru Dolok'})
    dataSet.push({ id:'12.13.10.1010', kecamatan:'12.13.10', name:'Laru Lombang'})
    dataSet.push({ id:'12.24.05.2007', kecamatan:'12.24.05', name:'Lasara'})
    dataSet.push({ id:'12.24.10.2018', kecamatan:'12.24.10', name:'Lasara'})
    dataSet.push({ id:'12.25.05.2014', kecamatan:'12.25.05', name:'Lasara Baene'})
    dataSet.push({ id:'12.25.03.2009', kecamatan:'12.25.03', name:'Lasara Bagawu'})
    dataSet.push({ id:'12.25.04.2007', kecamatan:'12.25.04', name:'Lasara Bahili'})
    dataSet.push({ id:'12.78.01.2010', kecamatan:'12.78.01', name:'Lasara Bahili'})
    dataSet.push({ id:'12.04.21.2002', kecamatan:'12.04.21', name:'Lasara Botomuzoi'})
    dataSet.push({ id:'12.24.02.2007', kecamatan:'12.24.02', name:'Lasara Sawo'})
    dataSet.push({ id:'12.04.28.2005', kecamatan:'12.04.28', name:'Lasara Siwalu Banua'})
    dataSet.push({ id:'12.78.03.2003', kecamatan:'12.78.03', name:'Lasara Sowu'})
    dataSet.push({ id:'12.04.05.2028', kecamatan:'12.04.05', name:'Lasara Tanose O'})
    dataSet.push({ id:'12.25.03.2013', kecamatan:'12.25.03', name:'Lasarafaga'})
    dataSet.push({ id:'12.04.06.2050', kecamatan:'12.04.06', name:'Lasela'})
    dataSet.push({ id:'12.14.05.2029', kecamatan:'12.14.05', name:'Lasonde'})
    dataSet.push({ id:'12.11.03.2007', kecamatan:'12.11.03', name:'Lau Bagot'})
    dataSet.push({ id:'12.07.04.2010', kecamatan:'12.07.04', name:'Lau Bakeni'})
    dataSet.push({ id:'12.06.09.2005', kecamatan:'12.06.09', name:'Lau Baleng'})
    dataSet.push({ id:'12.07.08.2007', kecamatan:'12.07.08', name:'Lau Barus Baru'})
    dataSet.push({ id:'12.06.13.2004', kecamatan:'12.06.13', name:'Lau Buluh'})
    dataSet.push({ id:'12.06.01.1010', kecamatan:'12.06.01', name:'Lau Cimba'})
    dataSet.push({ id:'12.05.01.2002', kecamatan:'12.05.01', name:'Lau Damak'})
    dataSet.push({ id:'12.06.10.2011', kecamatan:'12.06.10', name:'Lau Garut'})
    dataSet.push({ id:'12.06.02.2010', kecamatan:'12.06.02', name:'Lau Gumba'})
    dataSet.push({ id:'12.06.08.2007', kecamatan:'12.06.08', name:'Lau Kapur'})
    dataSet.push({ id:'12.06.10.2003', kecamatan:'12.06.10', name:'Lau Kesumpat'})
    dataSet.push({ id:'12.06.07.2023', kecamatan:'12.06.07', name:'Lau Kidupen'})
    dataSet.push({ id:'12.11.12.2007', kecamatan:'12.11.12', name:'Lau Lebah'})
    dataSet.push({ id:'12.06.07.2002', kecamatan:'12.06.07', name:'Lau Lingga'})
    dataSet.push({ id:'12.05.02.2025', kecamatan:'12.05.02', name:'Lau Lugur'})
    dataSet.push({ id:'12.11.03.2013', kecamatan:'12.11.03', name:'Lau Mil'})
    dataSet.push({ id:'12.11.03.2009', kecamatan:'12.11.03', name:'Lau Molgap'})
    dataSet.push({ id:'12.07.06.2031', kecamatan:'12.07.06', name:'Lau Mulgab'})
    dataSet.push({ id:'12.05.06.2006', kecamatan:'12.05.06', name:'Lau Mulgap'})
    dataSet.push({ id:'12.06.10.2002', kecamatan:'12.06.10', name:'Lau Mulgap'})
    dataSet.push({ id:'12.11.06.2017', kecamatan:'12.11.06', name:'Lau Njuhar I'})
    dataSet.push({ id:'12.11.03.2010', kecamatan:'12.11.03', name:'Lau Pak-Pak'})
    dataSet.push({ id:'12.06.10.2009', kecamatan:'12.06.10', name:'Lau Pakam'})
    dataSet.push({ id:'12.06.10.2001', kecamatan:'12.06.10', name:'Lau Pengulu'})
    dataSet.push({ id:'12.06.09.2012', kecamatan:'12.06.09', name:'Lau Peradep'})
    dataSet.push({ id:'12.06.09.2003', kecamatan:'12.06.09', name:'Lau Peranggunen'})
    dataSet.push({ id:'12.11.06.2004', kecamatan:'12.11.06', name:'Lau Primbon'})
    dataSet.push({ id:'12.07.08.2012', kecamatan:'12.07.08', name:'Lau Rakit'})
    dataSet.push({ id:'12.07.08.2015', kecamatan:'12.07.08', name:'Lau Rempak'})
    dataSet.push({ id:'12.06.01.2005', kecamatan:'12.06.01', name:'Lau Simomo'})
    dataSet.push({ id:'12.11.03.2014', kecamatan:'12.11.03', name:'Lau Sireme'})
    dataSet.push({ id:'12.06.10.2010', kecamatan:'12.06.10', name:'Lau Solu'})
    dataSet.push({ id:'12.11.06.2012', kecamatan:'12.11.06', name:'Lau Tawar'})
    dataSet.push({ id:'12.05.02.2020', kecamatan:'12.05.02', name:'Lau Tepu'})
    dataSet.push({ id:'12.71.07.1005', kecamatan:'12.71.07', name:'Laucih'})
    dataSet.push({ id:'12.06.04.2018', kecamatan:'12.06.04', name:'Lauriman'})
    dataSet.push({ id:'12.24.09.2002', kecamatan:'12.24.09', name:'Lauru Fadoro'})
    dataSet.push({ id:'12.24.09.2003', kecamatan:'12.24.09', name:'Lauru I'})
    dataSet.push({ id:'12.24.09.2007', kecamatan:'12.24.09', name:'Lauru Lahewa'})
    dataSet.push({ id:'12.14.22.2003', kecamatan:'12.14.22', name:'Lauso'})
    dataSet.push({ id:'12.07.26.2005', kecamatan:'12.07.26', name:'Laut Dendang'})
    dataSet.push({ id:'12.18.16.2002', kecamatan:'12.18.16', name:'Laut Tador'})
    dataSet.push({ id:'12.19.08.2002', kecamatan:'12.19.08', name:'Laut Tador'})
    dataSet.push({ id:'12.04.20.2004', kecamatan:'12.04.20', name:'Lawa-Lawa'})
    dataSet.push({ id:'12.14.01.2008', kecamatan:'12.14.01', name:'Lawa-Lawa Luo'})
    dataSet.push({ id:'12.14.02.2015', kecamatan:'12.14.02', name:'Lawa-Lawa Luo Gomo'})
    dataSet.push({ id:'12.14.34.2003', kecamatan:'12.14.34', name:'Lawa-Lawa Luo Idanotae'})
    dataSet.push({ id:'12.04.27.2003', kecamatan:'12.04.27', name:'Lawalawa Luo'})
    dataSet.push({ id:'12.25.08.2002', kecamatan:'12.25.08', name:'Lawelu'})
    dataSet.push({ id:'12.14.13.2003', kecamatan:'12.14.13', name:'Lawindra'})
    dataSet.push({ id:'12.14.14.2001', kecamatan:'12.14.14', name:'Lawindra'})
    dataSet.push({ id:'12.24.01.2004', kecamatan:'12.24.01', name:'Lawira I'})
    dataSet.push({ id:'12.24.01.2010', kecamatan:'12.24.01', name:'Lawira Ii'})
    dataSet.push({ id:'12.24.01.2002', kecamatan:'12.24.01', name:'Lawira Satua'})
    dataSet.push({ id:'12.04.06.2030', kecamatan:'12.04.06', name:'Lazara Idanoi'})
    dataSet.push({ id:'12.09.32.2004', kecamatan:'12.09.32', name:'Ledong Barat'})
    dataSet.push({ id:'12.09.32.2006', kecamatan:'12.09.32', name:'Ledong Timur'})
    dataSet.push({ id:'12.77.04.1004', kecamatan:'12.77.04', name:'Lembah Lubuk Manik'})
    dataSet.push({ id:'12.03.01.2024', kecamatan:'12.03.01', name:'Lembah Lubuk Raya'})
    dataSet.push({ id:'12.06.04.2026', kecamatan:'12.06.04', name:'Leparsamura'})
    dataSet.push({ id:'12.09.16.2003', kecamatan:'12.09.16', name:'Lestari'})
    dataSet.push({ id:'12.09.20.1007', kecamatan:'12.09.20', name:'Lestari'})
    dataSet.push({ id:'12.18.14.2005', kecamatan:'12.18.14', name:'Lestari Dadi'})
    dataSet.push({ id:'12.08.01.2011', kecamatan:'12.08.01', name:'Lestari Indah'})
    dataSet.push({ id:'12.14.27.2009', kecamatan:'12.14.27', name:'Lewa-Lewa'})
    dataSet.push({ id:'12.04.28.2008', kecamatan:'12.04.28', name:'Lewa Lewa'})
    dataSet.push({ id:'12.04.29.2006', kecamatan:'12.04.29', name:'Lewuoguru I'})
    dataSet.push({ id:'12.78.04.2019', kecamatan:'12.78.04', name:'Lewuoguru Idanoi'})
    dataSet.push({ id:'12.04.28.2002', kecamatan:'12.04.28', name:'Lewuoguru Ii'})
    dataSet.push({ id:'12.04.29.2008', kecamatan:'12.04.29', name:'Lewuombanua'})
    dataSet.push({ id:'12.20.04.2057', kecamatan:'12.20.04', name:'Liang Hasona'})
    dataSet.push({ id:'12.11.06.2015', kecamatan:'12.11.06', name:'Liang Jering'})
    dataSet.push({ id:'12.06.13.2014', kecamatan:'12.06.13', name:'Liang Merdeka'})
    dataSet.push({ id:'12.07.20.2004', kecamatan:'12.07.20', name:'Liang Muda'})
    dataSet.push({ id:'12.07.20.2014', kecamatan:'12.07.20', name:'Liang Pematang'})
    dataSet.push({ id:'12.08.24.2002', kecamatan:'12.08.24', name:'Lias Baru'})
    dataSet.push({ id:'12.12.21.2006', kecamatan:'12.12.21', name:'Liat Tondung'})
    dataSet.push({ id:'12.18.03.2002', kecamatan:'12.18.03', name:'Liberia'})
    dataSet.push({ id:'12.18.02.2015', kecamatan:'12.18.02', name:'Lidah Tanah'})
    dataSet.push({ id:'12.19.12.2004', kecamatan:'12.19.12', name:'Lima Laras'})
    dataSet.push({ id:'12.19.04.1001', kecamatan:'12.19.04', name:'Lima Puluh Kota'})
    dataSet.push({ id:'12.08.29.2021', kecamatan:'12.08.29', name:'Limag Raya'})
    dataSet.push({ id:'12.06.08.2005', kecamatan:'12.06.08', name:'Limang'})
    dataSet.push({ id:'12.07.02.2003', kecamatan:'12.07.02', name:'Limau Manis'})
    dataSet.push({ id:'12.13.12.2009', kecamatan:'12.13.12', name:'Limau Manis'})
    dataSet.push({ id:'12.05.23.2005', kecamatan:'12.05.23', name:'Limau Mungkur'})
    dataSet.push({ id:'12.07.08.2005', kecamatan:'12.07.08', name:'Limau Mungkur'})
    dataSet.push({ id:'12.75.03.1002', kecamatan:'12.75.03', name:'Limau Mungkur'})
    dataSet.push({ id:'12.19.03.2002', kecamatan:'12.19.03', name:'Limau Sundai'})
    dataSet.push({ id:'12.75.03.1003', kecamatan:'12.75.03', name:'Limau Sundai'})
    dataSet.push({ id:'12.18.07.2005', kecamatan:'12.18.07', name:'Limbong'})
    dataSet.push({ id:'12.21.07.2014', kecamatan:'12.21.07', name:'Limbong'})
    dataSet.push({ id:'12.14.30.2004', kecamatan:'12.14.30', name:'Limo Biang'})
    dataSet.push({ id:'12.06.12.2018', kecamatan:'12.06.12', name:'Lingga'})
    dataSet.push({ id:'12.08.02.2016', kecamatan:'12.08.02', name:'Lingga'})
    dataSet.push({ id:'12.06.09.2009', kecamatan:'12.06.09', name:'Lingga Muda'})
    dataSet.push({ id:'12.11.09.2004', kecamatan:'12.11.09', name:'Lingga Raja'})
    dataSet.push({ id:'12.11.09.2010', kecamatan:'12.11.09', name:'Lingga Raja Ii'})
    dataSet.push({ id:'12.10.09.2001', kecamatan:'12.10.09', name:'Lingga Tiga'})
    dataSet.push({ id:'12.06.12.2016', kecamatan:'12.06.12', name:'Linggajulu'})
    dataSet.push({ id:'12.12.06.2004', kecamatan:'12.12.06', name:'Lintong'})
    dataSet.push({ id:'12.12.09.2002', kecamatan:'12.12.09', name:'Lintong Julu'})
    dataSet.push({ id:'12.12.22.2001', kecamatan:'12.12.22', name:'Lintong Nihuta'})
    dataSet.push({ id:'12.17.07.2002', kecamatan:'12.17.07', name:'Lintong Nihuta'})
    dataSet.push({ id:'12.14.05.2005', kecamatan:'12.14.05', name:'Loboi'})
    dataSet.push({ id:'12.02.02.2012', kecamatan:'12.02.02', name:'Lobu Hole'})
    dataSet.push({ id:'12.12.04.2017', kecamatan:'12.12.04', name:'Lobu Hole'})
    dataSet.push({ id:'12.23.08.2004', kecamatan:'12.23.08', name:'Lobu Huala'})
    dataSet.push({ id:'12.09.18.2010', kecamatan:'12.09.18', name:'Lobu Jiur'})
    dataSet.push({ id:'12.03.01.2031', kecamatan:'12.03.01', name:'Lobu Layan Sigordang'})
    dataSet.push({ id:'12.02.05.2015', kecamatan:'12.02.05', name:'Lobu Pining'})
    dataSet.push({ id:'12.23.05.2015', kecamatan:'12.23.05', name:'Lobu Rampah'})
    dataSet.push({ id:'12.09.21.2006', kecamatan:'12.09.21', name:'Lobu Rappa'})
    dataSet.push({ id:'12.02.07.2007', kecamatan:'12.02.07', name:'Lobu Sihim'})
    dataSet.push({ id:'12.02.04.2009', kecamatan:'12.02.04', name:'Lobu Singkam'})
    dataSet.push({ id:'12.02.09.2009', kecamatan:'12.02.09', name:'Lobu Siregar I'})
    dataSet.push({ id:'12.02.09.2010', kecamatan:'12.02.09', name:'Lobu Siregar Ii'})
    dataSet.push({ id:'12.03.22.2017', kecamatan:'12.03.22', name:'Lobu Tayas'})
    dataSet.push({ id:'12.01.12.2011', kecamatan:'12.01.12', name:'Lobu Tua'})
    dataSet.push({ id:'12.13.14.2011', kecamatan:'12.13.14', name:'Lobung'})
    dataSet.push({ id:'12.10.02.1006', kecamatan:'12.10.02', name:'Lobusona'})
    dataSet.push({ id:'12.02.11.2007', kecamatan:'12.02.11', name:'Lobusunut'})
    dataSet.push({ id:'12.16.04.2006', kecamatan:'12.16.04', name:'Lobutolong'})
    dataSet.push({ id:'12.16.04.2011', kecamatan:'12.16.04', name:'Lobutolong Habinsaran'})
    dataSet.push({ id:'12.16.05.2006', kecamatan:'12.16.05', name:'Lobutua'})
    dataSet.push({ id:'12.08.29.2022', kecamatan:'12.08.29', name:'Lokkung Raya'})
    dataSet.push({ id:'12.78.04.2015', kecamatan:'12.78.04', name:'Lolo Ana A Idanoi'})
    dataSet.push({ id:'12.78.03.2002', kecamatan:'12.78.03', name:'Lolo Ana A Lolomoyo'})
    dataSet.push({ id:'12.14.07.2023', kecamatan:'12.14.07', name:'Loloabolo'})
    dataSet.push({ id:'12.04.21.2011', kecamatan:'12.04.21', name:'Loloana A'})
    dataSet.push({ id:'12.14.19.2009', kecamatan:'12.14.19', name:'Loloana A'})
    dataSet.push({ id:'12.24.07.2013', kecamatan:'12.24.07', name:'Loloana A'})
    dataSet.push({ id:'12.04.06.2020', kecamatan:'12.04.06', name:'Loloana A Gido'})
    dataSet.push({ id:'12.04.20.2015', kecamatan:'12.04.20', name:'Lolofaoso'})
    dataSet.push({ id:'12.14.08.2014', kecamatan:'12.14.08', name:'Lolofaoso'})
    dataSet.push({ id:'12.24.01.2009', kecamatan:'12.24.01', name:'Lolofaoso'})
    dataSet.push({ id:'12.04.20.2002', kecamatan:'12.04.20', name:'Lolofaoso Lalai'})
    dataSet.push({ id:'12.78.02.2004', kecamatan:'12.78.02', name:'Lolofaoso Tabaloho'})
    dataSet.push({ id:'12.25.07.2006', kecamatan:'12.25.07', name:'Lolofitu'})
    dataSet.push({ id:'12.25.05.2002', kecamatan:'12.25.05', name:'Lologolu'})
    dataSet.push({ id:'12.25.01.2004', kecamatan:'12.25.01', name:'Lologundre'})
    dataSet.push({ id:'12.25.03.2005', kecamatan:'12.25.03', name:'Lolohia'})
    dataSet.push({ id:'12.14.08.2017', kecamatan:'12.14.08', name:'Lolohowa'})
    dataSet.push({ id:'12.78.02.2008', kecamatan:'12.78.02', name:'Lololakha'})
    dataSet.push({ id:'12.78.05.2008', kecamatan:'12.78.05', name:'Lololawa'})
    dataSet.push({ id:'12.14.21.2007', kecamatan:'12.14.21', name:'Lolomaya'})
    dataSet.push({ id:'12.14.13.2010', kecamatan:'12.14.13', name:'Lolomboli'})
    dataSet.push({ id:'12.24.01.2012', kecamatan:'12.24.01', name:'Lolomboli'})
    dataSet.push({ id:'12.25.06.2005', kecamatan:'12.25.06', name:'Lolomboli'})
    dataSet.push({ id:'12.78.02.2005', kecamatan:'12.78.02', name:'Lolomboli'})
    dataSet.push({ id:'12.14.07.2013', kecamatan:'12.14.07', name:'Lolomoyo'})
    dataSet.push({ id:'12.14.08.2015', kecamatan:'12.14.08', name:'Lolomoyo'})
    dataSet.push({ id:'12.78.06.2005', kecamatan:'12.78.06', name:'Lolomoyo Tuhemberua'})
    dataSet.push({ id:'12.14.02.2017', kecamatan:'12.14.02', name:'Lolosoni'})
    dataSet.push({ id:'12.14.08.2016', kecamatan:'12.14.08', name:'Lolowau'})
    dataSet.push({ id:'12.25.01.2011', kecamatan:'12.25.01', name:'Lolowau'})
    dataSet.push({ id:'12.78.01.2011', kecamatan:'12.78.01', name:'Lolowonu Niko Otano'})
    dataSet.push({ id:'12.04.20.2006', kecamatan:'12.04.20', name:'Lolowua'})
    dataSet.push({ id:'12.04.20.2009', kecamatan:'12.04.20', name:'Lolowua Hiliwarasi'})
    dataSet.push({ id:'12.14.07.2012', kecamatan:'12.14.07', name:'Lolozaria'})
    dataSet.push({ id:'12.04.06.2029', kecamatan:'12.04.06', name:'Lolozasai'})
    dataSet.push({ id:'12.25.05.2005', kecamatan:'12.25.05', name:'Lolozirugi'})
    dataSet.push({ id:'12.14.34.2009', kecamatan:'12.14.34', name:'Lolozukhu'})
    dataSet.push({ id:'12.24.01.2006', kecamatan:'12.24.01', name:'Lombuza Ua'})
    dataSet.push({ id:'12.23.01.2006', kecamatan:'12.23.01', name:'Londut'})
    dataSet.push({ id:'12.12.01.2022', kecamatan:'12.12.01', name:'Longat'})
    dataSet.push({ id:'12.13.05.1006', kecamatan:'12.13.05', name:'Longat'})
    dataSet.push({ id:'12.11.05.2010', kecamatan:'12.11.05', name:'Longkotan'})
    dataSet.push({ id:'12.02.05.2013', kecamatan:'12.02.05', name:'Lontung Dolok'})
    dataSet.push({ id:'12.02.14.2002', kecamatan:'12.02.14', name:'Lontung Jae I'})
    dataSet.push({ id:'12.02.14.2008', kecamatan:'12.02.14', name:'Lontung Jae Ii'})
    dataSet.push({ id:'12.01.15.1002', kecamatan:'12.01.15', name:'Lopian'})
    dataSet.push({ id:'12.77.02.1003', kecamatan:'12.77.02', name:'Losung'})
    dataSet.push({ id:'12.20.04.2026', kecamatan:'12.20.04', name:'Losung Batu'})
    dataSet.push({ id:'12.77.01.1012', kecamatan:'12.77.01', name:'Losung Batu'})
    dataSet.push({ id:'12.14.29.2002', kecamatan:'12.14.29', name:'Luaha Idano Pono'})
    dataSet.push({ id:'12.78.02.2012', kecamatan:'12.78.02', name:'Luahalaraga'})
    dataSet.push({ id:'12.14.20.2014', kecamatan:'12.14.20', name:'Luahamofakhe'})
    dataSet.push({ id:'12.14.17.2003', kecamatan:'12.14.17', name:'Luahandroito'})
    dataSet.push({ id:'12.03.04.2112', kecamatan:'12.03.04', name:'Luat Lombang'})
    dataSet.push({ id:'12.07.06.2006', kecamatan:'12.07.06', name:'Lubang Ido'})
    dataSet.push({ id:'12.02.10.2006', kecamatan:'12.02.10', name:'Lubis'})
    dataSet.push({ id:'12.01.15.2007', kecamatan:'12.01.15', name:'Lubuk Ampolu'})
    dataSet.push({ id:'12.76.01.1002', kecamatan:'12.76.01', name:'Lubuk Baru'})
    dataSet.push({ id:'12.18.02.2016', kecamatan:'12.18.02', name:'Lubuk Bayas'})
    dataSet.push({ id:'12.19.10.2005', kecamatan:'12.19.10', name:'Lubuk Besar'})
    dataSet.push({ id:'12.13.13.2030', kecamatan:'12.13.13', name:'Lubuk Bondar Panjang'})
    dataSet.push({ id:'12.21.05.2004', kecamatan:'12.21.05', name:'Lubuk Bunut'})
    dataSet.push({ id:'12.18.02.2017', kecamatan:'12.18.02', name:'Lubuk Cemara'})
    dataSet.push({ id:'12.19.09.2011', kecamatan:'12.19.09', name:'Lubuk Cuik'})
    dataSet.push({ id:'12.18.02.2018', kecamatan:'12.18.02', name:'Lubuk Dendang'})
    dataSet.push({ id:'12.20.02.2023', kecamatan:'12.20.02', name:'Lubuk Godang'})
    dataSet.push({ id:'12.21.12.2001', kecamatan:'12.21.12', name:'Lubuk Gonting'})
    dataSet.push({ id:'12.19.10.2004', kecamatan:'12.19.10', name:'Lubuk Hulu'})
    dataSet.push({ id:'12.13.18.2015', kecamatan:'12.13.18', name:'Lubuk Kancah'})
    dataSet.push({ id:'12.13.17.2003', kecamatan:'12.13.17', name:'Lubuk Kapundung'})
    dataSet.push({ id:'12.13.17.2013', kecamatan:'12.13.17', name:'Lubuk Kapundung Ii'})
    dataSet.push({ id:'12.05.18.2003', kecamatan:'12.05.18', name:'Lubuk Kasih'})
    dataSet.push({ id:'12.05.18.2005', kecamatan:'12.05.18', name:'Lubuk Kertang'})
    dataSet.push({ id:'12.20.02.2034', kecamatan:'12.20.02', name:'Lubuk Kundur'})
    dataSet.push({ id:'12.20.02.2046', kecamatan:'12.20.02', name:'Lubuk Lanjang'})
    dataSet.push({ id:'12.07.28.1007', kecamatan:'12.07.28', name:'Lubuk Pakam I,Ii'})
    dataSet.push({ id:'12.07.28.1008', kecamatan:'12.07.28', name:'Lubuk Pakam Iii'})
    dataSet.push({ id:'12.07.28.1013', kecamatan:'12.07.28', name:'Lubuk Pakam Pekan'})
    dataSet.push({ id:'12.09.28.2004', kecamatan:'12.09.28', name:'Lubuk Palas'})
    dataSet.push({ id:'12.76.01.1012', kecamatan:'12.76.01', name:'Lubuk Raya'})
    dataSet.push({ id:'12.77.04.1002', kecamatan:'12.77.04', name:'Lubuk Raya'})
    dataSet.push({ id:'12.18.02.2019', kecamatan:'12.18.02', name:'Lubuk Rotan'})
    dataSet.push({ id:'12.18.01.2011', kecamatan:'12.18.01', name:'Lubuk Saban'})
    dataSet.push({ id:'12.13.13.2026', kecamatan:'12.13.13', name:'Lubuk Samboa'})
    dataSet.push({ id:'12.20.04.2008', kecamatan:'12.20.04', name:'Lubuk Torop'})
    dataSet.push({ id:'12.01.03.1004', kecamatan:'12.01.03', name:'Lubuk Tukko'})
    dataSet.push({ id:'12.01.03.1017', kecamatan:'12.01.03', name:'Lubuk Tukko Baru'})
    dataSet.push({ id:'12.24.11.2002', kecamatan:'12.24.11', name:'Lukhu Lase'})
    dataSet.push({ id:'12.12.02.2020', kecamatan:'12.12.02', name:'Lumban Bagasan'})
    dataSet.push({ id:'12.12.04.2006', kecamatan:'12.12.04', name:'Lumban Balik'})
    dataSet.push({ id:'12.16.04.2007', kecamatan:'12.16.04', name:'Lumban Barat'})
    dataSet.push({ id:'12.12.02.2015', kecamatan:'12.12.02', name:'Lumban Binanga'})
    dataSet.push({ id:'12.12.10.2003', kecamatan:'12.12.10', name:'Lumban Binanga'})
    dataSet.push({ id:'12.12.01.2015', kecamatan:'12.12.01', name:'Lumban Bulbul'})
    dataSet.push({ id:'12.02.05.2009', kecamatan:'12.02.05', name:'Lumban Dolok'})
    dataSet.push({ id:'12.12.03.2022', kecamatan:'12.12.03', name:'Lumban Dolok'})
    dataSet.push({ id:'12.13.04.2006', kecamatan:'12.13.04', name:'Lumban Dolok'})
    dataSet.push({ id:'12.13.06.2010', kecamatan:'12.13.06', name:'Lumban Dolok'})
    dataSet.push({ id:'12.12.01.1038', kecamatan:'12.12.01', name:'Lumban Dolok Hauma Bange'})
    dataSet.push({ id:'12.02.05.2017', kecamatan:'12.02.05', name:'Lumban Gaol'})
    dataSet.push({ id:'12.12.01.2010', kecamatan:'12.12.01', name:'Lumban Gaol'})
    dataSet.push({ id:'12.12.04.2019', kecamatan:'12.12.04', name:'Lumban Gaol'})
    dataSet.push({ id:'12.02.05.2006', kecamatan:'12.02.05', name:'Lumban Garaga'})
    dataSet.push({ id:'12.08.13.2014', kecamatan:'12.08.13', name:'Lumban Gorat'})
    dataSet.push({ id:'12.12.01.2025', kecamatan:'12.12.01', name:'Lumban Gorat'})
    dataSet.push({ id:'12.12.07.2003', kecamatan:'12.12.07', name:'Lumban Gurning'})
    dataSet.push({ id:'12.12.10.2014', kecamatan:'12.12.10', name:'Lumban Holbung'})
    dataSet.push({ id:'12.12.24.2008', kecamatan:'12.12.24', name:'Lumban Huala'})
    dataSet.push({ id:'12.03.21.2059', kecamatan:'12.03.21', name:'Lumban Huayan'})
    dataSet.push({ id:'12.21.08.2032', kecamatan:'12.21.08', name:'Lumban Huayan'})
    dataSet.push({ id:'12.02.10.2010', kecamatan:'12.02.10', name:'Lumban Ina Ina'})
    dataSet.push({ id:'12.03.30.2008', kecamatan:'12.03.30', name:'Lumban Jabi-Jabi'})
    dataSet.push({ id:'12.02.05.2011', kecamatan:'12.02.05', name:'Lumban Jaean'})
    dataSet.push({ id:'12.02.10.2002', kecamatan:'12.02.10', name:'Lumban Julu'})
    dataSet.push({ id:'12.12.04.2025', kecamatan:'12.12.04', name:'Lumban Lintong'})
    dataSet.push({ id:'12.12.23.2003', kecamatan:'12.12.23', name:'Lumban Lobu'})
    dataSet.push({ id:'12.12.24.2011', kecamatan:'12.12.24', name:'Lumban Manurung'})
    dataSet.push({ id:'12.02.10.2009', kecamatan:'12.02.10', name:'Lumban Motung'})
    dataSet.push({ id:'12.12.10.2017', kecamatan:'12.12.10', name:'Lumban Nabolon'})
    dataSet.push({ id:'12.13.01.2015', kecamatan:'12.13.01', name:'Lumban Pasir'})
    dataSet.push({ id:'12.13.10.2011', kecamatan:'12.13.10', name:'Lumban Pasir'})
    dataSet.push({ id:'12.12.01.2007', kecamatan:'12.12.01', name:'Lumban Pea'})
    dataSet.push({ id:'12.12.04.2012', kecamatan:'12.12.04', name:'Lumban Pea'})
    dataSet.push({ id:'12.12.01.2040', kecamatan:'12.12.01', name:'Lumban Pea Timur'})
    dataSet.push({ id:'12.12.04.2008', kecamatan:'12.12.04', name:'Lumban Pinasa'})
    dataSet.push({ id:'12.13.06.2009', kecamatan:'12.13.06', name:'Lumban Pinasa'})
    dataSet.push({ id:'12.12.04.2027', kecamatan:'12.12.04', name:'Lumban Pinasa Saroba'})
    dataSet.push({ id:'12.17.08.2020', kecamatan:'12.17.08', name:'Lumban Pinggol'})
    dataSet.push({ id:'12.16.06.2017', kecamatan:'12.16.06', name:'Lumban Purba'})
    dataSet.push({ id:'12.03.30.2011', kecamatan:'12.03.30', name:'Lumban Ratus'})
    dataSet.push({ id:'12.12.04.2004', kecamatan:'12.12.04', name:'Lumban Rau Barat'})
    dataSet.push({ id:'12.12.04.2002', kecamatan:'12.12.04', name:'Lumban Rau Selatan'})
    dataSet.push({ id:'12.12.21.2001', kecamatan:'12.12.21', name:'Lumban Rau Tengah'})
    dataSet.push({ id:'12.12.21.2008', kecamatan:'12.12.21', name:'Lumban Rau Tenggara'})
    dataSet.push({ id:'12.12.21.2002', kecamatan:'12.12.21', name:'Lumban Rau Timur'})
    dataSet.push({ id:'12.12.21.2003', kecamatan:'12.12.21', name:'Lumban Rau Utara'})
    dataSet.push({ id:'12.12.04.2011', kecamatan:'12.12.04', name:'Lumban Ruhap'})
    dataSet.push({ id:'12.12.23.2014', kecamatan:'12.12.23', name:'Lumban Sangkalan'})
    dataSet.push({ id:'12.12.06.2013', kecamatan:'12.12.06', name:'Lumban Sewa'})
    dataSet.push({ id:'12.02.02.2009', kecamatan:'12.02.02', name:'Lumban Siagian Jae'})
    dataSet.push({ id:'12.02.02.2010', kecamatan:'12.02.02', name:'Lumban Siagian Julu'})
    dataSet.push({ id:'12.16.04.2004', kecamatan:'12.16.04', name:'Lumban Sialaman'})
    dataSet.push({ id:'12.16.04.2010', kecamatan:'12.16.04', name:'Lumban Sianturi'})
    dataSet.push({ id:'12.11.11.2006', kecamatan:'12.11.11', name:'Lumban Sihite'})
    dataSet.push({ id:'12.02.10.2012', kecamatan:'12.02.10', name:'Lumban Silintong'})
    dataSet.push({ id:'12.12.01.2018', kecamatan:'12.12.01', name:'Lumban Silintong'})
    dataSet.push({ id:'12.02.13.2014', kecamatan:'12.02.13', name:'Lumban Sinaga Simatupang'})
    dataSet.push({ id:'12.02.13.2005', kecamatan:'12.02.13', name:'Lumban Siregar'})
    dataSet.push({ id:'12.12.24.2002', kecamatan:'12.12.24', name:'Lumban Sitorus'})
    dataSet.push({ id:'12.17.08.2001', kecamatan:'12.17.08', name:'Lumban Ss Dolok'})
    dataSet.push({ id:'12.17.08.2002', kecamatan:'12.17.08', name:'Lumban Ss Torua'})
    dataSet.push({ id:'12.16.06.2012', kecamatan:'12.16.06', name:'Lumban Tobing'})
    dataSet.push({ id:'12.02.05.2008', kecamatan:'12.02.05', name:'Lumban Tonga'})
    dataSet.push({ id:'12.16.09.2013', kecamatan:'12.16.09', name:'Lumban Tonga-Tonga'})
    dataSet.push({ id:'12.02.09.2017', kecamatan:'12.02.09', name:'Lumban Tonga Tonga'})
    dataSet.push({ id:'12.11.11.2007', kecamatan:'12.11.11', name:'Lumban Toruan'})
    dataSet.push({ id:'12.14.04.2008', kecamatan:'12.14.04', name:'Lumbui Melayu'})
    dataSet.push({ id:'12.14.04.2021', kecamatan:'12.14.04', name:'Lumbui Nias'})
    dataSet.push({ id:'12.01.19.1001', kecamatan:'12.01.19', name:'Lumut'})
    dataSet.push({ id:'12.01.19.2006', kecamatan:'12.01.19', name:'Lumut Maju'})
    dataSet.push({ id:'12.01.19.2005', kecamatan:'12.01.19', name:'Lumut Nauli'})
    dataSet.push({ id:'12.07.09.2019', kecamatan:'12.07.09', name:'Mabar'})
    dataSet.push({ id:'12.71.06.1005', kecamatan:'12.71.06', name:'Mabar'})
    dataSet.push({ id:'12.71.06.1006', kecamatan:'12.71.06', name:'Mabar Hilir'})
    dataSet.push({ id:'12.01.10.2020', kecamatan:'12.01.10', name:'Madani'})
    dataSet.push({ id:'12.78.01.2013', kecamatan:'12.78.01', name:'Madolaoli'})
    dataSet.push({ id:'12.71.16.1001', kecamatan:'12.71.16', name:'Madras Hulu'})
    dataSet.push({ id:'12.78.01.2012', kecamatan:'12.78.01', name:'Madula'})
    dataSet.push({ id:'12.01.10.2014', kecamatan:'12.01.10', name:'Maduma'})
    dataSet.push({ id:'12.17.01.2003', kecamatan:'12.17.01', name:'Maduma'})
    dataSet.push({ id:'12.13.09.2004', kecamatan:'12.13.09', name:'Maga Dolok'})
    dataSet.push({ id:'12.13.09.2003', kecamatan:'12.13.09', name:'Maga Lombang'})
    dataSet.push({ id:'12.15.07.2004', kecamatan:'12.15.07', name:'Mahala'})
    dataSet.push({ id:'12.14.16.2006', kecamatan:'12.14.16', name:'Mahang Labara'})
    dataSet.push({ id:'12.15.01.2007', kecamatan:'12.15.01', name:'Maholida'})
    dataSet.push({ id:'12.18.07.2013', kecamatan:'12.18.07', name:'Mainu Tengah'})
    dataSet.push({ id:'12.15.02.2014', kecamatan:'12.15.02', name:'Majanggut I'})
    dataSet.push({ id:'12.15.02.2015', kecamatan:'12.15.02', name:'Majanggut Ii'})
    dataSet.push({ id:'12.14.30.2010', kecamatan:'12.14.30', name:'Majino Lorang'})
    dataSet.push({ id:'12.11.04.2013', kecamatan:'12.11.04', name:'Maju'})
    dataSet.push({ id:'12.12.19.2005', kecamatan:'12.12.19', name:'Maju'})
    dataSet.push({ id:'12.01.06.2011', kecamatan:'12.01.06', name:'Makarti Nauli'})
    dataSet.push({ id:'12.01.16.2003', kecamatan:'12.01.16', name:'Makmur'})
    dataSet.push({ id:'12.18.03.2005', kecamatan:'12.18.03', name:'Makmur'})
    dataSet.push({ id:'12.14.31.2007', kecamatan:'12.14.31', name:'Makole'})
    dataSet.push({ id:'12.18.09.2018', kecamatan:'12.18.09', name:'Malasori'})
    dataSet.push({ id:'12.08.18.2006', kecamatan:'12.08.18', name:'Maligas Bayu'})
    dataSet.push({ id:'12.08.11.2012', kecamatan:'12.08.11', name:'Maligas Tonga'})
    dataSet.push({ id:'12.20.01.2013', kecamatan:'12.20.01', name:'Malino'})
    dataSet.push({ id:'12.13.07.2016', kecamatan:'12.13.07', name:'Malintang'})
    dataSet.push({ id:'12.13.07.2006', kecamatan:'12.13.07', name:'Malintang Jae'})
    dataSet.push({ id:'12.13.07.2007', kecamatan:'12.13.07', name:'Malintang Julu'})
    dataSet.push({ id:'12.04.10.2024', kecamatan:'12.04.10', name:'Maliwa A'})
    dataSet.push({ id:'12.03.31.2010', kecamatan:'12.03.31', name:'Malombu'})
    dataSet.push({ id:'12.15.01.2009', kecamatan:'12.15.01', name:'Malum'})
    dataSet.push({ id:'12.14.23.2001', kecamatan:'12.14.23', name:'Maluo'})
    dataSet.push({ id:'12.22.01.2003', kecamatan:'12.22.01', name:'Mampang'})
    dataSet.push({ id:'12.02.11.2001', kecamatan:'12.02.11', name:'Manalu'})
    dataSet.push({ id:'12.16.09.2004', kecamatan:'12.16.09', name:'Manalu'})
    dataSet.push({ id:'12.02.11.2003', kecamatan:'12.02.11', name:'Manalu Dolok'})
    dataSet.push({ id:'12.02.11.2002', kecamatan:'12.02.11', name:'Manalu Purba'})
    dataSet.push({ id:'12.13.08.2016', kecamatan:'12.13.08', name:'Manambin'})
    dataSet.push({ id:'12.20.04.2017', kecamatan:'12.20.04', name:'Mananti'})
    dataSet.push({ id:'12.20.12.2010', kecamatan:'12.20.12', name:'Mananti'})
    dataSet.push({ id:'12.21.05.2011', kecamatan:'12.21.05', name:'Mananti Sosa Jae'})
    dataSet.push({ id:'12.21.08.2026', kecamatan:'12.21.08', name:'Mananti Sosa Julu'})
    dataSet.push({ id:'12.20.12.2012', kecamatan:'12.20.12', name:'Manare Tua'})
    dataSet.push({ id:'12.14.23.2005', kecamatan:'12.14.23', name:'Manawadano'})
    dataSet.push({ id:'12.05.06.2011', kecamatan:'12.05.06', name:'Mancang'})
    dataSet.push({ id:'12.08.18.2008', kecamatan:'12.08.18', name:'Mancuk'})
    dataSet.push({ id:'12.76.05.1001', kecamatan:'12.76.05', name:'Mandailing'})
    dataSet.push({ id:'12.22.05.2001', kecamatan:'12.22.05', name:'Mandalasena'})
    dataSet.push({ id:'12.19.01.2016', kecamatan:'12.19.01', name:'Mandarsah'})
    dataSet.push({ id:'12.20.08.2017', kecamatan:'12.20.08', name:'Mandasip'})
    dataSet.push({ id:'12.21.08.2009', kecamatan:'12.21.08', name:'Mandian'})
    dataSet.push({ id:'12.01.05.2015', kecamatan:'12.01.05', name:'Manduamas Baru'})
    dataSet.push({ id:'12.01.05.2006', kecamatan:'12.01.05', name:'Manduamas Lama'})
    dataSet.push({ id:'12.77.05.2009', kecamatan:'12.77.05', name:'Manegen'})
    dataSet.push({ id:'12.20.06.2030', kecamatan:'12.20.06', name:'Mangaledang'})
    dataSet.push({ id:'12.20.06.2029', kecamatan:'12.20.06', name:'Mangaledang Lama'})
    dataSet.push({ id:'12.11.06.2014', kecamatan:'12.11.06', name:'Mangan Molih'})
    dataSet.push({ id:'12.05.07.2003', kecamatan:'12.05.07', name:'Mangga'})
    dataSet.push({ id:'12.71.07.1009', kecamatan:'12.71.07', name:'Mangga'})
    dataSet.push({ id:'12.01.03.1024', kecamatan:'12.01.03', name:'Mangga Dua'})
    dataSet.push({ id:'12.18.05.2003', kecamatan:'12.18.05', name:'Mangga Dua'})
    dataSet.push({ id:'12.18.12.2018', kecamatan:'12.18.12', name:'Manggis'})
    dataSet.push({ id:'12.21.09.2004', kecamatan:'12.21.09', name:'Manggis'})
    dataSet.push({ id:'12.19.04.2011', kecamatan:'12.19.04', name:'Mangkai Baru'})
    dataSet.push({ id:'12.19.04.2012', kecamatan:'12.19.04', name:'Mangkai Lama'})
    dataSet.push({ id:'12.08.09.2007', kecamatan:'12.08.09', name:'Manik Hataran'})
    dataSet.push({ id:'12.08.09.2009', kecamatan:'12.08.09', name:'Manik Maraja'})
    dataSet.push({ id:'12.08.09.2014', kecamatan:'12.08.09', name:'Manik Rambung'})
    dataSet.push({ id:'12.09.14.2005', kecamatan:'12.09.14', name:'Manis'})
    dataSet.push({ id:'12.13.18.2001', kecamatan:'12.13.18', name:'Manisak'})
    dataSet.push({ id:'12.21.02.2011', kecamatan:'12.21.02', name:'Manombo'})
    dataSet.push({ id:'12.08.18.2015', kecamatan:'12.08.18', name:'Manrayap Baru'})
    dataSet.push({ id:'12.06.04.2017', kecamatan:'12.06.04', name:'Manukmulia'})
    dataSet.push({ id:'12.13.17.2004', kecamatan:'12.13.17', name:'Manuncang'})
    dataSet.push({ id:'12.07.25.2002', kecamatan:'12.07.25', name:'Manunggal'})
    dataSet.push({ id:'12.77.05.2016', kecamatan:'12.77.05', name:'Manunggang Jae'})
    dataSet.push({ id:'12.77.05.2007', kecamatan:'12.77.05', name:'Manunggang Julu'})
    dataSet.push({ id:'12.13.01.2016', kecamatan:'12.13.01', name:'Manyabar'})
    dataSet.push({ id:'12.13.01.2040', kecamatan:'12.13.01', name:'Manyabar Jae'})
    dataSet.push({ id:'12.24.10.2012', kecamatan:'12.24.10', name:'Marafala'})
    dataSet.push({ id:'12.03.20.2015', kecamatan:'12.03.20', name:'Marancar Godang'})
    dataSet.push({ id:'12.03.20.2034', kecamatan:'12.03.20', name:'Marancar Julu'})
    dataSet.push({ id:'12.14.19.2005', kecamatan:'12.14.19', name:'Marao'})
    dataSet.push({ id:'12.23.05.1001', kecamatan:'12.23.05', name:'Marbau'})
    dataSet.push({ id:'12.23.05.2013', kecamatan:'12.23.05', name:'Marbau Selatan'})
    dataSet.push({ id:'12.12.03.2031', kecamatan:'12.12.03', name:'Marbulang'})
    dataSet.push({ id:'12.16.03.2007', kecamatan:'12.16.03', name:'Marbun Tonga Marbun Dolok'})
    dataSet.push({ id:'12.16.03.2001', kecamatan:'12.16.03', name:'Marbun Toruan'})
    dataSet.push({ id:'12.01.13.2004', kecamatan:'12.01.13', name:'Mardame'})
    dataSet.push({ id:'12.07.07.2007', kecamatan:'12.07.07', name:'Mardinding Julu'})
    dataSet.push({ id:'12.06.10.2008', kecamatan:'12.06.10', name:'Mardingding'})
    dataSet.push({ id:'12.06.17.2002', kecamatan:'12.06.17', name:'Mardingding'})
    dataSet.push({ id:'12.08.31.2004', kecamatan:'12.08.31', name:'Mardingding'})
    dataSet.push({ id:'12.07.21.2006', kecamatan:'12.07.21', name:'Marendal I'})
    dataSet.push({ id:'12.21.11.2018', kecamatan:'12.21.11', name:'Marenu'})
    dataSet.push({ id:'12.08.02.2005', kecamatan:'12.08.02', name:'Margo Mulyo'})
    dataSet.push({ id:'12.08.27.2007', kecamatan:'12.08.27', name:'Maria Buttu'})
    dataSet.push({ id:'12.08.21.2003', kecamatan:'12.08.21', name:'Mariah Bandar'})
    dataSet.push({ id:'12.08.26.2004', kecamatan:'12.08.26', name:'Mariah Dolok'})
    dataSet.push({ id:'12.08.18.2001', kecamatan:'12.08.18', name:'Mariah Hombang'})
    dataSet.push({ id:'12.08.19.2006', kecamatan:'12.08.19', name:'Mariah Jambi'})
    dataSet.push({ id:'12.18.08.2011', kecamatan:'12.18.08', name:'Mariah Nagur'})
    dataSet.push({ id:'12.18.13.2004', kecamatan:'12.18.13', name:'Mariah Padang'})
    dataSet.push({ id:'12.02.15.2006', kecamatan:'12.02.15', name:'Mariba Ni Aek'})
    dataSet.push({ id:'12.08.23.2002', kecamatan:'12.08.23', name:'Marihat Bandar'})
    dataSet.push({ id:'12.08.01.2002', kecamatan:'12.08.01', name:'Marihat Baris'})
    dataSet.push({ id:'12.08.02.2014', kecamatan:'12.08.02', name:'Marihat Bukit'})
    dataSet.push({ id:'12.08.08.2010', kecamatan:'12.08.08', name:'Marihat Butar'})
    dataSet.push({ id:'12.08.13.2004', kecamatan:'12.08.13', name:'Marihat Dolok'})
    dataSet.push({ id:'12.18.17.2009', kecamatan:'12.18.17', name:'Marihat Dolok'})
    dataSet.push({ id:'12.72.08.1006', kecamatan:'12.72.08', name:'Marihat Jaya'})
    dataSet.push({ id:'12.08.13.2011', kecamatan:'12.08.13', name:'Marihat Marsada'})
    dataSet.push({ id:'12.08.18.2009', kecamatan:'12.08.18', name:'Marihat Mayang'})
    dataSet.push({ id:'12.08.13.2013', kecamatan:'12.08.13', name:'Marihat Pondok'})
    dataSet.push({ id:'12.08.13.2007', kecamatan:'12.08.13', name:'Marihat Raja'})
    dataSet.push({ id:'12.08.08.2009', kecamatan:'12.08.08', name:'Marihat Tanjung'})
    dataSet.push({ id:'12.07.21.2007', kecamatan:'12.07.21', name:'Marindal II'})
    dataSet.push({ id:'12.03.03.2012', kecamatan:'12.03.03', name:'Marisi'})
    dataSet.push({ id:'12.14.30.2009', kecamatan:'12.14.30', name:'Marit Baru'})
    dataSet.push({ id:'12.08.05.2004', kecamatan:'12.08.05', name:'Marjandi'})
    dataSet.push({ id:'12.07.01.2011', kecamatan:'12.07.01', name:'Marjandi Pematang'})
    dataSet.push({ id:'12.08.05.2009', kecamatan:'12.08.05', name:'Marjandi Pisang'})
    dataSet.push({ id:'12.07.01.2012', kecamatan:'12.07.01', name:'Marjandi Tongah'})
    dataSet.push({ id:'12.18.08.2013', kecamatan:'12.18.08', name:'Marjanji'})
    dataSet.push({ id:'12.09.21.2005', kecamatan:'12.09.21', name:'Marjanji Aceh'})
    dataSet.push({ id:'12.20.12.2009', kecamatan:'12.20.12', name:'Marlaung'})
    dataSet.push({ id:'12.17.01.2018', kecamatan:'12.17.01', name:'Marlumba'})
    dataSet.push({ id:'12.12.10.2009', kecamatan:'12.12.10', name:'Marom'})
    dataSet.push({ id:'12.07.09.2018', kecamatan:'12.07.09', name:'Marombun Barat'})
    dataSet.push({ id:'12.07.09.2017', kecamatan:'12.07.09', name:'Marombun Ujung Jawi'})
    dataSet.push({ id:'12.16.10.2007', kecamatan:'12.16.10', name:'Marpadan'})
    dataSet.push({ id:'12.03.04.2111', kecamatan:'12.03.04', name:'Marsada'})
    dataSet.push({ id:'12.12.19.2001', kecamatan:'12.12.19', name:'Marsangap'})
    dataSet.push({ id:'12.22.04.2009', kecamatan:'12.22.04', name:'Marsonja'})
    dataSet.push({ id:'12.18.09.2024', kecamatan:'12.18.09', name:'Martebing'})
    dataSet.push({ id:'12.06.09.2001', kecamatan:'12.06.09', name:'Martelu'})
    dataSet.push({ id:'12.07.03.2014', kecamatan:'12.07.03', name:'Martelu'})
    dataSet.push({ id:'12.72.04.1004', kecamatan:'12.72.04', name:'Martimbang'})
    dataSet.push({ id:'12.17.01.2006', kecamatan:'12.17.01', name:'Martoba'})
    dataSet.push({ id:'12.72.03.1002', kecamatan:'12.72.03', name:'Martoba'})
    dataSet.push({ id:'12.71.13.1004', kecamatan:'12.71.13', name:'Martubung'})
    dataSet.push({ id:'12.20.12.2005', kecamatan:'12.20.12', name:'Martujuan'})
    dataSet.push({ id:'12.18.08.2004', kecamatan:'12.18.08', name:'Marubun'})
    dataSet.push({ id:'12.08.11.2020', kecamatan:'12.08.11', name:'Marubun Bayu'})
    dataSet.push({ id:'12.08.11.2013', kecamatan:'12.08.11', name:'Marubun Jaya'})
    dataSet.push({ id:'12.08.26.2005', kecamatan:'12.08.26', name:'Marubun Lokkung'})
    dataSet.push({ id:'12.08.07.2012', kecamatan:'12.08.07', name:'Marubun Siboras'})
    dataSet.push({ id:'12.01.11.2007', kecamatan:'12.01.11', name:'Masnauli'})
    dataSet.push({ id:'12.01.19.2003', kecamatan:'12.01.19', name:'Masundung'})
    dataSet.push({ id:'12.18.03.2003', kecamatan:'12.18.03', name:'Mata Pao'})
    dataSet.push({ id:'12.74.02.1005', kecamatan:'12.74.02', name:'Matahalasan'})
    dataSet.push({ id:'12.12.01.2006', kecamatan:'12.12.01', name:'Matio'})
    dataSet.push({ id:'12.16.06.2025', kecamatan:'12.16.06', name:'Matiti'})
    dataSet.push({ id:'12.16.06.2014', kecamatan:'12.16.06', name:'Matiti Ii'})
    dataSet.push({ id:'12.21.06.2007', kecamatan:'12.21.06', name:'Matondang'})
    dataSet.push({ id:'12.14.28.2003', kecamatan:'12.14.28', name:'Maufa'})
    dataSet.push({ id:'12.08.08.2002', kecamatan:'12.08.08', name:'Mayang'})
    dataSet.push({ id:'12.24.01.2007', kecamatan:'12.24.01', name:'Maziaya'})
    dataSet.push({ id:'12.24.06.2005', kecamatan:'12.24.06', name:'Mazingo'})
    dataSet.push({ id:'12.25.03.2011', kecamatan:'12.25.03', name:'Mazingo'})
    dataSet.push({ id:'12.78.02.2006', kecamatan:'12.78.02', name:'Mazingo Tabaloho'})
    dataSet.push({ id:'12.04.05.2034', kecamatan:'12.04.05', name:'Mazingo Tanose O'})
    dataSet.push({ id:'12.06.09.2002', kecamatan:'12.06.09', name:'Mbal-Mbal Petarum'})
    dataSet.push({ id:'12.07.07.2006', kecamatan:'12.07.07', name:'Mbaruai'})
    dataSet.push({ id:'12.06.07.2015', kecamatan:'12.06.07', name:'Mbetong'})
    dataSet.push({ id:'12.15.01.2010', kecamatan:'12.15.01', name:'Mbinalun'})
    dataSet.push({ id:'12.11.09.2011', kecamatan:'12.11.09', name:'Mbinanga'})
    dataSet.push({ id:'12.06.13.2016', kecamatan:'12.06.13', name:'Mburidi'})
    dataSet.push({ id:'12.24.11.2007', kecamatan:'12.24.11', name:'Meafu'})
    dataSet.push({ id:'12.12.22.2003', kecamatan:'12.12.22', name:'Meat'})
    dataSet.push({ id:'12.07.26.2015', kecamatan:'12.07.26', name:'Medan Estate'})
    dataSet.push({ id:'12.07.23.2010', kecamatan:'12.07.23', name:'Medan Krio'})
    dataSet.push({ id:'12.07.02.2001', kecamatan:'12.07.02', name:'Medan Sinembah'})
    dataSet.push({ id:'12.71.04.1006', kecamatan:'12.71.04', name:'Medan Tenggara'})
    dataSet.push({ id:'12.19.01.2006', kecamatan:'12.19.01', name:'Medang'})
    dataSet.push({ id:'12.19.01.2017', kecamatan:'12.19.01', name:'Medang Baru'})
    dataSet.push({ id:'12.14.26.2005', kecamatan:'12.14.26', name:'Mehaga'})
    dataSet.push({ id:'12.08.19.2004', kecamatan:'12.08.19', name:'Mekar Bahalat'})
    dataSet.push({ id:'12.09.19.1007', kecamatan:'12.09.19', name:'Mekar Baru'})
    dataSet.push({ id:'12.19.07.2016', kecamatan:'12.19.07', name:'Mekar Baru'})
    dataSet.push({ id:'12.19.11.2008', kecamatan:'12.19.11', name:'Mekar Baru'})
    dataSet.push({ id:'12.05.04.2016', kecamatan:'12.05.04', name:'Mekar Jaya'})
    dataSet.push({ id:'12.05.08.2012', kecamatan:'12.05.08', name:'Mekar Jaya'})
    dataSet.push({ id:'12.19.12.2005', kecamatan:'12.19.12', name:'Mekar Laras'})
    dataSet.push({ id:'12.05.17.2011', kecamatan:'12.05.17', name:'Mekar Makmur'})
    dataSet.push({ id:'12.09.21.2009', kecamatan:'12.09.21', name:'Mekar Marjanji'})
    dataSet.push({ id:'12.08.11.2011', kecamatan:'12.08.11', name:'Mekar Mulia'})
    dataSet.push({ id:'12.19.07.2009', kecamatan:'12.19.07', name:'Mekar Mulio'})
    dataSet.push({ id:'12.72.05.1010', kecamatan:'12.72.05', name:'Mekar Nauli'})
    dataSet.push({ id:'12.08.08.2016', kecamatan:'12.08.08', name:'Mekar Rejo'})
    dataSet.push({ id:'12.07.22.2003', kecamatan:'12.07.22', name:'Mekar Sari'})
    dataSet.push({ id:'12.09.14.2012', kecamatan:'12.09.14', name:'Mekar Sari'})
    dataSet.push({ id:'12.09.16.2017', kecamatan:'12.09.16', name:'Mekar Sari'})
    dataSet.push({ id:'12.19.08.2008', kecamatan:'12.19.08', name:'Mekar Sari'})
    dataSet.push({ id:'12.08.04.2009', kecamatan:'12.08.04', name:'Mekar Sari Raya'})
    dataSet.push({ id:'12.05.20.2006', kecamatan:'12.05.20', name:'Mekar Sawit'})
    dataSet.push({ id:'12.76.02.1013', kecamatan:'12.76.02', name:'Mekar Sentosa'})
    dataSet.push({ id:'12.08.09.2008', kecamatan:'12.08.09', name:'Mekar Sidamanik'})
    dataSet.push({ id:'12.09.31.2006', kecamatan:'12.09.31', name:'Mekar Tanjung'})
    dataSet.push({ id:'12.01.07.2006', kecamatan:'12.01.07', name:'Mela Dolok'})
    dataSet.push({ id:'12.01.07.2007', kecamatan:'12.01.07', name:'Mela I'})
    dataSet.push({ id:'12.01.07.2008', kecamatan:'12.01.07', name:'Mela Ii'})
    dataSet.push({ id:'12.06.14.2004', kecamatan:'12.06.14', name:'Melas'})
    dataSet.push({ id:'12.18.02.1038', kecamatan:'12.18.02', name:'Melati I'})
    dataSet.push({ id:'12.18.02.2020', kecamatan:'12.18.02', name:'Melati Ii'})
    dataSet.push({ id:'12.18.14.1012', kecamatan:'12.18.14', name:'Melati Kebun'})
    dataSet.push({ id:'12.72.03.1001', kecamatan:'12.72.03', name:'Melayu'})
    dataSet.push({ id:'12.14.30.2005', kecamatan:'12.14.30', name:'Memong'})
    dataSet.push({ id:'12.75.04.1004', kecamatan:'12.75.04', name:'Mencirim'})
    dataSet.push({ id:'12.09.08.2002', kecamatan:'12.09.08', name:'Meranti'})
    dataSet.push({ id:'12.10.09.2010', kecamatan:'12.10.09', name:'Meranti'})
    dataSet.push({ id:'12.12.03.2025', kecamatan:'12.12.03', name:'Meranti Barat'})
    dataSet.push({ id:'12.23.06.2009', kecamatan:'12.23.06', name:'Meranti Omas'})
    dataSet.push({ id:'12.10.20.2006', kecamatan:'12.10.20', name:'Meranti Paham'})
    dataSet.push({ id:'12.12.05.2003', kecamatan:'12.12.05', name:'Meranti Tengah'})
    dataSet.push({ id:'12.12.05.2002', kecamatan:'12.12.05', name:'Meranti Timur'})
    dataSet.push({ id:'12.12.05.2001', kecamatan:'12.12.05', name:'Meranti Utara'})
    dataSet.push({ id:'12.06.15.2008', kecamatan:'12.06.15', name:'Merdeka'})
    dataSet.push({ id:'12.71.17.1003', kecamatan:'12.71.17', name:'Merdeka'})
    dataSet.push({ id:'12.72.01.1005', kecamatan:'12.72.01', name:'Merdeka'})
    dataSet.push({ id:'12.06.05.2019', kecamatan:'12.06.05', name:'Merek'})
    dataSet.push({ id:'12.08.29.1001', kecamatan:'12.08.29', name:'Merek Raya'})
    dataSet.push({ id:'12.07.27.2010', kecamatan:'12.07.27', name:'Mesjid'})
    dataSet.push({ id:'12.71.01.1004', kecamatan:'12.71.01', name:'Mesjid'})
    dataSet.push({ id:'12.19.05.2006', kecamatan:'12.19.05', name:'Mesjid Lama'})
    dataSet.push({ id:'12.78.01.2015', kecamatan:'12.78.01', name:'Miga'})
    dataSet.push({ id:'12.05.02.2014', kecamatan:'12.05.02', name:'Minta Kasih'})
    dataSet.push({ id:'12.78.01.2016', kecamatan:'12.78.01', name:'Mo Awo'})
    dataSet.push({ id:'12.24.10.2017', kecamatan:'12.24.10', name:'Moawo'})
    dataSet.push({ id:'12.14.03.2042', kecamatan:'12.14.03', name:'Mogae'})
    dataSet.push({ id:'12.04.27.2012', kecamatan:'12.04.27', name:'Mohili'})
    dataSet.push({ id:'12.14.07.2011', kecamatan:'12.14.07', name:'Mohili'})
    dataSet.push({ id:'12.04.21.2015', kecamatan:'12.04.21', name:'Mohili Berua Botomuzoi'})
    dataSet.push({ id:'12.08.19.2002', kecamatan:'12.08.19', name:'Moho'})
    dataSet.push({ id:'12.01.08.2005', kecamatan:'12.01.08', name:'Mombang Boru'})
    dataSet.push({ id:'12.14.20.2017', kecamatan:'12.14.20', name:'Mombawa Oladano'})
    dataSet.push({ id:'12.21.07.2018', kecamatan:'12.21.07', name:'Mompang'})
    dataSet.push({ id:'12.77.06.2005', kecamatan:'12.77.06', name:'Mompang'})
    dataSet.push({ id:'12.20.02.2019', kecamatan:'12.20.02', name:'Mompang Dolok'})
    dataSet.push({ id:'12.20.11.2005', kecamatan:'12.20.11', name:'Mompang I'})
    dataSet.push({ id:'12.20.10.2011', kecamatan:'12.20.10', name:'Mompang Ii'})
    dataSet.push({ id:'12.13.02.1012', kecamatan:'12.13.02', name:'Mompang Jae'})
    dataSet.push({ id:'12.13.02.2010', kecamatan:'12.13.02', name:'Mompang Julu'})
    dataSet.push({ id:'12.20.02.2015', kecamatan:'12.20.02', name:'Mompang Lombang'})
    dataSet.push({ id:'12.13.19.2008', kecamatan:'12.13.19', name:'Mondan'})
    dataSet.push({ id:'12.03.21.2004', kecamatan:'12.03.21', name:'Mondang'})
    dataSet.push({ id:'12.21.08.2012', kecamatan:'12.21.08', name:'Mondang'})
    dataSet.push({ id:'12.04.10.2020', kecamatan:'12.04.10', name:'Mondrali'})
    dataSet.push({ id:'12.14.25.2001', kecamatan:'12.14.25', name:'Mondrowe'})
    dataSet.push({ id:'12.20.07.2032', kecamatan:'12.20.07', name:'Morang'})
    dataSet.push({ id:'12.12.08.2004', kecamatan:'12.12.08', name:'Motung'})
    dataSet.push({ id:'12.03.29.1009', kecamatan:'12.03.29', name:'Muara Ampolu'})
    dataSet.push({ id:'12.13.18.2008', kecamatan:'12.13.18', name:'Muara Bangko'})
    dataSet.push({ id:'12.13.06.2011', kecamatan:'12.13.06', name:'Muara Batang Angkola'})
    dataSet.push({ id:'12.01.09.2006', kecamatan:'12.01.09', name:'Muara Bolak'})
    dataSet.push({ id:'12.13.08.2018', kecamatan:'12.13.08', name:'Muara Botung'})
    dataSet.push({ id:'12.03.29.2011', kecamatan:'12.03.29', name:'Muara Huta Raja'})
    dataSet.push({ id:'12.13.12.2021', kecamatan:'12.13.12', name:'Muara Kumpulan'})
    dataSet.push({ id:'12.13.10.2012', kecamatan:'12.13.10', name:'Muara Mais'})
    dataSet.push({ id:'12.13.10.2013', kecamatan:'12.13.10', name:'Muara Mais Jambur'})
    dataSet.push({ id:'12.21.09.2017', kecamatan:'12.21.09', name:'Muara Malinto Baru'})
    dataSet.push({ id:'12.21.09.2011', kecamatan:'12.21.09', name:'Muara Malinto Lama'})
    dataSet.push({ id:'12.03.29.1008', kecamatan:'12.03.29', name:'Muara Manompas'})
    dataSet.push({ id:'12.08.11.2009', kecamatan:'12.08.11', name:'Muara Mulia'})
    dataSet.push({ id:'12.01.02.2023', kecamatan:'12.01.02', name:'Muara Nauli'})
    dataSet.push({ id:'12.01.03.1025', kecamatan:'12.01.03', name:'Muara Nibung'})
    dataSet.push({ id:'12.01.11.2008', kecamatan:'12.01.11', name:'Muara Ode'})
    dataSet.push({ id:'12.03.29.2007', kecamatan:'12.03.29', name:'Muara Opu'})
    dataSet.push({ id:'12.13.13.2016', kecamatan:'12.13.13', name:'Muara Parlampungan'})
    dataSet.push({ id:'12.13.15.2010', kecamatan:'12.13.15', name:'Muara Pertemuan'})
    dataSet.push({ id:'12.13.08.2014', kecamatan:'12.13.08', name:'Muara Potan'})
    dataSet.push({ id:'12.13.08.2017', kecamatan:'12.13.08', name:'Muara Pungkut'})
    dataSet.push({ id:'12.03.32.2014', kecamatan:'12.03.32', name:'Muara Purba Nauli'})
    dataSet.push({ id:'12.13.11.2006', kecamatan:'12.13.11', name:'Muara Saladi'})
    dataSet.push({ id:'12.74.03.1003', kecamatan:'12.74.03', name:'Muara Sentosa'})
    dataSet.push({ id:'12.13.08.2015', kecamatan:'12.13.08', name:'Muara Siambak'})
    dataSet.push({ id:'12.01.08.2007', kecamatan:'12.01.08', name:'Muara Sibuntuon'})
    dataSet.push({ id:'12.20.06.2034', kecamatan:'12.20.06', name:'Muara Sigama'})
    dataSet.push({ id:'12.13.13.1017', kecamatan:'12.13.13', name:'Muara Soma'})
    dataSet.push({ id:'12.03.32.2006', kecamatan:'12.03.32', name:'Muara Tais I'})
    dataSet.push({ id:'12.03.32.2007', kecamatan:'12.03.32', name:'Muara Tais II'})
    dataSet.push({ id:'12.03.32.2008', kecamatan:'12.03.32', name:'Muara Tais III'})
    dataSet.push({ id:'12.01.05.2016', kecamatan:'12.01.05', name:'Muara Tapus'})
    dataSet.push({ id:'12.21.09.2024', kecamatan:'12.21.09', name:'Muara Tige'})
    dataSet.push({ id:'12.78.01.2014', kecamatan:'12.78.01', name:'Mudik'})
    dataSet.push({ id:'12.05.10.2005', kecamatan:'12.05.10', name:'Muka Paya'})
    dataSet.push({ id:'12.06.04.2020', kecamatan:'12.06.04', name:'Mulawari'})
    dataSet.push({ id:'12.06.05.2016', kecamatan:'12.06.05', name:'Mulia Rayat'})
    dataSet.push({ id:'12.07.23.2005', kecamatan:'12.07.23', name:'Mulio Rejo'})
    dataSet.push({ id:'12.15.08.2003', kecamatan:'12.15.08', name:'Mungkur'})
    dataSet.push({ id:'12.16.10.2008', kecamatan:'12.16.10', name:'Mungkur'})
    dataSet.push({ id:'12.06.06.2002', kecamatan:'12.06.06', name:'Munte'})
    dataSet.push({ id:'12.05.01.2021', kecamatan:'12.05.01', name:'Musam Pembangunan'})
    dataSet.push({ id:'12.09.20.1006', kecamatan:'12.09.20', name:'Mutiara'})
    dataSet.push({ id:'12.24.11.2006', kecamatan:'12.24.11', name:'Muzoi'})
    dataSet.push({ id:'12.10.09.2011', kecamatan:'12.10.09', name:'N-1 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2012', kecamatan:'12.10.09', name:'N-2 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2013', kecamatan:'12.10.09', name:'N-3 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2014', kecamatan:'12.10.09', name:'N-4 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2015', kecamatan:'12.10.09', name:'N-5 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2016', kecamatan:'12.10.09', name:'N-6 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2017', kecamatan:'12.10.09', name:'N-7 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2018', kecamatan:'12.10.09', name:'N-8 Aek Nabara'})
    dataSet.push({ id:'12.14.25.2010', kecamatan:'12.14.25', name:'Na Ai'})
    dataSet.push({ id:'12.20.02.2060', kecamatan:'12.20.02', name:'Nabonggal'})
    dataSet.push({ id:'12.20.04.2056', kecamatan:'12.20.04', name:'Nabonggal'})
    dataSet.push({ id:'12.20.01.2004', kecamatan:'12.20.01', name:'Nabundong'})
    dataSet.push({ id:'12.06.07.2013', kecamatan:'12.06.07', name:'Naga'})
    dataSet.push({ id:'12.08.31.2011', kecamatan:'12.08.31', name:'Naga Bosar'})
    dataSet.push({ id:'12.08.28.2006', kecamatan:'12.08.28', name:'Naga Dolok'})
    dataSet.push({ id:'12.72.08.1003', kecamatan:'12.72.08', name:'Naga Huta'})
    dataSet.push({ id:'12.72.08.1004', kecamatan:'12.72.08', name:'Naga Huta Timur'})
    dataSet.push({ id:'12.08.22.2001', kecamatan:'12.08.22', name:'Naga Jaya I'})
    dataSet.push({ id:'12.08.22.2006', kecamatan:'12.08.22', name:'Naga Jaya Ii'})
    dataSet.push({ id:'12.18.13.2002', kecamatan:'12.18.13', name:'Naga Kesiangan'})
    dataSet.push({ id:'12.18.01.2012', kecamatan:'12.18.01', name:'Naga Kisar'})
    dataSet.push({ id:'12.72.06.1007', kecamatan:'12.72.06', name:'Naga Pita'})
    dataSet.push({ id:'12.72.06.1010', kecamatan:'12.72.06', name:'Naga Pitu'})
    dataSet.push({ id:'12.18.08.2010', kecamatan:'12.18.08', name:'Naga Raja'})
    dataSet.push({ id:'12.08.31.2005', kecamatan:'12.08.31', name:'Naga Saribu'})
    dataSet.push({ id:'12.20.02.2038', kecamatan:'12.20.02', name:'Naga Saribu'})
    dataSet.push({ id:'12.20.10.2009', kecamatan:'12.20.10', name:'Naga Saribu'})
    dataSet.push({ id:'12.08.22.2010', kecamatan:'12.08.22', name:'Naga Soppa'})
    dataSet.push({ id:'12.01.13.2005', kecamatan:'12.01.13', name:'Naga Timbul'})
    dataSet.push({ id:'12.07.02.2008', kecamatan:'12.07.02', name:'Naga Timbul'})
    dataSet.push({ id:'12.12.23.2005', kecamatan:'12.12.23', name:'Naga Timbul'})
    dataSet.push({ id:'12.06.05.2008', kecamatan:'12.06.05', name:'Nagalingga'})
    dataSet.push({ id:'12.06.05.2005', kecamatan:'12.06.05', name:'Nagara'})
    dataSet.push({ id:'12.18.07.2001', kecamatan:'12.18.07', name:'Nagaraja I'})
    dataSet.push({ id:'12.16.05.2009', kecamatan:'12.16.05', name:'Nagasaribu I'})
    dataSet.push({ id:'12.16.05.2010', kecamatan:'12.16.05', name:'Nagasaribu Ii'})
    dataSet.push({ id:'12.16.05.2020', kecamatan:'12.16.05', name:'Nagasaribu Iii'})
    dataSet.push({ id:'12.16.05.2021', kecamatan:'12.16.05', name:'Nagasaribu Iv'})
    dataSet.push({ id:'12.16.05.2022', kecamatan:'12.16.05', name:'Nagasaribu V'})
    dataSet.push({ id:'12.12.23.2015', kecamatan:'12.12.23', name:'Nagatimbul Timur'})
    dataSet.push({ id:'12.06.06.2001', kecamatan:'12.06.06', name:'Nageri'})
    dataSet.push({ id:'12.06.07.2008', kecamatan:'12.06.07', name:'Nageri'})
    dataSet.push({ id:'12.08.23.2003', kecamatan:'12.08.23', name:'Nagori Bandar'})
    dataSet.push({ id:'12.08.20.2016', kecamatan:'12.08.20', name:'Nagori Bayu'})
    dataSet.push({ id:'12.08.05.2003', kecamatan:'12.08.05', name:'Nagori Bosar'})
    dataSet.push({ id:'12.08.02.2011', kecamatan:'12.08.02', name:'Nagori Malela'})
    dataSet.push({ id:'12.08.15.2001', kecamatan:'12.08.15', name:'Nagori Purba'})
    dataSet.push({ id:'12.08.15.2003', kecamatan:'12.08.15', name:'Nagori Purba Horison'})
    dataSet.push({ id:'12.08.15.2004', kecamatan:'12.08.15', name:'Nagori Purba Pasir'})
    dataSet.push({ id:'12.08.15.2002', kecamatan:'12.08.15', name:'Nagori Sihalpe'})
    dataSet.push({ id:'12.08.27.2012', kecamatan:'12.08.27', name:'Nagori Tani'})
    dataSet.push({ id:'12.08.14.2013', kecamatan:'12.08.14', name:'Nagori Tongah'})
    dataSet.push({ id:'12.18.05.2002', kecamatan:'12.18.05', name:'Nagur'})
    dataSet.push({ id:'12.18.08.2008', kecamatan:'12.18.08', name:'Nagur Pane'})
    dataSet.push({ id:'12.08.28.2004', kecamatan:'12.08.28', name:'Nagur Usang'})
    dataSet.push({ id:'12.16.07.2010', kecamatan:'12.16.07', name:'Nagurguran'})
    dataSet.push({ id:'12.02.06.2008', kecamatan:'12.02.06', name:'Nahornop Marsada'})
    dataSet.push({ id:'12.20.01.2038', kecamatan:'12.20.01', name:'Nahula Jae'})
    dataSet.push({ id:'12.20.01.2009', kecamatan:'12.20.01', name:'Nahula Julu'})
    dataSet.push({ id:'12.17.03.2009', kecamatan:'12.17.03', name:'Nainggolan'})
    dataSet.push({ id:'12.01.02.1009', kecamatan:'12.01.02', name:'Naipospos Barat'})
    dataSet.push({ id:'12.02.13.2017', kecamatan:'12.02.13', name:'Najumambe'})
    dataSet.push({ id:'12.12.07.2005', kecamatan:'12.12.07', name:'Nalela'})
    dataSet.push({ id:'12.06.16.2004', kecamatan:'12.06.16', name:'Naman'})
    dataSet.push({ id:'12.05.02.2008', kecamatan:'12.05.02', name:'Naman Jahe'})
    dataSet.push({ id:'12.05.06.2005', kecamatan:'12.05.06', name:'Nambiki'})
    dataSet.push({ id:'12.07.06.2010', kecamatan:'12.07.06', name:'Namo Batang'})
    dataSet.push({ id:'12.07.05.2013', kecamatan:'12.07.05', name:'Namo Bintang'})
    dataSet.push({ id:'12.71.07.1003', kecamatan:'12.71.07', name:'Namo Gajah'})
    dataSet.push({ id:'12.07.06.2020', kecamatan:'12.07.06', name:'Namo Landur'})
    dataSet.push({ id:'12.07.06.2034', kecamatan:'12.07.06', name:'Namo Mbaru'})
    dataSet.push({ id:'12.05.03.2011', kecamatan:'12.05.03', name:'Namo Mbelin'})
    dataSet.push({ id:'12.07.06.2036', kecamatan:'12.07.06', name:'Namo Mbelin'})
    dataSet.push({ id:'12.07.04.2002', kecamatan:'12.07.04', name:'Namo Mirik'})
    dataSet.push({ id:'12.07.06.2013', kecamatan:'12.07.06', name:'Namo Pakam'})
    dataSet.push({ id:'12.07.06.2025', kecamatan:'12.07.06', name:'Namo Pinang'})
    dataSet.push({ id:'12.07.06.2003', kecamatan:'12.07.06', name:'Namo Rambe'})
    dataSet.push({ id:'12.07.05.2005', kecamatan:'12.07.05', name:'Namo Riam'})
    dataSet.push({ id:'12.07.04.2013', kecamatan:'12.07.04', name:'Namo Rube Julu'})
    dataSet.push({ id:'12.05.19.2005', kecamatan:'12.05.19', name:'Namo Sialang'})
    dataSet.push({ id:'12.07.05.2011', kecamatan:'12.07.05', name:'Namo Simpur'})
    dataSet.push({ id:'12.07.07.2008', kecamatan:'12.07.07', name:'Namo Suro Baru'})
    dataSet.push({ id:'12.07.07.2017', kecamatan:'12.07.07', name:'Namo Tualang'})
    dataSet.push({ id:'12.24.05.2008', kecamatan:'12.24.05', name:'Namohalu'})
    dataSet.push({ id:'12.07.05.2015', kecamatan:'12.07.05', name:'Namorih'})
    dataSet.push({ id:'12.06.07.2004', kecamatan:'12.06.07', name:'Namosuro'})
    dataSet.push({ id:'12.05.22.2005', kecamatan:'12.05.22', name:'Namoteras'})
    dataSet.push({ id:'12.05.22.2001', kecamatan:'12.05.22', name:'Namotogan'})
    dataSet.push({ id:'12.05.04.1005', kecamatan:'12.05.04', name:'Namu Ukur Selatan'})
    dataSet.push({ id:'12.05.04.2007', kecamatan:'12.05.04', name:'Namu Ukur Utara'})
    dataSet.push({ id:'12.06.12.2019', kecamatan:'12.06.12', name:'Nangbelawan'})
    dataSet.push({ id:'12.08.08.2017', kecamatan:'12.08.08', name:'Nanggar Bayu'})
    dataSet.push({ id:'12.03.14.2036', kecamatan:'12.03.14', name:'Nanggar Jati'})
    dataSet.push({ id:'12.03.14.2035', kecamatan:'12.03.14', name:'Nanggar Jati Huta Padang'})
    dataSet.push({ id:'12.75.01.1003', kecamatan:'12.75.01', name:'Nangka'})
    dataSet.push({ id:'12.14.06.2045', kecamatan:'12.14.06', name:'Nanowa'})
    dataSet.push({ id:'12.03.02.2015', kecamatan:'12.03.02', name:'Napa'})
    dataSet.push({ id:'12.03.06.1007', kecamatan:'12.03.06', name:'Napa'})
    dataSet.push({ id:'12.20.03.2017', kecamatan:'12.20.03', name:'Napa Lancat'})
    dataSet.push({ id:'12.20.06.2028', kecamatan:'12.20.06', name:'Napa Lombang'})
    dataSet.push({ id:'12.20.04.2014', kecamatan:'12.20.04', name:'Napagadung Laut'})
    dataSet.push({ id:'12.20.06.2035', kecamatan:'12.20.06', name:'Napahalas'})
    dataSet.push({ id:'12.12.21.2005', kecamatan:'12.12.21', name:'Napajoring'})
    dataSet.push({ id:'12.20.02.2069', kecamatan:'12.20.02', name:'Napasundali'})
    dataSet.push({ id:'12.15.06.2002', kecamatan:'12.15.06', name:'Napatalun Perlambuken'})
    dataSet.push({ id:'12.12.03.2023', kecamatan:'12.12.03', name:'Napitupulu'})
    dataSet.push({ id:'12.12.01.1039', kecamatan:'12.12.01', name:'Napitupulu Bagasan'})
    dataSet.push({ id:'12.06.17.2014', kecamatan:'12.06.17', name:'Narigunung I'})
    dataSet.push({ id:'12.06.17.2015', kecamatan:'12.06.17', name:'Narigunung Ii'})
    dataSet.push({ id:'12.12.20.2001', kecamatan:'12.12.20', name:'Narumonda I'})
    dataSet.push({ id:'12.12.20.2002', kecamatan:'12.12.20', name:'Narumonda Ii'})
    dataSet.push({ id:'12.12.20.2003', kecamatan:'12.12.20', name:'Narumonda Iii'})
    dataSet.push({ id:'12.12.20.2004', kecamatan:'12.12.20', name:'Narumonda Iv'})
    dataSet.push({ id:'12.12.20.2006', kecamatan:'12.12.20', name:'Narumonda Vi'})
    dataSet.push({ id:'12.12.20.2007', kecamatan:'12.12.20', name:'Narumonda Vii'})
    dataSet.push({ id:'12.12.20.2008', kecamatan:'12.12.20', name:'Narumonda Viii'})
    dataSet.push({ id:'12.03.14.2037', kecamatan:'12.03.14', name:'Natambang Roncitan'})
    dataSet.push({ id:'12.12.03.2008', kecamatan:'12.12.03', name:'Natolutali'})
    dataSet.push({ id:'12.12.06.2001', kecamatan:'12.12.06', name:'Natumingka'})
    dataSet.push({ id:'12.01.02.2022', kecamatan:'12.01.02', name:'Nauli'})
    dataSet.push({ id:'12.01.13.1003', kecamatan:'12.01.13', name:'Nauli'})
    dataSet.push({ id:'12.12.19.2002', kecamatan:'12.12.19', name:'Nauli'})
    dataSet.push({ id:'12.08.04.2016', kecamatan:'12.08.04', name:'Nauli Baru'})
    dataSet.push({ id:'12.78.05.2001', kecamatan:'12.78.05', name:'Nazalou Alo Oa'})
    dataSet.push({ id:'12.78.05.2009', kecamatan:'12.78.05', name:'Nazalou Lolowua'})
    dataSet.push({ id:'12.06.16.2012', kecamatan:'12.06.16', name:'Ndeskati'})
    dataSet.push({ id:'12.06.12.2014', kecamatan:'12.06.12', name:'Ndokumsiroga'})
    dataSet.push({ id:'12.14.10.2009', kecamatan:'12.14.10', name:'Ndraso Hilisimaetano'})
    dataSet.push({ id:'12.07.08.2006', kecamatan:'12.07.08', name:'Negara Beringin'})
    dataSet.push({ id:'12.10.08.1002', kecamatan:'12.10.08', name:'Negeri Baru'})
    dataSet.push({ id:'12.08.13.2001', kecamatan:'12.08.13', name:'Negeri Dolok'})
    dataSet.push({ id:'12.08.27.2003', kecamatan:'12.08.27', name:'Negeri Dolok'})
    dataSet.push({ id:'12.07.03.2015', kecamatan:'12.07.03', name:'Negeri Gugung'})
    dataSet.push({ id:'12.06.13.2001', kecamatan:'12.06.13', name:'Negeri Jahe'})
    dataSet.push({ id:'12.10.08.1001', kecamatan:'12.10.08', name:'Negeri Lama'})
    dataSet.push({ id:'12.10.08.2007', kecamatan:'12.10.08', name:'Negeri Lama Seberang'})
    dataSet.push({ id:'12.06.05.2002', kecamatan:'12.06.05', name:'Negeri Tongging'})
    dataSet.push({ id:'12.08.28.2010', kecamatan:'12.08.28', name:'Negri Bayu Muslimin'})
    dataSet.push({ id:'12.71.13.1005', kecamatan:'12.71.13', name:'Nelayan Indah'})
    dataSet.push({ id:'12.19.01.2014', kecamatan:'12.19.01', name:'Nenas Siam'})
    dataSet.push({ id:'12.04.06.2053', kecamatan:'12.04.06', name:'Nifolo O Lauru'})
    dataSet.push({ id:'12.78.05.2002', kecamatan:'12.78.05', name:'Niko Otano Dao'})
    dataSet.push({ id:'12.14.08.2048', kecamatan:'12.14.08', name:'Nituwu Boho'})
    dataSet.push({ id:'12.07.19.2019', kecamatan:'12.07.19', name:'Nogorejo'})
    dataSet.push({ id:'12.08.01.2009', kecamatan:'12.08.01', name:'Nusa Harapan'})
    dataSet.push({ id:'12.09.14.2010', kecamatan:'12.09.14', name:'Ofa Padang Mahondang'})
    dataSet.push({ id:'12.14.03.2036', kecamatan:'12.14.03', name:'Oikhoda Balaekha'})
    dataSet.push({ id:'12.04.21.2018', kecamatan:'12.04.21', name:'Ola Nori'})
    dataSet.push({ id:'12.04.10.2016', kecamatan:'12.04.10', name:'Oladano'})
    dataSet.push({ id:'12.14.26.2008', kecamatan:'12.14.26', name:'Oladano'})
    dataSet.push({ id:'12.14.25.2011', kecamatan:'12.14.25', name:'Olanori'})
    dataSet.push({ id:'12.14.20.2004', kecamatan:'12.14.20', name:'Olayama'})
    dataSet.push({ id:'12.04.06.2056', kecamatan:'12.04.06', name:'Olindrawa Sisarahili'})
    dataSet.push({ id:'12.78.03.2008', kecamatan:'12.78.03', name:'Olora'})
    dataSet.push({ id:'12.24.07.2009', kecamatan:'12.24.07', name:'Ombolata'})
    dataSet.push({ id:'12.24.10.2015', kecamatan:'12.24.10', name:'Ombolata'})
    dataSet.push({ id:'12.25.02.2015', kecamatan:'12.25.02', name:'Ombolata'})
    dataSet.push({ id:'12.78.04.2024', kecamatan:'12.78.04', name:'Ombolata'})
    dataSet.push({ id:'12.24.09.2004', kecamatan:'12.24.09', name:'Ombolata Afulu'})
    dataSet.push({ id:'12.04.05.2023', kecamatan:'12.04.05', name:'Ombolata Salo O'})
    dataSet.push({ id:'12.24.02.2002', kecamatan:'12.24.02', name:'Ombolata Sawo'})
    dataSet.push({ id:'12.78.02.2010', kecamatan:'12.78.02', name:'Ombolata Simenari'})
    dataSet.push({ id:'12.04.05.2042', kecamatan:'12.04.05', name:'Ombolata Sisarahili'})
    dataSet.push({ id:'12.78.01.2017', kecamatan:'12.78.01', name:'Ombolata Ulu'})
    dataSet.push({ id:'12.12.03.2006', kecamatan:'12.12.03', name:'Ombur'})
    dataSet.push({ id:'12.14.04.2027', kecamatan:'12.14.04', name:'Omega'})
    dataSet.push({ id:'12.12.02.2023', kecamatan:'12.12.02', name:'Ompu Raja Hatulian'})
    dataSet.push({ id:'12.12.02.2016', kecamatan:'12.12.02', name:'Ompu Raja Hutapea'})
    dataSet.push({ id:'12.12.02.2022', kecamatan:'12.12.02', name:'Ompu Raja Hutapea Timur'})
    dataSet.push({ id:'12.16.08.2002', kecamatan:'12.16.08', name:'Onan Ganjang'})
    dataSet.push({ id:'12.02.05.1001', kecamatan:'12.02.05', name:'Onan Hasang'})
    dataSet.push({ id:'12.11.09.2003', kecamatan:'12.11.09', name:'Onan Lama'})
    dataSet.push({ id:'12.17.02.2007', kecamatan:'12.17.02', name:'Onan Runggu'})
    dataSet.push({ id:'12.02.12.2006', kecamatan:'12.02.12', name:'Onan Runggu I'})
    dataSet.push({ id:'12.02.12.2018', kecamatan:'12.02.12', name:'Onan Runggu Ii'})
    dataSet.push({ id:'12.02.12.2008', kecamatan:'12.02.12', name:'Onan Runggu Iii'})
    dataSet.push({ id:'12.02.12.2014', kecamatan:'12.02.12', name:'Onan Runggu Iv'})
    dataSet.push({ id:'12.14.05.2048', kecamatan:'12.14.05', name:'Onaya'})
    dataSet.push({ id:'12.04.27.2008', kecamatan:'12.04.27', name:'Onodalinga'})
    dataSet.push({ id:'12.14.22.2006', kecamatan:'12.14.22', name:'Onohazumba'})
    dataSet.push({ id:'12.14.18.2006', kecamatan:'12.14.18', name:'Onohondro'})
    dataSet.push({ id:'12.25.01.2008', kecamatan:'12.25.01', name:'Onolimbu'})
    dataSet.push({ id:'12.25.03.2001', kecamatan:'12.25.03', name:'Onolimbu Raya'})
    dataSet.push({ id:'12.25.03.2012', kecamatan:'12.25.03', name:'Onolimbu You'})
    dataSet.push({ id:'12.04.20.2013', kecamatan:'12.04.20', name:'Onombongi'})
    dataSet.push({ id:'12.24.07.2012', kecamatan:'12.24.07', name:'Ononamolo Alasa'})
    dataSet.push({ id:'12.25.06.2006', kecamatan:'12.25.06', name:'Ononamolo I'})
    dataSet.push({ id:'12.04.05.2001', kecamatan:'12.04.05', name:'Ononamolo I Bot'})
    dataSet.push({ id:'12.78.02.2001', kecamatan:'12.78.02', name:'Ononamolo I Lot'})
    dataSet.push({ id:'12.25.06.2009', kecamatan:'12.25.06', name:'Ononamolo Ii'})
    dataSet.push({ id:'12.78.06.2009', kecamatan:'12.78.06', name:'Ononamolo Ii Lot'})
    dataSet.push({ id:'12.25.03.2002', kecamatan:'12.25.03', name:'Ononamolo Iii'})
    dataSet.push({ id:'12.04.21.2012', kecamatan:'12.04.21', name:'Ononamolo Talafu'})
    dataSet.push({ id:'12.24.07.2007', kecamatan:'12.24.07', name:'Ononamolo Tumula'})
    dataSet.push({ id:'12.24.08.2004', kecamatan:'12.24.08', name:'Ononazara'})
    dataSet.push({ id:'12.25.01.2007', kecamatan:'12.25.01', name:'Onowaembo'})
    dataSet.push({ id:'12.78.01.2018', kecamatan:'12.78.01', name:'Onowaembo'})
    dataSet.push({ id:'12.78.04.2023', kecamatan:'12.78.04', name:'Onowaembo'})
    dataSet.push({ id:'12.04.05.2040', kecamatan:'12.04.05', name:'Onowaembo Hiligara'})
    dataSet.push({ id:'12.24.10.2006', kecamatan:'12.24.10', name:'Onozalukhu'})
    dataSet.push({ id:'12.25.04.2010', kecamatan:'12.25.04', name:'Onozalukhu You'})
    dataSet.push({ id:'12.78.06.2008', kecamatan:'12.78.06', name:'Onozikho'})
    dataSet.push({ id:'12.78.01.2019', kecamatan:'12.78.01', name:'Onozitoli Olora'})
    dataSet.push({ id:'12.24.02.2004', kecamatan:'12.24.02', name:'Onozitoli Sawo'})
    dataSet.push({ id:'12.78.01.2020', kecamatan:'12.78.01', name:'Onozitoli Sifaoroasi'})
    dataSet.push({ id:'12.78.02.2007', kecamatan:'12.78.02', name:'Onozitoli Tabaloho'})
    dataSet.push({ id:'12.04.05.2033', kecamatan:'12.04.05', name:'Onozitolidulu'})
    dataSet.push({ id:'12.04.11.2013', kecamatan:'12.04.11', name:'Orahili'})
    dataSet.push({ id:'12.04.27.2001', kecamatan:'12.04.27', name:'Orahili'})
    dataSet.push({ id:'12.14.05.2054', kecamatan:'12.14.05', name:'Orahili'})
    dataSet.push({ id:'12.24.05.2010', kecamatan:'12.24.05', name:'Orahili'})
    dataSet.push({ id:'12.25.02.2024', kecamatan:'12.25.02', name:'Orahili'})
    dataSet.push({ id:'12.25.03.2014', kecamatan:'12.25.03', name:'Orahili Badalu'})
    dataSet.push({ id:'12.14.03.2016', kecamatan:'12.14.03', name:'Orahili Balaekha'})
    dataSet.push({ id:'12.14.09.2019', kecamatan:'12.14.09', name:'Orahili Bo E'})
    dataSet.push({ id:'12.14.07.2015', kecamatan:'12.14.07', name:'Orahili Eho'})
    dataSet.push({ id:'12.14.32.2004', kecamatan:'12.14.32', name:'Orahili Faomasi'})
    dataSet.push({ id:'12.14.18.2002', kecamatan:'12.14.18', name:'Orahili Fau'})
    dataSet.push({ id:'12.14.24.2012', kecamatan:'12.14.24', name:'Orahili Fondrako'})
    dataSet.push({ id:'12.14.02.2023', kecamatan:'12.14.02', name:'Orahili Gomo'})
    dataSet.push({ id:'12.14.22.2008', kecamatan:'12.14.22', name:'Orahili Huruna'})
    dataSet.push({ id:'12.04.20.2014', kecamatan:'12.04.20', name:'Orahili Idanoi'})
    dataSet.push({ id:'12.14.14.2011', kecamatan:'12.14.14', name:'Orahili Mola'})
    dataSet.push({ id:'12.14.02.2041', kecamatan:'12.14.02', name:'Orahili Sibohou'})
    dataSet.push({ id:'12.14.09.2002', kecamatan:'12.14.09', name:'Orahili Susua'})
    dataSet.push({ id:'12.78.05.2004', kecamatan:'12.78.05', name:'Orahili Tanose O'})
    dataSet.push({ id:'12.78.06.2003', kecamatan:'12.78.06', name:'Orahili Tumori'})
    dataSet.push({ id:'12.14.19.2002', kecamatan:'12.14.19', name:'Orahili Ulunoyo'})
    dataSet.push({ id:'12.04.10.2032', kecamatan:'12.04.10', name:'Orahili Zuzundrao'})
    dataSet.push({ id:'12.04.11.2018', kecamatan:'12.04.11', name:'Orahua'})
    dataSet.push({ id:'12.14.35.2003', kecamatan:'12.14.35', name:'Orahua'})
    dataSet.push({ id:'12.04.11.2023', kecamatan:'12.04.11', name:'Orahua Faondrato'})
    dataSet.push({ id:'12.14.09.2016', kecamatan:'12.14.09', name:'Orahua Uluzoi'})
    dataSet.push({ id:'12.14.17.2005', kecamatan:'12.14.17', name:'Orahuahili'})
    dataSet.push({ id:'12.09.14.2004', kecamatan:'12.09.14', name:'Orika'})
    dataSet.push({ id:'12.14.14.2010', kecamatan:'12.14.14', name:'Orlin'})
    dataSet.push({ id:'12.14.27.2004', kecamatan:'12.14.27', name:'Orsedes'})
    dataSet.push({ id:'12.14.01.2028', kecamatan:'12.14.01', name:'Orudua Lawa-Lawa Luo'})
    dataSet.push({ id:'12.14.24.2002', kecamatan:'12.14.24', name:'Orudua Sibohou'})
    dataSet.push({ id:'12.04.10.2030', kecamatan:'12.04.10', name:'Otalua'})
    dataSet.push({ id:'12.71.20.1008', kecamatan:'12.71.20', name:'P Berayan Bengkel'})
    dataSet.push({ id:'12.71.20.1006', kecamatan:'12.71.20', name:'P Berayan Darat I'})
    dataSet.push({ id:'12.71.20.1007', kecamatan:'12.71.20', name:'P Berayan Darat II'})
    dataSet.push({ id:'12.71.21.1005', kecamatan:'12.71.21', name:'P Bulan Selayang I'})
    dataSet.push({ id:'12.71.21.1003', kecamatan:'12.71.21', name:'P Bulan Selayang II'})
    dataSet.push({ id:'12.76.01.1001', kecamatan:'12.76.01', name:'Pabatu'})
    dataSet.push({ id:'12.18.07.2010', kecamatan:'12.18.07', name:'Pabatu I'})
    dataSet.push({ id:'12.18.07.2012', kecamatan:'12.18.07', name:'Pabatu Ii'})
    dataSet.push({ id:'12.18.07.2015', kecamatan:'12.18.07', name:'Pabatu Iii'})
    dataSet.push({ id:'12.18.07.2016', kecamatan:'12.18.07', name:'Pabatu Vi'})
    dataSet.push({ id:'12.20.05.2017', kecamatan:'12.20.05', name:'Padang Baruas'})
    dataSet.push({ id:'12.05.06.2003', kecamatan:'12.05.06', name:'Padang Brahrang'})
    dataSet.push({ id:'12.03.04.2059', kecamatan:'12.03.04', name:'Padang Bujur'})
    dataSet.push({ id:'12.20.05.2013', kecamatan:'12.20.05', name:'Padang Bujur'})
    dataSet.push({ id:'12.20.07.2030', kecamatan:'12.20.07', name:'Padang Bujur Baru'})
    dataSet.push({ id:'12.10.01.1009', kecamatan:'12.10.01', name:'Padang Bulan'})
    dataSet.push({ id:'12.13.08.2020', kecamatan:'12.13.08', name:'Padang Bulan'})
    dataSet.push({ id:'12.71.17.1005', kecamatan:'12.71.17', name:'Padang Bulan'})
    dataSet.push({ id:'12.05.06.2013', kecamatan:'12.05.06', name:'Padang Cermin'})
    dataSet.push({ id:'12.20.04.2060', kecamatan:'12.20.04', name:'Padang Garugur'})
    dataSet.push({ id:'12.20.07.2019', kecamatan:'12.20.07', name:'Padang Garugur'})
    dataSet.push({ id:'12.21.02.2021', kecamatan:'12.21.02', name:'Padang Garugur'})
    dataSet.push({ id:'12.21.11.2003', kecamatan:'12.21.11', name:'Padang Garugur Jae'})
    dataSet.push({ id:'12.21.11.2006', kecamatan:'12.21.11', name:'Padang Garugur Julu'})
    dataSet.push({ id:'12.21.11.2020', kecamatan:'12.21.11', name:'Padang Garugur Tonga'})
    dataSet.push({ id:'12.19.05.2007', kecamatan:'12.19.05', name:'Padang Genting'})
    dataSet.push({ id:'12.21.12.2002', kecamatan:'12.21.12', name:'Padang Hasior Dolok'})
    dataSet.push({ id:'12.21.12.2003', kecamatan:'12.21.12', name:'Padang Hasior Lombang'})
    dataSet.push({ id:'12.03.07.2029', kecamatan:'12.03.07', name:'Padang Kahombu'})
    dataSet.push({ id:'12.03.02.1030', kecamatan:'12.03.02', name:'Padang Lancat'})
    dataSet.push({ id:'12.05.13.2004', kecamatan:'12.05.13', name:'Padang Langkat'})
    dataSet.push({ id:'12.13.03.2015', kecamatan:'12.13.03', name:'Padang Laru'})
    dataSet.push({ id:'12.09.14.2009', kecamatan:'12.09.14', name:'Padang Mahondang'})
    dataSet.push({ id:'12.08.17.2013', kecamatan:'12.08.17', name:'Padang Mainu'})
    dataSet.push({ id:'12.20.01.2031', kecamatan:'12.20.01', name:'Padang Malakka'})
    dataSet.push({ id:'12.03.05.2073', kecamatan:'12.03.05', name:'Padang Mandailing Garugur'})
    dataSet.push({ id:'12.23.04.2007', kecamatan:'12.23.04', name:'Padang Maninjau'})
    dataSet.push({ id:'12.20.06.2023', kecamatan:'12.20.06', name:'Padang Manjoir'})
    dataSet.push({ id:'12.06.01.1009', kecamatan:'12.06.01', name:'Padang Mas'})
    dataSet.push({ id:'12.01.01.1002', kecamatan:'12.01.01', name:'Padang Masiang'})
    dataSet.push({ id:'12.10.01.1001', kecamatan:'12.10.01', name:'Padang Matinggi'})
    dataSet.push({ id:'12.20.07.2020', kecamatan:'12.20.07', name:'Padang Matinggi'})
    dataSet.push({ id:'12.21.02.2016', kecamatan:'12.21.02', name:'Padang Matinggi'})
    dataSet.push({ id:'12.77.02.1007', kecamatan:'12.77.02', name:'Padang Matinggi'})
    dataSet.push({ id:'12.20.01.2021', kecamatan:'12.20.01', name:'Padang Matinggi Gnt'})
    dataSet.push({ id:'12.77.02.1011', kecamatan:'12.77.02', name:'Padang Matinggi Lestari'})
    dataSet.push({ id:'12.20.01.2016', kecamatan:'12.20.01', name:'Padang Matinggi Simundol'})
    dataSet.push({ id:'12.76.01.1011', kecamatan:'12.76.01', name:'Padang Merbau'})
    dataSet.push({ id:'12.02.13.2021', kecamatan:'12.02.13', name:'Padang Parsadaan'})
    dataSet.push({ id:'12.09.15.2010', kecamatan:'12.09.15', name:'Padang Pulau'})
    dataSet.push({ id:'12.13.10.2014', kecamatan:'12.13.10', name:'Padang Sanggar'})
    dataSet.push({ id:'12.09.26.2007', kecamatan:'12.09.26', name:'Padang Sari'})
    dataSet.push({ id:'12.02.14.2004', kecamatan:'12.02.14', name:'Padang Siandomang'})
    dataSet.push({ id:'12.13.18.2018', kecamatan:'12.13.18', name:'Padang Silojongan'})
    dataSet.push({ id:'12.09.32.2007', kecamatan:'12.09.32', name:'Padang Sipirok'})
    dataSet.push({ id:'12.05.12.2002', kecamatan:'12.05.12', name:'Padang Tualang'})
    dataSet.push({ id:'12.11.02.1007', kecamatan:'12.11.02', name:'Pagagan Julu I'})
    dataSet.push({ id:'12.11.02.2010', kecamatan:'12.11.02', name:'Pagagan Julu Ii'})
    dataSet.push({ id:'12.11.02.2009', kecamatan:'12.11.02', name:'Pagagan Julu Iii'})
    dataSet.push({ id:'12.11.02.2008', kecamatan:'12.11.02', name:'Pagagan Julu Iv'})
    dataSet.push({ id:'12.11.02.2002', kecamatan:'12.11.02', name:'Pagagan Julu Ix'})
    dataSet.push({ id:'12.11.02.2006', kecamatan:'12.11.02', name:'Pagagan Julu V'})
    dataSet.push({ id:'12.11.02.2005', kecamatan:'12.11.02', name:'Pagagan Julu Vi'})
    dataSet.push({ id:'12.11.02.2004', kecamatan:'12.11.02', name:'Pagagan Julu Vii'})
    dataSet.push({ id:'12.11.02.2003', kecamatan:'12.11.02', name:'Pagagan Julu Viii'})
    dataSet.push({ id:'12.11.02.2001', kecamatan:'12.11.02', name:'Pagagan Julu X'})
    dataSet.push({ id:'12.12.04.2022', kecamatan:'12.12.04', name:'Pagar Batu'})
    dataSet.push({ id:'12.08.30.2010', kecamatan:'12.08.30', name:'Pagar Bosi'})
    dataSet.push({ id:'12.13.08.2019', kecamatan:'12.13.08', name:'Pagar Gunung'})
    dataSet.push({ id:'12.20.03.2015', kecamatan:'12.20.03', name:'Pagar Gunung'})
    dataSet.push({ id:'12.08.11.2014', kecamatan:'12.08.11', name:'Pagar Jambi'})
    dataSet.push({ id:'12.07.28.2002', kecamatan:'12.07.28', name:'Pagar Jati'})
    dataSet.push({ id:'12.18.11.2021', kecamatan:'12.18.11', name:'Pagar Manik'})
    dataSet.push({ id:'12.07.31.2006', kecamatan:'12.07.31', name:'Pagar Merbau I'})
    dataSet.push({ id:'12.07.31.2007', kecamatan:'12.07.31', name:'Pagar Merbau Ii'})
    dataSet.push({ id:'12.07.28.2005', kecamatan:'12.07.28', name:'Pagar Merbau Iii'})
    dataSet.push({ id:'12.08.06.2011', kecamatan:'12.08.06', name:'Pagar Pinang'})
    dataSet.push({ id:'12.02.10.2003', kecamatan:'12.02.10', name:'Pagaran'})
    dataSet.push({ id:'12.21.07.2040', kecamatan:'12.21.07', name:'Pagaran Baringin'})
    dataSet.push({ id:'12.21.09.2026', kecamatan:'12.21.09', name:'Pagaran Baringin'})
    dataSet.push({ id:'12.01.05.2017', kecamatan:'12.01.05', name:'Pagaran Baru'})
    dataSet.push({ id:'12.20.07.2026', kecamatan:'12.20.07', name:'Pagaran Batu'})
    dataSet.push({ id:'12.21.01.2002', kecamatan:'12.21.01', name:'Pagaran Bira Julu'})
    dataSet.push({ id:'12.21.09.2016', kecamatan:'12.21.09', name:'Pagaran Dolok Pinarik'})
    dataSet.push({ id:'12.21.05.2009', kecamatan:'12.21.05', name:'Pagaran Dolok Sosa Jae'})
    dataSet.push({ id:'12.13.04.2011', kecamatan:'12.13.04', name:'Pagaran Gala-Gala'})
    dataSet.push({ id:'12.01.15.2008', kecamatan:'12.01.15', name:'Pagaran Honas'})
    dataSet.push({ id:'12.21.04.2008', kecamatan:'12.21.04', name:'Pagaran Jae Batu'})
    dataSet.push({ id:'12.21.04.2005', kecamatan:'12.21.04', name:'Pagaran Jalu-Jalu'})
    dataSet.push({ id:'12.01.02.2019', kecamatan:'12.01.02', name:'Pagaran Julu'})
    dataSet.push({ id:'12.20.02.2054', kecamatan:'12.20.02', name:'Pagaran Julu Ii'})
    dataSet.push({ id:'12.02.03.2006', kecamatan:'12.02.03', name:'Pagaran Lambung Iii'})
    dataSet.push({ id:'12.02.03.2007', kecamatan:'12.02.03', name:'Pagaran Lambung Iv'})
    dataSet.push({ id:'12.21.04.2012', kecamatan:'12.21.04', name:'Pagaran Malaka'})
    dataSet.push({ id:'12.21.09.2010', kecamatan:'12.21.09', name:'Pagaran Manggis'})
    dataSet.push({ id:'12.21.04.2021', kecamatan:'12.21.04', name:'Pagaran Mompang'})
    dataSet.push({ id:'12.01.05.2004', kecamatan:'12.01.05', name:'Pagaran Nauli'})
    dataSet.push({ id:'12.21.04.2002', kecamatan:'12.21.04', name:'Pagaran Silindung'})
    dataSet.push({ id:'12.20.04.2047', kecamatan:'12.20.04', name:'Pagaran Singkam'})
    dataSet.push({ id:'12.20.02.2067', kecamatan:'12.20.02', name:'Pagaran Siregar'})
    dataSet.push({ id:'12.21.09.2005', kecamatan:'12.21.09', name:'Pagaran Tayas'})
    dataSet.push({ id:'12.13.01.2017', kecamatan:'12.13.01', name:'Pagaran Tonga'})
    dataSet.push({ id:'12.20.04.2048', kecamatan:'12.20.04', name:'Pagaran Tonga'})
    dataSet.push({ id:'12.21.01.2001', kecamatan:'12.21.01', name:'Pagaranbira Jae'})
    dataSet.push({ id:'12.02.04.2013', kecamatan:'12.02.04', name:'Pagarbatu'})
    dataSet.push({ id:'12.15.06.2004', kecamatan:'12.15.06', name:'Pagindar'})
    dataSet.push({ id:'12.13.03.2006', kecamatan:'12.13.03', name:'Pagur'})
    dataSet.push({ id:'12.02.05.2004', kecamatan:'12.02.05', name:'Pagur Dotan'})
    dataSet.push({ id:'12.21.10.2002', kecamatan:'12.21.10', name:'Pagur Satio'})
    dataSet.push({ id:'12.19.01.1021', kecamatan:'12.19.01', name:'Pagurawan'})
    dataSet.push({ id:'12.03.04.2110', kecamatan:'12.03.04', name:'Pahae Aek Sagala'})
    dataSet.push({ id:'12.19.05.2008', kecamatan:'12.19.05', name:'Pahang'})
    dataSet.push({ id:'12.74.05.1006', kecamatan:'12.74.05', name:'Pahang'})
    dataSet.push({ id:'12.01.10.2003', kecamatan:'12.01.10', name:'Pahieme I'})
    dataSet.push({ id:'12.01.10.2017', kecamatan:'12.01.10', name:'Pahieme Ii'})
    dataSet.push({ id:'12.19.06.2017', kecamatan:'12.19.06', name:'Pahlawan'})
    dataSet.push({ id:'12.71.18.1002', kecamatan:'12.71.18', name:'Pahlawan'})
    dataSet.push({ id:'12.72.01.1003', kecamatan:'12.72.01', name:'Pahlawan'})
    dataSet.push({ id:'12.75.01.1001', kecamatan:'12.75.01', name:'Pahlawan'})
    dataSet.push({ id:'12.12.01.2028', kecamatan:'12.12.01', name:'Paindoan'})
    dataSet.push({ id:'12.19.01.2007', kecamatan:'12.19.01', name:'Pakam'})
    dataSet.push({ id:'12.19.01.2008', kecamatan:'12.19.01', name:'Pakam Raya'})
    dataSet.push({ id:'12.19.01.2015', kecamatan:'12.19.01', name:'Pakam Raya Selatan'})
    dataSet.push({ id:'12.13.21.2001', kecamatan:'12.13.21', name:'Pakantan Dolok'})
    dataSet.push({ id:'12.13.21.2002', kecamatan:'12.13.21', name:'Pakantan Lombang'})
    dataSet.push({ id:'12.16.06.2022', kecamatan:'12.16.06', name:'Pakkat'})
    dataSet.push({ id:'12.16.09.2015', kecamatan:'12.16.09', name:'Pakkat Hauagong'})
    dataSet.push({ id:'12.02.13.2001', kecamatan:'12.02.13', name:'Pakpahan'})
    dataSet.push({ id:'12.17.02.2001', kecamatan:'12.17.02', name:'Pakpahan'})
    dataSet.push({ id:'12.07.19.2022', kecamatan:'12.07.19', name:'Paku'})
    dataSet.push({ id:'12.11.03.2006', kecamatan:'12.11.03', name:'Palding'})
    dataSet.push({ id:'12.08.13.2015', kecamatan:'12.08.13', name:'Palianopat'})
    dataSet.push({ id:'12.11.05.2008', kecamatan:'12.11.05', name:'Palipi'})
    dataSet.push({ id:'12.17.04.2004', kecamatan:'12.17.04', name:'Palipi'})
    dataSet.push({ id:'12.03.03.2097', kecamatan:'12.03.03', name:'Pall Xi'})
    dataSet.push({ id:'12.17.04.2019', kecamatan:'12.17.04', name:'Pallombuan'})
    dataSet.push({ id:'12.77.04.1005', kecamatan:'12.77.04', name:'Palopat Maria'})
    dataSet.push({ id:'12.77.05.2003', kecamatan:'12.77.05', name:'Palopat Pijor Koling'})
    dataSet.push({ id:'12.07.28.1009', kecamatan:'12.07.28', name:'Paluh Kemiri'})
    dataSet.push({ id:'12.07.24.2020', kecamatan:'12.07.24', name:'Paluh Kurau'})
    dataSet.push({ id:'12.07.24.2018', kecamatan:'12.07.24', name:'Paluh Manan'})
    dataSet.push({ id:'12.05.13.2002', kecamatan:'12.05.13', name:'Paluh Manis'})
    dataSet.push({ id:'12.05.19.2008', kecamatan:'12.05.19', name:'Paluh Pakeh Babussalam'})
    dataSet.push({ id:'12.07.32.2016', kecamatan:'12.07.32', name:'Paluh Sibaji'})
    dataSet.push({ id:'12.11.06.2008', kecamatan:'12.11.06', name:'Pamah'})
    dataSet.push({ id:'12.18.11.2022', kecamatan:'12.18.11', name:'Pamah'})
    dataSet.push({ id:'12.05.02.2011', kecamatan:'12.05.02', name:'Pamah Tambunan'})
    dataSet.push({ id:'12.20.01.2020', kecamatan:'12.20.01', name:'Pamarai'})
    dataSet.push({ id:'12.08.02.2009', kecamatan:'12.08.02', name:'Pamatang Gajing'})
    dataSet.push({ id:'12.08.32.2010', kecamatan:'12.08.32', name:'Pamatang Sinaman'})
    dataSet.push({ id:'12.08.02.2013', kecamatan:'12.08.02', name:'Pamatang Syahkuda'})
    dataSet.push({ id:'12.20.01.2044', kecamatan:'12.20.01', name:'Pamonoran'})
    dataSet.push({ id:'12.20.05.2011', kecamatan:'12.20.05', name:'Pamuntaran'})
    dataSet.push({ id:'12.17.04.2020', kecamatan:'12.17.04', name:'Pamutaran'})
    dataSet.push({ id:'12.03.30.1001', kecamatan:'12.03.30', name:'Panabari Hutatonga'})
    dataSet.push({ id:'12.17.08.2010', kecamatan:'12.17.08', name:'Panampangan'})
    dataSet.push({ id:'12.12.04.2007', kecamatan:'12.12.04', name:'Panamparan'})
    dataSet.push({ id:'12.01.02.2018', kecamatan:'12.01.02', name:'Pananggahan'})
    dataSet.push({ id:'12.01.17.2005', kecamatan:'12.01.17', name:'Pananggahan'})
    dataSet.push({ id:'12.17.03.2005', kecamatan:'12.17.03', name:'Pananggangan'})
    dataSet.push({ id:'12.17.03.2013', kecamatan:'12.17.03', name:'Pananggangan Ii'})
    dataSet.push({ id:'12.21.10.2011', kecamatan:'12.21.10', name:'Panarian'})
    dataSet.push({ id:'12.03.04.2054', kecamatan:'12.03.04', name:'Panaungan'})
    dataSet.push({ id:'12.20.02.2043', kecamatan:'12.20.02', name:'Panca'})
    dataSet.push({ id:'12.09.29.2006', kecamatan:'12.09.29', name:'Panca Arga'})
    dataSet.push({ id:'12.21.07.2039', kecamatan:'12.21.07', name:'Pancaukan'})
    dataSet.push({ id:'12.06.05.2018', kecamatan:'12.06.05', name:'Pancur Batu'})
    dataSet.push({ id:'12.05.02.2026', kecamatan:'12.05.02', name:'Pancur Ido'})
    dataSet.push({ id:'12.20.05.2001', kecamatan:'12.20.05', name:'Pancur Pangko'})
    dataSet.push({ id:'12.73.04.1004', kecamatan:'12.73.04', name:'Pancuran Bambu'})
    dataSet.push({ id:'12.73.04.1002', kecamatan:'12.73.04', name:'Pancuran Dewa'})
    dataSet.push({ id:'12.73.02.1004', kecamatan:'12.73.02', name:'Pancuran Gerobak'})
    dataSet.push({ id:'12.73.04.1001', kecamatan:'12.73.04', name:'Pancuran Kerambil'})
    dataSet.push({ id:'12.73.04.1003', kecamatan:'12.73.04', name:'Pancuran Pinang'})
    dataSet.push({ id:'12.01.03.1001', kecamatan:'12.01.03', name:'Pandan'})
    dataSet.push({ id:'12.11.07.2007', kecamatan:'12.11.07', name:'Pandan'})
    dataSet.push({ id:'12.01.03.1016', kecamatan:'12.01.03', name:'Pandan Wangi'})
    dataSet.push({ id:'12.71.18.1001', kecamatan:'12.71.18', name:'Pandau Hilir'})
    dataSet.push({ id:'12.71.01.1005', kecamatan:'12.71.01', name:'Pandau Hulu I'})
    dataSet.push({ id:'12.71.10.1005', kecamatan:'12.71.10', name:'Pandau Hulu Ii'})
    dataSet.push({ id:'12.11.11.2008', kecamatan:'12.11.11', name:'Pandiangan'})
    dataSet.push({ id:'12.16.02.2010', kecamatan:'12.16.02', name:'Pandumaan'})
    dataSet.push({ id:'12.08.07.2002', kecamatan:'12.08.07', name:'Panduman'})
    dataSet.push({ id:'12.08.04.1011', kecamatan:'12.08.04', name:'Panei Tongah'})
    dataSet.push({ id:'12.08.11.2008', kecamatan:'12.08.11', name:'Panembean Marjanji'})
    dataSet.push({ id:'12.17.03.2001', kecamatan:'12.17.03', name:'Pangaloan'})
    dataSet.push({ id:'12.06.05.2009', kecamatan:'12.06.05', name:'Pangambatan'})
    dataSet.push({ id:'12.20.03.2016', kecamatan:'12.20.03', name:'Pangarambangan'})
    dataSet.push({ id:'12.20.02.2014', kecamatan:'12.20.02', name:'Pangaran Julu I'})
    dataSet.push({ id:'12.02.03.2013', kecamatan:'12.02.03', name:'Pangaran Lambung I'})
    dataSet.push({ id:'12.02.03.2014', kecamatan:'12.02.03', name:'Pangaran Lambung Ii'})
    dataSet.push({ id:'12.02.03.2009', kecamatan:'12.02.03', name:'Pangaran Pisang'})
    dataSet.push({ id:'12.01.12.2002', kecamatan:'12.01.12', name:'Pangaribuan'})
    dataSet.push({ id:'12.03.04.2051', kecamatan:'12.03.04', name:'Pangaribuan'})
    dataSet.push({ id:'12.03.32.2011', kecamatan:'12.03.32', name:'Pangaribuan'})
    dataSet.push({ id:'12.11.07.2009', kecamatan:'12.11.07', name:'Pangaribuan'})
    dataSet.push({ id:'12.22.03.2004', kecamatan:'12.22.03', name:'Pangarungan'})
    dataSet.push({ id:'12.13.16.2006', kecamatan:'12.13.16', name:'Panggautan'})
    dataSet.push({ id:'12.13.01.2038', kecamatan:'12.13.01', name:'Panggorengan'})
    dataSet.push({ id:'12.16.09.2021', kecamatan:'12.16.09', name:'Panggugunan'})
    dataSet.push({ id:'12.11.02.2026', kecamatan:'12.11.02', name:'Pangguruan'})
    dataSet.push({ id:'12.20.03.2004', kecamatan:'12.20.03', name:'Pangirkiran'})
    dataSet.push({ id:'12.20.09.2004', kecamatan:'12.20.09', name:'Pangirkiran'})
    dataSet.push({ id:'12.21.02.2013', kecamatan:'12.21.02', name:'Pangirkiran Dolok'})
    dataSet.push({ id:'12.20.07.2003', kecamatan:'12.20.07', name:'Pangkal Dolok Julu'})
    dataSet.push({ id:'12.20.07.2002', kecamatan:'12.20.07', name:'Pangkal Dolok Lama'})
    dataSet.push({ id:'12.13.14.2014', kecamatan:'12.13.14', name:'Pangkalan'})
    dataSet.push({ id:'12.23.07.2007', kecamatan:'12.23.07', name:'Pangkalan'})
    dataSet.push({ id:'12.05.18.1004', kecamatan:'12.05.18', name:'Pangkalan Batu'})
    dataSet.push({ id:'12.19.01.1001', kecamatan:'12.19.01', name:'Pangkalan Dodek'})
    dataSet.push({ id:'12.19.01.1002', kecamatan:'12.19.01', name:'Pangkalan Dodek Baru'})
    dataSet.push({ id:'12.23.02.2007', kecamatan:'12.23.02', name:'Pangkalan Lunang'})
    dataSet.push({ id:'12.71.11.1004', kecamatan:'12.71.11', name:'Pangkalan Mansur'})
    dataSet.push({ id:'12.05.15.2011', kecamatan:'12.05.15', name:'Pangkalan Siata'})
    dataSet.push({ id:'12.13.09.2007', kecamatan:'12.13.09', name:'Pangkat'})
    dataSet.push({ id:'12.10.14.2005', kecamatan:'12.10.14', name:'Pangkatan'})
    dataSet.push({ id:'12.18.07.2002', kecamatan:'12.18.07', name:'Panglong'})
    dataSet.push({ id:'12.12.24.2006', kecamatan:'12.12.24', name:'Pangombusan'})
    dataSet.push({ id:'12.12.04.2026', kecamatan:'12.12.04', name:'Pangunjungan'})
    dataSet.push({ id:'12.03.04.2064', kecamatan:'12.03.04', name:'Pangurabaan'})
    dataSet.push({ id:'12.12.06.2002', kecamatan:'12.12.06', name:'Pangururan'})
    dataSet.push({ id:'12.12.06.2009', kecamatan:'12.12.06', name:'Pangururan Ii'})
    dataSet.push({ id:'12.12.06.2010', kecamatan:'12.12.06', name:'Pangururan Iii'})
    dataSet.push({ id:'12.02.09.2014', kecamatan:'12.02.09', name:'Paniaran'})
    dataSet.push({ id:'12.12.03.2029', kecamatan:'12.12.03', name:'Panindi'})
    dataSet.push({ id:'12.03.30.2003', kecamatan:'12.03.30', name:'Panindoan'})
    dataSet.push({ id:'12.19.05.2009', kecamatan:'12.19.05', name:'Panjang'})
    dataSet.push({ id:'12.13.10.2015', kecamatan:'12.13.10', name:'Panjaringan'})
    dataSet.push({ id:'12.11.15.1004', kecamatan:'12.11.15', name:'Panji Dabutar'})
    dataSet.push({ id:'12.03.01.2002', kecamatan:'12.03.01', name:'Panobasan'})
    dataSet.push({ id:'12.03.01.2035', kecamatan:'12.03.01', name:'Panobasan Lombang'})
    dataSet.push({ id:'12.18.17.2003', kecamatan:'12.18.17', name:'Panombean'})
    dataSet.push({ id:'12.08.24.2004', kecamatan:'12.08.24', name:'Panombean Baru'})
    dataSet.push({ id:'12.08.06.2009', kecamatan:'12.08.06', name:'Panombean Hutaurung'})
    dataSet.push({ id:'12.08.05.2001', kecamatan:'12.08.05', name:'Panombeian'})
    dataSet.push({ id:'12.03.03.2094', kecamatan:'12.03.03', name:'Panompuan'})
    dataSet.push({ id:'12.03.03.2003', kecamatan:'12.03.03', name:'Panompuan Jae'})
    dataSet.push({ id:'12.02.02.2002', kecamatan:'12.02.02', name:'Pansur Napitu'})
    dataSet.push({ id:'12.02.03.2002', kecamatan:'12.02.03', name:'Pansurbatu'})
    dataSet.push({ id:'12.16.02.2007', kecamatan:'12.16.02', name:'Pansurbatu'})
    dataSet.push({ id:'12.02.03.2015', kecamatan:'12.02.03', name:'Pansurbatu I'})
    dataSet.push({ id:'12.02.03.2016', kecamatan:'12.02.03', name:'Pansurbatu Ii'})
    dataSet.push({ id:'12.02.13.2011', kecamatan:'12.02.13', name:'Pansurnatolu'})
    dataSet.push({ id:'12.74.01.1005', kecamatan:'12.74.01', name:'Pantai Burung'})
    dataSet.push({ id:'12.05.11.2008', kecamatan:'12.05.11', name:'Pantai Cermin'})
    dataSet.push({ id:'12.18.01.2001', kecamatan:'12.18.01', name:'Pantai Cermin Kanan'})
    dataSet.push({ id:'12.18.01.2002', kecamatan:'12.18.01', name:'Pantai Cermin Kiri'})
    dataSet.push({ id:'12.05.09.2016', kecamatan:'12.05.09', name:'Pantai Gading'})
    dataSet.push({ id:'12.05.07.2008', kecamatan:'12.05.07', name:'Pantai Gemi'})
    dataSet.push({ id:'12.74.05.1010', kecamatan:'12.74.05', name:'Pantai Johor'})
    dataSet.push({ id:'12.07.32.2008', kecamatan:'12.07.32', name:'Pantai Labu Baru'})
    dataSet.push({ id:'12.07.32.2007', kecamatan:'12.07.32', name:'Pantai Labu Pekan'})
    dataSet.push({ id:'12.02.05.2016', kecamatan:'12.02.05', name:'Pantis'})
    dataSet.push({ id:'12.08.01.2014', kecamatan:'12.08.01', name:'Pantoan Maju'})
    dataSet.push({ id:'12.13.17.2005', kecamatan:'12.13.17', name:'Panunggulan'})
    dataSet.push({ id:'12.20.01.2024', kecamatan:'12.20.01', name:'Panyabungan'})
    dataSet.push({ id:'12.21.05.2012', kecamatan:'12.21.05', name:'Panyabungan'})
    dataSet.push({ id:'12.13.01.1033', kecamatan:'12.13.01', name:'Panyabungan I'})
    dataSet.push({ id:'12.13.01.1031', kecamatan:'12.13.01', name:'Panyabungan Ii'})
    dataSet.push({ id:'12.13.01.1032', kecamatan:'12.13.01', name:'Panyabungan Iii'})
    dataSet.push({ id:'12.13.01.2018', kecamatan:'12.13.01', name:'Panyabungan Jae'})
    dataSet.push({ id:'12.13.01.2019', kecamatan:'12.13.01', name:'Panyabungan Julu'})
    dataSet.push({ id:'12.13.01.2020', kecamatan:'12.13.01', name:'Panyabungan Tonga'})
    dataSet.push({ id:'12.77.01.1010', kecamatan:'12.77.01', name:'Panyanggar'})
    dataSet.push({ id:'12.20.03.2003', kecamatan:'12.20.03', name:'Paolan'})
    dataSet.push({ id:'12.02.15.2014', kecamatan:'12.02.15', name:'Papande'})
    dataSet.push({ id:'12.21.09.2023', kecamatan:'12.21.09', name:'Papaso'})
    dataSet.push({ id:'12.17.07.2007', kecamatan:'12.17.07', name:'Paraduan'})
    dataSet.push({ id:'12.21.06.2011', kecamatan:'12.21.06', name:'Paran Batu'})
    dataSet.push({ id:'12.21.12.2005', kecamatan:'12.21.12', name:'Paran Dolok'})
    dataSet.push({ id:'12.03.04.2106', kecamatan:'12.03.04', name:'Paran Dolok Mardomu'})
    dataSet.push({ id:'12.20.05.2012', kecamatan:'12.20.05', name:'Paran Gadung'})
    dataSet.push({ id:'12.20.03.2042', kecamatan:'12.20.03', name:'Paran Honas'})
    dataSet.push({ id:'12.03.04.2048', kecamatan:'12.03.04', name:'Paran Julu'})
    dataSet.push({ id:'12.21.11.2014', kecamatan:'12.21.11', name:'Paran Julu'})
    dataSet.push({ id:'12.20.05.2003', kecamatan:'12.20.05', name:'Paran Nangka'})
    dataSet.push({ id:'12.21.02.2056', kecamatan:'12.21.02', name:'Paran Napa Dolok'})
    dataSet.push({ id:'12.21.02.2067', kecamatan:'12.21.02', name:'Paran Napa Jae'})
    dataSet.push({ id:'12.03.04.2060', kecamatan:'12.03.04', name:'Paran Padang'})
    dataSet.push({ id:'12.20.04.2018', kecamatan:'12.20.04', name:'Paran Padang'})
    dataSet.push({ id:'12.20.08.2020', kecamatan:'12.20.08', name:'Paran Padang'})
    dataSet.push({ id:'12.21.03.2004', kecamatan:'12.21.03', name:'Paran Tonga'})
    dataSet.push({ id:'12.21.11.2013', kecamatan:'12.21.11', name:'Paran Tonga'})
    dataSet.push({ id:'12.20.08.2030', kecamatan:'12.20.08', name:'Paran Tonga Sim'})
    dataSet.push({ id:'12.05.02.2021', kecamatan:'12.05.02', name:'Parangguam'})
    dataSet.push({ id:'12.16.04.2002', kecamatan:'12.16.04', name:'Paranginan Selatan'})
    dataSet.push({ id:'12.16.04.2003', kecamatan:'12.16.04', name:'Paranginan Utara'})
    dataSet.push({ id:'12.08.16.1004', kecamatan:'12.08.16', name:'Parapat'})
    dataSet.push({ id:'12.21.08.2005', kecamatan:'12.21.08', name:'Parapat'})
    dataSet.push({ id:'12.12.04.2024', kecamatan:'12.12.04', name:'Pararungan'})
    dataSet.push({ id:'12.03.04.1061', kecamatan:'12.03.04', name:'Parau Sorat'})
    dataSet.push({ id:'12.20.07.2009', kecamatan:'12.20.07', name:'Parau Sorat'})
    dataSet.push({ id:'12.21.08.2022', kecamatan:'12.21.08', name:'Parau Sorat'})
    dataSet.push({ id:'12.03.05.2075', kecamatan:'12.03.05', name:'Parau Sorat Sitabo-Tabo'})
    dataSet.push({ id:'12.17.08.2003', kecamatan:'12.17.08', name:'Parbaba Dolok'})
    dataSet.push({ id:'12.12.10.2015', kecamatan:'12.12.10', name:'Parbagasan Janji Matogu'})
    dataSet.push({ id:'12.02.01.2023', kecamatan:'12.02.01', name:'Parbaju Julu'})
    dataSet.push({ id:'12.02.01.2024', kecamatan:'12.02.01', name:'Parbaju Tonga'})
    dataSet.push({ id:'12.02.01.2022', kecamatan:'12.02.01', name:'Parbaju Toruan'})
    dataSet.push({ id:'12.08.11.2019', kecamatan:'12.08.11', name:'Parbalogan'})
    dataSet.push({ id:'12.17.01.2013', kecamatan:'12.17.01', name:'Parbalohan'})
    dataSet.push({ id:'12.16.08.2003', kecamatan:'12.16.08', name:'Parbotihan'})
    dataSet.push({ id:'12.02.01.2014', kecamatan:'12.02.01', name:'Parbubu Dolok'})
    dataSet.push({ id:'12.02.01.2008', kecamatan:'12.02.01', name:'Parbubu I'})
    dataSet.push({ id:'12.02.01.2009', kecamatan:'12.02.01', name:'Parbubu Ii'})
    dataSet.push({ id:'12.02.01.2017', kecamatan:'12.02.01', name:'Parbubu Pea'})
    dataSet.push({ id:'12.11.10.2006', kecamatan:'12.11.10', name:'Parbuluan I'})
    dataSet.push({ id:'12.11.10.2005', kecamatan:'12.11.10', name:'Parbuluan Ii'})
    dataSet.push({ id:'12.11.10.2004', kecamatan:'12.11.10', name:'Parbuluan Iii'})
    dataSet.push({ id:'12.11.10.2003', kecamatan:'12.11.10', name:'Parbuluan Iv'})
    dataSet.push({ id:'12.11.10.2007', kecamatan:'12.11.10', name:'Parbuluan V'})
    dataSet.push({ id:'12.11.10.2008', kecamatan:'12.11.10', name:'Parbuluan Vi'})
    dataSet.push({ id:'12.08.08.2001', kecamatan:'12.08.08', name:'Parbutaran'})
    dataSet.push({ id:'12.08.23.2007', kecamatan:'12.08.23', name:'Pardagangan Ii'})
    dataSet.push({ id:'12.01.02.2006', kecamatan:'12.01.02', name:'Pardamean'})
    dataSet.push({ id:'12.03.29.2003', kecamatan:'12.03.29', name:'Pardamean'})
    dataSet.push({ id:'12.10.02.1007', kecamatan:'12.10.02', name:'Pardamean'})
    dataSet.push({ id:'12.72.05.1006', kecamatan:'12.72.05', name:'Pardamean'})
    dataSet.push({ id:'12.12.08.2003', kecamatan:'12.12.08', name:'Pardamean Ajibata'})
    dataSet.push({ id:'12.08.11.2010', kecamatan:'12.08.11', name:'Pardamean Asih'})
    dataSet.push({ id:'12.13.16.2007', kecamatan:'12.13.16', name:'Pardamean Baru'})
    dataSet.push({ id:'12.02.06.2013', kecamatan:'12.02.06', name:'Pardamean Nainggolan'})
    dataSet.push({ id:'12.12.08.2008', kecamatan:'12.12.08', name:'Pardamean Sibisa'})
    dataSet.push({ id:'12.12.01.1036', kecamatan:'12.12.01', name:'Pardede Onan'})
    dataSet.push({ id:'12.12.02.2018', kecamatan:'12.12.02', name:'Pardinggaran'})
    dataSet.push({ id:'12.12.23.2012', kecamatan:'12.12.23', name:'Pardolok Lumban Lobu'})
    dataSet.push({ id:'12.01.11.2004', kecamatan:'12.01.11', name:'Pardomuan'})
    dataSet.push({ id:'12.02.07.2008', kecamatan:'12.02.07', name:'Pardomuan'})
    dataSet.push({ id:'12.03.06.1019', kecamatan:'12.03.06', name:'Pardomuan'})
    dataSet.push({ id:'12.03.14.2033', kecamatan:'12.03.14', name:'Pardomuan'})
    dataSet.push({ id:'12.11.08.2003', kecamatan:'12.11.08', name:'Pardomuan'})
    dataSet.push({ id:'12.12.03.2017', kecamatan:'12.12.03', name:'Pardomuan'})
    dataSet.push({ id:'12.13.03.2007', kecamatan:'12.13.03', name:'Pardomuan'})
    dataSet.push({ id:'12.15.02.2006', kecamatan:'12.15.02', name:'Pardomuan'})
    dataSet.push({ id:'12.15.04.2002', kecamatan:'12.15.04', name:'Pardomuan'})
    dataSet.push({ id:'12.16.02.2012', kecamatan:'12.16.02', name:'Pardomuan'})
    dataSet.push({ id:'12.17.01.2011', kecamatan:'12.17.01', name:'Pardomuan'})
    dataSet.push({ id:'12.17.02.2004', kecamatan:'12.17.02', name:'Pardomuan'})
    dataSet.push({ id:'12.18.09.2011', kecamatan:'12.18.09', name:'Pardomuan'})
    dataSet.push({ id:'12.72.01.1006', kecamatan:'12.72.01', name:'Pardomuan'})
    dataSet.push({ id:'12.12.08.2002', kecamatan:'12.12.08', name:'Pardomuan Ajibata'})
    dataSet.push({ id:'12.08.27.2016', kecamatan:'12.08.27', name:'Pardomuan Bandar'})
    dataSet.push({ id:'12.17.08.2021', kecamatan:'12.17.08', name:'Pardomuan I'})
    dataSet.push({ id:'12.02.08.2004', kecamatan:'12.02.08', name:'Pardomuan Janji Angkola'})
    dataSet.push({ id:'12.12.08.2010', kecamatan:'12.12.08', name:'Pardomuan Motung'})
    dataSet.push({ id:'12.02.06.2007', kecamatan:'12.02.06', name:'Pardomuan Nainggolan'})
    dataSet.push({ id:'12.02.03.2003', kecamatan:'12.02.03', name:'Pardomuan Nauli'})
    dataSet.push({ id:'12.08.21.2005', kecamatan:'12.08.21', name:'Pardomuan Nauli'})
    dataSet.push({ id:'12.12.02.2009', kecamatan:'12.12.02', name:'Pardomuan Nauli'})
    dataSet.push({ id:'12.12.06.2003', kecamatan:'12.12.06', name:'Pardomuan Nauli'})
    dataSet.push({ id:'12.17.04.2005', kecamatan:'12.17.04', name:'Pardomuan Nauli'})
    dataSet.push({ id:'12.17.08.2006', kecamatan:'12.17.08', name:'Pardomuan Nauli'})
    dataSet.push({ id:'12.08.27.2002', kecamatan:'12.08.27', name:'Pardomuan Tongah'})
    dataSet.push({ id:'12.17.08.2011', kecamatan:'12.17.08', name:'Pardugul'})
    dataSet.push({ id:'12.11.02.2017', kecamatan:'12.11.02', name:'Pargambiran'})
    dataSet.push({ id:'12.01.06.2014', kecamatan:'12.01.06', name:'Pargaringan'})
    dataSet.push({ id:'12.01.02.1002', kecamatan:'12.01.02', name:'Pargarutan'})
    dataSet.push({ id:'12.03.04.2052', kecamatan:'12.03.04', name:'Pargarutan'})
    dataSet.push({ id:'12.03.03.2095', kecamatan:'12.03.03', name:'Pargarutan Dolok'})
    dataSet.push({ id:'12.03.03.2083', kecamatan:'12.03.03', name:'Pargarutan Jae'})
    dataSet.push({ id:'12.03.03.2013', kecamatan:'12.03.03', name:'Pargarutan Julu'})
    dataSet.push({ id:'12.03.03.2004', kecamatan:'12.03.03', name:'Pargarutan Tonga'})
    dataSet.push({ id:'12.16.05.2005', kecamatan:'12.16.05', name:'Pargaulan'})
    dataSet.push({ id:'12.03.32.2010', kecamatan:'12.03.32', name:'Pargumbangan'})
    dataSet.push({ id:'12.12.10.2005', kecamatan:'12.12.10', name:'Parhabinsaran Janji Matogu'})
    dataSet.push({ id:'12.17.08.2005', kecamatan:'12.17.08', name:'Parhorasan'})
    dataSet.push({ id:'12.72.05.1008', kecamatan:'12.72.05', name:'Parhorasan Nauli'})
    dataSet.push({ id:'12.02.10.2008', kecamatan:'12.02.10', name:'Parhorboan'})
    dataSet.push({ id:'12.08.12.2008', kecamatan:'12.08.12', name:'Parhundalian Jawa Dipar'})
    dataSet.push({ id:'12.17.03.1011', kecamatan:'12.17.03', name:'Parhusip Iii'})
    dataSet.push({ id:'12.08.26.2002', kecamatan:'12.08.26', name:'Paribuan'})
    dataSet.push({ id:'12.06.03.2001', kecamatan:'12.06.03', name:'Paribun'})
    dataSet.push({ id:'12.20.02.2068', kecamatan:'12.20.02', name:'Parigi'})
    dataSet.push({ id:'12.12.10.2006', kecamatan:'12.12.10', name:'Parik'})
    dataSet.push({ id:'12.02.09.2015', kecamatan:'12.02.09', name:'Parik Sabungan'})
    dataSet.push({ id:'12.08.20.2002', kecamatan:'12.08.20', name:'Parik Sabungan'})
    dataSet.push({ id:'12.01.17.2003', kecamatan:'12.01.17', name:'Parik Sinomba'})
    dataSet.push({ id:'12.16.06.2019', kecamatan:'12.16.06', name:'Parik Sinomba'})
    dataSet.push({ id:'12.06.06.2018', kecamatan:'12.06.06', name:'Parimbalang'})
    dataSet.push({ id:'12.22.04.2007', kecamatan:'12.22.04', name:'Parimburan'})
    dataSet.push({ id:'12.21.06.2009', kecamatan:'12.21.06', name:'Paringgonan'})
    dataSet.push({ id:'12.21.06.2010', kecamatan:'12.21.06', name:'Paringgonan Julu'})
    dataSet.push({ id:'12.02.14.2012', kecamatan:'12.02.14', name:'Parinsoran'})
    dataSet.push({ id:'12.05.03.2012', kecamatan:'12.05.03', name:'Parit Bindu'})
    dataSet.push({ id:'12.18.07.2007', kecamatan:'12.18.07', name:'Paritokan'})
    dataSet.push({ id:'12.08.32.2007', kecamatan:'12.08.32', name:'Parjalangan'})
    dataSet.push({ id:'12.01.04.2006', kecamatan:'12.01.04', name:'Parjalihotan Baru'})
    dataSet.push({ id:'12.18.08.2009', kecamatan:'12.18.08', name:'Parlambean'})
    dataSet.push({ id:'12.20.04.2064', kecamatan:'12.20.04', name:'Parlimbatan'})
    dataSet.push({ id:'12.02.13.2012', kecamatan:'12.02.13', name:'Parlombuan'})
    dataSet.push({ id:'12.17.08.2013', kecamatan:'12.17.08', name:'Parlondut'})
    dataSet.push({ id:'12.21.05.2008', kecamatan:'12.21.05', name:'Parmainan'})
    dataSet.push({ id:'12.02.14.2013', kecamatan:'12.02.14', name:'Parmanuhan'})
    dataSet.push({ id:'12.20.02.2042', kecamatan:'12.20.02', name:'Parmeraan'})
    dataSet.push({ id:'12.20.09.2010', kecamatan:'12.20.09', name:'Parmeraan'})
    dataSet.push({ id:'12.13.03.2008', kecamatan:'12.13.03', name:'Parmompang'})
    dataSet.push({ id:'12.08.06.2013', kecamatan:'12.08.06', name:'Parmonangan'})
    dataSet.push({ id:'12.16.09.2008', kecamatan:'12.16.09', name:'Parmonangan'})
    dataSet.push({ id:'12.17.01.2012', kecamatan:'12.17.01', name:'Parmonangan'})
    dataSet.push({ id:'12.17.08.2015', kecamatan:'12.17.08', name:'Parmonangan'})
    dataSet.push({ id:'12.16.08.2005', kecamatan:'12.16.08', name:'Parnapa'})
    dataSet.push({ id:'12.11.05.1014', kecamatan:'12.11.05', name:'Parongil'})
    dataSet.push({ id:'12.11.14.2003', kecamatan:'12.11.14', name:'Paropo'})
    dataSet.push({ id:'12.11.14.2005', kecamatan:'12.11.14', name:'Paropo I'})
    dataSet.push({ id:'12.12.07.2031', kecamatan:'12.12.07', name:'Parparean I'})
    dataSet.push({ id:'12.12.07.2033', kecamatan:'12.12.07', name:'Parparean II'})
    dataSet.push({ id:'12.12.07.1039', kecamatan:'12.12.07', name:'Parparean Iii'})
    dataSet.push({ id:'12.12.07.2030', kecamatan:'12.12.07', name:'Parparean Iv'})
    dataSet.push({ id:'12.23.01.2004', kecamatan:'12.23.01', name:'Parpaudangan'})
    dataSet.push({ id:'12.02.13.2004', kecamatan:'12.02.13', name:'Parratusan'})
    dataSet.push({ id:'12.03.01.2011', kecamatan:'12.03.01', name:'Parsalakan'})
    dataSet.push({ id:'12.12.03.2003', kecamatan:'12.12.03', name:'Parsambilan'})
    dataSet.push({ id:'12.17.09.2007', kecamatan:'12.17.09', name:'Parsaoran'})
    dataSet.push({ id:'12.12.08.1009', kecamatan:'12.12.08', name:'Parsaoran Ajibata'})
    dataSet.push({ id:'12.17.08.2007', kecamatan:'12.17.08', name:'Parsaoran I'})
    dataSet.push({ id:'12.02.08.2011', kecamatan:'12.02.08', name:'Parsaoran Janji Angkola'})
    dataSet.push({ id:'12.02.06.2012', kecamatan:'12.02.06', name:'Parsaoran Nainggolan'})
    dataSet.push({ id:'12.02.06.2009', kecamatan:'12.02.06', name:'Parsaoran Samosir'})
    dataSet.push({ id:'12.12.08.2007', kecamatan:'12.12.08', name:'Parsaoran Sibisa'})
    dataSet.push({ id:'12.17.04.2011', kecamatan:'12.17.04', name:'Parsaoran Urat'})
    dataSet.push({ id:'12.20.06.2011', kecamatan:'12.20.06', name:'Parsarmaan'})
    dataSet.push({ id:'12.02.13.2018', kecamatan:'12.02.13', name:'Parsibarungan'})
    dataSet.push({ id:'12.01.05.2018', kecamatan:'12.01.05', name:'Parsihotangan'})
    dataSet.push({ id:'12.16.02.2001', kecamatan:'12.16.02', name:'Parsingguran I'})
    dataSet.push({ id:'12.16.02.2006', kecamatan:'12.16.02', name:'Parsingguran Ii'})
    dataSet.push({ id:'12.12.04.2010', kecamatan:'12.12.04', name:'Parsoburan Barat'})
    dataSet.push({ id:'12.12.04.1009', kecamatan:'12.12.04', name:'Parsoburan Tengah'})
    dataSet.push({ id:'12.21.04.2022', kecamatan:'12.21.04', name:'Parsombaan'})
    dataSet.push({ id:'12.02.13.2022', kecamatan:'12.02.13', name:'Parsorminan I'})
    dataSet.push({ id:'12.02.14.2003', kecamatan:'12.02.14', name:'Parsosoran'})
    dataSet.push({ id:'12.12.01.2011', kecamatan:'12.12.01', name:'Parsuratan'})
    dataSet.push({ id:'12.02.01.2029', kecamatan:'12.02.01', name:'Partali Julu'})
    dataSet.push({ id:'12.06.05.2011', kecamatan:'12.06.05', name:'Partibi Lama'})
    dataSet.push({ id:'12.06.05.2001', kecamatan:'12.06.05', name:'Partibi Tembe'})
    dataSet.push({ id:'12.77.04.2009', kecamatan:'12.77.04', name:'Partihaman Saroha'})
    dataSet.push({ id:'12.02.01.1001', kecamatan:'12.02.01', name:'Partoli Toruan'})
    dataSet.push({ id:'12.12.10.2004', kecamatan:'12.12.10', name:'Partor Janji Matogu'})
    dataSet.push({ id:'12.12.10.2016', kecamatan:'12.12.10', name:'Partoruan Janji Matogu'})
    dataSet.push({ id:'12.12.23.2011', kecamatan:'12.12.23', name:'Partoruan Lumban Lobu'})
    dataSet.push({ id:'12.08.32.2008', kecamatan:'12.08.32', name:'Partuahan'})
    dataSet.push({ id:'12.17.05.2002', kecamatan:'12.17.05', name:'Partungkonaginjang'})
    dataSet.push({ id:'12.16.05.2017', kecamatan:'12.16.05', name:'Parulohan'})
    dataSet.push({ id:'12.20.05.2021', kecamatan:'12.20.05', name:'Parupuk Jae'})
    dataSet.push({ id:'12.20.05.2022', kecamatan:'12.20.05', name:'Parupuk Julu'})
    dataSet.push({ id:'12.20.01.2002', kecamatan:'12.20.01', name:'Pasang Lela'})
    dataSet.push({ id:'12.23.06.2011', kecamatan:'12.23.06', name:'Pasang Lela'})
    dataSet.push({ id:'12.01.03.1021', kecamatan:'12.01.03', name:'Pasar Baru'})
    dataSet.push({ id:'12.06.07.2011', kecamatan:'12.06.07', name:'Pasar Baru'})
    dataSet.push({ id:'12.18.03.2006', kecamatan:'12.18.03', name:'Pasar Baru'})
    dataSet.push({ id:'12.71.01.1001', kecamatan:'12.71.01', name:'Pasar Baru'})
    dataSet.push({ id:'12.74.03.1004', kecamatan:'12.74.03', name:'Pasar Baru'})
    dataSet.push({ id:'12.76.05.1002', kecamatan:'12.76.05', name:'Pasar Baru'})
    dataSet.push({ id:'12.13.15.1011', kecamatan:'12.13.15', name:'Pasar Baru Batahan'})
    dataSet.push({ id:'12.13.07.2008', kecamatan:'12.13.07', name:'Pasar Baru Malintang'})
    dataSet.push({ id:'12.13.15.2012', kecamatan:'12.13.15', name:'Pasar Batahan'})
    dataSet.push({ id:'12.01.01.1001', kecamatan:'12.01.01', name:'Pasar Batu Gerigis'})
    dataSet.push({ id:'12.21.02.2002', kecamatan:'12.21.02', name:'Pasar Binanga'})
    dataSet.push({ id:'12.12.06.2015', kecamatan:'12.12.06', name:'Pasar Borbor'})
    dataSet.push({ id:'12.16.06.1001', kecamatan:'12.16.06', name:'Pasar Dolok Sanggul'})
    dataSet.push({ id:'12.76.05.1003', kecamatan:'12.76.05', name:'Pasar Gambir'})
    dataSet.push({ id:'12.20.04.1001', kecamatan:'12.20.04', name:'Pasar Gunung Tua'})
    dataSet.push({ id:'12.13.01.1022', kecamatan:'12.13.01', name:'Pasar Hilir'})
    dataSet.push({ id:'12.21.03.2014', kecamatan:'12.21.03', name:'Pasar Huristak'})
    dataSet.push({ id:'12.13.19.2003', kecamatan:'12.13.19', name:'Pasar Huta Bargot'})
    dataSet.push({ id:'12.13.16.1025', kecamatan:'12.13.16', name:'Pasar I Natal'})
    dataSet.push({ id:'12.13.16.1008', kecamatan:'12.13.16', name:'Pasar II Natal'})
    dataSet.push({ id:'12.13.16.2009', kecamatan:'12.13.16', name:'Pasar Iii Natal'})
    dataSet.push({ id:'12.21.06.2008', kecamatan:'12.21.06', name:'Pasar Ipuh'})
    dataSet.push({ id:'12.05.04.2011', kecamatan:'12.05.04', name:'Pasar IV Namo Terasi'})
    dataSet.push({ id:'12.13.08.1036', kecamatan:'12.13.08', name:'Pasar Kotanopan'})
    dataSet.push({ id:'12.24.10.1001', kecamatan:'12.24.10', name:'Pasar Lahewa'})
    dataSet.push({ id:'12.03.07.2021', kecamatan:'12.03.07', name:'Pasar Lama'})
    dataSet.push({ id:'12.19.03.2009', kecamatan:'12.19.03', name:'Pasar Lapan'})
    dataSet.push({ id:'12.13.10.2016', kecamatan:'12.13.10', name:'Pasar Laru'})
    dataSet.push({ id:'12.21.04.2007', kecamatan:'12.21.04', name:'Pasar Latong'})
    dataSet.push({ id:'12.09.09.2007', kecamatan:'12.09.09', name:'Pasar Lembu'})
    dataSet.push({ id:'12.12.09.2007', kecamatan:'12.12.09', name:'Pasar Lumban Julu'})
    dataSet.push({ id:'12.13.09.1008', kecamatan:'12.13.09', name:'Pasar Maga'})
    dataSet.push({ id:'12.20.07.2010', kecamatan:'12.20.07', name:'Pasar Matanggor'})
    dataSet.push({ id:'12.07.28.2004', kecamatan:'12.07.28', name:'Pasar Melintang'})
    dataSet.push({ id:'12.71.01.1007', kecamatan:'12.71.01', name:'Pasar Merah Barat'})
    dataSet.push({ id:'12.71.10.1009', kecamatan:'12.71.10', name:'Pasar Merah Timur'})
    dataSet.push({ id:'12.13.12.1019', kecamatan:'12.13.12', name:'Pasar Muara Sipongi'})
    dataSet.push({ id:'12.01.06.1006', kecamatan:'12.01.06', name:'Pasar Onan Hurlang'})
    dataSet.push({ id:'12.01.05.1001', kecamatan:'12.01.05', name:'Pasar Onan Manduamas'})
    dataSet.push({ id:'12.17.08.1026', kecamatan:'12.17.08', name:'Pasar Pangururan'})
    dataSet.push({ id:'12.21.05.2013', kecamatan:'12.21.05', name:'Pasar Panyabungan'})
    dataSet.push({ id:'12.03.03.1098', kecamatan:'12.03.03', name:'Pasar Pargarutan'})
    dataSet.push({ id:'12.12.07.1037', kecamatan:'12.12.07', name:'Pasar Porsea'})
    dataSet.push({ id:'12.14.05.1046', kecamatan:'12.14.05', name:'Pasar Pulau Tello'})
    dataSet.push({ id:'12.05.13.2003', kecamatan:'12.05.13', name:'Pasar Rawa'})
    dataSet.push({ id:'12.20.01.2040', kecamatan:'12.20.01', name:'Pasar Sayur Matinggi'})
    dataSet.push({ id:'12.03.20.1004', kecamatan:'12.03.20', name:'Pasar Sempurna'})
    dataSet.push({ id:'12.02.09.1001', kecamatan:'12.02.09', name:'Pasar Siborong Borong'})
    dataSet.push({ id:'12.21.07.1001', kecamatan:'12.21.07', name:'Pasar Sibuhuan'})
    dataSet.push({ id:'12.20.01.2043', kecamatan:'12.20.01', name:'Pasar Simundol'})
    dataSet.push({ id:'12.13.17.2006', kecamatan:'12.13.17', name:'Pasar Singkuang I'})
    dataSet.push({ id:'12.13.17.2007', kecamatan:'12.13.17', name:'Pasar Singkuang Ii'})
    dataSet.push({ id:'12.03.05.1001', kecamatan:'12.03.05', name:'Pasar Sipagimbar'})
    dataSet.push({ id:'12.20.02.2006', kecamatan:'12.20.02', name:'Pasar Sipiongot'})
    dataSet.push({ id:'12.03.04.1001', kecamatan:'12.03.04', name:'Pasar Sipirok'})
    dataSet.push({ id:'12.01.10.2004', kecamatan:'12.01.10', name:'Pasar Sorkam'})
    dataSet.push({ id:'12.14.06.1008', kecamatan:'12.14.06', name:'Pasar Teluk Dalam'})
    dataSet.push({ id:'12.01.01.2004', kecamatan:'12.01.01', name:'Pasar Terandam'})
    dataSet.push({ id:'12.10.18.2010', kecamatan:'12.10.18', name:'Pasar Tiga'})
    dataSet.push({ id:'12.21.08.2006', kecamatan:'12.21.08', name:'Pasar Ujung Batu'})
    dataSet.push({ id:'12.07.33.2006', kecamatan:'12.07.33', name:'Pasar V Kebun Kelapa'})
    dataSet.push({ id:'12.13.16.2010', kecamatan:'12.13.16', name:'Pasar V Natal'})
    dataSet.push({ id:'12.07.33.2004', kecamatan:'12.07.33', name:'Pasar Vi Kuala Namu'})
    dataSet.push({ id:'12.05.04.2008', kecamatan:'12.05.04', name:'Pasar Vi Kwala Mencirim'})
    dataSet.push({ id:'12.13.16.2026', kecamatan:'12.13.16', name:'Pasar Vi Natal'})
    dataSet.push({ id:'12.05.04.2012', kecamatan:'12.05.04', name:'Pasar VIII Namo Terasi'})
    dataSet.push({ id:'12.07.04.2004', kecamatan:'12.07.04', name:'Pasar X'})
    dataSet.push({ id:'12.17.03.2010', kecamatan:'12.17.03', name:'Pasaran I'})
    dataSet.push({ id:'12.17.03.2006', kecamatan:'12.17.03', name:'Pasaran Parsaoran'})
    dataSet.push({ id:'12.16.06.2004', kecamatan:'12.16.06', name:'Pasaribu'})
    dataSet.push({ id:'12.01.16.2004', kecamatan:'12.01.16', name:'Pasaribu Tobing'})
    dataSet.push({ id:'12.01.10.2006', kecamatan:'12.01.10', name:'Pasaribu Tobing Jae'})
    dataSet.push({ id:'12.11.13.2002', kecamatan:'12.11.13', name:'Pasi'})
    dataSet.push({ id:'12.20.07.2025', kecamatan:'12.20.07', name:'Pasir Ampolu Hopong'})
    dataSet.push({ id:'12.20.11.2003', kecamatan:'12.20.11', name:'Pasir Bara'})
    dataSet.push({ id:'12.01.20.1004', kecamatan:'12.01.20', name:'Pasir Bidang'})
    dataSet.push({ id:'12.21.08.2003', kecamatan:'12.21.08', name:'Pasir Jae'})
    dataSet.push({ id:'12.21.08.2033', kecamatan:'12.21.08', name:'Pasir Julu'})
    dataSet.push({ id:'12.21.03.2016', kecamatan:'12.21.03', name:'Pasir Lancat Baru'})
    dataSet.push({ id:'12.21.03.2008', kecamatan:'12.21.03', name:'Pasir Lancat Lama'})
    dataSet.push({ id:'12.20.12.2013', kecamatan:'12.20.12', name:'Pasir Lancat Ub'})
    dataSet.push({ id:'12.03.32.2012', kecamatan:'12.03.32', name:'Pasir Matogu'})
    dataSet.push({ id:'12.11.06.2018', kecamatan:'12.11.06', name:'Pasir Mbelang'})
    dataSet.push({ id:'12.19.09.2006', kecamatan:'12.19.09', name:'Pasir Permit'})
    dataSet.push({ id:'12.20.06.2016', kecamatan:'12.20.06', name:'Pasir Pinang'})
    dataSet.push({ id:'12.21.03.2027', kecamatan:'12.21.03', name:'Pasir Pinang'})
    dataSet.push({ id:'12.13.22.2013', kecamatan:'12.13.22', name:'Pasir Putih'})
    dataSet.push({ id:'12.11.06.2010', kecamatan:'12.11.06', name:'Pasir Tengah'})
    dataSet.push({ id:'12.22.01.2004', kecamatan:'12.22.01', name:'Pasir Tuntung'})
    dataSet.push({ id:'12.05.13.2011', kecamatan:'12.05.13', name:'Pasiran'})
    dataSet.push({ id:'12.09.23.2010', kecamatan:'12.09.23', name:'Pasiran'})
    dataSet.push({ id:'12.13.10.2017', kecamatan:'12.13.10', name:'Pastap'})
    dataSet.push({ id:'12.13.10.2018', kecamatan:'12.13.10', name:'Pastap Julu'})
    dataSet.push({ id:'12.13.11.2007', kecamatan:'12.13.11', name:'Patahajang'})
    dataSet.push({ id:'12.12.07.2036', kecamatan:'12.12.07', name:'Patane I'})
    dataSet.push({ id:'12.12.07.2007', kecamatan:'12.12.07', name:'Patane Ii'})
    dataSet.push({ id:'12.12.07.1038', kecamatan:'12.12.07', name:'Patane Iii'})
    dataSet.push({ id:'12.12.07.2001', kecamatan:'12.12.07', name:'Patane Iv'})
    dataSet.push({ id:'12.12.07.2040', kecamatan:'12.12.07', name:'Patane V'})
    dataSet.push({ id:'12.13.08.2021', kecamatan:'12.13.08', name:'Patialo'})
    dataSet.push({ id:'12.13.16.2011', kecamatan:'12.13.16', name:'Patiluban Hilir'})
    dataSet.push({ id:'12.13.16.2012', kecamatan:'12.13.16', name:'Patiluban Mudik'})
    dataSet.push({ id:'12.08.24.2007', kecamatan:'12.08.24', name:'Patimbalan'})
    dataSet.push({ id:'12.07.21.2002', kecamatan:'12.07.21', name:'Patumbak I'})
    dataSet.push({ id:'12.07.21.2003', kecamatan:'12.07.21', name:'Patumbak Ii'})
    dataSet.push({ id:'12.07.21.2008', kecamatan:'12.07.21', name:'Patumbak Kampung'})
    dataSet.push({ id:'12.01.01.2010', kecamatan:'12.01.01', name:'Patupangan'})
    dataSet.push({ id:'12.18.13.2008', kecamatan:'12.18.13', name:'Paya Bagas'})
    dataSet.push({ id:'12.21.11.2022', kecamatan:'12.21.11', name:'Paya Bahung'})
    dataSet.push({ id:'12.20.12.2006', kecamatan:'12.20.12', name:'Paya Bahung Ub'})
    dataSet.push({ id:'12.07.24.2011', kecamatan:'12.07.24', name:'Paya Bakung'})
    dataSet.push({ id:'12.05.13.2006', kecamatan:'12.05.13', name:'Paya Bengkuang'})
    dataSet.push({ id:'12.21.03.2019', kecamatan:'12.21.03', name:'Paya Bujing'})
    dataSet.push({ id:'12.07.27.2009', kecamatan:'12.07.27', name:'Paya Gambar'})
    dataSet.push({ id:'12.07.23.2004', kecamatan:'12.07.23', name:'Paya Geli'})
    dataSet.push({ id:'12.07.19.2026', kecamatan:'12.07.19', name:'Paya Itik'})
    dataSet.push({ id:'12.07.19.2028', kecamatan:'12.07.19', name:'Paya Kuda'})
    dataSet.push({ id:'12.18.13.2006', kecamatan:'12.18.13', name:'Paya Lombang'})
    dataSet.push({ id:'12.05.07.1012', kecamatan:'12.05.07', name:'Paya Mabar'})
    dataSet.push({ id:'12.18.13.2009', kecamatan:'12.18.13', name:'Paya Mabar'})
    dataSet.push({ id:'12.20.02.2009', kecamatan:'12.20.02', name:'Paya Ombik'})
    dataSet.push({ id:'12.21.05.2016', kecamatan:'12.21.05', name:'Paya Ombur'})
    dataSet.push({ id:'12.18.16.2005', kecamatan:'12.18.16', name:'Paya Pasir'})
    dataSet.push({ id:'12.71.12.1005', kecamatan:'12.71.12', name:'Paya Pasir'})
    dataSet.push({ id:'12.05.11.2003', kecamatan:'12.05.11', name:'Paya Perupuk'})
    dataSet.push({ id:'12.18.16.2008', kecamatan:'12.18.16', name:'Paya Pinang'})
    dataSet.push({ id:'12.05.10.2012', kecamatan:'12.05.10', name:'Paya Rengas'})
    dataSet.push({ id:'12.75.03.1004', kecamatan:'12.75.03', name:'Paya Roba'})
    dataSet.push({ id:'12.07.19.2029', kecamatan:'12.07.19', name:'Paya Sampir'})
    dataSet.push({ id:'12.05.15.2004', kecamatan:'12.05.15', name:'Paya Tampak'})
    dataSet.push({ id:'12.05.08.2011', kecamatan:'12.05.08', name:'Paya Tusam'})
    dataSet.push({ id:'12.06.11.2001', kecamatan:'12.06.11', name:'Payung'})
    dataSet.push({ id:'12.71.20.1009', kecamatan:'12.71.20', name:'PB Bengkel Baru'})
    dataSet.push({ id:'12.01.02.2014', kecamatan:'12.01.02', name:'Pea Raja'})
    dataSet.push({ id:'12.16.09.2016', kecamatan:'12.16.09', name:'Peadungdung'})
    dataSet.push({ id:'12.16.04.2005', kecamatan:'12.16.04', name:'Pearung'})
    dataSet.push({ id:'12.16.04.2009', kecamatan:'12.16.04', name:'Pearung Silali'})
    dataSet.push({ id:'12.18.14.2006', kecamatan:'12.18.14', name:'Pegajahan'})
    dataSet.push({ id:'12.18.17.2008', kecamatan:'12.18.17', name:'Pegajahan Hulu'})
    dataSet.push({ id:'12.18.17.2014', kecamatan:'12.18.17', name:'Pegajahan Kahan'})
    dataSet.push({ id:'12.05.01.1001', kecamatan:'12.05.01', name:'Pekan Bahorok'})
    dataSet.push({ id:'12.18.06.2004', kecamatan:'12.18.06', name:'Pekan Bandar Khalipah'})
    dataSet.push({ id:'12.05.16.1009', kecamatan:'12.05.16', name:'Pekan Besitang'})
    dataSet.push({ id:'12.75.02.1007', kecamatan:'12.75.02', name:'Pekan Binjai'})
    dataSet.push({ id:'12.18.09.1029', kecamatan:'12.18.09', name:'Pekan Dolok Masihul'})
    dataSet.push({ id:'12.05.13.1001', kecamatan:'12.05.13', name:'Pekan Gebang'})
    dataSet.push({ id:'12.07.01.2008', kecamatan:'12.07.01', name:'Pekan Gunung Mariah'})
    dataSet.push({ id:'12.14.10.2007', kecamatan:'12.14.10', name:'Pekan Hilisimaetano'})
    dataSet.push({ id:'12.18.09.2005', kecamatan:'12.18.09', name:'Pekan Kamis'})
    dataSet.push({ id:'12.05.03.1001', kecamatan:'12.05.03', name:'Pekan Kuala'})
    dataSet.push({ id:'12.71.13.1001', kecamatan:'12.71.13', name:'Pekan Labuhan'})
    dataSet.push({ id:'12.05.04.2014', kecamatan:'12.05.04', name:'Pekan Sawah'})
    dataSet.push({ id:'12.05.06.1001', kecamatan:'12.05.06', name:'Pekan Selesai'})
    dataSet.push({ id:'12.18.03.2007', kecamatan:'12.18.03', name:'Pekan Sialang Buah'})
    dataSet.push({ id:'12.18.05.2001', kecamatan:'12.18.05', name:'Pekan Tanjung Beringin'})
    dataSet.push({ id:'12.07.02.1026', kecamatan:'12.07.02', name:'Pekan Tanjung Morawa'})
    dataSet.push({ id:'12.05.11.1005', kecamatan:'12.05.11', name:'Pekan Tanjung Pura'})
    dataSet.push({ id:'12.05.11.2006', kecamatan:'12.05.11', name:'Pekubuan'})
    dataSet.push({ id:'12.19.08.2003', kecamatan:'12.19.08', name:'Pelanggiran Laut Tador'})
    dataSet.push({ id:'12.05.14.2004', kecamatan:'12.05.14', name:'Pelawi Selatan'})
    dataSet.push({ id:'12.05.14.1001', kecamatan:'12.05.14', name:'Pelawi Utara'})
    dataSet.push({ id:'12.01.02.2007', kecamatan:'12.01.02', name:'Pelita'})
    dataSet.push({ id:'12.76.04.1002', kecamatan:'12.76.04', name:'Pelita'})
    dataSet.push({ id:'12.23.06.2002', kecamatan:'12.23.06', name:'Pematang'})
    dataSet.push({ id:'12.08.02.2003', kecamatan:'12.08.02', name:'Pematang Asilum'})
    dataSet.push({ id:'12.08.21.1010', kecamatan:'12.08.21', name:'Pematang Bandar'})
    dataSet.push({ id:'12.07.32.2019', kecamatan:'12.07.32', name:'Pematang Biara'})
    dataSet.push({ id:'12.05.11.2012', kecamatan:'12.05.11', name:'Pematang Cengal'})
    dataSet.push({ id:'12.05.11.2019', kecamatan:'12.05.11', name:'Pematang Cengal Barat'})
    dataSet.push({ id:'12.19.01.2009', kecamatan:'12.19.01', name:'Pematang Cengkering'})
    dataSet.push({ id:'12.18.05.2006', kecamatan:'12.18.05', name:'Pematang Cermai'})
    dataSet.push({ id:'12.08.28.2008', kecamatan:'12.08.28', name:'Pematang Dolok Kahean'})
    dataSet.push({ id:'12.18.04.2014', kecamatan:'12.18.04', name:'Pematang Ganjang'})
    dataSet.push({ id:'12.18.03.2008', kecamatan:'12.18.03', name:'Pematang Guntung'})
    dataSet.push({ id:'12.19.02.2009', kecamatan:'12.19.02', name:'Pematang Jering'})
    dataSet.push({ id:'12.07.25.2003', kecamatan:'12.07.25', name:'Pematang Johar'})
    dataSet.push({ id:'12.18.01.2010', kecamatan:'12.18.01', name:'Pematang Kasih'})
    dataSet.push({ id:'12.08.23.2001', kecamatan:'12.08.23', name:'Pematang Kerasaan'})
    dataSet.push({ id:'12.08.23.2010', kecamatan:'12.08.23', name:'Pematang Kerasaan Rejo'})
    dataSet.push({ id:'12.18.03.2012', kecamatan:'12.18.03', name:'Pematang Kuala'})
    dataSet.push({ id:'12.19.02.2010', kecamatan:'12.19.02', name:'Pematang Kuing'})
    dataSet.push({ id:'12.07.26.2001', kecamatan:'12.07.26', name:'Pematang Lalang'})
    dataSet.push({ id:'12.72.08.1005', kecamatan:'12.72.08', name:'Pematang Marihat'})
    dataSet.push({ id:'12.19.01.2018', kecamatan:'12.19.01', name:'Pematang Nibung'})
    dataSet.push({ id:'12.08.05.2008', kecamatan:'12.08.05', name:'Pematang Pane'})
    dataSet.push({ id:'12.19.03.2003', kecamatan:'12.19.03', name:'Pematang Panjang'})
    dataSet.push({ id:'12.19.09.2008', kecamatan:'12.19.09', name:'Pematang Panjang'})
    dataSet.push({ id:'12.08.05.2002', kecamatan:'12.08.05', name:'Pematang Panombean'})
    dataSet.push({ id:'12.74.04.1002', kecamatan:'12.74.04', name:'Pematang Pasir'})
    dataSet.push({ id:'12.18.04.2015', kecamatan:'12.18.04', name:'Pematang Pelintahan'})
    dataSet.push({ id:'12.08.14.2002', kecamatan:'12.08.14', name:'Pematang Purba'})
    dataSet.push({ id:'12.19.12.2009', kecamatan:'12.19.12', name:'Pematang Rambai'})
    dataSet.push({ id:'12.08.29.1011', kecamatan:'12.08.29', name:'Pematang Raya'})
    dataSet.push({ id:'12.09.10.2006', kecamatan:'12.09.10', name:'Pematang Sei Baru'})
    dataSet.push({ id:'12.10.09.2003', kecamatan:'12.10.09', name:'Pematang Seleng'})
    dataSet.push({ id:'12.05.11.2009', kecamatan:'12.05.11', name:'Pematang Serai'})
    dataSet.push({ id:'12.18.03.2004', kecamatan:'12.18.03', name:'Pematang Setrak'})
    dataSet.push({ id:'12.08.10.2002', kecamatan:'12.08.10', name:'Pematang Sidamanik'})
    dataSet.push({ id:'12.18.02.2024', kecamatan:'12.18.02', name:'Pematang Sijonam'})
    dataSet.push({ id:'12.08.01.2017', kecamatan:'12.08.01', name:'Pematang Silampuyang'})
    dataSet.push({ id:'12.08.01.2015', kecamatan:'12.08.01', name:'Pematang Simalungun'})
    dataSet.push({ id:'12.08.10.2007', kecamatan:'12.08.10', name:'Pematang Tambun Raya'})
    dataSet.push({ id:'12.08.11.1018', kecamatan:'12.08.11', name:'Pematang Tanah Jawa'})
    dataSet.push({ id:'12.18.02.2025', kecamatan:'12.18.02', name:'Pematang Tatal'})
    dataSet.push({ id:'12.05.11.2002', kecamatan:'12.05.11', name:'Pematang Tengah'})
    dataSet.push({ id:'12.05.23.2001', kecamatan:'12.05.23', name:'Pematang Tengah'})
    dataSet.push({ id:'12.19.09.2013', kecamatan:'12.19.09', name:'Pematang Tengah'})
    dataSet.push({ id:'12.18.05.2007', kecamatan:'12.18.05', name:'Pematang Terang'})
    dataSet.push({ id:'12.06.03.2019', kecamatan:'12.06.03', name:'Penampen'})
    dataSet.push({ id:'12.06.17.2012', kecamatan:'12.06.17', name:'Penampen'})
    dataSet.push({ id:'12.15.03.2014', kecamatan:'12.15.03', name:'Penanggalan Binanga Boang'})
    dataSet.push({ id:'12.07.02.2022', kecamatan:'12.07.02', name:'Penara Kebun'})
    dataSet.push({ id:'12.07.07.2010', kecamatan:'12.07.07', name:'Penen'})
    dataSet.push({ id:'12.18.15.2010', kecamatan:'12.18.15', name:'Penggalangan'})
    dataSet.push({ id:'12.18.16.2007', kecamatan:'12.18.16', name:'Penggalangan'})
    dataSet.push({ id:'12.18.16.2001', kecamatan:'12.18.16', name:'Penggalian'})
    dataSet.push({ id:'12.07.08.2013', kecamatan:'12.07.08', name:'Penungkiren'})
    dataSet.push({ id:'12.08.26.2010', kecamatan:'12.08.26', name:'Perasmian'})
    dataSet.push({ id:'12.18.10.2015', kecamatan:'12.18.10', name:'Perbahingan'})
    dataSet.push({ id:'12.06.17.2009', kecamatan:'12.06.17', name:'Perbaji'})
    dataSet.push({ id:'12.09.11.2015', kecamatan:'12.09.11', name:'Perbangunan'})
    dataSet.push({ id:'12.13.01.2021', kecamatan:'12.13.01', name:'Perbangunan'})
    dataSet.push({ id:'12.07.31.2013', kecamatan:'12.07.31', name:'Perbarakan'})
    dataSet.push({ id:'12.13.14.2034', kecamatan:'12.13.14', name:'Perbatasan'})
    dataSet.push({ id:'12.10.09.2004', kecamatan:'12.10.09', name:'Perbaungan'})
    dataSet.push({ id:'12.06.08.2006', kecamatan:'12.06.08', name:'Perbesi'})
    dataSet.push({ id:'12.06.09.2007', kecamatan:'12.06.09', name:'Perbulan'})
    dataSet.push({ id:'12.07.26.2004', kecamatan:'12.07.26', name:'Percut'})
    dataSet.push({ id:'12.08.23.1014', kecamatan:'12.08.23', name:'Perdagangan I'})
    dataSet.push({ id:'12.08.23.1015', kecamatan:'12.08.23', name:'Perdagangan Iii'})
    dataSet.push({ id:'12.05.05.2006', kecamatan:'12.05.05', name:'Perdamaian'})
    dataSet.push({ id:'12.05.07.1004', kecamatan:'12.05.07', name:'Perdamaian'})
    dataSet.push({ id:'12.07.02.2021', kecamatan:'12.07.02', name:'Perdamean'})
    dataSet.push({ id:'12.15.02.2021', kecamatan:'12.15.02', name:'Perduhapen'})
    dataSet.push({ id:'12.06.08.2010', kecamatan:'12.06.08', name:'Pergendangen'})
    dataSet.push({ id:'12.18.04.2004', kecamatan:'12.18.04', name:'Pergulaan'})
    dataSet.push({ id:'12.07.09.2020', kecamatan:'12.07.09', name:'Perguroan'})
    dataSet.push({ id:'12.05.06.2009', kecamatan:'12.05.06', name:'Perhiasan'})
    dataSet.push({ id:'12.09.30.2002', kecamatan:'12.09.30', name:'Perhutaan Silau'})
    dataSet.push({ id:'12.07.07.2009', kecamatan:'12.07.07', name:'Peria-Ria'})
    dataSet.push({ id:'12.71.20.1010', kecamatan:'12.71.20', name:'Perintis'})
    dataSet.push({ id:'12.15.01.2008', kecamatan:'12.15.01', name:'Perjaga'})
    dataSet.push({ id:'12.11.02.2018', kecamatan:'12.11.02', name:'Perjuangan'})
    dataSet.push({ id:'12.14.27.2008', kecamatan:'12.14.27', name:'Perjuangan'})
    dataSet.push({ id:'12.19.07.2014', kecamatan:'12.19.07', name:'Perjuangan'})
    dataSet.push({ id:'12.74.04.1003', kecamatan:'12.74.04', name:'Perjuangan'})
    dataSet.push({ id:'12.03.31.2004', kecamatan:'12.03.31', name:'Perkebunan'})
    dataSet.push({ id:'12.09.22.2005', kecamatan:'12.09.22', name:'Perkebunan Aek Nagaga'})
    dataSet.push({ id:'12.23.07.2006', kecamatan:'12.23.07', name:'Perkebunan Aek Pamienke'})
    dataSet.push({ id:'12.09.15.2012', kecamatan:'12.09.15', name:'Perkebunan Aek Tarum'})
    dataSet.push({ id:'12.09.13.2008', kecamatan:'12.09.13', name:'Perkebunan Air Batu I/Ii'})
    dataSet.push({ id:'12.09.13.2009', kecamatan:'12.09.13', name:'Perkebunan Air Batu Iii/Ix'})
    dataSet.push({ id:'12.10.20.2002', kecamatan:'12.10.20', name:'Perkebunan Ajamu'})
    dataSet.push({ id:'12.05.21.2010', kecamatan:'12.05.21', name:'Perkebunan Amal Tani'})
    dataSet.push({ id:'12.09.21.2003', kecamatan:'12.09.21', name:'Perkebunan Bandar Pulau'})
    dataSet.push({ id:'12.09.21.2002', kecamatan:'12.09.21', name:'Perkebunan Bandar Selamat'})
    dataSet.push({ id:'12.05.02.2006', kecamatan:'12.05.02', name:'Perkebunan Bandar Telu'})
    dataSet.push({ id:'12.22.02.2004', kecamatan:'12.22.02', name:'Perkebunan Batang Saponggol'})
    dataSet.push({ id:'12.03.02.1011', kecamatan:'12.03.02', name:'Perkebunan Batang Toru'})
    dataSet.push({ id:'12.05.03.2015', kecamatan:'12.05.03', name:'Perkebunan Bekiun'})
    dataSet.push({ id:'12.23.06.2005', kecamatan:'12.23.06', name:'Perkebunan Berangir'})
    dataSet.push({ id:'12.10.08.2005', kecamatan:'12.10.08', name:'Perkebunan Bilah'})
    dataSet.push({ id:'12.23.05.2005', kecamatan:'12.23.05', name:'Perkebunan Brussel'})
    dataSet.push({ id:'12.05.01.2009', kecamatan:'12.05.01', name:'Perkebunan Bukit Lawang'})
    dataSet.push({ id:'12.05.01.2008', kecamatan:'12.05.01', name:'Perkebunan Bungara'})
    dataSet.push({ id:'12.05.23.2003', kecamatan:'12.05.23', name:'Perkebunan Damar Condong'})
    dataSet.push({ id:'12.19.04.2014', kecamatan:'12.19.04', name:'Perkebunan Dolok'})
    dataSet.push({ id:'12.05.02.2004', kecamatan:'12.05.02', name:'Perkebunan Gelugur Langkat'})
    dataSet.push({ id:'12.09.22.2002', kecamatan:'12.09.22', name:'Perkebunan Gunung Melayu'})
    dataSet.push({ id:'12.23.07.2012', kecamatan:'12.23.07', name:'Perkebunan Halimbe'})
    dataSet.push({ id:'12.23.01.2010', kecamatan:'12.23.01', name:'Perkebunan Hanna'})
    dataSet.push({ id:'12.03.02.2021', kecamatan:'12.03.02', name:'Perkebunan Hapesong'})
    dataSet.push({ id:'12.09.12.2004', kecamatan:'12.09.12', name:'Perkebunan Hessa'})
    dataSet.push({ id:'12.23.01.2007', kecamatan:'12.23.01', name:'Perkebunan Kanopan Ulu'})
    dataSet.push({ id:'12.19.04.2015', kecamatan:'12.19.04', name:'Perkebunan Kwala Gunung'})
    dataSet.push({ id:'12.23.01.2009', kecamatan:'12.23.01', name:'Perkebunan Labuhan Haji'})
    dataSet.push({ id:'12.19.04.2017', kecamatan:'12.19.04', name:'Perkebunan Lima Puluh'})
    dataSet.push({ id:'12.19.04.2018', kecamatan:'12.19.04', name:'Perkebunan Limau Manis'})
    dataSet.push({ id:'12.23.05.2003', kecamatan:'12.23.05', name:'Perkebunan Marbau Selatan'})
    dataSet.push({ id:'12.05.22.2003', kecamatan:'12.05.22', name:'Perkebunan Marike'})
    dataSet.push({ id:'12.03.06.2013', kecamatan:'12.03.06', name:'Perkebunan Marpinggan'})
    dataSet.push({ id:'12.23.01.2008', kecamatan:'12.23.01', name:'Perkebunan Membang Muda'})
    dataSet.push({ id:'12.23.05.2004', kecamatan:'12.23.05', name:'Perkebunan Milano'})
    dataSet.push({ id:'12.22.01.2009', kecamatan:'12.22.01', name:'Perkebunan Nagodang'})
    dataSet.push({ id:'12.10.08.2004', kecamatan:'12.10.08', name:'Perkebunan Negeri Lama'})
    dataSet.push({ id:'12.22.01.2008', kecamatan:'12.22.01', name:'Perkebunan Nomark'})
    dataSet.push({ id:'12.23.04.2003', kecamatan:'12.23.04', name:'Perkebunan Padang Halaban'})
    dataSet.push({ id:'12.09.15.2016', kecamatan:'12.09.15', name:'Perkebunan Padang Pulau'})
    dataSet.push({ id:'12.10.14.2003', kecamatan:'12.10.14', name:'Perkebunan Pangkatan'})
    dataSet.push({ id:'12.23.04.2004', kecamatan:'12.23.04', name:'Perkebunan Panigoran'})
    dataSet.push({ id:'12.13.16.2013', kecamatan:'12.13.16', name:'Perkebunan Patiluban'})
    dataSet.push({ id:'12.22.02.2001', kecamatan:'12.22.02', name:'Perkebunan Pelabian'})
    dataSet.push({ id:'12.05.23.2004', kecamatan:'12.05.23', name:'Perkebunan Perapen'})
    dataSet.push({ id:'12.23.05.2002', kecamatan:'12.23.05', name:'Perkebunan Pernantian'})
    dataSet.push({ id:'12.19.11.2007', kecamatan:'12.19.11', name:'Perkebunan Petatal'})
    dataSet.push({ id:'12.77.05.2013', kecamatan:'12.77.05', name:'Perkebunan Pijor Koling'})
    dataSet.push({ id:'12.09.13.2006', kecamatan:'12.09.13', name:'Perkebunan Pulahan'})
    dataSet.push({ id:'12.05.01.2016', kecamatan:'12.05.01', name:'Perkebunan Pulo Rambung'})
    dataSet.push({ id:'12.07.32.2011', kecamatan:'12.07.32', name:'Perkebunan Ramunia'})
    dataSet.push({ id:'12.09.08.2004', kecamatan:'12.09.08', name:'Perkebunan Sei Balai'})
    dataSet.push({ id:'12.19.07.2005', kecamatan:'12.19.07', name:'Perkebunan Sei Balai'})
    dataSet.push({ id:'12.19.07.2010', kecamatan:'12.19.07', name:'Perkebunan Sei Bejangkar'})
    dataSet.push({ id:'12.09.23.2002', kecamatan:'12.09.23', name:'Perkebunan Sei Dadap I/Ii'})
    dataSet.push({ id:'12.09.23.2003', kecamatan:'12.09.23', name:'Perkebunan Sei Dadap Iii/Iv'})
    dataSet.push({ id:'12.05.01.2013', kecamatan:'12.05.01', name:'Perkebunan Sei Musam'})
    dataSet.push({ id:'12.22.01.2010', kecamatan:'12.22.01', name:'Perkebunan Sei Rumbia'})
    dataSet.push({ id:'12.09.16.2018', kecamatan:'12.09.16', name:'Perkebunan Sei Silau'})
    dataSet.push({ id:'12.10.08.2003', kecamatan:'12.10.08', name:'Perkebunan Sennah'})
    dataSet.push({ id:'12.03.02.2020', kecamatan:'12.03.02', name:'Perkebunan Sigala-Gala'})
    dataSet.push({ id:'12.13.14.2015', kecamatan:'12.13.14', name:'Perkebunan Simpang Gambir'})
    dataSet.push({ id:'12.19.02.1001', kecamatan:'12.19.02', name:'Perkebunan Sipare Pare'})
    dataSet.push({ id:'12.09.12.2002', kecamatan:'12.09.12', name:'Perkebunan Suka Raja'})
    dataSet.push({ id:'12.05.02.2005', kecamatan:'12.05.02', name:'Perkebunan Tambunan'})
    dataSet.push({ id:'12.19.11.2003', kecamatan:'12.19.11', name:'Perkebunan Tanah Datar'})
    dataSet.push({ id:'12.19.04.2019', kecamatan:'12.19.04', name:'Perkebunan Tanah Gambus'})
    dataSet.push({ id:'12.19.10.2001', kecamatan:'12.19.10', name:'Perkebunan Tanah Itam Ulu'})
    dataSet.push({ id:'12.05.10.2010', kecamatan:'12.05.10', name:'Perkebunan Tanjung Beringin'})
    dataSet.push({ id:'12.19.08.2004', kecamatan:'12.19.08', name:'Perkebunan Tanjung Kasau'})
    dataSet.push({ id:'12.05.02.2002', kecamatan:'12.05.02', name:'Perkebunan Tanjung Keliling'})
    dataSet.push({ id:'12.09.31.2003', kecamatan:'12.09.31', name:'Perkebunan Teluk Dalam'})
    dataSet.push({ id:'12.22.02.2002', kecamatan:'12.22.02', name:'Perkebunan Teluk Panji'})
    dataSet.push({ id:'12.22.02.2005', kecamatan:'12.22.02', name:'Perkebunan Tolan'})
    dataSet.push({ id:'12.22.02.2003', kecamatan:'12.22.02', name:'Perkebunan Tolan I/II'})
    dataSet.push({ id:'12.05.01.2007', kecamatan:'12.05.01', name:'Perkebunan Turangi'})
    dataSet.push({ id:'12.05.09.2013', kecamatan:'12.05.09', name:'Perkotaan'})
    dataSet.push({ id:'12.19.03.2017', kecamatan:'12.19.03', name:'Perkotaan'})
    dataSet.push({ id:'12.08.23.2008', kecamatan:'12.08.23', name:'Perlanaan'})
    dataSet.push({ id:'12.05.18.2006', kecamatan:'12.05.18', name:'Perlis'})
    dataSet.push({ id:'12.01.05.1020', kecamatan:'12.01.05', name:'Perluasan'})
    dataSet.push({ id:'12.06.07.2007', kecamatan:'12.06.07', name:'Pernantin'})
    dataSet.push({ id:'12.15.01.2006', kecamatan:'12.15.01', name:'Perolihen'})
    dataSet.push({ id:'12.07.04.2005', kecamatan:'12.07.04', name:'Perpanden'})
    dataSet.push({ id:'12.15.02.2005', kecamatan:'12.15.02', name:'Perpulungen'})
    dataSet.push({ id:'12.11.09.2013', kecamatan:'12.11.09', name:'Perrik Mbue'})
    dataSet.push({ id:'12.06.03.2013', kecamatan:'12.06.03', name:'Persadanta'})
    dataSet.push({ id:'12.09.14.2008', kecamatan:'12.09.14', name:'Persatuan'})
    dataSet.push({ id:'12.76.01.1006', kecamatan:'12.76.01', name:'Persiakan'})
    dataSet.push({ id:'12.09.11.2014', kecamatan:'12.09.11', name:'Pertahanan'})
    dataSet.push({ id:'12.18.09.2013', kecamatan:'12.18.09', name:'Pertambatan'})
    dataSet.push({ id:'12.07.05.2008', kecamatan:'12.07.05', name:'Pertampilen'})
    dataSet.push({ id:'12.18.13.2005', kecamatan:'12.18.13', name:'Pertapaan'})
    dataSet.push({ id:'12.06.12.2030', kecamatan:'12.06.12', name:'Perteguhen'})
    dataSet.push({ id:'12.02.11.2009', kecamatan:'12.02.11', name:'Pertengahan'})
    dataSet.push({ id:'12.05.08.2010', kecamatan:'12.05.08', name:'Pertumbukan'})
    dataSet.push({ id:'12.06.03.2010', kecamatan:'12.06.03', name:'Pertumbuken'})
    dataSet.push({ id:'12.06.08.2003', kecamatan:'12.06.08', name:'Pertumbuken'})
    dataSet.push({ id:'12.06.06.2010', kecamatan:'12.06.06', name:'Pertumbungen'})
    dataSet.push({ id:'12.07.05.2025', kecamatan:'12.07.05', name:'Perumnas Simalingkar'})
    dataSet.push({ id:'12.19.09.2002', kecamatan:'12.19.09', name:'Perupuk'})
    dataSet.push({ id:'12.74.01.1003', kecamatan:'12.74.01', name:'Perwira'})
    dataSet.push({ id:'12.07.19.2024', kecamatan:'12.07.19', name:'Petangguhan'})
    dataSet.push({ id:'12.07.28.1012', kecamatan:'12.07.28', name:'Petapahan'})
    dataSet.push({ id:'12.19.11.2009', kecamatan:'12.19.11', name:'Petatal'})
    dataSet.push({ id:'12.71.17.1001', kecamatan:'12.71.17', name:'Petisah Hulu'})
    dataSet.push({ id:'12.71.19.1001', kecamatan:'12.71.19', name:'Petisah Tengah'})
    dataSet.push({ id:'12.18.14.2008', kecamatan:'12.18.14', name:'Petuaran Hilir'})
    dataSet.push({ id:'12.18.14.2007', kecamatan:'12.18.14', name:'Petuaran Hulu'})
    dataSet.push({ id:'12.07.19.2023', kecamatan:'12.07.19', name:'Petumbukan'})
    dataSet.push({ id:'12.09.26.2004', kecamatan:'12.09.26', name:'Piasa Ulu'})
    dataSet.push({ id:'12.13.01.1023', kecamatan:'12.13.01', name:'Pidoli Dolok'})
    dataSet.push({ id:'12.13.01.2024', kecamatan:'12.13.01', name:'Pidoli Lombang'})
    dataSet.push({ id:'12.20.02.2053', kecamatan:'12.20.02', name:'Pijor Koling'})
    dataSet.push({ id:'12.20.10.2013', kecamatan:'12.20.10', name:'Pijor Koling'})
    dataSet.push({ id:'12.77.05.1002', kecamatan:'12.77.05', name:'Pijor Koling'})
    dataSet.push({ id:'12.03.14.2032', kecamatan:'12.03.14', name:'Pinagar'})
    dataSet.push({ id:'12.22.03.2007', kecamatan:'12.22.03', name:'Pinang Damai'})
    dataSet.push({ id:'12.76.04.1006', kecamatan:'12.76.04', name:'Pinang Mancung'})
    dataSet.push({ id:'12.08.06.2006', kecamatan:'12.08.06', name:'Pinang Ratus'})
    dataSet.push({ id:'12.01.04.1007', kecamatan:'12.01.04', name:'Pinangbaru'})
    dataSet.push({ id:'12.09.13.2003', kecamatan:'12.09.13', name:'Pinanggiripan'})
    dataSet.push({ id:'12.01.04.1001', kecamatan:'12.01.04', name:'Pinangsori'})
    dataSet.push({ id:'12.20.01.2027', kecamatan:'12.20.01', name:'Pinarik'})
    dataSet.push({ id:'12.21.09.2020', kecamatan:'12.21.09', name:'Pinarik'})
    dataSet.push({ id:'12.05.15.2005', kecamatan:'12.05.15', name:'Pintu Air'})
    dataSet.push({ id:'12.06.09.2015', kecamatan:'12.06.09', name:'Pintu Angin'})
    dataSet.push({ id:'12.12.03.2001', kecamatan:'12.12.03', name:'Pintu Batu'})
    dataSet.push({ id:'12.06.12.2007', kecamatan:'12.06.12', name:'Pintu Besi'})
    dataSet.push({ id:'12.12.02.2013', kecamatan:'12.12.02', name:'Pintu Bosi'})
    dataSet.push({ id:'12.20.09.2007', kecamatan:'12.20.09', name:'Pintu Bosi'})
    dataSet.push({ id:'12.77.06.2004', kecamatan:'12.77.06', name:'Pintu Langit Jae'})
    dataSet.push({ id:'12.03.06.2006', kecamatan:'12.03.06', name:'Pintu Padang'})
    dataSet.push({ id:'12.20.07.2004', kecamatan:'12.20.07', name:'Pintu Padang'})
    dataSet.push({ id:'12.21.06.2006', kecamatan:'12.21.06', name:'Pintu Padang'})
    dataSet.push({ id:'12.03.07.1060', kecamatan:'12.03.07', name:'Pintu Padang I'})
    dataSet.push({ id:'12.03.07.1061', kecamatan:'12.03.07', name:'Pintu Padang Ii'})
    dataSet.push({ id:'12.13.06.2012', kecamatan:'12.13.06', name:'Pintu Padang Jae'})
    dataSet.push({ id:'12.13.06.2013', kecamatan:'12.13.06', name:'Pintu Padang Julu'})
    dataSet.push({ id:'12.03.05.2076', kecamatan:'12.03.05', name:'Pintu Padang Mandalasena'})
    dataSet.push({ id:'12.20.02.2086', kecamatan:'12.20.02', name:'Pintu Padang Merdeka'})
    dataSet.push({ id:'12.12.05.2007', kecamatan:'12.12.05', name:'Pintu Pohan'})
    dataSet.push({ id:'12.12.05.2009', kecamatan:'12.12.05', name:'Pintu Pohan Dolok'})
    dataSet.push({ id:'12.17.08.1027', kecamatan:'12.17.08', name:'Pintu Sona'})
    dataSet.push({ id:'12.05.16.2005', kecamatan:'12.05.16', name:'Pir Adb Besitang'})
    dataSet.push({ id:'12.21.05.2024', kecamatan:'12.21.05', name:'Pir Trans Sosa I A'})
    dataSet.push({ id:'12.21.05.2025', kecamatan:'12.21.05', name:'Pir Trans Sosa I B'})
    dataSet.push({ id:'12.21.05.2028', kecamatan:'12.21.05', name:'Pir Trans Sosa Ii'})
    dataSet.push({ id:'12.21.05.2026', kecamatan:'12.21.05', name:'Pir Trans Sosa Iii A'})
    dataSet.push({ id:'12.21.05.2027', kecamatan:'12.21.05', name:'Pir Trans Sosa Iii B'})
    dataSet.push({ id:'12.21.05.2029', kecamatan:'12.21.05', name:'Pir Trans Sosa Iv'})
    dataSet.push({ id:'12.21.05.2030', kecamatan:'12.21.05', name:'Pir Trans Sosa V'})
    dataSet.push({ id:'12.21.05.2031', kecamatan:'12.21.05', name:'Pir Trans Sosa Vi'})
    dataSet.push({ id:'12.07.19.2025', kecamatan:'12.07.19', name:'Pisang Pala'})
    dataSet.push({ id:'12.18.08.2005', kecamatan:'12.18.08', name:'Pispis'})
    dataSet.push({ id:'12.21.08.2008', kecamatan:'12.21.08', name:'Plasma Mondang'})
    dataSet.push({ id:'12.01.16.2009', kecamatan:'12.01.16', name:'Po Simargarap'})
    dataSet.push({ id:'12.02.09.2013', kecamatan:'12.02.09', name:'Pohan Jae'})
    dataSet.push({ id:'12.02.09.2011', kecamatan:'12.02.09', name:'Pohan Julu'})
    dataSet.push({ id:'12.02.09.2012', kecamatan:'12.02.09', name:'Pohan Tonga'})
    dataSet.push({ id:'12.08.18.2014', kecamatan:'12.08.18', name:'Pokan Baru'})
    dataSet.push({ id:'12.06.13.2015', kecamatan:'12.06.13', name:'Pola Tebu'})
    dataSet.push({ id:'12.11.03.2019', kecamatan:'12.11.03', name:'Polding Jaya Sumbul'})
    dataSet.push({ id:'12.23.07.2002', kecamatan:'12.23.07', name:'Poldung'})
    dataSet.push({ id:'12.11.05.2013', kecamatan:'12.11.05', name:'Polling Anak-Anak'})
    dataSet.push({ id:'12.16.02.2003', kecamatan:'12.16.02', name:'Pollung'})
    dataSet.push({ id:'12.71.16.1002', kecamatan:'12.71.16', name:'Polonia'})
    dataSet.push({ id:'12.18.15.2001', kecamatan:'12.18.15', name:'Pon'})
    dataSet.push({ id:'12.05.02.2023', kecamatan:'12.05.02', name:'Ponco Warno'})
    dataSet.push({ id:'12.01.20.1005', kecamatan:'12.01.20', name:'Pondok Batu'})
    dataSet.push({ id:'12.10.09.2009', kecamatan:'12.10.09', name:'Pondok Batu'})
    dataSet.push({ id:'12.08.13.2012', kecamatan:'12.08.13', name:'Pondok Buluh'})
    dataSet.push({ id:'12.09.29.2005', kecamatan:'12.09.29', name:'Pondok Bungur'})
    dataSet.push({ id:'12.72.06.1008', kecamatan:'12.72.06', name:'Pondok Sayur'})
    dataSet.push({ id:'12.18.14.2009', kecamatan:'12.18.14', name:'Pondok Tengah'})
    dataSet.push({ id:'12.20.06.2014', kecamatan:'12.20.06', name:'Portibi Jae'})
    dataSet.push({ id:'12.20.06.2013', kecamatan:'12.20.06', name:'Portibi Julu'})
    dataSet.push({ id:'12.21.02.2005', kecamatan:'12.21.02', name:'Pp. Makmur'})
    dataSet.push({ id:'12.09.16.2005', kecamatan:'12.09.16', name:'Prapat Janji'})
    dataSet.push({ id:'12.72.02.1002', kecamatan:'12.72.02', name:'Proklamasi'})
    dataSet.push({ id:'12.15.07.2005', kecamatan:'12.15.07', name:'Prongil'})
    dataSet.push({ id:'12.07.03.2016', kecamatan:'12.07.03', name:'Puangaja'})
    dataSet.push({ id:'12.77.03.2010', kecamatan:'12.77.03', name:'Pudun Jae'})
    dataSet.push({ id:'12.77.03.2011', kecamatan:'12.77.03', name:'Pudun Julu'})
    dataSet.push({ id:'12.07.23.2003', kecamatan:'12.07.23', name:'Puji Mulyo'})
    dataSet.push({ id:'12.75.05.1005', kecamatan:'12.75.05', name:'Pujidadi'})
    dataSet.push({ id:'12.05.11.2011', kecamatan:'12.05.11', name:'Pulau Banyak'})
    dataSet.push({ id:'12.25.02.2006', kecamatan:'12.25.02', name:'Pulau Bogi'})
    dataSet.push({ id:'12.18.12.2020', kecamatan:'12.18.12', name:'Pulau Gambar'})
    dataSet.push({ id:'12.05.15.2008', kecamatan:'12.05.15', name:'Pulau Kampai'})
    dataSet.push({ id:'12.09.31.2004', kecamatan:'12.09.31', name:'Pulau Maria'})
    dataSet.push({ id:'12.09.13.2019', kecamatan:'12.09.13', name:'Pulau Pule'})
    dataSet.push({ id:'12.09.14.2003', kecamatan:'12.09.14', name:'Pulau Rakyat Pekan'})
    dataSet.push({ id:'12.09.14.2002', kecamatan:'12.09.14', name:'Pulau Rakyat Tua'})
    dataSet.push({ id:'12.19.10.2006', kecamatan:'12.19.10', name:'Pulau Sejuk'})
    dataSet.push({ id:'12.05.15.2007', kecamatan:'12.05.15', name:'Pulau Sembilan'})
    dataSet.push({ id:'12.05.21.2008', kecamatan:'12.05.21', name:'Pulau Semikat'})
    dataSet.push({ id:'12.74.06.1001', kecamatan:'12.74.06', name:'Pulau Simardan'})
    dataSet.push({ id:'12.18.12.2021', kecamatan:'12.18.12', name:'Pulau Tagor'})
    dataSet.push({ id:'12.07.19.2027', kecamatan:'12.07.19', name:'Pulau Tagor Batu'})
    dataSet.push({ id:'12.13.15.2013', kecamatan:'12.13.15', name:'Pulau Tamang'})
    dataSet.push({ id:'12.09.31.2005', kecamatan:'12.09.31', name:'Pulau Tanjung'})
    dataSet.push({ id:'12.08.07.2010', kecamatan:'12.08.07', name:'Puli Buah'})
    dataSet.push({ id:'12.09.30.2007', kecamatan:'12.09.30', name:'Pulo Bandring'})
    dataSet.push({ id:'12.23.05.2006', kecamatan:'12.23.05', name:'Pulo Bargot'})
    dataSet.push({ id:'12.21.03.2020', kecamatan:'12.21.03', name:'Pulo Bariang'})
    dataSet.push({ id:'12.08.18.2002', kecamatan:'12.08.18', name:'Pulo Bayu'})
    dataSet.push({ id:'12.71.05.1004', kecamatan:'12.71.05', name:'Pulo Berayan Kota'})
    dataSet.push({ id:'12.23.01.2005', kecamatan:'12.23.01', name:'Pulo Dogom'})
    dataSet.push({ id:'12.16.09.2014', kecamatan:'12.16.09', name:'Pulo Godang'})
    dataSet.push({ id:'12.23.06.2007', kecamatan:'12.23.06', name:'Pulo Jantan'})
    dataSet.push({ id:'12.20.01.2033', kecamatan:'12.20.01', name:'Pulo Liman'})
    dataSet.push({ id:'12.10.01.1008', kecamatan:'12.10.01', name:'Pulo Padang'})
    dataSet.push({ id:'12.01.18.2001', kecamatan:'12.01.18', name:'Pulo Pakkat'})
    dataSet.push({ id:'12.01.18.2003', kecamatan:'12.01.18', name:'Pulo Pakkat Ii'})
    dataSet.push({ id:'12.08.30.2013', kecamatan:'12.08.30', name:'Pulo Pitu Marihat'})
    dataSet.push({ id:'12.14.19.2013', kecamatan:'12.14.19', name:'Puncak Lolomatua'})
    dataSet.push({ id:'12.07.02.2011', kecamatan:'12.07.02', name:'Punden Rejo'})
    dataSet.push({ id:'12.09.09.2008', kecamatan:'12.09.09', name:'Punggulan'})
    dataSet.push({ id:'12.05.17.2003', kecamatan:'12.05.17', name:'Puraka I'})
    dataSet.push({ id:'12.05.17.2004', kecamatan:'12.05.17', name:'Puraka Ii'})
    dataSet.push({ id:'12.16.09.2002', kecamatan:'12.16.09', name:'Purba Baringin'})
    dataSet.push({ id:'12.13.09.2005', kecamatan:'12.13.09', name:'Purba Baru'})
    dataSet.push({ id:'12.16.09.2001', kecamatan:'12.16.09', name:'Purba Bersatu'})
    dataSet.push({ id:'12.02.11.2013', kecamatan:'12.02.11', name:'Purba Dolok'})
    dataSet.push({ id:'12.08.14.2006', kecamatan:'12.08.14', name:'Purba Dolok'})
    dataSet.push({ id:'12.16.06.2010', kecamatan:'12.16.06', name:'Purba Dolok'})
    dataSet.push({ id:'12.08.21.2006', kecamatan:'12.08.21', name:'Purba Ganda'})
    dataSet.push({ id:'12.13.20.2010', kecamatan:'12.13.20', name:'Purba Julu'})
    dataSet.push({ id:'12.13.09.2006', kecamatan:'12.13.09', name:'Purba Lamo'})
    dataSet.push({ id:'12.16.06.2003', kecamatan:'12.16.06', name:'Purba Manalu'})
    dataSet.push({ id:'12.16.09.2019', kecamatan:'12.16.09', name:'Purba Sianjur'})
    dataSet.push({ id:'12.20.04.2044', kecamatan:'12.20.04', name:'Purba Sinomba'})
    dataSet.push({ id:'12.08.25.2004', kecamatan:'12.08.25', name:'Purba Sinombah'})
    dataSet.push({ id:'12.08.14.2004', kecamatan:'12.08.14', name:'Purba Sipinggan'})
    dataSet.push({ id:'12.08.14.2001', kecamatan:'12.08.14', name:'Purba Tongah'})
    dataSet.push({ id:'12.01.17.2004', kecamatan:'12.01.17', name:'Purba Tua'})
    dataSet.push({ id:'12.02.08.2009', kecamatan:'12.02.08', name:'Purba Tua'})
    dataSet.push({ id:'12.03.30.2007', kecamatan:'12.03.30', name:'Purba Tua'})
    dataSet.push({ id:'12.08.25.2006', kecamatan:'12.08.25', name:'Purba Tua'})
    dataSet.push({ id:'12.12.06.2007', kecamatan:'12.12.06', name:'Purba Tua'})
    dataSet.push({ id:'12.20.02.2061', kecamatan:'12.20.02', name:'Purba Tua'})
    dataSet.push({ id:'12.20.04.2070', kecamatan:'12.20.04', name:'Purba Tua'})
    dataSet.push({ id:'12.20.07.2021', kecamatan:'12.20.07', name:'Purba Tua'})
    dataSet.push({ id:'12.21.07.2004', kecamatan:'12.21.07', name:'Purba Tua'})
    dataSet.push({ id:'12.08.25.2009', kecamatan:'12.08.25', name:'Purba Tua Baru'})
    dataSet.push({ id:'12.20.10.2014', kecamatan:'12.20.10', name:'Purba Tua Dolok'})
    dataSet.push({ id:'12.08.28.2007', kecamatan:'12.08.28', name:'Purbasari'})
    dataSet.push({ id:'12.02.13.2013', kecamatan:'12.02.13', name:'Purbatua'})
    dataSet.push({ id:'12.08.25.2016', kecamatan:'12.08.25', name:'Purbatua Etek'})
    dataSet.push({ id:'12.77.05.2005', kecamatan:'12.77.05', name:'Purbatua Pijor Koling'})
    dataSet.push({ id:'12.05.04.2010', kecamatan:'12.05.04', name:'Purwobinangun'})
    dataSet.push({ id:'12.07.23.2006', kecamatan:'12.07.23', name:'Purwodadi'})
    dataSet.push({ id:'12.07.31.2002', kecamatan:'12.07.31', name:'Purwodadi'})
    dataSet.push({ id:'12.08.21.2013', kecamatan:'12.08.21', name:'Purwodadi'})
    dataSet.push({ id:'12.77.03.2003', kecamatan:'12.77.03', name:'Purwodadi'})
    dataSet.push({ id:'12.23.04.2008', kecamatan:'12.23.04', name:'Purworejo'})
    dataSet.push({ id:'12.08.21.2001', kecamatan:'12.08.21', name:'Purwosari'})
    dataSet.push({ id:'12.71.01.1002', kecamatan:'12.71.01', name:'Pusat Pasar'})
    dataSet.push({ id:'12.16.01.2011', kecamatan:'12.16.01', name:'Pusuk I'})
    dataSet.push({ id:'12.16.01.2002', kecamatan:'12.16.01', name:'Pusuk Ii Simaninggir'})
    dataSet.push({ id:'12.08.03.2006', kecamatan:'12.08.03', name:'Rabuhit'})
    dataSet.push({ id:'12.09.22.2001', kecamatan:'12.09.22', name:'Rahuning'})
    dataSet.push({ id:'12.09.22.2006', kecamatan:'12.09.22', name:'Rahuning I'})
    dataSet.push({ id:'12.09.22.2007', kecamatan:'12.09.22', name:'Rahuning Ii'})
    dataSet.push({ id:'12.20.04.2019', kecamatan:'12.20.04', name:'Rahuning Jae'})
    dataSet.push({ id:'12.02.13.2007', kecamatan:'12.02.13', name:'Rahut Bosi'})
    dataSet.push({ id:'12.02.13.2024', kecamatan:'12.02.13', name:'Rahut Bosi Onan'})
    dataSet.push({ id:'12.08.18.2004', kecamatan:'12.08.18', name:'Raja Maligas'})
    dataSet.push({ id:'12.08.18.2011', kecamatan:'12.08.18', name:'Raja Maligas I'})
    dataSet.push({ id:'12.05.03.2009', kecamatan:'12.05.03', name:'Raja Tengah'})
    dataSet.push({ id:'12.21.03.2021', kecamatan:'12.21.03', name:'Ramba'})
    dataSet.push({ id:'12.21.08.2028', kecamatan:'12.21.08', name:'Ramba'})
    dataSet.push({ id:'12.14.24.2006', kecamatan:'12.14.24', name:'Ramba-Ramba'})
    dataSet.push({ id:'12.03.04.2068', kecamatan:'12.03.04', name:'Ramba Sihasur'})
    dataSet.push({ id:'12.06.09.2011', kecamatan:'12.06.09', name:'Rambah Tampu'})
    dataSet.push({ id:'12.07.08.2014', kecamatan:'12.07.08', name:'Rambai'})
    dataSet.push({ id:'12.76.05.1006', kecamatan:'12.76.05', name:'Rambung'})
    dataSet.push({ id:'12.75.05.1007', kecamatan:'12.75.05', name:'Rambung Barat'})
    dataSet.push({ id:'12.07.03.2018', kecamatan:'12.07.03', name:'Rambung Baru'})
    dataSet.push({ id:'12.75.05.1004', kecamatan:'12.75.05', name:'Rambung Dalam'})
    dataSet.push({ id:'12.18.04.2016', kecamatan:'12.18.04', name:'Rambung Estate'})
    dataSet.push({ id:'12.08.01.2004', kecamatan:'12.08.01', name:'Rambung Merah'})
    dataSet.push({ id:'12.18.04.2019', kecamatan:'12.18.04', name:'Rambung Sialang Hilir'})
    dataSet.push({ id:'12.18.04.2017', kecamatan:'12.18.04', name:'Rambung Sialang Hulu'})
    dataSet.push({ id:'12.18.04.2018', kecamatan:'12.18.04', name:'Rambung Sialang Tengah'})
    dataSet.push({ id:'12.75.05.1008', kecamatan:'12.75.05', name:'Rambung Timur'})
    dataSet.push({ id:'12.01.13.2002', kecamatan:'12.01.13', name:'Rampa'})
    dataSet.push({ id:'12.20.04.2015', kecamatan:'12.20.04', name:'Rampa Jae'})
    dataSet.push({ id:'12.20.04.2016', kecamatan:'12.20.04', name:'Rampa Julu'})
    dataSet.push({ id:'12.05.22.2006', kecamatan:'12.05.22', name:'Rampah'})
    dataSet.push({ id:'12.18.15.2005', kecamatan:'12.18.15', name:'Rampah Estate'})
    dataSet.push({ id:'12.07.32.2009', kecamatan:'12.07.32', name:'Ramunia 1'})
    dataSet.push({ id:'12.07.32.2010', kecamatan:'12.07.32', name:'Ramunia 2'})
    dataSet.push({ id:'12.20.02.2037', kecamatan:'12.20.02', name:'Rancaran'})
    dataSet.push({ id:'12.07.20.2013', kecamatan:'12.07.20', name:'Ranggit-Git'})
    dataSet.push({ id:'12.13.12.2012', kecamatan:'12.13.12', name:'Ranjo Batu'})
    dataSet.push({ id:'12.76.02.1004', kecamatan:'12.76.02', name:'Rantau Laban'})
    dataSet.push({ id:'12.07.32.2004', kecamatan:'12.07.32', name:'Rantau Panjang'})
    dataSet.push({ id:'12.13.17.2008', kecamatan:'12.13.17', name:'Rantau Panjang'})
    dataSet.push({ id:'12.10.01.1004', kecamatan:'12.10.01', name:'Rantauprapat'})
    dataSet.push({ id:'12.11.12.2004', kecamatan:'12.11.12', name:'Rante Besi'})
    dataSet.push({ id:'12.13.18.2009', kecamatan:'12.13.18', name:'Ranto Nalinjang'})
    dataSet.push({ id:'12.13.03.2009', kecamatan:'12.13.03', name:'Ranto Natas'})
    dataSet.push({ id:'12.13.18.2013', kecamatan:'12.13.18', name:'Ranto Panjang'})
    dataSet.push({ id:'12.13.13.2018', kecamatan:'12.13.13', name:'Rantobi'})
    dataSet.push({ id:'12.21.08.2021', kecamatan:'12.21.08', name:'Rao-Rao Dolok'})
    dataSet.push({ id:'12.13.13.2019', kecamatan:'12.13.13', name:'Rao Rao'})
    dataSet.push({ id:'12.13.10.2020', kecamatan:'12.13.10', name:'Rao Rao Dolok'})
    dataSet.push({ id:'12.13.10.2021', kecamatan:'12.13.10', name:'Rao Rao Lombang'})
    dataSet.push({ id:'12.14.05.2009', kecamatan:'12.14.05', name:'Rapa-Rapa Melayu'})
    dataSet.push({ id:'12.22.03.2002', kecamatan:'12.22.03', name:'Rasau'})
    dataSet.push({ id:'12.12.07.2042', kecamatan:'12.12.07', name:'Raut Bosi'})
    dataSet.push({ id:'12.01.06.2012', kecamatan:'12.01.06', name:'Rawa Makmur'})
    dataSet.push({ id:'12.08.30.2020', kecamatan:'12.08.30', name:'Rawa Masin'})
    dataSet.push({ id:'12.09.18.2011', kecamatan:'12.09.18', name:'Rawa Sari'})
    dataSet.push({ id:'12.09.29.2002', kecamatan:'12.09.29', name:'Rawang Baru'})
    dataSet.push({ id:'12.09.29.2001', kecamatan:'12.09.29', name:'Rawang Lama'})
    dataSet.push({ id:'12.08.04.2017', kecamatan:'12.08.04', name:'Rawang Pardomuan Nauli'})
    dataSet.push({ id:'12.09.29.2003', kecamatan:'12.09.29', name:'Rawang Pasar Iv'})
    dataSet.push({ id:'12.09.29.2004', kecamatan:'12.09.29', name:'Rawang Pasar V'})
    dataSet.push({ id:'12.09.29.2007', kecamatan:'12.09.29', name:'Rawang Pasar Vi'})
    dataSet.push({ id:'12.06.02.2003', kecamatan:'12.06.02', name:'Raya'})
    dataSet.push({ id:'12.08.29.2004', kecamatan:'12.08.29', name:'Raya Bayu'})
    dataSet.push({ id:'12.08.29.2013', kecamatan:'12.08.29', name:'Raya Bosi'})
    dataSet.push({ id:'12.08.32.2001', kecamatan:'12.08.32', name:'Raya Huluan'})
    dataSet.push({ id:'12.08.32.2005', kecamatan:'12.08.32', name:'Raya Usang'})
    dataSet.push({ id:'12.06.05.2012', kecamatan:'12.06.05', name:'Regaji'})
    dataSet.push({ id:'12.07.32.2005', kecamatan:'12.07.32', name:'Regemuk'})
    dataSet.push({ id:'12.71.12.1002', kecamatan:'12.71.12', name:'Rengas Pulau'})
    dataSet.push({ id:'12.11.06.2011', kecamatan:'12.11.06', name:'Renun'})
    dataSet.push({ id:'12.16.02.2005', kecamatan:'12.16.02', name:'Ria Ria'})
    dataSet.push({ id:'12.08.30.2015', kecamatan:'12.08.30', name:'Riah Na Poso'})
    dataSet.push({ id:'12.01.02.2008', kecamatan:'12.01.02', name:'Rianiate'})
    dataSet.push({ id:'12.03.31.1002', kecamatan:'12.03.31', name:'Rianiate'})
    dataSet.push({ id:'12.12.06.2005', kecamatan:'12.12.06', name:'Rianiate'})
    dataSet.push({ id:'12.17.08.2008', kecamatan:'12.17.08', name:'Rianiate'})
    dataSet.push({ id:'12.12.06.2014', kecamatan:'12.12.06', name:'Riganjang'})
    dataSet.push({ id:'12.06.13.2012', kecamatan:'12.06.13', name:'Rih Tengah'})
    dataSet.push({ id:'12.77.06.2006', kecamatan:'12.77.06', name:'Rimba Soping'})
    dataSet.push({ id:'12.18.08.2012', kecamatan:'12.18.08', name:'Rimbun'})
    dataSet.push({ id:'12.06.10.2004', kecamatan:'12.06.10', name:'Rimo Bunga'})
    dataSet.push({ id:'12.06.11.2004', kecamatan:'12.06.11', name:'Rimo Kayu'})
    dataSet.push({ id:'12.07.06.2035', kecamatan:'12.07.06', name:'Rimo Mungkur'})
    dataSet.push({ id:'12.01.12.1007', kecamatan:'12.01.12', name:'Rina Bolak'})
    dataSet.push({ id:'12.17.02.2006', kecamatan:'12.17.02', name:'Rina Bolak'})
    dataSet.push({ id:'12.22.05.2005', kecamatan:'12.22.05', name:'Rintis'})
    dataSet.push({ id:'12.02.08.2006', kecamatan:'12.02.08', name:'Robean'})
    dataSet.push({ id:'12.21.08.2029', kecamatan:'12.21.08', name:'Roburan'})
    dataSet.push({ id:'12.13.04.2007', kecamatan:'12.13.04', name:'Roburan Dolok'})
    dataSet.push({ id:'12.13.04.2008', kecamatan:'12.13.04', name:'Roburan Lombang'})
    dataSet.push({ id:'12.21.09.2021', kecamatan:'12.21.09', name:'Rombayan'})
    dataSet.push({ id:'12.23.07.2003', kecamatan:'12.23.07', name:'Rombisan'})
    dataSet.push({ id:'12.20.11.2009', kecamatan:'12.20.11', name:'Rondaman'})
    dataSet.push({ id:'12.20.06.2007', kecamatan:'12.20.06', name:'Rondaman Dolok'})
    dataSet.push({ id:'12.20.06.2010', kecamatan:'12.20.06', name:'Rondaman Lombang'})
    dataSet.push({ id:'12.20.03.2006', kecamatan:'12.20.03', name:'Rondaman Siburegar'})
    dataSet.push({ id:'12.17.07.2005', kecamatan:'12.17.07', name:'Ronggur Nihuta'})
    dataSet.push({ id:'12.20.02.2084', kecamatan:'12.20.02', name:'Rongkare'})
    dataSet.push({ id:'12.18.10.2024', kecamatan:'12.18.10', name:'Rubun Dunia'})
    dataSet.push({ id:'12.13.16.2014', kecamatan:'12.13.16', name:'Rukun Jaya'})
    dataSet.push({ id:'12.08.05.2011', kecamatan:'12.08.05', name:'Rukun Mulyo'})
    dataSet.push({ id:'12.06.02.2004', kecamatan:'12.06.02', name:'Rumah Berastagi'})
    dataSet.push({ id:'12.07.09.2023', kecamatan:'12.07.09', name:'Rumah Deleng'})
    dataSet.push({ id:'12.05.04.2002', kecamatan:'12.05.04', name:'Rumah Galuh'})
    dataSet.push({ id:'12.07.07.2011', kecamatan:'12.07.07', name:'Rumah Gerat'})
    dataSet.push({ id:'12.06.01.2001', kecamatan:'12.06.01', name:'Rumah Kabanjahe'})
    dataSet.push({ id:'12.07.06.2024', kecamatan:'12.07.06', name:'Rumah Keben'})
    dataSet.push({ id:'12.07.03.2017', kecamatan:'12.07.03', name:'Rumah Kinangkung Sp'})
    dataSet.push({ id:'12.07.20.2016', kecamatan:'12.07.20', name:'Rumah Lengo'})
    dataSet.push({ id:'12.07.06.2016', kecamatan:'12.07.06', name:'Rumah Mbacang'})
    dataSet.push({ id:'12.07.03.2019', kecamatan:'12.07.03', name:'Rumah Pil Pil'})
    dataSet.push({ id:'12.07.20.2003', kecamatan:'12.07.20', name:'Rumah Rih'})
    dataSet.push({ id:'12.07.03.2020', kecamatan:'12.07.03', name:'Rumah Sumbul'})
    dataSet.push({ id:'12.07.20.2012', kecamatan:'12.07.20', name:'Rumah Sumbul'})
    dataSet.push({ id:'12.06.03.2002', kecamatan:'12.06.03', name:'Rumamis'})
    dataSet.push({ id:'12.13.02.2014', kecamatan:'12.13.02', name:'Rumbio'})
    dataSet.push({ id:'12.13.05.2007', kecamatan:'12.13.05', name:'Runding'})
    dataSet.push({ id:'12.16.09.2012', kecamatan:'12.16.09', name:'Rura Aek Sopang'})
    dataSet.push({ id:'12.02.04.2010', kecamatan:'12.02.04', name:'Rura Julu Dolok'})
    dataSet.push({ id:'12.02.04.2011', kecamatan:'12.02.04', name:'Rura Julu Toruan'})
    dataSet.push({ id:'12.16.09.2011', kecamatan:'12.16.09', name:'Rura Tanjung'})
    dataSet.push({ id:'12.10.09.2019', kecamatan:'12.10.09', name:'S-1 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2020', kecamatan:'12.10.09', name:'S-2 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2021', kecamatan:'12.10.09', name:'S-3 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2022', kecamatan:'12.10.09', name:'S-4 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2023', kecamatan:'12.10.09', name:'S-5 Aek Nabara'})
    dataSet.push({ id:'12.10.09.2024', kecamatan:'12.10.09', name:'S-6 Aek Nabara'})
    dataSet.push({ id:'12.20.03.2037', kecamatan:'12.20.03', name:'Saba'})
    dataSet.push({ id:'12.20.01.2012', kecamatan:'12.20.01', name:'Saba Bangun'})
    dataSet.push({ id:'12.20.04.2066', kecamatan:'12.20.04', name:'Saba Bangunan'})
    dataSet.push({ id:'12.03.04.2115', kecamatan:'12.03.04', name:'Saba Batang Miha'})
    dataSet.push({ id:'12.13.08.2022', kecamatan:'12.13.08', name:'Saba Dolok'})
    dataSet.push({ id:'12.13.01.2039', kecamatan:'12.13.01', name:'Saba Jambu'})
    dataSet.push({ id:'12.13.05.2009', kecamatan:'12.13.05', name:'Saba Jior'})
    dataSet.push({ id:'12.13.19.2012', kecamatan:'12.13.19', name:'Saba Padang'})
    dataSet.push({ id:'12.21.07.2011', kecamatan:'12.21.07', name:'Saba Rimba'})
    dataSet.push({ id:'12.20.04.2065', kecamatan:'12.20.04', name:'Saba Sitahul Tahul'})
    dataSet.push({ id:'12.08.16.2002', kecamatan:'12.08.16', name:'Sabaganding'})
    dataSet.push({ id:'12.21.07.2020', kecamatan:'12.21.07', name:'Sabahotang'})
    dataSet.push({ id:'12.17.09.2003', kecamatan:'12.17.09', name:'Sabulan'})
    dataSet.push({ id:'12.22.04.2003', kecamatan:'12.22.04', name:'Sabungan'})
    dataSet.push({ id:'12.77.04.1003', kecamatan:'12.77.04', name:'Sabungan Jae'})
    dataSet.push({ id:'12.17.07.2006', kecamatan:'12.17.07', name:'Sabungan Nihuta'})
    dataSet.push({ id:'12.77.04.2006', kecamatan:'12.77.04', name:'Sabungan Sipabangun'})
    dataSet.push({ id:'12.02.12.2002', kecamatan:'12.02.12', name:'Sabungannihuta I'})
    dataSet.push({ id:'12.02.12.2020', kecamatan:'12.02.12', name:'Sabungannihuta Ii'})
    dataSet.push({ id:'12.02.12.2013', kecamatan:'12.02.12', name:'Sabungannihuta Iii'})
    dataSet.push({ id:'12.02.12.2001', kecamatan:'12.02.12', name:'Sabungannihuta Iv'})
    dataSet.push({ id:'12.02.12.2021', kecamatan:'12.02.12', name:'Sabungannihuta V'})
    dataSet.push({ id:'12.06.15.2009', kecamatan:'12.06.15', name:'Sada Perarih'})
    dataSet.push({ id:'12.77.01.1009', kecamatan:'12.77.01', name:'Sadabuan'})
    dataSet.push({ id:'12.07.26.2009', kecamatan:'12.07.26', name:'Saentis'})
    dataSet.push({ id:'12.14.31.2010', kecamatan:'12.14.31', name:'Saeru Melayu'})
    dataSet.push({ id:'12.78.01.2021', kecamatan:'12.78.01', name:'Saewe'})
    dataSet.push({ id:'12.08.10.2001', kecamatan:'12.08.10', name:'Sait Buttu Saribu'})
    dataSet.push({ id:'12.01.14.2006', kecamatan:'12.01.14', name:'Sait Kalangan Ii'})
    dataSet.push({ id:'12.17.08.2016', kecamatan:'12.17.08', name:'Sait Nihuta'})
    dataSet.push({ id:'12.04.35.2005', kecamatan:'12.04.35', name:'Saitagaramba'})
    dataSet.push({ id:'12.16.06.2015', kecamatan:'12.16.06', name:'Saitnihuta'})
    dataSet.push({ id:'12.04.10.2023', kecamatan:'12.04.10', name:'Saiwahili Hili Adulo'})
    dataSet.push({ id:'12.07.03.2021', kecamatan:'12.07.03', name:'Sala Bulan'})
    dataSet.push({ id:'12.05.23.2008', kecamatan:'12.05.23', name:'Sala Haji'})
    dataSet.push({ id:'12.15.03.2001', kecamatan:'12.15.03', name:'Salak I'})
    dataSet.push({ id:'12.15.03.2002', kecamatan:'12.15.03', name:'Salak Ii'})
    dataSet.push({ id:'12.13.01.2025', kecamatan:'12.13.01', name:'Salam Bue'})
    dataSet.push({ id:'12.07.05.2009', kecamatan:'12.07.05', name:'Salam Tani'})
    dataSet.push({ id:'12.21.09.2022', kecamatan:'12.21.09', name:'Salambue'})
    dataSet.push({ id:'12.77.05.2004', kecamatan:'12.77.05', name:'Salambue'})
    dataSet.push({ id:'12.07.06.2033', kecamatan:'12.07.06', name:'Salang Tungir'})
    dataSet.push({ id:'12.17.07.2004', kecamatan:'12.17.07', name:'Salaon Dolok'})
    dataSet.push({ id:'12.17.07.2001', kecamatan:'12.17.07', name:'Salaon Toba'})
    dataSet.push({ id:'12.17.07.2003', kecamatan:'12.17.07', name:'Salaon Tonga Tonga'})
    dataSet.push({ id:'12.13.17.2012', kecamatan:'12.13.17', name:'Sali Baru'})
    dataSet.push({ id:'12.06.04.2031', kecamatan:'12.06.04', name:'Salit'})
    dataSet.push({ id:'12.25.08.2003', kecamatan:'12.25.08', name:'Saloo'})
    dataSet.push({ id:'12.20.01.2023', kecamatan:'12.20.01', name:'Salusuhan'})
    dataSet.push({ id:'12.14.10.2005', kecamatan:'12.14.10', name:'Samadaya Hilisimaetano'})
    dataSet.push({ id:'12.78.04.2025', kecamatan:'12.78.04', name:'Samasi'})
    dataSet.push({ id:'12.11.13.2001', kecamatan:'12.11.13', name:'Sambaliang'})
    dataSet.push({ id:'12.05.05.2002', kecamatan:'12.05.05', name:'Sambi Rejo'})
    dataSet.push({ id:'12.07.26.2002', kecamatan:'12.07.26', name:'Sambirejo Timur'})
    dataSet.push({ id:'12.08.07.2001', kecamatan:'12.08.07', name:'Sambosar Raya'})
    dataSet.push({ id:'12.14.19.2001', kecamatan:'12.14.19', name:'Sambulu'})
    dataSet.push({ id:'12.14.08.2044', kecamatan:'12.14.08', name:'Samiri'})
    dataSet.push({ id:'12.02.13.2002', kecamatan:'12.02.13', name:'Sampagul'})
    dataSet.push({ id:'12.07.26.2010', kecamatan:'12.07.26', name:'Sampali'})
    dataSet.push({ id:'12.01.11.2002', kecamatan:'12.01.11', name:'Sampang Maruhur'})
    dataSet.push({ id:'12.07.04.2007', kecamatan:'12.07.04', name:'Sampe Cita'})
    dataSet.push({ id:'12.05.01.2004', kecamatan:'12.05.01', name:'Sampe Raya'})
    dataSet.push({ id:'12.16.08.2007', kecamatan:'12.16.08', name:'Sampe Tua'})
    dataSet.push({ id:'12.03.04.2072', kecamatan:'12.03.04', name:'Sampean'})
    dataSet.push({ id:'12.16.06.2006', kecamatan:'12.16.06', name:'Sampean'})
    dataSet.push({ id:'12.22.04.2008', kecamatan:'12.22.04', name:'Sampean'})
    dataSet.push({ id:'12.12.10.2018', kecamatan:'12.12.10', name:'Sampuara'})
    dataSet.push({ id:'12.06.14.2005', kecamatan:'12.06.14', name:'Sampun'})
    dataSet.push({ id:'12.17.05.2006', kecamatan:'12.17.05', name:'Sampur Toba'})
    dataSet.push({ id:'12.02.15.2007', kecamatan:'12.02.15', name:'Sampuran'})
    dataSet.push({ id:'12.13.18.2003', kecamatan:'12.13.18', name:'Sampuran'})
    dataSet.push({ id:'12.20.04.2028', kecamatan:'12.20.04', name:'Sampuran'})
    dataSet.push({ id:'12.20.09.2003', kecamatan:'12.20.09', name:'Sampuran Simarloting'})
    dataSet.push({ id:'12.06.01.2004', kecamatan:'12.06.01', name:'Samura'})
    dataSet.push({ id:'12.24.02.2003', kecamatan:'12.24.02', name:'Sanawuyu'})
    dataSet.push({ id:'12.20.03.2011', kecamatan:'12.20.03', name:'Sandean Jae'})
    dataSet.push({ id:'12.20.03.2013', kecamatan:'12.20.03', name:'Sandean Julu'})
    dataSet.push({ id:'12.20.03.2012', kecamatan:'12.20.03', name:'Sandean Tonga'})
    dataSet.push({ id:'12.04.10.2028', kecamatan:'12.04.10', name:'Sandruta'})
    dataSet.push({ id:'12.05.13.2008', kecamatan:'12.05.13', name:'Sangga Lima'})
    dataSet.push({ id:'12.03.03.2096', kecamatan:'12.03.03', name:'Sanggapati'})
    dataSet.push({ id:'12.16.07.2002', kecamatan:'12.16.07', name:'Sanggaran I'})
    dataSet.push({ id:'12.16.08.2012', kecamatan:'12.16.08', name:'Sanggaran Ii'})
    dataSet.push({ id:'12.12.01.1037', kecamatan:'12.12.01', name:'Sangkar Nihuta'})
    dataSet.push({ id:'12.02.02.2008', kecamatan:'12.02.02', name:'Sangkaran'})
    dataSet.push({ id:'12.21.04.2018', kecamatan:'12.21.04', name:'Sangkilon'})
    dataSet.push({ id:'12.03.31.1001', kecamatan:'12.03.31', name:'Sangkunur'})
    dataSet.push({ id:'12.17.04.2010', kecamatan:'12.17.04', name:'Saor Nauli Hatoguan'})
    dataSet.push({ id:'12.01.05.2002', kecamatan:'12.01.05', name:'Saragih'})
    dataSet.push({ id:'12.01.05.2010', kecamatan:'12.01.05', name:'Saragih Barat'})
    dataSet.push({ id:'12.01.05.2011', kecamatan:'12.01.05', name:'Saragih Timur'})
    dataSet.push({ id:'12.14.03.2018', kecamatan:'12.14.03', name:'Sarahililaza'})
    dataSet.push({ id:'12.13.01.2026', kecamatan:'12.13.01', name:'Sarak Matua'})
    dataSet.push({ id:'12.08.26.2003', kecamatan:'12.08.26', name:'Saran Padang'})
    dataSet.push({ id:'12.18.17.2018', kecamatan:'12.18.17', name:'Sarang Ginting Hulu'})
    dataSet.push({ id:'12.18.17.2017', kecamatan:'12.18.17', name:'Sarang Ginting Kahan'})
    dataSet.push({ id:'12.18.09.2019', kecamatan:'12.18.09', name:'Sarang Giting'})
    dataSet.push({ id:'12.09.25.2004', kecamatan:'12.09.25', name:'Sarang Helang'})
    dataSet.push({ id:'12.18.09.2021', kecamatan:'12.18.09', name:'Sarang Torop'})
    dataSet.push({ id:'12.13.15.2014', kecamatan:'12.13.15', name:'Sari Kenanga Batahan'})
    dataSet.push({ id:'12.71.16.1003', kecamatan:'12.71.16', name:'Sari Rejo'})
    dataSet.push({ id:'12.08.12.2005', kecamatan:'12.08.12', name:'Saribu Asih'})
    dataSet.push({ id:'12.08.31.2007', kecamatan:'12.08.31', name:'Saribu Jandi'})
    dataSet.push({ id:'12.12.01.2019', kecamatan:'12.12.01', name:'Saribu Raja Janji Maria'})
    dataSet.push({ id:'12.07.07.2015', kecamatan:'12.07.07', name:'Sarilaba Jahe'})
    dataSet.push({ id:'12.06.03.2018', kecamatan:'12.06.03', name:'Sarimanis'})
    dataSet.push({ id:'12.08.09.1013', kecamatan:'12.08.09', name:'Sarimatondang'})
    dataSet.push({ id:'12.08.10.2003', kecamatan:'12.08.10', name:'Sarimattin'})
    dataSet.push({ id:'12.06.06.2011', kecamatan:'12.06.06', name:'Sarimunte'})
    dataSet.push({ id:'12.06.06.2016', kecamatan:'12.06.06', name:'Sarinembah'})
    dataSet.push({ id:'12.11.03.2004', kecamatan:'12.11.03', name:'Sarintonu'})
    dataSet.push({ id:'12.01.05.2005', kecamatan:'12.01.05', name:'Sarma Nauli'})
    dataSet.push({ id:'12.03.04.2116', kecamatan:'12.03.04', name:'Sarogodung'})
    dataSet.push({ id:'12.01.20.1002', kecamatan:'12.01.20', name:'Sarudik'})
    dataSet.push({ id:'12.02.06.1001', kecamatan:'12.02.06', name:'Sarulla'})
    dataSet.push({ id:'12.13.16.2029', kecamatan:'12.13.16', name:'Sasaran'})
    dataSet.push({ id:'12.01.06.2005', kecamatan:'12.01.06', name:'Satahi Nauli'})
    dataSet.push({ id:'12.75.02.1002', kecamatan:'12.75.02', name:'Satria'})
    dataSet.push({ id:'12.76.03.1006', kecamatan:'12.76.03', name:'Satria'})
    dataSet.push({ id:'12.03.05.2070', kecamatan:'12.03.05', name:'Saut Banua Simanosor'})
    dataSet.push({ id:'12.01.12.2014', kecamatan:'12.01.12', name:'Sawah Lamo'})
    dataSet.push({ id:'12.05.20.2005', kecamatan:'12.05.20', name:'Sawit Hulu'})
    dataSet.push({ id:'12.07.04.2012', kecamatan:'12.07.04', name:'Sawit Rejo'})
    dataSet.push({ id:'12.05.20.1001', kecamatan:'12.05.20', name:'Sawit Seberang'})
    dataSet.push({ id:'12.24.02.2008', kecamatan:'12.24.02', name:'Sawo'})
    dataSet.push({ id:'12.07.03.2022', kecamatan:'12.07.03', name:'Sayum Sabah'})
    dataSet.push({ id:'12.21.10.2009', kecamatan:'12.21.10', name:'Sayur Mahincat'})
    dataSet.push({ id:'12.21.11.2025', kecamatan:'12.21.11', name:'Sayur Mahincat'})
    dataSet.push({ id:'12.13.08.2025', kecamatan:'12.13.08', name:'Sayur Maincat'})
    dataSet.push({ id:'12.13.19.2009', kecamatan:'12.13.19', name:'Sayur Maincat'})
    dataSet.push({ id:'12.03.21.1063', kecamatan:'12.03.21', name:'Sayur Matinggi'})
    dataSet.push({ id:'12.08.30.2005', kecamatan:'12.08.30', name:'Sayur Matinggi'})
    dataSet.push({ id:'12.20.01.2025', kecamatan:'12.20.01', name:'Sayur Matinggi'})
    dataSet.push({ id:'12.20.07.1001', kecamatan:'12.20.07', name:'Sayur Matinggi'})
    dataSet.push({ id:'12.20.07.2023', kecamatan:'12.20.07', name:'Sayur Matinggi Julu'})
    dataSet.push({ id:'12.13.23.2005', kecamatan:'12.13.23', name:'Sayur Matua'})
    dataSet.push({ id:'12.21.07.2025', kecamatan:'12.21.07', name:'Sayur Matua'})
    dataSet.push({ id:'12.21.11.2024', kecamatan:'12.21.11', name:'Sayur Matua'})
    dataSet.push({ id:'12.06.04.2027', kecamatan:'12.06.04', name:'Seberaya'})
    dataSet.push({ id:'12.05.21.2007', kecamatan:'12.05.21', name:'Sebertung'})
    dataSet.push({ id:'12.14.05.2051', kecamatan:'12.14.05', name:'Sebuasi'})
    dataSet.push({ id:'12.05.09.2008', kecamatan:'12.05.09', name:'Secanggang'})
    dataSet.push({ id:'12.05.14.2005', kecamatan:'12.05.14', name:'Securai Selatan'})
    dataSet.push({ id:'12.05.14.2002', kecamatan:'12.05.14', name:'Securai Utara'})
    dataSet.push({ id:'12.71.05.1005', kecamatan:'12.71.05', name:'Sei Agul'})
    dataSet.push({ id:'12.09.23.2007', kecamatan:'12.09.23', name:'Sei Alim Hasak'})
    dataSet.push({ id:'12.09.13.2001', kecamatan:'12.09.13', name:'Sei Alim Ulu'})
    dataSet.push({ id:'12.09.10.2007', kecamatan:'12.09.10', name:'Sei Apung'})
    dataSet.push({ id:'12.23.03.2007', kecamatan:'12.23.03', name:'Sei Apung'})
    dataSet.push({ id:'12.09.10.2008', kecamatan:'12.09.10', name:'Sei Apung Jaya'})
    dataSet.push({ id:'12.07.24.2002', kecamatan:'12.07.24', name:'Sei Baharu'})
    dataSet.push({ id:'12.19.07.2002', kecamatan:'12.19.07', name:'Sei Balai'})
    dataSet.push({ id:'12.05.19.2002', kecamatan:'12.05.19', name:'Sei Bamban'})
    dataSet.push({ id:'12.18.15.2002', kecamatan:'12.18.15', name:'Sei Bamban'})
    dataSet.push({ id:'12.18.15.2007', kecamatan:'12.18.15', name:'Sei Bamban Estate'})
    dataSet.push({ id:'12.10.19.2007', kecamatan:'12.10.19', name:'Sei Baru'})
    dataSet.push({ id:'12.19.07.2008', kecamatan:'12.19.07', name:'Sei Bejangkar'})
    dataSet.push({ id:'12.09.08.2011', kecamatan:'12.09.08', name:'Sei Beluru'})
    dataSet.push({ id:'12.18.15.2008', kecamatan:'12.18.15', name:'Sei Belutu'})
    dataSet.push({ id:'12.07.23.2017', kecamatan:'12.07.23', name:'Sei Beras Sekata'})
    dataSet.push({ id:'12.10.19.1001', kecamatan:'12.10.19', name:'Sei Berombang'})
    dataSet.push({ id:'12.05.17.1001', kecamatan:'12.05.17', name:'Sei Bilah'})
    dataSet.push({ id:'12.05.17.1010', kecamatan:'12.05.17', name:'Sei Bilah Timur'})
    dataSet.push({ id:'12.19.01.2010', kecamatan:'12.19.01', name:'Sei Buah Keras'})
    dataSet.push({ id:'12.18.02.2031', kecamatan:'12.18.02', name:'Sei Buluh'})
    dataSet.push({ id:'12.18.03.2001', kecamatan:'12.18.03', name:'Sei Buluh'})
    dataSet.push({ id:'12.18.15.2009', kecamatan:'12.18.15', name:'Sei Buluh'})
    dataSet.push({ id:'12.09.12.2006', kecamatan:'12.09.12', name:'Sei Dua Hulu'})
    dataSet.push({ id:'12.07.05.2022', kecamatan:'12.07.05', name:'Sei Glugur'})
    dataSet.push({ id:'12.09.24.2002', kecamatan:'12.09.24', name:'Sei Jawi-Jawi'})
    dataSet.push({ id:'12.10.20.2007', kecamatan:'12.10.20', name:'Sei Jawi-Jawi'})
    dataSet.push({ id:'12.09.23.2009', kecamatan:'12.09.23', name:'Sei Kamah Baru'})
    dataSet.push({ id:'12.09.23.2004', kecamatan:'12.09.23', name:'Sei Kamah I'})
    dataSet.push({ id:'12.09.23.2005', kecamatan:'12.09.23', name:'Sei Kamah Ii'})
    dataSet.push({ id:'12.07.19.2031', kecamatan:'12.07.19', name:'Sei Karang'})
    dataSet.push({ id:'12.18.10.2010', kecamatan:'12.18.10', name:'Sei Kari'})
    dataSet.push({ id:'12.10.08.2013', kecamatan:'12.10.08', name:'Sei Kasih'})
    dataSet.push({ id:'12.09.11.2010', kecamatan:'12.09.11', name:'Sei Kepayang Kanan'})
    dataSet.push({ id:'12.09.24.2006', kecamatan:'12.09.24', name:'Sei Kepayang Kiri'})
    dataSet.push({ id:'12.09.11.2008', kecamatan:'12.09.11', name:'Sei Kepayang Tengah'})
    dataSet.push({ id:'12.71.18.1003', kecamatan:'12.71.18', name:'Sei Kera Hilir I'})
    dataSet.push({ id:'12.71.18.1004', kecamatan:'12.71.18', name:'Sei Kera Hilir Ii'})
    dataSet.push({ id:'12.71.18.1005', kecamatan:'12.71.18', name:'Sei Kera Hulu'})
    dataSet.push({ id:'12.09.17.2006', kecamatan:'12.09.17', name:'Sei Kopas'})
    dataSet.push({ id:'12.09.12.2007', kecamatan:'12.09.12', name:'Sei Lama'})
    dataSet.push({ id:'12.09.24.2005', kecamatan:'12.09.24', name:'Sei Lendir'})
    dataSet.push({ id:'12.05.06.2002', kecamatan:'12.05.06', name:'Sei Limbat'})
    dataSet.push({ id:'12.05.20.2004', kecamatan:'12.05.20', name:'Sei Litur Tasik'})
    dataSet.push({ id:'12.10.19.2003', kecamatan:'12.10.19', name:'Sei Lumut'})
    dataSet.push({ id:'12.09.25.2001', kecamatan:'12.09.25', name:'Sei Lunang'})
    dataSet.push({ id:'12.08.08.2004', kecamatan:'12.08.08', name:'Sei Mangkei'})
    dataSet.push({ id:'12.71.13.1002', kecamatan:'12.71.13', name:'Sei Mati'})
    dataSet.push({ id:'12.71.15.1005', kecamatan:'12.71.15', name:'Sei Mati'})
    dataSet.push({ id:'12.07.04.2014', kecamatan:'12.07.04', name:'Sei Mencirim'})
    dataSet.push({ id:'12.07.23.2011', kecamatan:'12.07.23', name:'Sei Mencirim'})
    dataSet.push({ id:'12.19.12.2008', kecamatan:'12.19.12', name:'Sei Mentaram'})
    dataSet.push({ id:'12.07.02.2007', kecamatan:'12.07.02', name:'Sei Merah'})
    dataSet.push({ id:'12.05.15.2006', kecamatan:'12.05.15', name:'Sei Meran'})
    dataSet.push({ id:'12.22.03.2014', kecamatan:'12.22.03', name:'Sei Meranti'})
    dataSet.push({ id:'12.08.30.2016', kecamatan:'12.08.30', name:'Sei Merbau'})
    dataSet.push({ id:'12.74.04.1001', kecamatan:'12.74.04', name:'Sei Merbau'})
    dataSet.push({ id:'12.10.18.2005', kecamatan:'12.10.18', name:'Sei Merdeka'})
    dataSet.push({ id:'12.19.11.2002', kecamatan:'12.19.11', name:'Sei Muka'})
    dataSet.push({ id:'12.05.19.2003', kecamatan:'12.05.19', name:'Sei Musam'})
    dataSet.push({ id:'12.05.01.2017', kecamatan:'12.05.01', name:'Sei Musam Kendit'})
    dataSet.push({ id:'12.09.17.2003', kecamatan:'12.09.17', name:'Sei Nadoras'})
    dataSet.push({ id:'12.18.02.2032', kecamatan:'12.18.02', name:'Sei Nagalawan'})
    dataSet.push({ id:'12.10.18.2004', kecamatan:'12.10.18', name:'Sei Nahodaris'})
    dataSet.push({ id:'12.09.24.2001', kecamatan:'12.09.24', name:'Sei Nangka'})
    dataSet.push({ id:'12.09.11.2011', kecamatan:'12.09.11', name:'Sei Paham'})
    dataSet.push({ id:'12.18.04.2009', kecamatan:'12.18.04', name:'Sei Parit'})
    dataSet.push({ id:'12.09.25.2002', kecamatan:'12.09.25', name:'Sei Pasir'})
    dataSet.push({ id:'12.10.18.2002', kecamatan:'12.10.18', name:'Sei Pelancang'})
    dataSet.push({ id:'12.10.19.2002', kecamatan:'12.10.19', name:'Sei Penggantungan'})
    dataSet.push({ id:'12.05.03.2013', kecamatan:'12.05.03', name:'Sei Penjara'})
    dataSet.push({ id:'12.09.14.2001', kecamatan:'12.09.14', name:'Sei Piring'})
    dataSet.push({ id:'12.18.13.2010', kecamatan:'12.18.13', name:'Sei Priok'})
    dataSet.push({ id:'12.07.19.2030', kecamatan:'12.07.19', name:'Sei Putih'})
    dataSet.push({ id:'12.71.19.1004', kecamatan:'12.71.19', name:'Sei Putih Barat'})
    dataSet.push({ id:'12.71.19.1005', kecamatan:'12.71.19', name:'Sei Putih Tengah'})
    dataSet.push({ id:'12.71.19.1006', kecamatan:'12.71.19', name:'Sei Putih Timur I'})
    dataSet.push({ id:'12.71.19.1007', kecamatan:'12.71.19', name:'Sei Putih Timur Ii'})
    dataSet.push({ id:'12.19.01.2020', kecamatan:'12.19.01', name:'Sei Raja'})
    dataSet.push({ id:'12.74.03.1005', kecamatan:'12.74.03', name:'Sei Raja'})
    dataSet.push({ id:'12.10.18.2006', kecamatan:'12.10.18', name:'Sei Rakyat'})
    dataSet.push({ id:'12.19.01.2011', kecamatan:'12.19.01', name:'Sei Rakyat'})
    dataSet.push({ id:'12.18.04.2006', kecamatan:'12.18.04', name:'Sei Rampah'})
    dataSet.push({ id:'12.18.04.2008', kecamatan:'12.18.04', name:'Sei Rejo'})
    dataSet.push({ id:'12.71.01.1003', kecamatan:'12.71.01', name:'Sei Rengas I'})
    dataSet.push({ id:'12.71.10.1003', kecamatan:'12.71.10', name:'Sei Rengas Ii'})
    dataSet.push({ id:'12.71.10.1004', kecamatan:'12.71.10', name:'Sei Rengas Permata'})
    dataSet.push({ id:'12.09.19.1008', kecamatan:'12.09.19', name:'Sei Renggas'})
    dataSet.push({ id:'12.07.26.2018', kecamatan:'12.07.26', name:'Sei Rotan'})
    dataSet.push({ id:'12.10.19.2006', kecamatan:'12.10.19', name:'Sei Sakat'})
    dataSet.push({ id:'12.10.19.2005', kecamatan:'12.10.19', name:'Sei Sanggul'})
    dataSet.push({ id:'12.07.23.2001', kecamatan:'12.07.23', name:'Sei Semayang'})
    dataSet.push({ id:'12.09.25.2005', kecamatan:'12.09.25', name:'Sei Sembilang'})
    dataSet.push({ id:'12.23.03.2003', kecamatan:'12.23.03', name:'Sei Sentang'})
    dataSet.push({ id:'12.10.20.2005', kecamatan:'12.10.20', name:'Sei Sentosa'})
    dataSet.push({ id:'12.05.19.2004', kecamatan:'12.05.19', name:'Sei Serdang'})
    dataSet.push({ id:'12.18.13.2007', kecamatan:'12.18.13', name:'Sei Serimah'})
    dataSet.push({ id:'12.09.24.2003', kecamatan:'12.09.24', name:'Sei Serindan'})
    dataSet.push({ id:'12.10.18.2003', kecamatan:'12.10.18', name:'Sei Siarti'})
    dataSet.push({ id:'12.18.02.2033', kecamatan:'12.18.02', name:'Sei Sijenggi'})
    dataSet.push({ id:'12.71.02.1002', kecamatan:'12.71.02', name:'Sei Sikambing B'})
    dataSet.push({ id:'12.71.03.1007', kecamatan:'12.71.03', name:'Sei Sikambing C Ii'})
    dataSet.push({ id:'12.71.19.1003', kecamatan:'12.71.19', name:'Sei Sikambing D'})
    dataSet.push({ id:'12.09.27.2003', kecamatan:'12.09.27', name:'Sei Silau Barat'})
    dataSet.push({ id:'12.09.16.2007', kecamatan:'12.09.16', name:'Sei Silau Timur'})
    dataSet.push({ id:'12.09.27.2002', kecamatan:'12.09.27', name:'Sei Silau Tua'})
    dataSet.push({ id:'12.19.08.2009', kecamatan:'12.19.08', name:'Sei Simujur'})
    dataSet.push({ id:'12.05.15.2002', kecamatan:'12.05.15', name:'Sei Siur'})
    dataSet.push({ id:'12.19.02.2007', kecamatan:'12.19.02', name:'Sei Suka Deras'})
    dataSet.push({ id:'12.10.08.2008', kecamatan:'12.10.08', name:'Sei Tampang'})
    dataSet.push({ id:'12.10.08.2012', kecamatan:'12.10.08', name:'Sei Tarolat'})
    dataSet.push({ id:'12.10.19.2004', kecamatan:'12.10.19', name:'Sei Tawar'})
    dataSet.push({ id:'12.09.25.2003', kecamatan:'12.09.25', name:'Sei Tempurung'})
    dataSet.push({ id:'12.08.08.2008', kecamatan:'12.08.08', name:'Sei Torop'})
    dataSet.push({ id:'12.05.18.2002', kecamatan:'12.05.18', name:'Sei Tualang'})
    dataSet.push({ id:'12.09.24.2004', kecamatan:'12.09.24', name:'Sei Tualang Pandau'})
    dataSet.push({ id:'12.07.32.2001', kecamatan:'12.07.32', name:'Sei Tuan'})
    dataSet.push({ id:'12.08.01.2006', kecamatan:'12.08.01', name:'Sejahtera'})
    dataSet.push({ id:'12.74.02.1003', kecamatan:'12.74.02', name:'Sejahtera'})
    dataSet.push({ id:'12.07.28.2001', kecamatan:'12.07.28', name:'Sekip'})
    dataSet.push({ id:'12.71.19.1002', kecamatan:'12.71.19', name:'Sekip'})
    dataSet.push({ id:'12.05.16.2006', kecamatan:'12.05.16', name:'Sekoci'})
    dataSet.push({ id:'12.06.06.2017', kecamatan:'12.06.06', name:'Selakkar'})
    dataSet.push({ id:'12.02.08.2008', kecamatan:'12.02.08', name:'Selamat'})
    dataSet.push({ id:'12.07.07.2014', kecamatan:'12.07.07', name:'Selamat'})
    dataSet.push({ id:'12.06.11.2007', kecamatan:'12.06.11', name:'Selandi'})
    dataSet.push({ id:'12.10.08.2009', kecamatan:'12.10.08', name:'Selat Besar'})
    dataSet.push({ id:'12.10.18.2007', kecamatan:'12.10.18', name:'Selat Beting'})
    dataSet.push({ id:'12.74.06.1003', kecamatan:'12.74.06', name:'Selat Lancang'})
    dataSet.push({ id:'12.74.06.1005', kecamatan:'12.74.06', name:'Selat Tanjung Medan'})
    dataSet.push({ id:'12.09.20.1005', kecamatan:'12.09.20', name:'Selawan'})
    dataSet.push({ id:'12.05.06.2010', kecamatan:'12.05.06', name:'Selayang'})
    dataSet.push({ id:'12.05.06.2014', kecamatan:'12.05.06', name:'Selayang Baru'})
    dataSet.push({ id:'12.07.24.2008', kecamatan:'12.07.24', name:'Selemak'})
    dataSet.push({ id:'12.05.09.2009', kecamatan:'12.05.09', name:'Selotong'})
    dataSet.push({ id:'12.06.03.2015', kecamatan:'12.06.03', name:'Semangat'})
    dataSet.push({ id:'12.06.15.2002', kecamatan:'12.06.15', name:'Semangat'})
    dataSet.push({ id:'12.06.15.2006', kecamatan:'12.06.15', name:'Semangat Gunung'})
    dataSet.push({ id:'12.05.01.2015', kecamatan:'12.05.01', name:'Sematar'})
    dataSet.push({ id:'12.07.03.2023', kecamatan:'12.07.03', name:'Sembahe'})
    dataSet.push({ id:'12.07.05.2020', kecamatan:'12.07.05', name:'Sembahe Baru'})
    dataSet.push({ id:'12.18.01.2008', kecamatan:'12.18.01', name:'Sementara'})
    dataSet.push({ id:'12.06.02.2005', kecamatan:'12.06.02', name:'Sempajaya'})
    dataSet.push({ id:'12.71.21.1006', kecamatan:'12.71.21', name:'Sempakata'})
    dataSet.push({ id:'12.11.11.2005', kecamatan:'12.11.11', name:'Sempung Polling'})
    dataSet.push({ id:'12.74.06.1002', kecamatan:'12.74.06', name:'Semula Jadi'})
    dataSet.push({ id:'12.07.27.2001', kecamatan:'12.07.27', name:'Sena'})
    dataSet.push({ id:'12.05.05.2003', kecamatan:'12.05.05', name:'Sendang Rejo'})
    dataSet.push({ id:'12.09.19.1009', kecamatan:'12.09.19', name:'Sendang Sari'})
    dataSet.push({ id:'12.09.18.2009', kecamatan:'12.09.18', name:'Sengon Sari'})
    dataSet.push({ id:'12.08.02.2002', kecamatan:'12.08.02', name:'Senio'})
    dataSet.push({ id:'12.10.14.2006', kecamatan:'12.10.14', name:'Sennah'})
    dataSet.push({ id:'12.18.14.2013', kecamatan:'12.18.14', name:'Sennah'})
    dataSet.push({ id:'12.09.20.1004', kecamatan:'12.09.20', name:'Sentang'})
    dataSet.push({ id:'12.18.03.2010', kecamatan:'12.18.03', name:'Sentang'})
    dataSet.push({ id:'12.19.12.2001', kecamatan:'12.19.12', name:'Sentang'})
    dataSet.push({ id:'12.14.04.2023', kecamatan:'12.14.04', name:'Sepakat'})
    dataSet.push({ id:'12.05.23.2007', kecamatan:'12.05.23', name:'Serang Jaya'})
    dataSet.push({ id:'12.05.23.2006', kecamatan:'12.05.23', name:'Serang Jaya Hilir'})
    dataSet.push({ id:'12.05.21.2001', kecamatan:'12.05.21', name:'Serapit'})
    dataSet.push({ id:'12.08.02.2004', kecamatan:'12.08.02', name:'Serapuh'})
    dataSet.push({ id:'12.05.12.2001', kecamatan:'12.05.12', name:'Serapuh Abc'})
    dataSet.push({ id:'12.05.11.2001', kecamatan:'12.05.11', name:'Serapuh Asli'})
    dataSet.push({ id:'12.18.12.2032', kecamatan:'12.18.12', name:'Serba Jadi'})
    dataSet.push({ id:'12.07.23.2014', kecamatan:'12.07.23', name:'Serbajadi'})
    dataSet.push({ id:'12.18.08.2002', kecamatan:'12.18.08', name:'Serbananti'})
    dataSet.push({ id:'12.08.17.1015', kecamatan:'12.08.17', name:'Serbelawan'})
    dataSet.push({ id:'12.06.03.2016', kecamatan:'12.06.03', name:'Serdang'})
    dataSet.push({ id:'12.07.33.2001', kecamatan:'12.07.33', name:'Serdang'})
    dataSet.push({ id:'12.09.08.2012', kecamatan:'12.09.08', name:'Serdang'})
    dataSet.push({ id:'12.08.25.1012', kecamatan:'12.08.25', name:'Seribu Dolok'})
    dataSet.push({ id:'12.08.14.2009', kecamatan:'12.08.14', name:'Seribu Jandi'})
    dataSet.push({ id:'12.24.02.2001', kecamatan:'12.24.02', name:'Seriwa U'})
    dataSet.push({ id:'12.02.06.2011', kecamatan:'12.02.06', name:'Setia'})
    dataSet.push({ id:'12.75.02.1003', kecamatan:'12.75.02', name:'Setia'})
    dataSet.push({ id:'12.13.16.2015', kecamatan:'12.13.16', name:'Setia Karya'})
    dataSet.push({ id:'12.72.07.1003', kecamatan:'12.72.07', name:'Setia Negara'})
    dataSet.push({ id:'12.04.11.2020', kecamatan:'12.04.11', name:'Si Ofaewali Selatan'})
    dataSet.push({ id:'12.18.10.2004', kecamatan:'12.18.10', name:'Si Ujan Ujan'})
    dataSet.push({ id:'12.02.12.2010', kecamatan:'12.02.12', name:'Siabal-Abal I'})
    dataSet.push({ id:'12.02.12.2015', kecamatan:'12.02.12', name:'Siabal-Abal Ii'})
    dataSet.push({ id:'12.02.12.2009', kecamatan:'12.02.12', name:'Siabal-Abal Iii'})
    dataSet.push({ id:'12.02.12.2022', kecamatan:'12.02.12', name:'Siabal-Abal Iv'})
    dataSet.push({ id:'12.02.12.2024', kecamatan:'12.02.12', name:'Siabal-Abal V'})
    dataSet.push({ id:'12.02.12.2025', kecamatan:'12.02.12', name:'Siabal-Abal Vi'})
    dataSet.push({ id:'12.06.13.2003', kecamatan:'12.06.13', name:'Siabang-Abang'})
    dataSet.push({ id:'12.13.06.1014', kecamatan:'12.13.06', name:'Siabu'})
    dataSet.push({ id:'12.21.05.2015', kecamatan:'12.21.05', name:'Siabu'})
    dataSet.push({ id:'12.21.09.2008', kecamatan:'12.21.09', name:'Siadam'})
    dataSet.push({ id:'12.18.17.2019', kecamatan:'12.18.17', name:'Siahap'})
    dataSet.push({ id:'12.20.02.2055', kecamatan:'12.20.02', name:'Siala Gundi'})
    dataSet.push({ id:'12.21.03.2009', kecamatan:'12.21.03', name:'Siala Gundi'})
    dataSet.push({ id:'12.03.04.2085', kecamatan:'12.03.04', name:'Sialagundi'})
    dataSet.push({ id:'12.03.04.2105', kecamatan:'12.03.04', name:'Sialaman'})
    dataSet.push({ id:'12.21.07.2006', kecamatan:'12.21.07', name:'Sialambue'})
    dataSet.push({ id:'12.03.21.2005', kecamatan:'12.03.21', name:'Sialang'})
    dataSet.push({ id:'12.07.09.2025', kecamatan:'12.07.09', name:'Sialang'})
    dataSet.push({ id:'12.20.05.2023', kecamatan:'12.20.05', name:'Sialang'})
    dataSet.push({ id:'12.18.03.2009', kecamatan:'12.18.03', name:'Sialang Buah'})
    dataSet.push({ id:'12.20.02.2074', kecamatan:'12.20.02', name:'Sialang Dolok'})
    dataSet.push({ id:'12.07.24.2010', kecamatan:'12.07.24', name:'Sialang Muda'})
    dataSet.push({ id:'12.23.08.2012', kecamatan:'12.23.08', name:'Sialang Taji'})
    dataSet.push({ id:'12.17.08.2019', kecamatan:'12.17.08', name:'Sialanguan'})
    dataSet.push({ id:'12.14.04.2005', kecamatan:'12.14.04', name:'Sialema'})
    dataSet.push({ id:'12.21.04.2019', kecamatan:'12.21.04', name:'Siali-Ali'})
    dataSet.push({ id:'12.17.01.2021', kecamatan:'12.17.01', name:'Siallagan Pindaraya'})
    dataSet.push({ id:'12.01.19.2007', kecamatan:'12.01.19', name:'Sialogo'})
    dataSet.push({ id:'12.03.01.2016', kecamatan:'12.03.01', name:'Sialogo'})
    dataSet.push({ id:'12.18.10.2022', kecamatan:'12.18.10', name:'Sialtong'})
    dataSet.push({ id:'12.16.09.2007', kecamatan:'12.16.09', name:'Siambaton'})
    dataSet.push({ id:'12.16.09.2020', kecamatan:'12.16.09', name:'Siambaton Pahae'})
    dataSet.push({ id:'12.23.08.2003', kecamatan:'12.23.08', name:'Siamporik'})
    dataSet.push({ id:'12.03.06.2009', kecamatan:'12.03.06', name:'Siamporik Dolok'})
    dataSet.push({ id:'12.03.06.2010', kecamatan:'12.03.06', name:'Siamporik Lombang'})
    dataSet.push({ id:'12.25.05.2008', kecamatan:'12.25.05', name:'Sianaa'})
    dataSet.push({ id:'12.20.11.2001', kecamatan:'12.20.11', name:'Siancimun'})
    dataSet.push({ id:'12.02.01.2011', kecamatan:'12.02.01', name:'Siandor-Andor'})
    dataSet.push({ id:'12.03.02.2025', kecamatan:'12.03.02', name:'Sianggunan'})
    dataSet.push({ id:'12.21.01.2012', kecamatan:'12.21.01', name:'Sianggunan'})
    dataSet.push({ id:'12.12.01.2016', kecamatan:'12.12.01', name:'Sianipar Sihailhail'})
    dataSet.push({ id:'12.17.06.2006', kecamatan:'12.17.06', name:'Sianjur Mula Mula'})
    dataSet.push({ id:'12.01.09.2005', kecamatan:'12.01.09', name:'Siantar Ca'})
    dataSet.push({ id:'12.12.20.2010', kecamatan:'12.12.20', name:'Siantar Dangsina'})
    dataSet.push({ id:'12.01.09.2008', kecamatan:'12.01.09', name:'Siantar Dolok'})
    dataSet.push({ id:'12.08.01.2007', kecamatan:'12.08.01', name:'Siantar Estate'})
    dataSet.push({ id:'12.02.03.2004', kecamatan:'12.02.03', name:'Siantar Naipospos'})
    dataSet.push({ id:'12.12.20.2013', kecamatan:'12.12.20', name:'Siantar Sigordang'})
    dataSet.push({ id:'12.12.20.2009', kecamatan:'12.12.20', name:'Siantar Sitio Tio'})
    dataSet.push({ id:'12.12.20.2011', kecamatan:'12.12.20', name:'Siantar Tonga-Tonga I'})
    dataSet.push({ id:'12.12.20.2012', kecamatan:'12.12.20', name:'Siantar Tonga-Tonga Ii'})
    dataSet.push({ id:'12.12.20.2014', kecamatan:'12.12.20', name:'Siantar Tonga-Tonga Iii'})
    dataSet.push({ id:'12.12.24.2001', kecamatan:'12.12.24', name:'Siantar Utara'})
    dataSet.push({ id:'12.12.21.2010', kecamatan:'12.12.21', name:'Siantarasa'})
    dataSet.push({ id:'12.17.08.2018', kecamatan:'12.17.08', name:'Sianting-Anting'})
    dataSet.push({ id:'12.13.09.2009', kecamatan:'12.13.09', name:'Siantona'})
    dataSet.push({ id:'12.02.09.2019', kecamatan:'12.02.09', name:'Siaro'})
    dataSet.push({ id:'12.08.13.2010', kecamatan:'12.08.13', name:'Siatasan'})
    dataSet.push({ id:'12.01.08.1002', kecamatan:'12.01.08', name:'Sibabangun'})
    dataSet.push({ id:'12.12.23.2006', kecamatan:'12.12.23', name:'Sibadihon'})
    dataSet.push({ id:'12.03.04.2076', kecamatan:'12.03.04', name:'Sibadoar'})
    dataSet.push({ id:'12.02.05.2005', kecamatan:'12.02.05', name:'Sibaganding'})
    dataSet.push({ id:'12.02.14.2005', kecamatan:'12.02.14', name:'Sibaganding'})
    dataSet.push({ id:'12.07.09.2024', kecamatan:'12.07.09', name:'Sibaganding'})
    dataSet.push({ id:'12.20.04.2049', kecamatan:'12.20.04', name:'Sibagasi'})
    dataSet.push({ id:'12.15.06.2001', kecamatan:'12.15.06', name:'Sibagindar'})
    dataSet.push({ id:'12.02.03.2005', kecamatan:'12.02.03', name:'Sibalanga'})
    dataSet.push({ id:'12.02.14.2010', kecamatan:'12.02.14', name:'Sibalanga'})
    dataSet.push({ id:'12.02.15.2009', kecamatan:'12.02.15', name:'Sibandang'})
    dataSet.push({ id:'12.13.20.2007', kecamatan:'12.13.20', name:'Sibanggor Jae'})
    dataSet.push({ id:'12.13.20.2009', kecamatan:'12.13.20', name:'Sibanggor Julu'})
    dataSet.push({ id:'12.13.20.2008', kecamatan:'12.13.20', name:'Sibanggor Tonga'})
    dataSet.push({ id:'12.03.01.2006', kecamatan:'12.03.01', name:'Sibangkua'})
    dataSet.push({ id:'12.02.10.2004', kecamatan:'12.02.10', name:'Sibaragas'})
    dataSet.push({ id:'12.12.02.2004', kecamatan:'12.12.02', name:'Sibarani Nasampulu/Namungk'})
    dataSet.push({ id:'12.14.29.2006', kecamatan:'12.14.29', name:'Sibaranun'})
    dataSet.push({ id:'12.18.08.2020', kecamatan:'12.18.08', name:'Sibarau'})
    dataSet.push({ id:'12.10.07.2001', kecamatan:'12.10.07', name:'Sibargot'})
    dataSet.push({ id:'12.12.09.2004', kecamatan:'12.12.09', name:'Sibaruang'})
    dataSet.push({ id:'12.13.06.2015', kecamatan:'12.13.06', name:'Sibaruang'})
    dataSet.push({ id:'12.20.04.2030', kecamatan:'12.20.04', name:'Sibatang Kayu'})
    dataSet.push({ id:'12.21.02.2026', kecamatan:'12.21.02', name:'Sibatu Loting'})
    dataSet.push({ id:'12.20.02.2080', kecamatan:'12.20.02', name:'Sibayo'})
    dataSet.push({ id:'12.20.02.2050', kecamatan:'12.20.02', name:'Sibayo Jae'})
    dataSet.push({ id:'12.12.03.2027', kecamatan:'12.12.03', name:'Sibide'})
    dataSet.push({ id:'12.12.03.2026', kecamatan:'12.12.03', name:'Sibide Barat'})
    dataSet.push({ id:'12.13.12.2013', kecamatan:'12.13.12', name:'Sibinail'})
    dataSet.push({ id:'12.02.13.2016', kecamatan:'12.02.13', name:'Sibingke'})
    dataSet.push({ id:'12.01.09.2003', kecamatan:'12.01.09', name:'Sibintang'})
    dataSet.push({ id:'12.01.08.2008', kecamatan:'12.01.08', name:'Sibio bio'})
    dataSet.push({ id:'12.13.08.2028', kecamatan:'12.13.08', name:'Sibio Bio'})
    dataSet.push({ id:'12.20.02.2063', kecamatan:'12.20.02', name:'Sibio Bio'})
    dataSet.push({ id:'12.23.07.2004', kecamatan:'12.23.07', name:'Sibito'})
    dataSet.push({ id:'12.21.09.2025', kecamatan:'12.21.09', name:'Sibodak Papaso'})
    dataSet.push({ id:'12.21.05.2007', kecamatan:'12.21.05', name:'Sibodak Sosa Jae'})
    dataSet.push({ id:'12.12.01.2014', kecamatan:'12.12.01', name:'Sibolahotang Sas'})
    dataSet.push({ id:'12.06.05.2006', kecamatan:'12.06.05', name:'Sibolangit'})
    dataSet.push({ id:'12.07.03.2024', kecamatan:'12.07.03', name:'Sibolangit'})
    dataSet.push({ id:'12.73.01.1004', kecamatan:'12.73.01', name:'Sibolga Ilir'})
    dataSet.push({ id:'12.03.06.2008', kecamatan:'12.03.06', name:'Sibong-Bong'})
    dataSet.push({ id:'12.15.03.2009', kecamatan:'12.15.03', name:'Sibongkaras'})
    dataSet.push({ id:'12.16.10.2003', kecamatan:'12.16.10', name:'Sibongkare'})
    dataSet.push({ id:'12.16.10.2009', kecamatan:'12.16.10', name:'Sibongkare Sianju'})
    dataSet.push({ id:'12.17.03.2008', kecamatan:'12.17.03', name:'Sibonor Ompu Ratus'})
    dataSet.push({ id:'12.21.02.2068', kecamatan:'12.21.02', name:'Sibontar'})
    dataSet.push({ id:'12.08.31.2003', kecamatan:'12.08.31', name:'Siboras'})
    dataSet.push({ id:'12.11.05.2017', kecamatan:'12.11.05', name:'Siboras'})
    dataSet.push({ id:'12.16.07.2006', kecamatan:'12.16.07', name:'Siborboron'})
    dataSet.push({ id:'12.21.02.2006', kecamatan:'12.21.02', name:'Siboris Bahal'})
    dataSet.push({ id:'12.21.02.2015', kecamatan:'12.21.02', name:'Siboris Dolok'})
    dataSet.push({ id:'12.21.02.2023', kecamatan:'12.21.02', name:'Siboris Lombang'})
    dataSet.push({ id:'12.08.04.2003', kecamatan:'12.08.04', name:'Siborna'})
    dataSet.push({ id:'12.21.08.2001', kecamatan:'12.21.08', name:'Siborna Bunut'})
    dataSet.push({ id:'12.17.06.2008', kecamatan:'12.17.06', name:'Siboro'})
    dataSet.push({ id:'12.02.09.2002', kecamatan:'12.02.09', name:'Siborong Borong I'})
    dataSet.push({ id:'12.02.09.2003', kecamatan:'12.02.09', name:'Siborong Borong Ii'})
    dataSet.push({ id:'12.20.03.2010', kecamatan:'12.20.03', name:'Siboru Angin'})
    dataSet.push({ id:'12.16.04.2008', kecamatan:'12.16.04', name:'Siboru Torop'})
    dataSet.push({ id:'12.12.01.2027', kecamatan:'12.12.01', name:'Siboruon'})
    dataSet.push({ id:'12.21.06.2012', kecamatan:'12.21.06', name:'Sibual Buali'})
    dataSet.push({ id:'12.21.01.2014', kecamatan:'12.21.01', name:'Sibualbuali'})
    dataSet.push({ id:'12.12.02.2002', kecamatan:'12.12.02', name:'Sibuea'})
    dataSet.push({ id:'12.21.07.2007', kecamatan:'12.21.07', name:'Sibuhuan Jae'})
    dataSet.push({ id:'12.21.07.2002', kecamatan:'12.21.07', name:'Sibuhuan Julu'})
    dataSet.push({ id:'12.18.16.2010', kecamatan:'12.18.16', name:'Sibulan'})
    dataSet.push({ id:'12.02.08.2002', kecamatan:'12.02.08', name:'Sibulan Bulan'})
    dataSet.push({ id:'12.03.07.2045', kecamatan:'12.03.07', name:'Sibulele Muara'})
    dataSet.push({ id:'12.16.08.2009', kecamatan:'12.16.08', name:'Sibuluan'})
    dataSet.push({ id:'12.01.03.1018', kecamatan:'12.01.03', name:'Sibuluan Baru'})
    dataSet.push({ id:'12.01.03.1005', kecamatan:'12.01.03', name:'Sibuluan Indah'})
    dataSet.push({ id:'12.01.20.1001', kecamatan:'12.01.20', name:'Sibuluan Nalambok'})
    dataSet.push({ id:'12.01.03.1006', kecamatan:'12.01.03', name:'Sibuluan Nauli'})
    dataSet.push({ id:'12.01.03.1012', kecamatan:'12.01.03', name:'Sibuluan Raya'})
    dataSet.push({ id:'12.01.03.1019', kecamatan:'12.01.03', name:'Sibuluan Terpadu'})
    dataSet.push({ id:'12.08.06.2002', kecamatan:'12.08.06', name:'Sibunga Bunga'})
    dataSet.push({ id:'12.07.20.2020', kecamatan:'12.07.20', name:'Sibunga Bunga Hilir'})
    dataSet.push({ id:'12.16.05.2011', kecamatan:'12.16.05', name:'Sibuntoan Parpea'})
    dataSet.push({ id:'12.08.20.2003', kecamatan:'12.08.20', name:'Sibuntuon'})
    dataSet.push({ id:'12.12.01.2026', kecamatan:'12.12.01', name:'Sibuntuon'})
    dataSet.push({ id:'12.12.04.2023', kecamatan:'12.12.04', name:'Sibuntuon'})
    dataSet.push({ id:'12.12.10.2007', kecamatan:'12.12.10', name:'Sibuntuon'})
    dataSet.push({ id:'12.16.07.2009', kecamatan:'12.16.07', name:'Sibuntuon'})
    dataSet.push({ id:'12.16.05.2001', kecamatan:'12.16.05', name:'Sibuntuon Partur'})
    dataSet.push({ id:'12.20.02.2085', kecamatan:'12.20.02', name:'Siburbur'})
    dataSet.push({ id:'12.03.07.2016', kecamatan:'12.03.07', name:'Sidadi I'})
    dataSet.push({ id:'12.03.07.2063', kecamatan:'12.03.07', name:'Sidadi Ii'})
    dataSet.push({ id:'12.02.02.2004', kecamatan:'12.02.02', name:'Sidagal'})
    dataSet.push({ id:'12.01.16.2007', kecamatan:'12.01.16', name:'Sidaling'})
    dataSet.push({ id:'12.08.09.2002', kecamatan:'12.08.09', name:'Sidamanik'})
    dataSet.push({ id:'12.77.02.1009', kecamatan:'12.77.02', name:'Sidangkal'})
    dataSet.push({ id:'12.03.05.2069', kecamatan:'12.03.05', name:'Sidapdap Simanosor'})
    dataSet.push({ id:'12.17.04.2021', kecamatan:'12.17.04', name:'Sideak'})
    dataSet.push({ id:'12.11.01.1007', kecamatan:'12.11.01', name:'Sidiangkat'})
    dataSet.push({ id:'12.01.10.2016', kecamatan:'12.01.10', name:'Sidikalang'})
    dataSet.push({ id:'12.11.01.1010', kecamatan:'12.11.01', name:'Sidikalang'})
    dataSet.push({ id:'12.20.04.2067', kecamatan:'12.20.04', name:'Sidingkat'})
    dataSet.push({ id:'12.05.03.2018', kecamatan:'12.05.03', name:'Sido Makmur'})
    dataSet.push({ id:'12.13.22.2009', kecamatan:'12.13.22', name:'Sido Makmur'})
    dataSet.push({ id:'12.07.33.2008', kecamatan:'12.07.33', name:'Sidoarjo Ii Ramunia'})
    dataSet.push({ id:'12.07.07.2012', kecamatan:'12.07.07', name:'Sidodadi'})
    dataSet.push({ id:'12.07.27.2006', kecamatan:'12.07.27', name:'Sidodadi'})
    dataSet.push({ id:'12.09.19.1010', kecamatan:'12.09.19', name:'Sidodadi'})
    dataSet.push({ id:'12.71.20.1002', kecamatan:'12.71.20', name:'Sidodadi'})
    dataSet.push({ id:'12.07.31.2003', kecamatan:'12.07.31', name:'Sidodadi Batu B'})
    dataSet.push({ id:'12.07.33.2010', kecamatan:'12.07.33', name:'Sidodadi Ramunia'})
    dataSet.push({ id:'12.07.31.2008', kecamatan:'12.07.31', name:'Sidoharjo-I Pasar Miring'})
    dataSet.push({ id:'12.13.07.2010', kecamatan:'12.13.07', name:'Sidojadi'})
    dataSet.push({ id:'12.21.11.2007', kecamatan:'12.21.11', name:'Sidokan'})
    dataSet.push({ id:'12.09.19.1011', kecamatan:'12.09.19', name:'Sidomukti'})
    dataSet.push({ id:'12.19.07.2015', kecamatan:'12.19.07', name:'Sidomulio'})
    dataSet.push({ id:'12.21.10.2010', kecamatan:'12.21.10', name:'Sidomulio'})
    dataSet.push({ id:'12.05.05.2005', kecamatan:'12.05.05', name:'Sidomulyo'})
    dataSet.push({ id:'12.05.07.1006', kecamatan:'12.05.07', name:'Sidomulyo'})
    dataSet.push({ id:'12.07.07.2013', kecamatan:'12.07.07', name:'Sidomulyo'})
    dataSet.push({ id:'12.08.08.2015', kecamatan:'12.08.08', name:'Sidomulyo'})
    dataSet.push({ id:'12.09.26.2005', kecamatan:'12.09.26', name:'Sidomulyo'})
    dataSet.push({ id:'12.09.30.2008', kecamatan:'12.09.30', name:'Sidomulyo'})
    dataSet.push({ id:'12.10.08.2011', kecamatan:'12.10.08', name:'Sidomulyo'})
    dataSet.push({ id:'12.19.01.2012', kecamatan:'12.19.01', name:'Sidomulyo'})
    dataSet.push({ id:'12.23.04.2005', kecamatan:'12.23.04', name:'Sidomulyo'})
    dataSet.push({ id:'12.71.07.1006', kecamatan:'12.71.07', name:'Sidomulyo'})
    dataSet.push({ id:'12.20.09.2008', kecamatan:'12.20.09', name:'Sidong-Dong'})
    dataSet.push({ id:'12.21.02.2072', kecamatan:'12.21.02', name:'Sidongdong'})
    dataSet.push({ id:'12.71.18.1007', kecamatan:'12.71.18', name:'Sidorame Barat I'})
    dataSet.push({ id:'12.71.18.1008', kecamatan:'12.71.18', name:'Sidorame Barat Ii'})
    dataSet.push({ id:'12.71.18.1006', kecamatan:'12.71.18', name:'Sidorame Timur'})
    dataSet.push({ id:'12.05.21.2003', kecamatan:'12.05.21', name:'Sidorejo'})
    dataSet.push({ id:'12.10.02.1009', kecamatan:'12.10.02', name:'Sidorejo'})
    dataSet.push({ id:'12.71.14.1003', kecamatan:'12.71.14', name:'Sidorejo'})
    dataSet.push({ id:'12.71.14.1002', kecamatan:'12.71.14', name:'Sidorejo Hilir'})
    dataSet.push({ id:'12.10.14.2001', kecamatan:'12.10.14', name:'Sidorukun'})
    dataSet.push({ id:'12.08.23.2013', kecamatan:'12.08.23', name:'Sidotani'})
    dataSet.push({ id:'12.07.33.2002', kecamatan:'12.07.33', name:'Sidourip'})
    dataSet.push({ id:'12.02.08.2001', kecamatan:'12.02.08', name:'Sidua Bahal'})
    dataSet.push({ id:'12.23.08.2009', kecamatan:'12.23.08', name:'Sidua Dua'})
    dataSet.push({ id:'12.14.05.2014', kecamatan:'12.14.05', name:'Sidua Ewali'})
    dataSet.push({ id:'12.25.04.2004', kecamatan:'12.25.04', name:'Siduahili'})
    dataSet.push({ id:'12.12.02.2006', kecamatan:'12.12.02', name:'Sidulang'})
    dataSet.push({ id:'12.15.08.2002', kecamatan:'12.15.08', name:'Siempat Rube I'})
    dataSet.push({ id:'12.15.08.2001', kecamatan:'12.15.08', name:'Siempat Rube Ii'})
    dataSet.push({ id:'12.15.08.2004', kecamatan:'12.15.08', name:'Siempat Rube Iv'})
    dataSet.push({ id:'12.24.02.2005', kecamatan:'12.24.02', name:'Sifahandro'})
    dataSet.push({ id:'12.78.04.2001', kecamatan:'12.78.04', name:'Sifalaete'})
    dataSet.push({ id:'12.78.01.2022', kecamatan:'12.78.01', name:'Sifalaete Tabaloho'})
    dataSet.push({ id:'12.78.01.2023', kecamatan:'12.78.01', name:'Sifalaete Ulu'})
    dataSet.push({ id:'12.14.20.2006', kecamatan:'12.14.20', name:'Sifalago'})
    dataSet.push({ id:'12.14.27.2001', kecamatan:'12.14.27', name:'Sifalago Gomo'})
    dataSet.push({ id:'12.14.09.2001', kecamatan:'12.14.09', name:'Sifalago Susua'})
    dataSet.push({ id:'12.24.09.2008', kecamatan:'12.24.09', name:'Sifaoro Asi'})
    dataSet.push({ id:'12.24.10.2004', kecamatan:'12.24.10', name:'Sifaoro Asi'})
    dataSet.push({ id:'12.14.02.2024', kecamatan:'12.14.02', name:'Sifaoro Asi Gomo'})
    dataSet.push({ id:'12.14.14.2003', kecamatan:'12.14.14', name:'Sifaoro Asi Mola'})
    dataSet.push({ id:'12.04.29.2007', kecamatan:'12.04.29', name:'Sifaoro Asi'})
    dataSet.push({ id:'12.14.07.2004', kecamatan:'12.14.07', name:'Sifaoroasi'})
    dataSet.push({ id:'12.14.20.2005', kecamatan:'12.14.20', name:'Sifaoroasi'})
    dataSet.push({ id:'12.14.24.2008', kecamatan:'12.14.24', name:'Sifaoroasi'})
    dataSet.push({ id:'12.14.20.2015', kecamatan:'12.14.20', name:'Sifaoroasi Huruna'})
    dataSet.push({ id:'12.04.11.2016', kecamatan:'12.04.11', name:'Sifaoroasi Ulu Hou'})
    dataSet.push({ id:'12.04.27.2011', kecamatan:'12.04.27', name:'Sifaro Asi Ulu Gawo'})
    dataSet.push({ id:'12.14.31.2008', kecamatan:'12.14.31', name:'Sifauruasi'})
    dataSet.push({ id:'12.14.05.2008', kecamatan:'12.14.05', name:'Sifitu Ewali'})
    dataSet.push({ id:'12.14.26.2001', kecamatan:'12.14.26', name:'Sifitubanua'})
    dataSet.push({ id:'12.21.03.2007', kecamatan:'12.21.03', name:'Sigading'})
    dataSet.push({ id:'12.20.08.2033', kecamatan:'12.20.08', name:'Sigagan'})
    dataSet.push({ id:'12.21.01.2016', kecamatan:'12.21.01', name:'Sigala-Gala'})
    dataSet.push({ id:'12.21.05.2002', kecamatan:'12.21.05', name:'Sigala-Gala'})
    dataSet.push({ id:'12.20.02.2049', kecamatan:'12.20.02', name:'Sigala Gala'})
    dataSet.push({ id:'12.20.03.2023', kecamatan:'12.20.03', name:'Sigala Gala'})
    dataSet.push({ id:'12.03.07.1001', kecamatan:'12.03.07', name:'Sigalangan'})
    dataSet.push({ id:'12.13.01.2027', kecamatan:'12.13.01', name:'Sigalapang Julu'})
    dataSet.push({ id:'12.21.05.2014', kecamatan:'12.21.05', name:'Sigalapung'})
    dataSet.push({ id:'12.16.08.2010', kecamatan:'12.16.08', name:'Sigalogo'})
    dataSet.push({ id:'12.20.04.2062', kecamatan:'12.20.04', name:'Sigama'})
    dataSet.push({ id:'12.20.06.2036', kecamatan:'12.20.06', name:'Sigama Napahalas'})
    dataSet.push({ id:'12.20.04.2063', kecamatan:'12.20.04', name:'Sigama Ujung Gading'})
    dataSet.push({ id:'12.10.02.1005', kecamatan:'12.10.02', name:'Sigambal'})
    dataSet.push({ id:'12.11.07.2010', kecamatan:'12.11.07', name:'Sigambir-Gambir'})
    dataSet.push({ id:'12.01.01.2005', kecamatan:'12.01.01', name:'Sigambo Gambo'})
    dataSet.push({ id:'12.12.10.2008', kecamatan:'12.12.10', name:'Sigaol Barat'})
    dataSet.push({ id:'12.17.04.2014', kecamatan:'12.17.04', name:'Sigaol Marbun'})
    dataSet.push({ id:'12.17.04.2008', kecamatan:'12.17.04', name:'Sigaol Simbolon'})
    dataSet.push({ id:'12.12.10.2010', kecamatan:'12.12.10', name:'Sigaol Timur'})
    dataSet.push({ id:'12.12.08.2001', kecamatan:'12.12.08', name:'Sigapiton'})
    dataSet.push({ id:'12.07.21.2005', kecamatan:'12.07.21', name:'Sigara-Gara'})
    dataSet.push({ id:'12.06.16.2014', kecamatan:'12.06.16', name:'Sigarang-Garang'})
    dataSet.push({ id:'12.06.07.2024', kecamatan:'12.06.07', name:'Sigenderang'})
    dataSet.push({ id:'12.14.29.2003', kecamatan:'12.14.29', name:'Sigese'})
    dataSet.push({ id:'12.20.04.2021', kecamatan:'12.20.04', name:'Sigimbal'})
    dataSet.push({ id:'12.21.08.2027', kecamatan:'12.21.08', name:'Siginduang'})
    dataSet.push({ id:'12.01.14.2004', kecamatan:'12.01.14', name:'Sigiring Giring'})
    dataSet.push({ id:'12.08.04.2006', kecamatan:'12.08.04', name:'Sigodang'})
    dataSet.push({ id:'12.08.04.2007', kecamatan:'12.08.04', name:'Sigodang Barat'})
    dataSet.push({ id:'12.12.03.2010', kecamatan:'12.12.03', name:'Sigodang Tua'})
    dataSet.push({ id:'12.01.11.2006', kecamatan:'12.01.11', name:'Sigodung'})
    dataSet.push({ id:'12.01.12.2005', kecamatan:'12.01.12', name:'Sigolang'})
    dataSet.push({ id:'12.03.22.2003', kecamatan:'12.03.22', name:'Sigolang'})
    dataSet.push({ id:'12.16.05.2014', kecamatan:'12.16.05', name:'Sigompul'})
    dataSet.push({ id:'12.21.07.2019', kecamatan:'12.21.07', name:'Sigorbus Jae'})
    dataSet.push({ id:'12.21.07.2041', kecamatan:'12.21.07', name:'Sigorbus Julu'})
    dataSet.push({ id:'12.20.01.2019', kecamatan:'12.20.01', name:'Sigordang'})
    dataSet.push({ id:'12.02.13.2026', kecamatan:'12.02.13', name:'Sigotom Dolok Nauli'})
    dataSet.push({ id:'12.02.13.2006', kecamatan:'12.02.13', name:'Sigotom Julu'})
    dataSet.push({ id:'12.02.13.2025', kecamatan:'12.02.13', name:'Sigotom Timur'})
    dataSet.push({ id:'12.07.08.2009', kecamatan:'12.07.08', name:'Siguci'})
    dataSet.push({ id:'12.20.02.2001', kecamatan:'12.20.02', name:'Siguga'})
    dataSet.push({ id:'12.77.05.2006', kecamatan:'12.77.05', name:'Sigulang'})
    dataSet.push({ id:'12.03.07.2053', kecamatan:'12.03.07', name:'Sigulang Losung'})
    dataSet.push({ id:'12.72.03.1006', kecamatan:'12.72.03', name:'Sigulanggulang'})
    dataSet.push({ id:'12.16.07.2004', kecamatan:'12.16.07', name:'Sigulok'})
    dataSet.push({ id:'12.02.09.2018', kecamatan:'12.02.09', name:'Sigumbang'})
    dataSet.push({ id:'12.12.19.2004', kecamatan:'12.12.19', name:'Sigumpar'})
    dataSet.push({ id:'12.16.05.2016', kecamatan:'12.16.05', name:'Sigumpar'})
    dataSet.push({ id:'12.12.19.2009', kecamatan:'12.12.19', name:'Sigumpar Barat'})
    dataSet.push({ id:'12.12.19.1007', kecamatan:'12.12.19', name:'Sigumpar Dangsina'})
    dataSet.push({ id:'12.12.19.2008', kecamatan:'12.12.19', name:'Sigumpar Julu'})
    dataSet.push({ id:'12.03.01.2005', kecamatan:'12.03.01', name:'Sigumuru'})
    dataSet.push({ id:'12.02.06.2003', kecamatan:'12.02.06', name:'Sigurung-Gurung'})
    dataSet.push({ id:'12.21.02.2014', kecamatan:'12.21.02', name:'Sihaborgoan Barumun'})
    dataSet.push({ id:'12.21.02.2003', kecamatan:'12.21.02', name:'Sihaborgoan Dalan'})
    dataSet.push({ id:'12.01.18.2005', kecamatan:'12.01.18', name:'Sihadatuon'})
    dataSet.push({ id:'12.20.01.2006', kecamatan:'12.20.01', name:'Sihalo Halo'})
    dataSet.push({ id:'12.20.06.2026', kecamatan:'12.20.06', name:'Sihambeng'})
    dataSet.push({ id:'12.01.02.2021', kecamatan:'12.01.02', name:'Sihapas'})
    dataSet.push({ id:'12.01.18.2006', kecamatan:'12.01.18', name:'Sihapas'})
    dataSet.push({ id:'12.20.04.2024', kecamatan:'12.20.04', name:'Sihapas Hapas'})
    dataSet.push({ id:'12.01.04.2003', kecamatan:'12.01.04', name:'Sihaporas'})
    dataSet.push({ id:'12.08.10.2006', kecamatan:'12.08.10', name:'Sihaporas'})
    dataSet.push({ id:'12.21.01.2017', kecamatan:'12.21.01', name:'Sihaporas'})
    dataSet.push({ id:'12.01.03.1020', kecamatan:'12.01.03', name:'Sihaporas Nauli'})
    dataSet.push({ id:'12.01.17.2006', kecamatan:'12.01.17', name:'Siharbangan'})
    dataSet.push({ id:'12.14.26.2006', kecamatan:'12.14.26', name:'Sihare O'})
    dataSet.push({ id:'12.78.02.2009', kecamatan:'12.78.02', name:'Sihare O I Tabaloho'})
    dataSet.push({ id:'12.78.01.2024', kecamatan:'12.78.01', name:'Sihare O Ii Tabaloho'})
    dataSet.push({ id:'12.04.28.2003', kecamatan:'12.04.28', name:'Sihare O Iii'})
    dataSet.push({ id:'12.04.28.2010', kecamatan:'12.04.28', name:'Sihare O Iii Bawosalo O Berua'})
    dataSet.push({ id:'12.04.28.2011', kecamatan:'12.04.28', name:'Sihare O Iii Hilibadalu'})
    dataSet.push({ id:'12.78.06.2006', kecamatan:'12.78.06', name:'Sihare O Siwahili'})
    dataSet.push({ id:'12.04.35.2011', kecamatan:'12.04.35', name:'Sihare O Sogae Adu'})
    dataSet.push({ id:'12.25.06.2004', kecamatan:'12.25.06', name:'Sihareo'})
    dataSet.push({ id:'12.16.05.2002', kecamatan:'12.16.05', name:'Siharjulu'})
    dataSet.push({ id:'12.08.20.2015', kecamatan:'12.08.20', name:'Sihemum Baru'})
    dataSet.push({ id:'12.24.10.2019', kecamatan:'12.24.10', name:'Sihene Asi'})
    dataSet.push({ id:'12.13.06.2016', kecamatan:'12.13.06', name:'Sihepeng'})
    dataSet.push({ id:'12.13.06.2025', kecamatan:'12.13.06', name:'Sihepeng Dua'})
    dataSet.push({ id:'12.13.06.2028', kecamatan:'12.13.06', name:'Sihepeng Lima'})
    dataSet.push({ id:'12.13.06.2027', kecamatan:'12.13.06', name:'Sihepeng Opat'})
    dataSet.push({ id:'12.13.06.2024', kecamatan:'12.13.06', name:'Sihepeng Sada'})
    dataSet.push({ id:'12.13.06.2026', kecamatan:'12.13.06', name:'Sihepeng Tolu'})
    dataSet.push({ id:'12.16.08.2004', kecamatan:'12.16.08', name:'Sihikit'})
    dataSet.push({ id:'12.12.23.2001', kecamatan:'12.12.23', name:'Sihiong'})
    dataSet.push({ id:'12.77.05.1001', kecamatan:'12.77.05', name:'Sihitang'})
    dataSet.push({ id:'12.16.06.2011', kecamatan:'12.16.06', name:'Sihite I'})
    dataSet.push({ id:'12.16.06.2020', kecamatan:'12.16.06', name:'Sihite Ii'})
    dataSet.push({ id:'12.21.04.2023', kecamatan:'12.21.04', name:'Sihiuk'})
    dataSet.push({ id:'12.20.10.2010', kecamatan:'12.20.10', name:'Sihoda-Hoda'})
    dataSet.push({ id:'12.14.27.2006', kecamatan:'12.14.27', name:'Siholi'})
    dataSet.push({ id:'12.16.10.2005', kecamatan:'12.16.10', name:'Sihombu'})
    dataSet.push({ id:'12.16.04.2001', kecamatan:'12.16.04', name:'Sihonongan'})
    dataSet.push({ id:'12.20.11.2007', kecamatan:'12.20.11', name:'Sihopuk Baru'})
    dataSet.push({ id:'12.20.11.2008', kecamatan:'12.20.11', name:'Sihopuk Lama'})
    dataSet.push({ id:'12.03.06.2011', kecamatan:'12.03.06', name:'Sihopur'})
    dataSet.push({ id:'12.01.17.2002', kecamatan:'12.01.17', name:'Sihorbo'})
    dataSet.push({ id:'12.11.04.2002', kecamatan:'12.11.04', name:'Sihorbo'})
    dataSet.push({ id:'12.16.01.2021', kecamatan:'12.16.01', name:'Sihotang Hasugian Dolok I'})
    dataSet.push({ id:'12.16.01.2015', kecamatan:'12.16.01', name:'Sihotang Hasugian Dolok Ii'})
    dataSet.push({ id:'12.16.01.2016', kecamatan:'12.16.01', name:'Sihotang Hasugian Habinsaran'})
    dataSet.push({ id:'12.16.01.2010', kecamatan:'12.16.01', name:'Sihotang Hasugian Tonga'})
    dataSet.push({ id:'12.16.10.2002', kecamatan:'12.16.10', name:'Sihotang Hasugian Toruan'})
    dataSet.push({ id:'12.08.29.2012', kecamatan:'12.08.29', name:'Sihubu Raya'})
    dataSet.push({ id:'12.03.06.2017', kecamatan:'12.03.06', name:'Sihuik-Huik'})
    dataSet.push({ id:'12.02.01.2028', kecamatan:'12.02.01', name:'Sihujur'})
    dataSet.push({ id:'12.03.22.2033', kecamatan:'12.03.22', name:'Sihulambu'})
    dataSet.push({ id:'12.17.01.2002', kecamatan:'12.17.01', name:'Sihusapi'})
    dataSet.push({ id:'12.09.13.2018', kecamatan:'12.09.13', name:'Sijabut Teratai'})
    dataSet.push({ id:'12.74.05.1005', kecamatan:'12.74.05', name:'Sijambi'})
    dataSet.push({ id:'12.17.07.2008', kecamatan:'12.17.07', name:'Sijambur'})
    dataSet.push({ id:'12.20.02.2072', kecamatan:'12.20.02', name:'Sijantung Jae'})
    dataSet.push({ id:'12.20.02.2021', kecamatan:'12.20.02', name:'Sijantung Julu'})
    dataSet.push({ id:'12.20.02.2065', kecamatan:'12.20.02', name:'Sijara Jara'})
    dataSet.push({ id:'12.16.09.2005', kecamatan:'12.16.09', name:'Sijarango'})
    dataSet.push({ id:'12.16.09.2017', kecamatan:'12.16.09', name:'Sijarango I'})
    dataSet.push({ id:'12.20.02.2012', kecamatan:'12.20.02', name:'Sijorang'})
    dataSet.push({ id:'12.01.12.2001', kecamatan:'12.01.12', name:'Sijungkang'})
    dataSet.push({ id:'12.03.03.2079', kecamatan:'12.03.03', name:'Sijungkang'})
    dataSet.push({ id:'12.06.03.2012', kecamatan:'12.06.03', name:'Sikab'})
    dataSet.push({ id:'12.13.17.2009', kecamatan:'12.13.17', name:'Sikapas'})
    dataSet.push({ id:'12.13.16.2016', kecamatan:'12.13.16', name:'Sikara Kara'})
    dataSet.push({ id:'12.13.16.2017', kecamatan:'12.13.16', name:'Sikara Kara I'})
    dataSet.push({ id:'12.13.16.2018', kecamatan:'12.13.16', name:'Sikara Kara Ii'})
    dataSet.push({ id:'12.13.16.2019', kecamatan:'12.13.16', name:'Sikara Kara Iii'})
    dataSet.push({ id:'12.13.16.2020', kecamatan:'12.13.16', name:'Sikara Kara Iv'})
    dataSet.push({ id:'12.07.03.2025', kecamatan:'12.07.03', name:'Sikeben'})
    dataSet.push({ id:'12.14.15.2006', kecamatan:'12.14.15', name:'Sikhorilafau'})
    dataSet.push({ id:'12.13.14.2019', kecamatan:'12.13.14', name:'Sikumbu'})
    dataSet.push({ id:'12.08.20.2009', kecamatan:'12.08.20', name:'Silabah Jaya'})
    dataSet.push({ id:'12.12.03.2005', kecamatan:'12.12.03', name:'Silaen'})
    dataSet.push({ id:'12.16.06.2007', kecamatan:'12.16.06', name:'Silaga Laga'})
    dataSet.push({ id:'12.02.09.2020', kecamatan:'12.02.09', name:'Silait-Lait'})
    dataSet.push({ id:'12.03.21.2057', kecamatan:'12.03.21', name:'Silaiya'})
    dataSet.push({ id:'12.03.21.2062', kecamatan:'12.03.21', name:'Silaiya Tanjung Leuk'})
    dataSet.push({ id:'12.08.18.2003', kecamatan:'12.08.18', name:'Silakkidir'})
    dataSet.push({ id:'12.11.14.2002', kecamatan:'12.11.14', name:'Silalahi I'})
    dataSet.push({ id:'12.11.14.2001', kecamatan:'12.11.14', name:'Silalahi Ii'})
    dataSet.push({ id:'12.11.14.2004', kecamatan:'12.11.14', name:'Silalahi Iii'})
    dataSet.push({ id:'12.12.01.2017', kecamatan:'12.12.01', name:'Silalahi Pagar Batu'})
    dataSet.push({ id:'12.71.05.1002', kecamatan:'12.71.05', name:'Silalas'})
    dataSet.push({ id:'12.02.15.2011', kecamatan:'12.02.15', name:'Silali Toruan'})
    dataSet.push({ id:'12.12.07.2023', kecamatan:'12.12.07', name:'Silamosik I'})
    dataSet.push({ id:'12.12.23.2007', kecamatan:'12.12.23', name:'Silamosik Ii'})
    dataSet.push({ id:'12.08.01.2001', kecamatan:'12.08.01', name:'Silampuyang'})
    dataSet.push({ id:'12.77.02.1008', kecamatan:'12.77.02', name:'Silandit'})
    dataSet.push({ id:'12.02.15.2008', kecamatan:'12.02.15', name:'Silando'})
    dataSet.push({ id:'12.20.02.2052', kecamatan:'12.20.02', name:'Silangge'})
    dataSet.push({ id:'12.02.06.2004', kecamatan:'12.02.06', name:'Silangkitang'})
    dataSet.push({ id:'12.03.22.2020', kecamatan:'12.03.22', name:'Silangkitang'})
    dataSet.push({ id:'12.03.05.2078', kecamatan:'12.03.05', name:'Silangkitang Tambiski'})
    dataSet.push({ id:'12.02.13.2020', kecamatan:'12.02.13', name:'Silantom Jae'})
    dataSet.push({ id:'12.02.13.2010', kecamatan:'12.02.13', name:'Silantom Julu'})
    dataSet.push({ id:'12.02.13.2009', kecamatan:'12.02.13', name:'Silantom Tonga'})
    dataSet.push({ id:'12.20.03.2008', kecamatan:'12.20.03', name:'Silantoyung'})
    dataSet.push({ id:'12.08.03.2001', kecamatan:'12.08.03', name:'Silau Bayu'})
    dataSet.push({ id:'12.09.17.2004', kecamatan:'12.09.17', name:'Silau Jawa'})
    dataSet.push({ id:'12.08.01.2016', kecamatan:'12.08.01', name:'Silau Malaha'})
    dataSet.push({ id:'12.08.02.2007', kecamatan:'12.08.02', name:'Silau Malela'})
    dataSet.push({ id:'12.09.27.2004', kecamatan:'12.09.27', name:'Silau Maraja'})
    dataSet.push({ id:'12.08.26.2012', kecamatan:'12.08.26', name:'Silau Marawan'})
    dataSet.push({ id:'12.18.09.2004', kecamatan:'12.18.09', name:'Silau Merawan'})
    dataSet.push({ id:'12.18.08.2014', kecamatan:'12.18.08', name:'Silau Padang'})
    dataSet.push({ id:'12.18.04.2010', kecamatan:'12.18.04', name:'Silau Rakyat'})
    dataSet.push({ id:'12.16.06.2002', kecamatan:'12.16.06', name:'Sileang'})
    dataSet.push({ id:'12.07.04.2011', kecamatan:'12.07.04', name:'Silebo Lebo'})
    dataSet.push({ id:'12.08.17.2001', kecamatan:'12.08.17', name:'Silenduk'})
    dataSet.push({ id:'12.21.12.2009', kecamatan:'12.21.12', name:'Silenjeng'})
    dataSet.push({ id:'12.11.02.2024', kecamatan:'12.11.02', name:'Sileuh-Leuh Parsaoran'})
    dataSet.push({ id:'12.14.26.2004', kecamatan:'12.14.26', name:'Silima Banua'})
    dataSet.push({ id:'12.24.03.2007', kecamatan:'12.24.03', name:'Silima Banua'})
    dataSet.push({ id:'12.14.30.2002', kecamatan:'12.14.30', name:'Silima Banua Marit'})
    dataSet.push({ id:'12.14.34.2010', kecamatan:'12.14.34', name:'Silima Banua Umbunasi'})
    dataSet.push({ id:'12.14.05.2013', kecamatan:'12.14.05', name:'Silima Ewali'})
    dataSet.push({ id:'12.15.04.2003', kecamatan:'12.15.04', name:'Silima Kuta'})
    dataSet.push({ id:'12.15.07.2003', kecamatan:'12.15.07', name:'Silima Kuta'})
    dataSet.push({ id:'12.17.02.2010', kecamatan:'12.17.02', name:'Silima Lombu'})
    dataSet.push({ id:'12.04.05.2041', kecamatan:'12.04.05', name:'Silimabanua'})
    dataSet.push({ id:'12.08.31.2002', kecamatan:'12.08.31', name:'Silimakuta Barat'})
    dataSet.push({ id:'12.14.28.2002', kecamatan:'12.14.28', name:'Silina'})
    dataSet.push({ id:'12.14.28.2006', kecamatan:'12.14.28', name:'Silina Baru'})
    dataSet.push({ id:'12.18.11.2026', kecamatan:'12.18.11', name:'Silinda'})
    dataSet.push({ id:'12.14.18.2020', kecamatan:'12.14.18', name:'Siliwulawa'})
    dataSet.push({ id:'12.09.28.2001', kecamatan:'12.09.28', name:'Silo Baru'})
    dataSet.push({ id:'12.09.28.2003', kecamatan:'12.09.28', name:'Silo Bonto'})
    dataSet.push({ id:'12.09.28.2002', kecamatan:'12.09.28', name:'Silo Lama'})
    dataSet.push({ id:'12.20.02.2033', kecamatan:'12.20.02', name:'Silogo Logo'})
    dataSet.push({ id:'12.13.21.2008', kecamatan:'12.13.21', name:'Silogun'})
    dataSet.push({ id:'12.12.23.2013', kecamatan:'12.12.23', name:'Silombu'})
    dataSet.push({ id:'12.09.12.2008', kecamatan:'12.09.12', name:'Silomlom'})
    dataSet.push({ id:'12.02.07.2001', kecamatan:'12.02.07', name:'Silosung'})
    dataSet.push({ id:'12.77.03.2008', kecamatan:'12.77.03', name:'Siloting'})
    dataSet.push({ id:'12.08.29.2015', kecamatan:'12.08.29', name:'Silou Buttu'})
    dataSet.push({ id:'12.08.27.2005', kecamatan:'12.08.27', name:'Silou Dunia'})
    dataSet.push({ id:'12.08.29.2014', kecamatan:'12.08.29', name:'Silou Huluan'})
    dataSet.push({ id:'12.08.01.2005', kecamatan:'12.08.01', name:'Silou Manik'})
    dataSet.push({ id:'12.08.27.2010', kecamatan:'12.08.27', name:'Silou Paribuan'})
    dataSet.push({ id:'12.20.02.2028', kecamatan:'12.20.02', name:'Siloung'})
    dataSet.push({ id:'12.07.06.2007', kecamatan:'12.07.06', name:'Siluelue'})
    dataSet.push({ id:'12.08.02.2006', kecamatan:'12.08.02', name:'Silulu'})
    dataSet.push({ id:'12.23.06.2006', kecamatan:'12.23.06', name:'Silumajang'})
    dataSet.push({ id:'12.11.07.2006', kecamatan:'12.11.07', name:'Silumboyah'})
    dataSet.push({ id:'12.06.16.2001', kecamatan:'12.06.16', name:'Simacem'})
    dataSet.push({ id:'12.20.01.2039', kecamatan:'12.20.01', name:'Simadihon'})
    dataSet.push({ id:'12.25.05.2001', kecamatan:'12.25.05', name:'Simaeasi'})
    dataSet.push({ id:'12.13.19.2011', kecamatan:'12.13.19', name:'Simalagi'})
    dataSet.push({ id:'12.18.08.2018', kecamatan:'12.18.08', name:'Simalas'})
    dataSet.push({ id:'12.07.05.2012', kecamatan:'12.07.05', name:'Simalingkar A'})
    dataSet.push({ id:'12.71.07.1008', kecamatan:'12.71.07', name:'Simalingkar B'})
    dataSet.push({ id:'12.14.05.2012', kecamatan:'12.14.05', name:'Simaluaya'})
    dataSet.push({ id:'12.72.04.1003', kecamatan:'12.72.04', name:'Simalungun'})
    dataSet.push({ id:'12.20.02.2078', kecamatan:'12.20.02', name:'Simambal'})
    dataSet.push({ id:'12.02.01.2021', kecamatan:'12.02.01', name:'Simamora'})
    dataSet.push({ id:'12.16.03.2002', kecamatan:'12.16.03', name:'Simamora'})
    dataSet.push({ id:'12.02.10.2001', kecamatan:'12.02.10', name:'Simamora Hasibuan'})
    dataSet.push({ id:'12.08.27.2001', kecamatan:'12.08.27', name:'Simanabun'})
    dataSet.push({ id:'12.78.04.2006', kecamatan:'12.78.04', name:'Simanaere'})
    dataSet.push({ id:'12.04.21.2005', kecamatan:'12.04.21', name:'Simanaere Botomuzoi'})
    dataSet.push({ id:'12.02.02.2003', kecamatan:'12.02.02', name:'Simanampang'})
    dataSet.push({ id:'12.02.05.2014', kecamatan:'12.02.05', name:'Simanampang'})
    dataSet.push({ id:'12.20.07.2016', kecamatan:'12.20.07', name:'Simanapang'})
    dataSet.push({ id:'12.20.06.2019', kecamatan:'12.20.06', name:'Simandiangin'})
    dataSet.push({ id:'12.20.04.2058', kecamatan:'12.20.04', name:'Simandiangin Dolok'})
    dataSet.push({ id:'12.20.04.2059', kecamatan:'12.20.04', name:'Simandiangin Lombang'})
    dataSet.push({ id:'12.13.08.2030', kecamatan:'12.13.08', name:'Simandolam'})
    dataSet.push({ id:'12.14.21.2003', kecamatan:'12.14.21', name:'Simandraolo'})
    dataSet.push({ id:'12.78.01.2025', kecamatan:'12.78.01', name:'Simandraolo'})
    dataSet.push({ id:'12.14.21.2006', kecamatan:'12.14.21', name:'Simandraolo O O U'})
    dataSet.push({ id:'12.23.02.2005', kecamatan:'12.23.02', name:'Simandulang'})
    dataSet.push({ id:'12.11.09.2001', kecamatan:'12.11.09', name:'Simanduma'})
    dataSet.push({ id:'12.23.08.2010', kecamatan:'12.23.08', name:'Simangalam'})
    dataSet.push({ id:'12.03.05.2018', kecamatan:'12.03.05', name:'Simangambat'})
    dataSet.push({ id:'12.13.06.1023', kecamatan:'12.13.06', name:'Simangambat'})
    dataSet.push({ id:'12.20.01.2011', kecamatan:'12.20.01', name:'Simangambat'})
    dataSet.push({ id:'12.21.05.2001', kecamatan:'12.21.05', name:'Simangambat'})
    dataSet.push({ id:'12.20.07.2028', kecamatan:'12.20.07', name:'Simangambat Dolok'})
    dataSet.push({ id:'12.20.08.2025', kecamatan:'12.20.08', name:'Simangambat Jae'})
    dataSet.push({ id:'12.20.08.2032', kecamatan:'12.20.08', name:'Simangambat Julu'})
    dataSet.push({ id:'12.13.10.2025', kecamatan:'12.13.10', name:'Simangambat Tb'})
    dataSet.push({ id:'12.20.02.2048', kecamatan:'12.20.02', name:'Simangambat Tua'})
    dataSet.push({ id:'12.16.06.2027', kecamatan:'12.16.06', name:'Simangaronsang'})
    dataSet.push({ id:'12.16.03.2005', kecamatan:'12.16.03', name:'Simangulampe'})
    dataSet.push({ id:'12.02.07.2003', kecamatan:'12.02.07', name:'Simangumban Jae'})
    dataSet.push({ id:'12.02.07.2006', kecamatan:'12.02.07', name:'Simangumban Julu'})
    dataSet.push({ id:'12.13.13.2020', kecamatan:'12.13.13', name:'Simanguntong'})
    dataSet.push({ id:'12.17.01.2019', kecamatan:'12.17.01', name:'Simanindo'})
    dataSet.push({ id:'12.17.01.2008', kecamatan:'12.17.01', name:'Simanindo Sangkal'})
    dataSet.push({ id:'12.01.13.2006', kecamatan:'12.01.13', name:'Simaninggir'})
    dataSet.push({ id:'12.03.04.2075', kecamatan:'12.03.04', name:'Simaninggir'})
    dataSet.push({ id:'12.03.20.2016', kecamatan:'12.03.20', name:'Simaninggir'})
    dataSet.push({ id:'12.13.06.2017', kecamatan:'12.13.06', name:'Simaninggir'})
    dataSet.push({ id:'12.13.18.2012', kecamatan:'12.13.18', name:'Simaninggir'})
    dataSet.push({ id:'12.20.07.2017', kecamatan:'12.20.07', name:'Simaninggir'})
    dataSet.push({ id:'12.20.09.2005', kecamatan:'12.20.09', name:'Simaninggir'})
    dataSet.push({ id:'12.20.10.2007', kecamatan:'12.20.10', name:'Simaninggir'})
    dataSet.push({ id:'12.21.07.2015', kecamatan:'12.21.07', name:'Simaninggir'})
    dataSet.push({ id:'12.21.12.2007', kecamatan:'12.21.12', name:'Simaninggir'})
    dataSet.push({ id:'12.20.01.2010', kecamatan:'12.20.01', name:'Simaninggir Simundol'})
    dataSet.push({ id:'12.20.02.2013', kecamatan:'12.20.02', name:'Simaninggir Sip'})
    dataSet.push({ id:'12.21.01.2013', kecamatan:'12.21.01', name:'Simaninggir Sosopan'})
    dataSet.push({ id:'12.03.30.2013', kecamatan:'12.03.30', name:'Simaninggir Tano Tombangan'})
    dataSet.push({ id:'12.12.03.2028', kecamatan:'12.12.03', name:'Simanobak'})
    dataSet.push({ id:'12.13.02.2018', kecamatan:'12.13.02', name:'Simanondong'})
    dataSet.push({ id:'12.01.08.2010', kecamatan:'12.01.08', name:'Simanosor'})
    dataSet.push({ id:'12.20.02.2076', kecamatan:'12.20.02', name:'Simanosor'})
    dataSet.push({ id:'12.20.04.2061', kecamatan:'12.20.04', name:'Simanosor'})
    dataSet.push({ id:'12.08.10.2008', kecamatan:'12.08.10', name:'Simantin'})
    dataSet.push({ id:'12.08.04.2010', kecamatan:'12.08.04', name:'Simantin Pane Dame'})
    dataSet.push({ id:'12.21.06.2001', kecamatan:'12.21.06', name:'Simanuldang Jae'})
    dataSet.push({ id:'12.21.06.2002', kecamatan:'12.21.06', name:'Simanuldang Julu'})
    dataSet.push({ id:'12.02.04.2003', kecamatan:'12.02.04', name:'Simanungkalit'})
    dataSet.push({ id:'12.02.02.2005', kecamatan:'12.02.02', name:'Simarakir Julu'})
    dataSet.push({ id:'12.21.08.2016', kecamatan:'12.21.08', name:'Simarancar'})
    dataSet.push({ id:'12.02.05.2018', kecamatan:'12.02.05', name:'Simardangiang'})
    dataSet.push({ id:'12.20.07.2007', kecamatan:'12.20.07', name:'Simardona'})
    dataSet.push({ id:'12.12.06.2012', kecamatan:'12.12.06', name:'Simare'})
    dataSet.push({ id:'12.73.01.1005', kecamatan:'12.73.01', name:'Simare-Mare'})
    dataSet.push({ id:'12.01.16.2006', kecamatan:'12.01.16', name:'Simargarap'})
    dataSet.push({ id:'12.16.06.2005', kecamatan:'12.16.06', name:'Simarigung'})
    dataSet.push({ id:'12.17.06.2009', kecamatan:'12.17.06', name:'Simarihit'})
    dataSet.push({ id:'12.72.08.1001', kecamatan:'12.72.08', name:'Simarimbun'})
    dataSet.push({ id:'12.72.02.1005', kecamatan:'12.72.02', name:'Simarito'})
    dataSet.push({ id:'12.03.29.2010', kecamatan:'12.03.29', name:'Simarlelan'})
    dataSet.push({ id:'12.17.01.2015', kecamatan:'12.17.01', name:'Simarmata'})
    dataSet.push({ id:'12.03.06.1001', kecamatan:'12.03.06', name:'Simarpinggan'})
    dataSet.push({ id:'12.01.06.2013', kecamatan:'12.01.06', name:'Simarpinggang'})
    dataSet.push({ id:'12.21.01.2022', kecamatan:'12.21.01', name:'Simartolu'})
    dataSet.push({ id:'12.11.09.2008', kecamatan:'12.11.09', name:'Simartugan'})
    dataSet.push({ id:'12.20.04.2023', kecamatan:'12.20.04', name:'Simasi'})
    dataSet.push({ id:'12.02.05.2002', kecamatan:'12.02.05', name:'Simasom'})
    dataSet.push({ id:'12.77.06.2003', kecamatan:'12.77.06', name:'Simasom'})
    dataSet.push({ id:'12.02.05.2019', kecamatan:'12.02.05', name:'Simasom Toruan'})
    dataSet.push({ id:'12.22.01.2002', kecamatan:'12.22.01', name:'Simatahari'})
    dataSet.push({ id:'12.02.05.2010', kecamatan:'12.02.05', name:'Simataniari'})
    dataSet.push({ id:'12.03.31.2008', kecamatan:'12.03.31', name:'Simataniari'})
    dataSet.push({ id:'12.16.01.2013', kecamatan:'12.16.01', name:'Simataniari'})
    dataSet.push({ id:'12.20.02.2041', kecamatan:'12.20.02', name:'Simataniari'})
    dataSet.push({ id:'12.20.02.2039', kecamatan:'12.20.02', name:'Simataniari Jae'})
    dataSet.push({ id:'12.12.02.2014', kecamatan:'12.12.02', name:'Simatibung'})
    dataSet.push({ id:'12.03.31.2003', kecamatan:'12.03.31', name:'Simatohir'})
    dataSet.push({ id:'12.77.06.2007', kecamatan:'12.77.06', name:'Simatohir'})
    dataSet.push({ id:'12.20.02.2036', kecamatan:'12.20.02', name:'Simatorkis'})
    dataSet.push({ id:'12.03.01.1003', kecamatan:'12.03.01', name:'Simatorkis Sisoma'})
    dataSet.push({ id:'12.02.15.2010', kecamatan:'12.02.15', name:'Simatupang'})
    dataSet.push({ id:'12.18.13.2020', kecamatan:'12.18.13', name:'Gunung Kataran'})
    dataSet.push({ id:'12.13.19.2015', kecamatan:'12.13.19', name:'Huta Dangka'})
    dataSet.push({ id:'12.78.01.1032', kecamatan:'12.78.01', name:'Ilir'})
    dataSet.push({ id:'12.18.13.2018', kecamatan:'12.18.13', name:'Kedai Damar'})
    dataSet.push({ id:'12.78.01.1030', kecamatan:'12.78.01', name:'Pasar Gunungsitoli'})
    dataSet.push({ id:'12.12.02.1001', kecamatan:'12.12.02', name:'Pasar Laguboti'})
    dataSet.push({ id:'12.18.13.2019', kecamatan:'12.18.13', name:'Penonggol'})
    dataSet.push({ id:'12.78.01.1031', kecamatan:'12.78.01', name:'Saombo'})
    dataSet.push({ id:'12.16.10.2006', kecamatan:'12.16.10', name:'Simbara'})
    dataSet.push({ id:'12.15.01.2005', kecamatan:'12.15.01', name:'Simberruna'})
    dataSet.push({ id:'12.20.04.2078', kecamatan:'12.20.04', name:'Simbolon'})
    dataSet.push({ id:'12.17.04.2007', kecamatan:'12.17.04', name:'Simbolon Purba'})
    dataSet.push({ id:'12.08.05.2007', kecamatan:'12.08.05', name:'Simbolon Tengkoh'})
    dataSet.push({ id:'12.08.29.2017', kecamatan:'12.08.29', name:'Simbou Baru'})
    dataSet.push({ id:'12.07.01.2003', kecamatan:'12.07.01', name:'Simempar'})
    dataSet.push({ id:'12.15.05.2004', kecamatan:'12.15.05', name:'Simerpara'})
    dataSet.push({ id:'12.77.03.2014', kecamatan:'12.77.03', name:'Simirik'})
    dataSet.push({ id:'12.19.02.2008', kecamatan:'12.19.02', name:'Simodong'})
    dataSet.push({ id:'12.06.08.2011', kecamatan:'12.06.08', name:'Simolap'})
    dataSet.push({ id:'12.23.07.2005', kecamatan:'12.23.07', name:'Simonis'})
    dataSet.push({ id:'12.02.02.2007', kecamatan:'12.02.02', name:'Simorangkir Habinsaran'})
    dataSet.push({ id:'12.13.14.2021', kecamatan:'12.13.14', name:'Simpang Bajole'})
    dataSet.push({ id:'12.13.11.2008', kecamatan:'12.13.11', name:'Simpang Banyak Jae'})
    dataSet.push({ id:'12.13.11.2009', kecamatan:'12.13.11', name:'Simpang Banyak Julu'})
    dataSet.push({ id:'12.19.10.2007', kecamatan:'12.19.10', name:'Simpang Dolok'})
    dataSet.push({ id:'12.13.11.2010', kecamatan:'12.13.11', name:'Simpang Duhu Dolok'})
    dataSet.push({ id:'12.13.11.2011', kecamatan:'12.13.11', name:'Simpang Duhu Lombang'})
    dataSet.push({ id:'12.13.14.2022', kecamatan:'12.13.14', name:'Simpang Duku'})
    dataSet.push({ id:'12.13.14.2023', kecamatan:'12.13.14', name:'Simpang Durian'})
    dataSet.push({ id:'12.09.12.2009', kecamatan:'12.09.12', name:'Simpang Empat'})
    dataSet.push({ id:'12.18.04.2024', kecamatan:'12.18.04', name:'Simpang Empat'})
    dataSet.push({ id:'12.23.05.2011', kecamatan:'12.23.05', name:'Simpang Empat'})
    dataSet.push({ id:'12.13.14.1024', kecamatan:'12.13.14', name:'Simpang Gambir'})
    dataSet.push({ id:'12.19.04.2025', kecamatan:'12.19.04', name:'Simpang Gambus'})
    dataSet.push({ id:'12.01.11.2005', kecamatan:'12.01.11', name:'Simpang Iii Lae Bingke'})
    dataSet.push({ id:'12.13.14.2025', kecamatan:'12.13.14', name:'Simpang Koje'})
    dataSet.push({ id:'12.19.02.2019', kecamatan:'12.19.02', name:'Simpang Kopi'})
    dataSet.push({ id:'12.05.04.2003', kecamatan:'12.05.04', name:'Simpang Kuta Buluh'})
    dataSet.push({ id:'12.13.12.2015', kecamatan:'12.13.12', name:'Simpang Mandepo'})
    dataSet.push({ id:'12.23.06.2012', kecamatan:'12.23.06', name:'Simpang Marbau'})
    dataSet.push({ id:'12.08.04.2002', kecamatan:'12.08.04', name:'Simpang Pane Raya'})
    dataSet.push({ id:'12.08.05.2005', kecamatan:'12.08.05', name:'Simpang Panei'})
    dataSet.push({ id:'12.06.08.2012', kecamatan:'12.06.08', name:'Simpang Pergendangen'})
    dataSet.push({ id:'12.13.11.2012', kecamatan:'12.13.11', name:'Simpang Pining'})
    dataSet.push({ id:'12.05.01.2012', kecamatan:'12.05.01', name:'Simpang Pulo Rambung'})
    dataSet.push({ id:'12.08.04.2012', kecamatan:'12.08.04', name:'Simpang Raya Dasma'})
    dataSet.push({ id:'12.71.07.1002', kecamatan:'12.71.07', name:'Simpang Selayang'})
    dataSet.push({ id:'12.12.07.2041', kecamatan:'12.12.07', name:'Simpang Sigura-Gura'})
    dataSet.push({ id:'12.13.18.2002', kecamatan:'12.13.18', name:'Simpang Talap'})
    dataSet.push({ id:'12.71.02.1006', kecamatan:'12.71.02', name:'Simpang Tanjung'})
    dataSet.push({ id:'12.05.20.2003', kecamatan:'12.05.20', name:'Simpang Tiga'})
    dataSet.push({ id:'12.18.02.1039', kecamatan:'12.18.02', name:'Simpang Tiga Pekan'})
    dataSet.push({ id:'12.13.08.2026', kecamatan:'12.13.08', name:'Simpang Tolang Jae'})
    dataSet.push({ id:'12.13.08.2027', kecamatan:'12.13.08', name:'Simpang Tolang Julu'})
    dataSet.push({ id:'12.20.01.2008', kecamatan:'12.20.01', name:'Simundol'})
    dataSet.push({ id:'12.11.08.2006', kecamatan:'12.11.08', name:'Simungun'})
    dataSet.push({ id:'12.20.02.2081', kecamatan:'12.20.02', name:'Sinabongan'})
    dataSet.push({ id:'12.17.08.2023', kecamatan:'12.17.08', name:'Sinabulan'})
    dataSet.push({ id:'12.17.03.2003', kecamatan:'12.17.03', name:'Sinaga Uruk Pandiangan'})
    dataSet.push({ id:'12.18.04.2026', kecamatan:'12.18.04', name:'Sinah Kasih'})
    dataSet.push({ id:'12.08.28.1009', kecamatan:'12.08.28', name:'Sinaksak'})
    dataSet.push({ id:'12.06.03.2003', kecamatan:'12.06.03', name:'Sinaman'})
    dataSet.push({ id:'12.08.32.2009', kecamatan:'12.08.32', name:'Sinaman Labah'})
    dataSet.push({ id:'12.16.03.2004', kecamatan:'12.16.03', name:'Sinambela'})
    dataSet.push({ id:'12.11.04.2001', kecamatan:'12.11.04', name:'Sinampang'})
    dataSet.push({ id:'12.14.03.2043', kecamatan:'12.14.03', name:'Sinar Baho'})
    dataSet.push({ id:'12.08.25.2014', kecamatan:'12.08.25', name:'Sinar Baru'})
    dataSet.push({ id:'12.14.03.2026', kecamatan:'12.14.03', name:'Sinar Baru Darodaro'})
    dataSet.push({ id:'12.14.27.2005', kecamatan:'12.14.27', name:'Sinar Helaowo'})
    dataSet.push({ id:'12.14.07.2031', kecamatan:'12.14.07', name:'Sinar Ino O'})
    dataSet.push({ id:'12.08.31.2008', kecamatan:'12.08.31', name:'Sinar Naga Mariah'})
    dataSet.push({ id:'12.11.06.2019', kecamatan:'12.11.06', name:'Sinar Pagi'})
    dataSet.push({ id:'12.12.23.2002', kecamatan:'12.12.23', name:'Sinar Sabungan'})
    dataSet.push({ id:'12.14.26.2014', kecamatan:'12.14.26', name:'Sinar Susua'})
    dataSet.push({ id:'12.04.05.2022', kecamatan:'12.04.05', name:'Sinarikhi'})
    dataSet.push({ id:'12.08.27.2015', kecamatan:'12.08.27', name:'Sinasih'})
    dataSet.push({ id:'12.14.05.2010', kecamatan:'12.14.05', name:'Sinauru'})
    dataSet.push({ id:'12.08.07.1008', kecamatan:'12.08.07', name:'Sindar Raya'})
    dataSet.push({ id:'12.14.34.2011', kecamatan:'12.14.34', name:'Sindrolo'})
    dataSet.push({ id:'12.04.11.2025', kecamatan:'12.04.11', name:'Sindrondro'})
    dataSet.push({ id:'12.25.02.2011', kecamatan:'12.25.02', name:'Sineneeto'})
    dataSet.push({ id:'12.06.04.2004', kecamatan:'12.06.04', name:'Singa'})
    dataSet.push({ id:'12.77.04.2007', kecamatan:'12.77.04', name:'Singali'})
    dataSet.push({ id:'12.20.02.2002', kecamatan:'12.20.02', name:'Singanyal'})
    dataSet.push({ id:'12.13.08.2023', kecamatan:'12.13.08', name:'Singengu Jae'})
    dataSet.push({ id:'12.13.08.2024', kecamatan:'12.13.08', name:'Singengu Julu'})
    dataSet.push({ id:'12.06.06.2008', kecamatan:'12.06.06', name:'Singgamanik'})
    dataSet.push({ id:'12.17.06.2002', kecamatan:'12.17.06', name:'Singkam'})
    dataSet.push({ id:'12.13.06.2018', kecamatan:'12.13.06', name:'Sinonoan'})
    dataSet.push({ id:'12.12.03.2014', kecamatan:'12.12.03', name:'Sinta Dame'})
    dataSet.push({ id:'12.12.02.2003', kecamatan:'12.12.02', name:'Sintong Marnipi'})
    dataSet.push({ id:'12.13.22.2001', kecamatan:'12.13.22', name:'Sinunukan I'})
    dataSet.push({ id:'12.13.22.2014', kecamatan:'12.13.22', name:'Sinunukan I Central'})
    dataSet.push({ id:'12.13.22.2002', kecamatan:'12.13.22', name:'Sinunukan Ii'})
    dataSet.push({ id:'12.13.22.2003', kecamatan:'12.13.22', name:'Sinunukan Iii'})
    dataSet.push({ id:'12.13.22.2004', kecamatan:'12.13.22', name:'Sinunukan Iv'})
    dataSet.push({ id:'12.13.16.2027', kecamatan:'12.13.16', name:'Sinunukan V'})
    dataSet.push({ id:'12.13.15.2022', kecamatan:'12.13.15', name:'Sinunukan VI'})
    dataSet.push({ id:'12.03.06.2005', kecamatan:'12.03.06', name:'Sinyior'})
    dataSet.push({ id:'12.13.01.2037', kecamatan:'12.13.01', name:'Siobon Jae'})
    dataSet.push({ id:'12.13.01.2028', kecamatan:'12.13.01', name:'Siobon Julu'})
    dataSet.push({ id:'12.24.03.2002', kecamatan:'12.24.03', name:'Siofa Banua'})
    dataSet.push({ id:'12.14.30.2001', kecamatan:'12.14.30', name:'Siofa Banua Lorang'})
    dataSet.push({ id:'12.14.05.2011', kecamatan:'12.14.05', name:'Siofa Ewali'})
    dataSet.push({ id:'12.04.11.2015', kecamatan:'12.04.11', name:'Siofabanua'})
    dataSet.push({ id:'12.14.17.2010', kecamatan:'12.14.17', name:'Siofabanua'})
    dataSet.push({ id:'12.04.11.2010', kecamatan:'12.04.11', name:'Siofaewali'})
    dataSet.push({ id:'12.17.08.1028', kecamatan:'12.17.08', name:'Siogung-Ogung'})
    dataSet.push({ id:'12.21.09.2009', kecamatan:'12.21.09', name:'Siojo'})
    dataSet.push({ id:'12.10.02.1002', kecamatan:'12.10.02', name:'Sioldengan'})
    dataSet.push({ id:'12.21.02.2008', kecamatan:'12.21.02', name:'Siolip'})
    dataSet.push({ id:'12.21.07.2010', kecamatan:'12.21.07', name:'Siolip'})
    dataSet.push({ id:'12.20.04.2074', kecamatan:'12.20.04', name:'Siombob'})
    dataSet.push({ id:'12.09.16.2016', kecamatan:'12.09.16', name:'Sionggang'})
    dataSet.push({ id:'12.12.09.2006', kecamatan:'12.12.09', name:'Sionggang Selatan'})
    dataSet.push({ id:'12.12.09.2014', kecamatan:'12.12.09', name:'Sionggang Tengah'})
    dataSet.push({ id:'12.12.09.2008', kecamatan:'12.12.09', name:'Sionggang Utara'})
    dataSet.push({ id:'12.20.08.2029', kecamatan:'12.20.08', name:'Sionggoton'})
    dataSet.push({ id:'12.16.01.2005', kecamatan:'12.16.01', name:'Sionom Hudon Julu'})
    dataSet.push({ id:'12.16.01.2018', kecamatan:'12.16.01', name:'Sionom Hudon Runggu'})
    dataSet.push({ id:'12.16.01.2008', kecamatan:'12.16.01', name:'Sionom Hudon Selatan'})
    dataSet.push({ id:'12.16.01.2017', kecamatan:'12.16.01', name:'Sionom Hudon Sibulbulon'})
    dataSet.push({ id:'12.16.01.2009', kecamatan:'12.16.01', name:'Sionom Hudon Timur'})
    dataSet.push({ id:'12.16.01.2014', kecamatan:'12.16.01', name:'Sionom Hudon Timur Ii'})
    dataSet.push({ id:'12.16.01.2006', kecamatan:'12.16.01', name:'Sionom Hudon Tonga'})
    dataSet.push({ id:'12.16.01.2012', kecamatan:'12.16.01', name:'Sionom Hudon Toruan'})
    dataSet.push({ id:'12.16.01.2007', kecamatan:'12.16.01', name:'Sionom Hudon Utara'})
    dataSet.push({ id:'12.16.01.2003', kecamatan:'12.16.01', name:'Sionom Hudon Vii'})
    dataSet.push({ id:'12.02.06.2006', kecamatan:'12.02.06', name:'Siopat Bahal'})
    dataSet.push({ id:'12.17.08.2025', kecamatan:'12.17.08', name:'Siopat Sosor'})
    dataSet.push({ id:'12.72.01.1007', kecamatan:'12.72.01', name:'Siopat Suhu'})
    dataSet.push({ id:'12.01.11.2003', kecamatan:'12.01.11', name:'Siordang'})
    dataSet.push({ id:'12.12.21.2004', kecamatan:'12.12.21', name:'Sipagabu'})
    dataSet.push({ id:'12.16.09.2009', kecamatan:'12.16.09', name:'Sipagabu'})
    dataSet.push({ id:'12.21.11.2011', kecamatan:'12.21.11', name:'Sipagabu'})
    dataSet.push({ id:'12.20.03.2007', kecamatan:'12.20.03', name:'Sipaho'})
    dataSet.push({ id:'12.02.04.2005', kecamatan:'12.02.04', name:'Sipahutar'})
    dataSet.push({ id:'12.02.12.2003', kecamatan:'12.02.12', name:'Sipahutar I'})
    dataSet.push({ id:'12.02.12.2004', kecamatan:'12.02.12', name:'Sipahutar Ii'})
    dataSet.push({ id:'12.02.12.2005', kecamatan:'12.02.12', name:'Sipahutar Iii'})
    dataSet.push({ id:'12.01.16.2008', kecamatan:'12.01.16', name:'Sipakpahi'})
    dataSet.push({ id:'12.01.06.2009', kecamatan:'12.01.06', name:'Sipakpahi Aek Lobu'})
    dataSet.push({ id:'12.09.12.2012', kecamatan:'12.09.12', name:'Sipaku Area'})
    dataSet.push({ id:'12.01.20.2003', kecamatan:'12.01.20', name:'Sipan'})
    dataSet.push({ id:'12.08.16.2001', kecamatan:'12.08.16', name:'Sipangan Bolon'})
    dataSet.push({ id:'12.08.16.2006', kecamatan:'12.08.16', name:'Sipangan Bolon Mekar'})
    dataSet.push({ id:'12.01.14.1007', kecamatan:'12.01.14', name:'Sipange'})
    dataSet.push({ id:'12.03.21.2007', kecamatan:'12.03.21', name:'Sipange Godang'})
    dataSet.push({ id:'12.03.21.2006', kecamatan:'12.03.21', name:'Sipange Julu'})
    dataSet.push({ id:'12.03.21.2056', kecamatan:'12.03.21', name:'Sipange Siunjam'})
    dataSet.push({ id:'12.03.32.2004', kecamatan:'12.03.32', name:'Sipangko'})
    dataSet.push({ id:'12.13.01.2029', kecamatan:'12.13.01', name:'Sipapaga'})
    dataSet.push({ id:'12.21.02.2029', kecamatan:'12.21.02', name:'Siparau'})
    dataSet.push({ id:'12.19.03.2010', kecamatan:'12.19.03', name:'Sipare-Pare'})
    dataSet.push({ id:'12.23.05.2008', kecamatan:'12.23.05', name:'Sipare Pare Hilir'})
    dataSet.push({ id:'12.23.05.2007', kecamatan:'12.23.05', name:'Sipare Pare Tengah'})
    dataSet.push({ id:'12.17.05.2007', kecamatan:'12.17.05', name:'Siparmahan'})
    dataSet.push({ id:'12.01.10.2002', kecamatan:'12.01.10', name:'Sipea Pea'})
    dataSet.push({ id:'12.03.02.2023', kecamatan:'12.03.02', name:'Sipenggeng'})
    dataSet.push({ id:'12.20.03.2036', kecamatan:'12.20.03', name:'Sipenggeng'})
    dataSet.push({ id:'12.07.20.2017', kecamatan:'12.07.20', name:'Sipinggan'})
    dataSet.push({ id:'12.17.03.2014', kecamatan:'12.17.03', name:'Sipinggan'})
    dataSet.push({ id:'12.17.03.2007', kecamatan:'12.17.03', name:'Sipinggan Lumban Siantar'})
    dataSet.push({ id:'12.72.02.1006', kecamatan:'12.72.02', name:'Sipinggolpinggol'})
    dataSet.push({ id:'12.20.02.2030', kecamatan:'12.20.02', name:'Sipiongot'})
    dataSet.push({ id:'12.17.02.2011', kecamatan:'12.17.02', name:'Sipira'})
    dataSet.push({ id:'12.20.06.2008', kecamatan:'12.20.06', name:'Sipirok'})
    dataSet.push({ id:'12.21.03.2015', kecamatan:'12.21.03', name:'Sipirok Baru'})
    dataSet.push({ id:'12.03.04.1114', kecamatan:'12.03.04', name:'Sipirok Godang'})
    dataSet.push({ id:'12.18.08.2001', kecamatan:'12.18.08', name:'Sipispis'})
    dataSet.push({ id:'12.16.02.2011', kecamatan:'12.16.02', name:'Sipituhuta'})
    dataSet.push({ id:'12.20.01.2029', kecamatan:'12.20.01', name:'Sipogas'})
    dataSet.push({ id:'12.20.01.2030', kecamatan:'12.20.01', name:'Sipogas A'})
    dataSet.push({ id:'12.03.14.2028', kecamatan:'12.03.14', name:'Sipogu'})
    dataSet.push({ id:'12.13.13.2021', kecamatan:'12.13.13', name:'Sipogu'})
    dataSet.push({ id:'12.08.04.2004', kecamatan:'12.08.04', name:'Sipoldas'})
    dataSet.push({ id:'12.08.10.1009', kecamatan:'12.08.10', name:'Sipolha Horison'})
    dataSet.push({ id:'12.11.07.2012', kecamatan:'12.11.07', name:'Sipoltong'})
    dataSet.push({ id:'12.13.01.1035', kecamatan:'12.13.01', name:'Sipolu-Polu'})
    dataSet.push({ id:'12.16.05.2012', kecamatan:'12.16.05', name:'Siponjot'})
    dataSet.push({ id:'12.08.29.2010', kecamatan:'12.08.29', name:'Siporkas'})
    dataSet.push({ id:'12.02.10.2005', kecamatan:'12.02.10', name:'Sipultak'})
    dataSet.push({ id:'12.02.10.2013', kecamatan:'12.02.10', name:'Sipultak Dolok'})
    dataSet.push({ id:'12.20.05.2008', kecamatan:'12.20.05', name:'Sipupus Lombang'})
    dataSet.push({ id:'12.20.02.2056', kecamatan:'12.20.02', name:'Siraga Huta Padang'})
    dataSet.push({ id:'12.14.27.2010', kecamatan:'12.14.27', name:'Siraha'})
    dataSet.push({ id:'12.14.35.2005', kecamatan:'12.14.35', name:'Sirahia'})
    dataSet.push({ id:'12.21.06.2014', kecamatan:'12.21.06', name:'Siraisan'})
    dataSet.push({ id:'12.12.02.2021', kecamatan:'12.12.02', name:'Siraja Gorat'})
    dataSet.push({ id:'12.02.02.2001', kecamatan:'12.02.02', name:'Siraja Hutagalung'})
    dataSet.push({ id:'12.02.01.2026', kecamatan:'12.02.01', name:'Siraja Oloan'})
    dataSet.push({ id:'12.13.05.2008', kecamatan:'12.13.05', name:'Sirambas'})
    dataSet.push({ id:'12.01.12.2004', kecamatan:'12.01.12', name:'Sirami Ramian'})
    dataSet.push({ id:'12.20.02.2082', kecamatan:'12.20.02', name:'Siranap'})
    dataSet.push({ id:'12.10.01.1003', kecamatan:'12.10.01', name:'Sirandorung'})
    dataSet.push({ id:'12.13.03.2010', kecamatan:'12.13.03', name:'Sirangkap'})
    dataSet.push({ id:'12.74.05.1004', kecamatan:'12.74.05', name:'Sirantau'})
    dataSet.push({ id:'12.11.05.2015', kecamatan:'12.11.05', name:'Siratah'})
    dataSet.push({ id:'12.12.10.2012', kecamatan:'12.12.10', name:'Siregar Aek Nalas'})
    dataSet.push({ id:'12.04.06.2018', kecamatan:'12.04.06', name:'Sirete'})
    dataSet.push({ id:'12.08.30.2014', kecamatan:'12.08.30', name:'Siringan Ringan'})
    dataSet.push({ id:'12.20.03.2021', kecamatan:'12.20.03', name:'Siringki Jae'})
    dataSet.push({ id:'12.20.03.2043', kecamatan:'12.20.03', name:'Siringki Julu'})
    dataSet.push({ id:'12.12.03.2030', kecamatan:'12.12.03', name:'Siringkiron'})
    dataSet.push({ id:'12.10.01.1002', kecamatan:'12.10.01', name:'Siringo-Ringo'})
    dataSet.push({ id:'12.16.06.2023', kecamatan:'12.16.06', name:'Sirisirisi'})
    dataSet.push({ id:'12.02.14.2006', kecamatan:'12.02.14', name:'Sirmpang Bolon'})
    dataSet.push({ id:'12.14.07.2026', kecamatan:'12.14.07', name:'Sirofi'})
    dataSet.push({ id:'12.25.02.2021', kecamatan:'12.25.02', name:'Sirombu'})
    dataSet.push({ id:'12.08.20.2011', kecamatan:'12.08.20', name:'Sirube-Rube Gunung Purba'})
    dataSet.push({ id:'12.17.03.1012', kecamatan:'12.17.03', name:'Sirumahombar'})
    dataSet.push({ id:'12.06.12.2012', kecamatan:'12.06.12', name:'Sirumbia'})
    dataSet.push({ id:'12.12.08.2006', kecamatan:'12.12.08', name:'Sirungkungon'})
    dataSet.push({ id:'12.21.02.2027', kecamatan:'12.21.02', name:'Sisalean'})
    dataSet.push({ id:'12.14.05.2049', kecamatan:'12.14.05', name:'Sisarahili'})
    dataSet.push({ id:'12.24.05.2005', kecamatan:'12.24.05', name:'Sisarahili'})
    dataSet.push({ id:'12.04.11.2002', kecamatan:'12.04.11', name:'Sisarahili Bawolato'})
    dataSet.push({ id:'12.14.08.2022', kecamatan:'12.14.08', name:'Sisarahili Ekholo'})
    dataSet.push({ id:'12.14.34.2006', kecamatan:'12.14.34', name:'Sisarahili Ewo'})
    dataSet.push({ id:'12.14.20.2010', kecamatan:'12.14.20', name:'Sisarahili Huruna'})
    dataSet.push({ id:'12.25.05.2016', kecamatan:'12.25.05', name:'Sisarahili I'})
    dataSet.push({ id:'12.25.03.2008', kecamatan:'12.25.03', name:'Sisarahili Ii'})
    dataSet.push({ id:'12.14.22.2004', kecamatan:'12.14.22', name:'Sisarahili Oyo'})
    dataSet.push({ id:'12.78.01.2027', kecamatan:'12.78.01', name:'Sisarahili Sisambualahe'})
    dataSet.push({ id:'12.04.35.2009', kecamatan:'12.04.35', name:'Sisarahili Sogae Adu'})
    dataSet.push({ id:'12.04.27.2014', kecamatan:'12.04.27', name:'Sisarahili Soroma Asi'})
    dataSet.push({ id:'12.14.24.2003', kecamatan:'12.14.24', name:'Sisarahili Susua'})
    dataSet.push({ id:'12.24.02.2006', kecamatan:'12.24.02', name:'Sisarahili Teluk Siabang'})
    dataSet.push({ id:'12.78.01.2026', kecamatan:'12.78.01', name:'Sisarahiligamo'})
    dataSet.push({ id:'12.04.28.2004', kecamatan:'12.04.28', name:'Sisarahilima U'})
    dataSet.push({ id:'12.04.29.2004', kecamatan:'12.04.29', name:'Sisaratandrawa'})
    dataSet.push({ id:'12.03.02.2037', kecamatan:'12.03.02', name:'Sisipa'})
    dataSet.push({ id:'12.14.34.2005', kecamatan:'12.14.34', name:'Sisiwa Ewali'})
    dataSet.push({ id:'12.04.06.2022', kecamatan:'12.04.06', name:'Sisobahili'})
    dataSet.push({ id:'12.14.07.2016', kecamatan:'12.14.07', name:'Sisobahili'})
    dataSet.push({ id:'12.14.09.2011', kecamatan:'12.14.09', name:'Sisobahili'})
    dataSet.push({ id:'12.24.05.2006', kecamatan:'12.24.05', name:'Sisobahili'})
    dataSet.push({ id:'12.24.09.2006', kecamatan:'12.24.09', name:'Sisobahili'})
    dataSet.push({ id:'12.04.21.2013', kecamatan:'12.04.21', name:'Sisobahili Dola'})
    dataSet.push({ id:'12.14.22.2005', kecamatan:'12.14.22', name:'Sisobahili Huruna'})
    dataSet.push({ id:'12.04.05.2032', kecamatan:'12.04.05', name:'Sisobahili I Tanoseo'})
    dataSet.push({ id:'12.78.02.2013', kecamatan:'12.78.02', name:'Sisobahili Ii Tanose O'})
    dataSet.push({ id:'12.04.10.2014', kecamatan:'12.04.10', name:'Sisobahili Iraono Hura'})
    dataSet.push({ id:'12.14.23.2004', kecamatan:'12.14.23', name:'Sisobahili Siwalawa'})
    dataSet.push({ id:'12.78.01.2028', kecamatan:'12.78.01', name:'Sisobahili Tabaloho'})
    dataSet.push({ id:'12.04.27.2010', kecamatan:'12.04.27', name:'Sisobahili Ulu Gawo'})
    dataSet.push({ id:'12.04.05.2024', kecamatan:'12.04.05', name:'Sisobalauru'})
    dataSet.push({ id:'12.14.15.2003', kecamatan:'12.14.15', name:'Sisobambowo'})
    dataSet.push({ id:'12.25.01.2010', kecamatan:'12.25.01', name:'Sisobambowo'})
    dataSet.push({ id:'12.25.05.2020', kecamatan:'12.25.05', name:'Sisobambowo'})
    dataSet.push({ id:'12.25.02.2018', kecamatan:'12.25.02', name:'Sisobandrao'})
    dataSet.push({ id:'12.25.03.2010', kecamatan:'12.25.03', name:'Sisobandrao'})
    dataSet.push({ id:'12.25.01.2001', kecamatan:'12.25.01', name:'Sisobaoho'})
    dataSet.push({ id:'12.25.03.2003', kecamatan:'12.25.03', name:'Sisobaoho'})
    dataSet.push({ id:'12.04.29.2001', kecamatan:'12.04.29', name:'Sisobawino I'})
    dataSet.push({ id:'12.25.07.2001', kecamatan:'12.25.07', name:'Sisobawino Ii'})
    dataSet.push({ id:'12.03.30.2010', kecamatan:'12.03.30', name:'Sisoma'})
    dataSet.push({ id:'12.21.08.2013', kecamatan:'12.21.08', name:'Sisoma'})
    dataSet.push({ id:'12.02.11.2008', kecamatan:'12.02.11', name:'Sisordak'})
    dataSet.push({ id:'12.22.01.2005', kecamatan:'12.22.01', name:'Sisumut'})
    dataSet.push({ id:'12.03.01.2007', kecamatan:'12.03.01', name:'Sisundung'})
    dataSet.push({ id:'12.20.09.2009', kecamatan:'12.20.09', name:'Sitabar'})
    dataSet.push({ id:'12.20.03.2038', kecamatan:'12.20.03', name:'Sitabola'})
    dataSet.push({ id:'12.02.09.2005', kecamatan:'12.02.09', name:'Sitabotabo'})
    dataSet.push({ id:'12.02.09.2021', kecamatan:'12.02.09', name:'Sitabotabo Toruan'})
    dataSet.push({ id:'12.21.12.2004', kecamatan:'12.21.12', name:'Sitada-Tada'})
    dataSet.push({ id:'12.08.01.2010', kecamatan:'12.08.01', name:'Sitalasari'})
    dataSet.push({ id:'12.17.02.2008', kecamatan:'12.17.02', name:'Sitamiang'})
    dataSet.push({ id:'12.77.02.1004', kecamatan:'12.77.02', name:'Sitamiang'})
    dataSet.push({ id:'12.77.02.1012', kecamatan:'12.77.02', name:'Sitamiang Baru'})
    dataSet.push({ id:'12.03.07.2020', kecamatan:'12.03.07', name:'Sitampa Simatoras'})
    dataSet.push({ id:'12.02.01.2025', kecamatan:'12.02.01', name:'Sitampurung'})
    dataSet.push({ id:'12.02.09.2004', kecamatan:'12.02.09', name:'Sitampurung'})
    dataSet.push({ id:'12.16.10.2004', kecamatan:'12.16.10', name:'Sitanduk'})
    dataSet.push({ id:'12.02.15.2013', kecamatan:'12.02.15', name:'Sitanggor'})
    dataSet.push({ id:'12.20.05.2005', kecamatan:'12.20.05', name:'Sitanggoru'})
    dataSet.push({ id:'12.12.02.2010', kecamatan:'12.12.02', name:'Sitangkola'})
    dataSet.push({ id:'12.16.07.2003', kecamatan:'12.16.07', name:'Sitapongan'})
    dataSet.push({ id:'12.03.01.2015', kecamatan:'12.03.01', name:'Sitaratoit'})
    dataSet.push({ id:'12.01.15.2009', kecamatan:'12.01.15', name:'Sitardas'})
    dataSet.push({ id:'12.21.07.2017', kecamatan:'12.21.07', name:'Sitarolo Julu'})
    dataSet.push({ id:'12.03.01.1001', kecamatan:'12.03.01', name:'Sitinjak'})
    dataSet.push({ id:'12.17.02.2003', kecamatan:'12.17.02', name:'Sitinjak'})
    dataSet.push({ id:'12.11.15.2001', kecamatan:'12.11.15', name:'Sitinjo'})
    dataSet.push({ id:'12.11.15.2002', kecamatan:'12.11.15', name:'Sitinjo I'})
    dataSet.push({ id:'12.11.15.2003', kecamatan:'12.11.15', name:'Sitinjo Ii'})
    dataSet.push({ id:'12.01.03.2015', kecamatan:'12.01.03', name:'Sitio-Tio Hilir'})
    dataSet.push({ id:'12.16.05.2018', kecamatan:'12.16.05', name:'Sitio Ii'})
    dataSet.push({ id:'12.71.01.1012', kecamatan:'12.71.01', name:'Sitirejo I'})
    dataSet.push({ id:'12.71.09.1002', kecamatan:'12.71.09', name:'Sitirejo Ii'})
    dataSet.push({ id:'12.71.09.1003', kecamatan:'12.71.09', name:'Sitirejo Iii'})
    dataSet.push({ id:'12.01.12.2013', kecamatan:'12.01.12', name:'Sitiris-Tiris'})
    dataSet.push({ id:'12.02.05.2007', kecamatan:'12.02.05', name:'Sitolu Ama'})
    dataSet.push({ id:'12.02.08.2010', kecamatan:'12.02.08', name:'Sitolu Bahal'})
    dataSet.push({ id:'12.16.05.2003', kecamatan:'12.16.05', name:'Sitolu Bahal'})
    dataSet.push({ id:'12.04.11.2009', kecamatan:'12.04.11', name:'Sitolu Banua'})
    dataSet.push({ id:'12.14.26.2003', kecamatan:'12.14.26', name:'Sitolu Banua'})
    dataSet.push({ id:'12.17.08.2022', kecamatan:'12.17.08', name:'Sitolu Huta'})
    dataSet.push({ id:'12.12.02.2019', kecamatan:'12.12.02', name:'Sitoluama'})
    dataSet.push({ id:'12.24.10.2009', kecamatan:'12.24.10', name:'Sitolubanua'})
    dataSet.push({ id:'12.25.01.2003', kecamatan:'12.25.01', name:'Sitolubanua'})
    dataSet.push({ id:'12.25.04.2005', kecamatan:'12.25.04', name:'Sitolubanua Fadoro'})
    dataSet.push({ id:'12.25.04.2009', kecamatan:'12.25.04', name:'Sitoluewali'})
    dataSet.push({ id:'12.02.06.2005', kecamatan:'12.02.06', name:'Sitoluompu'})
    dataSet.push({ id:'12.02.02.2011', kecamatan:'12.02.02', name:'Sitompul'})
    dataSet.push({ id:'12.01.04.1004', kecamatan:'12.01.04', name:'Sitonong Bangun'})
    dataSet.push({ id:'12.20.01.2042', kecamatan:'12.20.01', name:'Sitonun'})
    dataSet.push({ id:'12.20.03.2039', kecamatan:'12.20.03', name:'Sitonun'})
    dataSet.push({ id:'12.20.06.2002', kecamatan:'12.20.06', name:'Sitopayan'})
    dataSet.push({ id:'12.12.03.2002', kecamatan:'12.12.03', name:'Sitorang'})
    dataSet.push({ id:'12.12.19.2003', kecamatan:'12.12.19', name:'Situa-Tua'})
    dataSet.push({ id:'12.03.04.2103', kecamatan:'12.03.04', name:'Situmba'})
    dataSet.push({ id:'12.03.30.2006', kecamatan:'12.03.30', name:'Situmba'})
    dataSet.push({ id:'12.03.04.2102', kecamatan:'12.03.04', name:'Situmba Julu'})
    dataSet.push({ id:'12.03.06.2004', kecamatan:'12.03.06', name:'Situmbaga'})
    dataSet.push({ id:'12.20.02.2064', kecamatan:'12.20.02', name:'Situmbaga'})
    dataSet.push({ id:'12.20.11.2011', kecamatan:'12.20.11', name:'Situmbaga'})
    dataSet.push({ id:'12.02.04.1001', kecamatan:'12.02.04', name:'Situmeang Habinsaran'})
    dataSet.push({ id:'12.02.04.2004', kecamatan:'12.02.04', name:'Situmeang Hasundutan'})
    dataSet.push({ id:'12.06.05.2014', kecamatan:'12.06.05', name:'Situnggaling'})
    dataSet.push({ id:'12.17.08.2017', kecamatan:'12.17.08', name:'Situngkir'})
    dataSet.push({ id:'12.09.21.2008', kecamatan:'12.09.21', name:'Situnjak'})
    dataSet.push({ id:'12.03.01.2004', kecamatan:'12.03.01', name:'Siuhom'})
    dataSet.push({ id:'12.09.20.1003', kecamatan:'12.09.20', name:'Siumbut Baru'})
    dataSet.push({ id:'12.09.20.1002', kecamatan:'12.09.20', name:'Siumbut Umbut'})
    dataSet.push({ id:'12.21.01.2006', kecamatan:'12.21.01', name:'Siundol Dolok'})
    dataSet.push({ id:'12.21.01.2004', kecamatan:'12.21.01', name:'Siundol Jae'})
    dataSet.push({ id:'12.21.01.2005', kecamatan:'12.21.01', name:'Siundol Julu'})
    dataSet.push({ id:'12.20.05.2006', kecamatan:'12.20.05', name:'Siunggam Dolok'})
    dataSet.push({ id:'12.20.10.2003', kecamatan:'12.20.10', name:'Siunggam Jae'})
    dataSet.push({ id:'12.20.10.2001', kecamatan:'12.20.10', name:'Siunggam Julu'})
    dataSet.push({ id:'12.20.10.2002', kecamatan:'12.20.10', name:'Siunggam Tonga'})
    dataSet.push({ id:'12.16.03.2006', kecamatan:'12.16.03', name:'Siunong Unong Julu'})
    dataSet.push({ id:'12.14.18.2005', kecamatan:'12.14.18', name:'Siwalawa'})
    dataSet.push({ id:'12.14.26.2002', kecamatan:'12.14.26', name:'Siwalu Banua'})
    dataSet.push({ id:'12.78.04.2016', kecamatan:'12.78.04', name:'Siwalubanua I'})
    dataSet.push({ id:'12.78.04.2008', kecamatan:'12.78.04', name:'Siwalubanua Ii'})
    dataSet.push({ id:'12.24.08.2002', kecamatan:'12.24.08', name:'Siwawo'})
    dataSet.push({ id:'12.04.29.2011', kecamatan:'12.04.29', name:'So Ewali'})
    dataSet.push({ id:'12.11.04.2003', kecamatan:'12.11.04', name:'Soban'})
    dataSet.push({ id:'12.20.05.2010', kecamatan:'12.20.05', name:'Sobar'})
    dataSet.push({ id:'12.14.03.2039', kecamatan:'12.14.03', name:'Sobawagoli'})
    dataSet.push({ id:'12.04.06.2028', kecamatan:'12.04.06', name:'Soewe'})
    dataSet.push({ id:'12.04.35.2006', kecamatan:'12.04.35', name:'Sogae Adu'})
    dataSet.push({ id:'12.01.12.2003', kecamatan:'12.01.12', name:'Sogar'})
    dataSet.push({ id:'12.04.11.2011', kecamatan:'12.04.11', name:'Sohoya'})
    dataSet.push({ id:'12.14.11.2002', kecamatan:'12.14.11', name:'Soledua'})
    dataSet.push({ id:'12.14.11.2010', kecamatan:'12.14.11', name:'Soledua I'})
    dataSet.push({ id:'12.14.11.2011', kecamatan:'12.14.11', name:'Soledua Ii'})
    dataSet.push({ id:'12.14.26.2011', kecamatan:'12.14.26', name:'Somambawa'})
    dataSet.push({ id:'12.03.21.2058', kecamatan:'12.03.21', name:'Somanggal Parmonangan'})
    dataSet.push({ id:'12.03.05.2072', kecamatan:'12.03.05', name:'Somba Debata Purba'})
    dataSet.push({ id:'12.04.06.2017', kecamatan:'12.04.06', name:'Somi'})
    dataSet.push({ id:'12.04.06.2055', kecamatan:'12.04.06', name:'Somi Botogo O'})
    dataSet.push({ id:'12.04.29.2005', kecamatan:'12.04.29', name:'Somolo Molo'})
    dataSet.push({ id:'12.08.29.1005', kecamatan:'12.08.29', name:'Sondi Raya'})
    dataSet.push({ id:'12.14.32.2006', kecamatan:'12.14.32', name:'Sondregeasi'})
    dataSet.push({ id:'12.23.01.2011', kecamatan:'12.23.01', name:'Sonomartani'})
    dataSet.push({ id:'12.11.08.2008', kecamatan:'12.11.08', name:'Sopo Butar'})
    dataSet.push({ id:'12.13.02.2017', kecamatan:'12.13.02', name:'Sopo Sorik'})
    dataSet.push({ id:'12.13.08.2029', kecamatan:'12.13.08', name:'Sopo Sorik'})
    dataSet.push({ id:'12.13.13.2022', kecamatan:'12.13.13', name:'Sopo Tinjak'})
    dataSet.push({ id:'12.13.01.2030', kecamatan:'12.13.01', name:'Sopobatu'})
    dataSet.push({ id:'12.08.07.2008', kecamatan:'12.08.07', name:'Sorba Dolog'})
    dataSet.push({ id:'12.08.30.2018', kecamatan:'12.08.30', name:'Sordang Baru'})
    dataSet.push({ id:'12.08.30.2007', kecamatan:'12.08.30', name:'Sordang Bolon'})
    dataSet.push({ id:'12.03.32.2013', kecamatan:'12.03.32', name:'Sori Manaon'})
    dataSet.push({ id:'12.01.04.1010', kecamatan:'12.01.04', name:'Sori Nauli'})
    dataSet.push({ id:'12.03.07.2030', kecamatan:'12.03.07', name:'Sorik'})
    dataSet.push({ id:'12.03.07.2057', kecamatan:'12.03.07', name:'Sorimadingin Pp'})
    dataSet.push({ id:'12.01.02.1001', kecamatan:'12.01.02', name:'Sorkam'})
    dataSet.push({ id:'12.01.10.1001', kecamatan:'12.01.10', name:'Sorkam Kanan'})
    dataSet.push({ id:'12.01.10.2018', kecamatan:'12.01.10', name:'Sorkam Kanan'})
    dataSet.push({ id:'12.01.02.2017', kecamatan:'12.01.02', name:'Sorkam Kiri'})
    dataSet.push({ id:'12.01.02.2016', kecamatan:'12.01.02', name:'Sorkam Tengah'})
    dataSet.push({ id:'12.14.22.2002', kecamatan:'12.14.22', name:'Soroma Asi'})
    dataSet.push({ id:'12.20.04.2046', kecamatan:'12.20.04', name:'Sosopan'})
    dataSet.push({ id:'12.21.01.2015', kecamatan:'12.21.01', name:'Sosopan'})
    dataSet.push({ id:'12.22.01.2007', kecamatan:'12.22.01', name:'Sosopan'})
    dataSet.push({ id:'12.21.01.2019', kecamatan:'12.21.01', name:'Sosopan Julu'})
    dataSet.push({ id:'12.17.05.2001', kecamatan:'12.17.05', name:'Sosor Dolok'})
    dataSet.push({ id:'12.01.09.1001', kecamatan:'12.01.09', name:'Sosor Gadong'})
    dataSet.push({ id:'12.01.12.2006', kecamatan:'12.01.12', name:'Sosor Gonting'})
    dataSet.push({ id:'12.16.06.2008', kecamatan:'12.16.06', name:'Sosor Gonting'})
    dataSet.push({ id:'12.11.04.2008', kecamatan:'12.11.04', name:'Sosor Lontung'})
    dataSet.push({ id:'12.16.06.2009', kecamatan:'12.16.06', name:'Sosor Tambok'})
    dataSet.push({ id:'12.16.06.2028', kecamatan:'12.16.06', name:'Sosortolong Sihite Iii'})
    dataSet.push({ id:'12.02.01.2019', kecamatan:'12.02.01', name:'Sosunggulon'})
    dataSet.push({ id:'12.14.10.2012', kecamatan:'12.14.10', name:'Soto O Hilisimaetano'})
    dataSet.push({ id:'12.76.02.1011', kecamatan:'12.76.02', name:'Sri Padang'})
    dataSet.push({ id:'12.05.07.1010', kecamatan:'12.05.07', name:'Stabat Baru'})
    dataSet.push({ id:'12.05.08.2003', kecamatan:'12.05.08', name:'Stabat Lama'})
    dataSet.push({ id:'12.05.08.2008', kecamatan:'12.05.08', name:'Stabat Lama Barat'})
    dataSet.push({ id:'12.05.08.2014', kecamatan:'12.05.08', name:'Stungkit'})
    dataSet.push({ id:'12.21.06.2005', kecamatan:'12.21.06', name:'Subulussalam'})
    dataSet.push({ id:'12.09.09.2012', kecamatan:'12.09.09', name:'Subur'})
    dataSet.push({ id:'12.07.06.2026', kecamatan:'12.07.06', name:'Sudirejo'})
    dataSet.push({ id:'12.71.01.1010', kecamatan:'12.71.01', name:'Sudirejo 1'})
    dataSet.push({ id:'12.71.01.1011', kecamatan:'12.71.01', name:'Sudirejo II'})
    dataSet.push({ id:'12.01.16.2001', kecamatan:'12.01.16', name:'Suga Suga Hutagodang'})
    dataSet.push({ id:'12.08.23.2009', kecamatan:'12.08.23', name:'Sugarang Bayu'})
    dataSet.push({ id:'12.07.05.2002', kecamatan:'12.07.05', name:'Sugau'})
    dataSet.push({ id:'12.03.20.2023', kecamatan:'12.03.20', name:'Sugi'})
    dataSet.push({ id:'12.07.27.2011', kecamatan:'12.07.27', name:'Sugiharjo'})
    dataSet.push({ id:'12.06.07.2006', kecamatan:'12.06.07', name:'Sugihen'})
    dataSet.push({ id:'12.06.14.2006', kecamatan:'12.06.14', name:'Sugihen'})
    dataSet.push({ id:'12.17.04.2001', kecamatan:'12.17.04', name:'Suhutnihuta Pardomuan'})
    dataSet.push({ id:'12.06.04.2012', kecamatan:'12.06.04', name:'Suka'})
    dataSet.push({ id:'12.18.02.2028', kecamatan:'12.18.02', name:'Suka Beras'})
    dataSet.push({ id:'12.05.03.2017', kecamatan:'12.05.03', name:'Suka Damai'})
    dataSet.push({ id:'12.05.10.2007', kecamatan:'12.05.10', name:'Suka Damai'})
    dataSet.push({ id:'12.09.30.2001', kecamatan:'12.09.30', name:'Suka Damai'})
    dataSet.push({ id:'12.13.22.2012', kecamatan:'12.13.22', name:'Suka Damai'})
    dataSet.push({ id:'12.18.15.2006', kecamatan:'12.18.15', name:'Suka Damai'})
    dataSet.push({ id:'12.71.16.1004', kecamatan:'12.71.16', name:'Suka Damai'})
    dataSet.push({ id:'12.09.30.2009', kecamatan:'12.09.30', name:'Suka Damai Barat'})
    dataSet.push({ id:'12.05.10.2013', kecamatan:'12.05.10', name:'Suka Damai Timur'})
    dataSet.push({ id:'12.07.04.2003', kecamatan:'12.07.04', name:'Suka Dame'})
    dataSet.push({ id:'12.20.09.2006', kecamatan:'12.20.09', name:'Suka Dame'})
    dataSet.push({ id:'12.05.10.2011', kecamatan:'12.05.10', name:'Suka Jadi'})
    dataSet.push({ id:'12.05.16.2007', kecamatan:'12.05.16', name:'Suka Jaya'})
    dataSet.push({ id:'12.19.06.2016', kecamatan:'12.19.06', name:'Suka Jaya'})
    dataSet.push({ id:'12.06.08.2014', kecamatan:'12.06.08', name:'Suka Julu'})
    dataSet.push({ id:'12.01.16.2002', kecamatan:'12.01.16', name:'Suka Maju'})
    dataSet.push({ id:'12.02.06.2010', kecamatan:'12.02.06', name:'Suka Maju'})
    dataSet.push({ id:'12.05.11.2017', kecamatan:'12.05.11', name:'Suka Maju'})
    dataSet.push({ id:'12.07.03.2026', kecamatan:'12.07.03', name:'Suka Maju'})
    dataSet.push({ id:'12.13.16.2028', kecamatan:'12.13.16', name:'Suka Maju'})
    dataSet.push({ id:'12.14.19.2008', kecamatan:'12.14.19', name:'Suka Maju'})
    dataSet.push({ id:'12.14.21.2008', kecamatan:'12.14.21', name:'Suka Maju'})
    dataSet.push({ id:'12.19.06.2006', kecamatan:'12.19.06', name:'Suka Maju'})
    dataSet.push({ id:'12.71.11.1001', kecamatan:'12.71.11', name:'Suka Maju'})
    dataSet.push({ id:'12.75.03.1005', kecamatan:'12.75.03', name:'Suka Maju'})
    dataSet.push({ id:'12.14.02.2040', kecamatan:'12.14.02', name:'Suka Maju Mohili'})
    dataSet.push({ id:'12.05.05.2007', kecamatan:'12.05.05', name:'Suka Makmur'})
    dataSet.push({ id:'12.07.03.2027', kecamatan:'12.07.03', name:'Suka Makmur'})
    dataSet.push({ id:'12.07.04.2001', kecamatan:'12.07.04', name:'Suka Makmur'})
    dataSet.push({ id:'12.07.22.2002', kecamatan:'12.07.22', name:'Suka Makmur'})
    dataSet.push({ id:'12.09.17.2005', kecamatan:'12.09.17', name:'Suka Makmur'})
    dataSet.push({ id:'12.09.30.2006', kecamatan:'12.09.30', name:'Suka Makmur'})
    dataSet.push({ id:'12.13.17.2014', kecamatan:'12.13.17', name:'Suka Makmur'})
    dataSet.push({ id:'12.06.04.2032', kecamatan:'12.06.04', name:'Suka Mbayak'})
    dataSet.push({ id:'12.05.09.2017', kecamatan:'12.05.09', name:'Suka Mulia'})
    dataSet.push({ id:'12.07.31.2004', kecamatan:'12.07.31', name:'Suka Mulia'})
    dataSet.push({ id:'12.05.21.2004', kecamatan:'12.05.21', name:'Suka Pulung'})
    dataSet.push({ id:'12.05.01.2006', kecamatan:'12.05.01', name:'Suka Rakyat'})
    dataSet.push({ id:'12.05.12.2009', kecamatan:'12.05.12', name:'Suka Ramai'})
    dataSet.push({ id:'12.13.02.2015', kecamatan:'12.13.02', name:'Suka Ramai'})
    dataSet.push({ id:'12.19.03.2013', kecamatan:'12.19.03', name:'Suka Ramai'})
    dataSet.push({ id:'12.19.07.2007', kecamatan:'12.19.07', name:'Suka Ramai'})
    dataSet.push({ id:'12.07.05.2023', kecamatan:'12.07.05', name:'Suka Raya'})
    dataSet.push({ id:'12.07.04.2008', kecamatan:'12.07.04', name:'Suka Rende'})
    dataSet.push({ id:'12.06.04.2033', kecamatan:'12.06.04', name:'Suka Sipilihen'})
    dataSet.push({ id:'12.06.07.2022', kecamatan:'12.06.07', name:'Sukababo'})
    dataSet.push({ id:'12.06.04.2019', kecamatan:'12.06.04', name:'Sukadame'})
    dataSet.push({ id:'12.11.06.2001', kecamatan:'12.11.06', name:'Sukadame'})
    dataSet.push({ id:'12.22.05.2006', kecamatan:'12.22.05', name:'Sukadame'})
    dataSet.push({ id:'12.72.03.1004', kecamatan:'12.72.03', name:'Sukadame'})
    dataSet.push({ id:'12.09.08.2022', kecamatan:'12.09.08', name:'Sukajadi'})
    dataSet.push({ id:'12.18.02.2029', kecamatan:'12.18.02', name:'Sukajadi'})
    dataSet.push({ id:'12.18.05.2004', kecamatan:'12.18.05', name:'Sukajadi'})
    dataSet.push({ id:'12.06.03.2007', kecamatan:'12.06.03', name:'Sukajulu'})
    dataSet.push({ id:'12.07.09.2027', kecamatan:'12.07.09', name:'Sukaluwei'})
    dataSet.push({ id:'12.06.04.2023', kecamatan:'12.06.04', name:'Sukamaju'})
    dataSet.push({ id:'12.07.23.2012', kecamatan:'12.07.23', name:'Sukamaju'})
    dataSet.push({ id:'12.72.05.1007', kecamatan:'12.72.05', name:'Sukamaju'})
    dataSet.push({ id:'12.72.05.1009', kecamatan:'12.72.05', name:'Sukamakmur'})
    dataSet.push({ id:'12.06.05.2007', kecamatan:'12.06.05', name:'Sukamandi'})
    dataSet.push({ id:'12.07.31.2014', kecamatan:'12.07.31', name:'Sukamandi Hilir'})
    dataSet.push({ id:'12.07.31.2015', kecamatan:'12.07.31', name:'Sukamandi Hulu'})
    dataSet.push({ id:'12.06.11.2005', kecamatan:'12.06.11', name:'Sukameriah'})
    dataSet.push({ id:'12.07.06.2014', kecamatan:'12.07.06', name:'Sukamulia Hilir'})
    dataSet.push({ id:'12.07.06.2015', kecamatan:'12.07.06', name:'Sukamulia Hulu'})
    dataSet.push({ id:'12.06.03.2004', kecamatan:'12.06.03', name:'Sukanalu'})
    dataSet.push({ id:'12.06.16.2005', kecamatan:'12.06.16', name:'Sukanalu'})
    dataSet.push({ id:'12.06.16.2009', kecamatan:'12.06.16', name:'Sukandebi'})
    dataSet.push({ id:'12.11.03.2012', kecamatan:'12.11.03', name:'Sukandebi'})
    dataSet.push({ id:'12.19.03.2004', kecamatan:'12.19.03', name:'Sukaraja'})
    dataSet.push({ id:'12.71.15.1004', kecamatan:'12.71.15', name:'Sukaraja'})
    dataSet.push({ id:'12.72.05.1002', kecamatan:'12.72.05', name:'Sukaraja'})
    dataSet.push({ id:'12.15.02.2001', kecamatan:'12.15.02', name:'Sukaramai'})
    dataSet.push({ id:'12.75.03.1006', kecamatan:'12.75.03', name:'Sukaramai'})
    dataSet.push({ id:'12.71.10.1001', kecamatan:'12.71.10', name:'Sukaramai I'})
    dataSet.push({ id:'12.71.10.1002', kecamatan:'12.71.10', name:'Sukaramai Ii'})
    dataSet.push({ id:'12.06.06.2020', kecamatan:'12.06.06', name:'Sukarame'})
    dataSet.push({ id:'12.23.01.2012', kecamatan:'12.23.01', name:'Sukarame'})
    dataSet.push({ id:'12.23.01.2013', kecamatan:'12.23.01', name:'Sukarame Baru'})
    dataSet.push({ id:'12.18.14.2010', kecamatan:'12.18.14', name:'Sukasari'})
    dataSet.push({ id:'12.06.17.2001', kecamatan:'12.06.17', name:'Sukatendel'})
    dataSet.push({ id:'12.06.16.2013', kecamatan:'12.06.16', name:'Sukatepu'})
    dataSet.push({ id:'12.19.07.2017', kecamatan:'12.19.07', name:'Suko Rejo'})
    dataSet.push({ id:'12.05.22.2007', kecamatan:'12.05.22', name:'Sulkam'})
    dataSet.push({ id:'12.11.05.2019', kecamatan:'12.11.05', name:'Sumbari'})
    dataSet.push({ id:'12.09.26.2002', kecamatan:'12.09.26', name:'Sumber Harapan'})
    dataSet.push({ id:'12.05.21.2009', kecamatan:'12.05.21', name:'Sumber Jaya'})
    dataSet.push({ id:'12.72.06.1001', kecamatan:'12.72.06', name:'Sumber Jaya'})
    dataSet.push({ id:'12.75.04.1007', kecamatan:'12.75.04', name:'Sumber Karya'})
    dataSet.push({ id:'12.19.04.2026', kecamatan:'12.19.04', name:'Sumber Makmur'})
    dataSet.push({ id:'12.07.23.2007', kecamatan:'12.07.23', name:'Sumber Melati Diski'})
    dataSet.push({ id:'12.06.01.2006', kecamatan:'12.06.01', name:'Sumber Mufakat'})
    dataSet.push({ id:'12.05.08.2009', kecamatan:'12.05.08', name:'Sumber Mulyo'})
    dataSet.push({ id:'12.23.05.2018', kecamatan:'12.23.05', name:'Sumber Mulyo'})
    dataSet.push({ id:'12.75.04.1006', kecamatan:'12.75.04', name:'Sumber Mulyorejo'})
    dataSet.push({ id:'12.19.04.2027', kecamatan:'12.19.04', name:'Sumber Padi'})
    dataSet.push({ id:'12.19.10.2003', kecamatan:'12.19.10', name:'Sumber Rejo'})
    dataSet.push({ id:'12.74.03.1002', kecamatan:'12.74.03', name:'Sumber Sari'})
    dataSet.push({ id:'12.19.11.2001', kecamatan:'12.19.11', name:'Sumber Tani'})
    dataSet.push({ id:'12.07.31.2016', kecamatan:'12.07.31', name:'Sumberejo'})
    dataSet.push({ id:'12.07.08.2003', kecamatan:'12.07.08', name:'Sumbul'})
    dataSet.push({ id:'12.11.11.2001', kecamatan:'12.11.11', name:'Sumbul'})
    dataSet.push({ id:'12.11.03.2001', kecamatan:'12.11.03', name:'Sumbul Tengah'})
    dataSet.push({ id:'12.03.02.2009', kecamatan:'12.03.02', name:'Sumuran'})
    dataSet.push({ id:'12.13.16.2021', kecamatan:'12.13.16', name:'Sundutan Tigo'})
    dataSet.push({ id:'12.18.11.2028', kecamatan:'12.18.11', name:'Sungai Buaya'})
    dataSet.push({ id:'12.20.02.2045', kecamatan:'12.20.02', name:'Sungai Datar'})
    dataSet.push({ id:'12.20.04.2071', kecamatan:'12.20.04', name:'Sungai Durian'})
    dataSet.push({ id:'12.21.08.2031', kecamatan:'12.21.08', name:'Sungai Jior'})
    dataSet.push({ id:'12.21.05.2018', kecamatan:'12.21.05', name:'Sungai Korang'})
    dataSet.push({ id:'12.20.04.2072', kecamatan:'12.20.04', name:'Sungai Orosan'})
    dataSet.push({ id:'12.20.02.2027', kecamatan:'12.20.02', name:'Sungai Pining'})
    dataSet.push({ id:'12.23.06.2004', kecamatan:'12.23.06', name:'Sungai Raja'})
    dataSet.push({ id:'12.11.07.2004', kecamatan:'12.11.07', name:'Sungai Raya'})
    dataSet.push({ id:'12.20.04.2025', kecamatan:'12.20.04', name:'Sungai Tolang'})
    dataSet.push({ id:'12.05.09.2006', kecamatan:'12.05.09', name:'Sungai Ular'})
    dataSet.push({ id:'12.03.05.2077', kecamatan:'12.03.05', name:'Sunge Sigiring-Giring'})
    dataSet.push({ id:'12.71.02.1003', kecamatan:'12.71.02', name:'Sunggal'})
    dataSet.push({ id:'12.07.23.2013', kecamatan:'12.07.23', name:'Sunggal Kanan'})
    dataSet.push({ id:'12.20.01.2017', kecamatan:'12.20.01', name:'Sunut'})
    dataSet.push({ id:'12.06.12.2026', kecamatan:'12.06.12', name:'Surbakti'})
    dataSet.push({ id:'12.21.04.2016', kecamatan:'12.21.04', name:'Suro Dingin'})
    dataSet.push({ id:'12.15.02.2016', kecamatan:'12.15.02', name:'Surung Mersada'})
    dataSet.push({ id:'12.14.24.2004', kecamatan:'12.14.24', name:'Susua'})
    dataSet.push({ id:'12.06.17.2017', kecamatan:'12.06.17', name:'Susuk'})
    dataSet.push({ id:'12.08.02.2015', kecamatan:'12.08.02', name:'Syahkuda Bayu'})
    dataSet.push({ id:'12.07.28.1011', kecamatan:'12.07.28', name:'Syahmad'})
    dataSet.push({ id:'12.13.17.2010', kecamatan:'12.13.17', name:'Tabuyung'})
    dataSet.push({ id:'12.14.17.2013', kecamatan:'12.14.17', name:'Tafulu'})
    dataSet.push({ id:'12.04.11.2014', kecamatan:'12.04.11', name:'Tagaule'})
    dataSet.push({ id:'12.13.17.2011', kecamatan:'12.13.17', name:'Tagilang Julu'})
    dataSet.push({ id:'12.03.07.2062', kecamatan:'12.03.07', name:'Tahalak Ujung Gading'})
    dataSet.push({ id:'12.07.08.2011', kecamatan:'12.07.08', name:'Tala Peta'})
    dataSet.push({ id:'12.04.21.2017', kecamatan:'12.04.21', name:'Talafu'})
    dataSet.push({ id:'12.08.18.2016', kecamatan:'12.08.18', name:'Talang Bayu'})
    dataSet.push({ id:'12.19.12.2010', kecamatan:'12.19.12', name:'Tali Air Permai'})
    dataSet.push({ id:'12.06.03.2011', kecamatan:'12.06.03', name:'Talimbaru'})
    dataSet.push({ id:'12.14.23.2006', kecamatan:'12.14.23', name:'Talio'})
    dataSet.push({ id:'12.13.16.2022', kecamatan:'12.13.16', name:'Taluk'})
    dataSet.push({ id:'12.07.08.2001', kecamatan:'12.07.08', name:'Talun Kenas'})
    dataSet.push({ id:'12.08.05.2006', kecamatan:'12.08.05', name:'Talun Kondot'})
    dataSet.push({ id:'12.08.21.2002', kecamatan:'12.08.21', name:'Talun Madear'})
    dataSet.push({ id:'12.08.21.2012', kecamatan:'12.08.21', name:'Talun Rejo'})
    dataSet.push({ id:'12.08.08.2006', kecamatan:'12.08.08', name:'Talun Saragih'})
    dataSet.push({ id:'12.14.25.2007', kecamatan:'12.14.25', name:'Taluzusua'})
    dataSet.push({ id:'12.09.30.2004', kecamatan:'12.09.30', name:'Taman Sari'})
    dataSet.push({ id:'12.05.10.2003', kecamatan:'12.05.10', name:'Tamaran'})
    dataSet.push({ id:'12.17.09.2005', kecamatan:'12.17.09', name:'Tamba Dolok'})
    dataSet.push({ id:'12.11.07.2001', kecamatan:'12.11.07', name:'Tambahan'})
    dataSet.push({ id:'12.01.05.2019', kecamatan:'12.01.05', name:'Tambahan Nanjur'})
    dataSet.push({ id:'12.18.12.2033', kecamatan:'12.18.12', name:'Tambak Cekur'})
    dataSet.push({ id:'12.06.02.1006', kecamatan:'12.06.02', name:'Tambak Lau Mulgab I'})
    dataSet.push({ id:'12.06.02.1007', kecamatan:'12.06.02', name:'Tambak Lau Mulgab II'})
    dataSet.push({ id:'12.76.03.1002', kecamatan:'12.76.03', name:'Tambangan'})
    dataSet.push({ id:'12.76.03.1008', kecamatan:'12.76.03', name:'Tambangan Hulu'})
    dataSet.push({ id:'12.13.10.2026', kecamatan:'12.13.10', name:'Tambangan Jae'})
    dataSet.push({ id:'12.13.10.2027', kecamatan:'12.13.10', name:'Tambangan Pasoman'})
    dataSet.push({ id:'12.13.10.2028', kecamatan:'12.13.10', name:'Tambangan Tonga'})
    dataSet.push({ id:'12.13.23.2001', kecamatan:'12.13.23', name:'Tambiski'})
    dataSet.push({ id:'12.13.23.2007', kecamatan:'12.13.23', name:'Tambiski Nauli'})
    dataSet.push({ id:'12.72.06.1003', kecamatan:'12.72.06', name:'Tambun Nabolon'})
    dataSet.push({ id:'12.17.02.2005', kecamatan:'12.17.02', name:'Tambun Sungkean'})
    dataSet.push({ id:'12.12.01.2041', kecamatan:'12.12.01', name:'Tambunan Sunge'})
    dataSet.push({ id:'12.07.03.2028', kecamatan:'12.07.03', name:'Tambunen'})
    dataSet.push({ id:'12.13.08.1032', kecamatan:'12.13.08', name:'Tamiang'})
    dataSet.push({ id:'12.21.09.2002', kecamatan:'12.21.09', name:'Tamiang'})
    dataSet.push({ id:'12.13.12.2016', kecamatan:'12.13.12', name:'Tamiang Mudo'})
    dataSet.push({ id:'12.20.07.2027', kecamatan:'12.20.07', name:'Tamosu'})
    dataSet.push({ id:'12.07.19.2034', kecamatan:'12.07.19', name:'Tanah Abang'})
    dataSet.push({ id:'12.18.16.2003', kecamatan:'12.18.16', name:'Tanah Besih'})
    dataSet.push({ id:'12.71.12.1004', kecamatan:'12.71.12', name:'Tanah Enam Ratus'})
    dataSet.push({ id:'12.07.20.2006', kecamatan:'12.07.20', name:'Tanah Gara Hulu'})
    dataSet.push({ id:'12.19.09.2012', kecamatan:'12.19.09', name:'Tanah Itam Ilir'})
    dataSet.push({ id:'12.07.19.2036', kecamatan:'12.07.19', name:'Tanah Merah'})
    dataSet.push({ id:'12.18.02.2034', kecamatan:'12.18.02', name:'Tanah Merah'})
    dataSet.push({ id:'12.19.03.2007', kecamatan:'12.19.03', name:'Tanah Merah'})
    dataSet.push({ id:'12.75.05.1001', kecamatan:'12.75.05', name:'Tanah Merah'})
    dataSet.push({ id:'12.11.06.2007', kecamatan:'12.11.06', name:'Tanah Pinem'})
    dataSet.push({ id:'12.18.04.2027', kecamatan:'12.18.04', name:'Tanah Raja'})
    dataSet.push({ id:'12.09.30.2003', kecamatan:'12.09.30', name:'Tanah Rakyat'})
    dataSet.push({ id:'12.19.03.2014', kecamatan:'12.19.03', name:'Tanah Rendah'})
    dataSet.push({ id:'12.75.05.1006', kecamatan:'12.75.05', name:'Tanah Seribu'})
    dataSet.push({ id:'12.19.07.2013', kecamatan:'12.19.07', name:'Tanah Timbul'})
    dataSet.push({ id:'12.19.03.2005', kecamatan:'12.19.03', name:'Tanah Tinggi'})
    dataSet.push({ id:'12.75.04.1001', kecamatan:'12.75.04', name:'Tanah Tinggi'})
    dataSet.push({ id:'12.07.24.2013', kecamatan:'12.07.24', name:'Tandem Hilir I'})
    dataSet.push({ id:'12.07.24.2014', kecamatan:'12.07.24', name:'Tandem Hilir Ii'})
    dataSet.push({ id:'12.07.24.2012', kecamatan:'12.07.24', name:'Tandem Hulu I'})
    dataSet.push({ id:'12.07.24.2006', kecamatan:'12.07.24', name:'Tandem Hulu Ii'})
    dataSet.push({ id:'12.03.06.2012', kecamatan:'12.03.06', name:'Tandihat'})
    dataSet.push({ id:'12.21.02.2017', kecamatan:'12.21.02', name:'Tandihat'})
    dataSet.push({ id:'12.13.18.2004', kecamatan:'12.13.18', name:'Tandikek'})
    dataSet.push({ id:'12.21.09.2014', kecamatan:'12.21.09', name:'Tandolan'})
    dataSet.push({ id:'12.07.08.2004', kecamatan:'12.07.08', name:'Tandukan Raga'})
    dataSet.push({ id:'12.09.21.2007', kecamatan:'12.09.21', name:'Tangga'})
    dataSet.push({ id:'12.20.10.2006', kecamatan:'12.20.10', name:'Tangga-Tangga Hambeng'})
    dataSet.push({ id:'12.08.12.2003', kecamatan:'12.08.12', name:'Tangga Batu'})
    dataSet.push({ id:'12.21.09.2015', kecamatan:'12.21.09', name:'Tangga Batu'})
    dataSet.push({ id:'12.12.22.2005', kecamatan:'12.12.22', name:'Tangga Batu Barat'})
    dataSet.push({ id:'12.12.24.2004', kecamatan:'12.12.24', name:'Tangga Batu I'})
    dataSet.push({ id:'12.12.24.2005', kecamatan:'12.12.24', name:'Tangga Batu Ii'})
    dataSet.push({ id:'12.12.22.2006', kecamatan:'12.12.22', name:'Tangga Batu Timur'})
    dataSet.push({ id:'12.21.04.2003', kecamatan:'12.21.04', name:'Tangga Bosi'})
    dataSet.push({ id:'12.13.06.2021', kecamatan:'12.13.06', name:'Tangga Bosi I'})
    dataSet.push({ id:'12.13.06.2019', kecamatan:'12.13.06', name:'Tangga Bosi Ii'})
    dataSet.push({ id:'12.13.06.2022', kecamatan:'12.13.06', name:'Tangga Bosi Iii'})
    dataSet.push({ id:'12.07.06.2022', kecamatan:'12.07.06', name:'Tangkahan'})
    dataSet.push({ id:'12.71.13.1006', kecamatan:'12.71.13', name:'Tangkahan'})
    dataSet.push({ id:'12.05.18.1001', kecamatan:'12.05.18', name:'Tangkahan Durian'})
    dataSet.push({ id:'12.06.03.2006', kecamatan:'12.06.03', name:'Tangkidik'})
    dataSet.push({ id:'12.75.02.1005', kecamatan:'12.75.02', name:'Tangsi'})
    dataSet.push({ id:'12.13.14.2035', kecamatan:'12.13.14', name:'Tangsi Atas'})
    dataSet.push({ id:'12.13.03.2011', kecamatan:'12.13.03', name:'Tanjung'})
    dataSet.push({ id:'12.21.06.2013', kecamatan:'12.21.06', name:'Tanjung'})
    dataSet.push({ id:'12.21.08.2030', kecamatan:'12.21.08', name:'Tanjung'})
    dataSet.push({ id:'12.21.11.2012', kecamatan:'12.21.11', name:'Tanjung'})
    dataSet.push({ id:'12.13.12.2017', kecamatan:'12.13.12', name:'Tanjung Alai'})
    dataSet.push({ id:'12.09.23.2001', kecamatan:'12.09.23', name:'Tanjung Alam'})
    dataSet.push({ id:'12.21.05.2003', kecamatan:'12.21.05', name:'Tanjung Ale'})
    dataSet.push({ id:'12.07.05.2021', kecamatan:'12.07.05', name:'Tanjung Anom'})
    dataSet.push({ id:'12.09.23.2008', kecamatan:'12.09.23', name:'Tanjung Asri'})
    dataSet.push({ id:'12.74.01.1001', kecamatan:'12.74.01', name:'Tanjung Balai Kota I'})
    dataSet.push({ id:'12.74.01.1002', kecamatan:'12.74.01', name:'Tanjung Balai Kota Ii'})
    dataSet.push({ id:'12.74.02.1001', kecamatan:'12.74.02', name:'Tanjung Balai Kota Iii'})
    dataSet.push({ id:'12.74.02.1002', kecamatan:'12.74.02', name:'Tanjung Balai Kota Iv'})
    dataSet.push({ id:'12.21.08.2024', kecamatan:'12.21.08', name:'Tanjung Bale'})
    dataSet.push({ id:'12.07.20.2002', kecamatan:'12.07.20', name:'Tanjung Bampu'})
    dataSet.push({ id:'12.21.09.2003', kecamatan:'12.21.09', name:'Tanjung Barani'})
    dataSet.push({ id:'12.21.03.2002', kecamatan:'12.21.03', name:'Tanjung Baringin'})
    dataSet.push({ id:'12.21.05.2006', kecamatan:'12.21.05', name:'Tanjung Baringin'})
    dataSet.push({ id:'12.21.10.2008', kecamatan:'12.21.10', name:'Tanjung Baringin Simarulak'})
    dataSet.push({ id:'12.07.02.2025', kecamatan:'12.07.02', name:'Tanjung Baru'})
    dataSet.push({ id:'12.21.09.2001', kecamatan:'12.21.09', name:'Tanjung Baru'})
    dataSet.push({ id:'12.20.02.2005', kecamatan:'12.20.02', name:'Tanjung Baru B'})
    dataSet.push({ id:'12.20.01.2041', kecamatan:'12.20.01', name:'Tanjung Baru Silaiya'})
    dataSet.push({ id:'12.06.03.2017', kecamatan:'12.06.03', name:'Tanjung Barus'})
    dataSet.push({ id:'12.06.06.2014', kecamatan:'12.06.06', name:'Tanjung Beringin'})
    dataSet.push({ id:'12.07.03.2029', kecamatan:'12.07.03', name:'Tanjung Beringin'})
    dataSet.push({ id:'12.11.02.2014', kecamatan:'12.11.02', name:'Tanjung Beringin'})
    dataSet.push({ id:'12.11.02.2027', kecamatan:'12.11.02', name:'Tanjung Beringin I'})
    dataSet.push({ id:'12.20.08.2021', kecamatan:'12.20.08', name:'Tanjung Botung'})
    dataSet.push({ id:'12.21.07.2022', kecamatan:'12.21.07', name:'Tanjung Botung'})
    dataSet.push({ id:'12.21.09.2019', kecamatan:'12.21.09', name:'Tanjung Botung Pinarik'})
    dataSet.push({ id:'12.21.08.2018', kecamatan:'12.21.08', name:'Tanjung Botung Sosa Jae'})
    dataSet.push({ id:'12.18.02.2035', kecamatan:'12.18.02', name:'Tanjung Buluh'})
    dataSet.push({ id:'12.17.08.2014', kecamatan:'12.17.08', name:'Tanjung Bunga'})
    dataSet.push({ id:'12.03.20.2036', kecamatan:'12.03.20', name:'Tanjung Dolok'})
    dataSet.push({ id:'12.21.07.2021', kecamatan:'12.21.07', name:'Tanjung Durian'})
    dataSet.push({ id:'12.19.02.2018', kecamatan:'12.19.02', name:'Tanjung Gading'})
    dataSet.push({ id:'12.07.28.2003', kecamatan:'12.07.28', name:'Tanjung Garbus I'})
    dataSet.push({ id:'12.07.31.2011', kecamatan:'12.07.31', name:'Tanjung Garbus Ii'})
    dataSet.push({ id:'12.07.31.2012', kecamatan:'12.07.31', name:'Tanjung Garbus Kampung'})
    dataSet.push({ id:'12.05.04.2015', kecamatan:'12.05.04', name:'Tanjung Gunung'})
    dataSet.push({ id:'12.06.09.2004', kecamatan:'12.06.09', name:'Tanjung Gunung'})
    dataSet.push({ id:'12.07.23.2008', kecamatan:'12.07.23', name:'Tanjung Gusta'})
    dataSet.push({ id:'12.71.03.1004', kecamatan:'12.71.03', name:'Tanjung Gusta'})
    dataSet.push({ id:'12.07.19.2001', kecamatan:'12.07.19', name:'Tanjung Gusti'})
    dataSet.push({ id:'12.10.08.2010', kecamatan:'12.10.08', name:'Tanjung Haloban'})
    dataSet.push({ id:'12.18.12.2010', kecamatan:'12.18.12', name:'Tanjung Harap'})
    dataSet.push({ id:'12.10.14.2007', kecamatan:'12.10.14', name:'Tanjung Harapan'})
    dataSet.push({ id:'12.08.22.2007', kecamatan:'12.08.22', name:'Tanjung Hataran'})
    dataSet.push({ id:'12.05.09.2007', kecamatan:'12.05.09', name:'Tanjung Ibus'})
    dataSet.push({ id:'12.05.05.2004', kecamatan:'12.05.05', name:'Tanjung Jati'})
    dataSet.push({ id:'12.13.03.2013', kecamatan:'12.13.03', name:'Tanjung Julu'})
    dataSet.push({ id:'12.05.21.2006', kecamatan:'12.05.21', name:'Tanjung Kariahan'})
    dataSet.push({ id:'12.19.08.2006', kecamatan:'12.19.08', name:'Tanjung Kasau'})
    dataSet.push({ id:'12.05.02.1007', kecamatan:'12.05.02', name:'Tanjung Langkat'})
    dataSet.push({ id:'12.13.12.2024', kecamatan:'12.13.12', name:'Tanjung Larangan'})
    dataSet.push({ id:'12.23.02.1001', kecamatan:'12.23.02', name:'Tanjung Leidong'})
    dataSet.push({ id:'12.05.01.2005', kecamatan:'12.05.01', name:'Tanjung Lenggang'})
    dataSet.push({ id:'12.20.02.2062', kecamatan:'12.20.02', name:'Tanjung Longat'})
    dataSet.push({ id:'12.23.03.2005', kecamatan:'12.23.03', name:'Tanjung Mangedar'})
    dataSet.push({ id:'12.08.19.2005', kecamatan:'12.08.19', name:'Tanjung Maraja'})
    dataSet.push({ id:'12.18.09.2026', kecamatan:'12.18.09', name:'Tanjung Maria'})
    dataSet.push({ id:'12.20.08.2016', kecamatan:'12.20.08', name:'Tanjung Maria'})
    dataSet.push({ id:'12.20.04.2012', kecamatan:'12.20.04', name:'Tanjung Marulak'})
    dataSet.push({ id:'12.76.02.1010', kecamatan:'12.76.02', name:'Tanjung Marulak'})
    dataSet.push({ id:'12.76.02.1012', kecamatan:'12.76.02', name:'Tanjung Marulak Hilir'})
    dataSet.push({ id:'12.06.17.2013', kecamatan:'12.06.17', name:'Tanjung Mbelang'})
    dataSet.push({ id:'12.03.30.2017', kecamatan:'12.03.30', name:'Tanjung Medan'})
    dataSet.push({ id:'12.10.07.2003', kecamatan:'12.10.07', name:'Tanjung Medan'})
    dataSet.push({ id:'12.13.12.2020', kecamatan:'12.13.12', name:'Tanjung Medan'})
    dataSet.push({ id:'12.22.02.2008', kecamatan:'12.22.02', name:'Tanjung Medan'})
    dataSet.push({ id:'12.05.06.2004', kecamatan:'12.05.06', name:'Tanjung Merahe'})
    dataSet.push({ id:'12.06.13.2011', kecamatan:'12.06.13', name:'Tanjung Merahe'})
    dataSet.push({ id:'12.06.17.2008', kecamatan:'12.06.17', name:'Tanjung Merawa'})
    dataSet.push({ id:'12.15.01.2001', kecamatan:'12.15.01', name:'Tanjung Meriah'})
    dataSet.push({ id:'12.13.02.2020', kecamatan:'12.13.02', name:'Tanjung Mompang'})
    dataSet.push({ id:'12.21.03.2024', kecamatan:'12.21.03', name:'Tanjung Morang'})
    dataSet.push({ id:'12.21.12.2008', kecamatan:'12.21.12', name:'Tanjung Morang'})
    dataSet.push({ id:'12.07.02.2014', kecamatan:'12.07.02', name:'Tanjung Morawa A'})
    dataSet.push({ id:'12.07.02.2012', kecamatan:'12.07.02', name:'Tanjung Morawa B'})
    dataSet.push({ id:'12.07.20.2009', kecamatan:'12.07.20', name:'Tanjung Muda'})
    dataSet.push({ id:'12.05.10.2004', kecamatan:'12.05.10', name:'Tanjung Mulia'})
    dataSet.push({ id:'12.07.02.2010', kecamatan:'12.07.02', name:'Tanjung Mulia'})
    dataSet.push({ id:'12.07.31.2001', kecamatan:'12.07.31', name:'Tanjung Mulia'})
    dataSet.push({ id:'12.15.01.2002', kecamatan:'12.15.01', name:'Tanjung Mulia'})
    dataSet.push({ id:'12.19.12.2002', kecamatan:'12.19.12', name:'Tanjung Mulia'})
    dataSet.push({ id:'12.22.02.2011', kecamatan:'12.22.02', name:'Tanjung Mulia'})
    dataSet.push({ id:'12.71.06.1002', kecamatan:'12.71.06', name:'Tanjung Mulia Hilir'})
    dataSet.push({ id:'12.71.06.1003', kecamatan:'12.71.06', name:'Tanjung Mulya'})
    dataSet.push({ id:'12.06.10.2005', kecamatan:'12.06.10', name:'Tanjung Pamah'})
    dataSet.push({ id:'12.05.15.2003', kecamatan:'12.05.15', name:'Tanjung Pasir'})
    dataSet.push({ id:'12.08.11.2001', kecamatan:'12.08.11', name:'Tanjung Pasir'})
    dataSet.push({ id:'12.23.08.2011', kecamatan:'12.23.08', name:'Tanjung Pasir'})
    dataSet.push({ id:'12.72.06.1011', kecamatan:'12.72.06', name:'Tanjung Pinggir'})
    dataSet.push({ id:'12.19.08.2001', kecamatan:'12.19.08', name:'Tanjung Prapat'})
    dataSet.push({ id:'12.06.17.2007', kecamatan:'12.06.17', name:'Tanjung Pulo'})
    dataSet.push({ id:'12.07.09.2030', kecamatan:'12.07.09', name:'Tanjung Purba'})
    dataSet.push({ id:'12.08.26.2011', kecamatan:'12.08.26', name:'Tanjung Purba'})
    dataSet.push({ id:'12.21.10.2005', kecamatan:'12.21.10', name:'Tanjung Purba Tua'})
    dataSet.push({ id:'12.05.12.2008', kecamatan:'12.05.12', name:'Tanjung Putus'})
    dataSet.push({ id:'12.18.14.2011', kecamatan:'12.18.14', name:'Tanjung Putus'})
    dataSet.push({ id:'12.07.20.2010', kecamatan:'12.07.20', name:'Tanjung Raja'})
    dataSet.push({ id:'12.08.30.2009', kecamatan:'12.08.30', name:'Tanjung Rapuan'})
    dataSet.push({ id:'12.07.26.2014', kecamatan:'12.07.26', name:'Tanjung Rejo'})
    dataSet.push({ id:'12.71.02.1005', kecamatan:'12.71.02', name:'Tanjung Rejo'})
    dataSet.push({ id:'12.21.11.2016', kecamatan:'12.21.11', name:'Tanjung Rokan'})
    dataSet.push({ id:'12.20.06.2009', kecamatan:'12.20.06', name:'Tanjung Salamat'})
    dataSet.push({ id:'12.11.09.2006', kecamatan:'12.11.09', name:'Tanjung Saluksuk'})
    dataSet.push({ id:'12.10.20.2001', kecamatan:'12.10.20', name:'Tanjung Sarang Elang'})
    dataSet.push({ id:'12.07.27.2003', kecamatan:'12.07.27', name:'Tanjung Sari'})
    dataSet.push({ id:'12.08.20.2014', kecamatan:'12.08.20', name:'Tanjung Saribu'})
    dataSet.push({ id:'12.05.12.1006', kecamatan:'12.05.12', name:'Tanjung Selamat'})
    dataSet.push({ id:'12.07.06.2011', kecamatan:'12.07.06', name:'Tanjung Selamat'})
    dataSet.push({ id:'12.07.23.2016', kecamatan:'12.07.23', name:'Tanjung Selamat'})
    dataSet.push({ id:'12.07.26.2013', kecamatan:'12.07.26', name:'Tanjung Selamat'})
    dataSet.push({ id:'12.22.02.2010', kecamatan:'12.22.02', name:'Tanjung Selamat'})
    dataSet.push({ id:'12.71.07.1001', kecamatan:'12.71.07', name:'Tanjung Selamat'})
    dataSet.push({ id:'12.07.07.2016', kecamatan:'12.07.07', name:'Tanjung Sena'})
    dataSet.push({ id:'12.19.08.2007', kecamatan:'12.19.08', name:'Tanjung Seri'})
    dataSet.push({ id:'12.13.06.2020', kecamatan:'12.13.06', name:'Tanjung Sialang'})
    dataSet.push({ id:'12.19.01.2013', kecamatan:'12.19.01', name:'Tanjung Sigoni'})
    dataSet.push({ id:'12.07.19.2037', kecamatan:'12.07.19', name:'Tanjung Siporkis'})
    dataSet.push({ id:'12.10.09.2002', kecamatan:'12.10.09', name:'Tanjung Siram'})
    dataSet.push({ id:'12.07.20.2018', kecamatan:'12.07.20', name:'Tanjung Timur'})
    dataSet.push({ id:'12.19.06.1001', kecamatan:'12.19.06', name:'Tanjung Tiram'})
    dataSet.push({ id:'12.20.04.2051', kecamatan:'12.20.04', name:'Tanjung Tiram'})
    dataSet.push({ id:'12.72.06.1009', kecamatan:'12.72.06', name:'Tanjung Tongah'})
    dataSet.push({ id:'12.17.01.2014', kecamatan:'12.17.01', name:'Tanjungan'})
    dataSet.push({ id:'12.19.03.2012', kecamatan:'12.19.03', name:'Tanjungharapan'})
    dataSet.push({ id:'12.19.03.2011', kecamatan:'12.19.03', name:'Tanjungkubah'})
    dataSet.push({ id:'12.19.03.2006', kecamatan:'12.19.03', name:'Tanjungmuda'})
    dataSet.push({ id:'12.19.03.2015', kecamatan:'12.19.03', name:'Tanjungmulya'})
    dataSet.push({ id:'12.71.21.1002', kecamatan:'12.71.21', name:'Tanjungsari'})
    dataSet.push({ id:'12.13.04.1009', kecamatan:'12.13.04', name:'Tano Bato'})
    dataSet.push({ id:'12.14.04.2024', kecamatan:'12.14.04', name:'Tano Mokinu'})
    dataSet.push({ id:'12.08.14.2007', kecamatan:'12.08.14', name:'Tano Tinggir'})
    dataSet.push({ id:'12.21.07.2023', kecamatan:'12.21.07', name:'Tanobato'})
    dataSet.push({ id:'12.77.01.1005', kecamatan:'12.77.01', name:'Tanobato'})
    dataSet.push({ id:'12.14.02.2035', kecamatan:'12.14.02', name:'Tanoniko O'})
    dataSet.push({ id:'12.12.04.2021', kecamatan:'12.12.04', name:'Taon Marisi'})
    dataSet.push({ id:'12.05.11.2016', kecamatan:'12.05.11', name:'Tapak Kuda'})
    dataSet.push({ id:'12.18.11.2031', kecamatan:'12.18.11', name:'Tapak Meriah'})
    dataSet.push({ id:'12.02.04.2007', kecamatan:'12.02.04', name:'Tapian Nauli'})
    dataSet.push({ id:'12.03.06.1014', kecamatan:'12.03.06', name:'Tapian Nauli'})
    dataSet.push({ id:'12.16.05.2004', kecamatan:'12.16.05', name:'Tapian Nauli'})
    dataSet.push({ id:'12.21.06.2003', kecamatan:'12.21.06', name:'Tapian Nauli'})
    dataSet.push({ id:'12.02.12.2019', kecamatan:'12.02.12', name:'Tapian Nauli I'})
    dataSet.push({ id:'12.01.07.1001', kecamatan:'12.01.07', name:'Tapian Nauli Ii'})
    dataSet.push({ id:'12.02.12.2012', kecamatan:'12.02.12', name:'Tapian Nauli Ii'})
    dataSet.push({ id:'12.01.07.2003', kecamatan:'12.01.07', name:'Tapian Nauli Iii'})
    dataSet.push({ id:'12.02.12.2007', kecamatan:'12.02.12', name:'Tapian Nauli Iii'})
    dataSet.push({ id:'12.01.07.2004', kecamatan:'12.01.07', name:'Tapian Nauli Iv'})
    dataSet.push({ id:'12.01.14.2005', kecamatan:'12.01.14', name:'Tapian Nauli/ Saurmanggita'})
    dataSet.push({ id:'12.13.14.1028', kecamatan:'12.13.14', name:'Tapus'})
    dataSet.push({ id:'12.03.22.2008', kecamatan:'12.03.22', name:'Tapus Godang'})
    dataSet.push({ id:'12.20.03.2040', kecamatan:'12.20.03', name:'Tapus Jae'})
    dataSet.push({ id:'12.03.22.2044', kecamatan:'12.03.22', name:'Tapus Sipagabu'})
    dataSet.push({ id:'12.21.03.2011', kecamatan:'12.21.03', name:'Tar Sihoda-Hoda'})
    dataSet.push({ id:'12.16.10.2001', kecamatan:'12.16.10', name:'Tarabintang'})
    dataSet.push({ id:'12.12.22.2002', kecamatan:'12.12.22', name:'Tarabunga'})
    dataSet.push({ id:'12.25.06.2010', kecamatan:'12.25.06', name:'Taraha'})
    dataSet.push({ id:'12.25.06.2008', kecamatan:'12.25.06', name:'Tarahoso'})
    dataSet.push({ id:'12.78.05.2005', kecamatan:'12.78.05', name:'Tarakhaini'})
    dataSet.push({ id:'12.03.29.2004', kecamatan:'12.03.29', name:'Tarapung Raya'})
    dataSet.push({ id:'12.08.30.2006', kecamatan:'12.08.30', name:'Taratak Nagodang'})
    dataSet.push({ id:'12.18.11.2029', kecamatan:'12.18.11', name:'Tarean'})
    dataSet.push({ id:'12.14.20.2011', kecamatan:'12.14.20', name:'Tarewe'})
    dataSet.push({ id:'12.13.13.2023', kecamatan:'12.13.13', name:'Tarlola'})
    dataSet.push({ id:'12.77.05.2018', kecamatan:'12.77.05', name:'Tarutung Baru'})
    dataSet.push({ id:'12.01.02.1004', kecamatan:'12.01.02', name:'Tarutung Bolak'})
    dataSet.push({ id:'12.20.02.2026', kecamatan:'12.20.02', name:'Tarutung Bolak'})
    dataSet.push({ id:'12.13.23.2002', kecamatan:'12.13.23', name:'Tarutung Panjang'})
    dataSet.push({ id:'12.03.32.2015', kecamatan:'12.03.32', name:'Tatengger'})
    dataSet.push({ id:'12.24.08.2001', kecamatan:'12.24.08', name:'Te Olo'})
    dataSet.push({ id:'12.09.19.1012', kecamatan:'12.09.19', name:'Tebing Kisaran'})
    dataSet.push({ id:'12.10.07.2005', kecamatan:'12.10.07', name:'Tebing Linggahara'})
    dataSet.push({ id:'12.10.07.2010', kecamatan:'12.10.07', name:'Tebing Linggahara Baru'})
    dataSet.push({ id:'12.05.12.2007', kecamatan:'12.05.12', name:'Tebing Tanjung Selamat'})
    dataSet.push({ id:'12.01.18.2002', kecamatan:'12.01.18', name:'Tebing Tinggi'})
    dataSet.push({ id:'12.13.03.2012', kecamatan:'12.13.03', name:'Tebing Tinggi'})
    dataSet.push({ id:'12.18.05.2005', kecamatan:'12.18.05', name:'Tebing Tinggi'})
    dataSet.push({ id:'12.76.03.1004', kecamatan:'12.76.03', name:'Tebing Tinggi'})
    dataSet.push({ id:'12.76.05.1007', kecamatan:'12.76.05', name:'Tebing Tinggi Lama'})
    dataSet.push({ id:'12.10.14.2002', kecamatan:'12.10.14', name:'Tebing Tinggi Pangkatan'})
    dataSet.push({ id:'12.14.04.2010', kecamatan:'12.14.04', name:'Tebolo Melayu'})
    dataSet.push({ id:'12.24.11.2004', kecamatan:'12.24.11', name:'Tefa O'})
    dataSet.push({ id:'12.71.04.1001', kecamatan:'12.71.04', name:'Tegal S Mandala I'})
    dataSet.push({ id:'12.71.04.1002', kecamatan:'12.71.04', name:'Tegal S Mandala II'})
    dataSet.push({ id:'12.71.04.1003', kecamatan:'12.71.04', name:'Tegal S Mandala III'})
    dataSet.push({ id:'12.09.19.1013', kecamatan:'12.09.19', name:'Tegal Sari'})
    dataSet.push({ id:'12.13.16.2023', kecamatan:'12.13.16', name:'Tegal Sari'})
    dataSet.push({ id:'12.18.09.2012', kecamatan:'12.18.09', name:'Tegal Sari'})
    dataSet.push({ id:'12.71.10.1010', kecamatan:'12.71.10', name:'Tegal Sari I'})
    dataSet.push({ id:'12.71.10.1011', kecamatan:'12.71.10', name:'Tegal Sari Ii'})
    dataSet.push({ id:'12.71.10.1012', kecamatan:'12.71.10', name:'Tegal Sari Iii'})
    dataSet.push({ id:'12.71.18.1009', kecamatan:'12.71.18', name:'Tegalrejo'})
    dataSet.push({ id:'12.08.08.2011', kecamatan:'12.08.08', name:'Teladan'})
    dataSet.push({ id:'12.09.20.1001', kecamatan:'12.09.20', name:'Teladan'})
    dataSet.push({ id:'12.09.26.2006', kecamatan:'12.09.26', name:'Teladan'})
    dataSet.push({ id:'12.72.02.1008', kecamatan:'12.72.02', name:'Teladan'})
    dataSet.push({ id:'12.71.01.1009', kecamatan:'12.71.01', name:'Teladan Barat'})
    dataSet.push({ id:'12.71.01.1008', kecamatan:'12.71.01', name:'Teladan Timur'})
    dataSet.push({ id:'12.05.09.2012', kecamatan:'12.05.09', name:'Telaga Jernih'})
    dataSet.push({ id:'12.05.17.2006', kecamatan:'12.05.17', name:'Telaga Said'})
    dataSet.push({ id:'12.07.02.2024', kecamatan:'12.07.02', name:'Telaga Sari'})
    dataSet.push({ id:'12.07.23.2015', kecamatan:'12.07.23', name:'Telaga Sari'})
    dataSet.push({ id:'12.10.18.2009', kecamatan:'12.10.18', name:'Telaga Suka'})
    dataSet.push({ id:'12.07.25.2005', kecamatan:'12.07.25', name:'Telaga Tujuh'})
    dataSet.push({ id:'12.05.04.2001', kecamatan:'12.05.04', name:'Telagah'})
    dataSet.push({ id:'12.03.02.2018', kecamatan:'12.03.02', name:'Telo'})
    dataSet.push({ id:'12.05.09.2002', kecamatan:'12.05.09', name:'Teluk'})
    dataSet.push({ id:'12.05.11.2007', kecamatan:'12.05.11', name:'Teluk Bakung'})
    dataSet.push({ id:'12.24.02.2010', kecamatan:'12.24.02', name:'Teluk Bengkuang'})
    dataSet.push({ id:'12.23.03.2006', kecamatan:'12.23.03', name:'Teluk Binjai'})
    dataSet.push({ id:'12.09.31.2002', kecamatan:'12.09.31', name:'Teluk Dalam'})
    dataSet.push({ id:'12.76.04.1007', kecamatan:'12.76.04', name:'Teluk Karang'})
    dataSet.push({ id:'12.08.30.2008', kecamatan:'12.08.30', name:'Teluk Lapian'})
    dataSet.push({ id:'12.14.30.2007', kecamatan:'12.14.30', name:'Teluk Limo'})
    dataSet.push({ id:'12.05.14.2003', kecamatan:'12.05.14', name:'Teluk Meku'})
    dataSet.push({ id:'12.22.02.2007', kecamatan:'12.22.02', name:'Teluk Panji'})
    dataSet.push({ id:'12.22.02.2012', kecamatan:'12.22.02', name:'Teluk Panji I'})
    dataSet.push({ id:'12.22.02.2013', kecamatan:'12.22.02', name:'Teluk Panji Ii'})
    dataSet.push({ id:'12.22.02.2014', kecamatan:'12.22.02', name:'Teluk Panji Iii'})
    dataSet.push({ id:'12.22.02.2015', kecamatan:'12.22.02', name:'Teluk Panji Iv'})
    dataSet.push({ id:'12.23.03.2004', kecamatan:'12.23.03', name:'Teluk Piai'})
    dataSet.push({ id:'12.23.02.2002', kecamatan:'12.23.02', name:'Teluk Pulai Dalam'})
    dataSet.push({ id:'12.23.02.2003', kecamatan:'12.23.02', name:'Teluk Pulai Luar'})
    dataSet.push({ id:'12.22.03.2003', kecamatan:'12.22.03', name:'Teluk Rampah'})
    dataSet.push({ id:'12.01.02.2003', kecamatan:'12.01.02', name:'Teluk Roban'})
    dataSet.push({ id:'12.10.20.2003', kecamatan:'12.10.20', name:'Teluk Sentosa'})
    dataSet.push({ id:'12.78.03.2004', kecamatan:'12.78.03', name:'Telukbelukar'})
    dataSet.push({ id:'12.07.26.2006', kecamatan:'12.07.26', name:'Tembung'})
    dataSet.push({ id:'12.71.14.1005', kecamatan:'12.71.14', name:'Tembung'})
    dataSet.push({ id:'12.06.17.2010', kecamatan:'12.06.17', name:'Temburun'})
    dataSet.push({ id:'12.08.08.2014', kecamatan:'12.08.08', name:'Tempel Jaya'})
    dataSet.push({ id:'12.07.05.2010', kecamatan:'12.07.05', name:'Tengah'})
    dataSet.push({ id:'12.07.32.2002', kecamatan:'12.07.32', name:'Tengah'})
    dataSet.push({ id:'12.23.07.2011', kecamatan:'12.23.07', name:'Terang Bulan'})
    dataSet.push({ id:'12.71.12.1003', kecamatan:'12.71.12', name:'Terjun'})
    dataSet.push({ id:'12.09.26.2003', kecamatan:'12.09.26', name:'Terusan Tengah'})
    dataSet.push({ id:'12.14.01.2017', kecamatan:'12.14.01', name:'Tesikhori'})
    dataSet.push({ id:'12.14.17.2001', kecamatan:'12.14.17', name:'Tetegawa Ai'})
    dataSet.push({ id:'12.14.17.2011', kecamatan:'12.14.17', name:'Tetegawa Ai Ehomo'})
    dataSet.push({ id:'12.04.10.2006', kecamatan:'12.04.10', name:'Tetegeona Ai'})
    dataSet.push({ id:'12.04.10.2022', kecamatan:'12.04.10', name:'Tetehosi'})
    dataSet.push({ id:'12.14.22.2009', kecamatan:'12.14.22', name:'Tetehosi'})
    dataSet.push({ id:'12.25.02.2016', kecamatan:'12.25.02', name:'Tetehosi'})
    dataSet.push({ id:'12.25.05.2015', kecamatan:'12.25.05', name:'Tetehosi'})
    dataSet.push({ id:'12.78.03.2005', kecamatan:'12.78.03', name:'Tetehosi Afia'})
    dataSet.push({ id:'12.04.21.2016', kecamatan:'12.04.21', name:'Tetehosi Botomuzoi'})
    dataSet.push({ id:'12.78.04.2010', kecamatan:'12.78.04', name:'Tetehosi I'})
    dataSet.push({ id:'12.78.04.2014', kecamatan:'12.78.04', name:'Tetehosi Ii'})
    dataSet.push({ id:'12.24.04.2001', kecamatan:'12.24.04', name:'Tetehosi Maziaya'})
    dataSet.push({ id:'12.78.02.2015', kecamatan:'12.78.02', name:'Tetehosi Ombolata'})
    dataSet.push({ id:'12.24.11.2003', kecamatan:'12.24.11', name:'Tetehosi Sorowi'})
    dataSet.push({ id:'12.14.03.2014', kecamatan:'12.14.03', name:'Tetezou'})
    dataSet.push({ id:'12.07.05.2003', kecamatan:'12.07.05', name:'Tiang Layar'})
    dataSet.push({ id:'12.08.06.1008', kecamatan:'12.08.06', name:'Tiga Balata'})
    dataSet.push({ id:'12.06.08.1019', kecamatan:'12.06.08', name:'Tiga Binanga'})
    dataSet.push({ id:'12.08.09.2004', kecamatan:'12.08.09', name:'Tiga Bolon'})
    dataSet.push({ id:'12.08.13.2005', kecamatan:'12.08.13', name:'Tiga Dolok'})
    dataSet.push({ id:'12.07.20.2001', kecamatan:'12.07.20', name:'Tiga Juhar'})
    dataSet.push({ id:'12.08.16.1005', kecamatan:'12.08.16', name:'Tiga Raja'})
    dataSet.push({ id:'12.08.14.1008', kecamatan:'12.08.14', name:'Tiga Runggu'})
    dataSet.push({ id:'12.04.10.2033', kecamatan:'12.04.10', name:'Tiga Serangkai Maliwa A'})
    dataSet.push({ id:'12.11.03.2005', kecamatan:'12.11.03', name:'Tigalingga'})
    dataSet.push({ id:'12.06.17.2006', kecamatan:'12.06.17', name:'Tiganderket'})
    dataSet.push({ id:'12.06.04.2011', kecamatan:'12.06.04', name:'Tigapanah'})
    dataSet.push({ id:'12.06.12.2006', kecamatan:'12.06.12', name:'Tigapancur'})
    dataSet.push({ id:'12.08.20.2001', kecamatan:'12.08.20', name:'Tigaras'})
    dataSet.push({ id:'12.25.01.2006', kecamatan:'12.25.01', name:'Tigaserangkai'})
    dataSet.push({ id:'12.08.23.2011', kecamatan:'12.08.23', name:'Timbaan'})
    dataSet.push({ id:'12.07.19.2035', kecamatan:'12.07.19', name:'Timbang Deli'})
    dataSet.push({ id:'12.71.09.1006', kecamatan:'12.71.09', name:'Timbang Deli'})
    dataSet.push({ id:'12.72.02.1004', kecamatan:'12.72.02', name:'Timbang Galung'})
    dataSet.push({ id:'12.05.01.2020', kecamatan:'12.05.01', name:'Timbang Jaya'})
    dataSet.push({ id:'12.75.04.1003', kecamatan:'12.75.04', name:'Timbang Langkat'})
    dataSet.push({ id:'12.05.01.2003', kecamatan:'12.05.01', name:'Timbang Lawan'})
    dataSet.push({ id:'12.07.06.2008', kecamatan:'12.07.06', name:'Timbang Lawan'})
    dataSet.push({ id:'12.77.01.1013', kecamatan:'12.77.01', name:'Timbangan'})
    dataSet.push({ id:'12.15.07.2002', kecamatan:'12.15.07', name:'Tinada'})
    dataSet.push({ id:'12.03.31.2007', kecamatan:'12.03.31', name:'Tindoan Laut'})
    dataSet.push({ id:'12.09.26.2001', kecamatan:'12.09.26', name:'Tinggi Raja'})
    dataSet.push({ id:'12.12.02.2011', kecamatan:'12.12.02', name:'Tinggir Nipasir'})
    dataSet.push({ id:'12.08.30.2004', kecamatan:'12.08.30', name:'Tinjoan'})
    dataSet.push({ id:'12.77.04.2010', kecamatan:'12.77.04', name:'Tinjoman Lama'})
    dataSet.push({ id:'12.18.08.2007', kecamatan:'12.18.08', name:'Tinokkah'})
    dataSet.push({ id:'12.16.03.2003', kecamatan:'12.16.03', name:'Tipang'})
    dataSet.push({ id:'12.71.11.1002', kecamatan:'12.71.11', name:'Titi Kuning'})
    dataSet.push({ id:'12.19.09.2007', kecamatan:'12.19.09', name:'Titi Merah'})
    dataSet.push({ id:'12.19.03.2016', kecamatan:'12.19.03', name:'Titi Payung'})
    dataSet.push({ id:'12.19.09.2005', kecamatan:'12.19.09', name:'Titi Putih'})
    dataSet.push({ id:'12.71.17.1006', kecamatan:'12.71.17', name:'Titi Rante'})
    dataSet.push({ id:'12.71.06.1001', kecamatan:'12.71.06', name:'Titipapan'})
    dataSet.push({ id:'12.72.04.1001', kecamatan:'12.72.04', name:'Toba'})
    dataSet.push({ id:'12.13.08.2033', kecamatan:'12.13.08', name:'Tobang'})
    dataSet.push({ id:'12.77.01.1006', kecamatan:'12.77.01', name:'Tobat'})
    dataSet.push({ id:'12.21.11.2008', kecamatan:'12.21.11', name:'Tobing'})
    dataSet.push({ id:'12.21.03.2013', kecamatan:'12.21.03', name:'Tobing Jae'})
    dataSet.push({ id:'12.21.03.2010', kecamatan:'12.21.03', name:'Tobing Julu'})
    dataSet.push({ id:'12.21.03.2017', kecamatan:'12.21.03', name:'Tobing Tinggi'})
    dataSet.push({ id:'12.21.11.2010', kecamatan:'12.21.11', name:'Tobing Tinggi'})
    dataSet.push({ id:'12.20.12.2007', kecamatan:'12.20.12', name:'Tobing Tinggi Ub'})
    dataSet.push({ id:'12.14.14.2007', kecamatan:'12.14.14', name:'Tobualo'})
    dataSet.push({ id:'12.01.04.2005', kecamatan:'12.01.04', name:'Toga Basir'})
    dataSet.push({ id:'12.25.02.2022', kecamatan:'12.25.02', name:'Togideu'})
    dataSet.push({ id:'12.25.02.2017', kecamatan:'12.25.02', name:'Togimbogi'})
    dataSet.push({ id:'12.14.11.2001', kecamatan:'12.14.11', name:'Togizita'})
    dataSet.push({ id:'12.14.11.2005', kecamatan:'12.14.11', name:'Togizita I'})
    dataSet.push({ id:'12.08.20.2010', kecamatan:'12.08.20', name:'Togu Domu Nauli'})
    dataSet.push({ id:'12.17.03.2004', kecamatan:'12.17.03', name:'Toguan Galung'})
    dataSet.push({ id:'12.08.26.2009', kecamatan:'12.08.26', name:'Togur'})
    dataSet.push({ id:'12.03.04.2069', kecamatan:'12.03.04', name:'Tolang'})
    dataSet.push({ id:'12.03.22.2043', kecamatan:'12.03.22', name:'Tolang'})
    dataSet.push({ id:'12.13.11.2013', kecamatan:'12.13.11', name:'Tolang'})
    dataSet.push({ id:'12.03.21.2009', kecamatan:'12.03.21', name:'Tolang Jae'})
    dataSet.push({ id:'12.03.21.2008', kecamatan:'12.03.21', name:'Tolang Julu'})
    dataSet.push({ id:'12.13.08.2031', kecamatan:'12.13.08', name:'Tombang Bustak'})
    dataSet.push({ id:'12.13.13.2024', kecamatan:'12.13.13', name:'Tombang Kaluang'})
    dataSet.push({ id:'12.17.01.2001', kecamatan:'12.17.01', name:'Tomok'})
    dataSet.push({ id:'12.17.01.2017', kecamatan:'12.17.01', name:'Tomok Parsaoran'})
    dataSet.push({ id:'12.72.01.1002', kecamatan:'12.72.01', name:'Tomuan'})
    dataSet.push({ id:'12.09.17.2008', kecamatan:'12.09.17', name:'Tomuan Holbung'})
    dataSet.push({ id:'12.08.12.2007', kecamatan:'12.08.12', name:'Tonduhan'})
    dataSet.push({ id:'12.72.08.1002', kecamatan:'12.72.08', name:'Tong Marimbun'})
    dataSet.push({ id:'12.06.05.2010', kecamatan:'12.06.05', name:'Tongging'})
    dataSet.push({ id:'12.13.13.2031', kecamatan:'12.13.13', name:'Tor Naincat'})
    dataSet.push({ id:'12.13.02.2019', kecamatan:'12.13.02', name:'Torbanua Raja'})
    dataSet.push({ id:'12.02.06.2002', kecamatan:'12.02.06', name:'Tordolok Nauli'})
    dataSet.push({ id:'12.22.03.2009', kecamatan:'12.22.03', name:'Torgamba'})
    dataSet.push({ id:'12.22.03.2011', kecamatan:'12.22.03', name:'Torganda'})
    dataSet.push({ id:'12.20.06.2039', kecamatan:'12.20.06', name:'Torluk Muara Dolok'})
    dataSet.push({ id:'12.12.04.2020', kecamatan:'12.12.04', name:'Tornagodang'})
    dataSet.push({ id:'12.06.12.2024', kecamatan:'12.06.12', name:'Torong'})
    dataSet.push({ id:'12.08.11.2002', kecamatan:'12.08.11', name:'Totap Majawa'})
    dataSet.push({ id:'12.15.08.2006', kecamatan:'12.15.08', name:'Traju'})
    dataSet.push({ id:'12.11.07.2008', kecamatan:'12.11.07', name:'Tualang'})
    dataSet.push({ id:'12.18.02.1041', kecamatan:'12.18.02', name:'Tualang'})
    dataSet.push({ id:'12.76.01.1010', kecamatan:'12.76.01', name:'Tualang'})
    dataSet.push({ id:'12.23.05.2009', kecamatan:'12.23.05', name:'Tubiran'})
    dataSet.push({ id:'12.25.02.2023', kecamatan:'12.25.02', name:'Tugala'})
    dataSet.push({ id:'12.25.02.2020', kecamatan:'12.25.02', name:'Tugala Gawu'})
    dataSet.push({ id:'12.24.11.2005', kecamatan:'12.24.11', name:'Tugala Lauru'})
    dataSet.push({ id:'12.14.08.2030', kecamatan:'12.14.08', name:'Tuhegafoa'})
    dataSet.push({ id:'12.14.27.2007', kecamatan:'12.14.27', name:'Tuhegafoa'})
    dataSet.push({ id:'12.04.21.2007', kecamatan:'12.04.21', name:'Tuhegafoa I'})
    dataSet.push({ id:'12.04.05.2025', kecamatan:'12.04.05', name:'Tuhegafoa Ii'})
    dataSet.push({ id:'12.78.04.2005', kecamatan:'12.78.04', name:'Tuhegeo I'})
    dataSet.push({ id:'12.78.04.2026', kecamatan:'12.78.04', name:'Tuhegeo Ii'})
    dataSet.push({ id:'12.04.28.2006', kecamatan:'12.04.28', name:'Tuhemberua'})
    dataSet.push({ id:'12.14.01.2016', kecamatan:'12.14.01', name:'Tuhemberua'})
    dataSet.push({ id:'12.25.05.2004', kecamatan:'12.25.05', name:'Tuhemberua'})
    dataSet.push({ id:'12.14.07.2033', kecamatan:'12.14.07', name:'Tuhemberua Amandraya'})
    dataSet.push({ id:'12.78.01.2029', kecamatan:'12.78.01', name:'Tuhemberua Ulu'})
    dataSet.push({ id:'12.04.35.2001', kecamatan:'12.04.35', name:'Tuhembuasi'})
    dataSet.push({ id:'12.24.05.2009', kecamatan:'12.24.05', name:'Tuhenakhe I'})
    dataSet.push({ id:'12.04.10.2009', kecamatan:'12.04.10', name:'Tuhewaebu'})
    dataSet.push({ id:'12.14.11.2004', kecamatan:'12.14.11', name:'Tuho Owo'})
    dataSet.push({ id:'12.25.05.2011', kecamatan:'12.25.05', name:'Tuhoowo'})
    dataSet.push({ id:'12.14.07.2008', kecamatan:'12.14.07', name:'Tuindrao'})
    dataSet.push({ id:'12.14.07.2032', kecamatan:'12.14.07', name:'Tuindrao I'})
    dataSet.push({ id:'12.01.14.1001', kecamatan:'12.01.14', name:'Tukka'})
    dataSet.push({ id:'12.16.09.2006', kecamatan:'12.16.09', name:'Tukka Dolok'})
    dataSet.push({ id:'12.17.01.1016', kecamatan:'12.17.01', name:'Tuktuk Siadong'})
    dataSet.push({ id:'12.04.35.2008', kecamatan:'12.04.35', name:'Tulumbaho'})
    dataSet.push({ id:'12.04.06.2052', kecamatan:'12.04.06', name:'Tulumbaho Salo O'})
    dataSet.push({ id:'12.14.01.2021', kecamatan:'12.14.01', name:'Tumari'})
    dataSet.push({ id:'12.01.05.2007', kecamatan:'12.01.05', name:'Tumba'})
    dataSet.push({ id:'12.01.05.2008', kecamatan:'12.01.05', name:'Tumba Jae'})
    dataSet.push({ id:'12.01.05.2014', kecamatan:'12.01.05', name:'Tumba Nauli'})
    dataSet.push({ id:'12.08.03.2005', kecamatan:'12.08.03', name:'Tumorang'})
    dataSet.push({ id:'12.25.05.2013', kecamatan:'12.25.05', name:'Tumori'})
    dataSet.push({ id:'12.78.06.2001', kecamatan:'12.78.06', name:'Tumori'})
    dataSet.push({ id:'12.78.06.2002', kecamatan:'12.78.06', name:'Tumori Balohili'})
    dataSet.push({ id:'12.07.33.2011', kecamatan:'12.07.33', name:'Tumpatan'})
    dataSet.push({ id:'12.07.27.2002', kecamatan:'12.07.27', name:'Tumpatan Nibung'})
    dataSet.push({ id:'12.13.16.2024', kecamatan:'12.13.16', name:'Tunas Karya'})
    dataSet.push({ id:'12.14.20.2008', kecamatan:'12.14.20', name:'Tundrumbaho'})
    dataSet.push({ id:'12.09.14.2006', kecamatan:'12.09.14', name:'Tunggul 45'})
    dataSet.push({ id:'12.75.04.1005', kecamatan:'12.75.04', name:'Tunggurono'})
    dataSet.push({ id:'12.11.05.2012', kecamatan:'12.11.05', name:'Tungtung Batu'})
    dataSet.push({ id:'12.07.05.2016', kecamatan:'12.07.05', name:'Tuntungan I'})
    dataSet.push({ id:'12.07.05.2018', kecamatan:'12.07.05', name:'Tuntungan Ii'})
    dataSet.push({ id:'12.11.12.2008', kecamatan:'12.11.12', name:'Tupak Raja'})
    dataSet.push({ id:'12.05.02.2009', kecamatan:'12.05.02', name:'Turangi'})
    dataSet.push({ id:'12.17.05.2008', kecamatan:'12.17.05', name:'Turpuk Limbong'})
    dataSet.push({ id:'12.17.05.2010', kecamatan:'12.17.05', name:'Turpuk Malau'})
    dataSet.push({ id:'12.17.05.2009', kecamatan:'12.17.05', name:'Turpuk Sagala'})
    dataSet.push({ id:'12.17.05.2011', kecamatan:'12.17.05', name:'Turpuk Sihotang'})
    dataSet.push({ id:'12.25.02.2003', kecamatan:'12.25.02', name:'Tuwa Tuwa'})
    dataSet.push({ id:'12.14.04.2002', kecamatan:'12.14.04', name:'Tuwaso'})
    dataSet.push({ id:'12.25.05.2003', kecamatan:'12.25.05', name:'Tuwuna'})
    dataSet.push({ id:'12.20.05.2014', kecamatan:'12.20.05', name:'Ubar'})
    dataSet.push({ id:'12.05.01.2022', kecamatan:'12.05.01', name:'Ujung Bandar'})
    dataSet.push({ id:'12.05.02.2019', kecamatan:'12.05.02', name:'Ujung Bandar'})
    dataSet.push({ id:'12.10.02.1004', kecamatan:'12.10.02', name:'Ujung Bandar'})
    dataSet.push({ id:'12.01.01.2006', kecamatan:'12.01.01', name:'Ujung Batu'})
    dataSet.push({ id:'12.21.08.2019', kecamatan:'12.21.08', name:'Ujung Batu'})
    dataSet.push({ id:'12.21.05.2019', kecamatan:'12.21.05', name:'Ujung Batu I'})
    dataSet.push({ id:'12.21.05.2020', kecamatan:'12.21.05', name:'Ujung Batu Ii'})
    dataSet.push({ id:'12.21.05.2021', kecamatan:'12.21.05', name:'Ujung Batu Iii'})
    dataSet.push({ id:'12.21.05.2022', kecamatan:'12.21.05', name:'Ujung Batu Iv'})
    dataSet.push({ id:'12.20.12.2008', kecamatan:'12.20.12', name:'Ujung Batu Jae'})
    dataSet.push({ id:'12.20.12.2002', kecamatan:'12.20.12', name:'Ujung Batu Julu'})
    dataSet.push({ id:'12.21.05.2023', kecamatan:'12.21.05', name:'Ujung Batu V'})
    dataSet.push({ id:'12.08.26.2014', kecamatan:'12.08.26', name:'Ujung Bawang'})
    dataSet.push({ id:'12.08.13.2006', kecamatan:'12.08.13', name:'Ujung Bondar'})
    dataSet.push({ id:'12.06.13.2008', kecamatan:'12.06.13', name:'Ujung Deleng'})
    dataSet.push({ id:'12.07.03.2030', kecamatan:'12.07.03', name:'Ujung Deleng'})
    dataSet.push({ id:'12.21.12.2006', kecamatan:'12.21.12', name:'Ujung Gading'})
    dataSet.push({ id:'12.22.04.2005', kecamatan:'12.22.04', name:'Ujung Gading'})
    dataSet.push({ id:'12.20.08.2026', kecamatan:'12.20.08', name:'Ujung Gading Jae'})
    dataSet.push({ id:'12.20.08.2031', kecamatan:'12.20.08', name:'Ujung Gading Julu'})
    dataSet.push({ id:'12.19.12.2007', kecamatan:'12.19.12', name:'Ujung Kubu'})
    dataSet.push({ id:'12.07.06.2005', kecamatan:'12.07.06', name:'Ujung Labuhan'})
    dataSet.push({ id:'12.08.31.2009', kecamatan:'12.08.31', name:'Ujung Mariah'})
    dataSet.push({ id:'12.13.08.2034', kecamatan:'12.13.08', name:'Ujung Marisi'})
    dataSet.push({ id:'12.07.01.2010', kecamatan:'12.07.01', name:'Ujung Meriah'})
    dataSet.push({ id:'12.18.17.2007', kecamatan:'12.18.17', name:'Ujung Negeri Hulu'})
    dataSet.push({ id:'12.18.17.2005', kecamatan:'12.18.17', name:'Ujung Negeri Kahan'})
    dataSet.push({ id:'12.08.30.1001', kecamatan:'12.08.30', name:'Ujung Padang'})
    dataSet.push({ id:'12.20.03.2022', kecamatan:'12.20.03', name:'Ujung Padang'})
    dataSet.push({ id:'12.21.05.2005', kecamatan:'12.21.05', name:'Ujung Padang'})
    dataSet.push({ id:'12.21.12.2012', kecamatan:'12.21.12', name:'Ujung Padang'})
    dataSet.push({ id:'12.23.07.2009', kecamatan:'12.23.07', name:'Ujung Padang'})
    dataSet.push({ id:'12.77.02.1005', kecamatan:'12.77.02', name:'Ujung Padang'})
    dataSet.push({ id:'12.06.11.2025', kecamatan:'12.06.11', name:'Ujung Payung'})
    dataSet.push({ id:'12.07.09.2033', kecamatan:'12.07.09', name:'Ujung Rambe'})
    dataSet.push({ id:'12.18.01.2005', kecamatan:'12.18.01', name:'Ujung Rambung'})
    dataSet.push({ id:'12.06.14.2002', kecamatan:'12.06.14', name:'Ujung Sampun'})
    dataSet.push({ id:'12.08.31.2001', kecamatan:'12.08.31', name:'Ujung Saribu'})
    dataSet.push({ id:'12.07.02.2002', kecamatan:'12.07.02', name:'Ujung Serdang'})
    dataSet.push({ id:'12.18.09.2028', kecamatan:'12.18.09', name:'Ujung Silau'})
    dataSet.push({ id:'12.12.02.2007', kecamatan:'12.12.02', name:'Ujung Tanduk'})
    dataSet.push({ id:'12.05.02.2010', kecamatan:'12.05.02', name:'Ujung Teran'})
    dataSet.push({ id:'12.06.15.2003', kecamatan:'12.06.15', name:'Ujung Teran'})
    dataSet.push({ id:'12.11.03.2002', kecamatan:'12.11.03', name:'Ujung Teran'})
    dataSet.push({ id:'12.77.03.2005', kecamatan:'12.77.03', name:'Ujunggurap'})
    dataSet.push({ id:'12.20.08.2014', kecamatan:'12.20.08', name:'Ulak Tano'})
    dataSet.push({ id:'12.21.01.2010', kecamatan:'12.21.01', name:'Ulu Aer'})
    dataSet.push({ id:'12.22.05.2004', kecamatan:'12.22.05', name:'Ulu Mahuam'})
    dataSet.push({ id:'12.03.05.2074', kecamatan:'12.03.05', name:'Ulu Mamis Situnggaling'})
    dataSet.push({ id:'12.14.17.2006', kecamatan:'12.14.17', name:'Ulu Mazo'})
    dataSet.push({ id:'12.14.25.2004', kecamatan:'12.14.25', name:'Uluidanoduo'})
    dataSet.push({ id:'12.15.04.2001', kecamatan:'12.15.04', name:'Ulumerah'})
    dataSet.push({ id:'12.04.06.2027', kecamatan:'12.04.06', name:'Umbu'})
    dataSet.push({ id:'12.14.35.2006', kecamatan:'12.14.35', name:'Umbu Idanotae'})
    dataSet.push({ id:'12.14.02.2043', kecamatan:'12.14.02', name:'Umbu Orahua'})
    dataSet.push({ id:'12.14.25.2005', kecamatan:'12.14.25', name:'Umbu Sohahau'})
    dataSet.push({ id:'12.14.23.2003', kecamatan:'12.14.23', name:'Umbuasi'})
    dataSet.push({ id:'12.14.23.2009', kecamatan:'12.14.23', name:'Umbuasi Barat'})
    dataSet.push({ id:'12.24.04.2002', kecamatan:'12.24.04', name:'Umbubalodano'})
    dataSet.push({ id:'12.14.14.2012', kecamatan:'12.14.14', name:'Umbunasi'})
    dataSet.push({ id:'12.17.01.2020', kecamatan:'12.17.01', name:'Unjur'})
    dataSet.push({ id:'12.01.09.2002', kecamatan:'12.01.09', name:'Unte Boang'})
    dataSet.push({ id:'12.20.01.2028', kecamatan:'12.20.01', name:'Unte Manis'})
    dataSet.push({ id:'12.02.15.2002', kecamatan:'12.02.15', name:'Unte Mungkur'})
    dataSet.push({ id:'12.01.06.2004', kecamatan:'12.01.06', name:'Unte Mungkur I'})
    dataSet.push({ id:'12.01.06.2003', kecamatan:'12.01.06', name:'Unte Mungkur Ii'})
    dataSet.push({ id:'12.01.06.2002', kecamatan:'12.01.06', name:'Unte Mungkur Iii'})
    dataSet.push({ id:'12.01.06.2001', kecamatan:'12.01.06', name:'Unte Mungkur Iv'})
    dataSet.push({ id:'12.21.02.2030', kecamatan:'12.21.02', name:'Unterudang'})
    dataSet.push({ id:'12.17.04.2003', kecamatan:'12.17.04', name:'Urat Ii'})
    dataSet.push({ id:'12.17.04.2009', kecamatan:'12.17.04', name:'Urat Timur'})
    dataSet.push({ id:'12.01.12.2009', kecamatan:'12.01.12', name:'Uratan'})
    dataSet.push({ id:'12.07.06.2023', kecamatan:'12.07.06', name:'Uruk Gedang'})
    dataSet.push({ id:'12.11.05.2016', kecamatan:'12.11.05', name:'Uruk Mblin'})
    dataSet.push({ id:'12.07.09.2032', kecamatan:'12.07.09', name:'Urung Ganjang'})
    dataSet.push({ id:'12.10.02.1003', kecamatan:'12.10.02', name:'Urung Kompas'})
    dataSet.push({ id:'12.08.14.2014', kecamatan:'12.08.14', name:'Urung Pane'})
    dataSet.push({ id:'12.09.27.2001', kecamatan:'12.09.27', name:'Urung Pane'})
    dataSet.push({ id:'12.08.14.2003', kecamatan:'12.08.14', name:'Urung Purba'})
    dataSet.push({ id:'12.13.08.2035', kecamatan:'12.13.08', name:'Usor Tolang'})
    dataSet.push({ id:'12.08.21.2011', kecamatan:'12.08.21', name:'Wana Rejo'})
    dataSet.push({ id:'12.25.07.2008', kecamatan:'12.25.07', name:'Wango'})
    dataSet.push({ id:'12.14.30.2008', kecamatan:'12.14.30', name:'Wawa'})
    dataSet.push({ id:'12.04.35.2010', kecamatan:'12.04.35', name:'We A-We A'})
    dataSet.push({ id:'12.03.02.1001', kecamatan:'12.03.02', name:'Wek I'})
    dataSet.push({ id:'12.77.01.1001', kecamatan:'12.77.01', name:'Wek I'})
    dataSet.push({ id:'12.03.02.1002', kecamatan:'12.03.02', name:'Wek Ii'})
    dataSet.push({ id:'12.77.01.1002', kecamatan:'12.77.01', name:'Wek Ii'})
    dataSet.push({ id:'12.03.02.2019', kecamatan:'12.03.02', name:'Wek Iii'})
    dataSet.push({ id:'12.77.01.1003', kecamatan:'12.77.01', name:'Wek Iii'})
    dataSet.push({ id:'12.03.02.2016', kecamatan:'12.03.02', name:'Wek Iv'})
    dataSet.push({ id:'12.77.01.1004', kecamatan:'12.77.01', name:'Wek Iv'})
    dataSet.push({ id:'12.77.02.1001', kecamatan:'12.77.02', name:'Wek V'})
    dataSet.push({ id:'12.77.02.1002', kecamatan:'12.77.02', name:'Wek Vi'})
    dataSet.push({ id:'12.13.22.2010', kecamatan:'12.13.22', name:'Wido Daren'})
    dataSet.push({ id:'12.13.22.2011', kecamatan:'12.13.22', name:'Wono Sari'})
    dataSet.push({ id:'12.07.02.2020', kecamatan:'12.07.02', name:'Wonosari'})
    dataSet.push({ id:'12.10.19.2008', kecamatan:'12.10.19', name:'Wonosari'})
    dataSet.push({ id:'12.14.30.2003', kecamatan:'12.14.30', name:'Zia Biang'})
    dataSet.push({ id:'12.25.05.2019', kecamatan:'12.25.05', name:'Zuzundrao'})
    dataSet.push({ id:'12.12.20.2005', kecamatan:'12.12.20', name:'Narumonda V'})
    dataSet.push({ id:'12.01.07.2002', kecamatan:'12.01.07', name:'Tapian Nauli I'})
    dataSet.push({ id:'12.73.02.1002', kecamatan:'12.73.02', name:'Pasar Baru'})
    dataSet.push({ id:'12.73.02.1003', kecamatan:'12.73.02', name:'Pasar Belakang'})
    setListDesa(dataSet)
    console.log('desa done')
  }
  function test_indikator() {
    var tampung;

    if (level === "negara")
      tampung = listIndikator.filter(item => item.provinsi === true)
    else if (level === "provinsi")
      tampung = listIndikator.filter(item => item.kabupaten === true)
    else if (level === "kabkot")
      tampung = listIndikator.filter(item => item.kecamatan === true)
    else if (level === "kecamatan")
      tampung = listIndikator.filter(item => item.desa === true)
    else if (level === "desa")
      tampung = listIndikator.filter(item => item.bnba === true)

    var tes = tampung.filter(item => item.id === idIndikator)
    return tes.length
  }

  useEffect(() => {

    if (idIndikator > 0) {
      var tes = test_indikator()
      console.log(idIndikator)
      if (tes == 0) {

        setValue()
        setTimeout(function () {
          alert('Indikator yang aktif tidak tersedia pada level administrasi saat ini. Silahkan pilih Indikator lain')
        }, 500)

      }
    }
  }, [idIndikator, level]);

  useEffect(() => {
    //alert('indikator')


    if (level === "negara") {
      //setIdProvince(kode);
      setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
      setInfoLabelWilayah("Indonesia")
      if (layer) {
        setUrl('./data/provinsi/provinsi_stats.geojson')
      }
      //if(idProvince === 0)
      //setUrl('./data/provinsi/provinsi_stats.geojson')
    } else if (level === "provinsi") {
      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
      setUrl('./data/kabupaten/' + idProvince + '.geojson')
      console.log(idProvince)
      var raw = listProvinces.filter(x => x.id == idProvince)
      console.log(listProvinces)
      console.log(raw)
      setInfoLabelWilayah("Provinsi " + raw[0].name)
      setListMunicipalsA(listMunicipals)
    } else if (level === "kabkot") {

      setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
      setUrl('./data/kecamatan/' + idMunicipal + '.geojson')
      var raw = listMunicipals.filter(x => x.id === idMunicipal)
      setInfoLabelWilayah(raw[0].name.includes("Kota ") ? raw[0].name : "Kabupaten " + raw[0].name)
      //load kecamatan
      setListKecamatanA(listKecamatan.filter(x => x.kabupaten === 0 || x.kabupaten === idMunicipal))
    } else if (level === "kecamatan") {
      setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
      setUrl('./data/desa/' + idKecamatan + '.geojson')
      var raw = listKecamatan.filter(x => x.id === idKecamatan)
      setInfoLabelWilayah("Kecamatan " + raw ? raw[0].name : "")
      setListDesaA(listDesa.filter(x => x.kecamatan === 0 || x.kecamatan === idKecamatan))
    } else if (level === "desa") {
      setListIndikatorAktif(listIndikator.filter(item => item.bnba === true))
      setUrl('./data/bnba/' + idDesa + '_pt.geojson')
      var raw = listDesa.filter(x => x.id === idDesa)
      setInfoLabelWilayah("Desa " + raw[0].name)
    }


  }, [level]);
  /*
  useEffect(() => {
    if (idKecamatan !== 0) {
      setIdDesa(0)
      setListDesaA(listDesa.filter(x => x.kecamatan === 0 || x.kecamatan === idKecamatan))
    }
  }, [idKecamatan]);
  */

  useEffect(() => {
    setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
    load_kabupaten53()
    load_kecamatan()
    load_desa()
    var dataset = [{ id: 0, name: "Semua" }]

    dataset.push({ id: 11, name: "Aceh" });
    dataset.push({ id: 51, name: "Bali" });
    dataset.push({ id: 36, name: "Banten" });
    dataset.push({ id: 17, name: "Bengkulu" });
    dataset.push({ id: 34, name: "DI Yogyakarta" });
    dataset.push({ id: 31, name: "DKI Jakarta" });
    dataset.push({ id: 75, name: "Gorontalo" });
    dataset.push({ id: 15, name: "Jambi" });
    dataset.push({ id: 32, name: "Jawa Barat" });
    dataset.push({ id: 33, name: "Jawa Tengah" });
    dataset.push({ id: 35, name: "Jawa Timur" });
    dataset.push({ id: 61, name: "Kalimantan Barat" });
    dataset.push({ id: 63, name: "Kalimantan Selatan" });
    dataset.push({ id: 62, name: "Kalimantan Tengah" });
    dataset.push({ id: 64, name: "Kalimantan Timur" });
    dataset.push({ id: 65, name: "Kalimantan Utara" });
    dataset.push({ id: 19, name: "Kep. Bangka Belitung" });
    dataset.push({ id: 21, name: "Kep. Riau" });
    dataset.push({ id: 18, name: "Lampung" });
    dataset.push({ id: 81, name: "Maluku" });
    dataset.push({ id: 82, name: "Maluku Utara" });
    dataset.push({ id: 52, name: "Nusa Tenggara Barat" });
    dataset.push({ id: 53, name: "Nusa Tenggara Timur" });
    dataset.push({ id: 91, name: "Papua" });
    dataset.push({ id: 92, name: "Papua Barat" });
    dataset.push({ id: 14, name: "Riau" });
    dataset.push({ id: 76, name: "Sulawesi Barat" });
    dataset.push({ id: 73, name: "Sulawesi Selatan" });
    dataset.push({ id: 72, name: "Sulawesi Tengah" });
    dataset.push({ id: 74, name: "Sulawesi Tenggara" });
    dataset.push({ id: 71, name: "Sulawesi Utara" });
    dataset.push({ id: 13, name: "Sumatera Barat" });
    dataset.push({ id: 16, name: "Sumatera Selatan" });
    dataset.push({ id: 12, name: "Sumatera Utara" });
    setListProvinces(dataset)

    setIdMunicipal(0);
    var kabupatenSet = [{ id: 0, province: 0, name: "Semua" }];
    setListMunicipalsA(kabupatenSet)

    setIdKecamatan(0);
    var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
    setListKecamatanA(kecamatanSet)

    setIdDesa(0);
    var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
    setListDesaA(desaSet)



  }, []);

  function getProvinces() {
    if (typeof (listProvinces) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listProvinces !== null) {
        if (listProvinces.length > 0) {
          return listProvinces.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  function getMunicipals() {
    if (typeof (listMunicipalsA) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listMunicipalsA !== null) {
        if (listMunicipalsA.length > 0) {
          return listMunicipalsA.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }
  function getKecamatan() {
    if (typeof (listKecamatanA) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listKecamatanA !== null) {
        if (listKecamatanA.length > 0) {
          return listKecamatanA.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }
  function getDesa() {
    if (typeof (listDesaA) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listDesaA !== null) {
        if (listDesaA.length > 0) {
          return listDesaA.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }
  function handleCloseBasemap(e) {
    setShowBasemap(false);
  }

  function handleCloseLayer() {
    setShowLayer(false)
  }

  function handleCloseIndikator() {
    setShowIndikator(false)
  }

  function handleClosePrint(e) {
    setShowPrint(false);
  }


  //const handleChangeSelect = (event) => {
  // setIdProvince(event.target.value);
  //};

  //const handleChange = (event, newValue) => {
  // setValue(newValue);
  // };



  function deleteDataset(id) {
    //setDataset(oldArray => [...oldArray, newElement]);
    //console.log(dataset);

    const layers = mapLayer.slice();
    console.log(id);

    //console.log(map)
    //map.eachLayer(function(layer){
    //if(layer.options.id === id)
    //map.removeLayer(layer)
    //});
    //var index = mapLayer.findIndex(x => x.id === id);
    //setDataset(mapLayer.slice(index, 1));
    //console.log(typeof(id))
    //console.log(typeof(dataset.slice()[0].id))
    //console.log(dataset.filter(item => item.id !== id))
    setMapLayer(mapLayer.filter(item => item.id !== id));
    setIdentifierDelete(id)

  }

  function handleVisible(id) {
    //setIdentifierVisible(id);
    const data = mapLayer.slice();
    //console.log(data[0]);
    var index = mapLayer.findIndex(x => x.id === id);
    //console.log(index);
    data[index].visible = !data[index].visible
    setMapLayer(data);
  }

  function handleOpacity(id, val) {
    //console.log(id, val)
    //setIdentifierVisible(id);
    const data = mapLayer.slice();
    //console.log(data[0]);
    var index = mapLayer.findIndex(x => x.id === id);
    //console.log(index);
    data[index].opacity = val
    setMapLayer(data);
  }
  const handleChangeProvinces = (event) => {
    //setIdCountry(event.target.value);
    setIdProvince(event.target.value);
    setKode(event.target.value);
    //console.log(event.target);

    var raw = listProvinces.filter(x => x.id === event.target.value)
    //console.log(event.target.value);

    setLabelProvince(raw[0].name);
    if (event.target.value === 0) {

      setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
      setIdMunicipal(0);
      var kabupatenSet = [{ id: 0, province: 0, name: "Semua" }];
      setListMunicipalsA(kabupatenSet)

      setIdKecamatan(0);
      var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
      setListKecamatanA(kecamatanSet)
      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
    } else if (event.target.value === 12) {
      //alert ('Generate Regions')
      setIdMunicipal(0);
      setListMunicipalsA(listMunicipals)
      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
    }
  };


  const handleChangeMunicipal = (event) => {

    setIdMunicipal(event.target.value);
    setKode(event.target.value);
    var raw = listMunicipals.filter(x => x.id === event.target.value)
    //console.log(event.target.value);

    setLabelMunicipal(raw[0].name);
    if (event.target.value === 0) {
      //setLocalLabelArea(labelCountry + "/" + labelProvince)

      setIdKecamatan(0);
      var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
      setListKecamatanA(kecamatanSet)

      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))

    } else {
      setIdKecamatan(0);
      setListKecamatanA(listKecamatan.filter(x => x.kabupaten === 0 || x.kabupaten === event.target.value))

      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
      setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
    }

  };


  const handleChangeKecamatan = (event) => {

    console.log(event.target.value)
    setIdKecamatan(event.target.value);
    setKode(event.target.value);
    var raw = listKecamatan.filter(x => x.id === event.target.value)
    //console.log(event.target.value);

    setLabelKecamatan(raw[0].name);
    if (event.target.value === 0) {
      //setLocalLabelArea(labelCountry + "/" + labelProvince)
      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
      setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
    } else {
      //alert ('Generate Regions')
      //setLocalLabelArea(labelCountry + "/" + labelProvince + "/" + raw[0].name)
      setIdDesa(0)
      setListDesaA(listDesa.filter(x => x.kecamatan === 0 || x.kecamatan === event.target.value))
      setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
    }

  };



  const handleChangeDesa = (event) => {
    //setIdDesa(0);
    //var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
    //setListDesaA(desaSet)
    //setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))

    setIdDesa(event.target.value);
    setKode(event.target.value);
    var raw = listDesa.filter(x => x.id === event.target.value)
    setLabelDesa(raw[0].name);
    if (event.target.value === 0) {
      setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
    } else {
      setListIndikatorAktif(listIndikator.filter(item => item.bnba === true))
    }


  };


  const handleMenuIndikator = () => {
    setShowIndikator(!showIndikator)
    if (collapsedIndikator)
      setCollapsedIndikator(false)
  };

  const handleMenuStudyArea = () => {
    setShowStudyArea(!showStudyArea)
    if (collapsedStudyArea)
      setCollapsedStudyArea(false)
  };
  const handleMenuLegenda = () => {
    setShowLegenda(!showLegenda)
    if (collapsedLegenda)
      setCollapsedLegenda(false)
  };
  const handleMenuInformation = () => {
    setShowInformation(!showInformation)
    if (collapsedInformation)
      setCollapsedInformation(false)
  };
  const handleMenuDiagram = () => {
    setShowDiagram(!showDiagram)
    if (collapsedDiagram)
      setCollapsedDiagram(false)
  };

  function handlingIndikator() {
    setShow(false)
    if (value) {
      setIdIndikator(value.id)
      setInfoLabelIndikator(value.label)
      setShowLegenda(true)
      setShowStudyArea(true)
      setLayer(value.layer)
      if (idProvince > 0) {
        if (idMunicipal !== 0) {
          if (idKecamatan !== 0) {
            if (idDesa !== 0) {
              setLevel("desa")
            } else {
              setLevel("kecamatan")
            }

          } else {
            setLevel("kabkot")
          }
        } else {
          setLevel("provinsi")
        }
      } else {
        setLevel("negara")
        setUrl('./data/provinsi/provinsi_stats.geojson')
      }

    } else {
      setIdIndikator(0)
      setInfoLabelIndikator("Belum ada indikator yang dipilih")
      setShowLegenda(false)
      setShowStudyArea(false)
      setLayer("")
      setUrl("")
    }
    /*
    if (value) {
      setShowProvinsi(false)
      setShowKabupaten(false)
      setShowKecamatan(false)
      setShowDesa(false)
      setShowBNBA(false)
      setIdIndikator(value.id)
      setInfoLabelIndikator(value.label)
      loadPeta(value)
      setShowLegenda(true)
    } else {
      setIdIndikator(0)
      setInfoLabelIndikator("Belum ada indikator yang dipilih")
      setShowProvinsi(false)
    }
    */
  }
  /*
  function loadPeta(row) {
    //console.log(row.id)
    setLayer(row.layer)
    if (idProvince > 0) {
      setShowProvinsi(false)
      if (idMunicipal > 0) {
        setShowKabupaten(false)
      } else {
        setShowKabupaten(true)
      }
    } else {
      setShowProvinsi(true)
    }

  }
  */
  function handlingRefine() {
    setShow(false)
    if (idProvince > 0) {
      if (idMunicipal !== 0) {
        if (idKecamatan !== 0) {
          if (idDesa !== 0) {
            setLevel("desa")
            var raw = listDesa.filter(x => x.id === idDesa)
            setInfoLabelWilayah("Desa " + raw[0].name)
            setUrl('./data/bnba/' + idDesa + '_pt.geojson')
          } else {
            setLevel("kecamatan")
            var raw = listKecamatan.filter(x => x.id === idKecamatan)
            setInfoLabelWilayah("Kecamatan " + raw[0].name)
            setUrl('./data/desa/' + idKecamatan + '.geojson')
          }
        } else {
          setLevel("kabkot")
          var raw = listMunicipals.filter(x => x.id === idMunicipal)
          setInfoLabelWilayah(raw[0].name.includes("Kota ") ? raw[0].name : "Kabupaten " + raw[0].name)
          setUrl('./data/kecamatan/' + idMunicipal + '.geojson')
        }
      } else {
        setLevel("provinsi")
        var raw = listProvinces.filter(x => x.id === idProvince)
        setInfoLabelWilayah("Provinsi " + raw[0].name)
        setUrl('./data/kabupaten/' + idProvince + '.geojson')
        setZoomToMap(idProvince)
      }
    } else {
      setLevel("negara")
      setInfoLabelWilayah("Indonesia")
      if (layer) {
        setUrl('./data/provinsi/provinsi_stats.geojson')
      }
    }
    /*

      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
      setUrl('./data/kabupaten/' + idProvince + '.geojson')
      var raw = listProvinces.filter(x => x.id === idProvince)
      setInfoLabelWilayah("Provinsi " + raw[0].name)
      setListMunicipalsA(listMunicipals)


    if (idIndikator > 0) {
      if (idProvince > 0) {
        //setZoomToMap([[[,],[13238952.748806197,],[13936426.68813236,-900586.487496253],[13936426.68813236,-1232970.377072403],[13238952.748806197,-1232970.377072403]]])

        if (idProvince == 53 && idMunicipal == 0) {
          var coord = []
          var xmin = coord[0]
          var ymin = coord[1]
          var xmax = coord[2]
          var ymax = coord[3]
          setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
        }
        if (idMunicipal > 0) {
          if (idMunicipal == 438 && idKecamatan == 0) {
            var coord = [13798870, -1140288, 13904091, -1057675]
            var xmin = coord[0]
            var ymin = coord[1]
            var xmax = coord[2]
            var ymax = coord[3]
            setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
          }
          if (idKecamatan > 0) {
            if (idKecamatan == 520 && idDesa == 0) {
              var coord = [13817608, -1111906, 13842753, -1094275]
              var xmin = coord[0]
              var ymin = coord[1]
              var xmax = coord[2]
              var ymax = coord[3]
              setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
            }
            if (idDesa > 0) {
              if (idDesa == 603) {
                var coord = [13827119,-1105042, 13834941,-1100044]
                var xmin = coord[0]
                var ymin = coord[1]
                var xmax = coord[2]
                var ymax = coord[3]
                setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
              }
              setInfoLabelWilayah(labelDesa)
              setListIndikatorAktif(listIndikator.filter(item => item.bnba === true))
              setShowProvinsi(false)
              setShowKabupaten(false)
              setShowKecamatan(false)
              setShowDesa(false)
              setShowBNBA(true)
            } else {
              setInfoLabelWilayah(labelKecamatan)
              setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
              setShowProvinsi(false)
              setShowKabupaten(false)
              setShowKecamatan(false)
              setShowDesa(true)
              setShowBNBA(false)
            }
          } else {
            setInfoLabelWilayah(labelMunicipal)
            setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
            setShowProvinsi(false)
            setShowKabupaten(false)
            setShowKecamatan(true)
            setShowDesa(false)
            setShowBNBA(false)
          }
        } else {
          setInfoLabelWilayah(labelProvince)
          setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
          setShowProvinsi(false)
          setShowKabupaten(true)
          setShowKecamatan(false)
          setShowDesa(false)
          setShowBNBA(false)
        }
      } else {
        var coord = [10576432.203633543, -1232970.377072403, 15698207.799929712, 677753.767059113]
        var xmin = coord[0]
        var ymin = coord[1]
        var xmax = coord[2]
        var ymax = coord[3]

        setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
        setInfoLabelWilayah('Indonesia')
        setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
        setShowProvinsi(true)
        setShowKabupaten(false)
        setShowKecamatan(false)
        setShowDesa(false)
        setShowBNBA(false)
      }
    } else {
      alert('Pilih Indikator terlebih dahulu..')
    }
    //alert('oke')
    /*
    if (idCountry > 0) {
        if (idProvince > 0) {
            if (idMunicipal > 0) {
                const requestOptions = {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                };
  
                //props.setShowArea(true)
                fetch(url_get_municipal + idMunicipal, requestOptions).then(res => res.json()).then(data => {
  
                    if (data.status === "ok") {
                        //console.log(data.message);
                        setLabelArea(localLabelArea);
                        var bbox = JSON.parse(data.message.bbox);
                        var geom = JSON.parse(data.message.geom);
  
                        //console.log(bbox.coordinates[0][0][0])
                        var center = JSON.parse(data.message.center);
                        console.log(center.coordinates)
                        setBbox([bbox.coordinates[0][0][0], bbox.coordinates[0][0][1], bbox.coordinates[0][2][0], bbox.coordinates[0][2][1]])
                        //props.setBboxLabel('[' + bbox.coordinates[0][0][0].toFixed(2) + ', ' + bbox.coordinates[0][0][1].toFixed(2) + ', ' + bbox.coordinates[0][2][0].toFixed(2) + ', ' + bbox.coordinates[0][2][1].toFixed(2) + ']')
                        setBoundary(geom)
                        setZoomBbox(true)
                        setVisibleBoundary(true)
                        setVisibleBbox(true)
                        //props.setBboxGeom([center, geom, 2]);
  
  
                    }
  
                });
            } else {
                const requestOptions = {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                };
  
                //alert('aaa')
                //props.setShowArea(true)
                fetch(url_get_province + idProvince, requestOptions).then(res => res.json()).then(data => {
                    if (data.status === "ok") {
                        //console.log(data.message);
                        //props.setAreaName(areaLabel)
                        setLabelArea(localLabelArea);
                        var bbox = JSON.parse(data.message.bbox);
                        var center = JSON.parse(data.message.center);
  
                        var geom = JSON.parse(data.message.geom);
                        //console.log(bbox.coordinates[0][0][0])
                        setBbox([bbox.coordinates[0][0][0], bbox.coordinates[0][0][1], bbox.coordinates[0][2][0], bbox.coordinates[0][2][1]])
                        //props.setBboxLabel('[' + bbox.coordinates[0][0][0].toFixed(2) + ', ' + bbox.coordinates[0][0][1].toFixed(2) + ', ' + bbox.coordinates[0][2][0].toFixed(2) + ', ' + bbox.coordinates[0][2][1].toFixed(2) + ']')
                        setBoundary(geom)
                        setZoomBbox(true)
                        setVisibleBoundary(true)
                        setVisibleBbox(true)
                        //props.setPerformZoom(true)
                        //props.setBboxGeom([center, geom, 1]);
                    }
  
                });
  
            }
        } else {
            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            };
  
            //alert('aaa')
            //props.setShowArea(true)
            fetch(url_get_country + idCountry, requestOptions).then(res => res.json()).then(data => {
                if (data.status === "ok") {
                    //console.log(data.message);
                    //props.setAreaName(areaLabel)
                    setLabelArea(localLabelArea);
                    var bbox = JSON.parse(data.message.bbox);
                    var center = JSON.parse(data.message.center);
  
                    var geom = JSON.parse(data.message.geom);
                    //console.log(bbox.coordinates[0][0][0])
  
                    setBbox([bbox.coordinates[0][0][0], bbox.coordinates[0][0][1], bbox.coordinates[0][2][0], bbox.coordinates[0][2][1]])
                    //props.setBboxLabel('[' + bbox.coordinates[0][0][0].toFixed(2) + ', ' + bbox.coordinates[0][0][1].toFixed(2) + ', ' + bbox.coordinates[0][2][0].toFixed(2) + ', ' + bbox.coordinates[0][2][1].toFixed(2) + ']')
                    setBoundary(geom)
                    setZoomBbox(true)
                    setVisibleBoundary(true)
                    setVisibleBbox(true)
                    //props.setPerformZoom(true)
                    //props.setBboxGeom([center, geom, 1]);
                }
  
            });
        }
    } else {
        setLabelArea("Indonesia")
        setBbox([10576432.203633543, -1232970.377072403, 15698207.799929712, 677753.767059113])
        setZoomBbox(true)
        setVisibleBoundary(true)
        setVisibleBbox(true)
        //props.setBboxLabel('[-133044556.25, -20037508.34, 133044555.80, 20037508.35]');
        //props.setCountry()
        //props.setPerformZoom(true)
        //props.setBboxGeom([{ type: "Point", coordinates: [60, -2] }, { type: "Polygon", coordinates: [[[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]]] }, 0]);
    }
    */
  }

  function closeMenuIndikator() {
    var legendContainer = document.getElementById('indikatorContainer');
    var legendContent = document.getElementById('indikatorContent');
    if (collapsedIndikator) {
      legendContainer.style.width = "300px";
      legendContainer.style.height = "130px";
      setCollapsedIndikator(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "250px";
      legendContainer.style.height = "30px";
      setCollapsedIndikator(true);
      legendContent.style.display = 'none';
    }

  }

  function closeMenuStudyArea() {
    var legendContainer = document.getElementById('studyAreaContainer');
    var legendContent = document.getElementById('studyAreaContent');
    if (collapsedStudyArea) {
      legendContainer.style.width = "300px";
      legendContainer.style.height = "310px";
      setCollapsedStudyArea(false)
      setTimeout(function () {
        legendContent.style.display = 'flex';
      }, 500)
    } else {
      legendContainer.style.width = "180px";
      legendContainer.style.height = "30px";
      setCollapsedStudyArea(true);
      legendContent.style.display = 'none';
    }

  }

  function closeMenuLegend() {
    var legendContainer = document.getElementById('legendContainer');
    var legendContent = document.getElementById('legendContent');
    if (collapsedLegenda) {
      legendContainer.style.width = "260px";
      legendContainer.style.height = "auto";
      setCollapsedLegenda(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "140px";
      legendContainer.style.height = "30px";
      setCollapsedLegenda(true);
      legendContent.style.display = 'none';
    }

  }

  function closeMenuInformation() {
    var legendContainer = document.getElementById('informationContainer');
    var legendContent = document.getElementById('informationContent');
    if (collapsedInformation) {
      legendContainer.style.width = "260px";
      legendContainer.style.height = "260px";
      setCollapsedInformation(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "150px";
      legendContainer.style.height = "30px";
      setCollapsedInformation(true);
      legendContent.style.display = 'none';
    }

  }
  function closeMenuDiagram() {
    var legendContainer = document.getElementById('diagramContainer');
    var legendContent = document.getElementById('diagramContent');
    if (collapsedDiagram) {
      legendContainer.style.width = "260px";
      setCollapsedDiagram(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "105px";
      setCollapsedDiagram(true);
      legendContent.style.display = 'none';
    }

  }


  //<Close fontSize="small" onClick={() => closeMenu()} />
  //ExpandMore

  function load_legend_wms() {
    if (idIndikator == 1) {
      if (level === "negara")
        return create_legenda('Prevalensi Stunting', ['#6575b7','#9bc31d', '#f4d53c', '#cb151a'], ["<10.00","10.01-20.00","20.01-30.00",">30.00"])
      else if (level === "provinsi")
        return create_legenda('Prevalensi Stunting', ['#6575b7', '#9bc31d', '#f4d53c', '#cb151a'], ["<10.00","10.01-20.00", "20.01-30.00", ">30.00"])
      else if (level === "kabkot")
        return <span>tidak ada legenda</span>
      else if (level === "kecamatan")
        return <span>tidak ada legenda</span>
      else if (level === "desa")
        return <span>tidak ada legenda</span>

    } /*else if (idIndikator == 2) {
      if (level === "negara")
        return create_legenda('Prevalensi Wasted', ['#6575b7','#9bc31d', '#f4d53c', '#cb151a'], ['<5.00', '5.01-10.00', '10.01-15.00', '>15.00'])
      else if (level === "provinsi")
        return create_legenda('Prevalensi Wasted', ['#6575b7','#9bc31d', '#f4d53c', '#cb151a'], ['<5.00', '5.01-10.00', '10.01-15.00', '>15.00'])
      else if (level === "kabkot")
        return <span>tidak ada legenda</span>
      else if (level === "kecamatan")
        return <span>tidak ada legenda</span>
      else if (level === "desa")
        return <span>tidak ada legenda</span>
    } */
    else if (idIndikator == 2) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga dengan Anak Usia 0-23 Bulan (Baduta)', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<8.01', '8.01-12.00', '12.01-15.00', '>15.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga dengan Anak Usia 0-23 Bulan (Baduta)', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<8.01', '8.01-13.00', '13.01-17.00', '>17.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga dengan Anak Usia 0-23 Bulan (Baduta)', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<7.01', '7.01-13.00', '13.01-18.00', '>18.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga dengan Anak Usia 0-23 Bulan (Baduta)', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<7.50', '7.51-15.00', '15.01-23.00', '>23.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga dengan Anak Usia 0-23 Bulan (Baduta)', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])
    } else if (idIndikator == 3) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga dengan Anak Usia Balita', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<21.01', '21.01-24.00', '24.01-27.00', '>27.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga dengan Anak Usia Balita', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<13.01', '13.01-25.00', '25.01-30.00', '>30.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga dengan Anak Usia Balita', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<13.01', '13.01-25.00', '25.01-30.00', '>30.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga dengan Anak Usia Balita', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<20.01', '20.01-30.00', '30.01-40.00', '>40.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga dengan Anak Usia Balita', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])
    } else if (idIndikator == 4) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Beresiko Stunting', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<55.01', '55.01-65.00', '65.01-75.00', '>75.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Beresiko Stunting', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<50.01', '50.01-65.00', '65.01-80.00', '>80.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Beresiko Stunting', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<50.01', '50.01-70.00', '70.01-85.00', '>85.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Beresiko Stunting', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<60.01', '60.01-75.00', '75.01-90.00', '>75.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Beresiko Stunting', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['Tidak Miskin', 'KRS', 'Miskin', 'KRS Miskin'])
    } else if (idIndikator == 5) {
      if (level === "negara")
        return create_legenda('Persentase PUS Hamil', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<3.01', '3.01-3.50', '3.51-4.00', '>4.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase PUS Hamil', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<3.51', '3.51-5.00', '5.01-9.00', '>9.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase PUS Hamil', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<3.01', '3.01-6.00', '6.01-16.00', '>6.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase PUS Hamil', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<4.01', '4.01-9.00', '9.01-23.00', '>23.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase PUS Hamil', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])
    } else if (idIndikator == 6) {
      
      if (level === "negara")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Jamban Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<12.01', '12.01-19.00', '19.01-30.00', '>30.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Jamban Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<13.01', '13.01-27.00', '27.01-50.00', '>50.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Jamban Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<15.01', '15.01-35.00', '35.01-60.00', '>60.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Jamban Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<15.01', '15.01-45.00', '45.01-75.00', '>75.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Sasaran Memiliki Jamban Tidak Layak', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } else if (idIndikator == 7) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Sumber Air Minum Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<8.01', '8.01-14.00', '14.01-27.00', '>27.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Sumber Air Minum Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<13.01', '13.01-32.00', '32.01-62.00', '>62.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Sumber Air Minum Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<13.01', '13.01-35.00', '35.01-70.00', '>70.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Sasaran Memiliki Sumber Air Minum Tidak Layak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<15.01', '15.01-45.00', '45.01-80.00', '>80.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Sasaran Memiliki Sumber Air Minum Tidak Layak', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])
    } else if (idIndikator == 8) {
      if (level === "negara")
        return create_legenda('Presentase PUS Terlalu Muda', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<0.81', '0.81-1.25', '1.26-2.00', '>2.00'])
      else if (level === "provinsi")
        return create_legenda('Presentase PUS Terlalu Muda', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<0.61', '0.61-1.20', '1.21-1.90', '>1.90'])
      else if (level === "kabkot")
        return create_legenda('Presentase PUS Terlalu Muda',  ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<1.01', '1.01-2.00', '2.01-4.50', '>4.50'])
      else if (level === "kecamatan")
        return create_legenda('Presentase PUS Terlalu Muda',  ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<1.01', '1.01-2.00', '2.01-5.00', '>5.00'])
      else if (level === "desa")
        return create_legenda_point('Presentase PUS Terlalu Muda', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])
    } else if (idIndikator == 9) {
      if (level === "negara")
        return create_legenda('Presentase PUS Terlalu Tua', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<23.01', '23.01-25.00', '25.01-26.00', '>26.00'])
      else if (level === "provinsi")
        return create_legenda('Presentase PUS Terlalu Tua', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<23.01', '23.01-25.00', '25.01-27.00', '>27.00'])
      else if (level === "kabkot")
        return create_legenda('Presentase PUS Terlalu Tua', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<20.01', '20.01-25.00', '25.01-30.00', '>30.00'])
      else if (level === "kecamatan")
        return create_legenda('Presentase PUS Terlalu Tua', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<15.01', '15.01-23.00', '23.01-27.00', '>27.00'])
      else if (level === "desa")
        return create_legenda_point('Presentase PUS Terlalu Tua', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } else if (idIndikator == 10) {
      if (level === "negara")
        return create_legenda('Presentase PUS Terlalu Dekat', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<0.61', '0.61-0.80', '0.81-1.40', '>1.40'])
      else if (level === "provinsi")
        return create_legenda('Presentase PUS Terlalu Dekat', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<1.01', '1.01-2.00', '2.01-3.50', '>3.50'])
      else if (level === "kabkot")
        return create_legenda('Presentase PUS Terlalu Dekat', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<1.01', '1.01-2.50', '2.51-5.00', '>5.00'])
      else if (level === "kecamatan")
        return create_legenda('Presentase PUS Terlalu Dekat', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<0.01', '0.01-1.20', '1.21-2.00', '>2.00'])
      else if (level === "desa")
        return create_legenda_point('Presentase PUS Terlalu Dekat', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])
    } else if (idIndikator == 11) {
      if (level === "negara")
        return create_legenda('Presentase PUS Terlalu Banyak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<20.01', '20.01-25.00', '25.01-37.50', '>37.50'])
      else if (level === "provinsi")
        return create_legenda('Presentase PUS Terlalu Banyak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<23.01', '23.01-33.00', '33.01-45.00', '>45.00'])
      else if (level === "kabkot")
        return create_legenda('Presentase PUS Terlalu Banyak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<20.01', '20.01-35.00', '35.01-50.00', '>50.00'])
      else if (level === "kecamatan")
        return create_legenda('Presentase PUS Terlalu Banyak', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<40.01', '40.01-50.00', '50.01-60.00', '>60.00'])
      else if (level === "desa")
        return create_legenda_point('Presentase PUS Terlalu Banyak', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } else if (idIndikator == 12) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Berpartisipasi KB', ['#cb151a', '#e68d0f', '#f4d53c', '#9bc31d'], ['27.05-36.00', '36.01-49.00', '49.01-66.00', '66.01-84.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Berpartisipasi KB', ['#cb151a', '#e68d0f', '#f4d53c', '#9bc31d'], ['18.74-36.00', '36.01-50.00', '50.01-70.00', '70.01-100.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Berpartisipasi KB', ['#cb151a', '#e68d0f', '#f4d53c', '#9bc31d'], ['0.00-33.00', '33.01-50.00', '50.01-75.00', '75.01-100.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Berpartisipasi KB', ['#cb151a', '#e68d0f', '#f4d53c', '#9bc31d'], ['0.00-24.00', '24.01-36.00', '36.01-48.00', '48.01-97.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Berpartisipasi KB', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } else if (idIndikator == 13) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Berisiko 0', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['30.84-37.00', '37.01-43.00', '43.01-48.00', '48.01-60.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Berisiko 0', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['3.90-29.00', '29.01-43.00', '43.01-56.00', '56.01-100.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Berisiko 0', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-27.00', '27.01-46.00', '46.01-67.00', '67.01-100.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Berisiko 0', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-27.00', '27.01-46.00', '46.01-66.00', '66.01-100.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Berisiko 0', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])
    } else if (idIndikator == 14) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Berisiko 1', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['8.60-12.00', '12.01-17.00', '17.01-22.00', '22.01-27.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Berisiko 1', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-13.00', '13.01-21.00', '21.01-34.00', '34.01-67.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Berisiko 1', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-13.00', '13.01-25.00', '25.01-44.00', '44.01-95.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Berisiko 1', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-12.00', '12.01-26.00', '26.01-42.00', '42.01-100.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Berisiko 1', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } else if (idIndikator == 15) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Berisiko 2', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<8.36', '8.36-14.00', '14.01-17.00', '17.01-20.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Berisiko 2', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-11.00', '11.01-16.00', '16.01-22.00', '22.01-36.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Berisiko 2', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-9.00', '9.01-17.00', '17.01-24.00', '24.01-64.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Berisiko 2', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-9.00', '9.01-17.00', '17.01-25.00', '25.01-64.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Berisiko 2', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } else if (idIndikator == 16) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Berisiko 3', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['<5.98', '5.98-13.00', '13.01-15.00', '15.01-18.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Berisiko 3', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-9.00', '9.01-13.00', '13.01-17.00', '17.01-25.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Berisiko 3', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-8.00', '8.01-14.00', '14.01-20.00', '20.01-100.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Berisiko 3', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-8.00', '8.01-15.00', '15.01-22.00', '22.01-100.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Berisiko 3', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } else if (idIndikator == 17) {
      if (level === "negara")
        return create_legenda('Persentase Keluarga Berisiko 4', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['5.49-8.00', '8.01-11.00', '11.01-13.00', '13.01-16.00'])
      else if (level === "provinsi")
        return create_legenda('Persentase Keluarga Berisiko 4', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-7.00', '7.01-12.00', '12.01-15.00', '15.01-23.00'])
      else if (level === "kabkot")
        return create_legenda('Persentase Keluarga Berisiko 4', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-6.00', '6.01-12.00', '12.01-17.00', '17.01-50.00'])
      else if (level === "kecamatan")
        return create_legenda('Persentase Keluarga Berisiko 4', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['0.00-6.00', '6.01-12.00', '12.01-18.00', '18.01-47.00'])
      else if (level === "desa")
        return create_legenda_point('Persentase Keluarga Berisiko 4', ['#ff0000', '#00ff00'], ['V (Ya)', 'X (Tidak)'])

    } 
    else {
      return <span>tidak ada legenda</span>
    }
  }

  function create_legenda(title, color, label) {
    return (
      <div style={{ fontSize: '12px' }}>
        <b>{title}</b>
        {color.map((row, index) => {
          return (
            <div key={index} style={{ display: 'flex', marginTop: '3px' }}>
              <div style={{ width: "15px", height: "15px", border: `1px solid ${row}`, backgroundColor: `${row}` }}>
              </div>
              <span style={{ marginLeft: '5px' }}>{label[index]}</span>
            </div>
          )
        })}
      </div>
    )
  }

  function create_legenda_point(title, color, label) {
    return (
      <div style={{ fontSize: '12px' }}>
        <b>{title}</b>
        {color.map((row, index) => {
          return (
            <div key={index} style={{ display: 'flex', marginTop: '3px' }}>
              <div style={{ width: "8px", height: "8px", borderRadius: "8px", border: `1px solid ${row}`, backgroundColor: `${row}` }}>
              </div>
              <span style={{ marginLeft: '5px' }}>{label[index]}</span>
            </div>
          )
        })}
      </div>
    )
  }

  const iconIndikator = collapsedIndikator ? <ExpandMore fontSize="small" /> : <ExpandLess fontSize="small" />
  const iconStudyArea = collapsedStudyArea ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />
  const iconLegenda = collapsedLegenda ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />
  const iconInformation = collapsedInformation ? <ExpandMore fontSize="small" /> : <ExpandLess fontSize="small" />
  const iconDiagram = collapsedDiagram ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />

  return (
    <Map center={fromLonLat(center)} zoom={zoom} basemap={basemap} >
      <Basemap basemap={basemap} setBasemap={setBasemap} open={showBasemap} handleCloseBasemap={(e) => handleCloseBasemap(e)} />
      {
        //  <Layer open={showLayer} handleCloseLayer={(e) => handleCloseLayer(e)} mapLayer={mapLayer} deleteDataset={(e) => deleteDataset(e)} handleVisible={e => handleVisible(e)}
        // setZoomToMap={(e) => setZoomToMap(e)} handleOpacity={(e, b) => handleOpacity(e, b)} setShowIndikator={(e) => setShowIndikator(e)} />
        //<List open={showIndikator} handleCloseIndikator={(e) => handleCloseIndikator(e)} mapLayer={mapLayer} setMapLayer={(e) => setMapLayer(e)} />
        //<ZoomToMap url={url} setShow={(e) => setShow(e)} />
      }

      <ZoomToMap zoomToMap={zoomToMap} setZoomToMap={(e) => setZoomToMap(e)} setShow={(e) => setShow(e)} />
      <PopUp coordinate={coordinate} layer={layer} show={show} content={content}
        setShow={(e) => setShow(e)} level={level} setLevel={(e) => setLevel(e)}
        kode={kode} setIdProvince={(e) => setIdProvince(e)}
        setIdMunicipal={(e) => setIdMunicipal(e)}
        setIdKecamatan={(e) => setIdKecamatan(e)}
        setIdDesa={(e) => setIdDesa(e)}
      />

      <LabelContainer>
        {
          //<div>{kode} , {layer}, {level}, {idProvince}, {idMunicipal}, {idKecamatan}, {idDesa}</div>
        }
        <div>Indikator: <span id="layer" style={{ display: "none" }}>{layer}</span><span id="level" style={{ display: "none" }}>{level}</span><TitleLabel>{infoLabelIndikator}</TitleLabel> | Wilayah: <TitleLabel>{infoLabelWilayah}</TitleLabel></div>
      </LabelContainer>

      {showIndikator && <IndikatorContainer id="indikatorContainer">
        <Closer>
          <Title>Daftar Indikator [{listIndikatorAktif.length}]</Title>
          <div>
            <IconButton id="icon" size="small" onClick={() => closeMenuIndikator()}>
              {iconIndikator}
            </IconButton>
            <IconButton size="small" onClick={() => setShowIndikator(false)} >
              <Close fontSize="small" />
            </IconButton>
          </div>
        </Closer>
        <div id="indikatorContent">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={listIndikatorAktif}
            ListboxProps={{ style: { maxHeight: '180px' } }}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Pilih Indikator" />}
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            size="small"
          />
          <Button variant="contained" fullWidth color="primary" style={{ marginTop: "15px", padding: "5px 15px", borderRadius: "20px" }} onClick={handlingIndikator}>Tampilkan</Button>
        </div>
      </IndikatorContainer>
      }
      {showStudyArea &&
        <StudyAreaContainer id="studyAreaContainer">
          <Closer>
            <Title>Pilih Wilayah</Title>
            <div>
              <IconButton id="icon" size="small" onClick={() => closeMenuStudyArea()}>
                {iconStudyArea}
              </IconButton>
              <IconButton size="small" onClick={() => setShowStudyArea(false)} >
                <Close fontSize="small" />
              </IconButton>
            </div>
          </Closer>
          <FormControl id="studyAreaContent" fullWidth style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', minHeight: "37vh" }}>
            <TextField
              id="outlined-select-currency"
              select
              label="Provinsi"
              value={idProvince}
              onChange={handleChangeProvinces}
              variant="outlined"
              size="small"
            >
              {
                getProvinces()
              }
            </TextField>
            <TextField
              id="outlined-select-province"
              select
              label="Kabupaten/Kota"
              value={idMunicipal}
              onChange={handleChangeMunicipal}
              variant="outlined"
              size="small"
            >
              {
                getMunicipals()
              }
            </TextField>
            <TextField
              id="outlined-select-municipal"
              select
              label="Kecamatan"
              value={idKecamatan}
              onChange={handleChangeKecamatan}
              variant="outlined"
              size="small"
            >
              {
                getKecamatan()
              }
            </TextField>
            <TextField
              id="outlined-select-municipal"
              select
              label="Desa"
              value={idDesa}
              onChange={handleChangeDesa}
              variant="outlined"
              size="small"
            >
              {
                getDesa()
              }
            </TextField>
            <Tooltip title="Pilih indikator terlebih dahulu jika tombol tidak aktif" open={!idIndikator > 0}>
              <span>
                <Button disabled={!idIndikator > 0} variant="contained" fullWidth color="primary" style={{ padding: "5px 15px", borderRadius: "20px" }} onClick={handlingRefine}>Perbarui</Button>
              </span>
            </Tooltip>
            {
              //<Button variant="contained" fullWidth color="secondary" style={{ padding: "5px 15px", borderRadius: "20px" }} onClick={handleClose}>Batal</Button>
            }
          </FormControl>
        </StudyAreaContainer>
      }
      {showLegenda &&
        <LegendContainer id="legendContainer">
          <Closer>
            <Title>Legenda</Title>
            <div>
              <IconButton id="icon" size="small" onClick={() => closeMenuLegend()}>
                {iconLegenda}
              </IconButton>
              <IconButton size="small" onClick={() => setShowLegenda(false)} >
                <Close fontSize="small" />
              </IconButton>
            </div>
          </Closer>
          <LegendContent id="legendContent">
            {
              load_legend_wms()
            }
          </LegendContent>
        </LegendContainer>
      }
      {showInformation &&
        <InfoContainer id="informationContainer">
          <Closer>
            <Title>Informasi</Title>
            <div>
              <IconButton id="icon" size="small" onClick={() => closeMenuInformation()}>
                {iconInformation}
              </IconButton>
              <IconButton size="small" onClick={() => setShowInformation(false)} >
                <Close fontSize="small" />
              </IconButton>
            </div>
          </Closer>
          <div id="informationContent" >
            <Value>Stunting dan Penyebabnya</Value>
            <div className="kontent">
              Masalah gizi pada balita merupakan masalah Kesehatan Masyarakat yang masih tergolong tinggi di Indonesia,
              baik yang bersifat akut maupun kronis. Stunting atau anak pendek berdasarkan umur merupakan salah satu
              indikator kondisi gagal tumbuh pada anak berusia dibawah lima tahun (balita) akibat kekurangan asupan gizi kronis
              dan infeksi berulangterutama pada periode 1.000 Hari Pertama Kehidupan (HPK), yaitu dari janin hingga anak berusia
              23 bulan.Karenanya periode 1.000 HPK ini disebut pula sebagai periode Emas untuk melakukan pencegahan atau koreksi
              masalah stunting dengan berbagai intervensi gizi spesifik dan sensitif. Intervensi gizi spesifik terdiri dari
              berbagai program yang bertujuan untuk menanggulangi penyebab langsung masalah stunting, sementara intervensi gizi
              sensitif merupakan kelompok program yang bertujuan untuk menanggulangi berbagai penyebab tak langsung dari stunting.
            </div>
            {
              /*
            <span>Jumlah Keluarga</span>
            <Value>- jiwa</Value>
            <span>Luas Wilayah</span>
            <Value>- km2</Value>
            <span>Jumlah Kasus Stunting</span>
            <Value>- jiwa</Value>
            <span>Jumlah Sarana Air Bersih</span>
            <Value>- buah</Value>
            <span>Jumlah Jamban Layak</span>
            <Value>- buah</Value>
            */
            }
          </div>
        </InfoContainer>
      }
      {showDiagram &&
        <DiagramContainer id="diagramContainer">
          <Closer>
            <Title>Diagram</Title>
            <IconButton id="icon" size="small" onClick={() => closeMenuDiagram()}>
              {iconDiagram}
            </IconButton>
          </Closer>
          <div id="diagramContent">
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
        </DiagramContainer>
      }
      <div id="dock-container">
        <div id="dock" className="unselectable">
          <ul>
            <li>
              <span>Pilih Indikator</span>
              <a href="#"><img src="layer.png" alt="kelola peta" onClick={() => handleMenuIndikator()} /></a>
            </li>
            <li>
              <span>Pilih Wilayah</span>
              <a href="#"><img src="area.png" alt="area studi" onClick={() => handleMenuStudyArea()} /></a>
            </li>
            <li>
              <span>Pilih Peta Dasar</span>
              <a href="#"><img src="basemap.png" alt="peta dasar" onClick={() => setShowBasemap(true)} /></a>
            </li>

            {
              /*
              <li>
                <span>Daftar Indikator</span>
                <a href="#"><img src="indikator.png" alt="daftar indikator" onClick={() => setShowIndikator(true)} /></a>
              </li>
              */
            }
            <li>
              <span>Informasi</span>
              <a href="#"><img src="information.png" alt="information" onClick={() => handleMenuInformation()} /></a>
            </li>
            <li>
              <span>Legenda</span>
              <a href="#"><img src="legend.png" alt="legenda" onClick={() => handleMenuLegenda()} /></a>
            </li>
            {
              /*
              <li>
                <span>Analisa Spasial</span>
                <a href="#"><img src="/analysis.png" /></a>
              </li>
              <li>
                <span>Pengukuran</span>
                <a href="#"><img src="/measurement.png" /></a>
              </li>
               <li>
              <span>Diagram</span>
              <a href="#"><img src="diagram.png" alt="diagram" onClick={() => handleMenuDiagram()} /></a>
            </li>
              */
            }


          </ul>
        </div>
      </div>

      {
        /*
         <AtributContainer>
        <p>Atribut</p>
      </AtributContainer>
        <ButtonContainer id="buttonContainer">
          <ButtonGroup disableElevation variant="contained" color="primary">
            <Button color="primary" style={{ padding: "10px 30px", borderRadius: "30px" }} startIcon={<LayersRounded />} size="small" onClick={() => setShowBasemap(true)}>Peta Dasar</Button>
          </ButtonGroup>
        </ButtonContainer>
        */
      }
      {
        /*
       
        */
      }
      {
        //  
        //<Print open={showPrint} handleClosePrint={(e) => handleClosePrint(e)} />
      }

      <Layers>
        <BasemapLayer
          basemap={basemap}
          zIndex={0}
        />
        <GraticuleLayer />
        <IndikatorLayer zIndex={12} url={url} setShow={(e) => setShow(e)}
          setCoordinate={(e) => setCoordinate(e)} setContent={(e) => setContent(e)}
          layer={layer} level={level} setKode={(e) => setKode(e)}
        />
        <DesaLayer zIndex={14} visible={level == 'desa'} flag={flag} setFlag={(e) => setFlag(e)} />
        {
          /*
          {showProvinsi && <ProvinsiLayer zIndex={12} visible={true} layer={layer} />}
          {showKabupaten && <KabupatenLayer zIndex={13} visible={true} layer={layer} kode={idProvince} />}
          {showKecamatan && <KecamatanLayer zIndex={14} visible={true} layer={layer} kode={idMunicipal} />}
          {showDesa && <DesaLayer zIndex={14} visible={true} layer={layer} kode={idKecamatan} />}
          {showBNBA && <BNBALayer zIndex={15} visible={true} layer={layer} kode={idDesa} />}
          */
        }
        {
          //showKabupaten && <KabupatenLayer zIndex={12} visible={true} /> }
          // { //showKecamatan && <KecamatanLayer zIndex={12} visible={true} /> }
          //   { //showDesa && <DesaLayer zIndex={12} visible={true} /> }
        }
        {
          /*
            <GroupLayer zIndex={11} mapLayer={mapLayer} identifierDelete={identifierDelete} setIdentifierDelete={setIdentifierDelete} />
      
          
          <BoundaryLayer zIndex={9} visible={visibleBoundary} boundary={boundary} />
          <BBoxLayer zIndex={10} visible={visibleBbox} bbox={bbox} zoomBbox={zoomBbox} setZoomBbox={setZoomBbox} />
          <StatisticLayer zIndex={12} visible={visibleStatistic} />
          <AnalysisLayer zIndex={13} visible={visibleAnalysis} buffered={buffered} />
          */
        }
        {
          /*
  
           <GroupLayer zIndex={11} />
  
          {showLayerStats && (
              <StatistikLayer
                source={vector({ features: new GeoJSON().readFeatures(geojsonObject, { featureProjection: get('EPSG:3857') }) })}
                style={styles.MultiPolygon}
              />
            )}
          <BBoxLayer zIndex={10} visible={true} bbox={bbox} />
          
          <GraticuleLayer />
          showLayer1 && (
              <VectorLayer
                source={vector({ features: new GeoJSON().readFeatures(geojsonObject, { featureProjection: get('EPSG:3857') }) })}
                style={styles.MultiPolygon}
              />
            )}
            {showLayer2 && (
              <VectorLayer
                source={vector({ features: new GeoJSON().readFeatures(geojsonObject2, { featureProjection: get('EPSG:3857') }) })}
                style={styles.MultiPolygon}
              />
              
              <Button color="primary" startIcon={<PrintIcon />} size="small" onClick={() => setShowPrint(true)}>Print Map</Button>
             <FullScreenControl />
            
          <GraticuleControl />
            )
             <IdentifyLayer zIndex={102} />
            */
        }

      </Layers>
      <Controls>

        {
          /*
          <IdentifyControl mapLayer={mapLayer} />
            <ZoomControl />
        <ZoomToExtentControl />
        <FullScreenControl />
        <GraticuleControl />
        <MeasureControl />
        <IdentifyControl />
        <DrawingControl />
         
        <ScaleLineControl />
        <OverviewMapControl basemap={basemap} />
        <AttributionControl />
         */
        }
      </Controls>
      <Interactions>
        {
          /*
          <DrawBbox drawing={drawing} setBbox={setBbox} setDrawing={setDrawing} setVisibleBbox={setVisibleBbox} setLabelArea={setLabelArea} />
          */
        }
      </Interactions>

    </Map>
  )
}

const LabelContainer = styled.div`
    position: fixed;
    z-index: 1;
    top: 80px;
    text-align: center;
    right: 25%;
    left: 25%;
    width: 50%;
    color: black;
    background-color: rgba(255,223,207, 0.85);
    border: 1px solid rgba(222, 222, 255, 0.85);
    height: 25px;
    padding: 10px 10px 10px 10px;
    transition: all 0.6s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;

const IndikatorContainer = styled.div`
    position: absolute;
    left: 10px;
    top: 80px;
    z-index:1;
    color: black;
    width:300px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 130px;
    padding: 5px 10px 10px 10px;
    transition: all 0.6s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;

const StudyAreaContainer = styled.div`
    position: absolute;
    left: 10px;
    bottom: 30px;
    z-index:1;
    color: black;
    width:300px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 310px;
    padding: 5px 10px 10px 10px;
    transition: all 0.6s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;

const LegendContainer = styled.div`
    position: absolute;
    right: 10px;
    bottom: 30px;
    z-index:1;
    color: black;
    width:260px;
    height: auto;
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    padding: 5px 10px 10px 10px;
    transition: all 0.8s;
    border-radius:10px;
`;

const InfoContainer = styled.div`
    position: absolute;
    right: 10px;
    top: 80px;
    z-index:1;
    color: black;
    width:260px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 260px;
    padding: 5px 10px 10px 10px;
    transition: all 0.8s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;

const DiagramContainer = styled.div`
    position: absolute;
    right: 10px;
    bottom: 30px;
    z-index:1;
    color: black;
    width:260px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 210px;
    padding: 5px 10px 10px 10px;
    transition: all 0.8s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;


const AtributContainer = styled.div`
  position: fixed;
  bottom: 0;
  text-align: center;
  right: 20%;
  left: 20%;
  width: 60%;
  background: rgba(255,255,255,0.2);
  border-radius: 10px 10px 0 0;
`;

const ButtonContainer = styled.div`
    position: absolute;
    z-index:1;
    margin-left: 350px;
    margin-top: 15px;
    color: white;
    transition: 0.8s;
`;


const Title = styled.h3`
  margin:0px;
  color:#2F4E6F;
`;

const TitleLabel = styled.span`
  color:#2F4E6F;
  font-size:14px;
  font-weight: bold;
`;

const Value = styled.h3`
  margin:0px;
  color:#89c6e5;
`;

const Closer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 10px;
`;

const LegendContent = styled.div`
  margin-top:10px;
  max-height: 210px;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 260px;
`;

const StatistikLegendContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;
const StatistikLabel = styled.div`

`;

const Box1 = styled.div`
  border: 1px solid #ccc;
  background-color:#ffffff;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box2 = styled.div`
  border: 1px solid #ccc;
  background-color: #ffbfbf;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box3 = styled.div`
  border: 1px solid #ccc;
  background-color: #ff8080;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box4 = styled.div`
  border: 1px solid #ccc;
  background-color: #ff4040;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box5 = styled.div`
  border: 1px solid #ccc;
  background-color: #ff0000;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;